var fP = Object.defineProperty;
var hP = (e, t, n) => t in e ? fP(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ne = (e, t, n) => (hP(e, typeof t != "symbol" ? t + "" : t, n), n);
import { watch as pe, onScopeDispose as wn, effectScope as Fh, reactive as mi, computed as B, watchEffect as Ln, toRefs as Bo, capitalize as Cb, isVNode as gP, Comment as mP, Fragment as qe, shallowRef as Pe, unref as Be, warn as Sc, ref as ie, provide as sn, inject as ht, defineComponent as Ae, camelize as Ob, h as Un, getCurrentInstance as Mb, toRaw as fn, createVNode as T, mergeProps as ge, onBeforeUnmount as _n, readonly as Nh, nextTick as gt, isRef as cr, toRef as Me, Text as vP, TransitionGroup as Qs, Transition as hn, onBeforeMount as Wh, withDirectives as Nt, resolveDirective as Ci, vShow as Ri, resolveDynamicComponent as sr, markRaw as pP, onMounted as mn, onUpdated as yP, createTextVNode as dr, Teleport as As, openBlock as ee, createBlock as Ne, normalizeClass as we, withCtx as Ye, renderSlot as De, createElementBlock as ce, normalizeStyle as Do, createElementVNode as ve, renderList as Dn, createCommentVNode as Fe, toDisplayString as Ue, normalizeProps as zt, guardReactiveProps as Qt, withModifiers as Wr, version as bP, onUnmounted as wP, isProxy as Tb, toHandlers as xa, useSlots as zh, resolveComponent as Hh, withKeys as _P, useAttrs as xP, createSlots as Cc, cloneVNode as kP, isReactive as SP, isReadonly as CP } from "vue";
function jr(e, t) {
  let n;
  function i() {
    n = Fh(), n.run(() => t.length ? t(() => {
      n == null || n.stop(), i();
    }) : t());
  }
  pe(e, (r) => {
    r && !n ? i() : r || (n == null || n.stop(), n = void 0);
  }, {
    immediate: !0
  }), wn(() => {
    n == null || n.stop();
  });
}
const ft = typeof window < "u", jh = ft && "IntersectionObserver" in window, OP = ft && ("ontouchstart" in window || window.navigator.maxTouchPoints > 0);
function Pb(e, t, n) {
  const i = t.length - 1;
  if (i < 0)
    return e === void 0 ? n : e;
  for (let r = 0; r < i; r++) {
    if (e == null)
      return n;
    e = e[t[r]];
  }
  return e == null || e[t[i]] === void 0 ? n : e[t[i]];
}
function Ba(e, t) {
  if (e === t)
    return !0;
  if (e instanceof Date && t instanceof Date && e.getTime() !== t.getTime() || e !== Object(e) || t !== Object(t))
    return !1;
  const n = Object.keys(e);
  return n.length !== Object.keys(t).length ? !1 : n.every((i) => Ba(e[i], t[i]));
}
function ih(e, t, n) {
  return e == null || !t || typeof t != "string" ? n : e[t] !== void 0 ? e[t] : (t = t.replace(/\[(\w+)\]/g, ".$1"), t = t.replace(/^\./, ""), Pb(e, t.split("."), n));
}
function hi(e, t, n) {
  if (t === !0)
    return e === void 0 ? n : e;
  if (t == null || typeof t == "boolean")
    return n;
  if (e !== Object(e)) {
    if (typeof t != "function")
      return n;
    const r = t(e, n);
    return typeof r > "u" ? n : r;
  }
  if (typeof t == "string")
    return ih(e, t, n);
  if (Array.isArray(t))
    return Pb(e, t, n);
  if (typeof t != "function")
    return n;
  const i = t(e, n);
  return typeof i > "u" ? n : i;
}
function Oc(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return Array.from({
    length: e
  }, (n, i) => t + i);
}
function ze(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "px";
  if (!(e == null || e === ""))
    return isNaN(+e) ? String(e) : isFinite(+e) ? `${Number(e)}${t}` : void 0;
}
function rh(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function Yh(e) {
  if (e && "$el" in e) {
    const t = e.$el;
    return (t == null ? void 0 : t.nodeType) === Node.TEXT_NODE ? t.nextElementSibling : t;
  }
  return e;
}
const Cp = Object.freeze({
  enter: 13,
  tab: 9,
  delete: 46,
  esc: 27,
  space: 32,
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  end: 35,
  home: 36,
  del: 46,
  backspace: 8,
  insert: 45,
  pageup: 33,
  pagedown: 34,
  shift: 16
});
function Ab(e) {
  return Object.keys(e);
}
function _f(e, t) {
  return t.every((n) => e.hasOwnProperty(n));
}
function Eb(e, t) {
  const n = {}, i = new Set(Object.keys(e));
  for (const r of t)
    i.has(r) && (n[r] = e[r]);
  return n;
}
function Op(e, t, n) {
  const i = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  for (const o in e)
    t.some((a) => a instanceof RegExp ? a.test(o) : a === o) && !(n != null && n.some((a) => a === o)) ? i[o] = e[o] : r[o] = e[o];
  return [i, r];
}
function gn(e, t) {
  const n = {
    ...e
  };
  return t.forEach((i) => delete n[i]), n;
}
function Ib(e, t) {
  const n = {};
  return t.forEach((i) => n[i] = e[i]), n;
}
const Db = /^on[^a-z]/, Uh = (e) => Db.test(e), MP = ["onAfterscriptexecute", "onAnimationcancel", "onAnimationend", "onAnimationiteration", "onAnimationstart", "onAuxclick", "onBeforeinput", "onBeforescriptexecute", "onChange", "onClick", "onCompositionend", "onCompositionstart", "onCompositionupdate", "onContextmenu", "onCopy", "onCut", "onDblclick", "onFocusin", "onFocusout", "onFullscreenchange", "onFullscreenerror", "onGesturechange", "onGestureend", "onGesturestart", "onGotpointercapture", "onInput", "onKeydown", "onKeypress", "onKeyup", "onLostpointercapture", "onMousedown", "onMousemove", "onMouseout", "onMouseover", "onMouseup", "onMousewheel", "onPaste", "onPointercancel", "onPointerdown", "onPointerenter", "onPointerleave", "onPointermove", "onPointerout", "onPointerover", "onPointerup", "onReset", "onSelect", "onSubmit", "onTouchcancel", "onTouchend", "onTouchmove", "onTouchstart", "onTransitioncancel", "onTransitionend", "onTransitionrun", "onTransitionstart", "onWheel"], TP = ["ArrowUp", "ArrowDown", "ArrowRight", "ArrowLeft", "Enter", "Escape", "Tab", " "];
function PP(e) {
  return e.isComposing && TP.includes(e.key);
}
function Mc(e) {
  const [t, n] = Op(e, [Db]), i = gn(t, MP), [r, o] = Op(n, ["class", "style", "id", /^data-/]);
  return Object.assign(r, t), Object.assign(o, i), [r, o];
}
function en(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function AP(e, t) {
  let n = 0;
  const i = function() {
    for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++)
      o[a] = arguments[a];
    clearTimeout(n), n = setTimeout(() => e(...o), Be(t));
  };
  return i.clear = () => {
    clearTimeout(n);
  }, i.immediate = e, i;
}
function lr(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return Math.max(t, Math.min(n, e));
}
function Mp(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0";
  return e + n.repeat(Math.max(0, t - e.length));
}
function Tp(e, t) {
  return (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0").repeat(Math.max(0, t - e.length)) + e;
}
function EP(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  const n = [];
  let i = 0;
  for (; i < e.length; )
    n.push(e.substr(i, t)), i += t;
  return n;
}
function dn() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0;
  const i = {};
  for (const r in e)
    i[r] = e[r];
  for (const r in t) {
    const o = e[r], a = t[r];
    if (rh(o) && rh(a)) {
      i[r] = dn(o, a, n);
      continue;
    }
    if (Array.isArray(o) && Array.isArray(a) && n) {
      i[r] = n(o, a);
      continue;
    }
    i[r] = a;
  }
  return i;
}
function Lb(e) {
  return e.map((t) => t.type === qe ? Lb(t.children) : t).flat();
}
function Ao() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  if (Ao.cache.has(e))
    return Ao.cache.get(e);
  const t = e.replace(/[^a-z]/gi, "-").replace(/\B([A-Z])/g, "-$1").toLowerCase();
  return Ao.cache.set(e, t), t;
}
Ao.cache = /* @__PURE__ */ new Map();
function ys(e, t) {
  if (!t || typeof t != "object")
    return [];
  if (Array.isArray(t))
    return t.map((n) => ys(e, n)).flat(1);
  if (t.suspense)
    return ys(e, t.ssContent);
  if (Array.isArray(t.children))
    return t.children.map((n) => ys(e, n)).flat(1);
  if (t.component) {
    if (Object.getOwnPropertySymbols(t.component.provides).includes(e))
      return [t.component];
    if (t.component.subTree)
      return ys(e, t.component.subTree).flat(1);
  }
  return [];
}
function qh(e) {
  const t = mi({}), n = B(e);
  return Ln(() => {
    for (const i in n.value)
      t[i] = n.value[i];
  }, {
    flush: "sync"
  }), Bo(t);
}
function Yu(e, t) {
  return e.includes(t);
}
function Bb(e) {
  return e[2].toLowerCase() + e.slice(3);
}
const gi = () => [Function, Array];
function Pp(e, t) {
  return t = "on" + Cb(t), !!(e[t] || e[`${t}Once`] || e[`${t}Capture`] || e[`${t}OnceCapture`] || e[`${t}CaptureOnce`]);
}
function IP(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  if (Array.isArray(e))
    for (const r of e)
      r(...n);
  else
    typeof e == "function" && e(...n);
}
function Es(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  const n = ["button", "[href]", 'input:not([type="hidden"])', "select", "textarea", "[tabindex]"].map((i) => `${i}${t ? ':not([tabindex="-1"])' : ""}:not([disabled])`).join(", ");
  return [...e.querySelectorAll(n)];
}
function Vb(e, t, n) {
  let i, r = e.indexOf(document.activeElement);
  const o = t === "next" ? 1 : -1;
  do
    r += o, i = e[r];
  while ((!i || i.offsetParent == null || !((n == null ? void 0 : n(i)) ?? !0)) && r < e.length && r >= 0);
  return i;
}
function Uu(e, t) {
  var i, r, o, a;
  const n = Es(e);
  if (!t)
    (e === document.activeElement || !e.contains(document.activeElement)) && ((i = n[0]) == null || i.focus());
  else if (t === "first")
    (r = n[0]) == null || r.focus();
  else if (t === "last")
    (o = n.at(-1)) == null || o.focus();
  else if (typeof t == "number")
    (a = n[t]) == null || a.focus();
  else {
    const l = Vb(n, t);
    l ? l.focus() : Uu(e, t === "next" ? "first" : "last");
  }
}
function DP() {
}
function qu(e, t) {
  if (!(ft && typeof CSS < "u" && typeof CSS.supports < "u" && CSS.supports(`selector(${t})`)))
    return null;
  try {
    return !!e && e.matches(t);
  } catch {
    return null;
  }
}
function Gh(e) {
  return e.some((t) => gP(t) ? t.type === mP ? !1 : t.type !== qe || Gh(t.children) : !0) ? e : null;
}
function LP(e, t) {
  if (!ft || e === 0)
    return t(), () => {
    };
  const n = window.setTimeout(t, e);
  return () => window.clearTimeout(n);
}
function BP(e, t) {
  const n = e.clientX, i = e.clientY, r = t.getBoundingClientRect(), o = r.left, a = r.top, l = r.right, u = r.bottom;
  return n >= o && n <= l && i >= a && i <= u;
}
function Gu() {
  const e = Pe(), t = (n) => {
    e.value = n;
  };
  return Object.defineProperty(t, "value", {
    enumerable: !0,
    get: () => e.value,
    set: (n) => e.value = n
  }), Object.defineProperty(t, "el", {
    enumerable: !0,
    get: () => Yh(e.value)
  }), t;
}
const $b = ["top", "bottom"], VP = ["start", "end", "left", "right"];
function oh(e, t) {
  let [n, i] = e.split(" ");
  return i || (i = Yu($b, n) ? "start" : Yu(VP, n) ? "top" : "center"), {
    side: Ap(n, t),
    align: Ap(i, t)
  };
}
function Ap(e, t) {
  return e === "start" ? t ? "right" : "left" : e === "end" ? t ? "left" : "right" : e;
}
function xf(e) {
  return {
    side: {
      center: "center",
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[e.side],
    align: e.align
  };
}
function kf(e) {
  return {
    side: e.side,
    align: {
      center: "center",
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[e.align]
  };
}
function Ep(e) {
  return {
    side: e.align,
    align: e.side
  };
}
function Ip(e) {
  return Yu($b, e.side) ? "y" : "x";
}
class Eo {
  constructor(t) {
    let {
      x: n,
      y: i,
      width: r,
      height: o
    } = t;
    this.x = n, this.y = i, this.width = r, this.height = o;
  }
  get top() {
    return this.y;
  }
  get bottom() {
    return this.y + this.height;
  }
  get left() {
    return this.x;
  }
  get right() {
    return this.x + this.width;
  }
}
function Dp(e, t) {
  return {
    x: {
      before: Math.max(0, t.left - e.left),
      after: Math.max(0, e.right - t.right)
    },
    y: {
      before: Math.max(0, t.top - e.top),
      after: Math.max(0, e.bottom - t.bottom)
    }
  };
}
function Rb(e) {
  return Array.isArray(e) ? new Eo({
    x: e[0],
    y: e[1],
    width: 0,
    height: 0
  }) : e.getBoundingClientRect();
}
function Xh(e) {
  const t = e.getBoundingClientRect(), n = getComputedStyle(e), i = n.transform;
  if (i) {
    let r, o, a, l, u;
    if (i.startsWith("matrix3d("))
      r = i.slice(9, -1).split(/, /), o = +r[0], a = +r[5], l = +r[12], u = +r[13];
    else if (i.startsWith("matrix("))
      r = i.slice(7, -1).split(/, /), o = +r[0], a = +r[3], l = +r[4], u = +r[5];
    else
      return new Eo(t);
    const d = n.transformOrigin, f = t.x - l - (1 - o) * parseFloat(d), m = t.y - u - (1 - a) * parseFloat(d.slice(d.indexOf(" ") + 1)), h = o ? t.width / o : e.offsetWidth + 1, v = a ? t.height / a : e.offsetHeight + 1;
    return new Eo({
      x: f,
      y: m,
      width: h,
      height: v
    });
  } else
    return new Eo(t);
}
function pa(e, t, n) {
  if (typeof e.animate > "u")
    return {
      finished: Promise.resolve()
    };
  let i;
  try {
    i = e.animate(t, n);
  } catch {
    return {
      finished: Promise.resolve()
    };
  }
  return typeof i.finished > "u" && (i.finished = new Promise((r) => {
    i.onfinish = () => {
      r(i);
    };
  })), i;
}
const Bu = /* @__PURE__ */ new WeakMap();
function $P(e, t) {
  Object.keys(t).forEach((n) => {
    if (Uh(n)) {
      const i = Bb(n), r = Bu.get(e);
      if (t[n] == null)
        r == null || r.forEach((o) => {
          const [a, l] = o;
          a === i && (e.removeEventListener(i, l), r.delete(o));
        });
      else if (!r || ![...r].some((o) => o[0] === i && o[1] === t[n])) {
        e.addEventListener(i, t[n]);
        const o = r || /* @__PURE__ */ new Set();
        o.add([i, t[n]]), Bu.has(e) || Bu.set(e, o);
      }
    } else
      t[n] == null ? e.removeAttribute(n) : e.setAttribute(n, t[n]);
  });
}
function RP(e, t) {
  Object.keys(t).forEach((n) => {
    if (Uh(n)) {
      const i = Bb(n), r = Bu.get(e);
      r == null || r.forEach((o) => {
        const [a, l] = o;
        a === i && (e.removeEventListener(i, l), r.delete(o));
      });
    } else
      e.removeAttribute(n);
  });
}
const ca = 2.4, Lp = 0.2126729, Bp = 0.7151522, Vp = 0.072175, FP = 0.55, NP = 0.58, WP = 0.57, zP = 0.62, uu = 0.03, $p = 1.45, HP = 5e-4, jP = 1.25, YP = 1.25, Rp = 0.078, Fp = 12.82051282051282, cu = 0.06, Np = 1e-3;
function Wp(e, t) {
  const n = (e.r / 255) ** ca, i = (e.g / 255) ** ca, r = (e.b / 255) ** ca, o = (t.r / 255) ** ca, a = (t.g / 255) ** ca, l = (t.b / 255) ** ca;
  let u = n * Lp + i * Bp + r * Vp, d = o * Lp + a * Bp + l * Vp;
  if (u <= uu && (u += (uu - u) ** $p), d <= uu && (d += (uu - d) ** $p), Math.abs(d - u) < HP)
    return 0;
  let f;
  if (d > u) {
    const m = (d ** FP - u ** NP) * jP;
    f = m < Np ? 0 : m < Rp ? m - m * Fp * cu : m - cu;
  } else {
    const m = (d ** zP - u ** WP) * YP;
    f = m > -Np ? 0 : m > -Rp ? m - m * Fp * cu : m + cu;
  }
  return f * 100;
}
function ur(e) {
  Sc(`Vuetify: ${e}`);
}
function ah(e) {
  Sc(`Vuetify error: ${e}`);
}
function UP(e, t) {
  t = Array.isArray(t) ? t.slice(0, -1).map((n) => `'${n}'`).join(", ") + ` or '${t.at(-1)}'` : `'${t}'`, Sc(`[Vuetify UPGRADE] '${e}' is deprecated, use ${t} instead.`);
}
const Xu = 0.20689655172413793, qP = (e) => e > Xu ** 3 ? Math.cbrt(e) : e / (3 * Xu ** 2) + 4 / 29, GP = (e) => e > Xu ? e ** 3 : 3 * Xu ** 2 * (e - 4 / 29);
function Fb(e) {
  const t = qP, n = t(e[1]);
  return [116 * n - 16, 500 * (t(e[0] / 0.95047) - n), 200 * (n - t(e[2] / 1.08883))];
}
function Nb(e) {
  const t = GP, n = (e[0] + 16) / 116;
  return [t(n + e[1] / 500) * 0.95047, t(n), t(n - e[2] / 200) * 1.08883];
}
const XP = [[3.2406, -1.5372, -0.4986], [-0.9689, 1.8758, 0.0415], [0.0557, -0.204, 1.057]], KP = (e) => e <= 31308e-7 ? e * 12.92 : 1.055 * e ** (1 / 2.4) - 0.055, ZP = [[0.4124, 0.3576, 0.1805], [0.2126, 0.7152, 0.0722], [0.0193, 0.1192, 0.9505]], QP = (e) => e <= 0.04045 ? e / 12.92 : ((e + 0.055) / 1.055) ** 2.4;
function Wb(e) {
  const t = Array(3), n = KP, i = XP;
  for (let r = 0; r < 3; ++r)
    t[r] = Math.round(lr(n(i[r][0] * e[0] + i[r][1] * e[1] + i[r][2] * e[2])) * 255);
  return {
    r: t[0],
    g: t[1],
    b: t[2]
  };
}
function Kh(e) {
  let {
    r: t,
    g: n,
    b: i
  } = e;
  const r = [0, 0, 0], o = QP, a = ZP;
  t = o(t / 255), n = o(n / 255), i = o(i / 255);
  for (let l = 0; l < 3; ++l)
    r[l] = a[l][0] * t + a[l][1] * n + a[l][2] * i;
  return r;
}
function sh(e) {
  return !!e && /^(#|var\(--|(rgb|hsl)a?\()/.test(e);
}
function JP(e) {
  return sh(e) && !/^((rgb|hsl)a?\()?var\(--/.test(e);
}
const zp = /^(?<fn>(?:rgb|hsl)a?)\((?<values>.+)\)/, eA = {
  rgb: (e, t, n, i) => ({
    r: e,
    g: t,
    b: n,
    a: i
  }),
  rgba: (e, t, n, i) => ({
    r: e,
    g: t,
    b: n,
    a: i
  }),
  hsl: (e, t, n, i) => Hp({
    h: e,
    s: t,
    l: n,
    a: i
  }),
  hsla: (e, t, n, i) => Hp({
    h: e,
    s: t,
    l: n,
    a: i
  }),
  hsv: (e, t, n, i) => Is({
    h: e,
    s: t,
    v: n,
    a: i
  }),
  hsva: (e, t, n, i) => Is({
    h: e,
    s: t,
    v: n,
    a: i
  })
};
function Vi(e) {
  if (typeof e == "number")
    return (isNaN(e) || e < 0 || e > 16777215) && ur(`'${e}' is not a valid hex color`), {
      r: (e & 16711680) >> 16,
      g: (e & 65280) >> 8,
      b: e & 255
    };
  if (typeof e == "string" && zp.test(e)) {
    const {
      groups: t
    } = e.match(zp), {
      fn: n,
      values: i
    } = t, r = i.split(/,\s*/).map((o) => o.endsWith("%") && ["hsl", "hsla", "hsv", "hsva"].includes(n) ? parseFloat(o) / 100 : parseFloat(o));
    return eA[n](...r);
  } else if (typeof e == "string") {
    let t = e.startsWith("#") ? e.slice(1) : e;
    [3, 4].includes(t.length) ? t = t.split("").map((i) => i + i).join("") : [6, 8].includes(t.length) || ur(`'${e}' is not a valid hex(a) color`);
    const n = parseInt(t, 16);
    return (isNaN(n) || n < 0 || n > 4294967295) && ur(`'${e}' is not a valid hex(a) color`), nA(t);
  } else if (typeof e == "object") {
    if (_f(e, ["r", "g", "b"]))
      return e;
    if (_f(e, ["h", "s", "l"]))
      return Is(zb(e));
    if (_f(e, ["h", "s", "v"]))
      return Is(e);
  }
  throw new TypeError(`Invalid color: ${e == null ? e : String(e) || e.constructor.name}
Expected #hex, #hexa, rgb(), rgba(), hsl(), hsla(), object or number`);
}
function Is(e) {
  const {
    h: t,
    s: n,
    v: i,
    a: r
  } = e, o = (l) => {
    const u = (l + t / 60) % 6;
    return i - i * n * Math.max(Math.min(u, 4 - u, 1), 0);
  }, a = [o(5), o(3), o(1)].map((l) => Math.round(l * 255));
  return {
    r: a[0],
    g: a[1],
    b: a[2],
    a: r
  };
}
function Hp(e) {
  return Is(zb(e));
}
function zb(e) {
  const {
    h: t,
    s: n,
    l: i,
    a: r
  } = e, o = i + n * Math.min(i, 1 - i), a = o === 0 ? 0 : 2 - 2 * i / o;
  return {
    h: t,
    s: a,
    v: o,
    a: r
  };
}
function du(e) {
  const t = Math.round(e).toString(16);
  return ("00".substr(0, 2 - t.length) + t).toUpperCase();
}
function tA(e) {
  let {
    r: t,
    g: n,
    b: i,
    a: r
  } = e;
  return `#${[du(t), du(n), du(i), r !== void 0 ? du(Math.round(r * 255)) : ""].join("")}`;
}
function nA(e) {
  e = iA(e);
  let [t, n, i, r] = EP(e, 2).map((o) => parseInt(o, 16));
  return r = r === void 0 ? r : r / 255, {
    r: t,
    g: n,
    b: i,
    a: r
  };
}
function iA(e) {
  return e.startsWith("#") && (e = e.slice(1)), e = e.replace(/([^0-9a-f])/gi, "F"), (e.length === 3 || e.length === 4) && (e = e.split("").map((t) => t + t).join("")), e.length !== 6 && (e = Mp(Mp(e, 6), 8, "F")), e;
}
function rA(e, t) {
  const n = Fb(Kh(e));
  return n[0] = n[0] + t * 10, Wb(Nb(n));
}
function oA(e, t) {
  const n = Fb(Kh(e));
  return n[0] = n[0] - t * 10, Wb(Nb(n));
}
function aA(e) {
  const t = Vi(e);
  return Kh(t)[1];
}
function Hb(e) {
  const t = Math.abs(Wp(Vi(0), Vi(e)));
  return Math.abs(Wp(Vi(16777215), Vi(e))) > Math.min(t, 50) ? "#fff" : "#000";
}
function le(e, t) {
  return (n) => Object.keys(e).reduce((i, r) => {
    const a = typeof e[r] == "object" && e[r] != null && !Array.isArray(e[r]) ? e[r] : {
      type: e[r]
    };
    return n && r in n ? i[r] = {
      ...a,
      default: n[r]
    } : i[r] = a, t && !i[r].source && (i[r].source = t), i;
  }, {});
}
const Xe = le({
  class: [String, Array, Object],
  style: {
    type: [String, Array, Object],
    default: null
  }
}, "component"), ka = Symbol.for("vuetify:defaults");
function sA(e) {
  return ie(e);
}
function Zh() {
  const e = ht(ka);
  if (!e)
    throw new Error("[Vuetify] Could not find defaults instance");
  return e;
}
function Gr(e, t) {
  const n = Zh(), i = ie(e), r = B(() => {
    if (Be(t == null ? void 0 : t.disabled))
      return n.value;
    const a = Be(t == null ? void 0 : t.scoped), l = Be(t == null ? void 0 : t.reset), u = Be(t == null ? void 0 : t.root);
    if (i.value == null && !(a || l || u))
      return n.value;
    let d = dn(i.value, {
      prev: n.value
    });
    if (a)
      return d;
    if (l || u) {
      const f = Number(l || 1 / 0);
      for (let m = 0; m <= f && !(!d || !("prev" in d)); m++)
        d = d.prev;
      return d && typeof u == "string" && u in d && (d = dn(dn(d, {
        prev: d
      }), d[u])), d;
    }
    return d.prev ? dn(d.prev, d) : d;
  });
  return sn(ka, r), r;
}
function lA(e, t) {
  var n, i;
  return typeof ((n = e.props) == null ? void 0 : n[t]) < "u" || typeof ((i = e.props) == null ? void 0 : i[Ao(t)]) < "u";
}
function uA() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Zh();
  const i = Gt("useDefaults");
  if (t = t ?? i.type.name ?? i.type.__name, !t)
    throw new Error("[Vuetify] Could not determine component name");
  const r = B(() => {
    var u;
    return (u = n.value) == null ? void 0 : u[e._as ?? t];
  }), o = new Proxy(e, {
    get(u, d) {
      var m, h, v, y, p, b, x;
      const f = Reflect.get(u, d);
      return d === "class" || d === "style" ? [(m = r.value) == null ? void 0 : m[d], f].filter((_) => _ != null) : typeof d == "string" && !lA(i.vnode, d) ? ((h = r.value) == null ? void 0 : h[d]) !== void 0 ? (v = r.value) == null ? void 0 : v[d] : ((p = (y = n.value) == null ? void 0 : y.global) == null ? void 0 : p[d]) !== void 0 ? (x = (b = n.value) == null ? void 0 : b.global) == null ? void 0 : x[d] : f : f;
    }
  }), a = Pe();
  Ln(() => {
    if (r.value) {
      const u = Object.entries(r.value).filter((d) => {
        let [f] = d;
        return f.startsWith(f[0].toUpperCase());
      });
      a.value = u.length ? Object.fromEntries(u) : void 0;
    } else
      a.value = void 0;
  });
  function l() {
    const u = hA(ka, i);
    sn(ka, B(() => a.value ? dn((u == null ? void 0 : u.value) ?? {}, a.value) : u == null ? void 0 : u.value));
  }
  return {
    props: o,
    provideSubDefaults: l
  };
}
function Va(e) {
  if (e._setup = e._setup ?? e.setup, !e.name)
    return ur("The component is missing an explicit name, unable to generate default prop value"), e;
  if (e._setup) {
    e.props = le(e.props ?? {}, e.name)();
    const t = Object.keys(e.props).filter((n) => n !== "class" && n !== "style");
    e.filterProps = function(i) {
      return Eb(i, t);
    }, e.props._as = String, e.setup = function(i, r) {
      const o = Zh();
      if (!o.value)
        return e._setup(i, r);
      const {
        props: a,
        provideSubDefaults: l
      } = uA(i, i._as ?? e.name, o), u = e._setup(a, r);
      return l(), u;
    };
  }
  return e;
}
function ye() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  return (t) => (e ? Va : Ae)(t);
}
function Js(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "div", n = arguments.length > 2 ? arguments[2] : void 0;
  return ye()({
    name: n ?? Cb(Ob(e.replace(/__/g, "-"))),
    props: {
      tag: {
        type: String,
        default: t
      },
      ...Xe()
    },
    setup(i, r) {
      let {
        slots: o
      } = r;
      return () => {
        var a;
        return Un(i.tag, {
          class: [e, i.class],
          style: i.style
        }, (a = o.default) == null ? void 0 : a.call(o));
      };
    }
  });
}
function jb(e) {
  if (typeof e.getRootNode != "function") {
    for (; e.parentNode; )
      e = e.parentNode;
    return e !== document ? null : document;
  }
  const t = e.getRootNode();
  return t !== document && t.getRootNode({
    composed: !0
  }) !== document ? null : t;
}
const Ku = "cubic-bezier(0.4, 0, 0.2, 1)", cA = "cubic-bezier(0.0, 0, 0.2, 1)", dA = "cubic-bezier(0.4, 0, 1, 1)";
function Gt(e, t) {
  const n = Mb();
  if (!n)
    throw new Error(`[Vuetify] ${e} ${t || "must be called from inside a setup function"}`);
  return n;
}
function Wi() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "composables";
  const t = Gt(e).type;
  return Ao((t == null ? void 0 : t.aliasName) || (t == null ? void 0 : t.name));
}
let Yb = 0, Vu = /* @__PURE__ */ new WeakMap();
function qn() {
  const e = Gt("getUid");
  if (Vu.has(e))
    return Vu.get(e);
  {
    const t = Yb++;
    return Vu.set(e, t), t;
  }
}
qn.reset = () => {
  Yb = 0, Vu = /* @__PURE__ */ new WeakMap();
};
function Ub(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  for (; e; ) {
    if (t ? fA(e) : Qh(e))
      return e;
    e = e.parentElement;
  }
  return document.scrollingElement;
}
function Zu(e, t) {
  const n = [];
  if (t && e && !t.contains(e))
    return n;
  for (; e && (Qh(e) && n.push(e), e !== t); )
    e = e.parentElement;
  return n;
}
function Qh(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  const t = window.getComputedStyle(e);
  return t.overflowY === "scroll" || t.overflowY === "auto" && e.scrollHeight > e.clientHeight;
}
function fA(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  const t = window.getComputedStyle(e);
  return ["scroll", "auto"].includes(t.overflowY);
}
function hA(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Gt("injectSelf");
  const {
    provides: n
  } = t;
  if (n && e in n)
    return n[e];
}
function gA(e) {
  for (; e; ) {
    if (window.getComputedStyle(e).position === "fixed")
      return !0;
    e = e.offsetParent;
  }
  return !1;
}
function Oe(e) {
  const t = Gt("useRender");
  t.render = e;
}
function rt(e, t, n) {
  let i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (m) => m, r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (m) => m;
  const o = Gt("useProxiedModel"), a = ie(e[t] !== void 0 ? e[t] : n), l = Ao(t), d = l !== t ? B(() => {
    var m, h, v, y;
    return e[t], !!(((m = o.vnode.props) != null && m.hasOwnProperty(t) || (h = o.vnode.props) != null && h.hasOwnProperty(l)) && ((v = o.vnode.props) != null && v.hasOwnProperty(`onUpdate:${t}`) || (y = o.vnode.props) != null && y.hasOwnProperty(`onUpdate:${l}`)));
  }) : B(() => {
    var m, h;
    return e[t], !!((m = o.vnode.props) != null && m.hasOwnProperty(t) && ((h = o.vnode.props) != null && h.hasOwnProperty(`onUpdate:${t}`)));
  });
  jr(() => !d.value, () => {
    pe(() => e[t], (m) => {
      a.value = m;
    });
  });
  const f = B({
    get() {
      const m = e[t];
      return i(d.value ? m : a.value);
    },
    set(m) {
      const h = r(m), v = fn(d.value ? e[t] : a.value);
      v === h || i(v) === m || (a.value = h, o == null || o.emit(`update:${t}`, h));
    }
  });
  return Object.defineProperty(f, "externalValue", {
    get: () => d.value ? e[t] : a.value
  }), f;
}
const qb = {
  badge: "Badge",
  open: "Open",
  close: "Close",
  dismiss: "Dismiss",
  confirmEdit: {
    ok: "OK",
    cancel: "Cancel"
  },
  dataIterator: {
    noResultsText: "No matching records found",
    loadingText: "Loading items..."
  },
  dataTable: {
    itemsPerPageText: "Rows per page:",
    ariaLabel: {
      sortDescending: "Sorted descending.",
      sortAscending: "Sorted ascending.",
      sortNone: "Not sorted.",
      activateNone: "Activate to remove sorting.",
      activateDescending: "Activate to sort descending.",
      activateAscending: "Activate to sort ascending."
    },
    sortBy: "Sort by"
  },
  dataFooter: {
    itemsPerPageText: "Items per page:",
    itemsPerPageAll: "All",
    nextPage: "Next page",
    prevPage: "Previous page",
    firstPage: "First page",
    lastPage: "Last page",
    pageText: "{0}-{1} of {2}"
  },
  dateRangeInput: {
    divider: "to"
  },
  datePicker: {
    itemsSelected: "{0} selected",
    range: {
      title: "Select dates",
      header: "Enter dates"
    },
    title: "Select date",
    header: "Enter date",
    input: {
      placeholder: "Enter date"
    }
  },
  noDataText: "No data available",
  carousel: {
    prev: "Previous visual",
    next: "Next visual",
    ariaLabel: {
      delimiter: "Carousel slide {0} of {1}"
    }
  },
  calendar: {
    moreEvents: "{0} more",
    today: "Today"
  },
  input: {
    clear: "Clear {0}",
    prependAction: "{0} prepended action",
    appendAction: "{0} appended action",
    otp: "Please enter OTP character {0}"
  },
  fileInput: {
    counter: "{0} files",
    counterSize: "{0} files ({1} in total)"
  },
  timePicker: {
    am: "AM",
    pm: "PM",
    title: "Select Time"
  },
  pagination: {
    ariaLabel: {
      root: "Pagination Navigation",
      next: "Next page",
      previous: "Previous page",
      page: "Go to page {0}",
      currentPage: "Page {0}, Current page",
      first: "First page",
      last: "Last page"
    }
  },
  stepper: {
    next: "Next",
    prev: "Previous"
  },
  rating: {
    ariaLabel: {
      item: "Rating {0} of {1}"
    }
  },
  loading: "Loading...",
  infiniteScroll: {
    loadMore: "Load more",
    empty: "No more"
  }
}, jp = "$vuetify.", Yp = (e, t) => e.replace(/\{(\d+)\}/g, (n, i) => String(t[+i])), Gb = (e, t, n) => function(i) {
  for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
    o[a - 1] = arguments[a];
  if (!i.startsWith(jp))
    return Yp(i, o);
  const l = i.replace(jp, ""), u = e.value && n.value[e.value], d = t.value && n.value[t.value];
  let f = ih(u, l, null);
  return f || (ur(`Translation key "${i}" not found in "${e.value}", trying fallback locale`), f = ih(d, l, null)), f || (ah(`Translation key "${i}" not found in fallback`), f = i), typeof f != "string" && (ah(`Translation key "${i}" has a non-string value`), f = i), Yp(f, o);
};
function Xb(e, t) {
  return (n, i) => new Intl.NumberFormat([e.value, t.value], i).format(n);
}
function Sf(e, t, n) {
  const i = rt(e, t, e[t] ?? n.value);
  return i.value = e[t] ?? n.value, pe(n, (r) => {
    e[t] == null && (i.value = n.value);
  }), i;
}
function Kb(e) {
  return (t) => {
    const n = Sf(t, "locale", e.current), i = Sf(t, "fallback", e.fallback), r = Sf(t, "messages", e.messages);
    return {
      name: "vuetify",
      current: n,
      fallback: i,
      messages: r,
      t: Gb(n, i, r),
      n: Xb(n, i),
      provide: Kb({
        current: n,
        fallback: i,
        messages: r
      })
    };
  };
}
function mA(e) {
  const t = Pe((e == null ? void 0 : e.locale) ?? "en"), n = Pe((e == null ? void 0 : e.fallback) ?? "en"), i = ie({
    en: qb,
    ...e == null ? void 0 : e.messages
  });
  return {
    name: "vuetify",
    current: t,
    fallback: n,
    messages: i,
    t: Gb(t, n, i),
    n: Xb(t, n),
    provide: Kb({
      current: t,
      fallback: n,
      messages: i
    })
  };
}
const Qu = Symbol.for("vuetify:locale");
function vA(e) {
  return e.name != null;
}
function pA(e) {
  const t = e != null && e.adapter && vA(e == null ? void 0 : e.adapter) ? e == null ? void 0 : e.adapter : mA(e), n = bA(t, e);
  return {
    ...t,
    ...n
  };
}
function tn() {
  const e = ht(Qu);
  if (!e)
    throw new Error("[Vuetify] Could not find injected locale instance");
  return e;
}
function yA() {
  return {
    af: !1,
    ar: !0,
    bg: !1,
    ca: !1,
    ckb: !1,
    cs: !1,
    de: !1,
    el: !1,
    en: !1,
    es: !1,
    et: !1,
    fa: !0,
    fi: !1,
    fr: !1,
    hr: !1,
    hu: !1,
    he: !0,
    id: !1,
    it: !1,
    ja: !1,
    km: !1,
    ko: !1,
    lv: !1,
    lt: !1,
    nl: !1,
    no: !1,
    pl: !1,
    pt: !1,
    ro: !1,
    ru: !1,
    sk: !1,
    sl: !1,
    srCyrl: !1,
    srLatn: !1,
    sv: !1,
    th: !1,
    tr: !1,
    az: !1,
    uk: !1,
    vi: !1,
    zhHans: !1,
    zhHant: !1
  };
}
function bA(e, t) {
  const n = ie((t == null ? void 0 : t.rtl) ?? yA()), i = B(() => n.value[e.current.value] ?? !1);
  return {
    isRtl: i,
    rtl: n,
    rtlClasses: B(() => `v-locale--is-${i.value ? "rtl" : "ltr"}`)
  };
}
function Xr() {
  const e = ht(Qu);
  if (!e)
    throw new Error("[Vuetify] Could not find injected rtl instance");
  return {
    isRtl: e.isRtl,
    rtlClasses: e.rtlClasses
  };
}
const Ds = {
  "001": 1,
  AD: 1,
  AE: 6,
  AF: 6,
  AG: 0,
  AI: 1,
  AL: 1,
  AM: 1,
  AN: 1,
  AR: 1,
  AS: 0,
  AT: 1,
  AU: 1,
  AX: 1,
  AZ: 1,
  BA: 1,
  BD: 0,
  BE: 1,
  BG: 1,
  BH: 6,
  BM: 1,
  BN: 1,
  BR: 0,
  BS: 0,
  BT: 0,
  BW: 0,
  BY: 1,
  BZ: 0,
  CA: 0,
  CH: 1,
  CL: 1,
  CM: 1,
  CN: 1,
  CO: 0,
  CR: 1,
  CY: 1,
  CZ: 1,
  DE: 1,
  DJ: 6,
  DK: 1,
  DM: 0,
  DO: 0,
  DZ: 6,
  EC: 1,
  EE: 1,
  EG: 6,
  ES: 1,
  ET: 0,
  FI: 1,
  FJ: 1,
  FO: 1,
  FR: 1,
  GB: 1,
  "GB-alt-variant": 0,
  GE: 1,
  GF: 1,
  GP: 1,
  GR: 1,
  GT: 0,
  GU: 0,
  HK: 0,
  HN: 0,
  HR: 1,
  HU: 1,
  ID: 0,
  IE: 1,
  IL: 0,
  IN: 0,
  IQ: 6,
  IR: 6,
  IS: 1,
  IT: 1,
  JM: 0,
  JO: 6,
  JP: 0,
  KE: 0,
  KG: 1,
  KH: 0,
  KR: 0,
  KW: 6,
  KZ: 1,
  LA: 0,
  LB: 1,
  LI: 1,
  LK: 1,
  LT: 1,
  LU: 1,
  LV: 1,
  LY: 6,
  MC: 1,
  MD: 1,
  ME: 1,
  MH: 0,
  MK: 1,
  MM: 0,
  MN: 1,
  MO: 0,
  MQ: 1,
  MT: 0,
  MV: 5,
  MX: 0,
  MY: 1,
  MZ: 0,
  NI: 0,
  NL: 1,
  NO: 1,
  NP: 0,
  NZ: 1,
  OM: 6,
  PA: 0,
  PE: 0,
  PH: 0,
  PK: 0,
  PL: 1,
  PR: 0,
  PT: 0,
  PY: 0,
  QA: 6,
  RE: 1,
  RO: 1,
  RS: 1,
  RU: 1,
  SA: 0,
  SD: 6,
  SE: 1,
  SG: 0,
  SI: 1,
  SK: 1,
  SM: 1,
  SV: 0,
  SY: 6,
  TH: 0,
  TJ: 1,
  TM: 1,
  TR: 1,
  TT: 0,
  TW: 0,
  UA: 1,
  UM: 0,
  US: 0,
  UY: 1,
  UZ: 1,
  VA: 1,
  VE: 0,
  VI: 0,
  VN: 1,
  WS: 0,
  XK: 1,
  YE: 0,
  ZA: 0,
  ZW: 0
};
function wA(e, t) {
  const n = [];
  let i = [];
  const r = Zb(e), o = Qb(e), a = (r.getDay() - Ds[t.slice(-2).toUpperCase()] + 7) % 7, l = (o.getDay() - Ds[t.slice(-2).toUpperCase()] + 7) % 7;
  for (let u = 0; u < a; u++) {
    const d = new Date(r);
    d.setDate(d.getDate() - (a - u)), i.push(d);
  }
  for (let u = 1; u <= o.getDate(); u++) {
    const d = new Date(e.getFullYear(), e.getMonth(), u);
    i.push(d), i.length === 7 && (n.push(i), i = []);
  }
  for (let u = 1; u < 7 - l; u++) {
    const d = new Date(o);
    d.setDate(d.getDate() + u), i.push(d);
  }
  return i.length > 0 && n.push(i), n;
}
function _A(e, t) {
  const n = new Date(e);
  for (; n.getDay() !== (Ds[t.slice(-2).toUpperCase()] ?? 0); )
    n.setDate(n.getDate() - 1);
  return n;
}
function xA(e, t) {
  const n = new Date(e), i = ((Ds[t.slice(-2).toUpperCase()] ?? 0) + 6) % 7;
  for (; n.getDay() !== i; )
    n.setDate(n.getDate() + 1);
  return n;
}
function Zb(e) {
  return new Date(e.getFullYear(), e.getMonth(), 1);
}
function Qb(e) {
  return new Date(e.getFullYear(), e.getMonth() + 1, 0);
}
function kA(e) {
  const t = e.split("-").map(Number);
  return new Date(t[0], t[1] - 1, t[2]);
}
const SA = /^([12]\d{3}-([1-9]|0[1-9]|1[0-2])-([1-9]|0[1-9]|[12]\d|3[01]))$/;
function Jb(e) {
  if (e == null)
    return /* @__PURE__ */ new Date();
  if (e instanceof Date)
    return e;
  if (typeof e == "string") {
    let t;
    if (SA.test(e))
      return kA(e);
    if (t = Date.parse(e), !isNaN(t))
      return new Date(t);
  }
  return null;
}
const Up = new Date(2e3, 0, 2);
function CA(e) {
  const t = Ds[e.slice(-2).toUpperCase()];
  return Oc(7).map((n) => {
    const i = new Date(Up);
    return i.setDate(Up.getDate() + t + n), new Intl.DateTimeFormat(e, {
      weekday: "narrow"
    }).format(i);
  });
}
function OA(e, t, n, i) {
  const r = Jb(e) ?? /* @__PURE__ */ new Date(), o = i == null ? void 0 : i[t];
  if (typeof o == "function")
    return o(r, t, n);
  let a = {};
  switch (t) {
    case "fullDate":
      a = {
        year: "numeric",
        month: "long",
        day: "numeric"
      };
      break;
    case "fullDateWithWeekday":
      a = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      };
      break;
    case "normalDate":
      const l = r.getDate(), u = new Intl.DateTimeFormat(n, {
        month: "long"
      }).format(r);
      return `${l} ${u}`;
    case "normalDateWithWeekday":
      a = {
        weekday: "short",
        day: "numeric",
        month: "short"
      };
      break;
    case "shortDate":
      a = {
        month: "short",
        day: "numeric"
      };
      break;
    case "year":
      a = {
        year: "numeric"
      };
      break;
    case "month":
      a = {
        month: "long"
      };
      break;
    case "monthShort":
      a = {
        month: "short"
      };
      break;
    case "monthAndYear":
      a = {
        month: "long",
        year: "numeric"
      };
      break;
    case "monthAndDate":
      a = {
        month: "long",
        day: "numeric"
      };
      break;
    case "weekday":
      a = {
        weekday: "long"
      };
      break;
    case "weekdayShort":
      a = {
        weekday: "short"
      };
      break;
    case "dayOfMonth":
      return new Intl.NumberFormat(n).format(r.getDate());
    case "hours12h":
      a = {
        hour: "numeric",
        hour12: !0
      };
      break;
    case "hours24h":
      a = {
        hour: "numeric",
        hour12: !1
      };
      break;
    case "minutes":
      a = {
        minute: "numeric"
      };
      break;
    case "seconds":
      a = {
        second: "numeric"
      };
      break;
    case "fullTime":
      a = {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: !0
      };
      break;
    case "fullTime12h":
      a = {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: !0
      };
      break;
    case "fullTime24h":
      a = {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: !1
      };
      break;
    case "fullDateTime":
      a = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: !0
      };
      break;
    case "fullDateTime12h":
      a = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: !0
      };
      break;
    case "fullDateTime24h":
      a = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: !1
      };
      break;
    case "keyboardDate":
      a = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      };
      break;
    case "keyboardDateTime":
      a = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: !1
      };
      break;
    case "keyboardDateTime12h":
      a = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: !0
      };
      break;
    case "keyboardDateTime24h":
      a = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: !1
      };
      break;
    default:
      a = o ?? {
        timeZone: "UTC",
        timeZoneName: "short"
      };
  }
  return new Intl.DateTimeFormat(n, a).format(r);
}
function MA(e, t) {
  const n = e.toJsDate(t), i = n.getFullYear(), r = Tp(String(n.getMonth() + 1), 2, "0"), o = Tp(String(n.getDate()), 2, "0");
  return `${i}-${r}-${o}`;
}
function TA(e) {
  const [t, n, i] = e.split("-").map(Number);
  return new Date(t, n - 1, i);
}
function PA(e, t) {
  const n = new Date(e);
  return n.setMinutes(n.getMinutes() + t), n;
}
function AA(e, t) {
  const n = new Date(e);
  return n.setHours(n.getHours() + t), n;
}
function EA(e, t) {
  const n = new Date(e);
  return n.setDate(n.getDate() + t), n;
}
function IA(e, t) {
  const n = new Date(e);
  return n.setDate(n.getDate() + t * 7), n;
}
function DA(e, t) {
  const n = new Date(e);
  return n.setDate(1), n.setMonth(n.getMonth() + t), n;
}
function LA(e) {
  return e.getFullYear();
}
function BA(e) {
  return e.getMonth();
}
function VA(e) {
  return e.getDate();
}
function $A(e) {
  return new Date(e.getFullYear(), e.getMonth() + 1, 1);
}
function RA(e) {
  return new Date(e.getFullYear(), e.getMonth() - 1, 1);
}
function FA(e) {
  return e.getHours();
}
function NA(e) {
  return e.getMinutes();
}
function WA(e) {
  return new Date(e.getFullYear(), 0, 1);
}
function zA(e) {
  return new Date(e.getFullYear(), 11, 31);
}
function HA(e, t) {
  return Ju(e, t[0]) && UA(e, t[1]);
}
function jA(e) {
  const t = new Date(e);
  return t instanceof Date && !isNaN(t.getTime());
}
function Ju(e, t) {
  return e.getTime() > t.getTime();
}
function YA(e, t) {
  return Ju(lh(e), lh(t));
}
function UA(e, t) {
  return e.getTime() < t.getTime();
}
function qp(e, t) {
  return e.getTime() === t.getTime();
}
function qA(e, t) {
  return e.getDate() === t.getDate() && e.getMonth() === t.getMonth() && e.getFullYear() === t.getFullYear();
}
function GA(e, t) {
  return e.getMonth() === t.getMonth() && e.getFullYear() === t.getFullYear();
}
function XA(e, t) {
  return e.getFullYear() === t.getFullYear();
}
function KA(e, t, n) {
  const i = new Date(e), r = new Date(t);
  switch (n) {
    case "years":
      return i.getFullYear() - r.getFullYear();
    case "quarters":
      return Math.floor((i.getMonth() - r.getMonth() + (i.getFullYear() - r.getFullYear()) * 12) / 4);
    case "months":
      return i.getMonth() - r.getMonth() + (i.getFullYear() - r.getFullYear()) * 12;
    case "weeks":
      return Math.floor((i.getTime() - r.getTime()) / (1e3 * 60 * 60 * 24 * 7));
    case "days":
      return Math.floor((i.getTime() - r.getTime()) / (1e3 * 60 * 60 * 24));
    case "hours":
      return Math.floor((i.getTime() - r.getTime()) / (1e3 * 60 * 60));
    case "minutes":
      return Math.floor((i.getTime() - r.getTime()) / (1e3 * 60));
    case "seconds":
      return Math.floor((i.getTime() - r.getTime()) / 1e3);
    default:
      return i.getTime() - r.getTime();
  }
}
function ZA(e, t) {
  const n = new Date(e);
  return n.setHours(t), n;
}
function QA(e, t) {
  const n = new Date(e);
  return n.setMinutes(t), n;
}
function JA(e, t) {
  const n = new Date(e);
  return n.setMonth(t), n;
}
function eE(e, t) {
  const n = new Date(e);
  return n.setDate(t), n;
}
function tE(e, t) {
  const n = new Date(e);
  return n.setFullYear(t), n;
}
function lh(e) {
  return new Date(e.getFullYear(), e.getMonth(), e.getDate(), 0, 0, 0, 0);
}
function nE(e) {
  return new Date(e.getFullYear(), e.getMonth(), e.getDate(), 23, 59, 59, 999);
}
class iE {
  constructor(t) {
    this.locale = t.locale, this.formats = t.formats;
  }
  date(t) {
    return Jb(t);
  }
  toJsDate(t) {
    return t;
  }
  toISO(t) {
    return MA(this, t);
  }
  parseISO(t) {
    return TA(t);
  }
  addMinutes(t, n) {
    return PA(t, n);
  }
  addHours(t, n) {
    return AA(t, n);
  }
  addDays(t, n) {
    return EA(t, n);
  }
  addWeeks(t, n) {
    return IA(t, n);
  }
  addMonths(t, n) {
    return DA(t, n);
  }
  getWeekArray(t) {
    return wA(t, this.locale);
  }
  startOfWeek(t) {
    return _A(t, this.locale);
  }
  endOfWeek(t) {
    return xA(t, this.locale);
  }
  startOfMonth(t) {
    return Zb(t);
  }
  endOfMonth(t) {
    return Qb(t);
  }
  format(t, n) {
    return OA(t, n, this.locale, this.formats);
  }
  isEqual(t, n) {
    return qp(t, n);
  }
  isValid(t) {
    return jA(t);
  }
  isWithinRange(t, n) {
    return HA(t, n);
  }
  isAfter(t, n) {
    return Ju(t, n);
  }
  isAfterDay(t, n) {
    return YA(t, n);
  }
  isBefore(t, n) {
    return !Ju(t, n) && !qp(t, n);
  }
  isSameDay(t, n) {
    return qA(t, n);
  }
  isSameMonth(t, n) {
    return GA(t, n);
  }
  isSameYear(t, n) {
    return XA(t, n);
  }
  setMinutes(t, n) {
    return QA(t, n);
  }
  setHours(t, n) {
    return ZA(t, n);
  }
  setMonth(t, n) {
    return JA(t, n);
  }
  setDate(t, n) {
    return eE(t, n);
  }
  setYear(t, n) {
    return tE(t, n);
  }
  getDiff(t, n, i) {
    return KA(t, n, i);
  }
  getWeekdays() {
    return CA(this.locale);
  }
  getYear(t) {
    return LA(t);
  }
  getMonth(t) {
    return BA(t);
  }
  getDate(t) {
    return VA(t);
  }
  getNextMonth(t) {
    return $A(t);
  }
  getPreviousMonth(t) {
    return RA(t);
  }
  getHours(t) {
    return FA(t);
  }
  getMinutes(t) {
    return NA(t);
  }
  startOfDay(t) {
    return lh(t);
  }
  endOfDay(t) {
    return nE(t);
  }
  startOfYear(t) {
    return WA(t);
  }
  endOfYear(t) {
    return zA(t);
  }
}
const e1 = Symbol.for("vuetify:date-options"), Gp = Symbol.for("vuetify:date-adapter");
function rE(e, t) {
  const n = dn({
    adapter: iE,
    locale: {
      af: "af-ZA",
      // ar: '', # not the same value for all variants
      bg: "bg-BG",
      ca: "ca-ES",
      ckb: "",
      cs: "cs-CZ",
      de: "de-DE",
      el: "el-GR",
      en: "en-US",
      // es: '', # not the same value for all variants
      et: "et-EE",
      fa: "fa-IR",
      fi: "fi-FI",
      // fr: '', #not the same value for all variants
      hr: "hr-HR",
      hu: "hu-HU",
      he: "he-IL",
      id: "id-ID",
      it: "it-IT",
      ja: "ja-JP",
      ko: "ko-KR",
      lv: "lv-LV",
      lt: "lt-LT",
      nl: "nl-NL",
      no: "no-NO",
      pl: "pl-PL",
      pt: "pt-PT",
      ro: "ro-RO",
      ru: "ru-RU",
      sk: "sk-SK",
      sl: "sl-SI",
      srCyrl: "sr-SP",
      srLatn: "sr-SP",
      sv: "sv-SE",
      th: "th-TH",
      tr: "tr-TR",
      az: "az-AZ",
      uk: "uk-UA",
      vi: "vi-VN",
      zhHans: "zh-CN",
      zhHant: "zh-TW"
    }
  }, e);
  return {
    options: n,
    instance: t1(n, t)
  };
}
function t1(e, t) {
  const n = mi(typeof e.adapter == "function" ? new e.adapter({
    locale: e.locale[t.current.value] ?? t.current.value,
    formats: e.formats
  }) : e.adapter);
  return pe(t.current, (i) => {
    n.locale = e.locale[i] ?? i ?? n.locale;
  }), n;
}
function el() {
  const e = ht(e1);
  if (!e)
    throw new Error("[Vuetify] Could not find injected date options");
  const t = tn();
  return t1(e, t);
}
function oE(e, t) {
  const n = e.toJsDate(t);
  let i = n.getFullYear(), r = new Date(i, 0, 1);
  if (n < r)
    i = i - 1, r = new Date(i, 0, 1);
  else {
    const l = new Date(i + 1, 0, 1);
    n >= l && (i = i + 1, r = l);
  }
  const o = Math.abs(n.getTime() - r.getTime()), a = Math.ceil(o / (1e3 * 60 * 60 * 24));
  return Math.floor(a / 7) + 1;
}
const uh = Symbol.for("vuetify:display"), Xp = {
  mobileBreakpoint: "lg",
  thresholds: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
    xxl: 2560
  }
}, aE = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Xp;
  return dn(Xp, e);
};
function Kp(e) {
  return ft && !e ? window.innerWidth : typeof e == "object" && e.clientWidth || 0;
}
function Zp(e) {
  return ft && !e ? window.innerHeight : typeof e == "object" && e.clientHeight || 0;
}
function Qp(e) {
  const t = ft && !e ? window.navigator.userAgent : "ssr";
  function n(y) {
    return !!t.match(y);
  }
  const i = n(/android/i), r = n(/iphone|ipad|ipod/i), o = n(/cordova/i), a = n(/electron/i), l = n(/chrome/i), u = n(/edge/i), d = n(/firefox/i), f = n(/opera/i), m = n(/win/i), h = n(/mac/i), v = n(/linux/i);
  return {
    android: i,
    ios: r,
    cordova: o,
    electron: a,
    chrome: l,
    edge: u,
    firefox: d,
    opera: f,
    win: m,
    mac: h,
    linux: v,
    touch: OP,
    ssr: t === "ssr"
  };
}
function sE(e, t) {
  const {
    thresholds: n,
    mobileBreakpoint: i
  } = aE(e), r = Pe(Zp(t)), o = Pe(Qp(t)), a = mi({}), l = Pe(Kp(t));
  function u() {
    r.value = Zp(), l.value = Kp();
  }
  function d() {
    u(), o.value = Qp();
  }
  return Ln(() => {
    const f = l.value < n.sm, m = l.value < n.md && !f, h = l.value < n.lg && !(m || f), v = l.value < n.xl && !(h || m || f), y = l.value < n.xxl && !(v || h || m || f), p = l.value >= n.xxl, b = f ? "xs" : m ? "sm" : h ? "md" : v ? "lg" : y ? "xl" : "xxl", x = typeof i == "number" ? i : n[i], _ = l.value < x;
    a.xs = f, a.sm = m, a.md = h, a.lg = v, a.xl = y, a.xxl = p, a.smAndUp = !f, a.mdAndUp = !(f || m), a.lgAndUp = !(f || m || h), a.xlAndUp = !(f || m || h || v), a.smAndDown = !(h || v || y || p), a.mdAndDown = !(v || y || p), a.lgAndDown = !(y || p), a.xlAndDown = !p, a.name = b, a.height = r.value, a.width = l.value, a.mobile = _, a.mobileBreakpoint = i, a.platform = o.value, a.thresholds = n;
  }), ft && window.addEventListener("resize", u, {
    passive: !0
  }), {
    ...Bo(a),
    update: d,
    ssr: !!t
  };
}
const lE = le({
  mobile: {
    type: Boolean,
    default: !1
  },
  mobileBreakpoint: [Number, String]
}, "display");
function Jh() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Wi();
  const n = ht(uh);
  if (!n)
    throw new Error("Could not find Vuetify display injection");
  const i = B(() => {
    if (e.mobile != null)
      return e.mobile;
    if (!e.mobileBreakpoint)
      return n.mobile.value;
    const o = typeof e.mobileBreakpoint == "number" ? e.mobileBreakpoint : n.thresholds.value[e.mobileBreakpoint];
    return n.width.value < o;
  }), r = B(() => t ? {
    [`${t}--mobile`]: i.value
  } : {});
  return {
    ...n,
    displayClasses: r,
    mobile: i
  };
}
const n1 = Symbol.for("vuetify:goto");
function i1() {
  return {
    container: void 0,
    duration: 300,
    layout: !1,
    offset: 0,
    easing: "easeInOutCubic",
    patterns: {
      linear: (e) => e,
      easeInQuad: (e) => e ** 2,
      easeOutQuad: (e) => e * (2 - e),
      easeInOutQuad: (e) => e < 0.5 ? 2 * e ** 2 : -1 + (4 - 2 * e) * e,
      easeInCubic: (e) => e ** 3,
      easeOutCubic: (e) => --e ** 3 + 1,
      easeInOutCubic: (e) => e < 0.5 ? 4 * e ** 3 : (e - 1) * (2 * e - 2) * (2 * e - 2) + 1,
      easeInQuart: (e) => e ** 4,
      easeOutQuart: (e) => 1 - --e ** 4,
      easeInOutQuart: (e) => e < 0.5 ? 8 * e ** 4 : 1 - 8 * --e ** 4,
      easeInQuint: (e) => e ** 5,
      easeOutQuint: (e) => 1 + --e ** 5,
      easeInOutQuint: (e) => e < 0.5 ? 16 * e ** 5 : 1 + 16 * --e ** 5
    }
  };
}
function uE(e) {
  return eg(e) ?? (document.scrollingElement || document.body);
}
function eg(e) {
  return typeof e == "string" ? document.querySelector(e) : Yh(e);
}
function Cf(e, t, n) {
  if (typeof e == "number")
    return t && n ? -e : e;
  let i = eg(e), r = 0;
  for (; i; )
    r += t ? i.offsetLeft : i.offsetTop, i = i.offsetParent;
  return r;
}
function cE(e, t) {
  return {
    rtl: t.isRtl,
    options: dn(i1(), e)
  };
}
async function Jp(e, t, n, i) {
  const r = n ? "scrollLeft" : "scrollTop", o = dn((i == null ? void 0 : i.options) ?? i1(), t), a = i == null ? void 0 : i.rtl.value, l = (typeof e == "number" ? e : eg(e)) ?? 0, u = o.container === "parent" && l instanceof HTMLElement ? l.parentElement : uE(o.container), d = typeof o.easing == "function" ? o.easing : o.patterns[o.easing];
  if (!d)
    throw new TypeError(`Easing function "${o.easing}" not found.`);
  let f;
  if (typeof l == "number")
    f = Cf(l, n, a);
  else if (f = Cf(l, n, a) - Cf(u, n, a), o.layout) {
    const y = window.getComputedStyle(l).getPropertyValue("--v-layout-top");
    y && (f -= parseInt(y, 10));
  }
  f += o.offset, f = fE(u, f, !!a, !!n);
  const m = u[r] ?? 0;
  if (f === m)
    return Promise.resolve(f);
  const h = performance.now();
  return new Promise((v) => requestAnimationFrame(function y(p) {
    const x = (p - h) / o.duration, _ = Math.floor(m + (f - m) * d(lr(x, 0, 1)));
    if (u[r] = _, x >= 1 && Math.abs(_ - u[r]) < 10)
      return v(f);
    if (x > 2)
      return ur("Scroll target is not reachable"), v(u[r]);
    requestAnimationFrame(y);
  }));
}
function dE() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const t = ht(n1), {
    isRtl: n
  } = Xr();
  if (!t)
    throw new Error("[Vuetify] Could not find injected goto instance");
  const i = {
    ...t,
    // can be set via VLocaleProvider
    rtl: B(() => t.rtl.value || n.value)
  };
  async function r(o, a) {
    return Jp(o, dn(e, a), !1, i);
  }
  return r.horizontal = async (o, a) => Jp(o, dn(e, a), !0, i), r;
}
function fE(e, t, n, i) {
  const {
    scrollWidth: r,
    scrollHeight: o
  } = e, [a, l] = e === document.scrollingElement ? [window.innerWidth, window.innerHeight] : [e.offsetWidth, e.offsetHeight];
  let u, d;
  return i ? n ? (u = -(r - a), d = 0) : (u = 0, d = r - a) : (u = 0, d = o + -l), Math.max(Math.min(t, d), u);
}
const hE = {
  collapse: "mdi-chevron-up",
  complete: "mdi-check",
  cancel: "mdi-close-circle",
  close: "mdi-close",
  delete: "mdi-close-circle",
  // delete (e.g. v-chip close)
  clear: "mdi-close-circle",
  success: "mdi-check-circle",
  info: "mdi-information",
  warning: "mdi-alert-circle",
  error: "mdi-close-circle",
  prev: "mdi-chevron-left",
  next: "mdi-chevron-right",
  checkboxOn: "mdi-checkbox-marked",
  checkboxOff: "mdi-checkbox-blank-outline",
  checkboxIndeterminate: "mdi-minus-box",
  delimiter: "mdi-circle",
  // for carousel
  sortAsc: "mdi-arrow-up",
  sortDesc: "mdi-arrow-down",
  expand: "mdi-chevron-down",
  menu: "mdi-menu",
  subgroup: "mdi-menu-down",
  dropdown: "mdi-menu-down",
  radioOn: "mdi-radiobox-marked",
  radioOff: "mdi-radiobox-blank",
  edit: "mdi-pencil",
  ratingEmpty: "mdi-star-outline",
  ratingFull: "mdi-star",
  ratingHalf: "mdi-star-half-full",
  loading: "mdi-cached",
  first: "mdi-page-first",
  last: "mdi-page-last",
  unfold: "mdi-unfold-more-horizontal",
  file: "mdi-paperclip",
  plus: "mdi-plus",
  minus: "mdi-minus",
  calendar: "mdi-calendar",
  treeviewCollapse: "mdi-menu-down",
  treeviewExpand: "mdi-menu-right",
  eyeDropper: "mdi-eyedropper"
}, r1 = {
  // Not using mergeProps here, functional components merge props by default (?)
  component: (e) => Un(o1, {
    ...e,
    class: "mdi"
  })
}, ot = [String, Function, Object, Array], ch = Symbol.for("vuetify:icons"), Tc = le({
  icon: {
    type: ot
  },
  // Could not remove this and use makeTagProps, types complained because it is not required
  tag: {
    type: String,
    required: !0
  }
}, "icon"), ey = ye()({
  name: "VComponentIcon",
  props: Tc(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return () => {
      const i = e.icon;
      return T(e.tag, null, {
        default: () => {
          var r;
          return [e.icon ? T(i, null, null) : (r = n.default) == null ? void 0 : r.call(n)];
        }
      });
    };
  }
}), tg = Va({
  name: "VSvgIcon",
  inheritAttrs: !1,
  props: Tc(),
  setup(e, t) {
    let {
      attrs: n
    } = t;
    return () => T(e.tag, ge(n, {
      style: null
    }), {
      default: () => [T("svg", {
        class: "v-icon__svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        role: "img",
        "aria-hidden": "true"
      }, [Array.isArray(e.icon) ? e.icon.map((i) => Array.isArray(i) ? T("path", {
        d: i[0],
        "fill-opacity": i[1]
      }, null) : T("path", {
        d: i
      }, null)) : T("path", {
        d: e.icon
      }, null)])]
    });
  }
});
Va({
  name: "VLigatureIcon",
  props: Tc(),
  setup(e) {
    return () => T(e.tag, null, {
      default: () => [e.icon]
    });
  }
});
const o1 = Va({
  name: "VClassIcon",
  props: Tc(),
  setup(e) {
    return () => T(e.tag, {
      class: e.icon
    }, null);
  }
});
function gE() {
  return {
    svg: {
      component: tg
    },
    class: {
      component: o1
    }
  };
}
function mE(e) {
  const t = gE(), n = (e == null ? void 0 : e.defaultSet) ?? "mdi";
  return n === "mdi" && !t.mdi && (t.mdi = r1), dn({
    defaultSet: n,
    sets: t,
    aliases: {
      ...hE,
      /* eslint-disable max-len */
      vuetify: ["M8.2241 14.2009L12 21L22 3H14.4459L8.2241 14.2009Z", ["M7.26303 12.4733L7.00113 12L2 3H12.5261C12.5261 3 12.5261 3 12.5261 3L7.26303 12.4733Z", 0.6]],
      "vuetify-outline": "svg:M7.26 12.47 12.53 3H2L7.26 12.47ZM14.45 3 8.22 14.2 12 21 22 3H14.45ZM18.6 5 12 16.88 10.51 14.2 15.62 5ZM7.26 8.35 5.4 5H9.13L7.26 8.35Z",
      "vuetify-play": ["m6.376 13.184-4.11-7.192C1.505 4.66 2.467 3 4.003 3h8.532l-.953 1.576-.006.01-.396.677c-.429.732-.214 1.507.194 2.015.404.503 1.092.878 1.869.806a3.72 3.72 0 0 1 1.005.022c.276.053.434.143.523.237.138.146.38.635-.25 2.09-.893 1.63-1.553 1.722-1.847 1.677-.213-.033-.468-.158-.756-.406a4.95 4.95 0 0 1-.8-.927c-.39-.564-1.04-.84-1.66-.846-.625-.006-1.316.27-1.693.921l-.478.826-.911 1.506Z", ["M9.093 11.552c.046-.079.144-.15.32-.148a.53.53 0 0 1 .43.207c.285.414.636.847 1.046 1.2.405.35.914.662 1.516.754 1.334.205 2.502-.698 3.48-2.495l.014-.028.013-.03c.687-1.574.774-2.852-.005-3.675-.37-.391-.861-.586-1.333-.676a5.243 5.243 0 0 0-1.447-.044c-.173.016-.393-.073-.54-.257-.145-.18-.127-.316-.082-.392l.393-.672L14.287 3h5.71c1.536 0 2.499 1.659 1.737 2.992l-7.997 13.996c-.768 1.344-2.706 1.344-3.473 0l-3.037-5.314 1.377-2.278.004-.006.004-.007.481-.831Z", 0.6]]
      /* eslint-enable max-len */
    }
  }, e);
}
const vE = (e) => {
  const t = ht(ch);
  if (!t)
    throw new Error("Missing Vuetify Icons provide!");
  return {
    iconData: B(() => {
      var u;
      const i = Be(e);
      if (!i)
        return {
          component: ey
        };
      let r = i;
      if (typeof r == "string" && (r = r.trim(), r.startsWith("$") && (r = (u = t.aliases) == null ? void 0 : u[r.slice(1)])), r || ur(`Could not find aliased icon "${i}"`), Array.isArray(r))
        return {
          component: tg,
          icon: r
        };
      if (typeof r != "string")
        return {
          component: ey,
          icon: r
        };
      const o = Object.keys(t.sets).find((d) => typeof r == "string" && r.startsWith(`${d}:`)), a = o ? r.slice(o.length + 1) : r;
      return {
        component: t.sets[o ?? t.defaultSet].component,
        icon: a
      };
    })
  };
}, Ls = Symbol.for("vuetify:theme"), Mt = le({
  theme: String
}, "theme");
function ty() {
  return {
    defaultTheme: "light",
    variations: {
      colors: [],
      lighten: 0,
      darken: 0
    },
    themes: {
      light: {
        dark: !1,
        colors: {
          background: "#FFFFFF",
          surface: "#FFFFFF",
          "surface-bright": "#FFFFFF",
          "surface-light": "#EEEEEE",
          "surface-variant": "#424242",
          "on-surface-variant": "#EEEEEE",
          primary: "#1867C0",
          "primary-darken-1": "#1F5592",
          secondary: "#48A9A6",
          "secondary-darken-1": "#018786",
          error: "#B00020",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FB8C00"
        },
        variables: {
          "border-color": "#000000",
          "border-opacity": 0.12,
          "high-emphasis-opacity": 0.87,
          "medium-emphasis-opacity": 0.6,
          "disabled-opacity": 0.38,
          "idle-opacity": 0.04,
          "hover-opacity": 0.04,
          "focus-opacity": 0.12,
          "selected-opacity": 0.08,
          "activated-opacity": 0.12,
          "pressed-opacity": 0.12,
          "dragged-opacity": 0.08,
          "theme-kbd": "#212529",
          "theme-on-kbd": "#FFFFFF",
          "theme-code": "#F5F5F5",
          "theme-on-code": "#000000"
        }
      },
      dark: {
        dark: !0,
        colors: {
          background: "#121212",
          surface: "#212121",
          "surface-bright": "#ccbfd6",
          "surface-light": "#424242",
          "surface-variant": "#a3a3a3",
          "on-surface-variant": "#424242",
          primary: "#2196F3",
          "primary-darken-1": "#277CC1",
          secondary: "#54B6B2",
          "secondary-darken-1": "#48A9A6",
          error: "#CF6679",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FB8C00"
        },
        variables: {
          "border-color": "#FFFFFF",
          "border-opacity": 0.12,
          "high-emphasis-opacity": 1,
          "medium-emphasis-opacity": 0.7,
          "disabled-opacity": 0.5,
          "idle-opacity": 0.1,
          "hover-opacity": 0.04,
          "focus-opacity": 0.12,
          "selected-opacity": 0.08,
          "activated-opacity": 0.12,
          "pressed-opacity": 0.16,
          "dragged-opacity": 0.08,
          "theme-kbd": "#212529",
          "theme-on-kbd": "#FFFFFF",
          "theme-code": "#343434",
          "theme-on-code": "#CCCCCC"
        }
      }
    }
  };
}
function pE() {
  var i, r;
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ty();
  const t = ty();
  if (!e)
    return {
      ...t,
      isDisabled: !0
    };
  const n = {};
  for (const [o, a] of Object.entries(e.themes ?? {})) {
    const l = a.dark || o === "dark" ? (i = t.themes) == null ? void 0 : i.dark : (r = t.themes) == null ? void 0 : r.light;
    n[o] = dn(l, a);
  }
  return dn(t, {
    ...e,
    themes: n
  });
}
function yE(e) {
  const t = pE(e), n = ie(t.defaultTheme), i = ie(t.themes), r = B(() => {
    const f = {};
    for (const [m, h] of Object.entries(i.value)) {
      const v = f[m] = {
        ...h,
        colors: {
          ...h.colors
        }
      };
      if (t.variations)
        for (const y of t.variations.colors) {
          const p = v.colors[y];
          if (p)
            for (const b of ["lighten", "darken"]) {
              const x = b === "lighten" ? rA : oA;
              for (const _ of Oc(t.variations[b], 1))
                v.colors[`${y}-${b}-${_}`] = tA(x(Vi(p), _));
            }
        }
      for (const y of Object.keys(v.colors)) {
        if (/^on-[a-z]/.test(y) || v.colors[`on-${y}`])
          continue;
        const p = `on-${y}`, b = Vi(v.colors[y]);
        v.colors[p] = Hb(b);
      }
    }
    return f;
  }), o = B(() => r.value[n.value]), a = B(() => {
    var y;
    const f = [];
    (y = o.value) != null && y.dark && bo(f, ":root", ["color-scheme: dark"]), bo(f, ":root", ny(o.value));
    for (const [p, b] of Object.entries(r.value))
      bo(f, `.v-theme--${p}`, [`color-scheme: ${b.dark ? "dark" : "normal"}`, ...ny(b)]);
    const m = [], h = [], v = new Set(Object.values(r.value).flatMap((p) => Object.keys(p.colors)));
    for (const p of v)
      /^on-[a-z]/.test(p) ? bo(h, `.${p}`, [`color: rgb(var(--v-theme-${p})) !important`]) : (bo(m, `.bg-${p}`, [`--v-theme-overlay-multiplier: var(--v-theme-${p}-overlay-multiplier)`, `background-color: rgb(var(--v-theme-${p})) !important`, `color: rgb(var(--v-theme-on-${p})) !important`]), bo(h, `.text-${p}`, [`color: rgb(var(--v-theme-${p})) !important`]), bo(h, `.border-${p}`, [`--v-border-color: var(--v-theme-${p})`]));
    return f.push(...m, ...h), f.map((p, b) => b === 0 ? p : `    ${p}`).join("");
  });
  function l() {
    return {
      style: [{
        children: a.value,
        id: "vuetify-theme-stylesheet",
        nonce: t.cspNonce || !1
      }]
    };
  }
  function u(f) {
    if (t.isDisabled)
      return;
    const m = f._context.provides.usehead;
    if (m)
      if (m.push) {
        const h = m.push(l);
        ft && pe(a, () => {
          h.patch(l);
        });
      } else
        ft ? (m.addHeadObjs(B(l)), Ln(() => m.updateDOM())) : m.addHeadObjs(l());
    else {
      let v = function() {
        if (typeof document < "u" && !h) {
          const y = document.createElement("style");
          y.type = "text/css", y.id = "vuetify-theme-stylesheet", t.cspNonce && y.setAttribute("nonce", t.cspNonce), h = y, document.head.appendChild(h);
        }
        h && (h.innerHTML = a.value);
      }, h = ft ? document.getElementById("vuetify-theme-stylesheet") : null;
      ft ? pe(a, v, {
        immediate: !0
      }) : v();
    }
  }
  const d = B(() => t.isDisabled ? void 0 : `v-theme--${n.value}`);
  return {
    install: u,
    isDisabled: t.isDisabled,
    name: n,
    themes: i,
    current: o,
    computedThemes: r,
    themeClasses: d,
    styles: a,
    global: {
      name: n,
      current: o
    }
  };
}
function Wt(e) {
  Gt("provideTheme");
  const t = ht(Ls, null);
  if (!t)
    throw new Error("Could not find Vuetify theme injection");
  const n = B(() => e.theme ?? t.name.value), i = B(() => t.themes.value[n.value]), r = B(() => t.isDisabled ? void 0 : `v-theme--${n.value}`), o = {
    ...t,
    name: n,
    current: i,
    themeClasses: r
  };
  return sn(Ls, o), o;
}
function JH() {
  Gt("useTheme");
  const e = ht(Ls, null);
  if (!e)
    throw new Error("Could not find Vuetify theme injection");
  return e;
}
function bo(e, t, n) {
  e.push(`${t} {
`, ...n.map((i) => `  ${i};
`), `}
`);
}
function ny(e) {
  const t = e.dark ? 2 : 1, n = e.dark ? 1 : 2, i = [];
  for (const [r, o] of Object.entries(e.colors)) {
    const a = Vi(o);
    i.push(`--v-theme-${r}: ${a.r},${a.g},${a.b}`), r.startsWith("on-") || i.push(`--v-theme-${r}-overlay-multiplier: ${aA(o) > 0.18 ? t : n}`);
  }
  for (const [r, o] of Object.entries(e.variables)) {
    const a = typeof o == "string" && o.startsWith("#") ? Vi(o) : void 0, l = a ? `${a.r}, ${a.g}, ${a.b}` : void 0;
    i.push(`--v-${r}: ${l ?? o}`);
  }
  return i;
}
function Bs(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "content";
  const n = Gu(), i = ie();
  if (ft) {
    const r = new ResizeObserver((o) => {
      e == null || e(o, r), o.length && (t === "content" ? i.value = o[0].contentRect : i.value = o[0].target.getBoundingClientRect());
    });
    _n(() => {
      r.disconnect();
    }), pe(() => n.el, (o, a) => {
      a && (r.unobserve(a), i.value = void 0), o && r.observe(o);
    }, {
      flush: "post"
    });
  }
  return {
    resizeRef: n,
    contentRect: Nh(i)
  };
}
const a1 = Symbol.for("vuetify:layout");
function bE() {
  const e = ht(a1);
  if (!e)
    throw new Error("[Vuetify] Could not find injected layout");
  return {
    layoutIsReady: gt(),
    getLayoutItem: e.getLayoutItem,
    mainRect: e.mainRect,
    mainStyles: e.mainStyles
  };
}
function s1() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    blueprint: t,
    ...n
  } = e, i = dn(t, n), {
    aliases: r = {},
    components: o = {},
    directives: a = {}
  } = i, l = sA(i.defaults), u = sE(i.display, i.ssr), d = yE(i.theme), f = mE(i.icons), m = pA(i.locale), h = rE(i.date, m), v = cE(i.goTo, m);
  return {
    install: (p) => {
      for (const b in a)
        p.directive(b, a[b]);
      for (const b in o)
        p.component(b, o[b]);
      for (const b in r)
        p.component(b, Va({
          ...r[b],
          name: b,
          aliasName: r[b].name
        }));
      if (d.install(p), p.provide(ka, l), p.provide(uh, u), p.provide(Ls, d), p.provide(ch, f), p.provide(Qu, m), p.provide(e1, h.options), p.provide(Gp, h.instance), p.provide(n1, v), ft && i.ssr)
        if (p.$nuxt)
          p.$nuxt.hook("app:suspense:resolve", () => {
            u.update();
          });
        else {
          const {
            mount: b
          } = p;
          p.mount = function() {
            const x = b(...arguments);
            return gt(() => u.update()), p.mount = b, x;
          };
        }
      qn.reset(), p.mixin({
        computed: {
          $vuetify() {
            return mi({
              defaults: da.call(this, ka),
              display: da.call(this, uh),
              theme: da.call(this, Ls),
              icons: da.call(this, ch),
              locale: da.call(this, Qu),
              date: da.call(this, Gp)
            });
          }
        }
      });
    },
    defaults: l,
    display: u,
    theme: d,
    icons: f,
    locale: m,
    date: h,
    goTo: v
  };
}
const wE = "3.6.7";
s1.version = wE;
function da(e) {
  var i, r;
  const t = this.$, n = ((i = t.parent) == null ? void 0 : i.provides) ?? ((r = t.vnode.appContext) == null ? void 0 : r.provides);
  if (n && e in n)
    return n[e];
}
const _E = ye()({
  name: "VCardActions",
  props: Xe(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return Gr({
      VBtn: {
        slim: !0,
        variant: "text"
      }
    }), Oe(() => {
      var i;
      return T("div", {
        class: ["v-card-actions", e.class],
        style: e.style
      }, [(i = n.default) == null ? void 0 : i.call(n)]);
    }), {};
  }
}), Bt = le({
  tag: {
    type: String,
    default: "div"
  }
}, "tag"), xE = le({
  opacity: [Number, String],
  ...Xe(),
  ...Bt()
}, "VCardSubtitle"), kE = ye()({
  name: "VCardSubtitle",
  props: xE(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return Oe(() => T(e.tag, {
      class: ["v-card-subtitle", e.class],
      style: [{
        "--v-card-subtitle-opacity": e.opacity
      }, e.style]
    }, n)), {};
  }
}), SE = Js("v-card-title"), CE = le({
  defaults: Object,
  disabled: Boolean,
  reset: [Number, String],
  root: [Boolean, String],
  scoped: Boolean
}, "VDefaultsProvider"), pt = ye(!1)({
  name: "VDefaultsProvider",
  props: CE(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      defaults: i,
      disabled: r,
      reset: o,
      root: a,
      scoped: l
    } = Bo(e);
    return Gr(i, {
      reset: o,
      root: a,
      scoped: l,
      disabled: r
    }), () => {
      var u;
      return (u = n.default) == null ? void 0 : u.call(n);
    };
  }
});
function ng(e) {
  return qh(() => {
    const t = [], n = {};
    if (e.value.background)
      if (sh(e.value.background)) {
        if (n.backgroundColor = e.value.background, !e.value.text && JP(e.value.background)) {
          const i = Vi(e.value.background);
          if (i.a == null || i.a === 1) {
            const r = Hb(i);
            n.color = r, n.caretColor = r;
          }
        }
      } else
        t.push(`bg-${e.value.background}`);
    return e.value.text && (sh(e.value.text) ? (n.color = e.value.text, n.caretColor = e.value.text) : t.push(`text-${e.value.text}`)), {
      colorClasses: t,
      colorStyles: n
    };
  });
}
function Fi(e, t) {
  const n = B(() => ({
    text: cr(e) ? e.value : t ? e[t] : null
  })), {
    colorClasses: i,
    colorStyles: r
  } = ng(n);
  return {
    textColorClasses: i,
    textColorStyles: r
  };
}
function Yn(e, t) {
  const n = B(() => ({
    background: cr(e) ? e.value : t ? e[t] : null
  })), {
    colorClasses: i,
    colorStyles: r
  } = ng(n);
  return {
    backgroundColorClasses: i,
    backgroundColorStyles: r
  };
}
const OE = ["x-small", "small", "default", "large", "x-large"], tl = le({
  size: {
    type: [String, Number],
    default: "default"
  }
}, "size");
function nl(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Wi();
  return qh(() => {
    let n, i;
    return Yu(OE, e.size) ? n = `${t}--size-${e.size}` : e.size && (i = {
      width: ze(e.size),
      height: ze(e.size)
    }), {
      sizeClasses: n,
      sizeStyles: i
    };
  });
}
const ME = le({
  color: String,
  disabled: Boolean,
  start: Boolean,
  end: Boolean,
  icon: ot,
  ...Xe(),
  ...tl(),
  ...Bt({
    tag: "i"
  }),
  ...Mt()
}, "VIcon"), At = ye()({
  name: "VIcon",
  props: ME(),
  setup(e, t) {
    let {
      attrs: n,
      slots: i
    } = t;
    const r = ie(), {
      themeClasses: o
    } = Wt(e), {
      iconData: a
    } = vE(B(() => r.value || e.icon)), {
      sizeClasses: l
    } = nl(e), {
      textColorClasses: u,
      textColorStyles: d
    } = Fi(Me(e, "color"));
    return Oe(() => {
      var h, v;
      const f = (h = i.default) == null ? void 0 : h.call(i);
      f && (r.value = (v = Lb(f).filter((y) => y.type === vP && y.children && typeof y.children == "string")[0]) == null ? void 0 : v.children);
      const m = !!(n.onClick || n.onClickOnce);
      return T(a.value.component, {
        tag: e.tag,
        icon: a.value.icon,
        class: ["v-icon", "notranslate", o.value, l.value, u.value, {
          "v-icon--clickable": m,
          "v-icon--disabled": e.disabled,
          "v-icon--start": e.start,
          "v-icon--end": e.end
        }, e.class],
        style: [l.value ? void 0 : {
          fontSize: ze(e.size),
          height: ze(e.size),
          width: ze(e.size)
        }, d.value, e.style],
        role: m ? "button" : void 0,
        "aria-hidden": !m,
        tabindex: m ? e.disabled ? -1 : 0 : void 0
      }, {
        default: () => [f]
      });
    }), {};
  }
}), hr = le({
  height: [Number, String],
  maxHeight: [Number, String],
  maxWidth: [Number, String],
  minHeight: [Number, String],
  minWidth: [Number, String],
  width: [Number, String]
}, "dimension");
function gr(e) {
  return {
    dimensionStyles: B(() => {
      const n = {}, i = ze(e.height), r = ze(e.maxHeight), o = ze(e.maxWidth), a = ze(e.minHeight), l = ze(e.minWidth), u = ze(e.width);
      return i != null && (n.height = i), r != null && (n.maxHeight = r), o != null && (n.maxWidth = o), a != null && (n.minHeight = a), l != null && (n.minWidth = l), u != null && (n.width = u), n;
    })
  };
}
function TE(e) {
  return {
    aspectStyles: B(() => {
      const t = Number(e.aspectRatio);
      return t ? {
        paddingBottom: String(1 / t * 100) + "%"
      } : void 0;
    })
  };
}
const l1 = le({
  aspectRatio: [String, Number],
  contentClass: null,
  inline: Boolean,
  ...Xe(),
  ...hr()
}, "VResponsive"), iy = ye()({
  name: "VResponsive",
  props: l1(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      aspectStyles: i
    } = TE(e), {
      dimensionStyles: r
    } = gr(e);
    return Oe(() => {
      var o;
      return T("div", {
        class: ["v-responsive", {
          "v-responsive--inline": e.inline
        }, e.class],
        style: [r.value, e.style]
      }, [T("div", {
        class: "v-responsive__sizer",
        style: i.value
      }, null), (o = n.additional) == null ? void 0 : o.call(n), n.default && T("div", {
        class: ["v-responsive__content", e.contentClass]
      }, [n.default()])]);
    }), {};
  }
}), Gn = le({
  rounded: {
    type: [Boolean, Number, String],
    default: void 0
  },
  tile: Boolean
}, "rounded");
function Xn(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Wi();
  return {
    roundedClasses: B(() => {
      const i = cr(e) ? e.value : e.rounded, r = cr(e) ? e.value : e.tile, o = [];
      if (i === !0 || i === "")
        o.push(`${t}--rounded`);
      else if (typeof i == "string" || i === 0)
        for (const a of String(i).split(" "))
          o.push(`rounded-${a}`);
      else
        (r || i === !1) && o.push("rounded-0");
      return o;
    })
  };
}
const $a = le({
  transition: {
    type: [Boolean, String, Object],
    default: "fade-transition",
    validator: (e) => e !== !0
  }
}, "transition"), Si = (e, t) => {
  let {
    slots: n
  } = t;
  const {
    transition: i,
    disabled: r,
    group: o,
    ...a
  } = e, {
    component: l = o ? Qs : hn,
    ...u
  } = typeof i == "object" ? i : {};
  return Un(l, ge(typeof i == "string" ? {
    name: r ? "" : i
  } : u, typeof i == "string" ? {} : Object.fromEntries(Object.entries({
    disabled: r,
    group: o
  }).filter((d) => {
    let [f, m] = d;
    return m !== void 0;
  })), a), n);
};
function PE(e, t) {
  if (!jh)
    return;
  const n = t.modifiers || {}, i = t.value, {
    handler: r,
    options: o
  } = typeof i == "object" ? i : {
    handler: i,
    options: {}
  }, a = new IntersectionObserver(function() {
    var m;
    let l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], u = arguments.length > 1 ? arguments[1] : void 0;
    const d = (m = e._observe) == null ? void 0 : m[t.instance.$.uid];
    if (!d)
      return;
    const f = l.some((h) => h.isIntersecting);
    r && (!n.quiet || d.init) && (!n.once || f || d.init) && r(f, l, u), f && n.once ? u1(e, t) : d.init = !0;
  }, o);
  e._observe = Object(e._observe), e._observe[t.instance.$.uid] = {
    init: !1,
    observer: a
  }, a.observe(e);
}
function u1(e, t) {
  var i;
  const n = (i = e._observe) == null ? void 0 : i[t.instance.$.uid];
  n && (n.observer.unobserve(e), delete e._observe[t.instance.$.uid]);
}
const AE = {
  mounted: PE,
  unmounted: u1
}, c1 = AE, EE = le({
  alt: String,
  cover: Boolean,
  color: String,
  draggable: {
    type: [Boolean, String],
    default: void 0
  },
  eager: Boolean,
  gradient: String,
  lazySrc: String,
  options: {
    type: Object,
    // For more information on types, navigate to:
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    default: () => ({
      root: void 0,
      rootMargin: void 0,
      threshold: void 0
    })
  },
  sizes: String,
  src: {
    type: [String, Object],
    default: ""
  },
  crossorigin: String,
  referrerpolicy: String,
  srcset: String,
  position: String,
  ...l1(),
  ...Xe(),
  ...Gn(),
  ...$a()
}, "VImg"), d1 = ye()({
  name: "VImg",
  directives: {
    intersect: c1
  },
  props: EE(),
  emits: {
    loadstart: (e) => !0,
    load: (e) => !0,
    error: (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: i
    } = t;
    const {
      backgroundColorClasses: r,
      backgroundColorStyles: o
    } = Yn(Me(e, "color")), {
      roundedClasses: a
    } = Xn(e), l = Gt("VImg"), u = Pe(""), d = ie(), f = Pe(e.eager ? "loading" : "idle"), m = Pe(), h = Pe(), v = B(() => e.src && typeof e.src == "object" ? {
      src: e.src.src,
      srcset: e.srcset || e.src.srcset,
      lazySrc: e.lazySrc || e.src.lazySrc,
      aspect: Number(e.aspectRatio || e.src.aspect || 0)
    } : {
      src: e.src,
      srcset: e.srcset,
      lazySrc: e.lazySrc,
      aspect: Number(e.aspectRatio || 0)
    }), y = B(() => v.value.aspect || m.value / h.value || 0);
    pe(() => e.src, () => {
      p(f.value !== "idle");
    }), pe(y, (I, L) => {
      !I && L && d.value && D(d.value);
    }), Wh(() => p());
    function p(I) {
      if (!(e.eager && I) && !(jh && !I && !e.eager)) {
        if (f.value = "loading", v.value.lazySrc) {
          const L = new Image();
          L.src = v.value.lazySrc, D(L, null);
        }
        v.value.src && gt(() => {
          var L;
          n("loadstart", ((L = d.value) == null ? void 0 : L.currentSrc) || v.value.src), setTimeout(() => {
            var N;
            if (!l.isUnmounted)
              if ((N = d.value) != null && N.complete) {
                if (d.value.naturalWidth || x(), f.value === "error")
                  return;
                y.value || D(d.value, null), f.value === "loading" && b();
              } else
                y.value || D(d.value), _();
          });
        });
      }
    }
    function b() {
      var I;
      l.isUnmounted || (_(), D(d.value), f.value = "loaded", n("load", ((I = d.value) == null ? void 0 : I.currentSrc) || v.value.src));
    }
    function x() {
      var I;
      l.isUnmounted || (f.value = "error", n("error", ((I = d.value) == null ? void 0 : I.currentSrc) || v.value.src));
    }
    function _() {
      const I = d.value;
      I && (u.value = I.currentSrc || I.src);
    }
    let O = -1;
    _n(() => {
      clearTimeout(O);
    });
    function D(I) {
      let L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      const N = () => {
        if (clearTimeout(O), l.isUnmounted)
          return;
        const {
          naturalHeight: V,
          naturalWidth: z
        } = I;
        V || z ? (m.value = z, h.value = V) : !I.complete && f.value === "loading" && L != null ? O = window.setTimeout(N, L) : (I.currentSrc.endsWith(".svg") || I.currentSrc.startsWith("data:image/svg+xml")) && (m.value = 1, h.value = 1);
      };
      N();
    }
    const F = B(() => ({
      "v-img__img--cover": e.cover,
      "v-img__img--contain": !e.cover
    })), $ = () => {
      var N;
      if (!v.value.src || f.value === "idle")
        return null;
      const I = T("img", {
        class: ["v-img__img", F.value],
        style: {
          objectPosition: e.position
        },
        src: v.value.src,
        srcset: v.value.srcset,
        alt: e.alt,
        crossorigin: e.crossorigin,
        referrerpolicy: e.referrerpolicy,
        draggable: e.draggable,
        sizes: e.sizes,
        ref: d,
        onLoad: b,
        onError: x
      }, null), L = (N = i.sources) == null ? void 0 : N.call(i);
      return T(Si, {
        transition: e.transition,
        appear: !0
      }, {
        default: () => [Nt(L ? T("picture", {
          class: "v-img__picture"
        }, [L, I]) : I, [[Ri, f.value === "loaded"]])]
      });
    }, A = () => T(Si, {
      transition: e.transition
    }, {
      default: () => [v.value.lazySrc && f.value !== "loaded" && T("img", {
        class: ["v-img__img", "v-img__img--preload", F.value],
        style: {
          objectPosition: e.position
        },
        src: v.value.lazySrc,
        alt: e.alt,
        crossorigin: e.crossorigin,
        referrerpolicy: e.referrerpolicy,
        draggable: e.draggable
      }, null)]
    }), k = () => i.placeholder ? T(Si, {
      transition: e.transition,
      appear: !0
    }, {
      default: () => [(f.value === "loading" || f.value === "error" && !i.error) && T("div", {
        class: "v-img__placeholder"
      }, [i.placeholder()])]
    }) : null, S = () => i.error ? T(Si, {
      transition: e.transition,
      appear: !0
    }, {
      default: () => [f.value === "error" && T("div", {
        class: "v-img__error"
      }, [i.error()])]
    }) : null, M = () => e.gradient ? T("div", {
      class: "v-img__gradient",
      style: {
        backgroundImage: `linear-gradient(${e.gradient})`
      }
    }, null) : null, E = Pe(!1);
    {
      const I = pe(y, (L) => {
        L && (requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            E.value = !0;
          });
        }), I());
      });
    }
    return Oe(() => {
      const I = iy.filterProps(e);
      return Nt(T(iy, ge({
        class: ["v-img", {
          "v-img--booting": !E.value
        }, r.value, a.value, e.class],
        style: [{
          width: ze(e.width === "auto" ? m.value : e.width)
        }, o.value, e.style]
      }, I, {
        aspectRatio: y.value,
        "aria-label": e.alt,
        role: e.alt ? "img" : void 0
      }), {
        additional: () => T(qe, null, [T($, null, null), T(A, null, null), T(M, null, null), T(k, null, null), T(S, null, null)]),
        default: i.default
      }), [[Ci("intersect"), {
        handler: p,
        options: e.options
      }, null, {
        once: !0
      }]]);
    }), {
      currentSrc: u,
      image: d,
      state: f,
      naturalWidth: m,
      naturalHeight: h
    };
  }
}), IE = [null, "default", "comfortable", "compact"], Oi = le({
  density: {
    type: String,
    default: "default",
    validator: (e) => IE.includes(e)
  }
}, "density");
function zi(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Wi();
  return {
    densityClasses: B(() => `${t}--density-${e.density}`)
  };
}
const DE = ["elevated", "flat", "tonal", "outlined", "text", "plain"];
function Vo(e, t) {
  return T(qe, null, [e && T("span", {
    key: "overlay",
    class: `${t}__overlay`
  }, null), T("span", {
    key: "underlay",
    class: `${t}__underlay`
  }, null)]);
}
const mr = le({
  color: String,
  variant: {
    type: String,
    default: "elevated",
    validator: (e) => DE.includes(e)
  }
}, "variant");
function Ra(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Wi();
  const n = B(() => {
    const {
      variant: o
    } = Be(e);
    return `${t}--variant-${o}`;
  }), {
    colorClasses: i,
    colorStyles: r
  } = ng(B(() => {
    const {
      variant: o,
      color: a
    } = Be(e);
    return {
      [["elevated", "flat"].includes(o) ? "background" : "text"]: a
    };
  }));
  return {
    colorClasses: i,
    colorStyles: r,
    variantClasses: n
  };
}
const LE = le({
  start: Boolean,
  end: Boolean,
  icon: ot,
  image: String,
  text: String,
  ...Xe(),
  ...Oi(),
  ...Gn(),
  ...tl(),
  ...Bt(),
  ...Mt(),
  ...mr({
    variant: "flat"
  })
}, "VAvatar"), fr = ye()({
  name: "VAvatar",
  props: LE(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: i
    } = Wt(e), {
      colorClasses: r,
      colorStyles: o,
      variantClasses: a
    } = Ra(e), {
      densityClasses: l
    } = zi(e), {
      roundedClasses: u
    } = Xn(e), {
      sizeClasses: d,
      sizeStyles: f
    } = nl(e);
    return Oe(() => T(e.tag, {
      class: ["v-avatar", {
        "v-avatar--start": e.start,
        "v-avatar--end": e.end
      }, i.value, r.value, l.value, u.value, d.value, a.value, e.class],
      style: [o.value, f.value, e.style]
    }, {
      default: () => [n.default ? T(pt, {
        key: "content-defaults",
        defaults: {
          VImg: {
            cover: !0,
            image: e.image
          },
          VIcon: {
            icon: e.icon
          }
        }
      }, {
        default: () => [n.default()]
      }) : e.image ? T(d1, {
        key: "image",
        src: e.image,
        alt: "",
        cover: !0
      }, null) : e.icon ? T(At, {
        key: "icon",
        icon: e.icon
      }, null) : e.text, Vo(!1, "v-avatar")]
    })), {};
  }
}), BE = le({
  appendAvatar: String,
  appendIcon: ot,
  prependAvatar: String,
  prependIcon: ot,
  subtitle: [String, Number],
  title: [String, Number],
  ...Xe(),
  ...Oi()
}, "VCardItem"), VE = ye()({
  name: "VCardItem",
  props: BE(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return Oe(() => {
      var d;
      const i = !!(e.prependAvatar || e.prependIcon), r = !!(i || n.prepend), o = !!(e.appendAvatar || e.appendIcon), a = !!(o || n.append), l = !!(e.title != null || n.title), u = !!(e.subtitle != null || n.subtitle);
      return T("div", {
        class: ["v-card-item", e.class],
        style: e.style
      }, [r && T("div", {
        key: "prepend",
        class: "v-card-item__prepend"
      }, [n.prepend ? T(pt, {
        key: "prepend-defaults",
        disabled: !i,
        defaults: {
          VAvatar: {
            density: e.density,
            image: e.prependAvatar
          },
          VIcon: {
            density: e.density,
            icon: e.prependIcon
          }
        }
      }, n.prepend) : T(qe, null, [e.prependAvatar && T(fr, {
        key: "prepend-avatar",
        density: e.density,
        image: e.prependAvatar
      }, null), e.prependIcon && T(At, {
        key: "prepend-icon",
        density: e.density,
        icon: e.prependIcon
      }, null)])]), T("div", {
        class: "v-card-item__content"
      }, [l && T(SE, {
        key: "title"
      }, {
        default: () => {
          var f;
          return [((f = n.title) == null ? void 0 : f.call(n)) ?? e.title];
        }
      }), u && T(kE, {
        key: "subtitle"
      }, {
        default: () => {
          var f;
          return [((f = n.subtitle) == null ? void 0 : f.call(n)) ?? e.subtitle];
        }
      }), (d = n.default) == null ? void 0 : d.call(n)]), a && T("div", {
        key: "append",
        class: "v-card-item__append"
      }, [n.append ? T(pt, {
        key: "append-defaults",
        disabled: !o,
        defaults: {
          VAvatar: {
            density: e.density,
            image: e.appendAvatar
          },
          VIcon: {
            density: e.density,
            icon: e.appendIcon
          }
        }
      }, n.append) : T(qe, null, [e.appendIcon && T(At, {
        key: "append-icon",
        density: e.density,
        icon: e.appendIcon
      }, null), e.appendAvatar && T(fr, {
        key: "append-avatar",
        density: e.density,
        image: e.appendAvatar
      }, null)])])]);
    }), {};
  }
}), $E = le({
  opacity: [Number, String],
  ...Xe(),
  ...Bt()
}, "VCardText"), RE = ye()({
  name: "VCardText",
  props: $E(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return Oe(() => T(e.tag, {
      class: ["v-card-text", e.class],
      style: [{
        "--v-card-text-opacity": e.opacity
      }, e.style]
    }, n)), {};
  }
}), $o = le({
  border: [Boolean, Number, String]
}, "border");
function Ro(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Wi();
  return {
    borderClasses: B(() => {
      const i = cr(e) ? e.value : e.border, r = [];
      if (i === !0 || i === "")
        r.push(`${t}--border`);
      else if (typeof i == "string" || i === 0)
        for (const o of String(i).split(" "))
          r.push(`border-${o}`);
      return r;
    })
  };
}
const Kr = le({
  elevation: {
    type: [Number, String],
    validator(e) {
      const t = parseInt(e);
      return !isNaN(t) && t >= 0 && // Material Design has a maximum elevation of 24
      // https://material.io/design/environment/elevation.html#default-elevations
      t <= 24;
    }
  }
}, "elevation");
function Zr(e) {
  return {
    elevationClasses: B(() => {
      const n = cr(e) ? e.value : e.elevation, i = [];
      return n == null || i.push(`elevation-${n}`), i;
    })
  };
}
function f1(e, t) {
  const n = ie(), i = Pe(!1);
  if (jh) {
    const r = new IntersectionObserver((o) => {
      e == null || e(o, r), i.value = !!o.find((a) => a.isIntersecting);
    }, t);
    _n(() => {
      r.disconnect();
    }), pe(n, (o, a) => {
      a && (r.unobserve(a), i.value = !1), o && r.observe(o);
    }, {
      flush: "post"
    });
  }
  return {
    intersectionRef: n,
    isIntersecting: i
  };
}
const ry = {
  center: "center",
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, il = le({
  location: String
}, "location");
function Pc(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = arguments.length > 2 ? arguments[2] : void 0;
  const {
    isRtl: i
  } = Xr();
  return {
    locationStyles: B(() => {
      if (!e.location)
        return {};
      const {
        side: o,
        align: a
      } = oh(e.location.split(" ").length > 1 ? e.location : `${e.location} center`, i.value);
      function l(d) {
        return n ? n(d) : 0;
      }
      const u = {};
      return o !== "center" && (t ? u[ry[o]] = `calc(100% - ${l(o)}px)` : u[o] = 0), a !== "center" ? t ? u[ry[a]] = `calc(100% - ${l(a)}px)` : u[a] = 0 : (o === "center" ? u.top = u.left = "50%" : u[{
        top: "left",
        bottom: "left",
        left: "top",
        right: "top"
      }[o]] = "50%", u.transform = {
        top: "translateX(-50%)",
        bottom: "translateX(-50%)",
        left: "translateY(-50%)",
        right: "translateY(-50%)",
        center: "translate(-50%, -50%)"
      }[o]), u;
    })
  };
}
const FE = le({
  absolute: Boolean,
  active: {
    type: Boolean,
    default: !0
  },
  bgColor: String,
  bgOpacity: [Number, String],
  bufferValue: {
    type: [Number, String],
    default: 0
  },
  bufferColor: String,
  bufferOpacity: [Number, String],
  clickable: Boolean,
  color: String,
  height: {
    type: [Number, String],
    default: 4
  },
  indeterminate: Boolean,
  max: {
    type: [Number, String],
    default: 100
  },
  modelValue: {
    type: [Number, String],
    default: 0
  },
  opacity: [Number, String],
  reverse: Boolean,
  stream: Boolean,
  striped: Boolean,
  roundedBar: Boolean,
  ...Xe(),
  ...il({
    location: "top"
  }),
  ...Gn(),
  ...Bt(),
  ...Mt()
}, "VProgressLinear"), h1 = ye()({
  name: "VProgressLinear",
  props: FE(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = rt(e, "modelValue"), {
      isRtl: r,
      rtlClasses: o
    } = Xr(), {
      themeClasses: a
    } = Wt(e), {
      locationStyles: l
    } = Pc(e), {
      textColorClasses: u,
      textColorStyles: d
    } = Fi(e, "color"), {
      backgroundColorClasses: f,
      backgroundColorStyles: m
    } = Yn(B(() => e.bgColor || e.color)), {
      backgroundColorClasses: h,
      backgroundColorStyles: v
    } = Yn(B(() => e.bufferColor || e.bgColor || e.color)), {
      backgroundColorClasses: y,
      backgroundColorStyles: p
    } = Yn(e, "color"), {
      roundedClasses: b
    } = Xn(e), {
      intersectionRef: x,
      isIntersecting: _
    } = f1(), O = B(() => parseFloat(e.max)), D = B(() => parseFloat(e.height)), F = B(() => lr(parseFloat(e.bufferValue) / O.value * 100, 0, 100)), $ = B(() => lr(parseFloat(i.value) / O.value * 100, 0, 100)), A = B(() => r.value !== e.reverse), k = B(() => e.indeterminate ? "fade-transition" : "slide-x-transition");
    function S(M) {
      if (!x.value)
        return;
      const {
        left: E,
        right: I,
        width: L
      } = x.value.getBoundingClientRect(), N = A.value ? L - M.clientX + (I - L) : M.clientX - E;
      i.value = Math.round(N / L * O.value);
    }
    return Oe(() => T(e.tag, {
      ref: x,
      class: ["v-progress-linear", {
        "v-progress-linear--absolute": e.absolute,
        "v-progress-linear--active": e.active && _.value,
        "v-progress-linear--reverse": A.value,
        "v-progress-linear--rounded": e.rounded,
        "v-progress-linear--rounded-bar": e.roundedBar,
        "v-progress-linear--striped": e.striped
      }, b.value, a.value, o.value, e.class],
      style: [{
        bottom: e.location === "bottom" ? 0 : void 0,
        top: e.location === "top" ? 0 : void 0,
        height: e.active ? ze(D.value) : 0,
        "--v-progress-linear-height": ze(D.value),
        ...e.absolute ? l.value : {}
      }, e.style],
      role: "progressbar",
      "aria-hidden": e.active ? "false" : "true",
      "aria-valuemin": "0",
      "aria-valuemax": e.max,
      "aria-valuenow": e.indeterminate ? void 0 : $.value,
      onClick: e.clickable && S
    }, {
      default: () => [e.stream && T("div", {
        key: "stream",
        class: ["v-progress-linear__stream", u.value],
        style: {
          ...d.value,
          [A.value ? "left" : "right"]: ze(-D.value),
          borderTop: `${ze(D.value / 2)} dotted`,
          opacity: parseFloat(e.bufferOpacity),
          top: `calc(50% - ${ze(D.value / 4)})`,
          width: ze(100 - F.value, "%"),
          "--v-progress-linear-stream-to": ze(D.value * (A.value ? 1 : -1))
        }
      }, null), T("div", {
        class: ["v-progress-linear__background", f.value],
        style: [m.value, {
          opacity: parseFloat(e.bgOpacity),
          width: e.stream ? 0 : void 0
        }]
      }, null), T("div", {
        class: ["v-progress-linear__buffer", h.value],
        style: [v.value, {
          opacity: parseFloat(e.bufferOpacity),
          width: ze(F.value, "%")
        }]
      }, null), T(hn, {
        name: k.value
      }, {
        default: () => [e.indeterminate ? T("div", {
          class: "v-progress-linear__indeterminate"
        }, [["long", "short"].map((M) => T("div", {
          key: M,
          class: ["v-progress-linear__indeterminate", M, y.value],
          style: p.value
        }, null))]) : T("div", {
          class: ["v-progress-linear__determinate", y.value],
          style: [p.value, {
            width: ze($.value, "%")
          }]
        }, null)]
      }), n.default && T("div", {
        class: "v-progress-linear__content"
      }, [n.default({
        value: $.value,
        buffer: F.value
      })])]
    })), {};
  }
}), ig = le({
  loading: [Boolean, String]
}, "loader");
function rg(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Wi();
  return {
    loaderClasses: B(() => ({
      [`${t}--loading`]: e.loading
    }))
  };
}
function g1(e, t) {
  var i;
  let {
    slots: n
  } = t;
  return T("div", {
    class: `${e.name}__loader`
  }, [((i = n.default) == null ? void 0 : i.call(n, {
    color: e.color,
    isActive: e.active
  })) || T(h1, {
    absolute: e.absolute,
    active: e.active,
    color: e.color,
    height: "2",
    indeterminate: !0
  }, null)]);
}
const NE = ["static", "relative", "fixed", "absolute", "sticky"], Ac = le({
  position: {
    type: String,
    validator: (
      /* istanbul ignore next */
      (e) => NE.includes(e)
    )
  }
}, "position");
function Ec(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Wi();
  return {
    positionClasses: B(() => e.position ? `${t}--${e.position}` : void 0)
  };
}
function WE() {
  const e = Gt("useRoute");
  return B(() => {
    var t;
    return (t = e == null ? void 0 : e.proxy) == null ? void 0 : t.$route;
  });
}
function zE() {
  var e, t;
  return (t = (e = Gt("useRouter")) == null ? void 0 : e.proxy) == null ? void 0 : t.$router;
}
function Ic(e, t) {
  var d, f;
  const n = sr("RouterLink"), i = B(() => !!(e.href || e.to)), r = B(() => (i == null ? void 0 : i.value) || Pp(t, "click") || Pp(e, "click"));
  if (typeof n == "string" || !("useLink" in n))
    return {
      isLink: i,
      isClickable: r,
      href: Me(e, "href")
    };
  const o = B(() => ({
    ...e,
    to: Me(() => e.to || "")
  })), a = n.useLink(o.value), l = B(() => e.to ? a : void 0), u = WE();
  return {
    isLink: i,
    isClickable: r,
    route: (d = l.value) == null ? void 0 : d.route,
    navigate: (f = l.value) == null ? void 0 : f.navigate,
    isActive: B(() => {
      var m, h, v;
      return l.value ? e.exact ? u.value ? ((v = l.value.isExactActive) == null ? void 0 : v.value) && Ba(l.value.route.value.query, u.value.query) : ((h = l.value.isExactActive) == null ? void 0 : h.value) ?? !1 : ((m = l.value.isActive) == null ? void 0 : m.value) ?? !1 : !1;
    }),
    href: B(() => {
      var m;
      return e.to ? (m = l.value) == null ? void 0 : m.route.value.href : e.href;
    })
  };
}
const Dc = le({
  href: String,
  replace: Boolean,
  to: [String, Object],
  exact: Boolean
}, "router");
let Of = !1;
function HE(e, t) {
  let n = !1, i, r;
  ft && (gt(() => {
    window.addEventListener("popstate", o), i = e == null ? void 0 : e.beforeEach((a, l, u) => {
      Of ? n ? t(u) : u() : setTimeout(() => n ? t(u) : u()), Of = !0;
    }), r = e == null ? void 0 : e.afterEach(() => {
      Of = !1;
    });
  }), wn(() => {
    window.removeEventListener("popstate", o), i == null || i(), r == null || r();
  }));
  function o(a) {
    var l;
    (l = a.state) != null && l.replaced || (n = !0, setTimeout(() => n = !1));
  }
}
const dh = Symbol("rippleStop"), jE = 80;
function oy(e, t) {
  e.style.transform = t, e.style.webkitTransform = t;
}
function fh(e) {
  return e.constructor.name === "TouchEvent";
}
function m1(e) {
  return e.constructor.name === "KeyboardEvent";
}
const YE = function(e, t) {
  var m;
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = 0, r = 0;
  if (!m1(e)) {
    const h = t.getBoundingClientRect(), v = fh(e) ? e.touches[e.touches.length - 1] : e;
    i = v.clientX - h.left, r = v.clientY - h.top;
  }
  let o = 0, a = 0.3;
  (m = t._ripple) != null && m.circle ? (a = 0.15, o = t.clientWidth / 2, o = n.center ? o : o + Math.sqrt((i - o) ** 2 + (r - o) ** 2) / 4) : o = Math.sqrt(t.clientWidth ** 2 + t.clientHeight ** 2) / 2;
  const l = `${(t.clientWidth - o * 2) / 2}px`, u = `${(t.clientHeight - o * 2) / 2}px`, d = n.center ? l : `${i - o}px`, f = n.center ? u : `${r - o}px`;
  return {
    radius: o,
    scale: a,
    x: d,
    y: f,
    centerX: l,
    centerY: u
  };
}, ec = {
  /* eslint-disable max-statements */
  show(e, t) {
    var v;
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!((v = t == null ? void 0 : t._ripple) != null && v.enabled))
      return;
    const i = document.createElement("span"), r = document.createElement("span");
    i.appendChild(r), i.className = "v-ripple__container", n.class && (i.className += ` ${n.class}`);
    const {
      radius: o,
      scale: a,
      x: l,
      y: u,
      centerX: d,
      centerY: f
    } = YE(e, t, n), m = `${o * 2}px`;
    r.className = "v-ripple__animation", r.style.width = m, r.style.height = m, t.appendChild(i);
    const h = window.getComputedStyle(t);
    h && h.position === "static" && (t.style.position = "relative", t.dataset.previousPosition = "static"), r.classList.add("v-ripple__animation--enter"), r.classList.add("v-ripple__animation--visible"), oy(r, `translate(${l}, ${u}) scale3d(${a},${a},${a})`), r.dataset.activated = String(performance.now()), setTimeout(() => {
      r.classList.remove("v-ripple__animation--enter"), r.classList.add("v-ripple__animation--in"), oy(r, `translate(${d}, ${f}) scale3d(1,1,1)`);
    }, 0);
  },
  hide(e) {
    var o;
    if (!((o = e == null ? void 0 : e._ripple) != null && o.enabled))
      return;
    const t = e.getElementsByClassName("v-ripple__animation");
    if (t.length === 0)
      return;
    const n = t[t.length - 1];
    if (n.dataset.isHiding)
      return;
    n.dataset.isHiding = "true";
    const i = performance.now() - Number(n.dataset.activated), r = Math.max(250 - i, 0);
    setTimeout(() => {
      n.classList.remove("v-ripple__animation--in"), n.classList.add("v-ripple__animation--out"), setTimeout(() => {
        var l;
        e.getElementsByClassName("v-ripple__animation").length === 1 && e.dataset.previousPosition && (e.style.position = e.dataset.previousPosition, delete e.dataset.previousPosition), ((l = n.parentNode) == null ? void 0 : l.parentNode) === e && e.removeChild(n.parentNode);
      }, 300);
    }, r);
  }
};
function v1(e) {
  return typeof e > "u" || !!e;
}
function Vs(e) {
  const t = {}, n = e.currentTarget;
  if (!(!(n != null && n._ripple) || n._ripple.touched || e[dh])) {
    if (e[dh] = !0, fh(e))
      n._ripple.touched = !0, n._ripple.isTouch = !0;
    else if (n._ripple.isTouch)
      return;
    if (t.center = n._ripple.centered || m1(e), n._ripple.class && (t.class = n._ripple.class), fh(e)) {
      if (n._ripple.showTimerCommit)
        return;
      n._ripple.showTimerCommit = () => {
        ec.show(e, n, t);
      }, n._ripple.showTimer = window.setTimeout(() => {
        var i;
        (i = n == null ? void 0 : n._ripple) != null && i.showTimerCommit && (n._ripple.showTimerCommit(), n._ripple.showTimerCommit = null);
      }, jE);
    } else
      ec.show(e, n, t);
  }
}
function ay(e) {
  e[dh] = !0;
}
function jn(e) {
  const t = e.currentTarget;
  if (t != null && t._ripple) {
    if (window.clearTimeout(t._ripple.showTimer), e.type === "touchend" && t._ripple.showTimerCommit) {
      t._ripple.showTimerCommit(), t._ripple.showTimerCommit = null, t._ripple.showTimer = window.setTimeout(() => {
        jn(e);
      });
      return;
    }
    window.setTimeout(() => {
      t._ripple && (t._ripple.touched = !1);
    }), ec.hide(t);
  }
}
function p1(e) {
  const t = e.currentTarget;
  t != null && t._ripple && (t._ripple.showTimerCommit && (t._ripple.showTimerCommit = null), window.clearTimeout(t._ripple.showTimer));
}
let $s = !1;
function y1(e) {
  !$s && (e.keyCode === Cp.enter || e.keyCode === Cp.space) && ($s = !0, Vs(e));
}
function b1(e) {
  $s = !1, jn(e);
}
function w1(e) {
  $s && ($s = !1, jn(e));
}
function _1(e, t, n) {
  const {
    value: i,
    modifiers: r
  } = t, o = v1(i);
  if (o || ec.hide(e), e._ripple = e._ripple ?? {}, e._ripple.enabled = o, e._ripple.centered = r.center, e._ripple.circle = r.circle, rh(i) && i.class && (e._ripple.class = i.class), o && !n) {
    if (r.stop) {
      e.addEventListener("touchstart", ay, {
        passive: !0
      }), e.addEventListener("mousedown", ay);
      return;
    }
    e.addEventListener("touchstart", Vs, {
      passive: !0
    }), e.addEventListener("touchend", jn, {
      passive: !0
    }), e.addEventListener("touchmove", p1, {
      passive: !0
    }), e.addEventListener("touchcancel", jn), e.addEventListener("mousedown", Vs), e.addEventListener("mouseup", jn), e.addEventListener("mouseleave", jn), e.addEventListener("keydown", y1), e.addEventListener("keyup", b1), e.addEventListener("blur", w1), e.addEventListener("dragstart", jn, {
      passive: !0
    });
  } else
    !o && n && x1(e);
}
function x1(e) {
  e.removeEventListener("mousedown", Vs), e.removeEventListener("touchstart", Vs), e.removeEventListener("touchend", jn), e.removeEventListener("touchmove", p1), e.removeEventListener("touchcancel", jn), e.removeEventListener("mouseup", jn), e.removeEventListener("mouseleave", jn), e.removeEventListener("keydown", y1), e.removeEventListener("keyup", b1), e.removeEventListener("dragstart", jn), e.removeEventListener("blur", w1);
}
function UE(e, t) {
  _1(e, t, !1);
}
function qE(e) {
  delete e._ripple, x1(e);
}
function GE(e, t) {
  if (t.value === t.oldValue)
    return;
  const n = v1(t.oldValue);
  _1(e, t, n);
}
const Fo = {
  mounted: UE,
  unmounted: qE,
  updated: GE
}, XE = le({
  appendAvatar: String,
  appendIcon: ot,
  disabled: Boolean,
  flat: Boolean,
  hover: Boolean,
  image: String,
  link: {
    type: Boolean,
    default: void 0
  },
  prependAvatar: String,
  prependIcon: ot,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  subtitle: [String, Number],
  text: [String, Number],
  title: [String, Number],
  ...$o(),
  ...Xe(),
  ...Oi(),
  ...hr(),
  ...Kr(),
  ...ig(),
  ...il(),
  ...Ac(),
  ...Gn(),
  ...Dc(),
  ...Bt(),
  ...Mt(),
  ...mr({
    variant: "elevated"
  })
}, "VCard"), e7 = ye()({
  name: "VCard",
  directives: {
    Ripple: Fo
  },
  props: XE(),
  setup(e, t) {
    let {
      attrs: n,
      slots: i
    } = t;
    const {
      themeClasses: r
    } = Wt(e), {
      borderClasses: o
    } = Ro(e), {
      colorClasses: a,
      colorStyles: l,
      variantClasses: u
    } = Ra(e), {
      densityClasses: d
    } = zi(e), {
      dimensionStyles: f
    } = gr(e), {
      elevationClasses: m
    } = Zr(e), {
      loaderClasses: h
    } = rg(e), {
      locationStyles: v
    } = Pc(e), {
      positionClasses: y
    } = Ec(e), {
      roundedClasses: p
    } = Xn(e), b = Ic(e, n), x = B(() => e.link !== !1 && b.isLink.value), _ = B(() => !e.disabled && e.link !== !1 && (e.link || b.isClickable.value));
    return Oe(() => {
      const O = x.value ? "a" : e.tag, D = !!(i.title || e.title != null), F = !!(i.subtitle || e.subtitle != null), $ = D || F, A = !!(i.append || e.appendAvatar || e.appendIcon), k = !!(i.prepend || e.prependAvatar || e.prependIcon), S = !!(i.image || e.image), M = $ || k || A, E = !!(i.text || e.text != null);
      return Nt(T(O, {
        class: ["v-card", {
          "v-card--disabled": e.disabled,
          "v-card--flat": e.flat,
          "v-card--hover": e.hover && !(e.disabled || e.flat),
          "v-card--link": _.value
        }, r.value, o.value, a.value, d.value, m.value, h.value, y.value, p.value, u.value, e.class],
        style: [l.value, f.value, v.value, e.style],
        href: b.href.value,
        onClick: _.value && b.navigate,
        tabindex: e.disabled ? -1 : void 0
      }, {
        default: () => {
          var I;
          return [S && T("div", {
            key: "image",
            class: "v-card__image"
          }, [i.image ? T(pt, {
            key: "image-defaults",
            disabled: !e.image,
            defaults: {
              VImg: {
                cover: !0,
                src: e.image
              }
            }
          }, i.image) : T(d1, {
            key: "image-img",
            cover: !0,
            src: e.image
          }, null)]), T(g1, {
            name: "v-card",
            active: !!e.loading,
            color: typeof e.loading == "boolean" ? void 0 : e.loading
          }, {
            default: i.loader
          }), M && T(VE, {
            key: "item",
            prependAvatar: e.prependAvatar,
            prependIcon: e.prependIcon,
            title: e.title,
            subtitle: e.subtitle,
            appendAvatar: e.appendAvatar,
            appendIcon: e.appendIcon
          }, {
            default: i.item,
            prepend: i.prepend,
            title: i.title,
            subtitle: i.subtitle,
            append: i.append
          }), E && T(RE, {
            key: "text"
          }, {
            default: () => {
              var L;
              return [((L = i.text) == null ? void 0 : L.call(i)) ?? e.text];
            }
          }), (I = i.default) == null ? void 0 : I.call(i), i.actions && T(_E, null, {
            default: i.actions
          }), Vo(_.value, "v-card")];
        }
      }), [[Ci("ripple"), _.value && e.ripple]]);
    }), {};
  }
}), KE = le({
  text: String,
  onClick: gi(),
  ...Xe(),
  ...Mt()
}, "VLabel"), og = ye()({
  name: "VLabel",
  props: KE(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return Oe(() => {
      var i;
      return T("label", {
        class: ["v-label", {
          "v-label--clickable": !!e.onClick
        }, e.class],
        style: e.style,
        onClick: e.onClick
      }, [e.text, (i = n.default) == null ? void 0 : i.call(n)]);
    }), {};
  }
}), k1 = Symbol.for("vuetify:selection-control-group"), ag = le({
  color: String,
  disabled: {
    type: Boolean,
    default: null
  },
  defaultsTarget: String,
  error: Boolean,
  id: String,
  inline: Boolean,
  falseIcon: ot,
  trueIcon: ot,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  multiple: {
    type: Boolean,
    default: null
  },
  name: String,
  readonly: {
    type: Boolean,
    default: null
  },
  modelValue: null,
  type: String,
  valueComparator: {
    type: Function,
    default: Ba
  },
  ...Xe(),
  ...Oi(),
  ...Mt()
}, "SelectionControlGroup"), ZE = le({
  ...ag({
    defaultsTarget: "VSelectionControl"
  })
}, "VSelectionControlGroup"), QE = ye()({
  name: "VSelectionControlGroup",
  props: ZE(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = rt(e, "modelValue"), r = qn(), o = B(() => e.id || `v-selection-control-group-${r}`), a = B(() => e.name || o.value), l = /* @__PURE__ */ new Set();
    return sn(k1, {
      modelValue: i,
      forceUpdate: () => {
        l.forEach((u) => u());
      },
      onForceUpdate: (u) => {
        l.add(u), wn(() => {
          l.delete(u);
        });
      }
    }), Gr({
      [e.defaultsTarget]: {
        color: Me(e, "color"),
        disabled: Me(e, "disabled"),
        density: Me(e, "density"),
        error: Me(e, "error"),
        inline: Me(e, "inline"),
        modelValue: i,
        multiple: B(() => !!e.multiple || e.multiple == null && Array.isArray(i.value)),
        name: a,
        falseIcon: Me(e, "falseIcon"),
        trueIcon: Me(e, "trueIcon"),
        readonly: Me(e, "readonly"),
        ripple: Me(e, "ripple"),
        type: Me(e, "type"),
        valueComparator: Me(e, "valueComparator")
      }
    }), Oe(() => {
      var u;
      return T("div", {
        class: ["v-selection-control-group", {
          "v-selection-control-group--inline": e.inline
        }, e.class],
        style: e.style,
        role: e.type === "radio" ? "radiogroup" : void 0
      }, [(u = n.default) == null ? void 0 : u.call(n)]);
    }), {};
  }
}), sg = le({
  label: String,
  baseColor: String,
  trueValue: null,
  falseValue: null,
  value: null,
  ...Xe(),
  ...ag()
}, "VSelectionControl");
function JE(e) {
  const t = ht(k1, void 0), {
    densityClasses: n
  } = zi(e), i = rt(e, "modelValue"), r = B(() => e.trueValue !== void 0 ? e.trueValue : e.value !== void 0 ? e.value : !0), o = B(() => e.falseValue !== void 0 ? e.falseValue : !1), a = B(() => !!e.multiple || e.multiple == null && Array.isArray(i.value)), l = B({
    get() {
      const v = t ? t.modelValue.value : i.value;
      return a.value ? en(v).some((y) => e.valueComparator(y, r.value)) : e.valueComparator(v, r.value);
    },
    set(v) {
      if (e.readonly)
        return;
      const y = v ? r.value : o.value;
      let p = y;
      a.value && (p = v ? [...en(i.value), y] : en(i.value).filter((b) => !e.valueComparator(b, r.value))), t ? t.modelValue.value = p : i.value = p;
    }
  }), {
    textColorClasses: u,
    textColorStyles: d
  } = Fi(B(() => {
    if (!(e.error || e.disabled))
      return l.value ? e.color : e.baseColor;
  })), {
    backgroundColorClasses: f,
    backgroundColorStyles: m
  } = Yn(B(() => l.value && !e.error && !e.disabled ? e.color : e.baseColor)), h = B(() => l.value ? e.trueIcon : e.falseIcon);
  return {
    group: t,
    densityClasses: n,
    trueValue: r,
    falseValue: o,
    model: l,
    textColorClasses: u,
    textColorStyles: d,
    backgroundColorClasses: f,
    backgroundColorStyles: m,
    icon: h
  };
}
const tc = ye()({
  name: "VSelectionControl",
  directives: {
    Ripple: Fo
  },
  inheritAttrs: !1,
  props: sg(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: i
    } = t;
    const {
      group: r,
      densityClasses: o,
      icon: a,
      model: l,
      textColorClasses: u,
      textColorStyles: d,
      backgroundColorClasses: f,
      backgroundColorStyles: m,
      trueValue: h
    } = JE(e), v = qn(), y = Pe(!1), p = Pe(!1), b = ie(), x = B(() => e.id || `input-${v}`), _ = B(() => !e.disabled && !e.readonly);
    r == null || r.onForceUpdate(() => {
      b.value && (b.value.checked = l.value);
    });
    function O(A) {
      _.value && (y.value = !0, qu(A.target, ":focus-visible") !== !1 && (p.value = !0));
    }
    function D() {
      y.value = !1, p.value = !1;
    }
    function F(A) {
      A.stopPropagation();
    }
    function $(A) {
      _.value && (e.readonly && r && gt(() => r.forceUpdate()), l.value = A.target.checked);
    }
    return Oe(() => {
      var E, I;
      const A = i.label ? i.label({
        label: e.label,
        props: {
          for: x.value
        }
      }) : e.label, [k, S] = Mc(n), M = T("input", ge({
        ref: b,
        checked: l.value,
        disabled: !!e.disabled,
        id: x.value,
        onBlur: D,
        onFocus: O,
        onInput: $,
        "aria-disabled": !!e.disabled,
        "aria-label": e.label,
        type: e.type,
        value: h.value,
        name: e.name,
        "aria-checked": e.type === "checkbox" ? l.value : void 0
      }, S), null);
      return T("div", ge({
        class: ["v-selection-control", {
          "v-selection-control--dirty": l.value,
          "v-selection-control--disabled": e.disabled,
          "v-selection-control--error": e.error,
          "v-selection-control--focused": y.value,
          "v-selection-control--focus-visible": p.value,
          "v-selection-control--inline": e.inline
        }, o.value, e.class]
      }, k, {
        style: e.style
      }), [T("div", {
        class: ["v-selection-control__wrapper", u.value],
        style: d.value
      }, [(E = i.default) == null ? void 0 : E.call(i, {
        backgroundColorClasses: f,
        backgroundColorStyles: m
      }), Nt(T("div", {
        class: ["v-selection-control__input"]
      }, [((I = i.input) == null ? void 0 : I.call(i, {
        model: l,
        textColorClasses: u,
        textColorStyles: d,
        backgroundColorClasses: f,
        backgroundColorStyles: m,
        inputNode: M,
        icon: a.value,
        props: {
          onFocus: O,
          onBlur: D,
          id: x.value
        }
      })) ?? T(qe, null, [a.value && T(At, {
        key: "icon",
        icon: a.value
      }, null), M])]), [[Ci("ripple"), e.ripple && [!e.disabled && !e.readonly, null, ["center", "circle"]]]])]), A && T(og, {
        for: x.value,
        onClick: F
      }, {
        default: () => [A]
      })]);
    }), {
      isFocused: y,
      input: b
    };
  }
}), S1 = le({
  indeterminate: Boolean,
  indeterminateIcon: {
    type: ot,
    default: "$checkboxIndeterminate"
  },
  ...sg({
    falseIcon: "$checkboxOff",
    trueIcon: "$checkboxOn"
  })
}, "VCheckboxBtn"), nc = ye()({
  name: "VCheckboxBtn",
  props: S1(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:indeterminate": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = rt(e, "indeterminate"), r = rt(e, "modelValue");
    function o(u) {
      i.value && (i.value = !1);
    }
    const a = B(() => i.value ? e.indeterminateIcon : e.falseIcon), l = B(() => i.value ? e.indeterminateIcon : e.trueIcon);
    return Oe(() => {
      const u = gn(tc.filterProps(e), ["modelValue"]);
      return T(tc, ge(u, {
        modelValue: r.value,
        "onUpdate:modelValue": [(d) => r.value = d, o],
        class: ["v-checkbox-btn", e.class],
        style: e.style,
        type: "checkbox",
        falseIcon: a.value,
        trueIcon: l.value,
        "aria-checked": i.value ? "mixed" : void 0
      }), n);
    }), {};
  }
});
function C1(e) {
  const {
    t
  } = tn();
  function n(i) {
    let {
      name: r
    } = i;
    const o = {
      prepend: "prependAction",
      prependInner: "prependAction",
      append: "appendAction",
      appendInner: "appendAction",
      clear: "clear"
    }[r], a = e[`onClick:${r}`], l = a && o ? t(`$vuetify.input.${o}`, e.label ?? "") : void 0;
    return T(At, {
      icon: e[`${r}Icon`],
      "aria-label": l,
      onClick: a
    }, null);
  }
  return {
    InputIcon: n
  };
}
const eI = le({
  disabled: Boolean,
  group: Boolean,
  hideOnLeave: Boolean,
  leaveAbsolute: Boolean,
  mode: String,
  origin: String
}, "transition");
function Kn(e, t, n) {
  return ye()({
    name: e,
    props: eI({
      mode: n,
      origin: t
    }),
    setup(i, r) {
      let {
        slots: o
      } = r;
      const a = {
        onBeforeEnter(l) {
          i.origin && (l.style.transformOrigin = i.origin);
        },
        onLeave(l) {
          if (i.leaveAbsolute) {
            const {
              offsetTop: u,
              offsetLeft: d,
              offsetWidth: f,
              offsetHeight: m
            } = l;
            l._transitionInitialStyles = {
              position: l.style.position,
              top: l.style.top,
              left: l.style.left,
              width: l.style.width,
              height: l.style.height
            }, l.style.position = "absolute", l.style.top = `${u}px`, l.style.left = `${d}px`, l.style.width = `${f}px`, l.style.height = `${m}px`;
          }
          i.hideOnLeave && l.style.setProperty("display", "none", "important");
        },
        onAfterLeave(l) {
          if (i.leaveAbsolute && (l != null && l._transitionInitialStyles)) {
            const {
              position: u,
              top: d,
              left: f,
              width: m,
              height: h
            } = l._transitionInitialStyles;
            delete l._transitionInitialStyles, l.style.position = u || "", l.style.top = d || "", l.style.left = f || "", l.style.width = m || "", l.style.height = h || "";
          }
        }
      };
      return () => {
        const l = i.group ? Qs : hn;
        return Un(l, {
          name: i.disabled ? "" : e,
          css: !i.disabled,
          ...i.group ? void 0 : {
            mode: i.mode
          },
          ...i.disabled ? {} : a
        }, o.default);
      };
    }
  });
}
function O1(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "in-out";
  return ye()({
    name: e,
    props: {
      mode: {
        type: String,
        default: n
      },
      disabled: Boolean,
      group: Boolean
    },
    setup(i, r) {
      let {
        slots: o
      } = r;
      const a = i.group ? Qs : hn;
      return () => Un(a, {
        name: i.disabled ? "" : e,
        css: !i.disabled,
        // mode: props.mode, // TODO: vuejs/vue-next#3104
        ...i.disabled ? {} : t
      }, o.default);
    }
  });
}
function M1() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  const n = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1) ? "width" : "height", i = Ob(`offset-${n}`);
  return {
    onBeforeEnter(a) {
      a._parent = a.parentNode, a._initialStyle = {
        transition: a.style.transition,
        overflow: a.style.overflow,
        [n]: a.style[n]
      };
    },
    onEnter(a) {
      const l = a._initialStyle;
      a.style.setProperty("transition", "none", "important"), a.style.overflow = "hidden";
      const u = `${a[i]}px`;
      a.style[n] = "0", a.offsetHeight, a.style.transition = l.transition, e && a._parent && a._parent.classList.add(e), requestAnimationFrame(() => {
        a.style[n] = u;
      });
    },
    onAfterEnter: o,
    onEnterCancelled: o,
    onLeave(a) {
      a._initialStyle = {
        transition: "",
        overflow: a.style.overflow,
        [n]: a.style[n]
      }, a.style.overflow = "hidden", a.style[n] = `${a[i]}px`, a.offsetHeight, requestAnimationFrame(() => a.style[n] = "0");
    },
    onAfterLeave: r,
    onLeaveCancelled: r
  };
  function r(a) {
    e && a._parent && a._parent.classList.remove(e), o(a);
  }
  function o(a) {
    const l = a._initialStyle[n];
    a.style.overflow = a._initialStyle.overflow, l != null && (a.style[n] = l), delete a._initialStyle;
  }
}
const tI = le({
  target: [Object, Array]
}, "v-dialog-transition"), lg = ye()({
  name: "VDialogTransition",
  props: tI(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = {
      onBeforeEnter(r) {
        r.style.pointerEvents = "none", r.style.visibility = "hidden";
      },
      async onEnter(r, o) {
        var h;
        await new Promise((v) => requestAnimationFrame(v)), await new Promise((v) => requestAnimationFrame(v)), r.style.visibility = "";
        const {
          x: a,
          y: l,
          sx: u,
          sy: d,
          speed: f
        } = ly(e.target, r), m = pa(r, [{
          transform: `translate(${a}px, ${l}px) scale(${u}, ${d})`,
          opacity: 0
        }, {}], {
          duration: 225 * f,
          easing: cA
        });
        (h = sy(r)) == null || h.forEach((v) => {
          pa(v, [{
            opacity: 0
          }, {
            opacity: 0,
            offset: 0.33
          }, {}], {
            duration: 225 * 2 * f,
            easing: Ku
          });
        }), m.finished.then(() => o());
      },
      onAfterEnter(r) {
        r.style.removeProperty("pointer-events");
      },
      onBeforeLeave(r) {
        r.style.pointerEvents = "none";
      },
      async onLeave(r, o) {
        var h;
        await new Promise((v) => requestAnimationFrame(v));
        const {
          x: a,
          y: l,
          sx: u,
          sy: d,
          speed: f
        } = ly(e.target, r);
        pa(r, [{}, {
          transform: `translate(${a}px, ${l}px) scale(${u}, ${d})`,
          opacity: 0
        }], {
          duration: 125 * f,
          easing: dA
        }).finished.then(() => o()), (h = sy(r)) == null || h.forEach((v) => {
          pa(v, [{}, {
            opacity: 0,
            offset: 0.2
          }, {
            opacity: 0
          }], {
            duration: 125 * 2 * f,
            easing: Ku
          });
        });
      },
      onAfterLeave(r) {
        r.style.removeProperty("pointer-events");
      }
    };
    return () => e.target ? T(hn, ge({
      name: "dialog-transition"
    }, i, {
      css: !1
    }), n) : T(hn, {
      name: "dialog-transition"
    }, n);
  }
});
function sy(e) {
  var n;
  const t = (n = e.querySelector(":scope > .v-card, :scope > .v-sheet, :scope > .v-list")) == null ? void 0 : n.children;
  return t && [...t];
}
function ly(e, t) {
  const n = Rb(e), i = Xh(t), [r, o] = getComputedStyle(t).transformOrigin.split(" ").map((x) => parseFloat(x)), [a, l] = getComputedStyle(t).getPropertyValue("--v-overlay-anchor-origin").split(" ");
  let u = n.left + n.width / 2;
  a === "left" || l === "left" ? u -= n.width / 2 : (a === "right" || l === "right") && (u += n.width / 2);
  let d = n.top + n.height / 2;
  a === "top" || l === "top" ? d -= n.height / 2 : (a === "bottom" || l === "bottom") && (d += n.height / 2);
  const f = n.width / i.width, m = n.height / i.height, h = Math.max(1, f, m), v = f / h || 0, y = m / h || 0, p = i.width * i.height / (window.innerWidth * window.innerHeight), b = p > 0.12 ? Math.min(1.5, (p - 0.12) * 10 + 1) : 1;
  return {
    x: u - (r + i.left),
    y: d - (o + i.top),
    sx: v,
    sy: y,
    speed: b
  };
}
Kn("fab-transition", "center center", "out-in");
Kn("dialog-bottom-transition");
Kn("dialog-top-transition");
const hh = Kn("fade-transition");
Kn("scale-transition");
Kn("scroll-x-transition");
Kn("scroll-x-reverse-transition");
Kn("scroll-y-transition");
Kn("scroll-y-reverse-transition");
Kn("slide-x-transition");
Kn("slide-x-reverse-transition");
const T1 = Kn("slide-y-transition");
Kn("slide-y-reverse-transition");
const P1 = O1("expand-transition", M1()), A1 = O1("expand-x-transition", M1("", !0)), nI = le({
  active: Boolean,
  color: String,
  messages: {
    type: [Array, String],
    default: () => []
  },
  ...Xe(),
  ...$a({
    transition: {
      component: T1,
      leaveAbsolute: !0,
      group: !0
    }
  })
}, "VMessages"), iI = ye()({
  name: "VMessages",
  props: nI(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = B(() => en(e.messages)), {
      textColorClasses: r,
      textColorStyles: o
    } = Fi(B(() => e.color));
    return Oe(() => T(Si, {
      transition: e.transition,
      tag: "div",
      class: ["v-messages", r.value, e.class],
      style: [o.value, e.style],
      role: "alert",
      "aria-live": "polite"
    }, {
      default: () => [e.active && i.value.map((a, l) => T("div", {
        class: "v-messages__message",
        key: `${l}-${i.value}`
      }, [n.message ? n.message({
        message: a
      }) : a]))]
    })), {};
  }
}), E1 = le({
  focused: Boolean,
  "onUpdate:focused": gi()
}, "focus");
function ug(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Wi();
  const n = rt(e, "focused"), i = B(() => ({
    [`${t}--focused`]: n.value
  }));
  function r() {
    n.value = !0;
  }
  function o() {
    n.value = !1;
  }
  return {
    focusClasses: i,
    isFocused: n,
    focus: r,
    blur: o
  };
}
const I1 = Symbol.for("vuetify:form"), rI = le({
  disabled: Boolean,
  fastFail: Boolean,
  readonly: Boolean,
  modelValue: {
    type: Boolean,
    default: null
  },
  validateOn: {
    type: String,
    default: "input"
  }
}, "form");
function oI(e) {
  const t = rt(e, "modelValue"), n = B(() => e.disabled), i = B(() => e.readonly), r = Pe(!1), o = ie([]), a = ie([]);
  async function l() {
    const f = [];
    let m = !0;
    a.value = [], r.value = !0;
    for (const h of o.value) {
      const v = await h.validate();
      if (v.length > 0 && (m = !1, f.push({
        id: h.id,
        errorMessages: v
      })), !m && e.fastFail)
        break;
    }
    return a.value = f, r.value = !1, {
      valid: m,
      errors: a.value
    };
  }
  function u() {
    o.value.forEach((f) => f.reset());
  }
  function d() {
    o.value.forEach((f) => f.resetValidation());
  }
  return pe(o, () => {
    let f = 0, m = 0;
    const h = [];
    for (const v of o.value)
      v.isValid === !1 ? (m++, h.push({
        id: v.id,
        errorMessages: v.errorMessages
      })) : v.isValid === !0 && f++;
    a.value = h, t.value = m > 0 ? !1 : f === o.value.length ? !0 : null;
  }, {
    deep: !0,
    flush: "post"
  }), sn(I1, {
    register: (f) => {
      let {
        id: m,
        vm: h,
        validate: v,
        reset: y,
        resetValidation: p
      } = f;
      o.value.some((b) => b.id === m) && ur(`Duplicate input name "${m}"`), o.value.push({
        id: m,
        validate: v,
        reset: y,
        resetValidation: p,
        vm: pP(h),
        isValid: null,
        errorMessages: []
      });
    },
    unregister: (f) => {
      o.value = o.value.filter((m) => m.id !== f);
    },
    update: (f, m, h) => {
      const v = o.value.find((y) => y.id === f);
      v && (v.isValid = m, v.errorMessages = h);
    },
    isDisabled: n,
    isReadonly: i,
    isValidating: r,
    isValid: t,
    items: o,
    validateOn: Me(e, "validateOn")
  }), {
    errors: a,
    isDisabled: n,
    isReadonly: i,
    isValidating: r,
    isValid: t,
    items: o,
    validate: l,
    reset: u,
    resetValidation: d
  };
}
function cg() {
  return ht(I1, null);
}
const aI = le({
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  errorMessages: {
    type: [Array, String],
    default: () => []
  },
  maxErrors: {
    type: [Number, String],
    default: 1
  },
  name: String,
  label: String,
  readonly: {
    type: Boolean,
    default: null
  },
  rules: {
    type: Array,
    default: () => []
  },
  modelValue: null,
  validateOn: String,
  validationValue: null,
  ...E1()
}, "validation");
function sI(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Wi(), n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : qn();
  const i = rt(e, "modelValue"), r = B(() => e.validationValue === void 0 ? i.value : e.validationValue), o = cg(), a = ie([]), l = Pe(!0), u = B(() => !!(en(i.value === "" ? null : i.value).length || en(r.value === "" ? null : r.value).length)), d = B(() => !!(e.disabled ?? (o == null ? void 0 : o.isDisabled.value))), f = B(() => !!(e.readonly ?? (o == null ? void 0 : o.isReadonly.value))), m = B(() => {
    var F;
    return (F = e.errorMessages) != null && F.length ? en(e.errorMessages).concat(a.value).slice(0, Math.max(0, +e.maxErrors)) : a.value;
  }), h = B(() => {
    let F = (e.validateOn ?? (o == null ? void 0 : o.validateOn.value)) || "input";
    F === "lazy" && (F = "input lazy");
    const $ = new Set((F == null ? void 0 : F.split(" ")) ?? []);
    return {
      blur: $.has("blur") || $.has("input"),
      input: $.has("input"),
      submit: $.has("submit"),
      lazy: $.has("lazy")
    };
  }), v = B(() => {
    var F;
    return e.error || (F = e.errorMessages) != null && F.length ? !1 : e.rules.length ? l.value ? a.value.length || h.value.lazy ? null : !0 : !a.value.length : !0;
  }), y = Pe(!1), p = B(() => ({
    [`${t}--error`]: v.value === !1,
    [`${t}--dirty`]: u.value,
    [`${t}--disabled`]: d.value,
    [`${t}--readonly`]: f.value
  })), b = Gt("validation"), x = B(() => e.name ?? Be(n));
  Wh(() => {
    o == null || o.register({
      id: x.value,
      vm: b,
      validate: D,
      reset: _,
      resetValidation: O
    });
  }), _n(() => {
    o == null || o.unregister(x.value);
  }), mn(async () => {
    h.value.lazy || await D(!0), o == null || o.update(x.value, v.value, m.value);
  }), jr(() => h.value.input, () => {
    pe(r, () => {
      if (r.value != null)
        D();
      else if (e.focused) {
        const F = pe(() => e.focused, ($) => {
          $ || D(), F();
        });
      }
    });
  }), jr(() => h.value.blur, () => {
    pe(() => e.focused, (F) => {
      F || D();
    });
  }), pe([v, m], () => {
    o == null || o.update(x.value, v.value, m.value);
  });
  async function _() {
    i.value = null, await gt(), await O();
  }
  async function O() {
    l.value = !0, h.value.lazy ? a.value = [] : await D(!0);
  }
  async function D() {
    let F = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    const $ = [];
    y.value = !0;
    for (const A of e.rules) {
      if ($.length >= +(e.maxErrors ?? 1))
        break;
      const S = await (typeof A == "function" ? A : () => A)(r.value);
      if (S !== !0) {
        if (S !== !1 && typeof S != "string") {
          console.warn(`${S} is not a valid value. Rule functions must return boolean true or a string.`);
          continue;
        }
        $.push(S || "");
      }
    }
    return a.value = $, y.value = !1, l.value = F, a.value;
  }
  return {
    errorMessages: m,
    isDirty: u,
    isDisabled: d,
    isReadonly: f,
    isPristine: l,
    isValid: v,
    isValidating: y,
    reset: _,
    resetValidation: O,
    validate: D,
    validationClasses: p
  };
}
const Lc = le({
  id: String,
  appendIcon: ot,
  centerAffix: {
    type: Boolean,
    default: !0
  },
  prependIcon: ot,
  hideDetails: [Boolean, String],
  hideSpinButtons: Boolean,
  hint: String,
  persistentHint: Boolean,
  messages: {
    type: [Array, String],
    default: () => []
  },
  direction: {
    type: String,
    default: "horizontal",
    validator: (e) => ["horizontal", "vertical"].includes(e)
  },
  "onClick:prepend": gi(),
  "onClick:append": gi(),
  ...Xe(),
  ...Oi(),
  ...Ib(hr(), ["maxWidth", "minWidth", "width"]),
  ...Mt(),
  ...aI()
}, "VInput"), Sa = ye()({
  name: "VInput",
  props: {
    ...Lc()
  },
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: i,
      emit: r
    } = t;
    const {
      densityClasses: o
    } = zi(e), {
      dimensionStyles: a
    } = gr(e), {
      themeClasses: l
    } = Wt(e), {
      rtlClasses: u
    } = Xr(), {
      InputIcon: d
    } = C1(e), f = qn(), m = B(() => e.id || `input-${f}`), h = B(() => `${m.value}-messages`), {
      errorMessages: v,
      isDirty: y,
      isDisabled: p,
      isReadonly: b,
      isPristine: x,
      isValid: _,
      isValidating: O,
      reset: D,
      resetValidation: F,
      validate: $,
      validationClasses: A
    } = sI(e, "v-input", m), k = B(() => ({
      id: m,
      messagesId: h,
      isDirty: y,
      isDisabled: p,
      isReadonly: b,
      isPristine: x,
      isValid: _,
      isValidating: O,
      reset: D,
      resetValidation: F,
      validate: $
    })), S = B(() => {
      var M;
      return (M = e.errorMessages) != null && M.length || !x.value && v.value.length ? v.value : e.hint && (e.persistentHint || e.focused) ? e.hint : e.messages;
    });
    return Oe(() => {
      var N, V, z, H;
      const M = !!(i.prepend || e.prependIcon), E = !!(i.append || e.appendIcon), I = S.value.length > 0, L = !e.hideDetails || e.hideDetails === "auto" && (I || !!i.details);
      return T("div", {
        class: ["v-input", `v-input--${e.direction}`, {
          "v-input--center-affix": e.centerAffix,
          "v-input--hide-spin-buttons": e.hideSpinButtons
        }, o.value, l.value, u.value, A.value, e.class],
        style: [a.value, e.style]
      }, [M && T("div", {
        key: "prepend",
        class: "v-input__prepend"
      }, [(N = i.prepend) == null ? void 0 : N.call(i, k.value), e.prependIcon && T(d, {
        key: "prepend-icon",
        name: "prepend"
      }, null)]), i.default && T("div", {
        class: "v-input__control"
      }, [(V = i.default) == null ? void 0 : V.call(i, k.value)]), E && T("div", {
        key: "append",
        class: "v-input__append"
      }, [e.appendIcon && T(d, {
        key: "append-icon",
        name: "append"
      }, null), (z = i.append) == null ? void 0 : z.call(i, k.value)]), L && T("div", {
        class: "v-input__details"
      }, [T(iI, {
        id: h.value,
        active: I,
        messages: S.value
      }, {
        message: i.message
      }), (H = i.details) == null ? void 0 : H.call(i, k.value)])]);
    }), {
      reset: D,
      resetValidation: F,
      validate: $,
      isValid: _,
      errorMessages: v
    };
  }
}), lI = le({
  ...Lc(),
  ...gn(S1(), ["inline"])
}, "VCheckbox"), t7 = ye()({
  name: "VCheckbox",
  inheritAttrs: !1,
  props: lI(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:focused": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: i
    } = t;
    const r = rt(e, "modelValue"), {
      isFocused: o,
      focus: a,
      blur: l
    } = ug(e), u = qn(), d = B(() => e.id || `checkbox-${u}`);
    return Oe(() => {
      const [f, m] = Mc(n), h = Sa.filterProps(e), v = nc.filterProps(e);
      return T(Sa, ge({
        class: ["v-checkbox", e.class]
      }, f, h, {
        modelValue: r.value,
        "onUpdate:modelValue": (y) => r.value = y,
        id: d.value,
        focused: o.value,
        style: e.style
      }), {
        ...i,
        default: (y) => {
          let {
            id: p,
            messagesId: b,
            isDisabled: x,
            isReadonly: _,
            isValid: O
          } = y;
          return T(nc, ge(v, {
            id: p.value,
            "aria-describedby": b.value,
            disabled: x.value,
            readonly: _.value
          }, m, {
            error: O.value === !1,
            modelValue: r.value,
            "onUpdate:modelValue": (D) => r.value = D,
            onFocus: a,
            onBlur: l
          }), i);
        }
      });
    }), {};
  }
}), D1 = le({
  baseColor: String,
  divided: Boolean,
  ...$o(),
  ...Xe(),
  ...Oi(),
  ...Kr(),
  ...Gn(),
  ...Bt(),
  ...Mt(),
  ...mr()
}, "VBtnGroup"), uy = ye()({
  name: "VBtnGroup",
  props: D1(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: i
    } = Wt(e), {
      densityClasses: r
    } = zi(e), {
      borderClasses: o
    } = Ro(e), {
      elevationClasses: a
    } = Zr(e), {
      roundedClasses: l
    } = Xn(e);
    Gr({
      VBtn: {
        height: "auto",
        baseColor: Me(e, "baseColor"),
        color: Me(e, "color"),
        density: Me(e, "density"),
        flat: !0,
        variant: Me(e, "variant")
      }
    }), Oe(() => T(e.tag, {
      class: ["v-btn-group", {
        "v-btn-group--divided": e.divided
      }, i.value, o.value, r.value, a.value, l.value, e.class],
      style: e.style
    }, n));
  }
}), rl = le({
  modelValue: {
    type: null,
    default: void 0
  },
  multiple: Boolean,
  mandatory: [Boolean, String],
  max: Number,
  selectedClass: String,
  disabled: Boolean
}, "group"), ol = le({
  value: null,
  disabled: Boolean,
  selectedClass: String
}, "group-item");
function al(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  const i = Gt("useGroupItem");
  if (!i)
    throw new Error("[Vuetify] useGroupItem composable must be used inside a component setup function");
  const r = qn();
  sn(Symbol.for(`${t.description}:id`), r);
  const o = ht(t, null);
  if (!o) {
    if (!n)
      return o;
    throw new Error(`[Vuetify] Could not find useGroup injection with symbol ${t.description}`);
  }
  const a = Me(e, "value"), l = B(() => !!(o.disabled.value || e.disabled));
  o.register({
    id: r,
    value: a,
    disabled: l
  }, i), _n(() => {
    o.unregister(r);
  });
  const u = B(() => o.isSelected(r)), d = B(() => o.items.value[0].id === r), f = B(() => o.items.value[o.items.value.length - 1].id === r), m = B(() => u.value && [o.selectedClass.value, e.selectedClass]);
  return pe(u, (h) => {
    i.emit("group:selected", {
      value: h
    });
  }, {
    flush: "sync"
  }), {
    id: r,
    isSelected: u,
    isFirst: d,
    isLast: f,
    toggle: () => o.select(r, !u.value),
    select: (h) => o.select(r, h),
    selectedClass: m,
    value: a,
    disabled: l,
    group: o
  };
}
function Fa(e, t) {
  let n = !1;
  const i = mi([]), r = rt(e, "modelValue", [], (h) => h == null ? [] : L1(i, en(h)), (h) => {
    const v = cI(i, h);
    return e.multiple ? v : v[0];
  }), o = Gt("useGroup");
  function a(h, v) {
    const y = h, p = Symbol.for(`${t.description}:id`), x = ys(p, o == null ? void 0 : o.vnode).indexOf(v);
    Be(y.value) == null && (y.value = x, y.useIndexAsValue = !0), x > -1 ? i.splice(x, 0, y) : i.push(y);
  }
  function l(h) {
    if (n)
      return;
    u();
    const v = i.findIndex((y) => y.id === h);
    i.splice(v, 1);
  }
  function u() {
    const h = i.find((v) => !v.disabled);
    h && e.mandatory === "force" && !r.value.length && (r.value = [h.id]);
  }
  mn(() => {
    u();
  }), _n(() => {
    n = !0;
  }), yP(() => {
    for (let h = 0; h < i.length; h++)
      i[h].useIndexAsValue && (i[h].value = h);
  });
  function d(h, v) {
    const y = i.find((p) => p.id === h);
    if (!(v && (y != null && y.disabled)))
      if (e.multiple) {
        const p = r.value.slice(), b = p.findIndex((_) => _ === h), x = ~b;
        if (v = v ?? !x, x && e.mandatory && p.length <= 1 || !x && e.max != null && p.length + 1 > e.max)
          return;
        b < 0 && v ? p.push(h) : b >= 0 && !v && p.splice(b, 1), r.value = p;
      } else {
        const p = r.value.includes(h);
        if (e.mandatory && p)
          return;
        r.value = v ?? !p ? [h] : [];
      }
  }
  function f(h) {
    if (e.multiple && ur('This method is not supported when using "multiple" prop'), r.value.length) {
      const v = r.value[0], y = i.findIndex((x) => x.id === v);
      let p = (y + h) % i.length, b = i[p];
      for (; b.disabled && p !== y; )
        p = (p + h) % i.length, b = i[p];
      if (b.disabled)
        return;
      r.value = [i[p].id];
    } else {
      const v = i.find((y) => !y.disabled);
      v && (r.value = [v.id]);
    }
  }
  const m = {
    register: a,
    unregister: l,
    selected: r,
    select: d,
    disabled: Me(e, "disabled"),
    prev: () => f(i.length - 1),
    next: () => f(1),
    isSelected: (h) => r.value.includes(h),
    selectedClass: B(() => e.selectedClass),
    items: B(() => i),
    getItemIndex: (h) => uI(i, h)
  };
  return sn(t, m), m;
}
function uI(e, t) {
  const n = L1(e, [t]);
  return n.length ? e.findIndex((i) => i.id === n[0]) : -1;
}
function L1(e, t) {
  const n = [];
  return t.forEach((i) => {
    const r = e.find((a) => Ba(i, a.value)), o = e[i];
    (r == null ? void 0 : r.value) != null ? n.push(r.id) : o != null && n.push(o.id);
  }), n;
}
function cI(e, t) {
  const n = [];
  return t.forEach((i) => {
    const r = e.findIndex((o) => o.id === i);
    if (~r) {
      const o = e[r];
      n.push(o.value != null ? o.value : r);
    }
  }), n;
}
const B1 = Symbol.for("vuetify:v-btn-toggle"), dI = le({
  ...D1(),
  ...rl()
}, "VBtnToggle"), fI = ye()({
  name: "VBtnToggle",
  props: dI(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      isSelected: i,
      next: r,
      prev: o,
      select: a,
      selected: l
    } = Fa(e, B1);
    return Oe(() => {
      const u = uy.filterProps(e);
      return T(uy, ge({
        class: ["v-btn-toggle", e.class]
      }, u, {
        style: e.style
      }), {
        default: () => {
          var d;
          return [(d = n.default) == null ? void 0 : d.call(n, {
            isSelected: i,
            next: r,
            prev: o,
            select: a,
            selected: l
          })];
        }
      });
    }), {
      next: r,
      prev: o,
      select: a
    };
  }
}), hI = le({
  bgColor: String,
  color: String,
  indeterminate: [Boolean, String],
  modelValue: {
    type: [Number, String],
    default: 0
  },
  rotate: {
    type: [Number, String],
    default: 0
  },
  width: {
    type: [Number, String],
    default: 4
  },
  ...Xe(),
  ...tl(),
  ...Bt({
    tag: "div"
  }),
  ...Mt()
}, "VProgressCircular"), gI = ye()({
  name: "VProgressCircular",
  props: hI(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = 20, r = 2 * Math.PI * i, o = ie(), {
      themeClasses: a
    } = Wt(e), {
      sizeClasses: l,
      sizeStyles: u
    } = nl(e), {
      textColorClasses: d,
      textColorStyles: f
    } = Fi(Me(e, "color")), {
      textColorClasses: m,
      textColorStyles: h
    } = Fi(Me(e, "bgColor")), {
      intersectionRef: v,
      isIntersecting: y
    } = f1(), {
      resizeRef: p,
      contentRect: b
    } = Bs(), x = B(() => Math.max(0, Math.min(100, parseFloat(e.modelValue)))), _ = B(() => Number(e.width)), O = B(() => u.value ? Number(e.size) : b.value ? b.value.width : Math.max(_.value, 32)), D = B(() => i / (1 - _.value / O.value) * 2), F = B(() => _.value / O.value * D.value), $ = B(() => ze((100 - x.value) / 100 * r));
    return Ln(() => {
      v.value = o.value, p.value = o.value;
    }), Oe(() => T(e.tag, {
      ref: o,
      class: ["v-progress-circular", {
        "v-progress-circular--indeterminate": !!e.indeterminate,
        "v-progress-circular--visible": y.value,
        "v-progress-circular--disable-shrink": e.indeterminate === "disable-shrink"
      }, a.value, l.value, d.value, e.class],
      style: [u.value, f.value, e.style],
      role: "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      "aria-valuenow": e.indeterminate ? void 0 : x.value
    }, {
      default: () => [T("svg", {
        style: {
          transform: `rotate(calc(-90deg + ${Number(e.rotate)}deg))`
        },
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: `0 0 ${D.value} ${D.value}`
      }, [T("circle", {
        class: ["v-progress-circular__underlay", m.value],
        style: h.value,
        fill: "transparent",
        cx: "50%",
        cy: "50%",
        r: i,
        "stroke-width": F.value,
        "stroke-dasharray": r,
        "stroke-dashoffset": 0
      }, null), T("circle", {
        class: "v-progress-circular__overlay",
        fill: "transparent",
        cx: "50%",
        cy: "50%",
        r: i,
        "stroke-width": F.value,
        "stroke-dasharray": r,
        "stroke-dashoffset": $.value
      }, null)]), n.default && T("div", {
        class: "v-progress-circular__content"
      }, [n.default({
        value: x.value
      })])]
    })), {};
  }
});
function mI(e, t) {
  pe(() => {
    var n;
    return (n = e.isActive) == null ? void 0 : n.value;
  }, (n) => {
    e.isLink.value && n && t && gt(() => {
      t(!0);
    });
  }, {
    immediate: !0
  });
}
const vI = le({
  active: {
    type: Boolean,
    default: void 0
  },
  baseColor: String,
  symbol: {
    type: null,
    default: B1
  },
  flat: Boolean,
  icon: [Boolean, String, Function, Object],
  prependIcon: ot,
  appendIcon: ot,
  block: Boolean,
  readonly: Boolean,
  slim: Boolean,
  stacked: Boolean,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  text: String,
  ...$o(),
  ...Xe(),
  ...Oi(),
  ...hr(),
  ...Kr(),
  ...ol(),
  ...ig(),
  ...il(),
  ...Ac(),
  ...Gn(),
  ...Dc(),
  ...tl(),
  ...Bt({
    tag: "button"
  }),
  ...Mt(),
  ...mr({
    variant: "elevated"
  })
}, "VBtn"), In = ye()({
  name: "VBtn",
  props: vI(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: i
    } = t;
    const {
      themeClasses: r
    } = Wt(e), {
      borderClasses: o
    } = Ro(e), {
      densityClasses: a
    } = zi(e), {
      dimensionStyles: l
    } = gr(e), {
      elevationClasses: u
    } = Zr(e), {
      loaderClasses: d
    } = rg(e), {
      locationStyles: f
    } = Pc(e), {
      positionClasses: m
    } = Ec(e), {
      roundedClasses: h
    } = Xn(e), {
      sizeClasses: v,
      sizeStyles: y
    } = nl(e), p = al(e, e.symbol, !1), b = Ic(e, n), x = B(() => {
      var M;
      return e.active !== void 0 ? e.active : b.isLink.value ? (M = b.isActive) == null ? void 0 : M.value : p == null ? void 0 : p.isSelected.value;
    }), _ = B(() => {
      var E, I;
      return {
        color: (p == null ? void 0 : p.isSelected.value) && (!b.isLink.value || ((E = b.isActive) == null ? void 0 : E.value)) || !p || ((I = b.isActive) == null ? void 0 : I.value) ? e.color ?? e.baseColor : e.baseColor,
        variant: e.variant
      };
    }), {
      colorClasses: O,
      colorStyles: D,
      variantClasses: F
    } = Ra(_), $ = B(() => (p == null ? void 0 : p.disabled.value) || e.disabled), A = B(() => e.variant === "elevated" && !(e.disabled || e.flat || e.border)), k = B(() => {
      if (!(e.value === void 0 || typeof e.value == "symbol"))
        return Object(e.value) === e.value ? JSON.stringify(e.value, null, 0) : e.value;
    });
    function S(M) {
      var E;
      $.value || b.isLink.value && (M.metaKey || M.ctrlKey || M.shiftKey || M.button !== 0 || n.target === "_blank") || ((E = b.navigate) == null || E.call(b, M), p == null || p.toggle());
    }
    return mI(b, p == null ? void 0 : p.select), Oe(() => {
      const M = b.isLink.value ? "a" : e.tag, E = !!(e.prependIcon || i.prepend), I = !!(e.appendIcon || i.append), L = !!(e.icon && e.icon !== !0);
      return Nt(T(M, {
        type: M === "a" ? void 0 : "button",
        class: ["v-btn", p == null ? void 0 : p.selectedClass.value, {
          "v-btn--active": x.value,
          "v-btn--block": e.block,
          "v-btn--disabled": $.value,
          "v-btn--elevated": A.value,
          "v-btn--flat": e.flat,
          "v-btn--icon": !!e.icon,
          "v-btn--loading": e.loading,
          "v-btn--readonly": e.readonly,
          "v-btn--slim": e.slim,
          "v-btn--stacked": e.stacked
        }, r.value, o.value, O.value, a.value, u.value, d.value, m.value, h.value, v.value, F.value, e.class],
        style: [D.value, l.value, f.value, y.value, e.style],
        "aria-busy": e.loading ? !0 : void 0,
        disabled: $.value || void 0,
        href: b.href.value,
        tabindex: e.loading || e.readonly ? -1 : void 0,
        onClick: S,
        value: k.value
      }, {
        default: () => {
          var N;
          return [Vo(!0, "v-btn"), !e.icon && E && T("span", {
            key: "prepend",
            class: "v-btn__prepend"
          }, [i.prepend ? T(pt, {
            key: "prepend-defaults",
            disabled: !e.prependIcon,
            defaults: {
              VIcon: {
                icon: e.prependIcon
              }
            }
          }, i.prepend) : T(At, {
            key: "prepend-icon",
            icon: e.prependIcon
          }, null)]), T("span", {
            class: "v-btn__content",
            "data-no-activator": ""
          }, [!i.default && L ? T(At, {
            key: "content-icon",
            icon: e.icon
          }, null) : T(pt, {
            key: "content-defaults",
            disabled: !L,
            defaults: {
              VIcon: {
                icon: e.icon
              }
            }
          }, {
            default: () => {
              var V;
              return [((V = i.default) == null ? void 0 : V.call(i)) ?? e.text];
            }
          })]), !e.icon && I && T("span", {
            key: "append",
            class: "v-btn__append"
          }, [i.append ? T(pt, {
            key: "append-defaults",
            disabled: !e.appendIcon,
            defaults: {
              VIcon: {
                icon: e.appendIcon
              }
            }
          }, i.append) : T(At, {
            key: "append-icon",
            icon: e.appendIcon
          }, null)]), !!e.loading && T("span", {
            key: "loader",
            class: "v-btn__loader"
          }, [((N = i.loader) == null ? void 0 : N.call(i)) ?? T(gI, {
            color: typeof e.loading == "boolean" ? void 0 : e.loading,
            indeterminate: !0,
            width: "2"
          }, null)])];
        }
      }), [[Fo, !$.value && !!e.ripple, "", {
        center: !!e.icon
      }]]);
    }), {
      group: p
    };
  }
}), pI = Js("v-spacer", "div", "VSpacer"), V1 = le({
  active: {
    type: [String, Array],
    default: void 0
  },
  disabled: {
    type: [Boolean, String, Array],
    default: !1
  },
  nextIcon: {
    type: [String],
    default: "$next"
  },
  prevIcon: {
    type: [String],
    default: "$prev"
  },
  modeIcon: {
    type: [String],
    default: "$subgroup"
  },
  text: String,
  viewMode: {
    type: String,
    default: "month"
  }
}, "VDatePickerControls"), cy = ye()({
  name: "VDatePickerControls",
  props: V1(),
  emits: {
    "click:year": () => !0,
    "click:month": () => !0,
    "click:prev": () => !0,
    "click:next": () => !0,
    "click:text": () => !0
  },
  setup(e, t) {
    let {
      emit: n
    } = t;
    const i = B(() => Array.isArray(e.disabled) ? e.disabled.includes("text") : !!e.disabled), r = B(() => Array.isArray(e.disabled) ? e.disabled.includes("mode") : !!e.disabled), o = B(() => Array.isArray(e.disabled) ? e.disabled.includes("prev") : !!e.disabled), a = B(() => Array.isArray(e.disabled) ? e.disabled.includes("next") : !!e.disabled);
    function l() {
      n("click:prev");
    }
    function u() {
      n("click:next");
    }
    function d() {
      n("click:year");
    }
    function f() {
      n("click:month");
    }
    return Oe(() => T("div", {
      class: ["v-date-picker-controls"]
    }, [T(In, {
      class: "v-date-picker-controls__month-btn",
      disabled: i.value,
      text: e.text,
      variant: "text",
      rounded: !0,
      onClick: f
    }, null), T(In, {
      key: "mode-btn",
      class: "v-date-picker-controls__mode-btn",
      disabled: r.value,
      density: "comfortable",
      icon: e.modeIcon,
      variant: "text",
      onClick: d
    }, null), T(pI, {
      key: "mode-spacer"
    }, null), T("div", {
      key: "month-buttons",
      class: "v-date-picker-controls__month"
    }, [T(In, {
      disabled: o.value,
      icon: e.prevIcon,
      variant: "text",
      onClick: l
    }, null), T(In, {
      disabled: a.value,
      icon: e.nextIcon,
      variant: "text",
      onClick: u
    }, null)])])), {};
  }
}), yI = le({
  appendIcon: String,
  color: String,
  header: String,
  transition: String,
  onClick: gi()
}, "VDatePickerHeader"), dy = ye()({
  name: "VDatePickerHeader",
  props: yI(),
  emits: {
    click: () => !0,
    "click:append": () => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: i
    } = t;
    const {
      backgroundColorClasses: r,
      backgroundColorStyles: o
    } = Yn(e, "color");
    function a() {
      n("click");
    }
    function l() {
      n("click:append");
    }
    return Oe(() => {
      const u = !!(i.default || e.header), d = !!(i.append || e.appendIcon);
      return T("div", {
        class: ["v-date-picker-header", {
          "v-date-picker-header--clickable": !!e.onClick
        }, r.value],
        style: o.value,
        onClick: a
      }, [i.prepend && T("div", {
        key: "prepend",
        class: "v-date-picker-header__prepend"
      }, [i.prepend()]), u && T(Si, {
        key: "content",
        name: e.transition
      }, {
        default: () => {
          var f;
          return [T("div", {
            key: e.header,
            class: "v-date-picker-header__content"
          }, [((f = i.default) == null ? void 0 : f.call(i)) ?? e.header])];
        }
      }), d && T("div", {
        class: "v-date-picker-header__append"
      }, [i.append ? T(pt, {
        key: "append-defaults",
        disabled: !e.appendIcon,
        defaults: {
          VBtn: {
            icon: e.appendIcon,
            variant: "text"
          }
        }
      }, {
        default: () => {
          var f;
          return [(f = i.append) == null ? void 0 : f.call(i)];
        }
      }) : T(In, {
        key: "append-btn",
        icon: e.appendIcon,
        variant: "text",
        onClick: l
      }, null)])]);
    }), {};
  }
}), bI = le({
  allowedDates: [Array, Function],
  disabled: Boolean,
  displayValue: null,
  modelValue: Array,
  month: [Number, String],
  max: null,
  min: null,
  showAdjacentMonths: Boolean,
  year: [Number, String],
  weekdays: {
    type: Array,
    default: () => [0, 1, 2, 3, 4, 5, 6]
  },
  weeksInMonth: {
    type: String,
    default: "dynamic"
  }
}, "calendar");
function wI(e) {
  const t = el(), n = rt(e, "modelValue", [], (h) => en(h)), i = B(() => e.displayValue ? t.date(e.displayValue) : n.value.length > 0 ? t.date(n.value[0]) : e.min ? t.date(e.min) : Array.isArray(e.allowedDates) ? t.date(e.allowedDates[0]) : t.date()), r = rt(e, "year", void 0, (h) => {
    const v = h != null ? Number(h) : t.getYear(i.value);
    return t.startOfYear(t.setYear(t.date(), v));
  }, (h) => t.getYear(h)), o = rt(e, "month", void 0, (h) => {
    const v = h != null ? Number(h) : t.getMonth(i.value), y = t.setYear(t.startOfMonth(t.date()), t.getYear(r.value));
    return t.setMonth(y, v);
  }, (h) => t.getMonth(h)), a = B(() => {
    const h = t.getWeekArray(o.value), v = h.flat(), y = 6 * 7;
    if (e.weeksInMonth === "static" && v.length < y) {
      const p = v[v.length - 1];
      let b = [];
      for (let x = 1; x <= y - v.length; x++)
        b.push(t.addDays(p, x)), x % 7 === 0 && (h.push(b), b = []);
    }
    return h;
  });
  function l(h, v) {
    return h.filter((y) => e.weekdays.includes(t.toJsDate(y).getDay())).map((y, p) => {
      const b = t.toISO(y), x = !t.isSameMonth(y, o.value), _ = t.isSameDay(y, t.startOfMonth(o.value)), O = t.isSameDay(y, t.endOfMonth(o.value)), D = t.isSameDay(y, o.value);
      return {
        date: y,
        isoDate: b,
        formatted: t.format(y, "keyboardDate"),
        year: t.getYear(y),
        month: t.getMonth(y),
        isDisabled: m(y),
        isWeekStart: p % 7 === 0,
        isWeekEnd: p % 7 === 6,
        isToday: t.isSameDay(y, v),
        isAdjacent: x,
        isHidden: x && !e.showAdjacentMonths,
        isStart: _,
        isSelected: n.value.some((F) => t.isSameDay(y, F)),
        isEnd: O,
        isSame: D,
        localized: t.format(y, "dayOfMonth")
      };
    });
  }
  const u = B(() => {
    const h = t.startOfWeek(i.value), v = [];
    for (let p = 0; p <= 6; p++)
      v.push(t.addDays(h, p));
    const y = t.date();
    return l(v, y);
  }), d = B(() => {
    const h = a.value.flat(), v = t.date();
    return l(h, v);
  }), f = B(() => a.value.map((h) => h.length ? oE(t, h[0]) : null));
  function m(h) {
    if (e.disabled)
      return !0;
    const v = t.date(h);
    return e.min && t.isAfter(t.date(e.min), v) || e.max && t.isAfter(v, t.date(e.max)) ? !0 : Array.isArray(e.allowedDates) && e.allowedDates.length > 0 ? !e.allowedDates.some((y) => t.isSameDay(t.date(y), v)) : typeof e.allowedDates == "function" ? !e.allowedDates(v) : !1;
  }
  return {
    displayValue: i,
    daysInMonth: d,
    daysInWeek: u,
    genDays: l,
    model: n,
    weeksInMonth: a,
    weekNumbers: f
  };
}
const $1 = le({
  color: String,
  hideWeekdays: Boolean,
  multiple: [Boolean, Number, String],
  showWeek: Boolean,
  transition: {
    type: String,
    default: "picker-transition"
  },
  reverseTransition: {
    type: String,
    default: "picker-reverse-transition"
  },
  ...bI()
}, "VDatePickerMonth"), fy = ye()({
  name: "VDatePickerMonth",
  props: $1(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:month": (e) => !0,
    "update:year": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: i
    } = t;
    const r = ie(), {
      daysInMonth: o,
      model: a,
      weekNumbers: l
    } = wI(e), u = el(), d = Pe(), f = Pe(), m = Pe(!1), h = B(() => m.value ? e.reverseTransition : e.transition);
    e.multiple === "range" && a.value.length > 0 && (d.value = a.value[0], a.value.length > 1 && (f.value = a.value[a.value.length - 1]));
    const v = B(() => {
      const x = ["number", "string"].includes(typeof e.multiple) ? Number(e.multiple) : 1 / 0;
      return a.value.length >= x;
    });
    pe(o, (x, _) => {
      _ && (m.value = u.isBefore(x[0].date, _[0].date));
    });
    function y(x) {
      const _ = u.startOfDay(x);
      if (!d.value)
        d.value = _, a.value = [d.value];
      else if (f.value)
        d.value = x, f.value = void 0, a.value = [d.value];
      else {
        if (u.isSameDay(_, d.value)) {
          d.value = void 0, a.value = [];
          return;
        } else
          u.isBefore(_, d.value) ? (f.value = u.endOfDay(d.value), d.value = _) : f.value = u.endOfDay(_);
        const O = u.getDiff(f.value, d.value, "days"), D = [d.value];
        for (let F = 1; F < O; F++) {
          const $ = u.addDays(d.value, F);
          D.push($);
        }
        D.push(f.value), a.value = D;
      }
    }
    function p(x) {
      const _ = a.value.findIndex((O) => u.isSameDay(O, x));
      if (_ === -1)
        a.value = [...a.value, x];
      else {
        const O = [...a.value];
        O.splice(_, 1), a.value = O;
      }
    }
    function b(x) {
      e.multiple === "range" ? y(x) : e.multiple ? p(x) : a.value = [x];
    }
    return () => T("div", {
      class: "v-date-picker-month"
    }, [e.showWeek && T("div", {
      key: "weeks",
      class: "v-date-picker-month__weeks"
    }, [!e.hideWeekdays && T("div", {
      key: "hide-week-days",
      class: "v-date-picker-month__day"
    }, [dr(" ")]), l.value.map((x) => T("div", {
      class: ["v-date-picker-month__day", "v-date-picker-month__day--adjacent"]
    }, [x]))]), T(Si, {
      name: h.value
    }, {
      default: () => {
        var x;
        return [T("div", {
          ref: r,
          key: (x = o.value[0].date) == null ? void 0 : x.toString(),
          class: "v-date-picker-month__days"
        }, [!e.hideWeekdays && u.getWeekdays().map((_) => T("div", {
          class: ["v-date-picker-month__day", "v-date-picker-month__weekday"]
        }, [_])), o.value.map((_, O) => {
          const D = {
            props: {
              onClick: () => b(_.date)
            },
            item: _,
            i: O
          };
          return v.value && !_.isSelected && (_.isDisabled = !0), T("div", {
            class: ["v-date-picker-month__day", {
              "v-date-picker-month__day--adjacent": _.isAdjacent,
              "v-date-picker-month__day--hide-adjacent": _.isHidden,
              "v-date-picker-month__day--selected": _.isSelected,
              "v-date-picker-month__day--week-end": _.isWeekEnd,
              "v-date-picker-month__day--week-start": _.isWeekStart
            }],
            "data-v-date": _.isDisabled ? void 0 : _.isoDate
          }, [(e.showAdjacentMonths || !_.isAdjacent) && T(pt, {
            defaults: {
              VBtn: {
                class: "v-date-picker-month__day-btn",
                color: (_.isSelected || _.isToday) && !_.isDisabled ? e.color : void 0,
                disabled: _.isDisabled,
                icon: !0,
                ripple: !1,
                text: _.localized,
                variant: _.isDisabled ? _.isToday ? "outlined" : "text" : _.isToday && !_.isSelected ? "outlined" : "flat",
                onClick: () => b(_.date)
              }
            }
          }, {
            default: () => {
              var F;
              return [((F = i.day) == null ? void 0 : F.call(i, D)) ?? T(In, D.props, null)];
            }
          })]);
        })])];
      }
    })]);
  }
}), R1 = le({
  color: String,
  height: [String, Number],
  min: null,
  max: null,
  modelValue: Number,
  year: Number
}, "VDatePickerMonths"), hy = ye()({
  name: "VDatePickerMonths",
  props: R1(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: i
    } = t;
    const r = el(), o = rt(e, "modelValue"), a = B(() => {
      let l = r.startOfYear(r.date());
      return e.year && (l = r.setYear(l, e.year)), Oc(12).map((u) => {
        const d = r.format(l, "monthShort"), f = !!(e.min && r.isAfter(r.startOfMonth(r.date(e.min)), l) || e.max && r.isAfter(l, r.startOfMonth(r.date(e.max))));
        return l = r.getNextMonth(l), {
          isDisabled: f,
          text: d,
          value: u
        };
      });
    });
    return Ln(() => {
      o.value = o.value ?? r.getMonth(r.date());
    }), Oe(() => T("div", {
      class: "v-date-picker-months",
      style: {
        height: ze(e.height)
      }
    }, [T("div", {
      class: "v-date-picker-months__content"
    }, [a.value.map((l, u) => {
      var m;
      const d = {
        active: o.value === u,
        color: o.value === u ? e.color : void 0,
        disabled: l.isDisabled,
        rounded: !0,
        text: l.text,
        variant: o.value === l.value ? "flat" : "text",
        onClick: () => f(u)
      };
      function f(h) {
        if (o.value === h) {
          n("update:modelValue", o.value);
          return;
        }
        o.value = h;
      }
      return ((m = i.month) == null ? void 0 : m.call(i, {
        month: l,
        i: u,
        props: d
      })) ?? T(In, ge({
        key: "month"
      }, d), null);
    })])])), {};
  }
}), F1 = le({
  color: String,
  height: [String, Number],
  min: null,
  max: null,
  modelValue: Number
}, "VDatePickerYears"), gy = ye()({
  name: "VDatePickerYears",
  props: F1(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: i
    } = t;
    const r = el(), o = rt(e, "modelValue"), a = B(() => {
      const u = r.getYear(r.date());
      let d = u - 100, f = u + 52;
      e.min && (d = r.getYear(r.date(e.min))), e.max && (f = r.getYear(r.date(e.max)));
      let m = r.startOfYear(r.date());
      return m = r.setYear(m, d), Oc(f - d + 1, d).map((h) => {
        const v = r.format(m, "year");
        return m = r.setYear(m, r.getYear(m) + 1), {
          text: v,
          value: h
        };
      });
    });
    Ln(() => {
      o.value = o.value ?? r.getYear(r.date());
    });
    const l = Gu();
    return mn(async () => {
      var u;
      await gt(), (u = l.el) == null || u.scrollIntoView({
        block: "center"
      });
    }), Oe(() => T("div", {
      class: "v-date-picker-years",
      style: {
        height: ze(e.height)
      }
    }, [T("div", {
      class: "v-date-picker-years__content"
    }, [a.value.map((u, d) => {
      var m;
      const f = {
        ref: o.value === u.value ? l : void 0,
        active: o.value === u.value,
        color: o.value === u.value ? e.color : void 0,
        rounded: !0,
        text: u.text,
        variant: o.value === u.value ? "flat" : "text",
        onClick: () => {
          if (o.value === u.value) {
            n("update:modelValue", o.value);
            return;
          }
          o.value = u.value;
        }
      };
      return ((m = i.year) == null ? void 0 : m.call(i, {
        year: u,
        i: d,
        props: f
      })) ?? T(In, ge({
        key: "month"
      }, f), null);
    })])])), {};
  }
}), _I = Js("v-picker-title"), dg = le({
  color: String,
  ...$o(),
  ...Xe(),
  ...hr(),
  ...Kr(),
  ...il(),
  ...Ac(),
  ...Gn(),
  ...Bt(),
  ...Mt()
}, "VSheet"), ic = ye()({
  name: "VSheet",
  props: dg(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: i
    } = Wt(e), {
      backgroundColorClasses: r,
      backgroundColorStyles: o
    } = Yn(Me(e, "color")), {
      borderClasses: a
    } = Ro(e), {
      dimensionStyles: l
    } = gr(e), {
      elevationClasses: u
    } = Zr(e), {
      locationStyles: d
    } = Pc(e), {
      positionClasses: f
    } = Ec(e), {
      roundedClasses: m
    } = Xn(e);
    return Oe(() => T(e.tag, {
      class: ["v-sheet", i.value, r.value, a.value, u.value, f.value, m.value, e.class],
      style: [o.value, l.value, d.value, e.style]
    }, n)), {};
  }
}), N1 = le({
  bgColor: String,
  landscape: Boolean,
  title: String,
  hideHeader: Boolean,
  ...dg()
}, "VPicker"), my = ye()({
  name: "VPicker",
  props: N1(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      backgroundColorClasses: i,
      backgroundColorStyles: r
    } = Yn(Me(e, "color"));
    return Oe(() => {
      const o = ic.filterProps(e), a = !!(e.title || n.title);
      return T(ic, ge(o, {
        color: e.bgColor,
        class: ["v-picker", {
          "v-picker--landscape": e.landscape,
          "v-picker--with-actions": !!n.actions
        }, e.class],
        style: e.style
      }), {
        default: () => {
          var l;
          return [!e.hideHeader && T("div", {
            key: "header",
            class: [i.value],
            style: [r.value]
          }, [a && T(_I, {
            key: "picker-title"
          }, {
            default: () => {
              var u;
              return [((u = n.title) == null ? void 0 : u.call(n)) ?? e.title];
            }
          }), n.header && T("div", {
            class: "v-picker__header"
          }, [n.header()])]), T("div", {
            class: "v-picker__body"
          }, [(l = n.default) == null ? void 0 : l.call(n)]), n.actions && T(pt, {
            defaults: {
              VBtn: {
                slim: !0,
                variant: "text"
              }
            }
          }, {
            default: () => [T("div", {
              class: "v-picker__actions"
            }, [n.actions()])]
          })];
        }
      });
    }), {};
  }
}), xI = le({
  // TODO: implement in v3.5
  // calendarIcon: {
  //   type: String,
  //   default: '$calendar',
  // },
  // keyboardIcon: {
  //   type: String,
  //   default: '$edit',
  // },
  // inputMode: {
  //   type: String as PropType<'calendar' | 'keyboard'>,
  //   default: 'calendar',
  // },
  // inputText: {
  //   type: String,
  //   default: '$vuetify.datePicker.input.placeholder',
  // },
  // inputPlaceholder: {
  //   type: String,
  //   default: 'dd/mm/yyyy',
  // },
  header: {
    type: String,
    default: "$vuetify.datePicker.header"
  },
  ...V1(),
  ...$1({
    weeksInMonth: "static"
  }),
  ...gn(R1(), ["modelValue"]),
  ...gn(F1(), ["modelValue"]),
  ...N1({
    title: "$vuetify.datePicker.title"
  }),
  modelValue: null
}, "VDatePicker"), n7 = ye()({
  name: "VDatePicker",
  props: xI(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:month": (e) => !0,
    "update:year": (e) => !0,
    // 'update:inputMode': (date: any) => true,
    "update:viewMode": (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: i
    } = t;
    const r = el(), {
      t: o
    } = tn(), a = rt(e, "modelValue", void 0, (S) => en(S), (S) => e.multiple ? S : S[0]), l = rt(e, "viewMode"), u = B(() => {
      var M;
      const S = r.date((M = a.value) == null ? void 0 : M[0]);
      return S && r.isValid(S) ? S : r.date();
    }), d = ie(Number(e.month ?? r.getMonth(r.startOfMonth(u.value)))), f = ie(Number(e.year ?? r.getYear(r.startOfYear(r.setMonth(u.value, d.value))))), m = Pe(!1), h = B(() => e.multiple && a.value.length > 1 ? o("$vuetify.datePicker.itemsSelected", a.value.length) : a.value[0] && r.isValid(a.value[0]) ? r.format(r.date(a.value[0]), "normalDateWithWeekday") : o(e.header)), v = B(() => {
      let S = r.date();
      return S = r.setDate(S, 1), S = r.setMonth(S, d.value), S = r.setYear(S, f.value), r.format(S, "monthAndYear");
    }), y = B(() => `date-picker-header${m.value ? "-reverse" : ""}-transition`), p = B(() => {
      const S = r.date(e.min);
      return e.min && r.isValid(S) ? S : null;
    }), b = B(() => {
      const S = r.date(e.max);
      return e.max && r.isValid(S) ? S : null;
    }), x = B(() => {
      if (e.disabled)
        return !0;
      const S = [];
      if (l.value !== "month")
        S.push("prev", "next");
      else {
        let M = r.date();
        if (M = r.setYear(M, f.value), M = r.setMonth(M, d.value), p.value) {
          const E = r.addDays(r.startOfMonth(M), -1);
          r.isAfter(p.value, E) && S.push("prev");
        }
        if (b.value) {
          const E = r.addDays(r.endOfMonth(M), 1);
          r.isAfter(E, b.value) && S.push("next");
        }
      }
      return S;
    });
    function _() {
      d.value < 11 ? d.value++ : (f.value++, d.value = 0, k(f.value)), A(d.value);
    }
    function O() {
      d.value > 0 ? d.value-- : (f.value--, d.value = 11, k(f.value)), A(d.value);
    }
    function D() {
      l.value = "month";
    }
    function F() {
      l.value = l.value === "months" ? "month" : "months";
    }
    function $() {
      l.value = l.value === "year" ? "month" : "year";
    }
    function A(S) {
      l.value === "months" && F(), n("update:month", S);
    }
    function k(S) {
      l.value === "year" && $(), n("update:year", S);
    }
    return pe(a, (S, M) => {
      const E = r.date(en(M)[M.length - 1]), I = r.date(en(S)[S.length - 1]), L = r.getMonth(I), N = r.getYear(I);
      L !== d.value && (d.value = L, A(d.value)), N !== f.value && (f.value = N, k(f.value)), m.value = r.isBefore(E, I);
    }), Oe(() => {
      const S = my.filterProps(e), M = cy.filterProps(e), E = dy.filterProps(e), I = fy.filterProps(e), L = gn(hy.filterProps(e), ["modelValue"]), N = gn(gy.filterProps(e), ["modelValue"]), V = {
        header: h.value,
        transition: y.value
      };
      return T(my, ge(S, {
        class: ["v-date-picker", `v-date-picker--${l.value}`, {
          "v-date-picker--show-week": e.showWeek
        }, e.class],
        style: e.style
      }), {
        title: () => {
          var z;
          return ((z = i.title) == null ? void 0 : z.call(i)) ?? T("div", {
            class: "v-date-picker__title"
          }, [o(e.title)]);
        },
        header: () => i.header ? T(pt, {
          defaults: {
            VDatePickerHeader: {
              ...V
            }
          }
        }, {
          default: () => {
            var z;
            return [(z = i.header) == null ? void 0 : z.call(i, V)];
          }
        }) : T(dy, ge({
          key: "header"
        }, E, V, {
          onClick: l.value !== "month" ? D : void 0
        }), {
          ...i,
          default: void 0
        }),
        default: () => T(qe, null, [T(cy, ge(M, {
          disabled: x.value,
          text: v.value,
          "onClick:next": _,
          "onClick:prev": O,
          "onClick:month": F,
          "onClick:year": $
        }), null), T(hh, {
          hideOnLeave: !0
        }, {
          default: () => [l.value === "months" ? T(hy, ge({
            key: "date-picker-months"
          }, L, {
            modelValue: d.value,
            "onUpdate:modelValue": [(z) => d.value = z, A],
            min: p.value,
            max: b.value,
            year: f.value
          }), null) : l.value === "year" ? T(gy, ge({
            key: "date-picker-years"
          }, N, {
            modelValue: f.value,
            "onUpdate:modelValue": [(z) => f.value = z, k],
            min: p.value,
            max: b.value
          }), null) : T(fy, ge({
            key: "date-picker-month"
          }, I, {
            modelValue: a.value,
            "onUpdate:modelValue": (z) => a.value = z,
            month: d.value,
            "onUpdate:month": [(z) => d.value = z, A],
            year: f.value,
            "onUpdate:year": [(z) => f.value = z, k],
            min: p.value,
            max: b.value
          }), null)]
        })]),
        actions: i.actions
      });
    }), {};
  }
});
function Mf(e, t) {
  return {
    x: e.x + t.x,
    y: e.y + t.y
  };
}
function kI(e, t) {
  return {
    x: e.x - t.x,
    y: e.y - t.y
  };
}
function vy(e, t) {
  if (e.side === "top" || e.side === "bottom") {
    const {
      side: n,
      align: i
    } = e, r = i === "left" ? 0 : i === "center" ? t.width / 2 : i === "right" ? t.width : i, o = n === "top" ? 0 : n === "bottom" ? t.height : n;
    return Mf({
      x: r,
      y: o
    }, t);
  } else if (e.side === "left" || e.side === "right") {
    const {
      side: n,
      align: i
    } = e, r = n === "left" ? 0 : n === "right" ? t.width : n, o = i === "top" ? 0 : i === "center" ? t.height / 2 : i === "bottom" ? t.height : i;
    return Mf({
      x: r,
      y: o
    }, t);
  }
  return Mf({
    x: t.width / 2,
    y: t.height / 2
  }, t);
}
const W1 = {
  static: OI,
  // specific viewport position, usually centered
  connected: TI
  // connected to a certain element
}, SI = le({
  locationStrategy: {
    type: [String, Function],
    default: "static",
    validator: (e) => typeof e == "function" || e in W1
  },
  location: {
    type: String,
    default: "bottom"
  },
  origin: {
    type: String,
    default: "auto"
  },
  offset: [Number, String, Array]
}, "VOverlay-location-strategies");
function CI(e, t) {
  const n = ie({}), i = ie();
  ft && jr(() => !!(t.isActive.value && e.locationStrategy), (o) => {
    var a, l;
    pe(() => e.locationStrategy, o), wn(() => {
      window.removeEventListener("resize", r), i.value = void 0;
    }), window.addEventListener("resize", r, {
      passive: !0
    }), typeof e.locationStrategy == "function" ? i.value = (a = e.locationStrategy(t, e, n)) == null ? void 0 : a.updateLocation : i.value = (l = W1[e.locationStrategy](t, e, n)) == null ? void 0 : l.updateLocation;
  });
  function r(o) {
    var a;
    (a = i.value) == null || a.call(i, o);
  }
  return {
    contentStyles: n,
    updateLocation: i
  };
}
function OI() {
}
function MI(e, t) {
  t ? e.style.removeProperty("left") : e.style.removeProperty("right");
  const n = Xh(e);
  return t ? n.x += parseFloat(e.style.right || 0) : n.x -= parseFloat(e.style.left || 0), n.y -= parseFloat(e.style.top || 0), n;
}
function TI(e, t, n) {
  (Array.isArray(e.target.value) || gA(e.target.value)) && Object.assign(n.value, {
    position: "fixed",
    top: 0,
    [e.isRtl.value ? "right" : "left"]: 0
  });
  const {
    preferredAnchor: r,
    preferredOrigin: o
  } = qh(() => {
    const y = oh(t.location, e.isRtl.value), p = t.origin === "overlap" ? y : t.origin === "auto" ? xf(y) : oh(t.origin, e.isRtl.value);
    return y.side === p.side && y.align === kf(p).align ? {
      preferredAnchor: Ep(y),
      preferredOrigin: Ep(p)
    } : {
      preferredAnchor: y,
      preferredOrigin: p
    };
  }), [a, l, u, d] = ["minWidth", "minHeight", "maxWidth", "maxHeight"].map((y) => B(() => {
    const p = parseFloat(t[y]);
    return isNaN(p) ? 1 / 0 : p;
  })), f = B(() => {
    if (Array.isArray(t.offset))
      return t.offset;
    if (typeof t.offset == "string") {
      const y = t.offset.split(" ").map(parseFloat);
      return y.length < 2 && y.push(0), y;
    }
    return typeof t.offset == "number" ? [t.offset, 0] : [0, 0];
  });
  let m = !1;
  const h = new ResizeObserver(() => {
    m && v();
  });
  pe([e.target, e.contentEl], (y, p) => {
    let [b, x] = y, [_, O] = p;
    _ && !Array.isArray(_) && h.unobserve(_), b && !Array.isArray(b) && h.observe(b), O && h.unobserve(O), x && h.observe(x);
  }, {
    immediate: !0
  }), wn(() => {
    h.disconnect();
  });
  function v() {
    if (m = !1, requestAnimationFrame(() => m = !0), !e.target.value || !e.contentEl.value)
      return;
    const y = Rb(e.target.value), p = MI(e.contentEl.value, e.isRtl.value), b = Zu(e.contentEl.value), x = 12;
    b.length || (b.push(document.documentElement), e.contentEl.value.style.top && e.contentEl.value.style.left || (p.x -= parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-x") || 0), p.y -= parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-y") || 0)));
    const _ = b.reduce((E, I) => {
      const L = I.getBoundingClientRect(), N = new Eo({
        x: I === document.documentElement ? 0 : L.x,
        y: I === document.documentElement ? 0 : L.y,
        width: I.clientWidth,
        height: I.clientHeight
      });
      return E ? new Eo({
        x: Math.max(E.left, N.left),
        y: Math.max(E.top, N.top),
        width: Math.min(E.right, N.right) - Math.max(E.left, N.left),
        height: Math.min(E.bottom, N.bottom) - Math.max(E.top, N.top)
      }) : N;
    }, void 0);
    _.x += x, _.y += x, _.width -= x * 2, _.height -= x * 2;
    let O = {
      anchor: r.value,
      origin: o.value
    };
    function D(E) {
      const I = new Eo(p), L = vy(E.anchor, y), N = vy(E.origin, I);
      let {
        x: V,
        y: z
      } = kI(L, N);
      switch (E.anchor.side) {
        case "top":
          z -= f.value[0];
          break;
        case "bottom":
          z += f.value[0];
          break;
        case "left":
          V -= f.value[0];
          break;
        case "right":
          V += f.value[0];
          break;
      }
      switch (E.anchor.align) {
        case "top":
          z -= f.value[1];
          break;
        case "bottom":
          z += f.value[1];
          break;
        case "left":
          V -= f.value[1];
          break;
        case "right":
          V += f.value[1];
          break;
      }
      return I.x += V, I.y += z, I.width = Math.min(I.width, u.value), I.height = Math.min(I.height, d.value), {
        overflows: Dp(I, _),
        x: V,
        y: z
      };
    }
    let F = 0, $ = 0;
    const A = {
      x: 0,
      y: 0
    }, k = {
      x: !1,
      y: !1
    };
    let S = -1;
    for (; ; ) {
      if (S++ > 10) {
        ah("Infinite loop detected in connectedLocationStrategy");
        break;
      }
      const {
        x: E,
        y: I,
        overflows: L
      } = D(O);
      F += E, $ += I, p.x += E, p.y += I;
      {
        const N = Ip(O.anchor), V = L.x.before || L.x.after, z = L.y.before || L.y.after;
        let H = !1;
        if (["x", "y"].forEach((W) => {
          if (W === "x" && V && !k.x || W === "y" && z && !k.y) {
            const j = {
              anchor: {
                ...O.anchor
              },
              origin: {
                ...O.origin
              }
            }, U = W === "x" ? N === "y" ? kf : xf : N === "y" ? xf : kf;
            j.anchor = U(j.anchor), j.origin = U(j.origin);
            const {
              overflows: K
            } = D(j);
            (K[W].before <= L[W].before && K[W].after <= L[W].after || K[W].before + K[W].after < (L[W].before + L[W].after) / 2) && (O = j, H = k[W] = !0);
          }
        }), H)
          continue;
      }
      L.x.before && (F += L.x.before, p.x += L.x.before), L.x.after && (F -= L.x.after, p.x -= L.x.after), L.y.before && ($ += L.y.before, p.y += L.y.before), L.y.after && ($ -= L.y.after, p.y -= L.y.after);
      {
        const N = Dp(p, _);
        A.x = _.width - N.x.before - N.x.after, A.y = _.height - N.y.before - N.y.after, F += N.x.before, p.x += N.x.before, $ += N.y.before, p.y += N.y.before;
      }
      break;
    }
    const M = Ip(O.anchor);
    return Object.assign(n.value, {
      "--v-overlay-anchor-origin": `${O.anchor.side} ${O.anchor.align}`,
      transformOrigin: `${O.origin.side} ${O.origin.align}`,
      // transform: `translate(${pixelRound(x)}px, ${pixelRound(y)}px)`,
      top: ze(Tf($)),
      left: e.isRtl.value ? void 0 : ze(Tf(F)),
      right: e.isRtl.value ? ze(Tf(-F)) : void 0,
      minWidth: ze(M === "y" ? Math.min(a.value, y.width) : a.value),
      maxWidth: ze(py(lr(A.x, a.value === 1 / 0 ? 0 : a.value, u.value))),
      maxHeight: ze(py(lr(A.y, l.value === 1 / 0 ? 0 : l.value, d.value)))
    }), {
      available: A,
      contentBox: p
    };
  }
  return pe(() => [r.value, o.value, t.offset, t.minWidth, t.minHeight, t.maxWidth, t.maxHeight], () => v()), gt(() => {
    const y = v();
    if (!y)
      return;
    const {
      available: p,
      contentBox: b
    } = y;
    b.height > p.y && requestAnimationFrame(() => {
      v(), requestAnimationFrame(() => {
        v();
      });
    });
  }), {
    updateLocation: v
  };
}
function Tf(e) {
  return Math.round(e * devicePixelRatio) / devicePixelRatio;
}
function py(e) {
  return Math.ceil(e * devicePixelRatio) / devicePixelRatio;
}
let gh = !0;
const rc = [];
function PI(e) {
  !gh || rc.length ? (rc.push(e), mh()) : (gh = !1, e(), mh());
}
let yy = -1;
function mh() {
  cancelAnimationFrame(yy), yy = requestAnimationFrame(() => {
    const e = rc.shift();
    e && e(), rc.length ? mh() : gh = !0;
  });
}
const $u = {
  none: null,
  close: II,
  block: DI,
  reposition: LI
}, AI = le({
  scrollStrategy: {
    type: [String, Function],
    default: "block",
    validator: (e) => typeof e == "function" || e in $u
  }
}, "VOverlay-scroll-strategies");
function EI(e, t) {
  if (!ft)
    return;
  let n;
  Ln(async () => {
    n == null || n.stop(), t.isActive.value && e.scrollStrategy && (n = Fh(), await new Promise((i) => setTimeout(i)), n.active && n.run(() => {
      var i;
      typeof e.scrollStrategy == "function" ? e.scrollStrategy(t, e, n) : (i = $u[e.scrollStrategy]) == null || i.call($u, t, e, n);
    }));
  }), wn(() => {
    n == null || n.stop();
  });
}
function II(e) {
  function t(n) {
    e.isActive.value = !1;
  }
  z1(e.targetEl.value ?? e.contentEl.value, t);
}
function DI(e, t) {
  var a;
  const n = (a = e.root.value) == null ? void 0 : a.offsetParent, i = [.../* @__PURE__ */ new Set([...Zu(e.targetEl.value, t.contained ? n : void 0), ...Zu(e.contentEl.value, t.contained ? n : void 0)])].filter((l) => !l.classList.contains("v-overlay-scroll-blocked")), r = window.innerWidth - document.documentElement.offsetWidth, o = ((l) => Qh(l) && l)(n || document.documentElement);
  o && e.root.value.classList.add("v-overlay--scroll-blocked"), i.forEach((l, u) => {
    l.style.setProperty("--v-body-scroll-x", ze(-l.scrollLeft)), l.style.setProperty("--v-body-scroll-y", ze(-l.scrollTop)), l !== document.documentElement && l.style.setProperty("--v-scrollbar-offset", ze(r)), l.classList.add("v-overlay-scroll-blocked");
  }), wn(() => {
    i.forEach((l, u) => {
      const d = parseFloat(l.style.getPropertyValue("--v-body-scroll-x")), f = parseFloat(l.style.getPropertyValue("--v-body-scroll-y")), m = l.style.scrollBehavior;
      l.style.scrollBehavior = "auto", l.style.removeProperty("--v-body-scroll-x"), l.style.removeProperty("--v-body-scroll-y"), l.style.removeProperty("--v-scrollbar-offset"), l.classList.remove("v-overlay-scroll-blocked"), l.scrollLeft = -d, l.scrollTop = -f, l.style.scrollBehavior = m;
    }), o && e.root.value.classList.remove("v-overlay--scroll-blocked");
  });
}
function LI(e, t, n) {
  let i = !1, r = -1, o = -1;
  function a(l) {
    PI(() => {
      var f, m;
      const u = performance.now();
      (m = (f = e.updateLocation).value) == null || m.call(f, l), i = (performance.now() - u) / (1e3 / 60) > 2;
    });
  }
  o = (typeof requestIdleCallback > "u" ? (l) => l() : requestIdleCallback)(() => {
    n.run(() => {
      z1(e.targetEl.value ?? e.contentEl.value, (l) => {
        i ? (cancelAnimationFrame(r), r = requestAnimationFrame(() => {
          r = requestAnimationFrame(() => {
            a(l);
          });
        })) : a(l);
      });
    });
  }), wn(() => {
    typeof cancelIdleCallback < "u" && cancelIdleCallback(o), cancelAnimationFrame(r);
  });
}
function z1(e, t) {
  const n = [document, ...Zu(e)];
  n.forEach((i) => {
    i.addEventListener("scroll", t, {
      passive: !0
    });
  }), wn(() => {
    n.forEach((i) => {
      i.removeEventListener("scroll", t);
    });
  });
}
const vh = Symbol.for("vuetify:v-menu"), BI = le({
  closeDelay: [Number, String],
  openDelay: [Number, String]
}, "delay");
function VI(e, t) {
  let n = () => {
  };
  function i(a) {
    n == null || n();
    const l = Number(a ? e.openDelay : e.closeDelay);
    return new Promise((u) => {
      n = LP(l, () => {
        t == null || t(a), u(a);
      });
    });
  }
  function r() {
    return i(!0);
  }
  function o() {
    return i(!1);
  }
  return {
    clearDelay: n,
    runOpenDelay: r,
    runCloseDelay: o
  };
}
const $I = le({
  target: [String, Object],
  activator: [String, Object],
  activatorProps: {
    type: Object,
    default: () => ({})
  },
  openOnClick: {
    type: Boolean,
    default: void 0
  },
  openOnHover: Boolean,
  openOnFocus: {
    type: Boolean,
    default: void 0
  },
  closeOnContentClick: Boolean,
  ...BI()
}, "VOverlay-activator");
function RI(e, t) {
  let {
    isActive: n,
    isTop: i
  } = t;
  const r = Gt("useActivator"), o = ie();
  let a = !1, l = !1, u = !0;
  const d = B(() => e.openOnFocus || e.openOnFocus == null && e.openOnHover), f = B(() => e.openOnClick || e.openOnClick == null && !e.openOnHover && !d.value), {
    runOpenDelay: m,
    runCloseDelay: h
  } = VI(e, (A) => {
    A === (e.openOnHover && a || d.value && l) && !(e.openOnHover && n.value && !i.value) && (n.value !== A && (u = !0), n.value = A);
  }), v = ie(), y = {
    onClick: (A) => {
      A.stopPropagation(), o.value = A.currentTarget || A.target, n.value || (v.value = [A.clientX, A.clientY]), n.value = !n.value;
    },
    onMouseenter: (A) => {
      var k;
      (k = A.sourceCapabilities) != null && k.firesTouchEvents || (a = !0, o.value = A.currentTarget || A.target, m());
    },
    onMouseleave: (A) => {
      a = !1, h();
    },
    onFocus: (A) => {
      qu(A.target, ":focus-visible") !== !1 && (l = !0, A.stopPropagation(), o.value = A.currentTarget || A.target, m());
    },
    onBlur: (A) => {
      l = !1, A.stopPropagation(), h();
    }
  }, p = B(() => {
    const A = {};
    return f.value && (A.onClick = y.onClick), e.openOnHover && (A.onMouseenter = y.onMouseenter, A.onMouseleave = y.onMouseleave), d.value && (A.onFocus = y.onFocus, A.onBlur = y.onBlur), A;
  }), b = B(() => {
    const A = {};
    if (e.openOnHover && (A.onMouseenter = () => {
      a = !0, m();
    }, A.onMouseleave = () => {
      a = !1, h();
    }), d.value && (A.onFocusin = () => {
      l = !0, m();
    }, A.onFocusout = () => {
      l = !1, h();
    }), e.closeOnContentClick) {
      const k = ht(vh, null);
      A.onClick = () => {
        n.value = !1, k == null || k.closeParents();
      };
    }
    return A;
  }), x = B(() => {
    const A = {};
    return e.openOnHover && (A.onMouseenter = () => {
      u && (a = !0, u = !1, m());
    }, A.onMouseleave = () => {
      a = !1, h();
    }), A;
  });
  pe(i, (A) => {
    A && (e.openOnHover && !a && (!d.value || !l) || d.value && !l && (!e.openOnHover || !a)) && (n.value = !1);
  }), pe(n, (A) => {
    A || setTimeout(() => {
      v.value = void 0;
    });
  }, {
    flush: "post"
  });
  const _ = Gu();
  Ln(() => {
    _.value && gt(() => {
      o.value = _.el;
    });
  });
  const O = Gu(), D = B(() => e.target === "cursor" && v.value ? v.value : O.value ? O.el : H1(e.target, r) || o.value), F = B(() => Array.isArray(D.value) ? void 0 : D.value);
  let $;
  return pe(() => !!e.activator, (A) => {
    A && ft ? ($ = Fh(), $.run(() => {
      FI(e, r, {
        activatorEl: o,
        activatorEvents: p
      });
    })) : $ && $.stop();
  }, {
    flush: "post",
    immediate: !0
  }), wn(() => {
    $ == null || $.stop();
  }), {
    activatorEl: o,
    activatorRef: _,
    target: D,
    targetEl: F,
    targetRef: O,
    activatorEvents: p,
    contentEvents: b,
    scrimEvents: x
  };
}
function FI(e, t, n) {
  let {
    activatorEl: i,
    activatorEvents: r
  } = n;
  pe(() => e.activator, (u, d) => {
    if (d && u !== d) {
      const f = l(d);
      f && a(f);
    }
    u && gt(() => o());
  }, {
    immediate: !0
  }), pe(() => e.activatorProps, () => {
    o();
  }), wn(() => {
    a();
  });
  function o() {
    let u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : l(), d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.activatorProps;
    u && $P(u, ge(r.value, d));
  }
  function a() {
    let u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : l(), d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.activatorProps;
    u && RP(u, ge(r.value, d));
  }
  function l() {
    let u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e.activator;
    const d = H1(u, t);
    return i.value = (d == null ? void 0 : d.nodeType) === Node.ELEMENT_NODE ? d : void 0, i.value;
  }
}
function H1(e, t) {
  var i, r;
  if (!e)
    return;
  let n;
  if (e === "parent") {
    let o = (r = (i = t == null ? void 0 : t.proxy) == null ? void 0 : i.$el) == null ? void 0 : r.parentNode;
    for (; o != null && o.hasAttribute("data-no-activator"); )
      o = o.parentNode;
    n = o;
  } else
    typeof e == "string" ? n = document.querySelector(e) : "$el" in e ? n = e.$el : n = e;
  return n;
}
function NI() {
  if (!ft)
    return Pe(!1);
  const {
    ssr: e
  } = Jh();
  if (e) {
    const t = Pe(!1);
    return mn(() => {
      t.value = !0;
    }), t;
  } else
    return Pe(!0);
}
const fg = le({
  eager: Boolean
}, "lazy");
function hg(e, t) {
  const n = Pe(!1), i = B(() => n.value || e.eager || t.value);
  pe(t, () => n.value = !0);
  function r() {
    e.eager || (n.value = !1);
  }
  return {
    isBooted: n,
    hasContent: i,
    onAfterLeave: r
  };
}
function sl() {
  const t = Gt("useScopeId").vnode.scopeId;
  return {
    scopeId: t ? {
      [t]: ""
    } : void 0
  };
}
const by = Symbol.for("vuetify:stack"), ls = mi([]);
function WI(e, t, n) {
  const i = Gt("useStack"), r = !n, o = ht(by, void 0), a = mi({
    activeChildren: /* @__PURE__ */ new Set()
  });
  sn(by, a);
  const l = Pe(+t.value);
  jr(e, () => {
    var m;
    const f = (m = ls.at(-1)) == null ? void 0 : m[1];
    l.value = f ? f + 10 : +t.value, r && ls.push([i.uid, l.value]), o == null || o.activeChildren.add(i.uid), wn(() => {
      if (r) {
        const h = fn(ls).findIndex((v) => v[0] === i.uid);
        ls.splice(h, 1);
      }
      o == null || o.activeChildren.delete(i.uid);
    });
  });
  const u = Pe(!0);
  r && Ln(() => {
    var m;
    const f = ((m = ls.at(-1)) == null ? void 0 : m[0]) === i.uid;
    setTimeout(() => u.value = f);
  });
  const d = B(() => !a.activeChildren.size);
  return {
    globalTop: Nh(u),
    localTop: d,
    stackStyles: B(() => ({
      zIndex: l.value
    }))
  };
}
function zI(e) {
  return {
    teleportTarget: B(() => {
      const n = e.value;
      if (n === !0 || !ft)
        return;
      const i = n === !1 ? document.body : typeof n == "string" ? document.querySelector(n) : n;
      if (i == null) {
        Sc(`Unable to locate target ${n}`);
        return;
      }
      let r = i.querySelector(":scope > .v-overlay-container");
      return r || (r = document.createElement("div"), r.className = "v-overlay-container", i.appendChild(r)), r;
    })
  };
}
function HI() {
  return !0;
}
function j1(e, t, n) {
  if (!e || Y1(e, n) === !1)
    return !1;
  const i = jb(t);
  if (typeof ShadowRoot < "u" && i instanceof ShadowRoot && i.host === e.target)
    return !1;
  const r = (typeof n.value == "object" && n.value.include || (() => []))();
  return r.push(t), !r.some((o) => o == null ? void 0 : o.contains(e.target));
}
function Y1(e, t) {
  return (typeof t.value == "object" && t.value.closeConditional || HI)(e);
}
function jI(e, t, n) {
  const i = typeof n.value == "function" ? n.value : n.value.handler;
  t._clickOutside.lastMousedownWasOutside && j1(e, t, n) && setTimeout(() => {
    Y1(e, n) && i && i(e);
  }, 0);
}
function wy(e, t) {
  const n = jb(e);
  t(document), typeof ShadowRoot < "u" && n instanceof ShadowRoot && t(n);
}
const YI = {
  // [data-app] may not be found
  // if using bind, inserted makes
  // sure that the root element is
  // available, iOS does not support
  // clicks on body
  mounted(e, t) {
    const n = (r) => jI(r, e, t), i = (r) => {
      e._clickOutside.lastMousedownWasOutside = j1(r, e, t);
    };
    wy(e, (r) => {
      r.addEventListener("click", n, !0), r.addEventListener("mousedown", i, !0);
    }), e._clickOutside || (e._clickOutside = {
      lastMousedownWasOutside: !1
    }), e._clickOutside[t.instance.$.uid] = {
      onClick: n,
      onMousedown: i
    };
  },
  unmounted(e, t) {
    e._clickOutside && (wy(e, (n) => {
      var o;
      if (!n || !((o = e._clickOutside) != null && o[t.instance.$.uid]))
        return;
      const {
        onClick: i,
        onMousedown: r
      } = e._clickOutside[t.instance.$.uid];
      n.removeEventListener("click", i, !0), n.removeEventListener("mousedown", r, !0);
    }), delete e._clickOutside[t.instance.$.uid]);
  }
};
function UI(e) {
  const {
    modelValue: t,
    color: n,
    ...i
  } = e;
  return T(hn, {
    name: "fade-transition",
    appear: !0
  }, {
    default: () => [e.modelValue && T("div", ge({
      class: ["v-overlay__scrim", e.color.backgroundColorClasses.value],
      style: e.color.backgroundColorStyles.value
    }, i), null)]
  });
}
const ll = le({
  absolute: Boolean,
  attach: [Boolean, String, Object],
  closeOnBack: {
    type: Boolean,
    default: !0
  },
  contained: Boolean,
  contentClass: null,
  contentProps: null,
  disabled: Boolean,
  opacity: [Number, String],
  noClickAnimation: Boolean,
  modelValue: Boolean,
  persistent: Boolean,
  scrim: {
    type: [Boolean, String],
    default: !0
  },
  zIndex: {
    type: [Number, String],
    default: 2e3
  },
  ...$I(),
  ...Xe(),
  ...hr(),
  ...fg(),
  ...SI(),
  ...AI(),
  ...Mt(),
  ...$a()
}, "VOverlay"), Yr = ye()({
  name: "VOverlay",
  directives: {
    ClickOutside: YI
  },
  inheritAttrs: !1,
  props: {
    _disableGlobalStack: Boolean,
    ...ll()
  },
  emits: {
    "click:outside": (e) => !0,
    "update:modelValue": (e) => !0,
    afterEnter: () => !0,
    afterLeave: () => !0
  },
  setup(e, t) {
    let {
      slots: n,
      attrs: i,
      emit: r
    } = t;
    const o = rt(e, "modelValue"), a = B({
      get: () => o.value,
      set: (Q) => {
        Q && e.disabled || (o.value = Q);
      }
    }), {
      teleportTarget: l
    } = zI(B(() => e.attach || e.contained)), {
      themeClasses: u
    } = Wt(e), {
      rtlClasses: d,
      isRtl: f
    } = Xr(), {
      hasContent: m,
      onAfterLeave: h
    } = hg(e, a), v = Yn(B(() => typeof e.scrim == "string" ? e.scrim : null)), {
      globalTop: y,
      localTop: p,
      stackStyles: b
    } = WI(a, Me(e, "zIndex"), e._disableGlobalStack), {
      activatorEl: x,
      activatorRef: _,
      target: O,
      targetEl: D,
      targetRef: F,
      activatorEvents: $,
      contentEvents: A,
      scrimEvents: k
    } = RI(e, {
      isActive: a,
      isTop: p
    }), {
      dimensionStyles: S
    } = gr(e), M = NI(), {
      scopeId: E
    } = sl();
    pe(() => e.disabled, (Q) => {
      Q && (a.value = !1);
    });
    const I = ie(), L = ie(), N = ie(), {
      contentStyles: V,
      updateLocation: z
    } = CI(e, {
      isRtl: f,
      contentEl: N,
      target: O,
      isActive: a
    });
    EI(e, {
      root: I,
      contentEl: N,
      targetEl: D,
      isActive: a,
      updateLocation: z
    });
    function H(Q) {
      r("click:outside", Q), e.persistent ? te() : a.value = !1;
    }
    function W(Q) {
      return a.value && y.value && // If using scrim, only close if clicking on it rather than anything opened on top
      (!e.scrim || Q.target === L.value);
    }
    ft && pe(a, (Q) => {
      Q ? window.addEventListener("keydown", j) : window.removeEventListener("keydown", j);
    }, {
      immediate: !0
    }), _n(() => {
      ft && window.removeEventListener("keydown", j);
    });
    function j(Q) {
      var J, re;
      Q.key === "Escape" && y.value && (e.persistent ? te() : (a.value = !1, (J = N.value) != null && J.contains(document.activeElement) && ((re = x.value) == null || re.focus())));
    }
    const U = zE();
    jr(() => e.closeOnBack, () => {
      HE(U, (Q) => {
        y.value && a.value ? (Q(!1), e.persistent ? te() : a.value = !1) : Q();
      });
    });
    const K = ie();
    pe(() => a.value && (e.absolute || e.contained) && l.value == null, (Q) => {
      if (Q) {
        const J = Ub(I.value);
        J && J !== document.scrollingElement && (K.value = J.scrollTop);
      }
    });
    function te() {
      e.noClickAnimation || N.value && pa(N.value, [{
        transformOrigin: "center"
      }, {
        transform: "scale(1.03)"
      }, {
        transformOrigin: "center"
      }], {
        duration: 150,
        easing: Ku
      });
    }
    function ue() {
      r("afterEnter");
    }
    function de() {
      h(), r("afterLeave");
    }
    return Oe(() => {
      var Q;
      return T(qe, null, [(Q = n.activator) == null ? void 0 : Q.call(n, {
        isActive: a.value,
        targetRef: F,
        props: ge({
          ref: _
        }, $.value, e.activatorProps)
      }), M.value && m.value && T(As, {
        disabled: !l.value,
        to: l.value
      }, {
        default: () => [T("div", ge({
          class: ["v-overlay", {
            "v-overlay--absolute": e.absolute || e.contained,
            "v-overlay--active": a.value,
            "v-overlay--contained": e.contained
          }, u.value, d.value, e.class],
          style: [b.value, {
            "--v-overlay-opacity": e.opacity,
            top: ze(K.value)
          }, e.style],
          ref: I
        }, E, i), [T(UI, ge({
          color: v,
          modelValue: a.value && !!e.scrim,
          ref: L
        }, k.value), null), T(Si, {
          appear: !0,
          persisted: !0,
          transition: e.transition,
          target: O.value,
          onAfterEnter: ue,
          onAfterLeave: de
        }, {
          default: () => {
            var J;
            return [Nt(T("div", ge({
              ref: N,
              class: ["v-overlay__content", e.contentClass],
              style: [S.value, V.value]
            }, A.value, e.contentProps), [(J = n.default) == null ? void 0 : J.call(n, {
              isActive: a
            })]), [[Ri, a.value], [Ci("click-outside"), {
              handler: H,
              closeConditional: W,
              include: () => [x.value]
            }]])];
          }
        })])]
      })]);
    }), {
      activatorEl: x,
      scrimEl: L,
      target: O,
      animateClick: te,
      contentEl: N,
      globalTop: y,
      localTop: p,
      updateLocation: z
    };
  }
}), Pf = Symbol("Forwarded refs");
function Af(e, t) {
  let n = e;
  for (; n; ) {
    const i = Reflect.getOwnPropertyDescriptor(n, t);
    if (i)
      return i;
    n = Object.getPrototypeOf(n);
  }
}
function Qr(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  return e[Pf] = n, new Proxy(e, {
    get(r, o) {
      if (Reflect.has(r, o))
        return Reflect.get(r, o);
      if (!(typeof o == "symbol" || o.startsWith("$") || o.startsWith("__"))) {
        for (const a of n)
          if (a.value && Reflect.has(a.value, o)) {
            const l = Reflect.get(a.value, o);
            return typeof l == "function" ? l.bind(a.value) : l;
          }
      }
    },
    has(r, o) {
      if (Reflect.has(r, o))
        return !0;
      if (typeof o == "symbol" || o.startsWith("$") || o.startsWith("__"))
        return !1;
      for (const a of n)
        if (a.value && Reflect.has(a.value, o))
          return !0;
      return !1;
    },
    set(r, o, a) {
      if (Reflect.has(r, o))
        return Reflect.set(r, o, a);
      if (typeof o == "symbol" || o.startsWith("$") || o.startsWith("__"))
        return !1;
      for (const l of n)
        if (l.value && Reflect.has(l.value, o))
          return Reflect.set(l.value, o, a);
      return !1;
    },
    getOwnPropertyDescriptor(r, o) {
      var l;
      const a = Reflect.getOwnPropertyDescriptor(r, o);
      if (a)
        return a;
      if (!(typeof o == "symbol" || o.startsWith("$") || o.startsWith("__"))) {
        for (const u of n) {
          if (!u.value)
            continue;
          const d = Af(u.value, o) ?? ("_" in u.value ? Af((l = u.value._) == null ? void 0 : l.setupState, o) : void 0);
          if (d)
            return d;
        }
        for (const u of n) {
          const d = u.value && u.value[Pf];
          if (!d)
            continue;
          const f = d.slice();
          for (; f.length; ) {
            const m = f.shift(), h = Af(m.value, o);
            if (h)
              return h;
            const v = m.value && m.value[Pf];
            v && f.push(...v);
          }
        }
      }
    }
  });
}
const qI = le({
  fullscreen: Boolean,
  retainFocus: {
    type: Boolean,
    default: !0
  },
  scrollable: Boolean,
  ...ll({
    origin: "center center",
    scrollStrategy: "block",
    transition: {
      component: lg
    },
    zIndex: 2400
  })
}, "VDialog"), i7 = ye()({
  name: "VDialog",
  props: qI(),
  emits: {
    "update:modelValue": (e) => !0,
    afterLeave: () => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: i
    } = t;
    const r = rt(e, "modelValue"), {
      scopeId: o
    } = sl(), a = ie();
    function l(f) {
      var v, y;
      const m = f.relatedTarget, h = f.target;
      if (m !== h && ((v = a.value) != null && v.contentEl) && // We're the topmost dialog
      ((y = a.value) != null && y.globalTop) && // It isn't the document or the dialog body
      ![document, a.value.contentEl].includes(h) && // It isn't inside the dialog body
      !a.value.contentEl.contains(h)) {
        const p = Es(a.value.contentEl);
        if (!p.length)
          return;
        const b = p[0], x = p[p.length - 1];
        m === b ? x.focus() : b.focus();
      }
    }
    ft && pe(() => r.value && e.retainFocus, (f) => {
      f ? document.addEventListener("focusin", l) : document.removeEventListener("focusin", l);
    }, {
      immediate: !0
    });
    function u() {
      var f;
      (f = a.value) != null && f.contentEl && !a.value.contentEl.contains(document.activeElement) && a.value.contentEl.focus({
        preventScroll: !0
      });
    }
    function d() {
      n("afterLeave");
    }
    return pe(r, async (f) => {
      var m;
      f || (await gt(), (m = a.value.activatorEl) == null || m.focus({
        preventScroll: !0
      }));
    }), Oe(() => {
      const f = Yr.filterProps(e), m = ge({
        "aria-haspopup": "dialog",
        "aria-expanded": String(r.value)
      }, e.activatorProps), h = ge({
        tabindex: -1
      }, e.contentProps);
      return T(Yr, ge({
        ref: a,
        class: ["v-dialog", {
          "v-dialog--fullscreen": e.fullscreen,
          "v-dialog--scrollable": e.scrollable
        }, e.class],
        style: e.style
      }, f, {
        modelValue: r.value,
        "onUpdate:modelValue": (v) => r.value = v,
        "aria-modal": "true",
        activatorProps: m,
        contentProps: h,
        role: "dialog",
        onAfterEnter: u,
        onAfterLeave: d
      }, o), {
        activator: i.activator,
        default: function() {
          for (var v = arguments.length, y = new Array(v), p = 0; p < v; p++)
            y[p] = arguments[p];
          return T(pt, {
            root: "VDialog"
          }, {
            default: () => {
              var b;
              return [(b = i.default) == null ? void 0 : b.call(i, ...y)];
            }
          });
        }
      });
    }), Qr({}, a);
  }
}), GI = le({
  color: String,
  inset: Boolean,
  length: [Number, String],
  opacity: [Number, String],
  thickness: [Number, String],
  vertical: Boolean,
  ...Xe(),
  ...Mt()
}, "VDivider"), U1 = ye()({
  name: "VDivider",
  props: GI(),
  setup(e, t) {
    let {
      attrs: n,
      slots: i
    } = t;
    const {
      themeClasses: r
    } = Wt(e), {
      textColorClasses: o,
      textColorStyles: a
    } = Fi(Me(e, "color")), l = B(() => {
      const u = {};
      return e.length && (u[e.vertical ? "maxHeight" : "maxWidth"] = ze(e.length)), e.thickness && (u[e.vertical ? "borderRightWidth" : "borderTopWidth"] = ze(e.thickness)), u;
    });
    return Oe(() => {
      const u = T("hr", {
        class: [{
          "v-divider": !0,
          "v-divider--inset": e.inset,
          "v-divider--vertical": e.vertical
        }, r.value, o.value, e.class],
        style: [l.value, a.value, {
          "--v-border-opacity": e.opacity
        }, e.style],
        "aria-orientation": !n.role || n.role === "separator" ? e.vertical ? "vertical" : "horizontal" : void 0,
        role: `${n.role || "separator"}`
      }, null);
      return i.default ? T("div", {
        class: ["v-divider__wrapper", {
          "v-divider__wrapper--vertical": e.vertical,
          "v-divider__wrapper--inset": e.inset
        }]
      }, [u, T("div", {
        class: "v-divider__content"
      }, [i.default()]), u]) : u;
    }), {};
  }
}), q1 = le({
  ...Xe(),
  ...fg()
}, "VExpansionPanelText"), _y = ye()({
  name: "VExpansionPanelText",
  props: q1(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = ht(Rs);
    if (!i)
      throw new Error("[Vuetify] v-expansion-panel-text needs to be placed inside v-expansion-panel");
    const {
      hasContent: r,
      onAfterLeave: o
    } = hg(e, i.isSelected);
    return Oe(() => T(P1, {
      onAfterLeave: o
    }, {
      default: () => {
        var a;
        return [Nt(T("div", {
          class: ["v-expansion-panel-text", e.class],
          style: e.style
        }, [n.default && r.value && T("div", {
          class: "v-expansion-panel-text__wrapper"
        }, [(a = n.default) == null ? void 0 : a.call(n)])]), [[Ri, i.isSelected.value]])];
      }
    })), {};
  }
}), G1 = le({
  color: String,
  expandIcon: {
    type: ot,
    default: "$expand"
  },
  collapseIcon: {
    type: ot,
    default: "$collapse"
  },
  hideActions: Boolean,
  focusable: Boolean,
  static: Boolean,
  ripple: {
    type: [Boolean, Object],
    default: !1
  },
  readonly: Boolean,
  ...Xe()
}, "VExpansionPanelTitle"), xy = ye()({
  name: "VExpansionPanelTitle",
  directives: {
    Ripple: Fo
  },
  props: G1(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = ht(Rs);
    if (!i)
      throw new Error("[Vuetify] v-expansion-panel-title needs to be placed inside v-expansion-panel");
    const {
      backgroundColorClasses: r,
      backgroundColorStyles: o
    } = Yn(e, "color"), a = B(() => ({
      collapseIcon: e.collapseIcon,
      disabled: i.disabled.value,
      expanded: i.isSelected.value,
      expandIcon: e.expandIcon,
      readonly: e.readonly
    }));
    return Oe(() => {
      var l;
      return Nt(T("button", {
        class: ["v-expansion-panel-title", {
          "v-expansion-panel-title--active": i.isSelected.value,
          "v-expansion-panel-title--focusable": e.focusable,
          "v-expansion-panel-title--static": e.static
        }, r.value, e.class],
        style: [o.value, e.style],
        type: "button",
        tabindex: i.disabled.value ? -1 : void 0,
        disabled: i.disabled.value,
        "aria-expanded": i.isSelected.value,
        onClick: e.readonly ? void 0 : i.toggle
      }, [T("span", {
        class: "v-expansion-panel-title__overlay"
      }, null), (l = n.default) == null ? void 0 : l.call(n, a.value), !e.hideActions && T("span", {
        class: "v-expansion-panel-title__icon"
      }, [n.actions ? n.actions(a.value) : T(At, {
        icon: i.isSelected.value ? e.collapseIcon : e.expandIcon
      }, null)])]), [[Ci("ripple"), e.ripple]]);
    }), {};
  }
}), X1 = le({
  title: String,
  text: String,
  bgColor: String,
  ...Kr(),
  ...ol(),
  ...Gn(),
  ...Bt(),
  ...G1(),
  ...q1()
}, "VExpansionPanel"), r7 = ye()({
  name: "VExpansionPanel",
  props: X1(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = al(e, Rs), {
      backgroundColorClasses: r,
      backgroundColorStyles: o
    } = Yn(e, "bgColor"), {
      elevationClasses: a
    } = Zr(e), {
      roundedClasses: l
    } = Xn(e), u = B(() => (i == null ? void 0 : i.disabled.value) || e.disabled), d = B(() => i.group.items.value.reduce((h, v, y) => (i.group.selected.value.includes(v.id) && h.push(y), h), [])), f = B(() => {
      const h = i.group.items.value.findIndex((v) => v.id === i.id);
      return !i.isSelected.value && d.value.some((v) => v - h === 1);
    }), m = B(() => {
      const h = i.group.items.value.findIndex((v) => v.id === i.id);
      return !i.isSelected.value && d.value.some((v) => v - h === -1);
    });
    return sn(Rs, i), Oe(() => {
      const h = !!(n.text || e.text), v = !!(n.title || e.title), y = xy.filterProps(e), p = _y.filterProps(e);
      return T(e.tag, {
        class: ["v-expansion-panel", {
          "v-expansion-panel--active": i.isSelected.value,
          "v-expansion-panel--before-active": f.value,
          "v-expansion-panel--after-active": m.value,
          "v-expansion-panel--disabled": u.value
        }, l.value, r.value, e.class],
        style: [o.value, e.style]
      }, {
        default: () => {
          var b;
          return [T("div", {
            class: ["v-expansion-panel__shadow", ...a.value]
          }, null), v && T(xy, ge({
            key: "title"
          }, y), {
            default: () => [n.title ? n.title() : e.title]
          }), h && T(_y, ge({
            key: "text"
          }, p), {
            default: () => [n.text ? n.text() : e.text]
          }), (b = n.default) == null ? void 0 : b.call(n)];
        }
      });
    }), {
      groupItem: i
    };
  }
}), Rs = Symbol.for("vuetify:v-expansion-panel"), XI = ["default", "accordion", "inset", "popout"], KI = le({
  flat: Boolean,
  ...rl(),
  ...X1(),
  ...Mt(),
  variant: {
    type: String,
    default: "default",
    validator: (e) => XI.includes(e)
  }
}, "VExpansionPanels");
ye()({
  name: "VExpansionPanels",
  props: KI(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      next: i,
      prev: r
    } = Fa(e, Rs), {
      themeClasses: o
    } = Wt(e), a = B(() => e.variant && `v-expansion-panels--variant-${e.variant}`);
    return Gr({
      VExpansionPanel: {
        bgColor: Me(e, "bgColor"),
        collapseIcon: Me(e, "collapseIcon"),
        color: Me(e, "color"),
        eager: Me(e, "eager"),
        elevation: Me(e, "elevation"),
        expandIcon: Me(e, "expandIcon"),
        focusable: Me(e, "focusable"),
        hideActions: Me(e, "hideActions"),
        readonly: Me(e, "readonly"),
        ripple: Me(e, "ripple"),
        rounded: Me(e, "rounded"),
        static: Me(e, "static")
      }
    }), Oe(() => T(e.tag, {
      class: ["v-expansion-panels", {
        "v-expansion-panels--flat": e.flat,
        "v-expansion-panels--tile": e.tile
      }, o.value, a.value, e.class],
      style: e.style
    }, {
      default: () => {
        var l;
        return [(l = n.default) == null ? void 0 : l.call(n, {
          prev: r,
          next: i
        })];
      }
    })), {
      next: i,
      prev: r
    };
  }
});
const ZI = le({
  ...Xe(),
  ...rI()
}, "VForm"), o7 = ye()({
  name: "VForm",
  props: ZI(),
  emits: {
    "update:modelValue": (e) => !0,
    submit: (e) => !0
  },
  setup(e, t) {
    let {
      slots: n,
      emit: i
    } = t;
    const r = oI(e), o = ie();
    function a(u) {
      u.preventDefault(), r.reset();
    }
    function l(u) {
      const d = u, f = r.validate();
      d.then = f.then.bind(f), d.catch = f.catch.bind(f), d.finally = f.finally.bind(f), i("submit", d), d.defaultPrevented || f.then((m) => {
        var v;
        let {
          valid: h
        } = m;
        h && ((v = o.value) == null || v.submit());
      }), d.preventDefault();
    }
    return Oe(() => {
      var u;
      return T("form", {
        ref: o,
        class: ["v-form", e.class],
        style: e.style,
        novalidate: !0,
        onReset: a,
        onSubmit: l
      }, [(u = n.default) == null ? void 0 : u.call(n, r)]);
    }), Qr(r, o);
  }
}), QI = le({
  // TODO
  // disableKeys: Boolean,
  id: String,
  ...gn(ll({
    closeDelay: 250,
    closeOnContentClick: !0,
    locationStrategy: "connected",
    openDelay: 300,
    scrim: !1,
    scrollStrategy: "reposition",
    transition: {
      component: lg
    }
  }), ["absolute"])
}, "VMenu"), K1 = ye()({
  name: "VMenu",
  props: QI(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = rt(e, "modelValue"), {
      scopeId: r
    } = sl(), o = qn(), a = B(() => e.id || `v-menu-${o}`), l = ie(), u = ht(vh, null), d = Pe(0);
    sn(vh, {
      register() {
        ++d.value;
      },
      unregister() {
        --d.value;
      },
      closeParents(p) {
        setTimeout(() => {
          !d.value && !e.persistent && (p == null || p && !BP(p, l.value.contentEl)) && (i.value = !1, u == null || u.closeParents());
        }, 40);
      }
    });
    async function f(p) {
      var _, O, D;
      const b = p.relatedTarget, x = p.target;
      await gt(), i.value && b !== x && ((_ = l.value) != null && _.contentEl) && // We're the topmost menu
      ((O = l.value) != null && O.globalTop) && // It isn't the document or the menu body
      ![document, l.value.contentEl].includes(x) && // It isn't inside the menu body
      !l.value.contentEl.contains(x) && ((D = Es(l.value.contentEl)[0]) == null || D.focus());
    }
    pe(i, (p) => {
      p ? (u == null || u.register(), document.addEventListener("focusin", f, {
        once: !0
      })) : (u == null || u.unregister(), document.removeEventListener("focusin", f));
    });
    function m(p) {
      u == null || u.closeParents(p);
    }
    function h(p) {
      var b, x, _;
      if (!e.disabled)
        if (p.key === "Tab" || p.key === "Enter" && !e.closeOnContentClick) {
          if (p.key === "Enter" && p.target instanceof HTMLTextAreaElement)
            return;
          p.key === "Enter" && p.preventDefault(), Vb(Es((b = l.value) == null ? void 0 : b.contentEl, !1), p.shiftKey ? "prev" : "next", (D) => D.tabIndex >= 0) || (i.value = !1, (_ = (x = l.value) == null ? void 0 : x.activatorEl) == null || _.focus());
        } else
          ["Enter", " "].includes(p.key) && e.closeOnContentClick && (i.value = !1, u == null || u.closeParents());
    }
    function v(p) {
      var x;
      if (e.disabled)
        return;
      const b = (x = l.value) == null ? void 0 : x.contentEl;
      b && i.value ? p.key === "ArrowDown" ? (p.preventDefault(), Uu(b, "next")) : p.key === "ArrowUp" && (p.preventDefault(), Uu(b, "prev")) : ["ArrowDown", "ArrowUp"].includes(p.key) && (i.value = !0, p.preventDefault(), setTimeout(() => setTimeout(() => v(p))));
    }
    const y = B(() => ge({
      "aria-haspopup": "menu",
      "aria-expanded": String(i.value),
      "aria-owns": a.value,
      onKeydown: v
    }, e.activatorProps));
    return Oe(() => {
      const p = Yr.filterProps(e);
      return T(Yr, ge({
        ref: l,
        id: a.value,
        class: ["v-menu", e.class],
        style: e.style
      }, p, {
        modelValue: i.value,
        "onUpdate:modelValue": (b) => i.value = b,
        absolute: !0,
        activatorProps: y.value,
        "onClick:outside": m,
        onKeydown: h
      }, r), {
        activator: n.activator,
        default: function() {
          for (var b = arguments.length, x = new Array(b), _ = 0; _ < b; _++)
            x[_] = arguments[_];
          return T(pt, {
            root: "VMenu"
          }, {
            default: () => {
              var O;
              return [(O = n.default) == null ? void 0 : O.call(n, ...x)];
            }
          });
        }
      });
    }), Qr({
      id: a,
      ΨopenChildren: d
    }, l);
  }
}), JI = le({
  ...sg({
    falseIcon: "$radioOff",
    trueIcon: "$radioOn"
  })
}, "VRadio"), a7 = ye()({
  name: "VRadio",
  props: JI(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return Oe(() => T(tc, ge(e, {
      class: ["v-radio", e.class],
      style: e.style,
      type: "radio"
    }), n)), {};
  }
}), eD = le({
  height: {
    type: [Number, String],
    default: "auto"
  },
  ...Lc(),
  ...gn(ag(), ["multiple"]),
  trueIcon: {
    type: ot,
    default: "$radioOn"
  },
  falseIcon: {
    type: ot,
    default: "$radioOff"
  },
  type: {
    type: String,
    default: "radio"
  }
}, "VRadioGroup"), s7 = ye()({
  name: "VRadioGroup",
  inheritAttrs: !1,
  props: eD(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: i
    } = t;
    const r = qn(), o = B(() => e.id || `radio-group-${r}`), a = rt(e, "modelValue");
    return Oe(() => {
      const [l, u] = Mc(n), d = Sa.filterProps(e), f = tc.filterProps(e), m = i.label ? i.label({
        label: e.label,
        props: {
          for: o.value
        }
      }) : e.label;
      return T(Sa, ge({
        class: ["v-radio-group", e.class],
        style: e.style
      }, l, d, {
        modelValue: a.value,
        "onUpdate:modelValue": (h) => a.value = h,
        id: o.value
      }), {
        ...i,
        default: (h) => {
          let {
            id: v,
            messagesId: y,
            isDisabled: p,
            isReadonly: b
          } = h;
          return T(qe, null, [m && T(og, {
            id: v.value
          }, {
            default: () => [m]
          }), T(QE, ge(f, {
            id: v.value,
            "aria-describedby": y.value,
            defaultsTarget: "VRadio",
            trueIcon: e.trueIcon,
            falseIcon: e.falseIcon,
            type: e.type,
            disabled: p.value,
            readonly: b.value,
            "aria-labelledby": m ? v.value : void 0,
            multiple: !1
          }, u, {
            modelValue: a.value,
            "onUpdate:modelValue": (x) => a.value = x
          }), i)]);
        }
      });
    }), {};
  }
});
function tD(e) {
  const t = Pe(e);
  let n = -1;
  function i() {
    clearInterval(n);
  }
  function r() {
    i(), gt(() => t.value = e);
  }
  function o(a) {
    const l = a ? getComputedStyle(a) : {
      transitionDuration: 0.2
    }, u = parseFloat(l.transitionDuration) * 1e3 || 200;
    if (i(), t.value <= 0)
      return;
    const d = performance.now();
    n = window.setInterval(() => {
      const f = performance.now() - d + u;
      t.value = Math.max(e - f, 0), t.value <= 0 && i();
    }, u);
  }
  return wn(i), {
    clear: i,
    time: t,
    start: o,
    reset: r
  };
}
const nD = le({
  multiLine: Boolean,
  text: String,
  timer: [Boolean, String],
  timeout: {
    type: [Number, String],
    default: 5e3
  },
  vertical: Boolean,
  ...il({
    location: "bottom"
  }),
  ...Ac(),
  ...Gn(),
  ...mr(),
  ...Mt(),
  ...gn(ll({
    transition: "v-snackbar-transition"
  }), ["persistent", "noClickAnimation", "scrim", "scrollStrategy"])
}, "VSnackbar"), l7 = ye()({
  name: "VSnackbar",
  props: nD(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = rt(e, "modelValue"), {
      positionClasses: r
    } = Ec(e), {
      scopeId: o
    } = sl(), {
      themeClasses: a
    } = Wt(e), {
      colorClasses: l,
      colorStyles: u,
      variantClasses: d
    } = Ra(e), {
      roundedClasses: f
    } = Xn(e), m = tD(Number(e.timeout)), h = ie(), v = ie(), y = Pe(!1), p = Pe(0), b = ie(), x = ht(a1, void 0);
    jr(() => !!x, () => {
      const M = bE();
      Ln(() => {
        b.value = M.mainStyles.value;
      });
    }), pe(i, O), pe(() => e.timeout, O), mn(() => {
      i.value && O();
    });
    let _ = -1;
    function O() {
      m.reset(), window.clearTimeout(_);
      const M = Number(e.timeout);
      if (!i.value || M === -1)
        return;
      const E = Yh(v.value);
      m.start(E), _ = window.setTimeout(() => {
        i.value = !1;
      }, M);
    }
    function D() {
      m.reset(), window.clearTimeout(_);
    }
    function F() {
      y.value = !0, D();
    }
    function $() {
      y.value = !1, O();
    }
    function A(M) {
      p.value = M.touches[0].clientY;
    }
    function k(M) {
      Math.abs(p.value - M.changedTouches[0].clientY) > 50 && (i.value = !1);
    }
    const S = B(() => e.location.split(" ").reduce((M, E) => (M[`v-snackbar--${E}`] = !0, M), {}));
    return Oe(() => {
      const M = Yr.filterProps(e), E = !!(n.default || n.text || e.text);
      return T(Yr, ge({
        ref: h,
        class: ["v-snackbar", {
          "v-snackbar--active": i.value,
          "v-snackbar--multi-line": e.multiLine && !e.vertical,
          "v-snackbar--timer": !!e.timer,
          "v-snackbar--vertical": e.vertical
        }, S.value, r.value, e.class],
        style: [b.value, e.style]
      }, M, {
        modelValue: i.value,
        "onUpdate:modelValue": (I) => i.value = I,
        contentProps: ge({
          class: ["v-snackbar__wrapper", a.value, l.value, f.value, d.value],
          style: [u.value],
          onPointerenter: F,
          onPointerleave: $
        }, M.contentProps),
        persistent: !0,
        noClickAnimation: !0,
        scrim: !1,
        scrollStrategy: "none",
        _disableGlobalStack: !0,
        onTouchstartPassive: A,
        onTouchend: k
      }, o), {
        default: () => {
          var I, L;
          return [Vo(!1, "v-snackbar"), e.timer && !y.value && T("div", {
            key: "timer",
            class: "v-snackbar__timer"
          }, [T(h1, {
            ref: v,
            color: typeof e.timer == "string" ? e.timer : "info",
            max: e.timeout,
            "model-value": m.time.value
          }, null)]), E && T("div", {
            key: "content",
            class: "v-snackbar__content",
            role: "status",
            "aria-live": "polite"
          }, [((I = n.text) == null ? void 0 : I.call(n)) ?? e.text, (L = n.default) == null ? void 0 : L.call(n)]), n.actions && T(pt, {
            defaults: {
              VBtn: {
                variant: "text",
                ripple: !1,
                slim: !0
              }
            }
          }, {
            default: () => [T("div", {
              class: "v-snackbar__actions"
            }, [n.actions({
              isActive: i
            })])]
          })];
        },
        activator: n.activator
      });
    }), Qr({}, h);
  }
}), Z1 = le({
  color: String,
  disabled: {
    type: [Boolean, String],
    default: !1
  },
  prevText: {
    type: String,
    default: "$vuetify.stepper.prev"
  },
  nextText: {
    type: String,
    default: "$vuetify.stepper.next"
  }
}, "VStepperActions"), iD = ye()({
  name: "VStepperActions",
  props: Z1(),
  emits: {
    "click:prev": () => !0,
    "click:next": () => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: i
    } = t;
    const {
      t: r
    } = tn();
    function o() {
      n("click:prev");
    }
    function a() {
      n("click:next");
    }
    return Oe(() => {
      const l = {
        onClick: o
      }, u = {
        onClick: a
      };
      return T("div", {
        class: "v-stepper-actions"
      }, [T(pt, {
        defaults: {
          VBtn: {
            disabled: ["prev", !0].includes(e.disabled),
            text: r(e.prevText),
            variant: "text"
          }
        }
      }, {
        default: () => {
          var d;
          return [((d = i.prev) == null ? void 0 : d.call(i, {
            props: l
          })) ?? T(In, l, null)];
        }
      }), T(pt, {
        defaults: {
          VBtn: {
            color: e.color,
            disabled: ["next", !0].includes(e.disabled),
            text: r(e.nextText),
            variant: "tonal"
          }
        }
      }, {
        default: () => {
          var d;
          return [((d = i.next) == null ? void 0 : d.call(i, {
            props: u
          })) ?? T(In, u, null)];
        }
      })]);
    }), {};
  }
}), rD = Js("v-stepper-header"), oD = le({
  color: String,
  title: String,
  subtitle: String,
  complete: Boolean,
  completeIcon: {
    type: String,
    default: "$complete"
  },
  editable: Boolean,
  editIcon: {
    type: String,
    default: "$edit"
  },
  error: Boolean,
  errorIcon: {
    type: String,
    default: "$error"
  },
  icon: String,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  rules: {
    type: Array,
    default: () => []
  }
}, "StepperItem"), aD = le({
  ...oD(),
  ...ol()
}, "VStepperItem"), sD = ye()({
  name: "VStepperItem",
  directives: {
    Ripple: Fo
  },
  props: aD(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = al(e, rw, !0), r = B(() => (i == null ? void 0 : i.value.value) ?? e.value), o = B(() => e.rules.every((h) => h() === !0)), a = B(() => !e.disabled && e.editable), l = B(() => !e.disabled && e.editable), u = B(() => e.error || !o.value), d = B(() => e.complete || e.rules.length > 0 && o.value), f = B(() => u.value ? e.errorIcon : d.value ? e.completeIcon : i.isSelected.value && e.editable ? e.editIcon : e.icon), m = B(() => ({
      canEdit: l.value,
      hasError: u.value,
      hasCompleted: d.value,
      title: e.title,
      subtitle: e.subtitle,
      step: r.value,
      value: e.value
    }));
    return Oe(() => {
      var b, x, _;
      const h = (!i || i.isSelected.value || d.value || l.value) && !u.value && !e.disabled, v = !!(e.title != null || n.title), y = !!(e.subtitle != null || n.subtitle);
      function p() {
        i == null || i.toggle();
      }
      return Nt(T("button", {
        class: ["v-stepper-item", {
          "v-stepper-item--complete": d.value,
          "v-stepper-item--disabled": e.disabled,
          "v-stepper-item--error": u.value
        }, i == null ? void 0 : i.selectedClass.value],
        disabled: !e.editable,
        onClick: p
      }, [a.value && Vo(!0, "v-stepper-item"), T(fr, {
        key: "stepper-avatar",
        class: "v-stepper-item__avatar",
        color: h ? e.color : void 0,
        size: 24
      }, {
        default: () => {
          var O;
          return [((O = n.icon) == null ? void 0 : O.call(n, m.value)) ?? (f.value ? T(At, {
            icon: f.value
          }, null) : r.value)];
        }
      }), T("div", {
        class: "v-stepper-item__content"
      }, [v && T("div", {
        key: "title",
        class: "v-stepper-item__title"
      }, [((b = n.title) == null ? void 0 : b.call(n, m.value)) ?? e.title]), y && T("div", {
        key: "subtitle",
        class: "v-stepper-item__subtitle"
      }, [((x = n.subtitle) == null ? void 0 : x.call(n, m.value)) ?? e.subtitle]), (_ = n.default) == null ? void 0 : _.call(n, m.value)])]), [[Ci("ripple"), e.ripple && e.editable, null]]);
    }), {};
  }
}), lD = (e) => {
  const {
    touchstartX: t,
    touchendX: n,
    touchstartY: i,
    touchendY: r
  } = e, o = 0.5, a = 16;
  e.offsetX = n - t, e.offsetY = r - i, Math.abs(e.offsetY) < o * Math.abs(e.offsetX) && (e.left && n < t - a && e.left(e), e.right && n > t + a && e.right(e)), Math.abs(e.offsetX) < o * Math.abs(e.offsetY) && (e.up && r < i - a && e.up(e), e.down && r > i + a && e.down(e));
};
function uD(e, t) {
  var i;
  const n = e.changedTouches[0];
  t.touchstartX = n.clientX, t.touchstartY = n.clientY, (i = t.start) == null || i.call(t, {
    originalEvent: e,
    ...t
  });
}
function cD(e, t) {
  var i;
  const n = e.changedTouches[0];
  t.touchendX = n.clientX, t.touchendY = n.clientY, (i = t.end) == null || i.call(t, {
    originalEvent: e,
    ...t
  }), lD(t);
}
function dD(e, t) {
  var i;
  const n = e.changedTouches[0];
  t.touchmoveX = n.clientX, t.touchmoveY = n.clientY, (i = t.move) == null || i.call(t, {
    originalEvent: e,
    ...t
  });
}
function fD() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const t = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: e.left,
    right: e.right,
    up: e.up,
    down: e.down,
    start: e.start,
    move: e.move,
    end: e.end
  };
  return {
    touchstart: (n) => uD(n, t),
    touchend: (n) => cD(n, t),
    touchmove: (n) => dD(n, t)
  };
}
function hD(e, t) {
  var l;
  const n = t.value, i = n != null && n.parent ? e.parentElement : e, r = (n == null ? void 0 : n.options) ?? {
    passive: !0
  }, o = (l = t.instance) == null ? void 0 : l.$.uid;
  if (!i || !o)
    return;
  const a = fD(t.value);
  i._touchHandlers = i._touchHandlers ?? /* @__PURE__ */ Object.create(null), i._touchHandlers[o] = a, Ab(a).forEach((u) => {
    i.addEventListener(u, a[u], r);
  });
}
function gD(e, t) {
  var o, a;
  const n = (o = t.value) != null && o.parent ? e.parentElement : e, i = (a = t.instance) == null ? void 0 : a.$.uid;
  if (!(n != null && n._touchHandlers) || !i)
    return;
  const r = n._touchHandlers[i];
  Ab(r).forEach((l) => {
    n.removeEventListener(l, r[l]);
  }), delete n._touchHandlers[i];
}
const Q1 = {
  mounted: hD,
  unmounted: gD
}, mD = Q1, J1 = Symbol.for("vuetify:v-window"), ew = Symbol.for("vuetify:v-window-group"), tw = le({
  continuous: Boolean,
  nextIcon: {
    type: [Boolean, String, Function, Object],
    default: "$next"
  },
  prevIcon: {
    type: [Boolean, String, Function, Object],
    default: "$prev"
  },
  reverse: Boolean,
  showArrows: {
    type: [Boolean, String],
    validator: (e) => typeof e == "boolean" || e === "hover"
  },
  touch: {
    type: [Object, Boolean],
    default: void 0
  },
  direction: {
    type: String,
    default: "horizontal"
  },
  modelValue: null,
  disabled: Boolean,
  selectedClass: {
    type: String,
    default: "v-window-item--active"
  },
  // TODO: mandatory should probably not be exposed but do this for now
  mandatory: {
    type: [Boolean, String],
    default: "force"
  },
  ...Xe(),
  ...Bt(),
  ...Mt()
}, "VWindow"), ky = ye()({
  name: "VWindow",
  directives: {
    Touch: Q1
  },
  props: tw(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: i
    } = Wt(e), {
      isRtl: r
    } = Xr(), {
      t: o
    } = tn(), a = Fa(e, ew), l = ie(), u = B(() => r.value ? !e.reverse : e.reverse), d = Pe(!1), f = B(() => {
      const D = e.direction === "vertical" ? "y" : "x", $ = (u.value ? !d.value : d.value) ? "-reverse" : "";
      return `v-window-${D}${$}-transition`;
    }), m = Pe(0), h = ie(void 0), v = B(() => a.items.value.findIndex((D) => a.selected.value.includes(D.id)));
    pe(v, (D, F) => {
      const $ = a.items.value.length, A = $ - 1;
      $ <= 2 ? d.value = D < F : D === A && F === 0 ? d.value = !0 : D === 0 && F === A ? d.value = !1 : d.value = D < F;
    }), sn(J1, {
      transition: f,
      isReversed: d,
      transitionCount: m,
      transitionHeight: h,
      rootRef: l
    });
    const y = B(() => e.continuous || v.value !== 0), p = B(() => e.continuous || v.value !== a.items.value.length - 1);
    function b() {
      y.value && a.prev();
    }
    function x() {
      p.value && a.next();
    }
    const _ = B(() => {
      const D = [], F = {
        icon: r.value ? e.nextIcon : e.prevIcon,
        class: `v-window__${u.value ? "right" : "left"}`,
        onClick: a.prev,
        "aria-label": o("$vuetify.carousel.prev")
      };
      D.push(y.value ? n.prev ? n.prev({
        props: F
      }) : T(In, F, null) : T("div", null, null));
      const $ = {
        icon: r.value ? e.prevIcon : e.nextIcon,
        class: `v-window__${u.value ? "left" : "right"}`,
        onClick: a.next,
        "aria-label": o("$vuetify.carousel.next")
      };
      return D.push(p.value ? n.next ? n.next({
        props: $
      }) : T(In, $, null) : T("div", null, null)), D;
    }), O = B(() => e.touch === !1 ? e.touch : {
      ...{
        left: () => {
          u.value ? b() : x();
        },
        right: () => {
          u.value ? x() : b();
        },
        start: (F) => {
          let {
            originalEvent: $
          } = F;
          $.stopPropagation();
        }
      },
      ...e.touch === !0 ? {} : e.touch
    });
    return Oe(() => Nt(T(e.tag, {
      ref: l,
      class: ["v-window", {
        "v-window--show-arrows-on-hover": e.showArrows === "hover"
      }, i.value, e.class],
      style: e.style
    }, {
      default: () => {
        var D, F;
        return [T("div", {
          class: "v-window__container",
          style: {
            height: h.value
          }
        }, [(D = n.default) == null ? void 0 : D.call(n, {
          group: a
        }), e.showArrows !== !1 && T("div", {
          class: "v-window__controls"
        }, [_.value])]), (F = n.additional) == null ? void 0 : F.call(n, {
          group: a
        })];
      }
    }), [[Ci("touch"), O.value]])), {
      group: a
    };
  }
}), vD = Symbol.for("vuetify:v-stepper"), pD = le({
  ...gn(tw(), ["continuous", "nextIcon", "prevIcon", "showArrows", "touch", "mandatory"])
}, "VStepperWindow"), yD = ye()({
  name: "VStepperWindow",
  props: pD(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = ht(vD, null), r = rt(e, "modelValue"), o = B({
      get() {
        var a;
        return r.value != null || !i ? r.value : (a = i.items.value.find((l) => i.selected.value.includes(l.id))) == null ? void 0 : a.value;
      },
      set(a) {
        r.value = a;
      }
    });
    return Oe(() => {
      const a = ky.filterProps(e);
      return T(ky, ge({
        _as: "VStepperWindow"
      }, a, {
        modelValue: o.value,
        "onUpdate:modelValue": (l) => o.value = l,
        class: ["v-stepper-window", e.class],
        style: e.style,
        mandatory: !1,
        touch: !1
      }), n);
    }), {};
  }
});
function nw() {
  const e = Pe(!1);
  return mn(() => {
    window.requestAnimationFrame(() => {
      e.value = !0;
    });
  }), {
    ssrBootStyles: B(() => e.value ? void 0 : {
      transition: "none !important"
    }),
    isBooted: Nh(e)
  };
}
const iw = le({
  reverseTransition: {
    type: [Boolean, String],
    default: void 0
  },
  transition: {
    type: [Boolean, String],
    default: void 0
  },
  ...Xe(),
  ...ol(),
  ...fg()
}, "VWindowItem"), Sy = ye()({
  name: "VWindowItem",
  directives: {
    Touch: mD
  },
  props: iw(),
  emits: {
    "group:selected": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = ht(J1), r = al(e, ew), {
      isBooted: o
    } = nw();
    if (!i || !r)
      throw new Error("[Vuetify] VWindowItem must be used inside VWindow");
    const a = Pe(!1), l = B(() => o.value && (i.isReversed.value ? e.reverseTransition !== !1 : e.transition !== !1));
    function u() {
      !a.value || !i || (a.value = !1, i.transitionCount.value > 0 && (i.transitionCount.value -= 1, i.transitionCount.value === 0 && (i.transitionHeight.value = void 0)));
    }
    function d() {
      var y;
      a.value || !i || (a.value = !0, i.transitionCount.value === 0 && (i.transitionHeight.value = ze((y = i.rootRef.value) == null ? void 0 : y.clientHeight)), i.transitionCount.value += 1);
    }
    function f() {
      u();
    }
    function m(y) {
      a.value && gt(() => {
        !l.value || !a.value || !i || (i.transitionHeight.value = ze(y.clientHeight));
      });
    }
    const h = B(() => {
      const y = i.isReversed.value ? e.reverseTransition : e.transition;
      return l.value ? {
        name: typeof y != "string" ? i.transition.value : y,
        onBeforeEnter: d,
        onAfterEnter: u,
        onEnterCancelled: f,
        onBeforeLeave: d,
        onAfterLeave: u,
        onLeaveCancelled: f,
        onEnter: m
      } : !1;
    }), {
      hasContent: v
    } = hg(e, r.isSelected);
    return Oe(() => T(Si, {
      transition: h.value,
      disabled: !o.value
    }, {
      default: () => {
        var y;
        return [Nt(T("div", {
          class: ["v-window-item", r.selectedClass.value, e.class],
          style: e.style
        }, [v.value && ((y = n.default) == null ? void 0 : y.call(n))]), [[Ri, r.isSelected.value]])];
      }
    })), {
      groupItem: r
    };
  }
}), bD = le({
  ...iw()
}, "VStepperWindowItem"), wD = ye()({
  name: "VStepperWindowItem",
  props: bD(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return Oe(() => {
      const i = Sy.filterProps(e);
      return T(Sy, ge({
        _as: "VStepperWindowItem"
      }, i, {
        class: ["v-stepper-window-item", e.class],
        style: e.style
      }), n);
    }), {};
  }
}), rw = Symbol.for("vuetify:v-stepper"), _D = le({
  altLabels: Boolean,
  bgColor: String,
  editable: Boolean,
  hideActions: Boolean,
  items: {
    type: Array,
    default: () => []
  },
  itemTitle: {
    type: String,
    default: "title"
  },
  itemValue: {
    type: String,
    default: "value"
  },
  mobile: Boolean,
  nonLinear: Boolean,
  flat: Boolean
}, "Stepper"), xD = le({
  ..._D(),
  ...rl({
    mandatory: "force",
    selectedClass: "v-stepper-item--selected"
  }),
  ...dg(),
  ...Ib(Z1(), ["prevText", "nextText"])
}, "VStepper"), u7 = ye()({
  name: "VStepper",
  props: xD(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      items: i,
      next: r,
      prev: o,
      selected: a
    } = Fa(e, rw), {
      color: l,
      editable: u,
      prevText: d,
      nextText: f
    } = Bo(e), m = B(() => e.items.map((y, p) => {
      const b = hi(y, e.itemTitle, y), x = hi(y, e.itemValue, p + 1);
      return {
        title: b,
        value: x,
        raw: y
      };
    })), h = B(() => i.value.findIndex((y) => a.value.includes(y.id))), v = B(() => e.disabled ? e.disabled : h.value === 0 ? "prev" : h.value === i.value.length - 1 ? "next" : !1);
    return Gr({
      VStepperItem: {
        editable: u,
        prevText: d,
        nextText: f
      },
      VStepperActions: {
        color: l,
        disabled: v,
        prevText: d,
        nextText: f
      }
    }), Oe(() => {
      const y = ic.filterProps(e), p = !!(n.header || e.items.length), b = e.items.length > 0, x = !e.hideActions && !!(b || n.actions);
      return T(ic, ge(y, {
        color: e.bgColor,
        class: ["v-stepper", {
          "v-stepper--alt-labels": e.altLabels,
          "v-stepper--flat": e.flat,
          "v-stepper--non-linear": e.nonLinear,
          "v-stepper--mobile": e.mobile
        }, e.class],
        style: e.style
      }), {
        default: () => {
          var _, O;
          return [p && T(rD, {
            key: "stepper-header"
          }, {
            default: () => [m.value.map((D, F) => {
              let {
                raw: $,
                ...A
              } = D;
              return T(qe, null, [!!F && T(U1, null, null), T(sD, A, {
                default: n[`header-item.${A.value}`] ?? n.header,
                icon: n.icon,
                title: n.title,
                subtitle: n.subtitle
              })]);
            })]
          }), b && T(yD, {
            key: "stepper-window"
          }, {
            default: () => [m.value.map((D) => T(wD, {
              value: D.value
            }, {
              default: () => {
                var F, $;
                return ((F = n[`item.${D.value}`]) == null ? void 0 : F.call(n, D)) ?? (($ = n.item) == null ? void 0 : $.call(n, D));
              }
            }))]
          }), (_ = n.default) == null ? void 0 : _.call(n, {
            prev: o,
            next: r
          }), x && (((O = n.actions) == null ? void 0 : O.call(n, {
            next: r,
            prev: o
          })) ?? T(iD, {
            key: "stepper-actions",
            "onClick:prev": o,
            "onClick:next": r
          }, n))];
        }
      });
    }), {
      prev: o,
      next: r
    };
  }
}), kD = le({
  withBackground: Boolean,
  ...Xe(),
  ...Mt(),
  ...Bt()
}, "VThemeProvider"), c7 = ye()({
  name: "VThemeProvider",
  props: kD(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: i
    } = Wt(e);
    return () => {
      var r;
      return e.withBackground ? T(e.tag, {
        class: ["v-theme-provider", i.value, e.class],
        style: e.style
      }, {
        default: () => {
          var o;
          return [(o = n.default) == null ? void 0 : o.call(n)];
        }
      }) : (r = n.default) == null ? void 0 : r.call(n);
    };
  }
}), SD = le({
  id: String,
  text: String,
  ...gn(ll({
    closeOnBack: !1,
    location: "end",
    locationStrategy: "connected",
    eager: !0,
    minWidth: 0,
    offset: 10,
    openOnClick: !1,
    openOnHover: !0,
    origin: "auto",
    scrim: !1,
    scrollStrategy: "reposition",
    transition: !1
  }), ["absolute", "persistent"])
}, "VTooltip"), d7 = ye()({
  name: "VTooltip",
  props: SD(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = rt(e, "modelValue"), {
      scopeId: r
    } = sl(), o = qn(), a = B(() => e.id || `v-tooltip-${o}`), l = ie(), u = B(() => e.location.split(" ").length > 1 ? e.location : e.location + " center"), d = B(() => e.origin === "auto" || e.origin === "overlap" || e.origin.split(" ").length > 1 || e.location.split(" ").length > 1 ? e.origin : e.origin + " center"), f = B(() => e.transition ? e.transition : i.value ? "scale-transition" : "fade-transition"), m = B(() => ge({
      "aria-describedby": a.value
    }, e.activatorProps));
    return Oe(() => {
      const h = Yr.filterProps(e);
      return T(Yr, ge({
        ref: l,
        class: ["v-tooltip", e.class],
        style: e.style,
        id: a.value
      }, h, {
        modelValue: i.value,
        "onUpdate:modelValue": (v) => i.value = v,
        transition: f.value,
        absolute: !0,
        location: u.value,
        origin: d.value,
        persistent: !0,
        role: "tooltip",
        activatorProps: m.value,
        _disableGlobalStack: !0
      }, r), {
        activator: n.activator,
        default: function() {
          var b;
          for (var v = arguments.length, y = new Array(v), p = 0; p < v; p++)
            y[p] = arguments[p];
          return ((b = n.default) == null ? void 0 : b.call(n, ...y)) ?? e.text;
        }
      });
    }), Qr({}, l);
  }
}), CD = (e, t, n) => {
  const i = e[t];
  return i ? typeof i == "function" ? i() : Promise.resolve(i) : new Promise((r, o) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(o.bind(null, new Error("Unknown variable dynamic import: " + t + (t.split("/").length !== n ? ". Note that variables only represent file names one level deep." : ""))));
  });
}, OD = {
  name: "OtIcon",
  customOptions: {}
}, qt = /* @__PURE__ */ Ae({
  ...OD,
  props: {
    name: { type: String, required: !0 },
    flag: { type: Boolean, default: !1 },
    tag: { type: String, default: "i" },
    inheritFill: { type: Boolean, default: !1 },
    inheritStroke: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = ie();
    return (async () => {
      const r = t.flag ? `flag-${t.name}` : t.name, { default: o } = await CD(/* @__PURE__ */ Object.assign({ "./ot-icons/3square.svg": () => import("./3square-RYPKbQHP.js"), "./ot-icons/add-square.svg": () => import("./add-square-Dw23pLaU.js"), "./ot-icons/add.svg": () => import("./add-B0yjm8Nl.js"), "./ot-icons/arrow-3.svg": () => import("./arrow-3-bvIUagP7.js"), "./ot-icons/arrow-down.svg": () => import("./arrow-down-B-a49Tmg.js"), "./ot-icons/arrow-left.svg": () => import("./arrow-left-ClxQrNJx.js"), "./ot-icons/arrow-right.svg": () => import("./arrow-right-D4lIgBb7.js"), "./ot-icons/arrow-swap-horizontal.svg": () => import("./arrow-swap-horizontal-C0Xceisn.js"), "./ot-icons/arrow-up.svg": () => import("./arrow-up-dEqi3Qyc.js"), "./ot-icons/bank.svg": () => import("./bank-CQ_UW5nh.js"), "./ot-icons/bitcoin.svg": () => import("./bitcoin-B2GPwLYy.js"), "./ot-icons/book.svg": () => import("./book-BIFEUsky.js"), "./ot-icons/bookmark-bold.svg": () => import("./bookmark-bold-D5I49jo4.js"), "./ot-icons/bookmark.svg": () => import("./bookmark-BonMEhHH.js"), "./ot-icons/calendar-tick.svg": () => import("./calendar-tick-C7q_YOwv.js"), "./ot-icons/calendar.svg": () => import("./calendar-WOKtASgV.js"), "./ot-icons/cancel.svg": () => import("./cancel-DuBKRSaR.js"), "./ot-icons/candle-hollow.svg": () => import("./candle-hollow-Cx5ciwrb.js"), "./ot-icons/candle.svg": () => import("./candle-CNR0Owv8.js"), "./ot-icons/chart.svg": () => import("./chart-D-zisMy3.js"), "./ot-icons/checkmark.svg": () => import("./checkmark-ChXv-rNv.js"), "./ot-icons/close-circle-bulk.svg": () => import("./close-circle-bulk-C5XUl0U7.js"), "./ot-icons/close-square.svg": () => import("./close-square-D-cAGrdE.js"), "./ot-icons/close.svg": () => import("./close-CzeK2MhZ.js"), "./ot-icons/copy.svg": () => import("./copy-BQ2yNem-.js"), "./ot-icons/credit-card.svg": () => import("./credit-card-BwF-8ESW.js"), "./ot-icons/danger-hollow.svg": () => import("./danger-hollow-BanHrYNz.js"), "./ot-icons/danger.svg": () => import("./danger-ChHZZNbd.js"), "./ot-icons/down.svg": () => import("./down-BWQ1rQob.js"), "./ot-icons/download.svg": () => import("./download-DSbMRyPs.js"), "./ot-icons/edit.svg": () => import("./edit-Co1qH3Ca.js"), "./ot-icons/export.svg": () => import("./export-DcGPchNb.js"), "./ot-icons/eye-slash.svg": () => import("./eye-slash-DKUI0NKQ.js"), "./ot-icons/eye.svg": () => import("./eye-DIcm-F1w.js"), "./ot-icons/face.svg": () => import("./face--wRSNB24.js"), "./ot-icons/file-text.svg": () => import("./file-text-DXakpA-l.js"), "./ot-icons/fingerprint.svg": () => import("./fingerprint-BEf5jPWh.js"), "./ot-icons/flag-de.svg": () => import("./flag-de-DZS4R0D-.js"), "./ot-icons/flag-uk.svg": () => import("./flag-uk-C3u3b_rx.js"), "./ot-icons/full-arrow-down.svg": () => import("./full-arrow-down-CYI5ilrw.js"), "./ot-icons/full-arrow-up.svg": () => import("./full-arrow-up-CEeMABCa.js"), "./ot-icons/global.svg": () => import("./global-Cg9HYNvj.js"), "./ot-icons/info-circle-bulk.svg": () => import("./info-circle-bulk-njcZcICz.js"), "./ot-icons/info-circle.svg": () => import("./info-circle-7ibkN6x8.js"), "./ot-icons/info-outlined.svg": () => import("./info-outlined-BlkRgKOw.js"), "./ot-icons/instant-solid.svg": () => import("./instant-solid-DwwJ2O2g.js"), "./ot-icons/instant.svg": () => import("./instant-DoI4QMgf.js"), "./ot-icons/iris.svg": () => import("./iris-DYvyu6b9.js"), "./ot-icons/layer.svg": () => import("./layer-uASJkeL8.js"), "./ot-icons/lightning-bolt.svg": () => import("./lightning-bolt-Cc1ZzXV1.js"), "./ot-icons/lock-circle.svg": () => import("./lock-circle-BPIagp4Y.js"), "./ot-icons/logout.svg": () => import("./logout-CJJl3nDe.js"), "./ot-icons/markets.svg": () => import("./markets-BX0ZYrOF.js"), "./ot-icons/medal-star.svg": () => import("./medal-star-DTJW36js.js"), "./ot-icons/minus-square.svg": () => import("./minus-square-CnJB5zYv.js"), "./ot-icons/more.svg": () => import("./more-DA1tu3E2.js"), "./ot-icons/next.svg": () => import("./next-BMfgv2Wd.js"), "./ot-icons/note-text.svg": () => import("./note-text-COT2S6NP.js"), "./ot-icons/notification.svg": () => import("./notification-C755tOEG.js"), "./ot-icons/previous.svg": () => import("./previous-CPsCnLV-.js"), "./ot-icons/received.svg": () => import("./received-Bh2qVf4u.js"), "./ot-icons/refresh-2.svg": () => import("./refresh-2-B9BCJ9S-.js"), "./ot-icons/refresh.svg": () => import("./refresh-DMSeOC7v.js"), "./ot-icons/repeat.svg": () => import("./repeat-BB2e8JZn.js"), "./ot-icons/row-vertical-bold.svg": () => import("./row-vertical-bold-DsXCxNGN.js"), "./ot-icons/row-vertical.svg": () => import("./row-vertical-BYXClebx.js"), "./ot-icons/search-normal.svg": () => import("./search-normal-UMWM41_q.js"), "./ot-icons/send-sqaure-2.svg": () => import("./send-sqaure-2-D9UsV4Xl.js"), "./ot-icons/send.svg": () => import("./send-D_tv2DVc.js"), "./ot-icons/setting.svg": () => import("./setting-xBFWUU5S.js"), "./ot-icons/slider-horizontal.svg": () => import("./slider-horizontal-Dg_Q5-72.js"), "./ot-icons/tick-circle-bulk.svg": () => import("./tick-circle-bulk-CACALklt.js"), "./ot-icons/trash.svg": () => import("./trash-D47v-26N.js"), "./ot-icons/trend-up.svg": () => import("./trend-up-DQyQthq9.js"), "./ot-icons/up.svg": () => import("./up-Ba7xm2_A.js"), "./ot-icons/user-octagon-bold.svg": () => import("./user-octagon-bold-DSEdYBLx.js"), "./ot-icons/user-octagon.svg": () => import("./user-octagon-CXQP5RC9.js"), "./ot-icons/user-square.svg": () => import("./user-square-DvjHQMSw.js"), "./ot-icons/verify.svg": () => import("./verify-BhT3Fg6u.js") }), `./ot-icons/${r}.svg`, 3);
      n.value = await fetch(o).then((a) => a.text()).catch(() => {
      });
    })(), (r, o) => (ee(), Ne(sr(e.tag), {
      class: we(["ot-icon", `ot-icon--${e.name}`, { "ot-icon--inherit-stroke": e.inheritStroke, "ot-icon--inherit-fill": e.inheritFill }]),
      innerHTML: n.value
    }, null, 8, ["class", "innerHTML"]));
  }
}), MD = {
  name: "OtTransitionFade",
  customOptions: {}
}, Bc = /* @__PURE__ */ Ae({
  ...MD,
  props: {
    duration: { type: [Number, Object], default: 300 }
  },
  emits: ["onEnter", "onLeave"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = (a) => {
      let l;
      typeof n.duration == "number" ? l = n.duration : l = n.duration.enter, a.style.transitionDuration = `${l}ms`, i("onEnter", a);
    }, o = (a) => {
      let l;
      typeof n.duration == "number" ? l = n.duration : l = n.duration.leave, a && (a.style.transitionDuration = `${l}ms`, i("onLeave", a));
    };
    return (a, l) => (ee(), Ne(hn, ge({
      mode: "out-in",
      name: "ot-transition-fade"
    }, a.$attrs, {
      onEnter: l[0] || (l[0] = (u) => r(a.$el)),
      onBeforeLeave: l[1] || (l[1] = (u) => o(a.$el))
    }), {
      default: Ye(() => [
        De(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), TD = ["onClick"], PD = { class: "cell-title" }, AD = {
  name: "OtGridTable",
  customOptions: {}
}, gg = /* @__PURE__ */ Ae({
  ...AD,
  props: {
    columns: { type: Array, required: !0 },
    data: { type: Array, required: !0 },
    headerClass: { type: String, default: "" },
    narrow: { type: Boolean, default: !1 },
    stickyHeader: { type: Boolean, default: !1 },
    withEmptyMessage: { type: Boolean, default: !1 }
  },
  emits: ["input", "click:column"],
  setup(e, { emit: t }) {
    const n = e, i = t, { t: r } = tn(), o = "ot-grid-table", a = B(() => [
      o,
      {
        [`${o}--narrow`]: n.narrow,
        [`${o}--sticky-header`]: n.stickyHeader
      }
    ]), l = B(() => r("$vuetify.table.noRecords")), u = ie(n.columns);
    pe(
      () => n.columns,
      (p) => {
        u.value = p;
      }
    );
    const d = B(() => f.value ? n.data.map((b) => b).sort((b, x) => {
      var _;
      return !f.value || !((_ = f.value) != null && _.sortFunction) ? 1 : f.value.reversed ? f.value.sortFunction(x, b) : f.value.sortFunction(b, x);
    }) : n.data), f = B(() => u.value ? u.value.find((p) => p.sorted) : null), m = (p) => ({
      [p.class]: !0,
      sorted: p.sorted,
      sortable: p.sortable
    }), h = (p) => {
      var x;
      if (i("click:column", p), !p.sortFunction)
        return;
      const b = (x = u.value) == null ? void 0 : x.map((_) => {
        const O = _;
        return p === O ? (O.sorted = !0, f.value && (O.reversed = !O.reversed)) : O.sorted = !1, O;
      });
      u.value = b;
    }, v = ie(), y = ie(0);
    return mn(() => {
      y.value = v.value.getBoundingClientRect().height;
    }), (p, b) => (ee(), ce("div", {
      class: we(a.value),
      style: Do(`--grid-table-column-number:${e.columns.length}; --grid-table-header-height: ${y.value}px`)
    }, [
      ve("div", {
        ref_key: "gridTableHeaderEl",
        ref: v,
        class: we({ [`${o}__header`]: !0, [e.headerClass]: e.headerClass })
      }, [
        (ee(!0), ce(qe, null, Dn(u.value, (x) => (ee(), ce("div", {
          key: x.internalId,
          class: we([{ [`${o}__header-cell`]: !0 }, m(x)]),
          onClick: (_) => h(x)
        }, [
          T(Bc, null, {
            default: Ye(() => [
              x.sortable ? (ee(), Ne(qt, {
                key: 0,
                class: we(["sort-icon", { "sort-down": x.reversed }]),
                "inherit-stroke": !0,
                name: x.sorted ? "full-arrow-up" : "arrow-3"
              }, null, 8, ["name", "class"])) : Fe("", !0)
            ]),
            _: 2
          }, 1024),
          ve("div", PD, Ue(x.title), 1),
          x.toggleable ? (ee(), Ne(qt, {
            key: 0,
            class: "sort-icon sort-icon--toggleable",
            name: "repeat",
            "inherit-stroke": !0
          })) : Fe("", !0)
        ], 10, TD))), 128))
      ], 2),
      e.withEmptyMessage && !e.data.length ? (ee(), ce("div", {
        key: 0,
        class: we([`${o}__info`])
      }, [
        T(qt, {
          name: "layer",
          "inherit-stroke": !0,
          class: we([`${o}__info-icon`])
        }, null, 8, ["class"]),
        ve("div", null, Ue(l.value), 1)
      ], 2)) : (ee(), ce("div", {
        key: 1,
        class: we({ [`${o}__table-container`]: !0 })
      }, [
        ve("div", {
          class: we({ [`${o}__body`]: !0 })
        }, [
          De(p.$slots, "default", zt(Qt(d.value)))
        ], 2),
        De(p.$slots, "footer", zt(Qt({ defaultClass: `${o}__footer` })))
      ], 2))
    ], 6));
  }
});
var or = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ED(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ID = typeof or == "object" && or && or.Object === Object && or, DD = ID, LD = DD, BD = typeof self == "object" && self && self.Object === Object && self, VD = LD || BD || Function("return this")(), $D = VD, RD = $D, FD = RD.Symbol, ow = FD, Cy = ow, aw = Object.prototype, ND = aw.hasOwnProperty, WD = aw.toString, us = Cy ? Cy.toStringTag : void 0;
function zD(e) {
  var t = ND.call(e, us), n = e[us];
  try {
    e[us] = void 0;
    var i = !0;
  } catch {
  }
  var r = WD.call(e);
  return i && (t ? e[us] = n : delete e[us]), r;
}
var HD = zD, jD = Object.prototype, YD = jD.toString;
function UD(e) {
  return YD.call(e);
}
var qD = UD, Oy = ow, GD = HD, XD = qD, KD = "[object Null]", ZD = "[object Undefined]", My = Oy ? Oy.toStringTag : void 0;
function QD(e) {
  return e == null ? e === void 0 ? ZD : KD : My && My in Object(e) ? GD(e) : XD(e);
}
var JD = QD;
function eL(e) {
  return e != null && typeof e == "object";
}
var tL = eL, nL = JD, iL = tL, rL = "[object Boolean]";
function oL(e) {
  return e === !0 || e === !1 || iL(e) && nL(e) == rL;
}
var aL = oL;
const sL = /* @__PURE__ */ ED(aL), lL = {
  name: "OtSpinner",
  customOptions: {}
}, Na = /* @__PURE__ */ Ae({
  ...lL,
  props: {
    variant: { type: String, default: "absolute" }
  },
  setup(e) {
    return (t, n) => (ee(), ce("div", {
      class: we(["ot-spinner", `ot-spinner--${e.variant}`])
    }, [
      (ee(), ce(qe, null, Dn([1, 2, 3, 4, 5], (i) => ve("div", {
        key: i,
        class: we(`bounce-${i}`)
      }, null, 2)), 64))
    ], 2));
  }
}), uL = { class: "ot-loading-indicator" }, cL = {
  name: "OtLoadingIndicator",
  customOptions: {}
}, Vc = /* @__PURE__ */ Ae({
  ...cL,
  props: {
    contentClass: { type: String, required: !1 },
    spinnerClass: { type: String, required: !1 },
    until: { type: [Promise, Boolean, Function] }
  },
  setup(e) {
    const t = e, n = ie(!0), i = () => {
      t.until().finally(() => {
        n.value = !1;
      });
    }, r = () => {
      n.value = t.until, pe(
        () => t.until,
        (o) => {
          n.value = o;
        }
      );
    };
    return sL(t.until) ? r() : i(), (o, a) => (ee(), ce("div", uL, [
      n.value ? (ee(), Ne(Na, {
        key: 0,
        class: we(e.spinnerClass)
      }, null, 8, ["class"])) : Fe("", !0),
      n.value ? Fe("", !0) : (ee(), ce("div", {
        key: 1,
        class: we(["real-content", e.contentClass])
      }, [
        De(o.$slots, "default")
      ], 2))
    ]));
  }
}), dL = () => "ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch, mg = (e, t) => e ? {
  el: "span"
} : {
  el: "a",
  attrs: {
    target: "_blank",
    rel: "noopener noreferrer",
    href: t,
    style: "text-decoration: none;"
  }
}, fL = {
  name: "OtButton",
  customOptions: {}
}, Ef = {
  base: "base",
  primary: "primary",
  secondary: "secondary",
  outline: "outline",
  "dark-outline": "dark-outline",
  clear: "clear",
  link: "link",
  tertiary: "tertiary",
  nav: "nav",
  success: "success",
  error: "error",
  "underlined-primary": "underlined-primary",
  "underlined-secondary": "underlined-secondary",
  "underlined-success": "underlined-success",
  "underlined-error": "underlined-error"
}, hL = {
  "3xs": "3xs",
  "2xs": "2xs",
  xs: "xs",
  sm: "sm",
  md: "md",
  lg: "lg",
  xl: "xl",
  "2xl": "2xl",
  "text-like": "text-like"
}, f7 = {
  zero: "zero",
  xs: "xs",
  sm: "sm",
  null: "null",
  lg: "lg",
  xl: "xl",
  pill: "pill",
  circle: "circle"
}, Ur = /* @__PURE__ */ Ae({
  ...fL,
  props: {
    activeNav: { type: Boolean, default: !1 },
    block: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    href: { type: String, required: !1 },
    hrefCustomIcon: { type: Object, required: !1 },
    loading: { type: Boolean, default: !1 },
    round: { type: Boolean, default: !1 },
    isNative: { type: Boolean, default: !1 },
    rounded: { type: String, default: "null" },
    size: { type: String, default: "md" },
    text: { type: String, required: !1 },
    to: { type: [String, Object], required: !1 },
    uniqueId: { type: String, default: () => `ot-button-${crypto.randomUUID()}` },
    variant: { type: String, default: "base" }
  },
  emits: ["click", "native-open-link"],
  setup(e, { emit: t }) {
    const n = e, i = t, { href: r } = Bo(n), o = dL() ? "touch-screen" : "not-touch-screen", a = B(() => {
      const f = () => n.disabled ? { disabled: !0 } : {}, m = () => n.loading ? { loading: !0 } : {};
      if (n.to)
        return {
          el: "router-link",
          attrs: {
            id: n.uniqueId,
            to: n.to,
            ...f(),
            ...m()
          }
        };
      if ((r == null ? void 0 : r.value) !== void 0 && typeof r.value == "string") {
        const h = mg(n.isNative, r.value);
        return {
          el: h.el,
          attrs: h.attrs ? {
            id: n.uniqueId,
            ...h.attrs
          } : {
            id: n.uniqueId
          }
        };
      }
      return {
        el: "button",
        attrs: {
          id: n.uniqueId,
          type: "button",
          ...f(),
          ...m()
        }
      };
    }), l = "ot-button", u = B(() => [
      l,
      o,
      n.variant ? `${l}--${n.variant}` : `${l}--${Ef.base}`,
      n.size ? `${l}--${n.size}` : `${l}--${hL.md}`,
      {
        [`${l}--block`]: n.block
      },
      n.rounded ? `ot-button--rounded-${n.rounded}` : "ot-button--rounded",
      {
        [`ot-button--${Ef.nav}--active`]: n.variant === Ef.nav && n.activeNav
      }
    ]), d = (f) => {
      n.disabled || (n.href && n.isNative && i("native-open-link"), i("click", f));
    };
    return (f, m) => (ee(), Ne(sr(a.value.el), ge(a.value.attrs, {
      class: u.value,
      tabindex: "0",
      onClick: d
    }), {
      default: Ye(() => [
        Be(r) && e.text ? (ee(), ce(qe, { key: 0 }, [
          ve("span", null, Ue(e.text), 1),
          T(qt, ge({ "inherit-stroke": !0 }, e.hrefCustomIcon ? e.hrefCustomIcon.attrs : {}, {
            name: e.hrefCustomIcon ? e.hrefCustomIcon.name : "export",
            class: `${l}__external-icon`
          }), null, 16, ["name", "class"])
        ], 64)) : f.$slots.default ? De(f.$slots, "default", { key: 1 }) : e.text ? (ee(), ce(qe, { key: 2 }, [
          dr(Ue(e.text), 1)
        ], 64)) : Fe("", !0),
        e.loading ? (ee(), ce("div", {
          key: 3,
          class: we(`${l}__loader`)
        }, [
          T(Na)
        ], 2)) : Fe("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), gL = { class: "ot-table-error" }, mL = { class: "ot-table-error__title" }, vL = { class: "ot-table-error__message" }, pL = {
  name: "OtTableError",
  customOptions: {}
}, vg = /* @__PURE__ */ Ae({
  ...pL,
  props: {
    error: { type: String, required: !0 },
    retry: { type: Function, required: !1 },
    title: { type: String, required: !1 }
  },
  setup(e) {
    const t = e, { t: n } = tn(), i = B(() => t.title && t.title !== "undefined" ? t.title : n("$vuetify.table.error.titile")), r = B(() => n("$vuetify.table.retryButton"));
    return (o, a) => (ee(), ce("div", gL, [
      ve("h3", mL, Ue(i.value), 1),
      ve("p", vL, Ue(e.error), 1),
      e.retry ? (ee(), Ne(Ur, {
        key: 0,
        class: "ot-table-error__retry",
        size: "sm",
        text: r.value,
        onClick: e.retry
      }, null, 8, ["text", "onClick"])) : Fe("", !0)
    ]));
  }
}), yL = {
  name: "OtAsyncGridTable",
  customOptions: {}
}, sw = /* @__PURE__ */ Ae({
  ...yL,
  props: {
    columns: { type: Array, default: () => [] },
    data: { type: Array, default: () => [] },
    error: { type: [String, Object], required: !1 },
    headerClass: { type: String, required: !1 },
    loading: { type: Boolean, default: !1 },
    narrow: { type: Boolean, default: !1 },
    retry: { type: Function, required: !1 },
    stickyHeader: { type: Boolean, default: !1 },
    withEmptyMessage: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = (o, a) => {
      if (typeof a != "string" && a)
        return a[o];
      if (typeof a == "string" && o === "message")
        return a;
    }, i = B(() => n("title", t.error)), r = B(() => n("message", t.error));
    return (o, a) => r.value ? (ee(), Ne(vg, {
      key: 0,
      error: r.value,
      title: i.value,
      retry: e.retry
    }, null, 8, ["error", "title", "retry"])) : (ee(), Ne(Vc, {
      key: 1,
      until: e.loading,
      "is-black": !1
    }, {
      default: Ye(() => [
        T(gg, {
          class: "ot-async-grid-table",
          columns: e.columns,
          data: e.data,
          "header-class": e.headerClass,
          narrow: e.narrow,
          "sticky-header": e.stickyHeader,
          "with-empty-message": e.withEmptyMessage
        }, {
          default: Ye((l) => [
            De(o.$slots, "default", zt(Qt(l)))
          ]),
          footer: Ye((l) => [
            De(o.$slots, "footer", zt(Qt(l)))
          ]),
          _: 3
        }, 8, ["columns", "data", "header-class", "narrow", "sticky-header", "with-empty-message"])
      ]),
      _: 3
    }, 8, ["until"]));
  }
});
var bL = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, If = Math.ceil, di = Math.floor, An = "[BigNumber Error] ", Ty = An + "Number primitive has more than 15 significant digits: ", ki = 1e14, je = 14, Df = 9007199254740991, Lf = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], Er = 1e7, Zt = 1e9;
function lw(e) {
  var t, n, i, r = _.prototype = { constructor: _, toString: null, valueOf: null }, o = new _(1), a = 20, l = 4, u = -7, d = 21, f = -1e7, m = 1e7, h = !1, v = 1, y = 0, p = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: " ",
    // non-breaking space
    suffix: ""
  }, b = "0123456789abcdefghijklmnopqrstuvwxyz", x = !0;
  function _(k, S) {
    var M, E, I, L, N, V, z, H, W = this;
    if (!(W instanceof _))
      return new _(k, S);
    if (S == null) {
      if (k && k._isBigNumber === !0) {
        W.s = k.s, !k.c || k.e > m ? W.c = W.e = null : k.e < f ? W.c = [W.e = 0] : (W.e = k.e, W.c = k.c.slice());
        return;
      }
      if ((V = typeof k == "number") && k * 0 == 0) {
        if (W.s = 1 / k < 0 ? (k = -k, -1) : 1, k === ~~k) {
          for (L = 0, N = k; N >= 10; N /= 10, L++)
            ;
          L > m ? W.c = W.e = null : (W.e = L, W.c = [k]);
          return;
        }
        H = String(k);
      } else {
        if (!bL.test(H = String(k)))
          return i(W, H, V);
        W.s = H.charCodeAt(0) == 45 ? (H = H.slice(1), -1) : 1;
      }
      (L = H.indexOf(".")) > -1 && (H = H.replace(".", "")), (N = H.search(/e/i)) > 0 ? (L < 0 && (L = N), L += +H.slice(N + 1), H = H.substring(0, N)) : L < 0 && (L = H.length);
    } else {
      if (St(S, 2, b.length, "Base"), S == 10 && x)
        return W = new _(k), $(W, a + W.e + 1, l);
      if (H = String(k), V = typeof k == "number") {
        if (k * 0 != 0)
          return i(W, H, V, S);
        if (W.s = 1 / k < 0 ? (H = H.slice(1), -1) : 1, _.DEBUG && H.replace(/^0\.0*|\./, "").length > 15)
          throw Error(Ty + k);
      } else
        W.s = H.charCodeAt(0) === 45 ? (H = H.slice(1), -1) : 1;
      for (M = b.slice(0, S), L = N = 0, z = H.length; N < z; N++)
        if (M.indexOf(E = H.charAt(N)) < 0) {
          if (E == ".") {
            if (N > L) {
              L = z;
              continue;
            }
          } else if (!I && (H == H.toUpperCase() && (H = H.toLowerCase()) || H == H.toLowerCase() && (H = H.toUpperCase()))) {
            I = !0, N = -1, L = 0;
            continue;
          }
          return i(W, String(k), V, S);
        }
      V = !1, H = n(H, S, 10, W.s), (L = H.indexOf(".")) > -1 ? H = H.replace(".", "") : L = H.length;
    }
    for (N = 0; H.charCodeAt(N) === 48; N++)
      ;
    for (z = H.length; H.charCodeAt(--z) === 48; )
      ;
    if (H = H.slice(N, ++z)) {
      if (z -= N, V && _.DEBUG && z > 15 && (k > Df || k !== di(k)))
        throw Error(Ty + W.s * k);
      if ((L = L - N - 1) > m)
        W.c = W.e = null;
      else if (L < f)
        W.c = [W.e = 0];
      else {
        if (W.e = L, W.c = [], N = (L + 1) % je, L < 0 && (N += je), N < z) {
          for (N && W.c.push(+H.slice(0, N)), z -= je; N < z; )
            W.c.push(+H.slice(N, N += je));
          N = je - (H = H.slice(N)).length;
        } else
          N -= z;
        for (; N--; H += "0")
          ;
        W.c.push(+H);
      }
    } else
      W.c = [W.e = 0];
  }
  _.clone = lw, _.ROUND_UP = 0, _.ROUND_DOWN = 1, _.ROUND_CEIL = 2, _.ROUND_FLOOR = 3, _.ROUND_HALF_UP = 4, _.ROUND_HALF_DOWN = 5, _.ROUND_HALF_EVEN = 6, _.ROUND_HALF_CEIL = 7, _.ROUND_HALF_FLOOR = 8, _.EUCLID = 9, _.config = _.set = function(k) {
    var S, M;
    if (k != null)
      if (typeof k == "object") {
        if (k.hasOwnProperty(S = "DECIMAL_PLACES") && (M = k[S], St(M, 0, Zt, S), a = M), k.hasOwnProperty(S = "ROUNDING_MODE") && (M = k[S], St(M, 0, 8, S), l = M), k.hasOwnProperty(S = "EXPONENTIAL_AT") && (M = k[S], M && M.pop ? (St(M[0], -Zt, 0, S), St(M[1], 0, Zt, S), u = M[0], d = M[1]) : (St(M, -Zt, Zt, S), u = -(d = M < 0 ? -M : M))), k.hasOwnProperty(S = "RANGE"))
          if (M = k[S], M && M.pop)
            St(M[0], -Zt, -1, S), St(M[1], 1, Zt, S), f = M[0], m = M[1];
          else if (St(M, -Zt, Zt, S), M)
            f = -(m = M < 0 ? -M : M);
          else
            throw Error(An + S + " cannot be zero: " + M);
        if (k.hasOwnProperty(S = "CRYPTO"))
          if (M = k[S], M === !!M)
            if (M)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                h = M;
              else
                throw h = !M, Error(An + "crypto unavailable");
            else
              h = M;
          else
            throw Error(An + S + " not true or false: " + M);
        if (k.hasOwnProperty(S = "MODULO_MODE") && (M = k[S], St(M, 0, 9, S), v = M), k.hasOwnProperty(S = "POW_PRECISION") && (M = k[S], St(M, 0, Zt, S), y = M), k.hasOwnProperty(S = "FORMAT"))
          if (M = k[S], typeof M == "object")
            p = M;
          else
            throw Error(An + S + " not an object: " + M);
        if (k.hasOwnProperty(S = "ALPHABET"))
          if (M = k[S], typeof M == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(M))
            x = M.slice(0, 10) == "0123456789", b = M;
          else
            throw Error(An + S + " invalid: " + M);
      } else
        throw Error(An + "Object expected: " + k);
    return {
      DECIMAL_PLACES: a,
      ROUNDING_MODE: l,
      EXPONENTIAL_AT: [u, d],
      RANGE: [f, m],
      CRYPTO: h,
      MODULO_MODE: v,
      POW_PRECISION: y,
      FORMAT: p,
      ALPHABET: b
    };
  }, _.isBigNumber = function(k) {
    if (!k || k._isBigNumber !== !0)
      return !1;
    if (!_.DEBUG)
      return !0;
    var S, M, E = k.c, I = k.e, L = k.s;
    e:
      if ({}.toString.call(E) == "[object Array]") {
        if ((L === 1 || L === -1) && I >= -Zt && I <= Zt && I === di(I)) {
          if (E[0] === 0) {
            if (I === 0 && E.length === 1)
              return !0;
            break e;
          }
          if (S = (I + 1) % je, S < 1 && (S += je), String(E[0]).length == S) {
            for (S = 0; S < E.length; S++)
              if (M = E[S], M < 0 || M >= ki || M !== di(M))
                break e;
            if (M !== 0)
              return !0;
          }
        }
      } else if (E === null && I === null && (L === null || L === 1 || L === -1))
        return !0;
    throw Error(An + "Invalid BigNumber: " + k);
  }, _.maximum = _.max = function() {
    return D(arguments, -1);
  }, _.minimum = _.min = function() {
    return D(arguments, 1);
  }, _.random = function() {
    var k = 9007199254740992, S = Math.random() * k & 2097151 ? function() {
      return di(Math.random() * k);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(M) {
      var E, I, L, N, V, z = 0, H = [], W = new _(o);
      if (M == null ? M = a : St(M, 0, Zt), N = If(M / je), h)
        if (crypto.getRandomValues) {
          for (E = crypto.getRandomValues(new Uint32Array(N *= 2)); z < N; )
            V = E[z] * 131072 + (E[z + 1] >>> 11), V >= 9e15 ? (I = crypto.getRandomValues(new Uint32Array(2)), E[z] = I[0], E[z + 1] = I[1]) : (H.push(V % 1e14), z += 2);
          z = N / 2;
        } else if (crypto.randomBytes) {
          for (E = crypto.randomBytes(N *= 7); z < N; )
            V = (E[z] & 31) * 281474976710656 + E[z + 1] * 1099511627776 + E[z + 2] * 4294967296 + E[z + 3] * 16777216 + (E[z + 4] << 16) + (E[z + 5] << 8) + E[z + 6], V >= 9e15 ? crypto.randomBytes(7).copy(E, z) : (H.push(V % 1e14), z += 7);
          z = N / 7;
        } else
          throw h = !1, Error(An + "crypto unavailable");
      if (!h)
        for (; z < N; )
          V = S(), V < 9e15 && (H[z++] = V % 1e14);
      for (N = H[--z], M %= je, N && M && (V = Lf[je - M], H[z] = di(N / V) * V); H[z] === 0; H.pop(), z--)
        ;
      if (z < 0)
        H = [L = 0];
      else {
        for (L = -1; H[0] === 0; H.splice(0, 1), L -= je)
          ;
        for (z = 1, V = H[0]; V >= 10; V /= 10, z++)
          ;
        z < je && (L -= je - z);
      }
      return W.e = L, W.c = H, W;
    };
  }(), _.sum = function() {
    for (var k = 1, S = arguments, M = new _(S[0]); k < S.length; )
      M = M.plus(S[k++]);
    return M;
  }, n = /* @__PURE__ */ function() {
    var k = "0123456789";
    function S(M, E, I, L) {
      for (var N, V = [0], z, H = 0, W = M.length; H < W; ) {
        for (z = V.length; z--; V[z] *= E)
          ;
        for (V[0] += L.indexOf(M.charAt(H++)), N = 0; N < V.length; N++)
          V[N] > I - 1 && (V[N + 1] == null && (V[N + 1] = 0), V[N + 1] += V[N] / I | 0, V[N] %= I);
      }
      return V.reverse();
    }
    return function(M, E, I, L, N) {
      var V, z, H, W, j, U, K, te, ue = M.indexOf("."), de = a, Q = l;
      for (ue >= 0 && (W = y, y = 0, M = M.replace(".", ""), te = new _(E), U = te.pow(M.length - ue), y = W, te.c = S(
        er(ui(U.c), U.e, "0"),
        10,
        I,
        k
      ), te.e = te.c.length), K = S(M, E, I, N ? (V = b, k) : (V = k, b)), H = W = K.length; K[--W] == 0; K.pop())
        ;
      if (!K[0])
        return V.charAt(0);
      if (ue < 0 ? --H : (U.c = K, U.e = H, U.s = L, U = t(U, te, de, Q, I), K = U.c, j = U.r, H = U.e), z = H + de + 1, ue = K[z], W = I / 2, j = j || z < 0 || K[z + 1] != null, j = Q < 4 ? (ue != null || j) && (Q == 0 || Q == (U.s < 0 ? 3 : 2)) : ue > W || ue == W && (Q == 4 || j || Q == 6 && K[z - 1] & 1 || Q == (U.s < 0 ? 8 : 7)), z < 1 || !K[0])
        M = j ? er(V.charAt(1), -de, V.charAt(0)) : V.charAt(0);
      else {
        if (K.length = z, j)
          for (--I; ++K[--z] > I; )
            K[z] = 0, z || (++H, K = [1].concat(K));
        for (W = K.length; !K[--W]; )
          ;
        for (ue = 0, M = ""; ue <= W; M += V.charAt(K[ue++]))
          ;
        M = er(M, H, V.charAt(0));
      }
      return M;
    };
  }(), t = /* @__PURE__ */ function() {
    function k(E, I, L) {
      var N, V, z, H, W = 0, j = E.length, U = I % Er, K = I / Er | 0;
      for (E = E.slice(); j--; )
        z = E[j] % Er, H = E[j] / Er | 0, N = K * z + H * U, V = U * z + N % Er * Er + W, W = (V / L | 0) + (N / Er | 0) + K * H, E[j] = V % L;
      return W && (E = [W].concat(E)), E;
    }
    function S(E, I, L, N) {
      var V, z;
      if (L != N)
        z = L > N ? 1 : -1;
      else
        for (V = z = 0; V < L; V++)
          if (E[V] != I[V]) {
            z = E[V] > I[V] ? 1 : -1;
            break;
          }
      return z;
    }
    function M(E, I, L, N) {
      for (var V = 0; L--; )
        E[L] -= V, V = E[L] < I[L] ? 1 : 0, E[L] = V * N + E[L] - I[L];
      for (; !E[0] && E.length > 1; E.splice(0, 1))
        ;
    }
    return function(E, I, L, N, V) {
      var z, H, W, j, U, K, te, ue, de, Q, J, re, me, xe, tt, nt, fe, be = E.s == I.s ? 1 : -1, Ee = E.c, ke = I.c;
      if (!Ee || !Ee[0] || !ke || !ke[0])
        return new _(
          // Return NaN if either NaN, or both Infinity or 0.
          !E.s || !I.s || (Ee ? ke && Ee[0] == ke[0] : !ke) ? NaN : (
            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            Ee && Ee[0] == 0 || !ke ? be * 0 : be / 0
          )
        );
      for (ue = new _(be), de = ue.c = [], H = E.e - I.e, be = L + H + 1, V || (V = ki, H = fi(E.e / je) - fi(I.e / je), be = be / je | 0), W = 0; ke[W] == (Ee[W] || 0); W++)
        ;
      if (ke[W] > (Ee[W] || 0) && H--, be < 0)
        de.push(1), j = !0;
      else {
        for (xe = Ee.length, nt = ke.length, W = 0, be += 2, U = di(V / (ke[0] + 1)), U > 1 && (ke = k(ke, U, V), Ee = k(Ee, U, V), nt = ke.length, xe = Ee.length), me = nt, Q = Ee.slice(0, nt), J = Q.length; J < nt; Q[J++] = 0)
          ;
        fe = ke.slice(), fe = [0].concat(fe), tt = ke[0], ke[1] >= V / 2 && tt++;
        do {
          if (U = 0, z = S(ke, Q, nt, J), z < 0) {
            if (re = Q[0], nt != J && (re = re * V + (Q[1] || 0)), U = di(re / tt), U > 1)
              for (U >= V && (U = V - 1), K = k(ke, U, V), te = K.length, J = Q.length; S(K, Q, te, J) == 1; )
                U--, M(K, nt < te ? fe : ke, te, V), te = K.length, z = 1;
            else
              U == 0 && (z = U = 1), K = ke.slice(), te = K.length;
            if (te < J && (K = [0].concat(K)), M(Q, K, J, V), J = Q.length, z == -1)
              for (; S(ke, Q, nt, J) < 1; )
                U++, M(Q, nt < J ? fe : ke, J, V), J = Q.length;
          } else
            z === 0 && (U++, Q = [0]);
          de[W++] = U, Q[0] ? Q[J++] = Ee[me] || 0 : (Q = [Ee[me]], J = 1);
        } while ((me++ < xe || Q[0] != null) && be--);
        j = Q[0] != null, de[0] || de.splice(0, 1);
      }
      if (V == ki) {
        for (W = 1, be = de[0]; be >= 10; be /= 10, W++)
          ;
        $(ue, L + (ue.e = W + H * je - 1) + 1, N, j);
      } else
        ue.e = H, ue.r = +j;
      return ue;
    };
  }();
  function O(k, S, M, E) {
    var I, L, N, V, z;
    if (M == null ? M = l : St(M, 0, 8), !k.c)
      return k.toString();
    if (I = k.c[0], N = k.e, S == null)
      z = ui(k.c), z = E == 1 || E == 2 && (N <= u || N >= d) ? hu(z, N) : er(z, N, "0");
    else if (k = $(new _(k), S, M), L = k.e, z = ui(k.c), V = z.length, E == 1 || E == 2 && (S <= L || L <= u)) {
      for (; V < S; z += "0", V++)
        ;
      z = hu(z, L);
    } else if (S -= N, z = er(z, L, "0"), L + 1 > V) {
      if (--S > 0)
        for (z += "."; S--; z += "0")
          ;
    } else if (S += L - V, S > 0)
      for (L + 1 == V && (z += "."); S--; z += "0")
        ;
    return k.s < 0 && I ? "-" + z : z;
  }
  function D(k, S) {
    for (var M, E, I = 1, L = new _(k[0]); I < k.length; I++)
      E = new _(k[I]), (!E.s || (M = wo(L, E)) === S || M === 0 && L.s === S) && (L = E);
    return L;
  }
  function F(k, S, M) {
    for (var E = 1, I = S.length; !S[--I]; S.pop())
      ;
    for (I = S[0]; I >= 10; I /= 10, E++)
      ;
    return (M = E + M * je - 1) > m ? k.c = k.e = null : M < f ? k.c = [k.e = 0] : (k.e = M, k.c = S), k;
  }
  i = /* @__PURE__ */ function() {
    var k = /^(-?)0([xbo])(?=\w[\w.]*$)/i, S = /^([^.]+)\.$/, M = /^\.([^.]+)$/, E = /^-?(Infinity|NaN)$/, I = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function(L, N, V, z) {
      var H, W = V ? N : N.replace(I, "");
      if (E.test(W))
        L.s = isNaN(W) ? null : W < 0 ? -1 : 1;
      else {
        if (!V && (W = W.replace(k, function(j, U, K) {
          return H = (K = K.toLowerCase()) == "x" ? 16 : K == "b" ? 2 : 8, !z || z == H ? U : j;
        }), z && (H = z, W = W.replace(S, "$1").replace(M, "0.$1")), N != W))
          return new _(W, H);
        if (_.DEBUG)
          throw Error(An + "Not a" + (z ? " base " + z : "") + " number: " + N);
        L.s = null;
      }
      L.c = L.e = null;
    };
  }();
  function $(k, S, M, E) {
    var I, L, N, V, z, H, W, j = k.c, U = Lf;
    if (j) {
      e: {
        for (I = 1, V = j[0]; V >= 10; V /= 10, I++)
          ;
        if (L = S - I, L < 0)
          L += je, N = S, z = j[H = 0], W = di(z / U[I - N - 1] % 10);
        else if (H = If((L + 1) / je), H >= j.length)
          if (E) {
            for (; j.length <= H; j.push(0))
              ;
            z = W = 0, I = 1, L %= je, N = L - je + 1;
          } else
            break e;
        else {
          for (z = V = j[H], I = 1; V >= 10; V /= 10, I++)
            ;
          L %= je, N = L - je + I, W = N < 0 ? 0 : di(z / U[I - N - 1] % 10);
        }
        if (E = E || S < 0 || // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
        j[H + 1] != null || (N < 0 ? z : z % U[I - N - 1]), E = M < 4 ? (W || E) && (M == 0 || M == (k.s < 0 ? 3 : 2)) : W > 5 || W == 5 && (M == 4 || E || M == 6 && // Check whether the digit to the left of the rounding digit is odd.
        (L > 0 ? N > 0 ? z / U[I - N] : 0 : j[H - 1]) % 10 & 1 || M == (k.s < 0 ? 8 : 7)), S < 1 || !j[0])
          return j.length = 0, E ? (S -= k.e + 1, j[0] = U[(je - S % je) % je], k.e = -S || 0) : j[0] = k.e = 0, k;
        if (L == 0 ? (j.length = H, V = 1, H--) : (j.length = H + 1, V = U[je - L], j[H] = N > 0 ? di(z / U[I - N] % U[N]) * V : 0), E)
          for (; ; )
            if (H == 0) {
              for (L = 1, N = j[0]; N >= 10; N /= 10, L++)
                ;
              for (N = j[0] += V, V = 1; N >= 10; N /= 10, V++)
                ;
              L != V && (k.e++, j[0] == ki && (j[0] = 1));
              break;
            } else {
              if (j[H] += V, j[H] != ki)
                break;
              j[H--] = 0, V = 1;
            }
        for (L = j.length; j[--L] === 0; j.pop())
          ;
      }
      k.e > m ? k.c = k.e = null : k.e < f && (k.c = [k.e = 0]);
    }
    return k;
  }
  function A(k) {
    var S, M = k.e;
    return M === null ? k.toString() : (S = ui(k.c), S = M <= u || M >= d ? hu(S, M) : er(S, M, "0"), k.s < 0 ? "-" + S : S);
  }
  return r.absoluteValue = r.abs = function() {
    var k = new _(this);
    return k.s < 0 && (k.s = 1), k;
  }, r.comparedTo = function(k, S) {
    return wo(this, new _(k, S));
  }, r.decimalPlaces = r.dp = function(k, S) {
    var M, E, I, L = this;
    if (k != null)
      return St(k, 0, Zt), S == null ? S = l : St(S, 0, 8), $(new _(L), k + L.e + 1, S);
    if (!(M = L.c))
      return null;
    if (E = ((I = M.length - 1) - fi(this.e / je)) * je, I = M[I])
      for (; I % 10 == 0; I /= 10, E--)
        ;
    return E < 0 && (E = 0), E;
  }, r.dividedBy = r.div = function(k, S) {
    return t(this, new _(k, S), a, l);
  }, r.dividedToIntegerBy = r.idiv = function(k, S) {
    return t(this, new _(k, S), 0, 1);
  }, r.exponentiatedBy = r.pow = function(k, S) {
    var M, E, I, L, N, V, z, H, W, j = this;
    if (k = new _(k), k.c && !k.isInteger())
      throw Error(An + "Exponent not an integer: " + A(k));
    if (S != null && (S = new _(S)), V = k.e > 14, !j.c || !j.c[0] || j.c[0] == 1 && !j.e && j.c.length == 1 || !k.c || !k.c[0])
      return W = new _(Math.pow(+A(j), V ? k.s * (2 - fu(k)) : +A(k))), S ? W.mod(S) : W;
    if (z = k.s < 0, S) {
      if (S.c ? !S.c[0] : !S.s)
        return new _(NaN);
      E = !z && j.isInteger() && S.isInteger(), E && (j = j.mod(S));
    } else {
      if (k.e > 9 && (j.e > 0 || j.e < -1 || (j.e == 0 ? j.c[0] > 1 || V && j.c[1] >= 24e7 : j.c[0] < 8e13 || V && j.c[0] <= 9999975e7)))
        return L = j.s < 0 && fu(k) ? -0 : 0, j.e > -1 && (L = 1 / L), new _(z ? 1 / L : L);
      y && (L = If(y / je + 2));
    }
    for (V ? (M = new _(0.5), z && (k.s = 1), H = fu(k)) : (I = Math.abs(+A(k)), H = I % 2), W = new _(o); ; ) {
      if (H) {
        if (W = W.times(j), !W.c)
          break;
        L ? W.c.length > L && (W.c.length = L) : E && (W = W.mod(S));
      }
      if (I) {
        if (I = di(I / 2), I === 0)
          break;
        H = I % 2;
      } else if (k = k.times(M), $(k, k.e + 1, 1), k.e > 14)
        H = fu(k);
      else {
        if (I = +A(k), I === 0)
          break;
        H = I % 2;
      }
      j = j.times(j), L ? j.c && j.c.length > L && (j.c.length = L) : E && (j = j.mod(S));
    }
    return E ? W : (z && (W = o.div(W)), S ? W.mod(S) : L ? $(W, y, l, N) : W);
  }, r.integerValue = function(k) {
    var S = new _(this);
    return k == null ? k = l : St(k, 0, 8), $(S, S.e + 1, k);
  }, r.isEqualTo = r.eq = function(k, S) {
    return wo(this, new _(k, S)) === 0;
  }, r.isFinite = function() {
    return !!this.c;
  }, r.isGreaterThan = r.gt = function(k, S) {
    return wo(this, new _(k, S)) > 0;
  }, r.isGreaterThanOrEqualTo = r.gte = function(k, S) {
    return (S = wo(this, new _(k, S))) === 1 || S === 0;
  }, r.isInteger = function() {
    return !!this.c && fi(this.e / je) > this.c.length - 2;
  }, r.isLessThan = r.lt = function(k, S) {
    return wo(this, new _(k, S)) < 0;
  }, r.isLessThanOrEqualTo = r.lte = function(k, S) {
    return (S = wo(this, new _(k, S))) === -1 || S === 0;
  }, r.isNaN = function() {
    return !this.s;
  }, r.isNegative = function() {
    return this.s < 0;
  }, r.isPositive = function() {
    return this.s > 0;
  }, r.isZero = function() {
    return !!this.c && this.c[0] == 0;
  }, r.minus = function(k, S) {
    var M, E, I, L, N = this, V = N.s;
    if (k = new _(k, S), S = k.s, !V || !S)
      return new _(NaN);
    if (V != S)
      return k.s = -S, N.plus(k);
    var z = N.e / je, H = k.e / je, W = N.c, j = k.c;
    if (!z || !H) {
      if (!W || !j)
        return W ? (k.s = -S, k) : new _(j ? N : NaN);
      if (!W[0] || !j[0])
        return j[0] ? (k.s = -S, k) : new _(W[0] ? N : (
          // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
          l == 3 ? -0 : 0
        ));
    }
    if (z = fi(z), H = fi(H), W = W.slice(), V = z - H) {
      for ((L = V < 0) ? (V = -V, I = W) : (H = z, I = j), I.reverse(), S = V; S--; I.push(0))
        ;
      I.reverse();
    } else
      for (E = (L = (V = W.length) < (S = j.length)) ? V : S, V = S = 0; S < E; S++)
        if (W[S] != j[S]) {
          L = W[S] < j[S];
          break;
        }
    if (L && (I = W, W = j, j = I, k.s = -k.s), S = (E = j.length) - (M = W.length), S > 0)
      for (; S--; W[M++] = 0)
        ;
    for (S = ki - 1; E > V; ) {
      if (W[--E] < j[E]) {
        for (M = E; M && !W[--M]; W[M] = S)
          ;
        --W[M], W[E] += ki;
      }
      W[E] -= j[E];
    }
    for (; W[0] == 0; W.splice(0, 1), --H)
      ;
    return W[0] ? F(k, W, H) : (k.s = l == 3 ? -1 : 1, k.c = [k.e = 0], k);
  }, r.modulo = r.mod = function(k, S) {
    var M, E, I = this;
    return k = new _(k, S), !I.c || !k.s || k.c && !k.c[0] ? new _(NaN) : !k.c || I.c && !I.c[0] ? new _(I) : (v == 9 ? (E = k.s, k.s = 1, M = t(I, k, 0, 3), k.s = E, M.s *= E) : M = t(I, k, 0, v), k = I.minus(M.times(k)), !k.c[0] && v == 1 && (k.s = I.s), k);
  }, r.multipliedBy = r.times = function(k, S) {
    var M, E, I, L, N, V, z, H, W, j, U, K, te, ue, de, Q = this, J = Q.c, re = (k = new _(k, S)).c;
    if (!J || !re || !J[0] || !re[0])
      return !Q.s || !k.s || J && !J[0] && !re || re && !re[0] && !J ? k.c = k.e = k.s = null : (k.s *= Q.s, !J || !re ? k.c = k.e = null : (k.c = [0], k.e = 0)), k;
    for (E = fi(Q.e / je) + fi(k.e / je), k.s *= Q.s, z = J.length, j = re.length, z < j && (te = J, J = re, re = te, I = z, z = j, j = I), I = z + j, te = []; I--; te.push(0))
      ;
    for (ue = ki, de = Er, I = j; --I >= 0; ) {
      for (M = 0, U = re[I] % de, K = re[I] / de | 0, N = z, L = I + N; L > I; )
        H = J[--N] % de, W = J[N] / de | 0, V = K * H + W * U, H = U * H + V % de * de + te[L] + M, M = (H / ue | 0) + (V / de | 0) + K * W, te[L--] = H % ue;
      te[L] = M;
    }
    return M ? ++E : te.splice(0, 1), F(k, te, E);
  }, r.negated = function() {
    var k = new _(this);
    return k.s = -k.s || null, k;
  }, r.plus = function(k, S) {
    var M, E = this, I = E.s;
    if (k = new _(k, S), S = k.s, !I || !S)
      return new _(NaN);
    if (I != S)
      return k.s = -S, E.minus(k);
    var L = E.e / je, N = k.e / je, V = E.c, z = k.c;
    if (!L || !N) {
      if (!V || !z)
        return new _(I / 0);
      if (!V[0] || !z[0])
        return z[0] ? k : new _(V[0] ? E : I * 0);
    }
    if (L = fi(L), N = fi(N), V = V.slice(), I = L - N) {
      for (I > 0 ? (N = L, M = z) : (I = -I, M = V), M.reverse(); I--; M.push(0))
        ;
      M.reverse();
    }
    for (I = V.length, S = z.length, I - S < 0 && (M = z, z = V, V = M, S = I), I = 0; S; )
      I = (V[--S] = V[S] + z[S] + I) / ki | 0, V[S] = ki === V[S] ? 0 : V[S] % ki;
    return I && (V = [I].concat(V), ++N), F(k, V, N);
  }, r.precision = r.sd = function(k, S) {
    var M, E, I, L = this;
    if (k != null && k !== !!k)
      return St(k, 1, Zt), S == null ? S = l : St(S, 0, 8), $(new _(L), k, S);
    if (!(M = L.c))
      return null;
    if (I = M.length - 1, E = I * je + 1, I = M[I]) {
      for (; I % 10 == 0; I /= 10, E--)
        ;
      for (I = M[0]; I >= 10; I /= 10, E++)
        ;
    }
    return k && L.e + 1 > E && (E = L.e + 1), E;
  }, r.shiftedBy = function(k) {
    return St(k, -Df, Df), this.times("1e" + k);
  }, r.squareRoot = r.sqrt = function() {
    var k, S, M, E, I, L = this, N = L.c, V = L.s, z = L.e, H = a + 4, W = new _("0.5");
    if (V !== 1 || !N || !N[0])
      return new _(!V || V < 0 && (!N || N[0]) ? NaN : N ? L : 1 / 0);
    if (V = Math.sqrt(+A(L)), V == 0 || V == 1 / 0 ? (S = ui(N), (S.length + z) % 2 == 0 && (S += "0"), V = Math.sqrt(+S), z = fi((z + 1) / 2) - (z < 0 || z % 2), V == 1 / 0 ? S = "5e" + z : (S = V.toExponential(), S = S.slice(0, S.indexOf("e") + 1) + z), M = new _(S)) : M = new _(V + ""), M.c[0]) {
      for (z = M.e, V = z + H, V < 3 && (V = 0); ; )
        if (I = M, M = W.times(I.plus(t(L, I, H, 1))), ui(I.c).slice(0, V) === (S = ui(M.c)).slice(0, V))
          if (M.e < z && --V, S = S.slice(V - 3, V + 1), S == "9999" || !E && S == "4999") {
            if (!E && ($(I, I.e + a + 2, 0), I.times(I).eq(L))) {
              M = I;
              break;
            }
            H += 4, V += 4, E = 1;
          } else {
            (!+S || !+S.slice(1) && S.charAt(0) == "5") && ($(M, M.e + a + 2, 1), k = !M.times(M).eq(L));
            break;
          }
    }
    return $(M, M.e + a + 1, l, k);
  }, r.toExponential = function(k, S) {
    return k != null && (St(k, 0, Zt), k++), O(this, k, S, 1);
  }, r.toFixed = function(k, S) {
    return k != null && (St(k, 0, Zt), k = k + this.e + 1), O(this, k, S);
  }, r.toFormat = function(k, S, M) {
    var E, I = this;
    if (M == null)
      k != null && S && typeof S == "object" ? (M = S, S = null) : k && typeof k == "object" ? (M = k, k = S = null) : M = p;
    else if (typeof M != "object")
      throw Error(An + "Argument not an object: " + M);
    if (E = I.toFixed(k, S), I.c) {
      var L, N = E.split("."), V = +M.groupSize, z = +M.secondaryGroupSize, H = M.groupSeparator || "", W = N[0], j = N[1], U = I.s < 0, K = U ? W.slice(1) : W, te = K.length;
      if (z && (L = V, V = z, z = L, te -= L), V > 0 && te > 0) {
        for (L = te % V || V, W = K.substr(0, L); L < te; L += V)
          W += H + K.substr(L, V);
        z > 0 && (W += H + K.slice(L)), U && (W = "-" + W);
      }
      E = j ? W + (M.decimalSeparator || "") + ((z = +M.fractionGroupSize) ? j.replace(
        new RegExp("\\d{" + z + "}\\B", "g"),
        "$&" + (M.fractionGroupSeparator || "")
      ) : j) : W;
    }
    return (M.prefix || "") + E + (M.suffix || "");
  }, r.toFraction = function(k) {
    var S, M, E, I, L, N, V, z, H, W, j, U, K = this, te = K.c;
    if (k != null && (V = new _(k), !V.isInteger() && (V.c || V.s !== 1) || V.lt(o)))
      throw Error(An + "Argument " + (V.isInteger() ? "out of range: " : "not an integer: ") + A(V));
    if (!te)
      return new _(K);
    for (S = new _(o), H = M = new _(o), E = z = new _(o), U = ui(te), L = S.e = U.length - K.e - 1, S.c[0] = Lf[(N = L % je) < 0 ? je + N : N], k = !k || V.comparedTo(S) > 0 ? L > 0 ? S : H : V, N = m, m = 1 / 0, V = new _(U), z.c[0] = 0; W = t(V, S, 0, 1), I = M.plus(W.times(E)), I.comparedTo(k) != 1; )
      M = E, E = I, H = z.plus(W.times(I = H)), z = I, S = V.minus(W.times(I = S)), V = I;
    return I = t(k.minus(M), E, 0, 1), z = z.plus(I.times(H)), M = M.plus(I.times(E)), z.s = H.s = K.s, L = L * 2, j = t(H, E, L, l).minus(K).abs().comparedTo(
      t(z, M, L, l).minus(K).abs()
    ) < 1 ? [H, E] : [z, M], m = N, j;
  }, r.toNumber = function() {
    return +A(this);
  }, r.toPrecision = function(k, S) {
    return k != null && St(k, 1, Zt), O(this, k, S, 2);
  }, r.toString = function(k) {
    var S, M = this, E = M.s, I = M.e;
    return I === null ? E ? (S = "Infinity", E < 0 && (S = "-" + S)) : S = "NaN" : (k == null ? S = I <= u || I >= d ? hu(ui(M.c), I) : er(ui(M.c), I, "0") : k === 10 && x ? (M = $(new _(M), a + I + 1, l), S = er(ui(M.c), M.e, "0")) : (St(k, 2, b.length, "Base"), S = n(er(ui(M.c), I, "0"), 10, k, E, !0)), E < 0 && M.c[0] && (S = "-" + S)), S;
  }, r.valueOf = r.toJSON = function() {
    return A(this);
  }, r._isBigNumber = !0, r[Symbol.toStringTag] = "BigNumber", r[Symbol.for("nodejs.util.inspect.custom")] = r.valueOf, e != null && _.set(e), _;
}
function fi(e) {
  var t = e | 0;
  return e > 0 || e === t ? t : t - 1;
}
function ui(e) {
  for (var t, n, i = 1, r = e.length, o = e[0] + ""; i < r; ) {
    for (t = e[i++] + "", n = je - t.length; n--; t = "0" + t)
      ;
    o += t;
  }
  for (r = o.length; o.charCodeAt(--r) === 48; )
    ;
  return o.slice(0, r + 1 || 1);
}
function wo(e, t) {
  var n, i, r = e.c, o = t.c, a = e.s, l = t.s, u = e.e, d = t.e;
  if (!a || !l)
    return null;
  if (n = r && !r[0], i = o && !o[0], n || i)
    return n ? i ? 0 : -l : a;
  if (a != l)
    return a;
  if (n = a < 0, i = u == d, !r || !o)
    return i ? 0 : !r ^ n ? 1 : -1;
  if (!i)
    return u > d ^ n ? 1 : -1;
  for (l = (u = r.length) < (d = o.length) ? u : d, a = 0; a < l; a++)
    if (r[a] != o[a])
      return r[a] > o[a] ^ n ? 1 : -1;
  return u == d ? 0 : u > d ^ n ? 1 : -1;
}
function St(e, t, n, i) {
  if (e < t || e > n || e !== di(e))
    throw Error(An + (i || "Argument") + (typeof e == "number" ? e < t || e > n ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
}
function fu(e) {
  var t = e.c.length - 1;
  return fi(e.e / je) == t && e.c[t] % 2 != 0;
}
function hu(e, t) {
  return (e.length > 1 ? e.charAt(0) + "." + e.slice(1) : e) + (t < 0 ? "e" : "e+") + t;
}
function er(e, t, n) {
  var i, r;
  if (t < 0) {
    for (r = n + "."; ++t; r += n)
      ;
    e = r + e;
  } else if (i = e.length, ++t > i) {
    for (r = n, t -= i; --t; r += n)
      ;
    e += r;
  } else
    t < i && (e = e.slice(0, t) + "." + e.slice(t));
  return e;
}
var zr = lw();
zr.config({ ROUNDING_MODE: zr.ROUND_DOWN });
var oc = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
oc.exports;
(function(e, t) {
  (function() {
    function n(X, oe, C) {
      switch (C.length) {
        case 0:
          return X.call(oe);
        case 1:
          return X.call(oe, C[0]);
        case 2:
          return X.call(oe, C[0], C[1]);
        case 3:
          return X.call(oe, C[0], C[1], C[2]);
      }
      return X.apply(oe, C);
    }
    function i(X, oe, C, Se) {
      for (var Ve = -1, Ce = X == null ? 0 : X.length; ++Ve < Ce; ) {
        var kn = X[Ve];
        oe(Se, kn, C(kn), X);
      }
      return Se;
    }
    function r(X, oe) {
      for (var C = -1, Se = X == null ? 0 : X.length; ++C < Se && oe(X[C], C, X) !== !1; )
        ;
      return X;
    }
    function o(X, oe) {
      for (var C = X == null ? 0 : X.length; C-- && oe(X[C], C, X) !== !1; )
        ;
      return X;
    }
    function a(X, oe) {
      for (var C = -1, Se = X == null ? 0 : X.length; ++C < Se; )
        if (!oe(X[C], C, X))
          return !1;
      return !0;
    }
    function l(X, oe) {
      for (var C = -1, Se = X == null ? 0 : X.length, Ve = 0, Ce = []; ++C < Se; ) {
        var kn = X[C];
        oe(kn, C, X) && (Ce[Ve++] = kn);
      }
      return Ce;
    }
    function u(X, oe) {
      return !!(X != null && X.length) && O(X, oe, 0) > -1;
    }
    function d(X, oe, C) {
      for (var Se = -1, Ve = X == null ? 0 : X.length; ++Se < Ve; )
        if (C(oe, X[Se]))
          return !0;
      return !1;
    }
    function f(X, oe) {
      for (var C = -1, Se = X == null ? 0 : X.length, Ve = Array(Se); ++C < Se; )
        Ve[C] = oe(X[C], C, X);
      return Ve;
    }
    function m(X, oe) {
      for (var C = -1, Se = oe.length, Ve = X.length; ++C < Se; )
        X[Ve + C] = oe[C];
      return X;
    }
    function h(X, oe, C, Se) {
      var Ve = -1, Ce = X == null ? 0 : X.length;
      for (Se && Ce && (C = X[++Ve]); ++Ve < Ce; )
        C = oe(C, X[Ve], Ve, X);
      return C;
    }
    function v(X, oe, C, Se) {
      var Ve = X == null ? 0 : X.length;
      for (Se && Ve && (C = X[--Ve]); Ve--; )
        C = oe(C, X[Ve], Ve, X);
      return C;
    }
    function y(X, oe) {
      for (var C = -1, Se = X == null ? 0 : X.length; ++C < Se; )
        if (oe(X[C], C, X))
          return !0;
      return !1;
    }
    function p(X) {
      return X.split("");
    }
    function b(X) {
      return X.match(mk) || [];
    }
    function x(X, oe, C) {
      var Se;
      return C(X, function(Ve, Ce, kn) {
        if (oe(Ve, Ce, kn))
          return Se = Ce, !1;
      }), Se;
    }
    function _(X, oe, C, Se) {
      for (var Ve = X.length, Ce = C + (Se ? 1 : -1); Se ? Ce-- : ++Ce < Ve; )
        if (oe(X[Ce], Ce, X))
          return Ce;
      return -1;
    }
    function O(X, oe, C) {
      return oe === oe ? nt(X, oe, C) : _(X, F, C);
    }
    function D(X, oe, C, Se) {
      for (var Ve = C - 1, Ce = X.length; ++Ve < Ce; )
        if (Se(X[Ve], oe))
          return Ve;
      return -1;
    }
    function F(X) {
      return X !== X;
    }
    function $(X, oe) {
      var C = X == null ? 0 : X.length;
      return C ? E(X, oe) / C : qo;
    }
    function A(X) {
      return function(oe) {
        return oe == null ? Y : oe[X];
      };
    }
    function k(X) {
      return function(oe) {
        return X == null ? Y : X[oe];
      };
    }
    function S(X, oe, C, Se, Ve) {
      return Ve(X, function(Ce, kn, Sd) {
        C = Se ? (Se = !1, Ce) : oe(C, Ce, kn, Sd);
      }), C;
    }
    function M(X, oe) {
      var C = X.length;
      for (X.sort(oe); C--; )
        X[C] = X[C].value;
      return X;
    }
    function E(X, oe) {
      for (var C, Se = -1, Ve = X.length; ++Se < Ve; ) {
        var Ce = oe(X[Se]);
        Ce !== Y && (C = C === Y ? Ce : C + Ce);
      }
      return C;
    }
    function I(X, oe) {
      for (var C = -1, Se = Array(X); ++C < X; )
        Se[C] = oe(C);
      return Se;
    }
    function L(X, oe) {
      return f(oe, function(C) {
        return [C, X[C]];
      });
    }
    function N(X) {
      return X && X.slice(0, ke(X) + 1).replace(vd, "");
    }
    function V(X) {
      return function(oe) {
        return X(oe);
      };
    }
    function z(X, oe) {
      return f(oe, function(C) {
        return X[C];
      });
    }
    function H(X, oe) {
      return X.has(oe);
    }
    function W(X, oe) {
      for (var C = -1, Se = X.length; ++C < Se && O(oe, X[C], 0) > -1; )
        ;
      return C;
    }
    function j(X, oe) {
      for (var C = X.length; C-- && O(oe, X[C], 0) > -1; )
        ;
      return C;
    }
    function U(X, oe) {
      for (var C = X.length, Se = 0; C--; )
        X[C] === oe && ++Se;
      return Se;
    }
    function K(X) {
      return "\\" + Qk[X];
    }
    function te(X, oe) {
      return X == null ? Y : X[oe];
    }
    function ue(X) {
      return Yk.test(X);
    }
    function de(X) {
      return Uk.test(X);
    }
    function Q(X) {
      for (var oe, C = []; !(oe = X.next()).done; )
        C.push(oe.value);
      return C;
    }
    function J(X) {
      var oe = -1, C = Array(X.size);
      return X.forEach(function(Se, Ve) {
        C[++oe] = [Ve, Se];
      }), C;
    }
    function re(X, oe) {
      return function(C) {
        return X(oe(C));
      };
    }
    function me(X, oe) {
      for (var C = -1, Se = X.length, Ve = 0, Ce = []; ++C < Se; ) {
        var kn = X[C];
        kn !== oe && kn !== Yo || (X[C] = Yo, Ce[Ve++] = C);
      }
      return Ce;
    }
    function xe(X) {
      var oe = -1, C = Array(X.size);
      return X.forEach(function(Se) {
        C[++oe] = Se;
      }), C;
    }
    function tt(X) {
      var oe = -1, C = Array(X.size);
      return X.forEach(function(Se) {
        C[++oe] = [Se, Se];
      }), C;
    }
    function nt(X, oe, C) {
      for (var Se = C - 1, Ve = X.length; ++Se < Ve; )
        if (X[Se] === oe)
          return Se;
      return -1;
    }
    function fe(X, oe, C) {
      for (var Se = C + 1; Se--; )
        if (X[Se] === oe)
          return Se;
      return Se;
    }
    function be(X) {
      return ue(X) ? at(X) : nS(X);
    }
    function Ee(X) {
      return ue(X) ? xn(X) : p(X);
    }
    function ke(X) {
      for (var oe = X.length; oe-- && dk.test(X.charAt(oe)); )
        ;
      return oe;
    }
    function at(X) {
      for (var oe = _d.lastIndex = 0; _d.test(X); )
        ++oe;
      return oe;
    }
    function xn(X) {
      return X.match(_d) || [];
    }
    function vi(X) {
      return X.match(jk) || [];
    }
    var Y, pi = "4.17.21", Ht = 200, jo = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", nn = "Expected a function", vr = "Invalid `variable` option passed into `_.template`", yi = "__lodash_hash_undefined__", Qc = 500, Yo = "__lodash_placeholder__", Mi = 1, vl = 2, pr = 4, yr = 1, Uo = 2, Xt = 1, ji = 2, pl = 4, Qn = 8, br = 16, Jn = 32, wr = 64, bi = 128, to = 256, Wa = 512, Jc = 30, ed = "...", td = 800, nd = 16, yl = 1, id = 2, rd = 3, Yi = 1 / 0, Ti = 9007199254740991, od = 17976931348623157e292, qo = NaN, ei = 4294967295, ad = ei - 1, sd = ei >>> 1, ld = [["ary", bi], ["bind", Xt], ["bindKey", ji], ["curry", Qn], ["curryRight", br], ["flip", Wa], ["partial", Jn], ["partialRight", wr], ["rearg", to]], _r = "[object Arguments]", Go = "[object Array]", ud = "[object AsyncFunction]", no = "[object Boolean]", io = "[object Date]", cd = "[object DOMException]", Xo = "[object Error]", Ko = "[object Function]", bl = "[object GeneratorFunction]", Vn = "[object Map]", ro = "[object Number]", dd = "[object Null]", wi = "[object Object]", wl = "[object Promise]", fd = "[object Proxy]", oo = "[object RegExp]", $n = "[object Set]", ao = "[object String]", Zo = "[object Symbol]", hd = "[object Undefined]", so = "[object WeakMap]", gd = "[object WeakSet]", lo = "[object ArrayBuffer]", xr = "[object DataView]", za = "[object Float32Array]", Ha = "[object Float64Array]", ja = "[object Int8Array]", Ya = "[object Int16Array]", ti = "[object Int32Array]", Ua = "[object Uint8Array]", We = "[object Uint8ClampedArray]", Rn = "[object Uint16Array]", kr = "[object Uint32Array]", _l = /\b__p \+= '';/g, xl = /\b(__p \+=) '' \+/g, kl = /(__e\(.*?\)|\b__t\)) \+\n'';/g, om = /&(?:amp|lt|gt|quot|#39);/g, am = /[&<>"']/g, ik = RegExp(om.source), rk = RegExp(am.source), ok = /<%-([\s\S]+?)%>/g, ak = /<%([\s\S]+?)%>/g, sm = /<%=([\s\S]+?)%>/g, sk = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, lk = /^\w*$/, uk = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, md = /[\\^$.*+?()[\]{}|]/g, ck = RegExp(md.source), vd = /^\s+/, dk = /\s/, fk = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, hk = /\{\n\/\* \[wrapped with (.+)\] \*/, gk = /,? & /, mk = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, vk = /[()=,{}\[\]\/\s]/, pk = /\\(\\)?/g, yk = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, lm = /\w*$/, bk = /^[-+]0x[0-9a-f]+$/i, wk = /^0b[01]+$/i, _k = /^\[object .+?Constructor\]$/, xk = /^0o[0-7]+$/i, kk = /^(?:0|[1-9]\d*)$/, Sk = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Sl = /($^)/, Ck = /['\n\r\u2028\u2029\\]/g, Cl = "\\ud800-\\udfff", Ok = "\\u0300-\\u036f", Mk = "\\ufe20-\\ufe2f", Tk = "\\u20d0-\\u20ff", um = Ok + Mk + Tk, cm = "\\u2700-\\u27bf", dm = "a-z\\xdf-\\xf6\\xf8-\\xff", Pk = "\\xac\\xb1\\xd7\\xf7", Ak = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ek = "\\u2000-\\u206f", Ik = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", fm = "A-Z\\xc0-\\xd6\\xd8-\\xde", hm = "\\ufe0e\\ufe0f", gm = Pk + Ak + Ek + Ik, pd = "['’]", Dk = "[" + Cl + "]", mm = "[" + gm + "]", Ol = "[" + um + "]", vm = "\\d+", Lk = "[" + cm + "]", pm = "[" + dm + "]", ym = "[^" + Cl + gm + vm + cm + dm + fm + "]", yd = "\\ud83c[\\udffb-\\udfff]", Bk = "(?:" + Ol + "|" + yd + ")", bm = "[^" + Cl + "]", bd = "(?:\\ud83c[\\udde6-\\uddff]){2}", wd = "[\\ud800-\\udbff][\\udc00-\\udfff]", Qo = "[" + fm + "]", wm = "\\u200d", _m = "(?:" + pm + "|" + ym + ")", Vk = "(?:" + Qo + "|" + ym + ")", xm = "(?:" + pd + "(?:d|ll|m|re|s|t|ve))?", km = "(?:" + pd + "(?:D|LL|M|RE|S|T|VE))?", Sm = Bk + "?", Cm = "[" + hm + "]?", $k = "(?:" + wm + "(?:" + [bm, bd, wd].join("|") + ")" + Cm + Sm + ")*", Rk = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Fk = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Om = Cm + Sm + $k, Nk = "(?:" + [Lk, bd, wd].join("|") + ")" + Om, Wk = "(?:" + [bm + Ol + "?", Ol, bd, wd, Dk].join("|") + ")", zk = RegExp(pd, "g"), Hk = RegExp(Ol, "g"), _d = RegExp(yd + "(?=" + yd + ")|" + Wk + Om, "g"), jk = RegExp([Qo + "?" + pm + "+" + xm + "(?=" + [mm, Qo, "$"].join("|") + ")", Vk + "+" + km + "(?=" + [mm, Qo + _m, "$"].join("|") + ")", Qo + "?" + _m + "+" + xm, Qo + "+" + km, Fk, Rk, vm, Nk].join("|"), "g"), Yk = RegExp("[" + wm + Cl + um + hm + "]"), Uk = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, qk = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"], Gk = -1, yt = {};
    yt[za] = yt[Ha] = yt[ja] = yt[Ya] = yt[ti] = yt[Ua] = yt[We] = yt[Rn] = yt[kr] = !0, yt[_r] = yt[Go] = yt[lo] = yt[no] = yt[xr] = yt[io] = yt[Xo] = yt[Ko] = yt[Vn] = yt[ro] = yt[wi] = yt[oo] = yt[$n] = yt[ao] = yt[so] = !1;
    var mt = {};
    mt[_r] = mt[Go] = mt[lo] = mt[xr] = mt[no] = mt[io] = mt[za] = mt[Ha] = mt[ja] = mt[Ya] = mt[ti] = mt[Vn] = mt[ro] = mt[wi] = mt[oo] = mt[$n] = mt[ao] = mt[Zo] = mt[Ua] = mt[We] = mt[Rn] = mt[kr] = !0, mt[Xo] = mt[Ko] = mt[so] = !1;
    var Xk = {
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Kk = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, Zk = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }, Qk = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" }, Jk = parseFloat, eS = parseInt, Mm = typeof or == "object" && or && or.Object === Object && or, tS = typeof self == "object" && self && self.Object === Object && self, rn = Mm || tS || Function("return this")(), xd = t && !t.nodeType && t, uo = xd && !0 && e && !e.nodeType && e, Tm = uo && uo.exports === xd, kd = Tm && Mm.process, ni = function() {
      try {
        var X = uo && uo.require && uo.require("util").types;
        return X || kd && kd.binding && kd.binding("util");
      } catch {
      }
    }(), Pm = ni && ni.isArrayBuffer, Am = ni && ni.isDate, Em = ni && ni.isMap, Im = ni && ni.isRegExp, Dm = ni && ni.isSet, Lm = ni && ni.isTypedArray, nS = A("length"), iS = k(Xk), rS = k(Kk), oS = k(Zk), aS = function X(oe) {
      function C(s) {
        if (Tt(s) && !He(s) && !(s instanceof Ce)) {
          if (s instanceof Ve)
            return s;
          if (ut.call(s, "__wrapped__"))
            return Tv(s);
        }
        return new Ve(s);
      }
      function Se() {
      }
      function Ve(s, c) {
        this.__wrapped__ = s, this.__actions__ = [], this.__chain__ = !!c, this.__index__ = 0, this.__values__ = Y;
      }
      function Ce(s) {
        this.__wrapped__ = s, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = ei, this.__views__ = [];
      }
      function kn() {
        var s = new Ce(this.__wrapped__);
        return s.__actions__ = Sn(this.__actions__), s.__dir__ = this.__dir__, s.__filtered__ = this.__filtered__, s.__iteratees__ = Sn(this.__iteratees__), s.__takeCount__ = this.__takeCount__, s.__views__ = Sn(this.__views__), s;
      }
      function Sd() {
        if (this.__filtered__) {
          var s = new Ce(this);
          s.__dir__ = -1, s.__filtered__ = !0;
        } else
          s = this.clone(), s.__dir__ *= -1;
        return s;
      }
      function sS() {
        var s = this.__wrapped__.value(), c = this.__dir__, g = He(s), w = c < 0, P = g ? s.length : 0, R = v2(0, P, this.__views__), q = R.start, G = R.end, Z = G - q, se = w ? G : q - 1, ae = this.__iteratees__, he = ae.length, _e = 0, Te = ln(Z, this.__takeCount__);
        if (!g || !w && P == Z && Te == Z)
          return tv(s, this.__actions__);
        var Ie = [];
        e:
          for (; Z-- && _e < Te; ) {
            se += c;
            for (var Ge = -1, Le = s[se]; ++Ge < he; ) {
              var Qe = ae[Ge], Je = Qe.iteratee, cn = Qe.type, Tn = Je(Le);
              if (cn == id)
                Le = Tn;
              else if (!Tn) {
                if (cn == yl)
                  continue e;
                break e;
              }
            }
            Ie[_e++] = Le;
          }
        return Ie;
      }
      function co(s) {
        var c = -1, g = s == null ? 0 : s.length;
        for (this.clear(); ++c < g; ) {
          var w = s[c];
          this.set(w[0], w[1]);
        }
      }
      function lS() {
        this.__data__ = rs ? rs(null) : {}, this.size = 0;
      }
      function uS(s) {
        var c = this.has(s) && delete this.__data__[s];
        return this.size -= c ? 1 : 0, c;
      }
      function cS(s) {
        var c = this.__data__;
        if (rs) {
          var g = c[s];
          return g === yi ? Y : g;
        }
        return ut.call(c, s) ? c[s] : Y;
      }
      function dS(s) {
        var c = this.__data__;
        return rs ? c[s] !== Y : ut.call(c, s);
      }
      function fS(s, c) {
        var g = this.__data__;
        return this.size += this.has(s) ? 0 : 1, g[s] = rs && c === Y ? yi : c, this;
      }
      function Ui(s) {
        var c = -1, g = s == null ? 0 : s.length;
        for (this.clear(); ++c < g; ) {
          var w = s[c];
          this.set(w[0], w[1]);
        }
      }
      function hS() {
        this.__data__ = [], this.size = 0;
      }
      function gS(s) {
        var c = this.__data__, g = Ml(c, s);
        return !(g < 0) && (g == c.length - 1 ? c.pop() : tu.call(c, g, 1), --this.size, !0);
      }
      function mS(s) {
        var c = this.__data__, g = Ml(c, s);
        return g < 0 ? Y : c[g][1];
      }
      function vS(s) {
        return Ml(this.__data__, s) > -1;
      }
      function pS(s, c) {
        var g = this.__data__, w = Ml(g, s);
        return w < 0 ? (++this.size, g.push([s, c])) : g[w][1] = c, this;
      }
      function qi(s) {
        var c = -1, g = s == null ? 0 : s.length;
        for (this.clear(); ++c < g; ) {
          var w = s[c];
          this.set(w[0], w[1]);
        }
      }
      function yS() {
        this.size = 0, this.__data__ = { hash: new co(), map: new (ns || Ui)(), string: new co() };
      }
      function bS(s) {
        var c = Fl(this, s).delete(s);
        return this.size -= c ? 1 : 0, c;
      }
      function wS(s) {
        return Fl(this, s).get(s);
      }
      function _S(s) {
        return Fl(this, s).has(s);
      }
      function xS(s, c) {
        var g = Fl(this, s), w = g.size;
        return g.set(s, c), this.size += g.size == w ? 0 : 1, this;
      }
      function fo(s) {
        var c = -1, g = s == null ? 0 : s.length;
        for (this.__data__ = new qi(); ++c < g; )
          this.add(s[c]);
      }
      function kS(s) {
        return this.__data__.set(s, yi), this;
      }
      function SS(s) {
        return this.__data__.has(s);
      }
      function _i(s) {
        this.size = (this.__data__ = new Ui(s)).size;
      }
      function CS() {
        this.__data__ = new Ui(), this.size = 0;
      }
      function OS(s) {
        var c = this.__data__, g = c.delete(s);
        return this.size = c.size, g;
      }
      function MS(s) {
        return this.__data__.get(s);
      }
      function TS(s) {
        return this.__data__.has(s);
      }
      function PS(s, c) {
        var g = this.__data__;
        if (g instanceof Ui) {
          var w = g.__data__;
          if (!ns || w.length < Ht - 1)
            return w.push([s, c]), this.size = ++g.size, this;
          g = this.__data__ = new qi(w);
        }
        return g.set(s, c), this.size = g.size, this;
      }
      function Bm(s, c) {
        var g = He(s), w = !g && yo(s), P = !g && !w && Pr(s), R = !g && !w && !P && ua(s), q = g || w || P || R, G = q ? I(s.length, CM) : [], Z = G.length;
        for (var se in s)
          !c && !ut.call(s, se) || q && (se == "length" || P && (se == "offset" || se == "parent") || R && (se == "buffer" || se == "byteLength" || se == "byteOffset") || Zi(se, Z)) || G.push(se);
        return G;
      }
      function Vm(s) {
        var c = s.length;
        return c ? s[Ld(0, c - 1)] : Y;
      }
      function AS(s, c) {
        return Nl(Sn(s), ho(c, 0, s.length));
      }
      function ES(s) {
        return Nl(Sn(s));
      }
      function Cd(s, c, g) {
        (g === Y || xi(s[c], g)) && (g !== Y || c in s) || Gi(s, c, g);
      }
      function qa(s, c, g) {
        var w = s[c];
        ut.call(s, c) && xi(w, g) && (g !== Y || c in s) || Gi(s, c, g);
      }
      function Ml(s, c) {
        for (var g = s.length; g--; )
          if (xi(s[g][0], c))
            return g;
        return -1;
      }
      function IS(s, c, g, w) {
        return Tr(s, function(P, R, q) {
          c(w, P, g(P), q);
        }), w;
      }
      function $m(s, c) {
        return s && Ai(c, Kt(c), s);
      }
      function DS(s, c) {
        return s && Ai(c, On(c), s);
      }
      function Gi(s, c, g) {
        c == "__proto__" && nu ? nu(s, c, { configurable: !0, enumerable: !0, value: g, writable: !0 }) : s[c] = g;
      }
      function Od(s, c) {
        for (var g = -1, w = c.length, P = jt(w), R = s == null; ++g < w; )
          P[g] = R ? Y : Jd(s, c[g]);
        return P;
      }
      function ho(s, c, g) {
        return s === s && (g !== Y && (s = s <= g ? s : g), c !== Y && (s = s >= c ? s : c)), s;
      }
      function ii(s, c, g, w, P, R) {
        var q, G = c & Mi, Z = c & vl, se = c & pr;
        if (g && (q = P ? g(s, w, P, R) : g(s)), q !== Y)
          return q;
        if (!kt(s))
          return s;
        var ae = He(s);
        if (ae) {
          if (q = y2(s), !G)
            return Sn(s, q);
        } else {
          var he = un(s), _e = he == Ko || he == bl;
          if (Pr(s))
            return iv(s, G);
          if (he == wi || he == _r || _e && !P) {
            if (q = Z || _e ? {} : _v(s), !G)
              return Z ? l2(s, DS(q, s)) : s2(s, $m(q, s));
          } else {
            if (!mt[he])
              return P ? s : {};
            q = b2(s, he, G);
          }
        }
        R || (R = new _i());
        var Te = R.get(s);
        if (Te)
          return Te;
        R.set(s, q), yp(s) ? s.forEach(function(Le) {
          q.add(ii(Le, c, g, Le, s, R));
        }) : pp(s) && s.forEach(function(Le, Qe) {
          q.set(Qe, ii(Le, c, g, Qe, s, R));
        });
        var Ie = se ? Z ? Yd : jd : Z ? On : Kt, Ge = ae ? Y : Ie(s);
        return r(Ge || s, function(Le, Qe) {
          Ge && (Qe = Le, Le = s[Qe]), qa(q, Qe, ii(Le, c, g, Qe, s, R));
        }), q;
      }
      function LS(s) {
        var c = Kt(s);
        return function(g) {
          return Rm(g, s, c);
        };
      }
      function Rm(s, c, g) {
        var w = g.length;
        if (s == null)
          return !w;
        for (s = bt(s); w--; ) {
          var P = g[w], R = c[P], q = s[P];
          if (q === Y && !(P in s) || !R(q))
            return !1;
        }
        return !0;
      }
      function Fm(s, c, g) {
        if (typeof s != "function")
          throw new si(nn);
        return as(function() {
          s.apply(Y, g);
        }, c);
      }
      function Ga(s, c, g, w) {
        var P = -1, R = u, q = !0, G = s.length, Z = [], se = c.length;
        if (!G)
          return Z;
        g && (c = f(c, V(g))), w ? (R = d, q = !1) : c.length >= Ht && (R = H, q = !1, c = new fo(c));
        e:
          for (; ++P < G; ) {
            var ae = s[P], he = g == null ? ae : g(ae);
            if (ae = w || ae !== 0 ? ae : 0, q && he === he) {
              for (var _e = se; _e--; )
                if (c[_e] === he)
                  continue e;
              Z.push(ae);
            } else
              R(c, he, w) || Z.push(ae);
          }
        return Z;
      }
      function BS(s, c) {
        var g = !0;
        return Tr(s, function(w, P, R) {
          return g = !!c(w, P, R);
        }), g;
      }
      function Tl(s, c, g) {
        for (var w = -1, P = s.length; ++w < P; ) {
          var R = s[w], q = c(R);
          if (q != null && (G === Y ? q === q && !Nn(q) : g(q, G)))
            var G = q, Z = R;
        }
        return Z;
      }
      function VS(s, c, g, w) {
        var P = s.length;
        for (g = Ke(g), g < 0 && (g = -g > P ? 0 : P + g), w = w === Y || w > P ? P : Ke(w), w < 0 && (w += P), w = g > w ? 0 : Uv(w); g < w; )
          s[g++] = c;
        return s;
      }
      function Nm(s, c) {
        var g = [];
        return Tr(s, function(w, P, R) {
          c(w, P, R) && g.push(w);
        }), g;
      }
      function on(s, c, g, w, P) {
        var R = -1, q = s.length;
        for (g || (g = _2), P || (P = []); ++R < q; ) {
          var G = s[R];
          c > 0 && g(G) ? c > 1 ? on(G, c - 1, g, w, P) : m(P, G) : w || (P[P.length] = G);
        }
        return P;
      }
      function Pi(s, c) {
        return s && hf(s, c, Kt);
      }
      function Md(s, c) {
        return s && up(s, c, Kt);
      }
      function Pl(s, c) {
        return l(c, function(g) {
          return Qi(s[g]);
        });
      }
      function go(s, c) {
        c = Cr(c, s);
        for (var g = 0, w = c.length; s != null && g < w; )
          s = s[Ei(c[g++])];
        return g && g == w ? s : Y;
      }
      function Wm(s, c, g) {
        var w = c(s);
        return He(s) ? w : m(w, g(s));
      }
      function vn(s) {
        return s == null ? s === Y ? hd : dd : po && po in bt(s) ? m2(s) : M2(s);
      }
      function Td(s, c) {
        return s > c;
      }
      function $S(s, c) {
        return s != null && ut.call(s, c);
      }
      function RS(s, c) {
        return s != null && c in bt(s);
      }
      function FS(s, c, g) {
        return s >= ln(c, g) && s < Yt(c, g);
      }
      function Pd(s, c, g) {
        for (var w = g ? d : u, P = s[0].length, R = s.length, q = R, G = jt(R), Z = 1 / 0, se = []; q--; ) {
          var ae = s[q];
          q && c && (ae = f(ae, V(c))), Z = ln(ae.length, Z), G[q] = !g && (c || P >= 120 && ae.length >= 120) ? new fo(q && ae) : Y;
        }
        ae = s[0];
        var he = -1, _e = G[0];
        e:
          for (; ++he < P && se.length < Z; ) {
            var Te = ae[he], Ie = c ? c(Te) : Te;
            if (Te = g || Te !== 0 ? Te : 0, !(_e ? H(_e, Ie) : w(se, Ie, g))) {
              for (q = R; --q; ) {
                var Ge = G[q];
                if (!(Ge ? H(Ge, Ie) : w(s[q], Ie, g)))
                  continue e;
              }
              _e && _e.push(Ie), se.push(Te);
            }
          }
        return se;
      }
      function NS(s, c, g, w) {
        return Pi(s, function(P, R, q) {
          c(w, g(P), R, q);
        }), w;
      }
      function Xa(s, c, g) {
        c = Cr(c, s), s = Cv(s, c);
        var w = s == null ? s : s[Ei(oi(c))];
        return w == null ? Y : n(w, s, g);
      }
      function zm(s) {
        return Tt(s) && vn(s) == _r;
      }
      function WS(s) {
        return Tt(s) && vn(s) == lo;
      }
      function zS(s) {
        return Tt(s) && vn(s) == io;
      }
      function Ka(s, c, g, w, P) {
        return s === c || (s == null || c == null || !Tt(s) && !Tt(c) ? s !== s && c !== c : HS(s, c, g, w, Ka, P));
      }
      function HS(s, c, g, w, P, R) {
        var q = He(s), G = He(c), Z = q ? Go : un(s), se = G ? Go : un(c);
        Z = Z == _r ? wi : Z, se = se == _r ? wi : se;
        var ae = Z == wi, he = se == wi, _e = Z == se;
        if (_e && Pr(s)) {
          if (!Pr(c))
            return !1;
          q = !0, ae = !1;
        }
        if (_e && !ae)
          return R || (R = new _i()), q || ua(s) ? bv(s, c, g, w, P, R) : h2(s, c, Z, g, w, P, R);
        if (!(g & yr)) {
          var Te = ae && ut.call(s, "__wrapped__"), Ie = he && ut.call(c, "__wrapped__");
          if (Te || Ie) {
            var Ge = Te ? s.value() : s, Le = Ie ? c.value() : c;
            return R || (R = new _i()), P(Ge, Le, g, w, R);
          }
        }
        return !!_e && (R || (R = new _i()), g2(s, c, g, w, P, R));
      }
      function jS(s) {
        return Tt(s) && un(s) == Vn;
      }
      function Ad(s, c, g, w) {
        var P = g.length, R = P, q = !w;
        if (s == null)
          return !R;
        for (s = bt(s); P--; ) {
          var G = g[P];
          if (q && G[2] ? G[1] !== s[G[0]] : !(G[0] in s))
            return !1;
        }
        for (; ++P < R; ) {
          G = g[P];
          var Z = G[0], se = s[Z], ae = G[1];
          if (q && G[2]) {
            if (se === Y && !(Z in s))
              return !1;
          } else {
            var he = new _i();
            if (w)
              var _e = w(se, ae, Z, s, c, he);
            if (!(_e === Y ? Ka(ae, se, yr | Uo, w, he) : _e))
              return !1;
          }
        }
        return !0;
      }
      function Hm(s) {
        return !(!kt(s) || k2(s)) && (Qi(s) ? AM : _k).test(vo(s));
      }
      function YS(s) {
        return Tt(s) && vn(s) == oo;
      }
      function US(s) {
        return Tt(s) && un(s) == $n;
      }
      function qS(s) {
        return Tt(s) && Yl(s.length) && !!yt[vn(s)];
      }
      function jm(s) {
        return typeof s == "function" ? s : s == null ? Mn : typeof s == "object" ? He(s) ? qm(s[0], s[1]) : Um(s) : Qv(s);
      }
      function Ed(s) {
        if (!Ja(s))
          return VM(s);
        var c = [];
        for (var g in bt(s))
          ut.call(s, g) && g != "constructor" && c.push(g);
        return c;
      }
      function GS(s) {
        if (!kt(s))
          return O2(s);
        var c = Ja(s), g = [];
        for (var w in s)
          (w != "constructor" || !c && ut.call(s, w)) && g.push(w);
        return g;
      }
      function Id(s, c) {
        return s < c;
      }
      function Ym(s, c) {
        var g = -1, w = Cn(s) ? jt(s.length) : [];
        return Tr(s, function(P, R, q) {
          w[++g] = c(P, R, q);
        }), w;
      }
      function Um(s) {
        var c = Ud(s);
        return c.length == 1 && c[0][2] ? kv(c[0][0], c[0][1]) : function(g) {
          return g === s || Ad(g, s, c);
        };
      }
      function qm(s, c) {
        return qd(s) && xv(c) ? kv(Ei(s), c) : function(g) {
          var w = Jd(g, s);
          return w === Y && w === c ? ef(g, s) : Ka(c, w, yr | Uo);
        };
      }
      function Al(s, c, g, w, P) {
        s !== c && hf(c, function(R, q) {
          if (P || (P = new _i()), kt(R))
            XS(s, c, q, g, Al, w, P);
          else {
            var G = w ? w(Xd(s, q), R, q + "", s, c, P) : Y;
            G === Y && (G = R), Cd(s, q, G);
          }
        }, On);
      }
      function XS(s, c, g, w, P, R, q) {
        var G = Xd(s, g), Z = Xd(c, g), se = q.get(Z);
        if (se)
          return Cd(s, g, se), Y;
        var ae = R ? R(G, Z, g + "", s, c, q) : Y, he = ae === Y;
        if (he) {
          var _e = He(Z), Te = !_e && Pr(Z), Ie = !_e && !Te && ua(Z);
          ae = Z, _e || Te || Ie ? He(G) ? ae = G : Vt(G) ? ae = Sn(G) : Te ? (he = !1, ae = iv(Z, !0)) : Ie ? (he = !1, ae = rv(Z, !0)) : ae = [] : es(Z) || yo(Z) ? (ae = G, yo(G) ? ae = qv(G) : kt(G) && !Qi(G) || (ae = _v(Z))) : he = !1;
        }
        he && (q.set(Z, ae), P(ae, Z, w, R, q), q.delete(Z)), Cd(s, g, ae);
      }
      function Gm(s, c) {
        var g = s.length;
        if (g)
          return c += c < 0 ? g : 0, Zi(c, g) ? s[c] : Y;
      }
      function Xm(s, c, g) {
        c = c.length ? f(c, function(P) {
          return He(P) ? function(R) {
            return go(R, P.length === 1 ? P[0] : P);
          } : P;
        }) : [Mn];
        var w = -1;
        return c = f(c, V($e())), M(Ym(s, function(P, R, q) {
          return { criteria: f(c, function(G) {
            return G(P);
          }), index: ++w, value: P };
        }), function(P, R) {
          return a2(P, R, g);
        });
      }
      function KS(s, c) {
        return Km(s, c, function(g, w) {
          return ef(s, w);
        });
      }
      function Km(s, c, g) {
        for (var w = -1, P = c.length, R = {}; ++w < P; ) {
          var q = c[w], G = go(s, q);
          g(G, q) && Za(R, Cr(q, s), G);
        }
        return R;
      }
      function ZS(s) {
        return function(c) {
          return go(c, s);
        };
      }
      function Dd(s, c, g, w) {
        var P = w ? D : O, R = -1, q = c.length, G = s;
        for (s === c && (c = Sn(c)), g && (G = f(s, V(g))); ++R < q; )
          for (var Z = 0, se = c[R], ae = g ? g(se) : se; (Z = P(G, ae, Z, w)) > -1; )
            G !== s && tu.call(G, Z, 1), tu.call(s, Z, 1);
        return s;
      }
      function Zm(s, c) {
        for (var g = s ? c.length : 0, w = g - 1; g--; ) {
          var P = c[g];
          if (g == w || P !== R) {
            var R = P;
            Zi(P) ? tu.call(s, P, 1) : $d(s, P);
          }
        }
        return s;
      }
      function Ld(s, c) {
        return s + ru(ap() * (c - s + 1));
      }
      function QS(s, c, g, w) {
        for (var P = -1, R = Yt(iu((c - s) / (g || 1)), 0), q = jt(R); R--; )
          q[w ? R : ++P] = s, s += g;
        return q;
      }
      function Bd(s, c) {
        var g = "";
        if (!s || c < 1 || c > Ti)
          return g;
        do
          c % 2 && (g += s), c = ru(c / 2), c && (s += s);
        while (c);
        return g;
      }
      function Ze(s, c) {
        return vf(Sv(s, c, Mn), s + "");
      }
      function JS(s) {
        return Vm(ia(s));
      }
      function e2(s, c) {
        var g = ia(s);
        return Nl(g, ho(c, 0, g.length));
      }
      function Za(s, c, g, w) {
        if (!kt(s))
          return s;
        c = Cr(c, s);
        for (var P = -1, R = c.length, q = R - 1, G = s; G != null && ++P < R; ) {
          var Z = Ei(c[P]), se = g;
          if (Z === "__proto__" || Z === "constructor" || Z === "prototype")
            return s;
          if (P != q) {
            var ae = G[Z];
            se = w ? w(ae, Z, G) : Y, se === Y && (se = kt(ae) ? ae : Zi(c[P + 1]) ? [] : {});
          }
          qa(G, Z, se), G = G[Z];
        }
        return s;
      }
      function t2(s) {
        return Nl(ia(s));
      }
      function ri(s, c, g) {
        var w = -1, P = s.length;
        c < 0 && (c = -c > P ? 0 : P + c), g = g > P ? P : g, g < 0 && (g += P), P = c > g ? 0 : g - c >>> 0, c >>>= 0;
        for (var R = jt(P); ++w < P; )
          R[w] = s[w + c];
        return R;
      }
      function n2(s, c) {
        var g;
        return Tr(s, function(w, P, R) {
          return g = c(w, P, R), !g;
        }), !!g;
      }
      function El(s, c, g) {
        var w = 0, P = s == null ? w : s.length;
        if (typeof c == "number" && c === c && P <= sd) {
          for (; w < P; ) {
            var R = w + P >>> 1, q = s[R];
            q !== null && !Nn(q) && (g ? q <= c : q < c) ? w = R + 1 : P = R;
          }
          return P;
        }
        return Vd(s, c, Mn, g);
      }
      function Vd(s, c, g, w) {
        var P = 0, R = s == null ? 0 : s.length;
        if (R === 0)
          return 0;
        c = g(c);
        for (var q = c !== c, G = c === null, Z = Nn(c), se = c === Y; P < R; ) {
          var ae = ru((P + R) / 2), he = g(s[ae]), _e = he !== Y, Te = he === null, Ie = he === he, Ge = Nn(he);
          if (q)
            var Le = w || Ie;
          else
            Le = se ? Ie && (w || _e) : G ? Ie && _e && (w || !Te) : Z ? Ie && _e && !Te && (w || !Ge) : !Te && !Ge && (w ? he <= c : he < c);
          Le ? P = ae + 1 : R = ae;
        }
        return ln(R, ad);
      }
      function Qm(s, c) {
        for (var g = -1, w = s.length, P = 0, R = []; ++g < w; ) {
          var q = s[g], G = c ? c(q) : q;
          if (!g || !xi(G, Z)) {
            var Z = G;
            R[P++] = q === 0 ? 0 : q;
          }
        }
        return R;
      }
      function Jm(s) {
        return typeof s == "number" ? s : Nn(s) ? qo : +s;
      }
      function Fn(s) {
        if (typeof s == "string")
          return s;
        if (He(s))
          return f(s, Fn) + "";
        if (Nn(s))
          return sp ? sp.call(s) : "";
        var c = s + "";
        return c == "0" && 1 / s == -Yi ? "-0" : c;
      }
      function Sr(s, c, g) {
        var w = -1, P = u, R = s.length, q = !0, G = [], Z = G;
        if (g)
          q = !1, P = d;
        else if (R >= Ht) {
          var se = c ? null : qM(s);
          if (se)
            return xe(se);
          q = !1, P = H, Z = new fo();
        } else
          Z = c ? [] : G;
        e:
          for (; ++w < R; ) {
            var ae = s[w], he = c ? c(ae) : ae;
            if (ae = g || ae !== 0 ? ae : 0, q && he === he) {
              for (var _e = Z.length; _e--; )
                if (Z[_e] === he)
                  continue e;
              c && Z.push(he), G.push(ae);
            } else
              P(Z, he, g) || (Z !== G && Z.push(he), G.push(ae));
          }
        return G;
      }
      function $d(s, c) {
        return c = Cr(c, s), s = Cv(s, c), s == null || delete s[Ei(oi(c))];
      }
      function ev(s, c, g, w) {
        return Za(s, c, g(go(s, c)), w);
      }
      function Il(s, c, g, w) {
        for (var P = s.length, R = w ? P : -1; (w ? R-- : ++R < P) && c(s[R], R, s); )
          ;
        return g ? ri(s, w ? 0 : R, w ? R + 1 : P) : ri(s, w ? R + 1 : 0, w ? P : R);
      }
      function tv(s, c) {
        var g = s;
        return g instanceof Ce && (g = g.value()), h(c, function(w, P) {
          return P.func.apply(P.thisArg, m([w], P.args));
        }, g);
      }
      function Rd(s, c, g) {
        var w = s.length;
        if (w < 2)
          return w ? Sr(s[0]) : [];
        for (var P = -1, R = jt(w); ++P < w; )
          for (var q = s[P], G = -1; ++G < w; )
            G != P && (R[P] = Ga(R[P] || q, s[G], c, g));
        return Sr(on(R, 1), c, g);
      }
      function nv(s, c, g) {
        for (var w = -1, P = s.length, R = c.length, q = {}; ++w < P; )
          g(q, s[w], w < R ? c[w] : Y);
        return q;
      }
      function Fd(s) {
        return Vt(s) ? s : [];
      }
      function Nd(s) {
        return typeof s == "function" ? s : Mn;
      }
      function Cr(s, c) {
        return He(s) ? s : qd(s, c) ? [s] : gp(lt(s));
      }
      function Or(s, c, g) {
        var w = s.length;
        return g = g === Y ? w : g, !c && g >= w ? s : ri(s, c, g);
      }
      function iv(s, c) {
        if (c)
          return s.slice();
        var g = s.length, w = tp ? tp(g) : new s.constructor(g);
        return s.copy(w), w;
      }
      function Wd(s) {
        var c = new s.constructor(s.byteLength);
        return new Jl(c).set(new Jl(s)), c;
      }
      function i2(s, c) {
        return new s.constructor(c ? Wd(s.buffer) : s.buffer, s.byteOffset, s.byteLength);
      }
      function r2(s) {
        var c = new s.constructor(s.source, lm.exec(s));
        return c.lastIndex = s.lastIndex, c;
      }
      function o2(s) {
        return os ? bt(os.call(s)) : {};
      }
      function rv(s, c) {
        return new s.constructor(c ? Wd(s.buffer) : s.buffer, s.byteOffset, s.length);
      }
      function ov(s, c) {
        if (s !== c) {
          var g = s !== Y, w = s === null, P = s === s, R = Nn(s), q = c !== Y, G = c === null, Z = c === c, se = Nn(c);
          if (!G && !se && !R && s > c || R && q && Z && !G && !se || w && q && Z || !g && Z || !P)
            return 1;
          if (!w && !R && !se && s < c || se && g && P && !w && !R || G && g && P || !q && P || !Z)
            return -1;
        }
        return 0;
      }
      function a2(s, c, g) {
        for (var w = -1, P = s.criteria, R = c.criteria, q = P.length, G = g.length; ++w < q; ) {
          var Z = ov(P[w], R[w]);
          if (Z)
            return w >= G ? Z : Z * (g[w] == "desc" ? -1 : 1);
        }
        return s.index - c.index;
      }
      function av(s, c, g, w) {
        for (var P = -1, R = s.length, q = g.length, G = -1, Z = c.length, se = Yt(R - q, 0), ae = jt(Z + se), he = !w; ++G < Z; )
          ae[G] = c[G];
        for (; ++P < q; )
          (he || P < R) && (ae[g[P]] = s[P]);
        for (; se--; )
          ae[G++] = s[P++];
        return ae;
      }
      function sv(s, c, g, w) {
        for (var P = -1, R = s.length, q = -1, G = g.length, Z = -1, se = c.length, ae = Yt(R - G, 0), he = jt(ae + se), _e = !w; ++P < ae; )
          he[P] = s[P];
        for (var Te = P; ++Z < se; )
          he[Te + Z] = c[Z];
        for (; ++q < G; )
          (_e || P < R) && (he[Te + g[q]] = s[P++]);
        return he;
      }
      function Sn(s, c) {
        var g = -1, w = s.length;
        for (c || (c = jt(w)); ++g < w; )
          c[g] = s[g];
        return c;
      }
      function Ai(s, c, g, w) {
        var P = !g;
        g || (g = {});
        for (var R = -1, q = c.length; ++R < q; ) {
          var G = c[R], Z = w ? w(g[G], s[G], G, g, s) : Y;
          Z === Y && (Z = s[G]), P ? Gi(g, G, Z) : qa(g, G, Z);
        }
        return g;
      }
      function s2(s, c) {
        return Ai(s, mf(s), c);
      }
      function l2(s, c) {
        return Ai(s, fp(s), c);
      }
      function Dl(s, c) {
        return function(g, w) {
          var P = He(g) ? i : IS, R = c ? c() : {};
          return P(g, s, $e(w, 2), R);
        };
      }
      function ea(s) {
        return Ze(function(c, g) {
          var w = -1, P = g.length, R = P > 1 ? g[P - 1] : Y, q = P > 2 ? g[2] : Y;
          for (R = s.length > 3 && typeof R == "function" ? (P--, R) : Y, q && pn(g[0], g[1], q) && (R = P < 3 ? Y : R, P = 1), c = bt(c); ++w < P; ) {
            var G = g[w];
            G && s(c, G, w, R);
          }
          return c;
        });
      }
      function lv(s, c) {
        return function(g, w) {
          if (g == null)
            return g;
          if (!Cn(g))
            return s(g, w);
          for (var P = g.length, R = c ? P : -1, q = bt(g); (c ? R-- : ++R < P) && w(q[R], R, q) !== !1; )
            ;
          return g;
        };
      }
      function uv(s) {
        return function(c, g, w) {
          for (var P = -1, R = bt(c), q = w(c), G = q.length; G--; ) {
            var Z = q[s ? G : ++P];
            if (g(R[Z], Z, R) === !1)
              break;
          }
          return c;
        };
      }
      function u2(s, c, g) {
        function w() {
          return (this && this !== rn && this instanceof w ? R : s).apply(P ? g : this, arguments);
        }
        var P = c & Xt, R = Qa(s);
        return w;
      }
      function cv(s) {
        return function(c) {
          c = lt(c);
          var g = ue(c) ? Ee(c) : Y, w = g ? g[0] : c.charAt(0), P = g ? Or(g, 1).join("") : c.slice(1);
          return w[s]() + P;
        };
      }
      function ta(s) {
        return function(c) {
          return h(Zv(Kv(c).replace(zk, "")), s, "");
        };
      }
      function Qa(s) {
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return new s();
            case 1:
              return new s(c[0]);
            case 2:
              return new s(c[0], c[1]);
            case 3:
              return new s(c[0], c[1], c[2]);
            case 4:
              return new s(c[0], c[1], c[2], c[3]);
            case 5:
              return new s(c[0], c[1], c[2], c[3], c[4]);
            case 6:
              return new s(c[0], c[1], c[2], c[3], c[4], c[5]);
            case 7:
              return new s(c[0], c[1], c[2], c[3], c[4], c[5], c[6]);
          }
          var g = la(s.prototype), w = s.apply(g, c);
          return kt(w) ? w : g;
        };
      }
      function c2(s, c, g) {
        function w() {
          for (var R = arguments.length, q = jt(R), G = R, Z = na(w); G--; )
            q[G] = arguments[G];
          var se = R < 3 && q[0] !== Z && q[R - 1] !== Z ? [] : me(q, Z);
          return R -= se.length, R < g ? mv(s, c, Ll, w.placeholder, Y, q, se, Y, Y, g - R) : n(this && this !== rn && this instanceof w ? P : s, this, q);
        }
        var P = Qa(s);
        return w;
      }
      function dv(s) {
        return function(c, g, w) {
          var P = bt(c);
          if (!Cn(c)) {
            var R = $e(g, 3);
            c = Kt(c), g = function(G) {
              return R(P[G], G, P);
            };
          }
          var q = s(c, g, w);
          return q > -1 ? P[R ? c[q] : q] : Y;
        };
      }
      function fv(s) {
        return Ki(function(c) {
          var g = c.length, w = g, P = Ve.prototype.thru;
          for (s && c.reverse(); w--; ) {
            var R = c[w];
            if (typeof R != "function")
              throw new si(nn);
            if (P && !q && Rl(R) == "wrapper")
              var q = new Ve([], !0);
          }
          for (w = q ? w : g; ++w < g; ) {
            R = c[w];
            var G = Rl(R), Z = G == "wrapper" ? gf(R) : Y;
            q = Z && Gd(Z[0]) && Z[1] == (bi | Qn | Jn | to) && !Z[4].length && Z[9] == 1 ? q[Rl(Z[0])].apply(q, Z[3]) : R.length == 1 && Gd(R) ? q[G]() : q.thru(R);
          }
          return function() {
            var se = arguments, ae = se[0];
            if (q && se.length == 1 && He(ae))
              return q.plant(ae).value();
            for (var he = 0, _e = g ? c[he].apply(this, se) : ae; ++he < g; )
              _e = c[he].call(this, _e);
            return _e;
          };
        });
      }
      function Ll(s, c, g, w, P, R, q, G, Z, se) {
        function ae() {
          for (var Qe = arguments.length, Je = jt(Qe), cn = Qe; cn--; )
            Je[cn] = arguments[cn];
          if (Ie)
            var Tn = na(ae), Ar = U(Je, Tn);
          if (w && (Je = av(Je, w, P, Ie)), R && (Je = sv(Je, R, q, Ie)), Qe -= Ar, Ie && Qe < se)
            return mv(s, c, Ll, ae.placeholder, g, Je, me(Je, Tn), G, Z, se - Qe);
          var Pt = _e ? g : this, li = Te ? Pt[s] : s;
          return Qe = Je.length, G ? Je = T2(Je, G) : Ge && Qe > 1 && Je.reverse(), he && Z < Qe && (Je.length = Z), this && this !== rn && this instanceof ae && (li = Le || Qa(li)), li.apply(Pt, Je);
        }
        var he = c & bi, _e = c & Xt, Te = c & ji, Ie = c & (Qn | br), Ge = c & Wa, Le = Te ? Y : Qa(s);
        return ae;
      }
      function hv(s, c) {
        return function(g, w) {
          return NS(g, s, c(w), {});
        };
      }
      function Bl(s, c) {
        return function(g, w) {
          var P;
          if (g === Y && w === Y)
            return c;
          if (g !== Y && (P = g), w !== Y) {
            if (P === Y)
              return w;
            typeof g == "string" || typeof w == "string" ? (g = Fn(g), w = Fn(w)) : (g = Jm(g), w = Jm(w)), P = s(g, w);
          }
          return P;
        };
      }
      function zd(s) {
        return Ki(function(c) {
          return c = f(c, V($e())), Ze(function(g) {
            var w = this;
            return s(c, function(P) {
              return n(P, w, g);
            });
          });
        });
      }
      function Vl(s, c) {
        c = c === Y ? " " : Fn(c);
        var g = c.length;
        if (g < 2)
          return g ? Bd(c, s) : c;
        var w = Bd(c, iu(s / be(c)));
        return ue(c) ? Or(Ee(w), 0, s).join("") : w.slice(0, s);
      }
      function d2(s, c, g, w) {
        function P() {
          for (var G = -1, Z = arguments.length, se = -1, ae = w.length, he = jt(ae + Z), _e = this && this !== rn && this instanceof P ? q : s; ++se < ae; )
            he[se] = w[se];
          for (; Z--; )
            he[se++] = arguments[++G];
          return n(_e, R ? g : this, he);
        }
        var R = c & Xt, q = Qa(s);
        return P;
      }
      function gv(s) {
        return function(c, g, w) {
          return w && typeof w != "number" && pn(c, g, w) && (g = w = Y), c = Ji(c), g === Y ? (g = c, c = 0) : g = Ji(g), w = w === Y ? c < g ? 1 : -1 : Ji(w), QS(c, g, w, s);
        };
      }
      function $l(s) {
        return function(c, g) {
          return typeof c == "string" && typeof g == "string" || (c = ai(c), g = ai(g)), s(c, g);
        };
      }
      function mv(s, c, g, w, P, R, q, G, Z, se) {
        var ae = c & Qn, he = ae ? q : Y, _e = ae ? Y : q, Te = ae ? R : Y, Ie = ae ? Y : R;
        c |= ae ? Jn : wr, c &= ~(ae ? wr : Jn), c & pl || (c &= ~(Xt | ji));
        var Ge = [s, c, P, Te, he, Ie, _e, G, Z, se], Le = g.apply(Y, Ge);
        return Gd(s) && hp(Le, Ge), Le.placeholder = w, Ov(Le, s, c);
      }
      function Hd(s) {
        var c = ra[s];
        return function(g, w) {
          if (g = ai(g), w = w == null ? 0 : ln(Ke(w), 292), w && op(g)) {
            var P = (lt(g) + "e").split("e");
            return P = (lt(c(P[0] + "e" + (+P[1] + w))) + "e").split("e"), +(P[0] + "e" + (+P[1] - w));
          }
          return c(g);
        };
      }
      function vv(s) {
        return function(c) {
          var g = un(c);
          return g == Vn ? J(c) : g == $n ? tt(c) : L(c, s(c));
        };
      }
      function Xi(s, c, g, w, P, R, q, G) {
        var Z = c & ji;
        if (!Z && typeof s != "function")
          throw new si(nn);
        var se = w ? w.length : 0;
        if (se || (c &= ~(Jn | wr), w = P = Y), q = q === Y ? q : Yt(Ke(q), 0), G = G === Y ? G : Ke(G), se -= P ? P.length : 0, c & wr) {
          var ae = w, he = P;
          w = P = Y;
        }
        var _e = Z ? Y : gf(s), Te = [s, c, g, w, P, ae, he, R, q, G];
        if (_e && C2(Te, _e), s = Te[0], c = Te[1], g = Te[2], w = Te[3], P = Te[4], G = Te[9] = Te[9] === Y ? Z ? 0 : s.length : Yt(Te[9] - se, 0), !G && c & (Qn | br) && (c &= ~(Qn | br)), c && c != Xt)
          Ie = c == Qn || c == br ? c2(s, c, G) : c != Jn && c != (Xt | Jn) || P.length ? Ll.apply(Y, Te) : d2(s, c, g, w);
        else
          var Ie = u2(s, c, g);
        return Ov((_e ? cp : hp)(Ie, Te), s, c);
      }
      function pv(s, c, g, w) {
        return s === Y || xi(s, oa[g]) && !ut.call(w, g) ? c : s;
      }
      function yv(s, c, g, w, P, R) {
        return kt(s) && kt(c) && (R.set(c, s), Al(s, c, Y, yv, R), R.delete(c)), s;
      }
      function f2(s) {
        return es(s) ? Y : s;
      }
      function bv(s, c, g, w, P, R) {
        var q = g & yr, G = s.length, Z = c.length;
        if (G != Z && !(q && Z > G))
          return !1;
        var se = R.get(s), ae = R.get(c);
        if (se && ae)
          return se == c && ae == s;
        var he = -1, _e = !0, Te = g & Uo ? new fo() : Y;
        for (R.set(s, c), R.set(c, s); ++he < G; ) {
          var Ie = s[he], Ge = c[he];
          if (w)
            var Le = q ? w(Ge, Ie, he, c, s, R) : w(Ie, Ge, he, s, c, R);
          if (Le !== Y) {
            if (Le)
              continue;
            _e = !1;
            break;
          }
          if (Te) {
            if (!y(c, function(Qe, Je) {
              if (!H(Te, Je) && (Ie === Qe || P(Ie, Qe, g, w, R)))
                return Te.push(Je);
            })) {
              _e = !1;
              break;
            }
          } else if (Ie !== Ge && !P(Ie, Ge, g, w, R)) {
            _e = !1;
            break;
          }
        }
        return R.delete(s), R.delete(c), _e;
      }
      function h2(s, c, g, w, P, R, q) {
        switch (g) {
          case xr:
            if (s.byteLength != c.byteLength || s.byteOffset != c.byteOffset)
              return !1;
            s = s.buffer, c = c.buffer;
          case lo:
            return !(s.byteLength != c.byteLength || !R(new Jl(s), new Jl(c)));
          case no:
          case io:
          case ro:
            return xi(+s, +c);
          case Xo:
            return s.name == c.name && s.message == c.message;
          case oo:
          case ao:
            return s == c + "";
          case Vn:
            var G = J;
          case $n:
            var Z = w & yr;
            if (G || (G = xe), s.size != c.size && !Z)
              return !1;
            var se = q.get(s);
            if (se)
              return se == c;
            w |= Uo, q.set(s, c);
            var ae = bv(G(s), G(c), w, P, R, q);
            return q.delete(s), ae;
          case Zo:
            if (os)
              return os.call(s) == os.call(c);
        }
        return !1;
      }
      function g2(s, c, g, w, P, R) {
        var q = g & yr, G = jd(s), Z = G.length;
        if (Z != jd(c).length && !q)
          return !1;
        for (var se = Z; se--; ) {
          var ae = G[se];
          if (!(q ? ae in c : ut.call(c, ae)))
            return !1;
        }
        var he = R.get(s), _e = R.get(c);
        if (he && _e)
          return he == c && _e == s;
        var Te = !0;
        R.set(s, c), R.set(c, s);
        for (var Ie = q; ++se < Z; ) {
          ae = G[se];
          var Ge = s[ae], Le = c[ae];
          if (w)
            var Qe = q ? w(Le, Ge, ae, c, s, R) : w(Ge, Le, ae, s, c, R);
          if (!(Qe === Y ? Ge === Le || P(Ge, Le, g, w, R) : Qe)) {
            Te = !1;
            break;
          }
          Ie || (Ie = ae == "constructor");
        }
        if (Te && !Ie) {
          var Je = s.constructor, cn = c.constructor;
          Je != cn && "constructor" in s && "constructor" in c && !(typeof Je == "function" && Je instanceof Je && typeof cn == "function" && cn instanceof cn) && (Te = !1);
        }
        return R.delete(s), R.delete(c), Te;
      }
      function Ki(s) {
        return vf(Sv(s, Y, Ev), s + "");
      }
      function jd(s) {
        return Wm(s, Kt, mf);
      }
      function Yd(s) {
        return Wm(s, On, fp);
      }
      function Rl(s) {
        for (var c = s.name + "", g = sa[c], w = ut.call(sa, c) ? g.length : 0; w--; ) {
          var P = g[w], R = P.func;
          if (R == null || R == s)
            return P.name;
        }
        return c;
      }
      function na(s) {
        return (ut.call(C, "placeholder") ? C : s).placeholder;
      }
      function $e() {
        var s = C.iteratee || nf;
        return s = s === nf ? jm : s, arguments.length ? s(arguments[0], arguments[1]) : s;
      }
      function Fl(s, c) {
        var g = s.__data__;
        return x2(c) ? g[typeof c == "string" ? "string" : "hash"] : g.map;
      }
      function Ud(s) {
        for (var c = Kt(s), g = c.length; g--; ) {
          var w = c[g], P = s[w];
          c[g] = [w, P, xv(P)];
        }
        return c;
      }
      function mo(s, c) {
        var g = te(s, c);
        return Hm(g) ? g : Y;
      }
      function m2(s) {
        var c = ut.call(s, po), g = s[po];
        try {
          s[po] = Y;
          var w = !0;
        } catch {
        }
        var P = Zl.call(s);
        return w && (c ? s[po] = g : delete s[po]), P;
      }
      function v2(s, c, g) {
        for (var w = -1, P = g.length; ++w < P; ) {
          var R = g[w], q = R.size;
          switch (R.type) {
            case "drop":
              s += q;
              break;
            case "dropRight":
              c -= q;
              break;
            case "take":
              c = ln(c, s + q);
              break;
            case "takeRight":
              s = Yt(s, c - q);
          }
        }
        return { start: s, end: c };
      }
      function p2(s) {
        var c = s.match(hk);
        return c ? c[1].split(gk) : [];
      }
      function wv(s, c, g) {
        c = Cr(c, s);
        for (var w = -1, P = c.length, R = !1; ++w < P; ) {
          var q = Ei(c[w]);
          if (!(R = s != null && g(s, q)))
            break;
          s = s[q];
        }
        return R || ++w != P ? R : (P = s == null ? 0 : s.length, !!P && Yl(P) && Zi(q, P) && (He(s) || yo(s)));
      }
      function y2(s) {
        var c = s.length, g = new s.constructor(c);
        return c && typeof s[0] == "string" && ut.call(s, "index") && (g.index = s.index, g.input = s.input), g;
      }
      function _v(s) {
        return typeof s.constructor != "function" || Ja(s) ? {} : la(eu(s));
      }
      function b2(s, c, g) {
        var w = s.constructor;
        switch (c) {
          case lo:
            return Wd(s);
          case no:
          case io:
            return new w(+s);
          case xr:
            return i2(s, g);
          case za:
          case Ha:
          case ja:
          case Ya:
          case ti:
          case Ua:
          case We:
          case Rn:
          case kr:
            return rv(s, g);
          case Vn:
            return new w();
          case ro:
          case ao:
            return new w(s);
          case oo:
            return r2(s);
          case $n:
            return new w();
          case Zo:
            return o2(s);
        }
      }
      function w2(s, c) {
        var g = c.length;
        if (!g)
          return s;
        var w = g - 1;
        return c[w] = (g > 1 ? "& " : "") + c[w], c = c.join(g > 2 ? ", " : " "), s.replace(fk, `{
/* [wrapped with ` + c + `] */
`);
      }
      function _2(s) {
        return He(s) || yo(s) || !!(rp && s && s[rp]);
      }
      function Zi(s, c) {
        var g = typeof s;
        return c = c ?? Ti, !!c && (g == "number" || g != "symbol" && kk.test(s)) && s > -1 && s % 1 == 0 && s < c;
      }
      function pn(s, c, g) {
        if (!kt(g))
          return !1;
        var w = typeof c;
        return !!(w == "number" ? Cn(g) && Zi(c, g.length) : w == "string" && c in g) && xi(g[c], s);
      }
      function qd(s, c) {
        if (He(s))
          return !1;
        var g = typeof s;
        return !(g != "number" && g != "symbol" && g != "boolean" && s != null && !Nn(s)) || lk.test(s) || !sk.test(s) || c != null && s in bt(c);
      }
      function x2(s) {
        var c = typeof s;
        return c == "string" || c == "number" || c == "symbol" || c == "boolean" ? s !== "__proto__" : s === null;
      }
      function Gd(s) {
        var c = Rl(s), g = C[c];
        if (typeof g != "function" || !(c in Ce.prototype))
          return !1;
        if (s === g)
          return !0;
        var w = gf(g);
        return !!w && s === w[0];
      }
      function k2(s) {
        return !!ep && ep in s;
      }
      function Ja(s) {
        var c = s && s.constructor;
        return s === (typeof c == "function" && c.prototype || oa);
      }
      function xv(s) {
        return s === s && !kt(s);
      }
      function kv(s, c) {
        return function(g) {
          return g != null && g[s] === c && (c !== Y || s in bt(g));
        };
      }
      function S2(s) {
        var c = Hl(s, function(w) {
          return g.size === Qc && g.clear(), w;
        }), g = c.cache;
        return c;
      }
      function C2(s, c) {
        var g = s[1], w = c[1], P = g | w, R = P < (Xt | ji | bi), q = w == bi && g == Qn || w == bi && g == to && s[7].length <= c[8] || w == (bi | to) && c[7].length <= c[8] && g == Qn;
        if (!R && !q)
          return s;
        w & Xt && (s[2] = c[2], P |= g & Xt ? 0 : pl);
        var G = c[3];
        if (G) {
          var Z = s[3];
          s[3] = Z ? av(Z, G, c[4]) : G, s[4] = Z ? me(s[3], Yo) : c[4];
        }
        return G = c[5], G && (Z = s[5], s[5] = Z ? sv(Z, G, c[6]) : G, s[6] = Z ? me(s[5], Yo) : c[6]), G = c[7], G && (s[7] = G), w & bi && (s[8] = s[8] == null ? c[8] : ln(s[8], c[8])), s[9] == null && (s[9] = c[9]), s[0] = c[0], s[1] = P, s;
      }
      function O2(s) {
        var c = [];
        if (s != null)
          for (var g in bt(s))
            c.push(g);
        return c;
      }
      function M2(s) {
        return Zl.call(s);
      }
      function Sv(s, c, g) {
        return c = Yt(c === Y ? s.length - 1 : c, 0), function() {
          for (var w = arguments, P = -1, R = Yt(w.length - c, 0), q = jt(R); ++P < R; )
            q[P] = w[c + P];
          P = -1;
          for (var G = jt(c + 1); ++P < c; )
            G[P] = w[P];
          return G[c] = g(q), n(s, this, G);
        };
      }
      function Cv(s, c) {
        return c.length < 2 ? s : go(s, ri(c, 0, -1));
      }
      function T2(s, c) {
        for (var g = s.length, w = ln(c.length, g), P = Sn(s); w--; ) {
          var R = c[w];
          s[w] = Zi(R, g) ? P[R] : Y;
        }
        return s;
      }
      function Xd(s, c) {
        if ((c !== "constructor" || typeof s[c] != "function") && c != "__proto__")
          return s[c];
      }
      function Ov(s, c, g) {
        var w = c + "";
        return vf(s, w2(w, P2(p2(w), g)));
      }
      function Mv(s) {
        var c = 0, g = 0;
        return function() {
          var w = $M(), P = nd - (w - g);
          if (g = w, P > 0) {
            if (++c >= td)
              return arguments[0];
          } else
            c = 0;
          return s.apply(Y, arguments);
        };
      }
      function Nl(s, c) {
        var g = -1, w = s.length, P = w - 1;
        for (c = c === Y ? w : c; ++g < c; ) {
          var R = Ld(g, P), q = s[R];
          s[R] = s[g], s[g] = q;
        }
        return s.length = c, s;
      }
      function Ei(s) {
        if (typeof s == "string" || Nn(s))
          return s;
        var c = s + "";
        return c == "0" && 1 / s == -Yi ? "-0" : c;
      }
      function vo(s) {
        if (s != null) {
          try {
            return Kl.call(s);
          } catch {
          }
          try {
            return s + "";
          } catch {
          }
        }
        return "";
      }
      function P2(s, c) {
        return r(ld, function(g) {
          var w = "_." + g[0];
          c & g[1] && !u(s, w) && s.push(w);
        }), s.sort();
      }
      function Tv(s) {
        if (s instanceof Ce)
          return s.clone();
        var c = new Ve(s.__wrapped__, s.__chain__);
        return c.__actions__ = Sn(s.__actions__), c.__index__ = s.__index__, c.__values__ = s.__values__, c;
      }
      function A2(s, c, g) {
        c = (g ? pn(s, c, g) : c === Y) ? 1 : Yt(Ke(c), 0);
        var w = s == null ? 0 : s.length;
        if (!w || c < 1)
          return [];
        for (var P = 0, R = 0, q = jt(iu(w / c)); P < w; )
          q[R++] = ri(s, P, P += c);
        return q;
      }
      function E2(s) {
        for (var c = -1, g = s == null ? 0 : s.length, w = 0, P = []; ++c < g; ) {
          var R = s[c];
          R && (P[w++] = R);
        }
        return P;
      }
      function I2() {
        var s = arguments.length;
        if (!s)
          return [];
        for (var c = jt(s - 1), g = arguments[0], w = s; w--; )
          c[w - 1] = arguments[w];
        return m(He(g) ? Sn(g) : [g], on(c, 1));
      }
      function D2(s, c, g) {
        var w = s == null ? 0 : s.length;
        return w ? (c = g || c === Y ? 1 : Ke(c), ri(s, c < 0 ? 0 : c, w)) : [];
      }
      function L2(s, c, g) {
        var w = s == null ? 0 : s.length;
        return w ? (c = g || c === Y ? 1 : Ke(c), c = w - c, ri(s, 0, c < 0 ? 0 : c)) : [];
      }
      function B2(s, c) {
        return s && s.length ? Il(s, $e(c, 3), !0, !0) : [];
      }
      function V2(s, c) {
        return s && s.length ? Il(s, $e(c, 3), !0) : [];
      }
      function $2(s, c, g, w) {
        var P = s == null ? 0 : s.length;
        return P ? (g && typeof g != "number" && pn(s, c, g) && (g = 0, w = P), VS(s, c, g, w)) : [];
      }
      function Pv(s, c, g) {
        var w = s == null ? 0 : s.length;
        if (!w)
          return -1;
        var P = g == null ? 0 : Ke(g);
        return P < 0 && (P = Yt(w + P, 0)), _(s, $e(c, 3), P);
      }
      function Av(s, c, g) {
        var w = s == null ? 0 : s.length;
        if (!w)
          return -1;
        var P = w - 1;
        return g !== Y && (P = Ke(g), P = g < 0 ? Yt(w + P, 0) : ln(P, w - 1)), _(s, $e(c, 3), P, !0);
      }
      function Ev(s) {
        return s != null && s.length ? on(s, 1) : [];
      }
      function R2(s) {
        return s != null && s.length ? on(s, Yi) : [];
      }
      function F2(s, c) {
        return s != null && s.length ? (c = c === Y ? 1 : Ke(c), on(s, c)) : [];
      }
      function N2(s) {
        for (var c = -1, g = s == null ? 0 : s.length, w = {}; ++c < g; ) {
          var P = s[c];
          w[P[0]] = P[1];
        }
        return w;
      }
      function Iv(s) {
        return s && s.length ? s[0] : Y;
      }
      function W2(s, c, g) {
        var w = s == null ? 0 : s.length;
        if (!w)
          return -1;
        var P = g == null ? 0 : Ke(g);
        return P < 0 && (P = Yt(w + P, 0)), O(s, c, P);
      }
      function z2(s) {
        return s != null && s.length ? ri(s, 0, -1) : [];
      }
      function H2(s, c) {
        return s == null ? "" : BM.call(s, c);
      }
      function oi(s) {
        var c = s == null ? 0 : s.length;
        return c ? s[c - 1] : Y;
      }
      function j2(s, c, g) {
        var w = s == null ? 0 : s.length;
        if (!w)
          return -1;
        var P = w;
        return g !== Y && (P = Ke(g), P = P < 0 ? Yt(w + P, 0) : ln(P, w - 1)), c === c ? fe(s, c, P) : _(s, F, P, !0);
      }
      function Y2(s, c) {
        return s && s.length ? Gm(s, Ke(c)) : Y;
      }
      function Dv(s, c) {
        return s && s.length && c && c.length ? Dd(s, c) : s;
      }
      function U2(s, c, g) {
        return s && s.length && c && c.length ? Dd(s, c, $e(g, 2)) : s;
      }
      function q2(s, c, g) {
        return s && s.length && c && c.length ? Dd(s, c, Y, g) : s;
      }
      function G2(s, c) {
        var g = [];
        if (!s || !s.length)
          return g;
        var w = -1, P = [], R = s.length;
        for (c = $e(c, 3); ++w < R; ) {
          var q = s[w];
          c(q, w, s) && (g.push(q), P.push(w));
        }
        return Zm(s, P), g;
      }
      function Kd(s) {
        return s == null ? s : FM.call(s);
      }
      function X2(s, c, g) {
        var w = s == null ? 0 : s.length;
        return w ? (g && typeof g != "number" && pn(s, c, g) ? (c = 0, g = w) : (c = c == null ? 0 : Ke(c), g = g === Y ? w : Ke(g)), ri(s, c, g)) : [];
      }
      function K2(s, c) {
        return El(s, c);
      }
      function Z2(s, c, g) {
        return Vd(s, c, $e(g, 2));
      }
      function Q2(s, c) {
        var g = s == null ? 0 : s.length;
        if (g) {
          var w = El(s, c);
          if (w < g && xi(s[w], c))
            return w;
        }
        return -1;
      }
      function J2(s, c) {
        return El(s, c, !0);
      }
      function eC(s, c, g) {
        return Vd(s, c, $e(g, 2), !0);
      }
      function tC(s, c) {
        if (s != null && s.length) {
          var g = El(s, c, !0) - 1;
          if (xi(s[g], c))
            return g;
        }
        return -1;
      }
      function nC(s) {
        return s && s.length ? Qm(s) : [];
      }
      function iC(s, c) {
        return s && s.length ? Qm(s, $e(c, 2)) : [];
      }
      function rC(s) {
        var c = s == null ? 0 : s.length;
        return c ? ri(s, 1, c) : [];
      }
      function oC(s, c, g) {
        return s && s.length ? (c = g || c === Y ? 1 : Ke(c), ri(s, 0, c < 0 ? 0 : c)) : [];
      }
      function aC(s, c, g) {
        var w = s == null ? 0 : s.length;
        return w ? (c = g || c === Y ? 1 : Ke(c), c = w - c, ri(s, c < 0 ? 0 : c, w)) : [];
      }
      function sC(s, c) {
        return s && s.length ? Il(s, $e(c, 3), !1, !0) : [];
      }
      function lC(s, c) {
        return s && s.length ? Il(s, $e(c, 3)) : [];
      }
      function uC(s) {
        return s && s.length ? Sr(s) : [];
      }
      function cC(s, c) {
        return s && s.length ? Sr(s, $e(c, 2)) : [];
      }
      function dC(s, c) {
        return c = typeof c == "function" ? c : Y, s && s.length ? Sr(s, Y, c) : [];
      }
      function Zd(s) {
        if (!s || !s.length)
          return [];
        var c = 0;
        return s = l(s, function(g) {
          if (Vt(g))
            return c = Yt(g.length, c), !0;
        }), I(c, function(g) {
          return f(s, A(g));
        });
      }
      function Lv(s, c) {
        if (!s || !s.length)
          return [];
        var g = Zd(s);
        return c == null ? g : f(g, function(w) {
          return n(c, Y, w);
        });
      }
      function fC(s, c) {
        return nv(s || [], c || [], qa);
      }
      function hC(s, c) {
        return nv(s || [], c || [], Za);
      }
      function Bv(s) {
        var c = C(s);
        return c.__chain__ = !0, c;
      }
      function gC(s, c) {
        return c(s), s;
      }
      function Wl(s, c) {
        return c(s);
      }
      function mC() {
        return Bv(this);
      }
      function vC() {
        return new Ve(this.value(), this.__chain__);
      }
      function pC() {
        this.__values__ === Y && (this.__values__ = Yv(this.value()));
        var s = this.__index__ >= this.__values__.length;
        return { done: s, value: s ? Y : this.__values__[this.__index__++] };
      }
      function yC() {
        return this;
      }
      function bC(s) {
        for (var c, g = this; g instanceof Se; ) {
          var w = Tv(g);
          w.__index__ = 0, w.__values__ = Y, c ? P.__wrapped__ = w : c = w;
          var P = w;
          g = g.__wrapped__;
        }
        return P.__wrapped__ = s, c;
      }
      function wC() {
        var s = this.__wrapped__;
        if (s instanceof Ce) {
          var c = s;
          return this.__actions__.length && (c = new Ce(this)), c = c.reverse(), c.__actions__.push({ func: Wl, args: [Kd], thisArg: Y }), new Ve(c, this.__chain__);
        }
        return this.thru(Kd);
      }
      function _C() {
        return tv(this.__wrapped__, this.__actions__);
      }
      function xC(s, c, g) {
        var w = He(s) ? a : BS;
        return g && pn(s, c, g) && (c = Y), w(s, $e(c, 3));
      }
      function kC(s, c) {
        return (He(s) ? l : Nm)(s, $e(c, 3));
      }
      function SC(s, c) {
        return on(zl(s, c), 1);
      }
      function CC(s, c) {
        return on(zl(s, c), Yi);
      }
      function OC(s, c, g) {
        return g = g === Y ? 1 : Ke(g), on(zl(s, c), g);
      }
      function Vv(s, c) {
        return (He(s) ? r : Tr)(s, $e(c, 3));
      }
      function $v(s, c) {
        return (He(s) ? o : lp)(s, $e(c, 3));
      }
      function MC(s, c, g, w) {
        s = Cn(s) ? s : ia(s), g = g && !w ? Ke(g) : 0;
        var P = s.length;
        return g < 0 && (g = Yt(P + g, 0)), Ul(s) ? g <= P && s.indexOf(c, g) > -1 : !!P && O(s, c, g) > -1;
      }
      function zl(s, c) {
        return (He(s) ? f : Ym)(s, $e(c, 3));
      }
      function TC(s, c, g, w) {
        return s == null ? [] : (He(c) || (c = c == null ? [] : [c]), g = w ? Y : g, He(g) || (g = g == null ? [] : [g]), Xm(s, c, g));
      }
      function PC(s, c, g) {
        var w = He(s) ? h : S, P = arguments.length < 3;
        return w(s, $e(c, 4), g, P, Tr);
      }
      function AC(s, c, g) {
        var w = He(s) ? v : S, P = arguments.length < 3;
        return w(s, $e(c, 4), g, P, lp);
      }
      function EC(s, c) {
        return (He(s) ? l : Nm)(s, jl($e(c, 3)));
      }
      function IC(s) {
        return (He(s) ? Vm : JS)(s);
      }
      function DC(s, c, g) {
        return c = (g ? pn(s, c, g) : c === Y) ? 1 : Ke(c), (He(s) ? AS : e2)(s, c);
      }
      function LC(s) {
        return (He(s) ? ES : t2)(s);
      }
      function BC(s) {
        if (s == null)
          return 0;
        if (Cn(s))
          return Ul(s) ? be(s) : s.length;
        var c = un(s);
        return c == Vn || c == $n ? s.size : Ed(s).length;
      }
      function VC(s, c, g) {
        var w = He(s) ? y : n2;
        return g && pn(s, c, g) && (c = Y), w(s, $e(c, 3));
      }
      function $C(s, c) {
        if (typeof c != "function")
          throw new si(nn);
        return s = Ke(s), function() {
          if (--s < 1)
            return c.apply(this, arguments);
        };
      }
      function Rv(s, c, g) {
        return c = g ? Y : c, c = s && c == null ? s.length : c, Xi(s, bi, Y, Y, Y, Y, c);
      }
      function Fv(s, c) {
        var g;
        if (typeof c != "function")
          throw new si(nn);
        return s = Ke(s), function() {
          return --s > 0 && (g = c.apply(this, arguments)), s <= 1 && (c = Y), g;
        };
      }
      function Nv(s, c, g) {
        c = g ? Y : c;
        var w = Xi(s, Qn, Y, Y, Y, Y, Y, c);
        return w.placeholder = Nv.placeholder, w;
      }
      function Wv(s, c, g) {
        c = g ? Y : c;
        var w = Xi(s, br, Y, Y, Y, Y, Y, c);
        return w.placeholder = Wv.placeholder, w;
      }
      function zv(s, c, g) {
        function w(Pt) {
          var li = _e, ss = Te;
          return _e = Te = Y, Je = Pt, Ge = s.apply(ss, li);
        }
        function P(Pt) {
          return Je = Pt, Le = as(G, c), cn ? w(Pt) : Ge;
        }
        function R(Pt) {
          var li = Pt - Qe, ss = Pt - Je, Sp = c - li;
          return Tn ? ln(Sp, Ie - ss) : Sp;
        }
        function q(Pt) {
          var li = Pt - Qe, ss = Pt - Je;
          return Qe === Y || li >= c || li < 0 || Tn && ss >= Ie;
        }
        function G() {
          var Pt = su();
          return q(Pt) ? Z(Pt) : (Le = as(G, R(Pt)), Y);
        }
        function Z(Pt) {
          return Le = Y, Ar && _e ? w(Pt) : (_e = Te = Y, Ge);
        }
        function se() {
          Le !== Y && dp(Le), Je = 0, _e = Qe = Te = Le = Y;
        }
        function ae() {
          return Le === Y ? Ge : Z(su());
        }
        function he() {
          var Pt = su(), li = q(Pt);
          if (_e = arguments, Te = this, Qe = Pt, li) {
            if (Le === Y)
              return P(Qe);
            if (Tn)
              return dp(Le), Le = as(G, c), w(Qe);
          }
          return Le === Y && (Le = as(G, c)), Ge;
        }
        var _e, Te, Ie, Ge, Le, Qe, Je = 0, cn = !1, Tn = !1, Ar = !0;
        if (typeof s != "function")
          throw new si(nn);
        return c = ai(c) || 0, kt(g) && (cn = !!g.leading, Tn = "maxWait" in g, Ie = Tn ? Yt(ai(g.maxWait) || 0, c) : Ie, Ar = "trailing" in g ? !!g.trailing : Ar), he.cancel = se, he.flush = ae, he;
      }
      function RC(s) {
        return Xi(s, Wa);
      }
      function Hl(s, c) {
        if (typeof s != "function" || c != null && typeof c != "function")
          throw new si(nn);
        var g = function() {
          var w = arguments, P = c ? c.apply(this, w) : w[0], R = g.cache;
          if (R.has(P))
            return R.get(P);
          var q = s.apply(this, w);
          return g.cache = R.set(P, q) || R, q;
        };
        return g.cache = new (Hl.Cache || qi)(), g;
      }
      function jl(s) {
        if (typeof s != "function")
          throw new si(nn);
        return function() {
          var c = arguments;
          switch (c.length) {
            case 0:
              return !s.call(this);
            case 1:
              return !s.call(this, c[0]);
            case 2:
              return !s.call(this, c[0], c[1]);
            case 3:
              return !s.call(this, c[0], c[1], c[2]);
          }
          return !s.apply(this, c);
        };
      }
      function FC(s) {
        return Fv(2, s);
      }
      function NC(s, c) {
        if (typeof s != "function")
          throw new si(nn);
        return c = c === Y ? c : Ke(c), Ze(s, c);
      }
      function WC(s, c) {
        if (typeof s != "function")
          throw new si(nn);
        return c = c == null ? 0 : Yt(Ke(c), 0), Ze(function(g) {
          var w = g[c], P = Or(g, 0, c);
          return w && m(P, w), n(s, this, P);
        });
      }
      function zC(s, c, g) {
        var w = !0, P = !0;
        if (typeof s != "function")
          throw new si(nn);
        return kt(g) && (w = "leading" in g ? !!g.leading : w, P = "trailing" in g ? !!g.trailing : P), zv(s, c, { leading: w, maxWait: c, trailing: P });
      }
      function HC(s) {
        return Rv(s, 1);
      }
      function jC(s, c) {
        return yf(Nd(c), s);
      }
      function YC() {
        if (!arguments.length)
          return [];
        var s = arguments[0];
        return He(s) ? s : [s];
      }
      function UC(s) {
        return ii(s, pr);
      }
      function qC(s, c) {
        return c = typeof c == "function" ? c : Y, ii(s, pr, c);
      }
      function GC(s) {
        return ii(s, Mi | pr);
      }
      function XC(s, c) {
        return c = typeof c == "function" ? c : Y, ii(s, Mi | pr, c);
      }
      function KC(s, c) {
        return c == null || Rm(s, c, Kt(c));
      }
      function xi(s, c) {
        return s === c || s !== s && c !== c;
      }
      function Cn(s) {
        return s != null && Yl(s.length) && !Qi(s);
      }
      function Vt(s) {
        return Tt(s) && Cn(s);
      }
      function ZC(s) {
        return s === !0 || s === !1 || Tt(s) && vn(s) == no;
      }
      function QC(s) {
        return Tt(s) && s.nodeType === 1 && !es(s);
      }
      function JC(s) {
        if (s == null)
          return !0;
        if (Cn(s) && (He(s) || typeof s == "string" || typeof s.splice == "function" || Pr(s) || ua(s) || yo(s)))
          return !s.length;
        var c = un(s);
        if (c == Vn || c == $n)
          return !s.size;
        if (Ja(s))
          return !Ed(s).length;
        for (var g in s)
          if (ut.call(s, g))
            return !1;
        return !0;
      }
      function eO(s, c) {
        return Ka(s, c);
      }
      function tO(s, c, g) {
        g = typeof g == "function" ? g : Y;
        var w = g ? g(s, c) : Y;
        return w === Y ? Ka(s, c, Y, g) : !!w;
      }
      function Qd(s) {
        if (!Tt(s))
          return !1;
        var c = vn(s);
        return c == Xo || c == cd || typeof s.message == "string" && typeof s.name == "string" && !es(s);
      }
      function nO(s) {
        return typeof s == "number" && op(s);
      }
      function Qi(s) {
        if (!kt(s))
          return !1;
        var c = vn(s);
        return c == Ko || c == bl || c == ud || c == fd;
      }
      function Hv(s) {
        return typeof s == "number" && s == Ke(s);
      }
      function Yl(s) {
        return typeof s == "number" && s > -1 && s % 1 == 0 && s <= Ti;
      }
      function kt(s) {
        var c = typeof s;
        return s != null && (c == "object" || c == "function");
      }
      function Tt(s) {
        return s != null && typeof s == "object";
      }
      function iO(s, c) {
        return s === c || Ad(s, c, Ud(c));
      }
      function rO(s, c, g) {
        return g = typeof g == "function" ? g : Y, Ad(s, c, Ud(c), g);
      }
      function oO(s) {
        return jv(s) && s != +s;
      }
      function aO(s) {
        if (GM(s))
          throw new lf(jo);
        return Hm(s);
      }
      function sO(s) {
        return s === null;
      }
      function lO(s) {
        return s == null;
      }
      function jv(s) {
        return typeof s == "number" || Tt(s) && vn(s) == ro;
      }
      function es(s) {
        if (!Tt(s) || vn(s) != wi)
          return !1;
        var c = eu(s);
        if (c === null)
          return !0;
        var g = ut.call(c, "constructor") && c.constructor;
        return typeof g == "function" && g instanceof g && Kl.call(g) == TM;
      }
      function uO(s) {
        return Hv(s) && s >= -Ti && s <= Ti;
      }
      function Ul(s) {
        return typeof s == "string" || !He(s) && Tt(s) && vn(s) == ao;
      }
      function Nn(s) {
        return typeof s == "symbol" || Tt(s) && vn(s) == Zo;
      }
      function cO(s) {
        return s === Y;
      }
      function dO(s) {
        return Tt(s) && un(s) == so;
      }
      function fO(s) {
        return Tt(s) && vn(s) == gd;
      }
      function Yv(s) {
        if (!s)
          return [];
        if (Cn(s))
          return Ul(s) ? Ee(s) : Sn(s);
        if (ts && s[ts])
          return Q(s[ts]());
        var c = un(s);
        return (c == Vn ? J : c == $n ? xe : ia)(s);
      }
      function Ji(s) {
        return s ? (s = ai(s), s === Yi || s === -Yi ? (s < 0 ? -1 : 1) * od : s === s ? s : 0) : s === 0 ? s : 0;
      }
      function Ke(s) {
        var c = Ji(s), g = c % 1;
        return c === c ? g ? c - g : c : 0;
      }
      function Uv(s) {
        return s ? ho(Ke(s), 0, ei) : 0;
      }
      function ai(s) {
        if (typeof s == "number")
          return s;
        if (Nn(s))
          return qo;
        if (kt(s)) {
          var c = typeof s.valueOf == "function" ? s.valueOf() : s;
          s = kt(c) ? c + "" : c;
        }
        if (typeof s != "string")
          return s === 0 ? s : +s;
        s = N(s);
        var g = wk.test(s);
        return g || xk.test(s) ? eS(s.slice(2), g ? 2 : 8) : bk.test(s) ? qo : +s;
      }
      function qv(s) {
        return Ai(s, On(s));
      }
      function hO(s) {
        return s ? ho(Ke(s), -Ti, Ti) : s === 0 ? s : 0;
      }
      function lt(s) {
        return s == null ? "" : Fn(s);
      }
      function gO(s, c) {
        var g = la(s);
        return c == null ? g : $m(g, c);
      }
      function mO(s, c) {
        return x(s, $e(c, 3), Pi);
      }
      function vO(s, c) {
        return x(s, $e(c, 3), Md);
      }
      function pO(s, c) {
        return s == null ? s : hf(s, $e(c, 3), On);
      }
      function yO(s, c) {
        return s == null ? s : up(s, $e(c, 3), On);
      }
      function bO(s, c) {
        return s && Pi(s, $e(c, 3));
      }
      function wO(s, c) {
        return s && Md(s, $e(c, 3));
      }
      function _O(s) {
        return s == null ? [] : Pl(s, Kt(s));
      }
      function xO(s) {
        return s == null ? [] : Pl(s, On(s));
      }
      function Jd(s, c, g) {
        var w = s == null ? Y : go(s, c);
        return w === Y ? g : w;
      }
      function kO(s, c) {
        return s != null && wv(s, c, $S);
      }
      function ef(s, c) {
        return s != null && wv(s, c, RS);
      }
      function Kt(s) {
        return Cn(s) ? Bm(s) : Ed(s);
      }
      function On(s) {
        return Cn(s) ? Bm(s, !0) : GS(s);
      }
      function SO(s, c) {
        var g = {};
        return c = $e(c, 3), Pi(s, function(w, P, R) {
          Gi(g, c(w, P, R), w);
        }), g;
      }
      function CO(s, c) {
        var g = {};
        return c = $e(c, 3), Pi(s, function(w, P, R) {
          Gi(g, P, c(w, P, R));
        }), g;
      }
      function OO(s, c) {
        return Gv(s, jl($e(c)));
      }
      function Gv(s, c) {
        if (s == null)
          return {};
        var g = f(Yd(s), function(w) {
          return [w];
        });
        return c = $e(c), Km(s, g, function(w, P) {
          return c(w, P[0]);
        });
      }
      function MO(s, c, g) {
        c = Cr(c, s);
        var w = -1, P = c.length;
        for (P || (P = 1, s = Y); ++w < P; ) {
          var R = s == null ? Y : s[Ei(c[w])];
          R === Y && (w = P, R = g), s = Qi(R) ? R.call(s) : R;
        }
        return s;
      }
      function TO(s, c, g) {
        return s == null ? s : Za(s, c, g);
      }
      function PO(s, c, g, w) {
        return w = typeof w == "function" ? w : Y, s == null ? s : Za(s, c, g, w);
      }
      function AO(s, c, g) {
        var w = He(s), P = w || Pr(s) || ua(s);
        if (c = $e(c, 4), g == null) {
          var R = s && s.constructor;
          g = P ? w ? new R() : [] : kt(s) && Qi(R) ? la(eu(s)) : {};
        }
        return (P ? r : Pi)(s, function(q, G, Z) {
          return c(g, q, G, Z);
        }), g;
      }
      function EO(s, c) {
        return s == null || $d(s, c);
      }
      function IO(s, c, g) {
        return s == null ? s : ev(s, c, Nd(g));
      }
      function DO(s, c, g, w) {
        return w = typeof w == "function" ? w : Y, s == null ? s : ev(s, c, Nd(g), w);
      }
      function ia(s) {
        return s == null ? [] : z(s, Kt(s));
      }
      function LO(s) {
        return s == null ? [] : z(s, On(s));
      }
      function BO(s, c, g) {
        return g === Y && (g = c, c = Y), g !== Y && (g = ai(g), g = g === g ? g : 0), c !== Y && (c = ai(c), c = c === c ? c : 0), ho(ai(s), c, g);
      }
      function VO(s, c, g) {
        return c = Ji(c), g === Y ? (g = c, c = 0) : g = Ji(g), s = ai(s), FS(s, c, g);
      }
      function $O(s, c, g) {
        if (g && typeof g != "boolean" && pn(s, c, g) && (c = g = Y), g === Y && (typeof c == "boolean" ? (g = c, c = Y) : typeof s == "boolean" && (g = s, s = Y)), s === Y && c === Y ? (s = 0, c = 1) : (s = Ji(s), c === Y ? (c = s, s = 0) : c = Ji(c)), s > c) {
          var w = s;
          s = c, c = w;
        }
        if (g || s % 1 || c % 1) {
          var P = ap();
          return ln(s + P * (c - s + Jk("1e-" + ((P + "").length - 1))), c);
        }
        return Ld(s, c);
      }
      function Xv(s) {
        return wf(lt(s).toLowerCase());
      }
      function Kv(s) {
        return s = lt(s), s && s.replace(Sk, iS).replace(Hk, "");
      }
      function RO(s, c, g) {
        s = lt(s), c = Fn(c);
        var w = s.length;
        g = g === Y ? w : ho(Ke(g), 0, w);
        var P = g;
        return g -= c.length, g >= 0 && s.slice(g, P) == c;
      }
      function FO(s) {
        return s = lt(s), s && rk.test(s) ? s.replace(am, rS) : s;
      }
      function NO(s) {
        return s = lt(s), s && ck.test(s) ? s.replace(md, "\\$&") : s;
      }
      function WO(s, c, g) {
        s = lt(s), c = Ke(c);
        var w = c ? be(s) : 0;
        if (!c || w >= c)
          return s;
        var P = (c - w) / 2;
        return Vl(ru(P), g) + s + Vl(iu(P), g);
      }
      function zO(s, c, g) {
        s = lt(s), c = Ke(c);
        var w = c ? be(s) : 0;
        return c && w < c ? s + Vl(c - w, g) : s;
      }
      function HO(s, c, g) {
        s = lt(s), c = Ke(c);
        var w = c ? be(s) : 0;
        return c && w < c ? Vl(c - w, g) + s : s;
      }
      function jO(s, c, g) {
        return g || c == null ? c = 0 : c && (c = +c), RM(lt(s).replace(vd, ""), c || 0);
      }
      function YO(s, c, g) {
        return c = (g ? pn(s, c, g) : c === Y) ? 1 : Ke(c), Bd(lt(s), c);
      }
      function UO() {
        var s = arguments, c = lt(s[0]);
        return s.length < 3 ? c : c.replace(s[1], s[2]);
      }
      function qO(s, c, g) {
        return g && typeof g != "number" && pn(s, c, g) && (c = g = Y), (g = g === Y ? ei : g >>> 0) ? (s = lt(s), s && (typeof c == "string" || c != null && !bf(c)) && (c = Fn(c), !c && ue(s)) ? Or(Ee(s), 0, g) : s.split(c, g)) : [];
      }
      function GO(s, c, g) {
        return s = lt(s), g = g == null ? 0 : ho(Ke(g), 0, s.length), c = Fn(c), s.slice(g, g + c.length) == c;
      }
      function XO(s, c, g) {
        var w = C.templateSettings;
        g && pn(s, c, g) && (c = Y), s = lt(s), c = lu({}, c, w, pv);
        var P, R, q = lu({}, c.imports, w.imports, pv), G = Kt(q), Z = z(q, G), se = 0, ae = c.interpolate || Sl, he = "__p += '", _e = uf((c.escape || Sl).source + "|" + ae.source + "|" + (ae === sm ? yk : Sl).source + "|" + (c.evaluate || Sl).source + "|$", "g"), Te = "//# sourceURL=" + (ut.call(c, "sourceURL") ? (c.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Gk + "]") + `
`;
        s.replace(_e, function(Le, Qe, Je, cn, Tn, Ar) {
          return Je || (Je = cn), he += s.slice(se, Ar).replace(Ck, K), Qe && (P = !0, he += `' +
__e(` + Qe + `) +
'`), Tn && (R = !0, he += `';
` + Tn + `;
__p += '`), Je && (he += `' +
((__t = (` + Je + `)) == null ? '' : __t) +
'`), se = Ar + Le.length, Le;
        }), he += `';
`;
        var Ie = ut.call(c, "variable") && c.variable;
        if (Ie) {
          if (vk.test(Ie))
            throw new lf(vr);
        } else
          he = `with (obj) {
` + he + `
}
`;
        he = (R ? he.replace(_l, "") : he).replace(xl, "$1").replace(kl, "$1;"), he = "function(" + (Ie || "obj") + `) {
` + (Ie ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (P ? ", __e = _.escape" : "") + (R ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + he + `return __p
}`;
        var Ge = kp(function() {
          return Jv(G, Te + "return " + he).apply(Y, Z);
        });
        if (Ge.source = he, Qd(Ge))
          throw Ge;
        return Ge;
      }
      function KO(s) {
        return lt(s).toLowerCase();
      }
      function ZO(s) {
        return lt(s).toUpperCase();
      }
      function QO(s, c, g) {
        if (s = lt(s), s && (g || c === Y))
          return N(s);
        if (!s || !(c = Fn(c)))
          return s;
        var w = Ee(s), P = Ee(c);
        return Or(w, W(w, P), j(w, P) + 1).join("");
      }
      function JO(s, c, g) {
        if (s = lt(s), s && (g || c === Y))
          return s.slice(0, ke(s) + 1);
        if (!s || !(c = Fn(c)))
          return s;
        var w = Ee(s);
        return Or(w, 0, j(w, Ee(c)) + 1).join("");
      }
      function eM(s, c, g) {
        if (s = lt(s), s && (g || c === Y))
          return s.replace(vd, "");
        if (!s || !(c = Fn(c)))
          return s;
        var w = Ee(s);
        return Or(w, W(w, Ee(c))).join("");
      }
      function tM(s, c) {
        var g = Jc, w = ed;
        if (kt(c)) {
          var P = "separator" in c ? c.separator : P;
          g = "length" in c ? Ke(c.length) : g, w = "omission" in c ? Fn(c.omission) : w;
        }
        s = lt(s);
        var R = s.length;
        if (ue(s)) {
          var q = Ee(s);
          R = q.length;
        }
        if (g >= R)
          return s;
        var G = g - be(w);
        if (G < 1)
          return w;
        var Z = q ? Or(q, 0, G).join("") : s.slice(0, G);
        if (P === Y)
          return Z + w;
        if (q && (G += Z.length - G), bf(P)) {
          if (s.slice(G).search(P)) {
            var se, ae = Z;
            for (P.global || (P = uf(P.source, lt(lm.exec(P)) + "g")), P.lastIndex = 0; se = P.exec(ae); )
              var he = se.index;
            Z = Z.slice(0, he === Y ? G : he);
          }
        } else if (s.indexOf(Fn(P), G) != G) {
          var _e = Z.lastIndexOf(P);
          _e > -1 && (Z = Z.slice(0, _e));
        }
        return Z + w;
      }
      function nM(s) {
        return s = lt(s), s && ik.test(s) ? s.replace(om, oS) : s;
      }
      function Zv(s, c, g) {
        return s = lt(s), c = g ? Y : c, c === Y ? de(s) ? vi(s) : b(s) : s.match(c) || [];
      }
      function iM(s) {
        var c = s == null ? 0 : s.length, g = $e();
        return s = c ? f(s, function(w) {
          if (typeof w[1] != "function")
            throw new si(nn);
          return [g(w[0]), w[1]];
        }) : [], Ze(function(w) {
          for (var P = -1; ++P < c; ) {
            var R = s[P];
            if (n(R[0], this, w))
              return n(R[1], this, w);
          }
        });
      }
      function rM(s) {
        return LS(ii(s, Mi));
      }
      function tf(s) {
        return function() {
          return s;
        };
      }
      function oM(s, c) {
        return s == null || s !== s ? c : s;
      }
      function Mn(s) {
        return s;
      }
      function nf(s) {
        return jm(typeof s == "function" ? s : ii(s, Mi));
      }
      function aM(s) {
        return Um(ii(s, Mi));
      }
      function sM(s, c) {
        return qm(s, ii(c, Mi));
      }
      function rf(s, c, g) {
        var w = Kt(c), P = Pl(c, w);
        g != null || kt(c) && (P.length || !w.length) || (g = c, c = s, s = this, P = Pl(c, Kt(c)));
        var R = !(kt(g) && "chain" in g && !g.chain), q = Qi(s);
        return r(P, function(G) {
          var Z = c[G];
          s[G] = Z, q && (s.prototype[G] = function() {
            var se = this.__chain__;
            if (R || se) {
              var ae = s(this.__wrapped__);
              return (ae.__actions__ = Sn(this.__actions__)).push({ func: Z, args: arguments, thisArg: s }), ae.__chain__ = se, ae;
            }
            return Z.apply(s, m([this.value()], arguments));
          });
        }), s;
      }
      function lM() {
        return rn._ === this && (rn._ = PM), this;
      }
      function of() {
      }
      function uM(s) {
        return s = Ke(s), Ze(function(c) {
          return Gm(c, s);
        });
      }
      function Qv(s) {
        return qd(s) ? A(Ei(s)) : ZS(s);
      }
      function cM(s) {
        return function(c) {
          return s == null ? Y : go(s, c);
        };
      }
      function af() {
        return [];
      }
      function sf() {
        return !1;
      }
      function dM() {
        return {};
      }
      function fM() {
        return "";
      }
      function hM() {
        return !0;
      }
      function gM(s, c) {
        if (s = Ke(s), s < 1 || s > Ti)
          return [];
        var g = ei, w = ln(s, ei);
        c = $e(c), s -= ei;
        for (var P = I(w, c); ++g < s; )
          c(g);
        return P;
      }
      function mM(s) {
        return He(s) ? f(s, Ei) : Nn(s) ? [s] : Sn(gp(lt(s)));
      }
      function vM(s) {
        var c = ++MM;
        return lt(s) + c;
      }
      function pM(s) {
        return s && s.length ? Tl(s, Mn, Td) : Y;
      }
      function yM(s, c) {
        return s && s.length ? Tl(s, $e(c, 2), Td) : Y;
      }
      function bM(s) {
        return $(s, Mn);
      }
      function wM(s, c) {
        return $(s, $e(c, 2));
      }
      function _M(s) {
        return s && s.length ? Tl(s, Mn, Id) : Y;
      }
      function xM(s, c) {
        return s && s.length ? Tl(s, $e(c, 2), Id) : Y;
      }
      function kM(s) {
        return s && s.length ? E(s, Mn) : 0;
      }
      function SM(s, c) {
        return s && s.length ? E(s, $e(c, 2)) : 0;
      }
      oe = oe == null ? rn : Jo.defaults(rn.Object(), oe, Jo.pick(rn, qk));
      var jt = oe.Array, ql = oe.Date, lf = oe.Error, Jv = oe.Function, ra = oe.Math, bt = oe.Object, uf = oe.RegExp, CM = oe.String, si = oe.TypeError, Gl = jt.prototype, OM = Jv.prototype, oa = bt.prototype, Xl = oe["__core-js_shared__"], Kl = OM.toString, ut = oa.hasOwnProperty, MM = 0, ep = function() {
        var s = /[^.]+$/.exec(Xl && Xl.keys && Xl.keys.IE_PROTO || "");
        return s ? "Symbol(src)_1." + s : "";
      }(), Zl = oa.toString, TM = Kl.call(bt), PM = rn._, AM = uf("^" + Kl.call(ut).replace(md, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Ql = Tm ? oe.Buffer : Y, Mr = oe.Symbol, Jl = oe.Uint8Array, tp = Ql ? Ql.allocUnsafe : Y, eu = re(bt.getPrototypeOf, bt), np = bt.create, ip = oa.propertyIsEnumerable, tu = Gl.splice, rp = Mr ? Mr.isConcatSpreadable : Y, ts = Mr ? Mr.iterator : Y, po = Mr ? Mr.toStringTag : Y, nu = function() {
        try {
          var s = mo(bt, "defineProperty");
          return s({}, "", {}), s;
        } catch {
        }
      }(), EM = oe.clearTimeout !== rn.clearTimeout && oe.clearTimeout, IM = ql && ql.now !== rn.Date.now && ql.now, DM = oe.setTimeout !== rn.setTimeout && oe.setTimeout, iu = ra.ceil, ru = ra.floor, cf = bt.getOwnPropertySymbols, LM = Ql ? Ql.isBuffer : Y, op = oe.isFinite, BM = Gl.join, VM = re(bt.keys, bt), Yt = ra.max, ln = ra.min, $M = ql.now, RM = oe.parseInt, ap = ra.random, FM = Gl.reverse, df = mo(oe, "DataView"), ns = mo(oe, "Map"), ff = mo(oe, "Promise"), aa = mo(oe, "Set"), is = mo(oe, "WeakMap"), rs = mo(bt, "create"), ou = is && new is(), sa = {}, NM = vo(df), WM = vo(ns), zM = vo(ff), HM = vo(aa), jM = vo(is), au = Mr ? Mr.prototype : Y, os = au ? au.valueOf : Y, sp = au ? au.toString : Y, la = /* @__PURE__ */ function() {
        function s() {
        }
        return function(c) {
          if (!kt(c))
            return {};
          if (np)
            return np(c);
          s.prototype = c;
          var g = new s();
          return s.prototype = Y, g;
        };
      }();
      C.templateSettings = { escape: ok, evaluate: ak, interpolate: sm, variable: "", imports: { _: C } }, C.prototype = Se.prototype, C.prototype.constructor = C, Ve.prototype = la(Se.prototype), Ve.prototype.constructor = Ve, Ce.prototype = la(Se.prototype), Ce.prototype.constructor = Ce, co.prototype.clear = lS, co.prototype.delete = uS, co.prototype.get = cS, co.prototype.has = dS, co.prototype.set = fS, Ui.prototype.clear = hS, Ui.prototype.delete = gS, Ui.prototype.get = mS, Ui.prototype.has = vS, Ui.prototype.set = pS, qi.prototype.clear = yS, qi.prototype.delete = bS, qi.prototype.get = wS, qi.prototype.has = _S, qi.prototype.set = xS, fo.prototype.add = fo.prototype.push = kS, fo.prototype.has = SS, _i.prototype.clear = CS, _i.prototype.delete = OS, _i.prototype.get = MS, _i.prototype.has = TS, _i.prototype.set = PS;
      var Tr = lv(Pi), lp = lv(Md, !0), hf = uv(), up = uv(!0), cp = ou ? function(s, c) {
        return ou.set(s, c), s;
      } : Mn, YM = nu ? function(s, c) {
        return nu(s, "toString", {
          configurable: !0,
          enumerable: !1,
          value: tf(c),
          writable: !0
        });
      } : Mn, UM = Ze, dp = EM || function(s) {
        return rn.clearTimeout(s);
      }, qM = aa && 1 / xe(new aa([, -0]))[1] == Yi ? function(s) {
        return new aa(s);
      } : of, gf = ou ? function(s) {
        return ou.get(s);
      } : of, mf = cf ? function(s) {
        return s == null ? [] : (s = bt(s), l(cf(s), function(c) {
          return ip.call(s, c);
        }));
      } : af, fp = cf ? function(s) {
        for (var c = []; s; )
          m(c, mf(s)), s = eu(s);
        return c;
      } : af, un = vn;
      (df && un(new df(new ArrayBuffer(1))) != xr || ns && un(new ns()) != Vn || ff && un(ff.resolve()) != wl || aa && un(new aa()) != $n || is && un(new is()) != so) && (un = function(s) {
        var c = vn(s), g = c == wi ? s.constructor : Y, w = g ? vo(g) : "";
        if (w)
          switch (w) {
            case NM:
              return xr;
            case WM:
              return Vn;
            case zM:
              return wl;
            case HM:
              return $n;
            case jM:
              return so;
          }
        return c;
      });
      var GM = Xl ? Qi : sf, hp = Mv(cp), as = DM || function(s, c) {
        return rn.setTimeout(s, c);
      }, vf = Mv(YM), gp = S2(function(s) {
        var c = [];
        return s.charCodeAt(0) === 46 && c.push(""), s.replace(uk, function(g, w, P, R) {
          c.push(P ? R.replace(pk, "$1") : w || g);
        }), c;
      }), XM = Ze(function(s, c) {
        return Vt(s) ? Ga(s, on(c, 1, Vt, !0)) : [];
      }), KM = Ze(function(s, c) {
        var g = oi(c);
        return Vt(g) && (g = Y), Vt(s) ? Ga(s, on(c, 1, Vt, !0), $e(g, 2)) : [];
      }), ZM = Ze(function(s, c) {
        var g = oi(c);
        return Vt(g) && (g = Y), Vt(s) ? Ga(s, on(c, 1, Vt, !0), Y, g) : [];
      }), QM = Ze(function(s) {
        var c = f(s, Fd);
        return c.length && c[0] === s[0] ? Pd(c) : [];
      }), JM = Ze(function(s) {
        var c = oi(s), g = f(s, Fd);
        return c === oi(g) ? c = Y : g.pop(), g.length && g[0] === s[0] ? Pd(g, $e(c, 2)) : [];
      }), eT = Ze(function(s) {
        var c = oi(s), g = f(s, Fd);
        return c = typeof c == "function" ? c : Y, c && g.pop(), g.length && g[0] === s[0] ? Pd(g, Y, c) : [];
      }), tT = Ze(Dv), nT = Ki(function(s, c) {
        var g = s == null ? 0 : s.length, w = Od(s, c);
        return Zm(s, f(c, function(P) {
          return Zi(P, g) ? +P : P;
        }).sort(ov)), w;
      }), iT = Ze(function(s) {
        return Sr(on(s, 1, Vt, !0));
      }), rT = Ze(function(s) {
        var c = oi(s);
        return Vt(c) && (c = Y), Sr(on(s, 1, Vt, !0), $e(c, 2));
      }), oT = Ze(function(s) {
        var c = oi(s);
        return c = typeof c == "function" ? c : Y, Sr(on(s, 1, Vt, !0), Y, c);
      }), aT = Ze(function(s, c) {
        return Vt(s) ? Ga(s, c) : [];
      }), sT = Ze(function(s) {
        return Rd(l(s, Vt));
      }), lT = Ze(function(s) {
        var c = oi(s);
        return Vt(c) && (c = Y), Rd(l(s, Vt), $e(c, 2));
      }), uT = Ze(function(s) {
        var c = oi(s);
        return c = typeof c == "function" ? c : Y, Rd(l(s, Vt), Y, c);
      }), cT = Ze(Zd), dT = Ze(function(s) {
        var c = s.length, g = c > 1 ? s[c - 1] : Y;
        return g = typeof g == "function" ? (s.pop(), g) : Y, Lv(s, g);
      }), fT = Ki(function(s) {
        var c = s.length, g = c ? s[0] : 0, w = this.__wrapped__, P = function(R) {
          return Od(R, s);
        };
        return !(c > 1 || this.__actions__.length) && w instanceof Ce && Zi(g) ? (w = w.slice(g, +g + (c ? 1 : 0)), w.__actions__.push({ func: Wl, args: [P], thisArg: Y }), new Ve(w, this.__chain__).thru(function(R) {
          return c && !R.length && R.push(Y), R;
        })) : this.thru(P);
      }), hT = Dl(function(s, c, g) {
        ut.call(s, g) ? ++s[g] : Gi(s, g, 1);
      }), gT = dv(Pv), mT = dv(Av), vT = Dl(function(s, c, g) {
        ut.call(s, g) ? s[g].push(c) : Gi(s, g, [c]);
      }), pT = Ze(function(s, c, g) {
        var w = -1, P = typeof c == "function", R = Cn(s) ? jt(s.length) : [];
        return Tr(s, function(q) {
          R[++w] = P ? n(c, q, g) : Xa(q, c, g);
        }), R;
      }), yT = Dl(function(s, c, g) {
        Gi(s, g, c);
      }), bT = Dl(function(s, c, g) {
        s[g ? 0 : 1].push(c);
      }, function() {
        return [[], []];
      }), wT = Ze(function(s, c) {
        if (s == null)
          return [];
        var g = c.length;
        return g > 1 && pn(s, c[0], c[1]) ? c = [] : g > 2 && pn(c[0], c[1], c[2]) && (c = [c[0]]), Xm(s, on(c, 1), []);
      }), su = IM || function() {
        return rn.Date.now();
      }, pf = Ze(function(s, c, g) {
        var w = Xt;
        if (g.length) {
          var P = me(g, na(pf));
          w |= Jn;
        }
        return Xi(s, w, c, g, P);
      }), mp = Ze(function(s, c, g) {
        var w = Xt | ji;
        if (g.length) {
          var P = me(g, na(mp));
          w |= Jn;
        }
        return Xi(c, w, s, g, P);
      }), _T = Ze(function(s, c) {
        return Fm(s, 1, c);
      }), xT = Ze(function(s, c, g) {
        return Fm(s, ai(c) || 0, g);
      });
      Hl.Cache = qi;
      var kT = UM(function(s, c) {
        c = c.length == 1 && He(c[0]) ? f(c[0], V($e())) : f(on(c, 1), V($e()));
        var g = c.length;
        return Ze(function(w) {
          for (var P = -1, R = ln(w.length, g); ++P < R; )
            w[P] = c[P].call(this, w[P]);
          return n(s, this, w);
        });
      }), yf = Ze(function(s, c) {
        return Xi(s, Jn, Y, c, me(c, na(yf)));
      }), vp = Ze(function(s, c) {
        return Xi(s, wr, Y, c, me(c, na(vp)));
      }), ST = Ki(function(s, c) {
        return Xi(s, to, Y, Y, Y, c);
      }), CT = $l(Td), OT = $l(function(s, c) {
        return s >= c;
      }), yo = zm(/* @__PURE__ */ function() {
        return arguments;
      }()) ? zm : function(s) {
        return Tt(s) && ut.call(s, "callee") && !ip.call(s, "callee");
      }, He = jt.isArray, MT = Pm ? V(Pm) : WS, Pr = LM || sf, TT = Am ? V(Am) : zS, pp = Em ? V(Em) : jS, bf = Im ? V(Im) : YS, yp = Dm ? V(Dm) : US, ua = Lm ? V(Lm) : qS, PT = $l(Id), AT = $l(function(s, c) {
        return s <= c;
      }), ET = ea(function(s, c) {
        if (Ja(c) || Cn(c))
          return Ai(c, Kt(c), s), Y;
        for (var g in c)
          ut.call(c, g) && qa(s, g, c[g]);
      }), bp = ea(function(s, c) {
        Ai(c, On(c), s);
      }), lu = ea(function(s, c, g, w) {
        Ai(c, On(c), s, w);
      }), IT = ea(function(s, c, g, w) {
        Ai(c, Kt(c), s, w);
      }), DT = Ki(Od), LT = Ze(function(s, c) {
        s = bt(s);
        var g = -1, w = c.length, P = w > 2 ? c[2] : Y;
        for (P && pn(c[0], c[1], P) && (w = 1); ++g < w; )
          for (var R = c[g], q = On(R), G = -1, Z = q.length; ++G < Z; ) {
            var se = q[G], ae = s[se];
            (ae === Y || xi(ae, oa[se]) && !ut.call(s, se)) && (s[se] = R[se]);
          }
        return s;
      }), BT = Ze(function(s) {
        return s.push(Y, yv), n(wp, Y, s);
      }), VT = hv(function(s, c, g) {
        c != null && typeof c.toString != "function" && (c = Zl.call(c)), s[c] = g;
      }, tf(Mn)), $T = hv(function(s, c, g) {
        c != null && typeof c.toString != "function" && (c = Zl.call(c)), ut.call(s, c) ? s[c].push(g) : s[c] = [g];
      }, $e), RT = Ze(Xa), FT = ea(function(s, c, g) {
        Al(s, c, g);
      }), wp = ea(function(s, c, g, w) {
        Al(s, c, g, w);
      }), NT = Ki(function(s, c) {
        var g = {};
        if (s == null)
          return g;
        var w = !1;
        c = f(c, function(R) {
          return R = Cr(R, s), w || (w = R.length > 1), R;
        }), Ai(s, Yd(s), g), w && (g = ii(g, Mi | vl | pr, f2));
        for (var P = c.length; P--; )
          $d(g, c[P]);
        return g;
      }), WT = Ki(function(s, c) {
        return s == null ? {} : KS(s, c);
      }), _p = vv(Kt), xp = vv(On), zT = ta(function(s, c, g) {
        return c = c.toLowerCase(), s + (g ? Xv(c) : c);
      }), HT = ta(function(s, c, g) {
        return s + (g ? "-" : "") + c.toLowerCase();
      }), jT = ta(function(s, c, g) {
        return s + (g ? " " : "") + c.toLowerCase();
      }), YT = cv("toLowerCase"), UT = ta(function(s, c, g) {
        return s + (g ? "_" : "") + c.toLowerCase();
      }), qT = ta(function(s, c, g) {
        return s + (g ? " " : "") + wf(c);
      }), GT = ta(function(s, c, g) {
        return s + (g ? " " : "") + c.toUpperCase();
      }), wf = cv("toUpperCase"), kp = Ze(function(s, c) {
        try {
          return n(s, Y, c);
        } catch (g) {
          return Qd(g) ? g : new lf(g);
        }
      }), XT = Ki(function(s, c) {
        return r(c, function(g) {
          g = Ei(g), Gi(s, g, pf(s[g], s));
        }), s;
      }), KT = fv(), ZT = fv(!0), QT = Ze(function(s, c) {
        return function(g) {
          return Xa(g, s, c);
        };
      }), JT = Ze(function(s, c) {
        return function(g) {
          return Xa(s, g, c);
        };
      }), eP = zd(f), tP = zd(a), nP = zd(y), iP = gv(), rP = gv(!0), oP = Bl(function(s, c) {
        return s + c;
      }, 0), aP = Hd("ceil"), sP = Bl(function(s, c) {
        return s / c;
      }, 1), lP = Hd("floor"), uP = Bl(function(s, c) {
        return s * c;
      }, 1), cP = Hd("round"), dP = Bl(function(s, c) {
        return s - c;
      }, 0);
      return C.after = $C, C.ary = Rv, C.assign = ET, C.assignIn = bp, C.assignInWith = lu, C.assignWith = IT, C.at = DT, C.before = Fv, C.bind = pf, C.bindAll = XT, C.bindKey = mp, C.castArray = YC, C.chain = Bv, C.chunk = A2, C.compact = E2, C.concat = I2, C.cond = iM, C.conforms = rM, C.constant = tf, C.countBy = hT, C.create = gO, C.curry = Nv, C.curryRight = Wv, C.debounce = zv, C.defaults = LT, C.defaultsDeep = BT, C.defer = _T, C.delay = xT, C.difference = XM, C.differenceBy = KM, C.differenceWith = ZM, C.drop = D2, C.dropRight = L2, C.dropRightWhile = B2, C.dropWhile = V2, C.fill = $2, C.filter = kC, C.flatMap = SC, C.flatMapDeep = CC, C.flatMapDepth = OC, C.flatten = Ev, C.flattenDeep = R2, C.flattenDepth = F2, C.flip = RC, C.flow = KT, C.flowRight = ZT, C.fromPairs = N2, C.functions = _O, C.functionsIn = xO, C.groupBy = vT, C.initial = z2, C.intersection = QM, C.intersectionBy = JM, C.intersectionWith = eT, C.invert = VT, C.invertBy = $T, C.invokeMap = pT, C.iteratee = nf, C.keyBy = yT, C.keys = Kt, C.keysIn = On, C.map = zl, C.mapKeys = SO, C.mapValues = CO, C.matches = aM, C.matchesProperty = sM, C.memoize = Hl, C.merge = FT, C.mergeWith = wp, C.method = QT, C.methodOf = JT, C.mixin = rf, C.negate = jl, C.nthArg = uM, C.omit = NT, C.omitBy = OO, C.once = FC, C.orderBy = TC, C.over = eP, C.overArgs = kT, C.overEvery = tP, C.overSome = nP, C.partial = yf, C.partialRight = vp, C.partition = bT, C.pick = WT, C.pickBy = Gv, C.property = Qv, C.propertyOf = cM, C.pull = tT, C.pullAll = Dv, C.pullAllBy = U2, C.pullAllWith = q2, C.pullAt = nT, C.range = iP, C.rangeRight = rP, C.rearg = ST, C.reject = EC, C.remove = G2, C.rest = NC, C.reverse = Kd, C.sampleSize = DC, C.set = TO, C.setWith = PO, C.shuffle = LC, C.slice = X2, C.sortBy = wT, C.sortedUniq = nC, C.sortedUniqBy = iC, C.split = qO, C.spread = WC, C.tail = rC, C.take = oC, C.takeRight = aC, C.takeRightWhile = sC, C.takeWhile = lC, C.tap = gC, C.throttle = zC, C.thru = Wl, C.toArray = Yv, C.toPairs = _p, C.toPairsIn = xp, C.toPath = mM, C.toPlainObject = qv, C.transform = AO, C.unary = HC, C.union = iT, C.unionBy = rT, C.unionWith = oT, C.uniq = uC, C.uniqBy = cC, C.uniqWith = dC, C.unset = EO, C.unzip = Zd, C.unzipWith = Lv, C.update = IO, C.updateWith = DO, C.values = ia, C.valuesIn = LO, C.without = aT, C.words = Zv, C.wrap = jC, C.xor = sT, C.xorBy = lT, C.xorWith = uT, C.zip = cT, C.zipObject = fC, C.zipObjectDeep = hC, C.zipWith = dT, C.entries = _p, C.entriesIn = xp, C.extend = bp, C.extendWith = lu, rf(C, C), C.add = oP, C.attempt = kp, C.camelCase = zT, C.capitalize = Xv, C.ceil = aP, C.clamp = BO, C.clone = UC, C.cloneDeep = GC, C.cloneDeepWith = XC, C.cloneWith = qC, C.conformsTo = KC, C.deburr = Kv, C.defaultTo = oM, C.divide = sP, C.endsWith = RO, C.eq = xi, C.escape = FO, C.escapeRegExp = NO, C.every = xC, C.find = gT, C.findIndex = Pv, C.findKey = mO, C.findLast = mT, C.findLastIndex = Av, C.findLastKey = vO, C.floor = lP, C.forEach = Vv, C.forEachRight = $v, C.forIn = pO, C.forInRight = yO, C.forOwn = bO, C.forOwnRight = wO, C.get = Jd, C.gt = CT, C.gte = OT, C.has = kO, C.hasIn = ef, C.head = Iv, C.identity = Mn, C.includes = MC, C.indexOf = W2, C.inRange = VO, C.invoke = RT, C.isArguments = yo, C.isArray = He, C.isArrayBuffer = MT, C.isArrayLike = Cn, C.isArrayLikeObject = Vt, C.isBoolean = ZC, C.isBuffer = Pr, C.isDate = TT, C.isElement = QC, C.isEmpty = JC, C.isEqual = eO, C.isEqualWith = tO, C.isError = Qd, C.isFinite = nO, C.isFunction = Qi, C.isInteger = Hv, C.isLength = Yl, C.isMap = pp, C.isMatch = iO, C.isMatchWith = rO, C.isNaN = oO, C.isNative = aO, C.isNil = lO, C.isNull = sO, C.isNumber = jv, C.isObject = kt, C.isObjectLike = Tt, C.isPlainObject = es, C.isRegExp = bf, C.isSafeInteger = uO, C.isSet = yp, C.isString = Ul, C.isSymbol = Nn, C.isTypedArray = ua, C.isUndefined = cO, C.isWeakMap = dO, C.isWeakSet = fO, C.join = H2, C.kebabCase = HT, C.last = oi, C.lastIndexOf = j2, C.lowerCase = jT, C.lowerFirst = YT, C.lt = PT, C.lte = AT, C.max = pM, C.maxBy = yM, C.mean = bM, C.meanBy = wM, C.min = _M, C.minBy = xM, C.stubArray = af, C.stubFalse = sf, C.stubObject = dM, C.stubString = fM, C.stubTrue = hM, C.multiply = uP, C.nth = Y2, C.noConflict = lM, C.noop = of, C.now = su, C.pad = WO, C.padEnd = zO, C.padStart = HO, C.parseInt = jO, C.random = $O, C.reduce = PC, C.reduceRight = AC, C.repeat = YO, C.replace = UO, C.result = MO, C.round = cP, C.runInContext = X, C.sample = IC, C.size = BC, C.snakeCase = UT, C.some = VC, C.sortedIndex = K2, C.sortedIndexBy = Z2, C.sortedIndexOf = Q2, C.sortedLastIndex = J2, C.sortedLastIndexBy = eC, C.sortedLastIndexOf = tC, C.startCase = qT, C.startsWith = GO, C.subtract = dP, C.sum = kM, C.sumBy = SM, C.template = XO, C.times = gM, C.toFinite = Ji, C.toInteger = Ke, C.toLength = Uv, C.toLower = KO, C.toNumber = ai, C.toSafeInteger = hO, C.toString = lt, C.toUpper = ZO, C.trim = QO, C.trimEnd = JO, C.trimStart = eM, C.truncate = tM, C.unescape = nM, C.uniqueId = vM, C.upperCase = GT, C.upperFirst = wf, C.each = Vv, C.eachRight = $v, C.first = Iv, rf(C, function() {
        var s = {};
        return Pi(C, function(c, g) {
          ut.call(C.prototype, g) || (s[g] = c);
        }), s;
      }(), { chain: !1 }), C.VERSION = pi, r(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(s) {
        C[s].placeholder = C;
      }), r(["drop", "take"], function(s, c) {
        Ce.prototype[s] = function(g) {
          g = g === Y ? 1 : Yt(Ke(g), 0);
          var w = this.__filtered__ && !c ? new Ce(this) : this.clone();
          return w.__filtered__ ? w.__takeCount__ = ln(g, w.__takeCount__) : w.__views__.push({ size: ln(g, ei), type: s + (w.__dir__ < 0 ? "Right" : "") }), w;
        }, Ce.prototype[s + "Right"] = function(g) {
          return this.reverse()[s](g).reverse();
        };
      }), r(["filter", "map", "takeWhile"], function(s, c) {
        var g = c + 1, w = g == yl || g == rd;
        Ce.prototype[s] = function(P) {
          var R = this.clone();
          return R.__iteratees__.push({ iteratee: $e(P, 3), type: g }), R.__filtered__ = R.__filtered__ || w, R;
        };
      }), r(["head", "last"], function(s, c) {
        var g = "take" + (c ? "Right" : "");
        Ce.prototype[s] = function() {
          return this[g](1).value()[0];
        };
      }), r(["initial", "tail"], function(s, c) {
        var g = "drop" + (c ? "" : "Right");
        Ce.prototype[s] = function() {
          return this.__filtered__ ? new Ce(this) : this[g](1);
        };
      }), Ce.prototype.compact = function() {
        return this.filter(Mn);
      }, Ce.prototype.find = function(s) {
        return this.filter(s).head();
      }, Ce.prototype.findLast = function(s) {
        return this.reverse().find(s);
      }, Ce.prototype.invokeMap = Ze(function(s, c) {
        return typeof s == "function" ? new Ce(this) : this.map(function(g) {
          return Xa(g, s, c);
        });
      }), Ce.prototype.reject = function(s) {
        return this.filter(jl($e(s)));
      }, Ce.prototype.slice = function(s, c) {
        s = Ke(s);
        var g = this;
        return g.__filtered__ && (s > 0 || c < 0) ? new Ce(g) : (s < 0 ? g = g.takeRight(-s) : s && (g = g.drop(s)), c !== Y && (c = Ke(c), g = c < 0 ? g.dropRight(-c) : g.take(c - s)), g);
      }, Ce.prototype.takeRightWhile = function(s) {
        return this.reverse().takeWhile(s).reverse();
      }, Ce.prototype.toArray = function() {
        return this.take(ei);
      }, Pi(Ce.prototype, function(s, c) {
        var g = /^(?:filter|find|map|reject)|While$/.test(c), w = /^(?:head|last)$/.test(c), P = C[w ? "take" + (c == "last" ? "Right" : "") : c], R = w || /^find/.test(c);
        P && (C.prototype[c] = function() {
          var q = this.__wrapped__, G = w ? [1] : arguments, Z = q instanceof Ce, se = G[0], ae = Z || He(q), he = function(Qe) {
            var Je = P.apply(C, m([Qe], G));
            return w && _e ? Je[0] : Je;
          };
          ae && g && typeof se == "function" && se.length != 1 && (Z = ae = !1);
          var _e = this.__chain__, Te = !!this.__actions__.length, Ie = R && !_e, Ge = Z && !Te;
          if (!R && ae) {
            q = Ge ? q : new Ce(this);
            var Le = s.apply(q, G);
            return Le.__actions__.push({ func: Wl, args: [he], thisArg: Y }), new Ve(Le, _e);
          }
          return Ie && Ge ? s.apply(this, G) : (Le = this.thru(he), Ie ? w ? Le.value()[0] : Le.value() : Le);
        });
      }), r(["pop", "push", "shift", "sort", "splice", "unshift"], function(s) {
        var c = Gl[s], g = /^(?:push|sort|unshift)$/.test(s) ? "tap" : "thru", w = /^(?:pop|shift)$/.test(s);
        C.prototype[s] = function() {
          var P = arguments;
          if (w && !this.__chain__) {
            var R = this.value();
            return c.apply(He(R) ? R : [], P);
          }
          return this[g](function(q) {
            return c.apply(He(q) ? q : [], P);
          });
        };
      }), Pi(Ce.prototype, function(s, c) {
        var g = C[c];
        if (g) {
          var w = g.name + "";
          ut.call(sa, w) || (sa[w] = []), sa[w].push({ name: c, func: g });
        }
      }), sa[Ll(Y, ji).name] = [{ name: "wrapper", func: Y }], Ce.prototype.clone = kn, Ce.prototype.reverse = Sd, Ce.prototype.value = sS, C.prototype.at = fT, C.prototype.chain = mC, C.prototype.commit = vC, C.prototype.next = pC, C.prototype.plant = bC, C.prototype.reverse = wC, C.prototype.toJSON = C.prototype.valueOf = C.prototype.value = _C, C.prototype.first = C.prototype.head, ts && (C.prototype[ts] = yC), C;
    }, Jo = aS();
    uo ? ((uo.exports = Jo)._ = Jo, xd._ = Jo) : rn._ = Jo;
  }).call(or);
})(oc, oc.exports);
var wL = oc.exports, uw = {};
(function(e) {
  e.aliasToReal = {
    // Lodash aliases.
    each: "forEach",
    eachRight: "forEachRight",
    entries: "toPairs",
    entriesIn: "toPairsIn",
    extend: "assignIn",
    extendAll: "assignInAll",
    extendAllWith: "assignInAllWith",
    extendWith: "assignInWith",
    first: "head",
    // Methods that are curried variants of others.
    conforms: "conformsTo",
    matches: "isMatch",
    property: "get",
    // Ramda aliases.
    __: "placeholder",
    F: "stubFalse",
    T: "stubTrue",
    all: "every",
    allPass: "overEvery",
    always: "constant",
    any: "some",
    anyPass: "overSome",
    apply: "spread",
    assoc: "set",
    assocPath: "set",
    complement: "negate",
    compose: "flowRight",
    contains: "includes",
    dissoc: "unset",
    dissocPath: "unset",
    dropLast: "dropRight",
    dropLastWhile: "dropRightWhile",
    equals: "isEqual",
    identical: "eq",
    indexBy: "keyBy",
    init: "initial",
    invertObj: "invert",
    juxt: "over",
    omitAll: "omit",
    nAry: "ary",
    path: "get",
    pathEq: "matchesProperty",
    pathOr: "getOr",
    paths: "at",
    pickAll: "pick",
    pipe: "flow",
    pluck: "map",
    prop: "get",
    propEq: "matchesProperty",
    propOr: "getOr",
    props: "at",
    symmetricDifference: "xor",
    symmetricDifferenceBy: "xorBy",
    symmetricDifferenceWith: "xorWith",
    takeLast: "takeRight",
    takeLastWhile: "takeRightWhile",
    unapply: "rest",
    unnest: "flatten",
    useWith: "overArgs",
    where: "conformsTo",
    whereEq: "isMatch",
    zipObj: "zipObject"
  }, e.aryMethod = {
    1: [
      "assignAll",
      "assignInAll",
      "attempt",
      "castArray",
      "ceil",
      "create",
      "curry",
      "curryRight",
      "defaultsAll",
      "defaultsDeepAll",
      "floor",
      "flow",
      "flowRight",
      "fromPairs",
      "invert",
      "iteratee",
      "memoize",
      "method",
      "mergeAll",
      "methodOf",
      "mixin",
      "nthArg",
      "over",
      "overEvery",
      "overSome",
      "rest",
      "reverse",
      "round",
      "runInContext",
      "spread",
      "template",
      "trim",
      "trimEnd",
      "trimStart",
      "uniqueId",
      "words",
      "zipAll"
    ],
    2: [
      "add",
      "after",
      "ary",
      "assign",
      "assignAllWith",
      "assignIn",
      "assignInAllWith",
      "at",
      "before",
      "bind",
      "bindAll",
      "bindKey",
      "chunk",
      "cloneDeepWith",
      "cloneWith",
      "concat",
      "conformsTo",
      "countBy",
      "curryN",
      "curryRightN",
      "debounce",
      "defaults",
      "defaultsDeep",
      "defaultTo",
      "delay",
      "difference",
      "divide",
      "drop",
      "dropRight",
      "dropRightWhile",
      "dropWhile",
      "endsWith",
      "eq",
      "every",
      "filter",
      "find",
      "findIndex",
      "findKey",
      "findLast",
      "findLastIndex",
      "findLastKey",
      "flatMap",
      "flatMapDeep",
      "flattenDepth",
      "forEach",
      "forEachRight",
      "forIn",
      "forInRight",
      "forOwn",
      "forOwnRight",
      "get",
      "groupBy",
      "gt",
      "gte",
      "has",
      "hasIn",
      "includes",
      "indexOf",
      "intersection",
      "invertBy",
      "invoke",
      "invokeMap",
      "isEqual",
      "isMatch",
      "join",
      "keyBy",
      "lastIndexOf",
      "lt",
      "lte",
      "map",
      "mapKeys",
      "mapValues",
      "matchesProperty",
      "maxBy",
      "meanBy",
      "merge",
      "mergeAllWith",
      "minBy",
      "multiply",
      "nth",
      "omit",
      "omitBy",
      "overArgs",
      "pad",
      "padEnd",
      "padStart",
      "parseInt",
      "partial",
      "partialRight",
      "partition",
      "pick",
      "pickBy",
      "propertyOf",
      "pull",
      "pullAll",
      "pullAt",
      "random",
      "range",
      "rangeRight",
      "rearg",
      "reject",
      "remove",
      "repeat",
      "restFrom",
      "result",
      "sampleSize",
      "some",
      "sortBy",
      "sortedIndex",
      "sortedIndexOf",
      "sortedLastIndex",
      "sortedLastIndexOf",
      "sortedUniqBy",
      "split",
      "spreadFrom",
      "startsWith",
      "subtract",
      "sumBy",
      "take",
      "takeRight",
      "takeRightWhile",
      "takeWhile",
      "tap",
      "throttle",
      "thru",
      "times",
      "trimChars",
      "trimCharsEnd",
      "trimCharsStart",
      "truncate",
      "union",
      "uniqBy",
      "uniqWith",
      "unset",
      "unzipWith",
      "without",
      "wrap",
      "xor",
      "zip",
      "zipObject",
      "zipObjectDeep"
    ],
    3: [
      "assignInWith",
      "assignWith",
      "clamp",
      "differenceBy",
      "differenceWith",
      "findFrom",
      "findIndexFrom",
      "findLastFrom",
      "findLastIndexFrom",
      "getOr",
      "includesFrom",
      "indexOfFrom",
      "inRange",
      "intersectionBy",
      "intersectionWith",
      "invokeArgs",
      "invokeArgsMap",
      "isEqualWith",
      "isMatchWith",
      "flatMapDepth",
      "lastIndexOfFrom",
      "mergeWith",
      "orderBy",
      "padChars",
      "padCharsEnd",
      "padCharsStart",
      "pullAllBy",
      "pullAllWith",
      "rangeStep",
      "rangeStepRight",
      "reduce",
      "reduceRight",
      "replace",
      "set",
      "slice",
      "sortedIndexBy",
      "sortedLastIndexBy",
      "transform",
      "unionBy",
      "unionWith",
      "update",
      "xorBy",
      "xorWith",
      "zipWith"
    ],
    4: [
      "fill",
      "setWith",
      "updateWith"
    ]
  }, e.aryRearg = {
    2: [1, 0],
    3: [2, 0, 1],
    4: [3, 2, 0, 1]
  }, e.iterateeAry = {
    dropRightWhile: 1,
    dropWhile: 1,
    every: 1,
    filter: 1,
    find: 1,
    findFrom: 1,
    findIndex: 1,
    findIndexFrom: 1,
    findKey: 1,
    findLast: 1,
    findLastFrom: 1,
    findLastIndex: 1,
    findLastIndexFrom: 1,
    findLastKey: 1,
    flatMap: 1,
    flatMapDeep: 1,
    flatMapDepth: 1,
    forEach: 1,
    forEachRight: 1,
    forIn: 1,
    forInRight: 1,
    forOwn: 1,
    forOwnRight: 1,
    map: 1,
    mapKeys: 1,
    mapValues: 1,
    partition: 1,
    reduce: 2,
    reduceRight: 2,
    reject: 1,
    remove: 1,
    some: 1,
    takeRightWhile: 1,
    takeWhile: 1,
    times: 1,
    transform: 2
  }, e.iterateeRearg = {
    mapKeys: [1],
    reduceRight: [1, 0]
  }, e.methodRearg = {
    assignInAllWith: [1, 0],
    assignInWith: [1, 2, 0],
    assignAllWith: [1, 0],
    assignWith: [1, 2, 0],
    differenceBy: [1, 2, 0],
    differenceWith: [1, 2, 0],
    getOr: [2, 1, 0],
    intersectionBy: [1, 2, 0],
    intersectionWith: [1, 2, 0],
    isEqualWith: [1, 2, 0],
    isMatchWith: [2, 1, 0],
    mergeAllWith: [1, 0],
    mergeWith: [1, 2, 0],
    padChars: [2, 1, 0],
    padCharsEnd: [2, 1, 0],
    padCharsStart: [2, 1, 0],
    pullAllBy: [2, 1, 0],
    pullAllWith: [2, 1, 0],
    rangeStep: [1, 2, 0],
    rangeStepRight: [1, 2, 0],
    setWith: [3, 1, 2, 0],
    sortedIndexBy: [2, 1, 0],
    sortedLastIndexBy: [2, 1, 0],
    unionBy: [1, 2, 0],
    unionWith: [1, 2, 0],
    updateWith: [3, 1, 2, 0],
    xorBy: [1, 2, 0],
    xorWith: [1, 2, 0],
    zipWith: [1, 2, 0]
  }, e.methodSpread = {
    assignAll: { start: 0 },
    assignAllWith: { start: 0 },
    assignInAll: { start: 0 },
    assignInAllWith: { start: 0 },
    defaultsAll: { start: 0 },
    defaultsDeepAll: { start: 0 },
    invokeArgs: { start: 2 },
    invokeArgsMap: { start: 2 },
    mergeAll: { start: 0 },
    mergeAllWith: { start: 0 },
    partial: { start: 1 },
    partialRight: { start: 1 },
    without: { start: 1 },
    zipAll: { start: 0 }
  }, e.mutate = {
    array: {
      fill: !0,
      pull: !0,
      pullAll: !0,
      pullAllBy: !0,
      pullAllWith: !0,
      pullAt: !0,
      remove: !0,
      reverse: !0
    },
    object: {
      assign: !0,
      assignAll: !0,
      assignAllWith: !0,
      assignIn: !0,
      assignInAll: !0,
      assignInAllWith: !0,
      assignInWith: !0,
      assignWith: !0,
      defaults: !0,
      defaultsAll: !0,
      defaultsDeep: !0,
      defaultsDeepAll: !0,
      merge: !0,
      mergeAll: !0,
      mergeAllWith: !0,
      mergeWith: !0
    },
    set: {
      set: !0,
      setWith: !0,
      unset: !0,
      update: !0,
      updateWith: !0
    }
  }, e.realToAlias = function() {
    var t = Object.prototype.hasOwnProperty, n = e.aliasToReal, i = {};
    for (var r in n) {
      var o = n[r];
      t.call(i, o) ? i[o].push(r) : i[o] = [r];
    }
    return i;
  }(), e.remap = {
    assignAll: "assign",
    assignAllWith: "assignWith",
    assignInAll: "assignIn",
    assignInAllWith: "assignInWith",
    curryN: "curry",
    curryRightN: "curryRight",
    defaultsAll: "defaults",
    defaultsDeepAll: "defaultsDeep",
    findFrom: "find",
    findIndexFrom: "findIndex",
    findLastFrom: "findLast",
    findLastIndexFrom: "findLastIndex",
    getOr: "get",
    includesFrom: "includes",
    indexOfFrom: "indexOf",
    invokeArgs: "invoke",
    invokeArgsMap: "invokeMap",
    lastIndexOfFrom: "lastIndexOf",
    mergeAll: "merge",
    mergeAllWith: "mergeWith",
    padChars: "pad",
    padCharsEnd: "padEnd",
    padCharsStart: "padStart",
    propertyOf: "get",
    rangeStep: "range",
    rangeStepRight: "rangeRight",
    restFrom: "rest",
    spreadFrom: "spread",
    trimChars: "trim",
    trimCharsEnd: "trimEnd",
    trimCharsStart: "trimStart",
    zipAll: "zip"
  }, e.skipFixed = {
    castArray: !0,
    flow: !0,
    flowRight: !0,
    iteratee: !0,
    mixin: !0,
    rearg: !0,
    runInContext: !0
  }, e.skipRearg = {
    add: !0,
    assign: !0,
    assignIn: !0,
    bind: !0,
    bindKey: !0,
    concat: !0,
    difference: !0,
    divide: !0,
    eq: !0,
    gt: !0,
    gte: !0,
    isEqual: !0,
    lt: !0,
    lte: !0,
    matchesProperty: !0,
    merge: !0,
    multiply: !0,
    overArgs: !0,
    partial: !0,
    partialRight: !0,
    propertyOf: !0,
    random: !0,
    range: !0,
    rangeRight: !0,
    subtract: !0,
    zip: !0,
    zipObject: !0,
    zipObjectDeep: !0
  };
})(uw);
var _L = {}, Ut = uw, xL = _L, Py = Array.prototype.push;
function kL(e, t) {
  return t == 2 ? function(n, i) {
    return e.apply(void 0, arguments);
  } : function(n) {
    return e.apply(void 0, arguments);
  };
}
function Bf(e, t) {
  return t == 2 ? function(n, i) {
    return e(n, i);
  } : function(n) {
    return e(n);
  };
}
function Ay(e) {
  for (var t = e ? e.length : 0, n = Array(t); t--; )
    n[t] = e[t];
  return n;
}
function SL(e) {
  return function(t) {
    return e({}, t);
  };
}
function CL(e, t) {
  return function() {
    for (var n = arguments.length, i = n - 1, r = Array(n); n--; )
      r[n] = arguments[n];
    var o = r[t], a = r.slice(0, t);
    return o && Py.apply(a, o), t != i && Py.apply(a, r.slice(t + 1)), e.apply(this, a);
  };
}
function Vf(e, t) {
  return function() {
    var n = arguments.length;
    if (n) {
      for (var i = Array(n); n--; )
        i[n] = arguments[n];
      var r = i[0] = t.apply(void 0, i);
      return e.apply(void 0, i), r;
    }
  };
}
function ph(e, t, n, i) {
  var r = typeof t == "function", o = t === Object(t);
  if (o && (i = n, n = t, t = void 0), n == null)
    throw new TypeError();
  i || (i = {});
  var a = {
    cap: "cap" in i ? i.cap : !0,
    curry: "curry" in i ? i.curry : !0,
    fixed: "fixed" in i ? i.fixed : !0,
    immutable: "immutable" in i ? i.immutable : !0,
    rearg: "rearg" in i ? i.rearg : !0
  }, l = r ? n : xL, u = "curry" in i && i.curry, d = "fixed" in i && i.fixed, f = "rearg" in i && i.rearg, m = r ? n.runInContext() : void 0, h = r ? n : {
    ary: e.ary,
    assign: e.assign,
    clone: e.clone,
    curry: e.curry,
    forEach: e.forEach,
    isArray: e.isArray,
    isError: e.isError,
    isFunction: e.isFunction,
    isWeakMap: e.isWeakMap,
    iteratee: e.iteratee,
    keys: e.keys,
    rearg: e.rearg,
    toInteger: e.toInteger,
    toPath: e.toPath
  }, v = h.ary, y = h.assign, p = h.clone, b = h.curry, x = h.forEach, _ = h.isArray, O = h.isError, D = h.isFunction, F = h.isWeakMap, $ = h.keys, A = h.rearg, k = h.toInteger, S = h.toPath, M = $(Ut.aryMethod), E = {
    castArray: function(Q) {
      return function() {
        var J = arguments[0];
        return _(J) ? Q(Ay(J)) : Q.apply(void 0, arguments);
      };
    },
    iteratee: function(Q) {
      return function() {
        var J = arguments[0], re = arguments[1], me = Q(J, re), xe = me.length;
        return a.cap && typeof re == "number" ? (re = re > 2 ? re - 2 : 1, xe && xe <= re ? me : Bf(me, re)) : me;
      };
    },
    mixin: function(Q) {
      return function(J) {
        var re = this;
        if (!D(re))
          return Q(re, Object(J));
        var me = [];
        return x($(J), function(xe) {
          D(J[xe]) && me.push([xe, re.prototype[xe]]);
        }), Q(re, Object(J)), x(me, function(xe) {
          var tt = xe[1];
          D(tt) ? re.prototype[xe[0]] = tt : delete re.prototype[xe[0]];
        }), re;
      };
    },
    nthArg: function(Q) {
      return function(J) {
        var re = J < 0 ? 1 : k(J) + 1;
        return b(Q(J), re);
      };
    },
    rearg: function(Q) {
      return function(J, re) {
        var me = re ? re.length : 0;
        return b(Q(J, re), me);
      };
    },
    runInContext: function(Q) {
      return function(J) {
        return ph(e, Q(J), i);
      };
    }
  };
  function I(Q, J) {
    if (a.cap) {
      var re = Ut.iterateeRearg[Q];
      if (re)
        return U(J, re);
      var me = !r && Ut.iterateeAry[Q];
      if (me)
        return j(J, me);
    }
    return J;
  }
  function L(Q, J, re) {
    return u || a.curry && re > 1 ? b(J, re) : J;
  }
  function N(Q, J, re) {
    if (a.fixed && (d || !Ut.skipFixed[Q])) {
      var me = Ut.methodSpread[Q], xe = me && me.start;
      return xe === void 0 ? v(J, re) : CL(J, xe);
    }
    return J;
  }
  function V(Q, J, re) {
    return a.rearg && re > 1 && (f || !Ut.skipRearg[Q]) ? A(J, Ut.methodRearg[Q] || Ut.aryRearg[re]) : J;
  }
  function z(Q, J) {
    J = S(J);
    for (var re = -1, me = J.length, xe = me - 1, tt = p(Object(Q)), nt = tt; nt != null && ++re < me; ) {
      var fe = J[re], be = nt[fe];
      be != null && !(D(be) || O(be) || F(be)) && (nt[fe] = p(re == xe ? be : Object(be))), nt = nt[fe];
    }
    return tt;
  }
  function H(Q) {
    return ue.runInContext.convert(Q)(void 0);
  }
  function W(Q, J) {
    var re = Ut.aliasToReal[Q] || Q, me = Ut.remap[re] || re, xe = i;
    return function(tt) {
      var nt = r ? m : h, fe = r ? m[me] : J, be = y(y({}, xe), tt);
      return ph(nt, re, fe, be);
    };
  }
  function j(Q, J) {
    return K(Q, function(re) {
      return typeof re == "function" ? Bf(re, J) : re;
    });
  }
  function U(Q, J) {
    return K(Q, function(re) {
      var me = J.length;
      return kL(A(Bf(re, me), J), me);
    });
  }
  function K(Q, J) {
    return function() {
      var re = arguments.length;
      if (!re)
        return Q();
      for (var me = Array(re); re--; )
        me[re] = arguments[re];
      var xe = a.rearg ? 0 : re - 1;
      return me[xe] = J(me[xe]), Q.apply(void 0, me);
    };
  }
  function te(Q, J, re) {
    var me, xe = Ut.aliasToReal[Q] || Q, tt = J, nt = E[xe];
    return nt ? tt = nt(J) : a.immutable && (Ut.mutate.array[xe] ? tt = Vf(J, Ay) : Ut.mutate.object[xe] ? tt = Vf(J, SL(J)) : Ut.mutate.set[xe] && (tt = Vf(J, z))), x(M, function(fe) {
      return x(Ut.aryMethod[fe], function(be) {
        if (xe == be) {
          var Ee = Ut.methodSpread[xe], ke = Ee && Ee.afterRearg;
          return me = ke ? N(xe, V(xe, tt, fe), fe) : V(xe, N(xe, tt, fe), fe), me = I(xe, me), me = L(xe, me, fe), !1;
        }
      }), !me;
    }), me || (me = tt), me == J && (me = u ? b(me, 1) : function() {
      return J.apply(this, arguments);
    }), me.convert = W(xe, J), me.placeholder = J.placeholder = re, me;
  }
  if (!o)
    return te(t, n, l);
  var ue = n, de = [];
  return x(M, function(Q) {
    x(Ut.aryMethod[Q], function(J) {
      var re = ue[Ut.remap[J] || J];
      re && de.push([J, te(J, re, ue)]);
    });
  }), x($(ue), function(Q) {
    var J = ue[Q];
    if (typeof J == "function") {
      for (var re = de.length; re--; )
        if (de[re][0] == Q)
          return;
      J.convert = W(Q, J), de.push([Q, J]);
    }
  }), x(de, function(Q) {
    ue[Q[0]] = Q[1];
  }), ue.convert = H, ue.placeholder = ue, x($(ue), function(Q) {
    x(Ut.realToAlias[Q] || [], function(J) {
      ue[J] = ue[Q];
    });
  }), ue;
}
var OL = ph, Ey = wL.runInContext(), Fs = OL(Ey, Ey);
function cw({
  number: e,
  precision: t,
  locale: n = "en",
  grouping: i = !1,
  style: r = "decimal",
  currency: o = "EUR",
  currencyDisplay: a = "code"
}) {
  const l = {
    en: "en",
    de: "de-DE"
  };
  return e.toLocaleString(l[n] ?? l.en, {
    style: r,
    currency: o,
    currencyDisplay: a,
    useGrouping: i,
    minimumFractionDigits: t,
    maximumFractionDigits: t
  });
}
const ML = (e) => e.replace(/\s/g, ""), TL = (e) => e.replace(/,/g, "."), PL = (e) => e.replace(/[^0-9.]/gi, ""), AL = (e) => (t) => {
  const n = `${t}`.split(".");
  if (n && n.length > 1) {
    const i = n[1];
    if (i && i.length > Number(e))
      return `${n[0]}.${i.substring(0, e)}`;
  }
  return `${t}`;
}, EL = (e) => Fs.pipe(ML, TL, PL, AL(e));
function dw({
  v: e,
  precision: t,
  symbol: n,
  grouping: i = !1,
  locale: r = "en"
}) {
  const o = Number.isNaN(t) ? 0 : Number(t);
  let a = new zr(e).toFixed(o);
  return i && (a = cw({
    number: +a,
    precision: o + 1,
    grouping: !0,
    locale: r
  }), a = a.slice(0, -1)), n && (a = `${a} ${n}`), a;
}
const IL = { class: "ot-balance" }, DL = {
  name: "OtBalance",
  customOptions: {}
}, pg = /* @__PURE__ */ Ae({
  ...DL,
  props: {
    grouping: { type: Boolean, default: !0 },
    lightSymbol: { type: Boolean, default: !1 },
    masked: { type: Boolean, default: !1 },
    precision: { type: [Number, String], required: !1 },
    symbol: { type: String, required: !1 },
    truncate: { type: Boolean, default: !1 },
    value: { type: [String, Number, Object], required: !1 }
  },
  setup(e) {
    const t = e, { t: n, current: i } = tn(), r = 8, o = 100, a = B(() => {
      const l = !t.precision || Number.isNaN(+t.precision) ? r : t.precision, u = t.masked ? o : Number(t.value);
      if (!t.value || Number.isNaN(u))
        return n("$vuetify.fundamentals.emptyValues.default");
      const d = dw({
        v: u,
        precision: l,
        grouping: t.grouping,
        locale: i.value
      });
      return t.masked ? d.replace(/[0-9]/g, "*") : d;
    });
    return (l, u) => (ee(), ce("span", IL, [
      ve("div", {
        class: we(["ot-balance__number", { "truncate-text": e.truncate }]),
        testid: "balance-value"
      }, Ue(a.value), 3),
      e.symbol ? (ee(), ce("div", {
        key: 0,
        class: we(["ot-balance__symbol", { "ot-balance__symbol--light": e.lightSymbol }])
      }, Ue(e.symbol), 3)) : Fe("", !0)
    ]));
  }
}), LL = {
  name: "OtBalanceLoading",
  customOptions: {}
}, fw = /* @__PURE__ */ Ae({
  ...LL,
  props: {
    loadingUntil: { type: Boolean, required: !0 },
    variant: { type: String, default: "center" }
  },
  setup(e) {
    return (t, n) => (ee(), Ne(Vc, {
      class: we(["ot-balance-loading", `ot-balance-loading--${e.variant}`]),
      until: e.loadingUntil,
      "is-black": !1
    }, {
      default: Ye(() => [
        T(pg, ge({ class: "ot-balance-loading__balance" }, t.$attrs), null, 16)
      ]),
      _: 1
    }, 8, ["class", "until"]));
  }
}), BL = {
  key: 1,
  class: "ot-banner__message"
}, VL = {
  name: "OtBanner",
  customOptions: {}
}, hw = /* @__PURE__ */ Ae({
  ...VL,
  props: {
    message: { type: String, default: "" },
    variant: { type: String, default: "warning" }
  },
  setup(e) {
    return (t, n) => (ee(), ce("div", {
      class: we(["ot-banner", [`ot-banner--${e.variant}`]])
    }, [
      t.$slots.default ? De(t.$slots, "default", { key: 0 }) : (ee(), ce("div", BL, Ue(e.message), 1))
    ], 2));
  }
}), $L = { class: "ot-button-dropdown" }, RL = {
  name: "OtButtonDropdown",
  customOptions: {}
}, gw = /* @__PURE__ */ Ae({
  ...RL,
  props: {
    activatorIconClass: { type: String, default: "" },
    activatorTextClass: { type: String, default: "" },
    btnText: { type: String, required: !1 },
    countZendesk: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    isOpen: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    size: { type: String, default: "sm" },
    square: { type: Boolean, default: !1 },
    uniqueId: { type: String },
    variant: { type: String, default: "icon" }
  },
  emits: ["update:isOpen"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = (x) => {
      const _ = (E) => (I) => E ? getComputedStyle(E).getPropertyValue(`--${I}`).trim() : void 0, O = (E) => {
        const I = document.querySelector("body");
        return _(I)(E);
      }, D = (E) => E ? Number(E.replace("rem", "").replace("px", "")) : 0, F = _(x), $ = O("safe-area-top"), A = F("menu-max-height"), k = F("menu-activator-gap"), S = F("menu-reserved-space-around"), M = O("zendesk-safe-zone-bottom");
      return {
        iosNativeSafeZoneTop: D($) ?? 0,
        menuActivatorGap: D(k) ?? 4,
        menuMaxHeight: D(A) ?? 400,
        menuReservedSpaceAround: D(S) ?? 16,
        zendeskSafeZoneBottom: D(M) ?? 0
      };
    }, o = ie(), a = ie(), l = ie(n.isOpen);
    pe(
      () => n.isOpen,
      (x) => {
        l.value = x;
      }
    );
    const u = ie(!1), d = 300, f = B({
      get: () => l.value,
      set: (x) => {
        x ? l.value = x : (u.value = !1, setTimeout(() => {
          l.value = x;
        }, d)), i("update:isOpen", x);
      }
    }), m = ie({}), h = B(() => n.variant === "icon"), v = () => {
      n.disabled || (f.value = !f.value);
    }, y = B(() => f.value ? "primary" : "dark-outline"), p = () => {
      f.value = !1;
    }, b = (x) => {
      if (!x || !o.value || !a.value)
        return;
      a.value.scrollTop = 0;
      const { bottom: _, right: O, top: D } = o.value.$el.getBoundingClientRect(), { height: F } = a.value.getBoundingClientRect(), { iosNativeSafeZoneTop: $, menuActivatorGap: A, menuMaxHeight: k, menuReservedSpaceAround: S, zendeskSafeZoneBottom: M } = r(o.value.$el), E = F > k ? k : F, I = D - $ - S, L = window.innerHeight - _ - S - (n.countZendesk ? M : 0), N = I > E ? E : I, V = L > E ? E : L, z = `calc(100% - ${O}px)`, H = () => {
        m.value = {
          top: `${D - N - A}px`,
          right: z,
          height: `${N}px`,
          transformOrigin: "bottom right"
        };
      }, W = () => {
        m.value = {
          top: `${_ + A}px`,
          right: z,
          height: `${V}px`,
          transformOrigin: "top right"
        };
      };
      L > V ? W() : I > N ? H() : L > I ? W() : H(), u.value = !0;
    };
    return pe(f, (x) => {
      gt(() => b(x));
    }), (x, _) => (ee(), ce("div", $L, [
      T(Ur, {
        ref_key: "activatorEl",
        ref: o,
        class: we(["ot-button-dropdown__activator", { "ot-button-dropdown__activator--square": e.square || e.variant === "icon" }]),
        size: e.size,
        variant: y.value,
        disabled: e.disabled,
        loading: e.loading,
        "unique-id": e.uniqueId,
        onClick: _[0] || (_[0] = Wr((O) => v(), ["stop"]))
      }, {
        default: Ye(() => [
          h.value ? (ee(), Ne(qt, {
            key: 0,
            name: "more",
            class: we(["ot-button-dropdown__activator-icon", e.activatorIconClass]),
            "inherit-stroke": !0
          }, null, 8, ["class"])) : (ee(), ce("span", {
            key: 1,
            class: we(["ot-button-dropdown__activator-text", e.activatorTextClass])
          }, Ue(e.btnText), 3))
        ]),
        _: 1
      }, 8, ["class", "size", "variant", "disabled", "loading", "unique-id"]),
      (ee(), Ne(As, { to: "body" }, [
        f.value ? (ee(), ce("div", {
          key: 0,
          ref_key: "menuContentEl",
          ref: a,
          class: we(["ot-button-dropdown__wrapper", { "ot-button-dropdown__wrapper--open": u.value }]),
          style: Do([m.value, `--animation-duration:${d}ms`]),
          onClick: _[1] || (_[1] = Wr((O) => p(), ["stop"]))
        }, [
          De(x.$slots, "options", { itemClass: "ot-button-dropdown__item" })
        ], 6)) : Fe("", !0)
      ])),
      (ee(), Ne(As, { to: "body" }, [
        f.value ? (ee(), ce("div", {
          key: 0,
          class: "ot-button-dropdown__click-away",
          onClick: _[2] || (_[2] = Wr((O) => p(), ["stop"]))
        })) : Fe("", !0)
      ]))
    ]));
  }
}), FL = {
  name: "OtButtonToggle",
  customOptions: {}
}, mw = /* @__PURE__ */ Ae({
  ...FL,
  props: {
    modelValue: { type: Object, required: !0 },
    options: { type: Array, required: !0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = t, i = (r) => {
      n("update:modelValue", r);
    };
    return (r, o) => (ee(), Ne(fI, ge({
      class: "ot-button-toggle",
      rounded: "16",
      variant: "flat",
      color: "elevation-2",
      "model-value": e.modelValue.value
    }, r.$attrs), {
      default: Ye(() => [
        (ee(!0), ce(qe, null, Dn(e.options, (a) => (ee(), Ne(In, {
          key: a.label,
          value: a.value,
          class: "ot-button-toggle__item",
          onClick: (l) => i(a)
        }, {
          default: Ye(() => [
            dr(Ue(a.label), 1)
          ]),
          _: 2
        }, 1032, ["value", "onClick"]))), 128))
      ]),
      _: 1
    }, 16, ["model-value"]));
  }
});
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function ul(e) {
  return e + 0.5 | 0;
}
const Vr = (e, t, n) => Math.max(Math.min(e, n), t);
function bs(e) {
  return Vr(ul(e * 2.55), 0, 255);
}
function Hr(e) {
  return Vr(ul(e * 255), 0, 255);
}
function rr(e) {
  return Vr(ul(e / 2.55) / 100, 0, 1);
}
function Iy(e) {
  return Vr(ul(e * 100), 0, 100);
}
const ci = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, yh = [..."0123456789ABCDEF"], NL = (e) => yh[e & 15], WL = (e) => yh[(e & 240) >> 4] + yh[e & 15], gu = (e) => (e & 240) >> 4 === (e & 15), zL = (e) => gu(e.r) && gu(e.g) && gu(e.b) && gu(e.a);
function HL(e) {
  var t = e.length, n;
  return e[0] === "#" && (t === 4 || t === 5 ? n = {
    r: 255 & ci[e[1]] * 17,
    g: 255 & ci[e[2]] * 17,
    b: 255 & ci[e[3]] * 17,
    a: t === 5 ? ci[e[4]] * 17 : 255
  } : (t === 7 || t === 9) && (n = {
    r: ci[e[1]] << 4 | ci[e[2]],
    g: ci[e[3]] << 4 | ci[e[4]],
    b: ci[e[5]] << 4 | ci[e[6]],
    a: t === 9 ? ci[e[7]] << 4 | ci[e[8]] : 255
  })), n;
}
const jL = (e, t) => e < 255 ? t(e) : "";
function YL(e) {
  var t = zL(e) ? NL : WL;
  return e ? "#" + t(e.r) + t(e.g) + t(e.b) + jL(e.a, t) : void 0;
}
const UL = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function vw(e, t, n) {
  const i = t * Math.min(n, 1 - n), r = (o, a = (o + e / 30) % 12) => n - i * Math.max(Math.min(a - 3, 9 - a, 1), -1);
  return [r(0), r(8), r(4)];
}
function qL(e, t, n) {
  const i = (r, o = (r + e / 60) % 6) => n - n * t * Math.max(Math.min(o, 4 - o, 1), 0);
  return [i(5), i(3), i(1)];
}
function GL(e, t, n) {
  const i = vw(e, 1, 0.5);
  let r;
  for (t + n > 1 && (r = 1 / (t + n), t *= r, n *= r), r = 0; r < 3; r++)
    i[r] *= 1 - t - n, i[r] += t;
  return i;
}
function XL(e, t, n, i, r) {
  return e === r ? (t - n) / i + (t < n ? 6 : 0) : t === r ? (n - e) / i + 2 : (e - t) / i + 4;
}
function yg(e) {
  const n = e.r / 255, i = e.g / 255, r = e.b / 255, o = Math.max(n, i, r), a = Math.min(n, i, r), l = (o + a) / 2;
  let u, d, f;
  return o !== a && (f = o - a, d = l > 0.5 ? f / (2 - o - a) : f / (o + a), u = XL(n, i, r, f, o), u = u * 60 + 0.5), [u | 0, d || 0, l];
}
function bg(e, t, n, i) {
  return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, i)).map(Hr);
}
function wg(e, t, n) {
  return bg(vw, e, t, n);
}
function KL(e, t, n) {
  return bg(GL, e, t, n);
}
function ZL(e, t, n) {
  return bg(qL, e, t, n);
}
function pw(e) {
  return (e % 360 + 360) % 360;
}
function QL(e) {
  const t = UL.exec(e);
  let n = 255, i;
  if (!t)
    return;
  t[5] !== i && (n = t[6] ? bs(+t[5]) : Hr(+t[5]));
  const r = pw(+t[2]), o = +t[3] / 100, a = +t[4] / 100;
  return t[1] === "hwb" ? i = KL(r, o, a) : t[1] === "hsv" ? i = ZL(r, o, a) : i = wg(r, o, a), {
    r: i[0],
    g: i[1],
    b: i[2],
    a: n
  };
}
function JL(e, t) {
  var n = yg(e);
  n[0] = pw(n[0] + t), n = wg(n), e.r = n[0], e.g = n[1], e.b = n[2];
}
function eB(e) {
  if (!e)
    return;
  const t = yg(e), n = t[0], i = Iy(t[1]), r = Iy(t[2]);
  return e.a < 255 ? `hsla(${n}, ${i}%, ${r}%, ${rr(e.a)})` : `hsl(${n}, ${i}%, ${r}%)`;
}
const Dy = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, Ly = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function tB() {
  const e = {}, t = Object.keys(Ly), n = Object.keys(Dy);
  let i, r, o, a, l;
  for (i = 0; i < t.length; i++) {
    for (a = l = t[i], r = 0; r < n.length; r++)
      o = n[r], l = l.replace(o, Dy[o]);
    o = parseInt(Ly[a], 16), e[l] = [o >> 16 & 255, o >> 8 & 255, o & 255];
  }
  return e;
}
let mu;
function nB(e) {
  mu || (mu = tB(), mu.transparent = [0, 0, 0, 0]);
  const t = mu[e.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const iB = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rB(e) {
  const t = iB.exec(e);
  let n = 255, i, r, o;
  if (t) {
    if (t[7] !== i) {
      const a = +t[7];
      n = t[8] ? bs(a) : Vr(a * 255, 0, 255);
    }
    return i = +t[1], r = +t[3], o = +t[5], i = 255 & (t[2] ? bs(i) : Vr(i, 0, 255)), r = 255 & (t[4] ? bs(r) : Vr(r, 0, 255)), o = 255 & (t[6] ? bs(o) : Vr(o, 0, 255)), {
      r: i,
      g: r,
      b: o,
      a: n
    };
  }
}
function oB(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${rr(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
const $f = (e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, fa = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function aB(e, t, n) {
  const i = fa(rr(e.r)), r = fa(rr(e.g)), o = fa(rr(e.b));
  return {
    r: Hr($f(i + n * (fa(rr(t.r)) - i))),
    g: Hr($f(r + n * (fa(rr(t.g)) - r))),
    b: Hr($f(o + n * (fa(rr(t.b)) - o))),
    a: e.a + n * (t.a - e.a)
  };
}
function vu(e, t, n) {
  if (e) {
    let i = yg(e);
    i[t] = Math.max(0, Math.min(i[t] + i[t] * n, t === 0 ? 360 : 1)), i = wg(i), e.r = i[0], e.g = i[1], e.b = i[2];
  }
}
function yw(e, t) {
  return e && Object.assign(t || {}, e);
}
function By(e) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (t = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (t.a = Hr(e[3]))) : (t = yw(e, { r: 0, g: 0, b: 0, a: 1 }), t.a = Hr(t.a)), t;
}
function sB(e) {
  return e.charAt(0) === "r" ? rB(e) : QL(e);
}
class Ns {
  constructor(t) {
    if (t instanceof Ns)
      return t;
    const n = typeof t;
    let i;
    n === "object" ? i = By(t) : n === "string" && (i = HL(t) || nB(t) || sB(t)), this._rgb = i, this._valid = !!i;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = yw(this._rgb);
    return t && (t.a = rr(t.a)), t;
  }
  set rgb(t) {
    this._rgb = By(t);
  }
  rgbString() {
    return this._valid ? oB(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? YL(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? eB(this._rgb) : void 0;
  }
  mix(t, n) {
    if (t) {
      const i = this.rgb, r = t.rgb;
      let o;
      const a = n === o ? 0.5 : n, l = 2 * a - 1, u = i.a - r.a, d = ((l * u === -1 ? l : (l + u) / (1 + l * u)) + 1) / 2;
      o = 1 - d, i.r = 255 & d * i.r + o * r.r + 0.5, i.g = 255 & d * i.g + o * r.g + 0.5, i.b = 255 & d * i.b + o * r.b + 0.5, i.a = a * i.a + (1 - a) * r.a, this.rgb = i;
    }
    return this;
  }
  interpolate(t, n) {
    return t && (this._rgb = aB(this._rgb, t._rgb, n)), this;
  }
  clone() {
    return new Ns(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = Hr(t), this;
  }
  clearer(t) {
    const n = this._rgb;
    return n.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, n = ul(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = n, this;
  }
  opaquer(t) {
    const n = this._rgb;
    return n.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return vu(this._rgb, 2, t), this;
  }
  darken(t) {
    return vu(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return vu(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return vu(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return JL(this._rgb, t), this;
  }
}
/*!
 * Chart.js v4.4.3
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */
function tr() {
}
const lB = /* @__PURE__ */ (() => {
  let e = 0;
  return () => e++;
})();
function _t(e) {
  return e === null || typeof e > "u";
}
function Ct(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function it(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function Et(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function zn(e, t) {
  return Et(e) ? e : t;
}
function et(e, t) {
  return typeof e > "u" ? t : e;
}
const uB = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : +e / t, bw = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function vt(e, t, n) {
  if (e && typeof e.call == "function")
    return e.apply(n, t);
}
function dt(e, t, n, i) {
  let r, o, a;
  if (Ct(e))
    if (o = e.length, i)
      for (r = o - 1; r >= 0; r--)
        t.call(n, e[r], r);
    else
      for (r = 0; r < o; r++)
        t.call(n, e[r], r);
  else if (it(e))
    for (a = Object.keys(e), o = a.length, r = 0; r < o; r++)
      t.call(n, e[a[r]], a[r]);
}
function ac(e, t) {
  let n, i, r, o;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (n = 0, i = e.length; n < i; ++n)
    if (r = e[n], o = t[n], r.datasetIndex !== o.datasetIndex || r.index !== o.index)
      return !1;
  return !0;
}
function sc(e) {
  if (Ct(e))
    return e.map(sc);
  if (it(e)) {
    const t = /* @__PURE__ */ Object.create(null), n = Object.keys(e), i = n.length;
    let r = 0;
    for (; r < i; ++r)
      t[n[r]] = sc(e[n[r]]);
    return t;
  }
  return e;
}
function ww(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
function cB(e, t, n, i) {
  if (!ww(e))
    return;
  const r = t[e], o = n[e];
  it(r) && it(o) ? Ws(r, o, i) : t[e] = sc(o);
}
function Ws(e, t, n) {
  const i = Ct(t) ? t : [
    t
  ], r = i.length;
  if (!it(e))
    return e;
  n = n || {};
  const o = n.merger || cB;
  let a;
  for (let l = 0; l < r; ++l) {
    if (a = i[l], !it(a))
      continue;
    const u = Object.keys(a);
    for (let d = 0, f = u.length; d < f; ++d)
      o(u[d], e, a, n);
  }
  return e;
}
function Ss(e, t) {
  return Ws(e, t, {
    merger: dB
  });
}
function dB(e, t, n) {
  if (!ww(e))
    return;
  const i = t[e], r = n[e];
  it(i) && it(r) ? Ss(i, r) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = sc(r));
}
const Vy = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: (e) => e.x,
  y: (e) => e.y
};
function fB(e) {
  const t = e.split("."), n = [];
  let i = "";
  for (const r of t)
    i += r, i.endsWith("\\") ? i = i.slice(0, -1) + "." : (n.push(i), i = "");
  return n;
}
function hB(e) {
  const t = fB(e);
  return (n) => {
    for (const i of t) {
      if (i === "")
        break;
      n = n && n[i];
    }
    return n;
  };
}
function zs(e, t) {
  return (Vy[t] || (Vy[t] = hB(t)))(e);
}
function _g(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const lc = (e) => typeof e < "u", qr = (e) => typeof e == "function", $y = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
};
function gB(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const Dt = Math.PI, xt = 2 * Dt, mB = xt + Dt, uc = Number.POSITIVE_INFINITY, vB = Dt / 180, $t = Dt / 2, _o = Dt / 4, Ry = Dt * 2 / 3, $r = Math.log10, Ca = Math.sign;
function Cs(e, t, n) {
  return Math.abs(e - t) < n;
}
function Fy(e) {
  const t = Math.round(e);
  e = Cs(e, t, e / 1e3) ? t : e;
  const n = Math.pow(10, Math.floor($r(e))), i = e / n;
  return (i <= 1 ? 1 : i <= 2 ? 2 : i <= 5 ? 5 : 10) * n;
}
function pB(e) {
  const t = [], n = Math.sqrt(e);
  let i;
  for (i = 1; i < n; i++)
    e % i === 0 && (t.push(i), t.push(e / i));
  return n === (n | 0) && t.push(n), t.sort((r, o) => r - o).pop(), t;
}
function Hs(e) {
  return !isNaN(parseFloat(e)) && isFinite(e);
}
function yB(e, t) {
  const n = Math.round(e);
  return n - t <= e && n + t >= e;
}
function _w(e, t, n) {
  let i, r, o;
  for (i = 0, r = e.length; i < r; i++)
    o = e[i][n], isNaN(o) || (t.min = Math.min(t.min, o), t.max = Math.max(t.max, o));
}
function $i(e) {
  return e * (Dt / 180);
}
function xg(e) {
  return e * (180 / Dt);
}
function Ny(e) {
  if (!Et(e))
    return;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n++;
  return n;
}
function xw(e, t) {
  const n = t.x - e.x, i = t.y - e.y, r = Math.sqrt(n * n + i * i);
  let o = Math.atan2(i, n);
  return o < -0.5 * Dt && (o += xt), {
    angle: o,
    distance: r
  };
}
function bh(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function bB(e, t) {
  return (e - t + mB) % xt - Dt;
}
function Hn(e) {
  return (e % xt + xt) % xt;
}
function js(e, t, n, i) {
  const r = Hn(e), o = Hn(t), a = Hn(n), l = Hn(o - r), u = Hn(a - r), d = Hn(r - o), f = Hn(r - a);
  return r === o || r === a || i && o === a || l > u && d < f;
}
function yn(e, t, n) {
  return Math.max(t, Math.min(n, e));
}
function wB(e) {
  return yn(e, -32768, 32767);
}
function To(e, t, n, i = 1e-6) {
  return e >= Math.min(t, n) - i && e <= Math.max(t, n) + i;
}
function kg(e, t, n) {
  n = n || ((a) => e[a] < t);
  let i = e.length - 1, r = 0, o;
  for (; i - r > 1; )
    o = r + i >> 1, n(o) ? r = o : i = o;
  return {
    lo: r,
    hi: i
  };
}
const Po = (e, t, n, i) => kg(e, n, i ? (r) => {
  const o = e[r][t];
  return o < n || o === n && e[r + 1][t] === n;
} : (r) => e[r][t] < n), _B = (e, t, n) => kg(e, n, (i) => e[i][t] >= n);
function xB(e, t, n) {
  let i = 0, r = e.length;
  for (; i < r && e[i] < t; )
    i++;
  for (; r > i && e[r - 1] > n; )
    r--;
  return i > 0 || r < e.length ? e.slice(i, r) : e;
}
const kw = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function kB(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), kw.forEach((n) => {
    const i = "_onData" + _g(n), r = e[n];
    Object.defineProperty(e, n, {
      configurable: !0,
      enumerable: !1,
      value(...o) {
        const a = r.apply(this, o);
        return e._chartjs.listeners.forEach((l) => {
          typeof l[i] == "function" && l[i](...o);
        }), a;
      }
    });
  });
}
function Wy(e, t) {
  const n = e._chartjs;
  if (!n)
    return;
  const i = n.listeners, r = i.indexOf(t);
  r !== -1 && i.splice(r, 1), !(i.length > 0) && (kw.forEach((o) => {
    delete e[o];
  }), delete e._chartjs);
}
function SB(e) {
  const t = new Set(e);
  return t.size === e.length ? e : Array.from(t);
}
const Sw = function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
}();
function Cw(e, t) {
  let n = [], i = !1;
  return function(...r) {
    n = r, i || (i = !0, Sw.call(window, () => {
      i = !1, e.apply(t, n);
    }));
  };
}
function CB(e, t) {
  let n;
  return function(...i) {
    return t ? (clearTimeout(n), n = setTimeout(e, t, i)) : e.apply(this, i), t;
  };
}
const Ow = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", Wn = (e, t, n) => e === "start" ? t : e === "end" ? n : (t + n) / 2, OB = (e, t, n, i) => e === (i ? "left" : "right") ? n : e === "center" ? (t + n) / 2 : t;
function MB(e, t, n) {
  const i = t.length;
  let r = 0, o = i;
  if (e._sorted) {
    const { iScale: a, _parsed: l } = e, u = a.axis, { min: d, max: f, minDefined: m, maxDefined: h } = a.getUserBounds();
    m && (r = yn(Math.min(
      // @ts-expect-error Need to type _parsed
      Po(l, u, d).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? i : Po(t, u, a.getPixelForValue(d)).lo
    ), 0, i - 1)), h ? o = yn(Math.max(
      // @ts-expect-error Need to type _parsed
      Po(l, a.axis, f, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? 0 : Po(t, u, a.getPixelForValue(f), !0).hi + 1
    ), r, i) - r : o = i - r;
  }
  return {
    start: r,
    count: o
  };
}
function TB(e) {
  const { xScale: t, yScale: n, _scaleRanges: i } = e, r = {
    xmin: t.min,
    xmax: t.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!i)
    return e._scaleRanges = r, !0;
  const o = i.xmin !== t.min || i.xmax !== t.max || i.ymin !== n.min || i.ymax !== n.max;
  return Object.assign(i, r), o;
}
const pu = (e) => e === 0 || e === 1, zy = (e, t, n) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * xt / n)), Hy = (e, t, n) => Math.pow(2, -10 * e) * Math.sin((e - t) * xt / n) + 1, Os = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * $t) + 1,
  easeOutSine: (e) => Math.sin(e * $t),
  easeInOutSine: (e) => -0.5 * (Math.cos(Dt * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => pu(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => pu(e) ? e : zy(e, 0.075, 0.3),
  easeOutElastic: (e) => pu(e) ? e : Hy(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return pu(e) ? e : e < 0.5 ? 0.5 * zy(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * Hy(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - Os.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? Os.easeInBounce(e * 2) * 0.5 : Os.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
function Sg(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function jy(e) {
  return Sg(e) ? e : new Ns(e);
}
function Rf(e) {
  return Sg(e) ? e : new Ns(e).saturate(0.5).darken(0.1).hexString();
}
const PB = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], AB = [
  "color",
  "borderColor",
  "backgroundColor"
];
function EB(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: AB
    },
    numbers: {
      type: "number",
      properties: PB
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function IB(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const Yy = /* @__PURE__ */ new Map();
function DB(e, t) {
  t = t || {};
  const n = e + JSON.stringify(t);
  let i = Yy.get(n);
  return i || (i = new Intl.NumberFormat(e, t), Yy.set(n, i)), i;
}
function $c(e, t, n) {
  return DB(t, n).format(e);
}
const Mw = {
  values(e) {
    return Ct(e) ? e : "" + e;
  },
  numeric(e, t, n) {
    if (e === 0)
      return "0";
    const i = this.chart.options.locale;
    let r, o = e;
    if (n.length > 1) {
      const d = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (d < 1e-4 || d > 1e15) && (r = "scientific"), o = LB(e, n);
    }
    const a = $r(Math.abs(o)), l = isNaN(a) ? 1 : Math.max(Math.min(-1 * Math.floor(a), 20), 0), u = {
      notation: r,
      minimumFractionDigits: l,
      maximumFractionDigits: l
    };
    return Object.assign(u, this.options.ticks.format), $c(e, i, u);
  },
  logarithmic(e, t, n) {
    if (e === 0)
      return "0";
    const i = n[t].significand || e / Math.pow(10, Math.floor($r(e)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(i) || t > 0.8 * n.length ? Mw.numeric.call(this, e, t, n) : "";
  }
};
function LB(e, t) {
  let n = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(n) >= 1 && e !== Math.floor(e) && (n = e - Math.floor(e)), n;
}
var Rc = {
  formatters: Mw
};
function BB(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, n) => n.lineWidth,
      tickColor: (t, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Rc.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const Lo = /* @__PURE__ */ Object.create(null), wh = /* @__PURE__ */ Object.create(null);
function Ms(e, t) {
  if (!t)
    return e;
  const n = t.split(".");
  for (let i = 0, r = n.length; i < r; ++i) {
    const o = n[i];
    e = e[o] || (e[o] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function Ff(e, t, n) {
  return typeof t == "string" ? Ws(Ms(e, t), n) : Ws(Ms(e, ""), t);
}
class VB {
  constructor(t, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (i) => i.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (i, r) => Rf(r.backgroundColor), this.hoverBorderColor = (i, r) => Rf(r.borderColor), this.hoverColor = (i, r) => Rf(r.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(n);
  }
  set(t, n) {
    return Ff(this, t, n);
  }
  get(t) {
    return Ms(this, t);
  }
  describe(t, n) {
    return Ff(wh, t, n);
  }
  override(t, n) {
    return Ff(Lo, t, n);
  }
  route(t, n, i, r) {
    const o = Ms(this, t), a = Ms(this, i), l = "_" + n;
    Object.defineProperties(o, {
      [l]: {
        value: o[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const u = this[l], d = a[r];
          return it(u) ? Object.assign({}, d, u) : et(u, d);
        },
        set(u) {
          this[l] = u;
        }
      }
    });
  }
  apply(t) {
    t.forEach((n) => n(this));
  }
}
var It = /* @__PURE__ */ new VB({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  EB,
  IB,
  BB
]);
function $B(e) {
  return !e || _t(e.size) || _t(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function cc(e, t, n, i, r) {
  let o = t[r];
  return o || (o = t[r] = e.measureText(r).width, n.push(r)), o > i && (i = o), i;
}
function RB(e, t, n, i) {
  i = i || {};
  let r = i.data = i.data || {}, o = i.garbageCollect = i.garbageCollect || [];
  i.font !== t && (r = i.data = {}, o = i.garbageCollect = [], i.font = t), e.save(), e.font = t;
  let a = 0;
  const l = n.length;
  let u, d, f, m, h;
  for (u = 0; u < l; u++)
    if (m = n[u], m != null && !Ct(m))
      a = cc(e, r, o, a, m);
    else if (Ct(m))
      for (d = 0, f = m.length; d < f; d++)
        h = m[d], h != null && !Ct(h) && (a = cc(e, r, o, a, h));
  e.restore();
  const v = o.length / 2;
  if (v > n.length) {
    for (u = 0; u < v; u++)
      delete r[o[u]];
    o.splice(0, v);
  }
  return a;
}
function xo(e, t, n) {
  const i = e.currentDevicePixelRatio, r = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((t - r) * i) / i + r;
}
function Uy(e, t) {
  !t && !e || (t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore());
}
function _h(e, t, n, i) {
  Tw(e, t, n, i, null);
}
function Tw(e, t, n, i, r) {
  let o, a, l, u, d, f, m, h;
  const v = t.pointStyle, y = t.rotation, p = t.radius;
  let b = (y || 0) * vB;
  if (v && typeof v == "object" && (o = v.toString(), o === "[object HTMLImageElement]" || o === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(n, i), e.rotate(b), e.drawImage(v, -v.width / 2, -v.height / 2, v.width, v.height), e.restore();
    return;
  }
  if (!(isNaN(p) || p <= 0)) {
    switch (e.beginPath(), v) {
      default:
        r ? e.ellipse(n, i, r / 2, p, 0, 0, xt) : e.arc(n, i, p, 0, xt), e.closePath();
        break;
      case "triangle":
        f = r ? r / 2 : p, e.moveTo(n + Math.sin(b) * f, i - Math.cos(b) * p), b += Ry, e.lineTo(n + Math.sin(b) * f, i - Math.cos(b) * p), b += Ry, e.lineTo(n + Math.sin(b) * f, i - Math.cos(b) * p), e.closePath();
        break;
      case "rectRounded":
        d = p * 0.516, u = p - d, a = Math.cos(b + _o) * u, m = Math.cos(b + _o) * (r ? r / 2 - d : u), l = Math.sin(b + _o) * u, h = Math.sin(b + _o) * (r ? r / 2 - d : u), e.arc(n - m, i - l, d, b - Dt, b - $t), e.arc(n + h, i - a, d, b - $t, b), e.arc(n + m, i + l, d, b, b + $t), e.arc(n - h, i + a, d, b + $t, b + Dt), e.closePath();
        break;
      case "rect":
        if (!y) {
          u = Math.SQRT1_2 * p, f = r ? r / 2 : u, e.rect(n - f, i - u, 2 * f, 2 * u);
          break;
        }
        b += _o;
      case "rectRot":
        m = Math.cos(b) * (r ? r / 2 : p), a = Math.cos(b) * p, l = Math.sin(b) * p, h = Math.sin(b) * (r ? r / 2 : p), e.moveTo(n - m, i - l), e.lineTo(n + h, i - a), e.lineTo(n + m, i + l), e.lineTo(n - h, i + a), e.closePath();
        break;
      case "crossRot":
        b += _o;
      case "cross":
        m = Math.cos(b) * (r ? r / 2 : p), a = Math.cos(b) * p, l = Math.sin(b) * p, h = Math.sin(b) * (r ? r / 2 : p), e.moveTo(n - m, i - l), e.lineTo(n + m, i + l), e.moveTo(n + h, i - a), e.lineTo(n - h, i + a);
        break;
      case "star":
        m = Math.cos(b) * (r ? r / 2 : p), a = Math.cos(b) * p, l = Math.sin(b) * p, h = Math.sin(b) * (r ? r / 2 : p), e.moveTo(n - m, i - l), e.lineTo(n + m, i + l), e.moveTo(n + h, i - a), e.lineTo(n - h, i + a), b += _o, m = Math.cos(b) * (r ? r / 2 : p), a = Math.cos(b) * p, l = Math.sin(b) * p, h = Math.sin(b) * (r ? r / 2 : p), e.moveTo(n - m, i - l), e.lineTo(n + m, i + l), e.moveTo(n + h, i - a), e.lineTo(n - h, i + a);
        break;
      case "line":
        a = r ? r / 2 : Math.cos(b) * p, l = Math.sin(b) * p, e.moveTo(n - a, i - l), e.lineTo(n + a, i + l);
        break;
      case "dash":
        e.moveTo(n, i), e.lineTo(n + Math.cos(b) * (r ? r / 2 : p), i + Math.sin(b) * p);
        break;
      case !1:
        e.closePath();
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
function ar(e, t, n) {
  return n = n || 0.5, !t || e && e.x > t.left - n && e.x < t.right + n && e.y > t.top - n && e.y < t.bottom + n;
}
function Fc(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function Nc(e) {
  e.restore();
}
function FB(e, t, n, i, r) {
  if (!t)
    return e.lineTo(n.x, n.y);
  if (r === "middle") {
    const o = (t.x + n.x) / 2;
    e.lineTo(o, t.y), e.lineTo(o, n.y);
  } else
    r === "after" != !!i ? e.lineTo(t.x, n.y) : e.lineTo(n.x, t.y);
  e.lineTo(n.x, n.y);
}
function NB(e, t, n, i) {
  if (!t)
    return e.lineTo(n.x, n.y);
  e.bezierCurveTo(i ? t.cp1x : t.cp2x, i ? t.cp1y : t.cp2y, i ? n.cp2x : n.cp1x, i ? n.cp2y : n.cp1y, n.x, n.y);
}
function WB(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), _t(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function zB(e, t, n, i, r) {
  if (r.strikethrough || r.underline) {
    const o = e.measureText(i), a = t - o.actualBoundingBoxLeft, l = t + o.actualBoundingBoxRight, u = n - o.actualBoundingBoxAscent, d = n + o.actualBoundingBoxDescent, f = r.strikethrough ? (u + d) / 2 : d;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = r.decorationWidth || 2, e.moveTo(a, f), e.lineTo(l, f), e.stroke();
  }
}
function HB(e, t) {
  const n = e.fillStyle;
  e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = n;
}
function Oa(e, t, n, i, r, o = {}) {
  const a = Ct(t) ? t : [
    t
  ], l = o.strokeWidth > 0 && o.strokeColor !== "";
  let u, d;
  for (e.save(), e.font = r.string, WB(e, o), u = 0; u < a.length; ++u)
    d = a[u], o.backdrop && HB(e, o.backdrop), l && (o.strokeColor && (e.strokeStyle = o.strokeColor), _t(o.strokeWidth) || (e.lineWidth = o.strokeWidth), e.strokeText(d, n, i, o.maxWidth)), e.fillText(d, n, i, o.maxWidth), zB(e, n, i, d, o), i += Number(r.lineHeight);
  e.restore();
}
function dc(e, t) {
  const { x: n, y: i, w: r, h: o, radius: a } = t;
  e.arc(n + a.topLeft, i + a.topLeft, a.topLeft, 1.5 * Dt, Dt, !0), e.lineTo(n, i + o - a.bottomLeft), e.arc(n + a.bottomLeft, i + o - a.bottomLeft, a.bottomLeft, Dt, $t, !0), e.lineTo(n + r - a.bottomRight, i + o), e.arc(n + r - a.bottomRight, i + o - a.bottomRight, a.bottomRight, $t, 0, !0), e.lineTo(n + r, i + a.topRight), e.arc(n + r - a.topRight, i + a.topRight, a.topRight, 0, -$t, !0), e.lineTo(n + a.topLeft, i);
}
const jB = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, YB = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function UB(e, t) {
  const n = ("" + e).match(jB);
  if (!n || n[1] === "normal")
    return t * 1.2;
  switch (e = +n[2], n[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const qB = (e) => +e || 0;
function Cg(e, t) {
  const n = {}, i = it(t), r = i ? Object.keys(t) : t, o = it(e) ? i ? (a) => et(e[a], e[t[a]]) : (a) => e[a] : () => e;
  for (const a of r)
    n[a] = qB(o(a));
  return n;
}
function GB(e) {
  return Cg(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function ya(e) {
  return Cg(e, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function bn(e) {
  const t = GB(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function an(e, t) {
  e = e || {}, t = t || It.font;
  let n = et(e.size, t.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let i = et(e.style, t.style);
  i && !("" + i).match(YB) && (console.warn('Invalid font style specified: "' + i + '"'), i = void 0);
  const r = {
    family: et(e.family, t.family),
    lineHeight: UB(et(e.lineHeight, t.lineHeight), n),
    size: n,
    style: i,
    weight: et(e.weight, t.weight),
    string: ""
  };
  return r.string = $B(r), r;
}
function yu(e, t, n, i) {
  let r = !0, o, a, l;
  for (o = 0, a = e.length; o < a; ++o)
    if (l = e[o], l !== void 0 && (t !== void 0 && typeof l == "function" && (l = l(t), r = !1), n !== void 0 && Ct(l) && (l = l[n % l.length], r = !1), l !== void 0))
      return i && !r && (i.cacheable = !1), l;
}
function XB(e, t, n) {
  const { min: i, max: r } = e, o = bw(t, (r - i) / 2), a = (l, u) => n && l === 0 ? 0 : l + u;
  return {
    min: a(i, -Math.abs(o)),
    max: a(r, o)
  };
}
function Jr(e, t) {
  return Object.assign(Object.create(e), t);
}
function Og(e, t = [
  ""
], n, i, r = () => e[0]) {
  const o = n || e;
  typeof i > "u" && (i = Iw("_fallback", e));
  const a = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: o,
    _fallback: i,
    _getTarget: r,
    override: (l) => Og([
      l,
      ...e
    ], t, o, i)
  };
  return new Proxy(a, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(l, u) {
      return delete l[u], delete l._keys, delete e[0][u], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(l, u) {
      return Aw(l, u, () => iV(u, t, e, l));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(l, u) {
      return Reflect.getOwnPropertyDescriptor(l._scopes[0], u);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(l, u) {
      return Gy(l).includes(u);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(l) {
      return Gy(l);
    },
    /**
    * A trap for setting property values.
    */
    set(l, u, d) {
      const f = l._storage || (l._storage = r());
      return l[u] = f[u] = d, delete l._keys, !0;
    }
  });
}
function Ma(e, t, n, i) {
  const r = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: Pw(e, i),
    setContext: (o) => Ma(e, o, n, i),
    override: (o) => Ma(e.override(o), t, n, i)
  };
  return new Proxy(r, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(o, a) {
      return delete o[a], delete e[a], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(o, a, l) {
      return Aw(o, a, () => ZB(o, a, l));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(o, a) {
      return o._descriptors.allKeys ? Reflect.has(e, a) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, a);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    /**
    * A trap for the in operator.
    */
    has(o, a) {
      return Reflect.has(e, a);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    /**
    * A trap for setting property values.
    */
    set(o, a, l) {
      return e[a] = l, delete o[a], !0;
    }
  });
}
function Pw(e, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = t.scriptable, _indexable: i = t.indexable, _allKeys: r = t.allKeys } = e;
  return {
    allKeys: r,
    scriptable: n,
    indexable: i,
    isScriptable: qr(n) ? n : () => n,
    isIndexable: qr(i) ? i : () => i
  };
}
const KB = (e, t) => e ? e + _g(t) : t, Mg = (e, t) => it(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function Aw(e, t, n) {
  if (Object.prototype.hasOwnProperty.call(e, t) || t === "constructor")
    return e[t];
  const i = n();
  return e[t] = i, i;
}
function ZB(e, t, n) {
  const { _proxy: i, _context: r, _subProxy: o, _descriptors: a } = e;
  let l = i[t];
  return qr(l) && a.isScriptable(t) && (l = QB(t, l, e, n)), Ct(l) && l.length && (l = JB(t, l, e, a.isIndexable)), Mg(t, l) && (l = Ma(l, r, o && o[t], a)), l;
}
function QB(e, t, n, i) {
  const { _proxy: r, _context: o, _subProxy: a, _stack: l } = n;
  if (l.has(e))
    throw new Error("Recursion detected: " + Array.from(l).join("->") + "->" + e);
  l.add(e);
  let u = t(o, a || i);
  return l.delete(e), Mg(e, u) && (u = Tg(r._scopes, r, e, u)), u;
}
function JB(e, t, n, i) {
  const { _proxy: r, _context: o, _subProxy: a, _descriptors: l } = n;
  if (typeof o.index < "u" && i(e))
    return t[o.index % t.length];
  if (it(t[0])) {
    const u = t, d = r._scopes.filter((f) => f !== u);
    t = [];
    for (const f of u) {
      const m = Tg(d, r, e, f);
      t.push(Ma(m, o, a && a[e], l));
    }
  }
  return t;
}
function Ew(e, t, n) {
  return qr(e) ? e(t, n) : e;
}
const eV = (e, t) => e === !0 ? t : typeof e == "string" ? zs(t, e) : void 0;
function tV(e, t, n, i, r) {
  for (const o of t) {
    const a = eV(n, o);
    if (a) {
      e.add(a);
      const l = Ew(a._fallback, n, r);
      if (typeof l < "u" && l !== n && l !== i)
        return l;
    } else if (a === !1 && typeof i < "u" && n !== i)
      return null;
  }
  return !1;
}
function Tg(e, t, n, i) {
  const r = t._rootScopes, o = Ew(t._fallback, n, i), a = [
    ...e,
    ...r
  ], l = /* @__PURE__ */ new Set();
  l.add(i);
  let u = qy(l, a, n, o || n, i);
  return u === null || typeof o < "u" && o !== n && (u = qy(l, a, o, u, i), u === null) ? !1 : Og(Array.from(l), [
    ""
  ], r, o, () => nV(t, n, i));
}
function qy(e, t, n, i, r) {
  for (; n; )
    n = tV(e, t, n, i, r);
  return n;
}
function nV(e, t, n) {
  const i = e._getTarget();
  t in i || (i[t] = {});
  const r = i[t];
  return Ct(r) && it(n) ? n : r || {};
}
function iV(e, t, n, i) {
  let r;
  for (const o of t)
    if (r = Iw(KB(o, e), n), typeof r < "u")
      return Mg(e, r) ? Tg(n, i, e, r) : r;
}
function Iw(e, t) {
  for (const n of t) {
    if (!n)
      continue;
    const i = n[e];
    if (typeof i < "u")
      return i;
  }
}
function Gy(e) {
  let t = e._keys;
  return t || (t = e._keys = rV(e._scopes)), t;
}
function rV(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const i of Object.keys(n).filter((r) => !r.startsWith("_")))
      t.add(i);
  return Array.from(t);
}
const oV = Number.EPSILON || 1e-14, Ta = (e, t) => t < e.length && !e[t].skip && e[t], Dw = (e) => e === "x" ? "y" : "x";
function aV(e, t, n, i) {
  const r = e.skip ? t : e, o = t, a = n.skip ? t : n, l = bh(o, r), u = bh(a, o);
  let d = l / (l + u), f = u / (l + u);
  d = isNaN(d) ? 0 : d, f = isNaN(f) ? 0 : f;
  const m = i * d, h = i * f;
  return {
    previous: {
      x: o.x - m * (a.x - r.x),
      y: o.y - m * (a.y - r.y)
    },
    next: {
      x: o.x + h * (a.x - r.x),
      y: o.y + h * (a.y - r.y)
    }
  };
}
function sV(e, t, n) {
  const i = e.length;
  let r, o, a, l, u, d = Ta(e, 0);
  for (let f = 0; f < i - 1; ++f)
    if (u = d, d = Ta(e, f + 1), !(!u || !d)) {
      if (Cs(t[f], 0, oV)) {
        n[f] = n[f + 1] = 0;
        continue;
      }
      r = n[f] / t[f], o = n[f + 1] / t[f], l = Math.pow(r, 2) + Math.pow(o, 2), !(l <= 9) && (a = 3 / Math.sqrt(l), n[f] = r * a * t[f], n[f + 1] = o * a * t[f]);
    }
}
function lV(e, t, n = "x") {
  const i = Dw(n), r = e.length;
  let o, a, l, u = Ta(e, 0);
  for (let d = 0; d < r; ++d) {
    if (a = l, l = u, u = Ta(e, d + 1), !l)
      continue;
    const f = l[n], m = l[i];
    a && (o = (f - a[n]) / 3, l[`cp1${n}`] = f - o, l[`cp1${i}`] = m - o * t[d]), u && (o = (u[n] - f) / 3, l[`cp2${n}`] = f + o, l[`cp2${i}`] = m + o * t[d]);
  }
}
function uV(e, t = "x") {
  const n = Dw(t), i = e.length, r = Array(i).fill(0), o = Array(i);
  let a, l, u, d = Ta(e, 0);
  for (a = 0; a < i; ++a)
    if (l = u, u = d, d = Ta(e, a + 1), !!u) {
      if (d) {
        const f = d[t] - u[t];
        r[a] = f !== 0 ? (d[n] - u[n]) / f : 0;
      }
      o[a] = l ? d ? Ca(r[a - 1]) !== Ca(r[a]) ? 0 : (r[a - 1] + r[a]) / 2 : r[a - 1] : r[a];
    }
  sV(e, r, o), lV(e, o, t);
}
function bu(e, t, n) {
  return Math.max(Math.min(e, n), t);
}
function cV(e, t) {
  let n, i, r, o, a, l = ar(e[0], t);
  for (n = 0, i = e.length; n < i; ++n)
    a = o, o = l, l = n < i - 1 && ar(e[n + 1], t), o && (r = e[n], a && (r.cp1x = bu(r.cp1x, t.left, t.right), r.cp1y = bu(r.cp1y, t.top, t.bottom)), l && (r.cp2x = bu(r.cp2x, t.left, t.right), r.cp2y = bu(r.cp2y, t.top, t.bottom)));
}
function dV(e, t, n, i, r) {
  let o, a, l, u;
  if (t.spanGaps && (e = e.filter((d) => !d.skip)), t.cubicInterpolationMode === "monotone")
    uV(e, r);
  else {
    let d = i ? e[e.length - 1] : e[0];
    for (o = 0, a = e.length; o < a; ++o)
      l = e[o], u = aV(d, l, e[Math.min(o + 1, a - (i ? 0 : 1)) % a], t.tension), l.cp1x = u.previous.x, l.cp1y = u.previous.y, l.cp2x = u.next.x, l.cp2y = u.next.y, d = l;
  }
  t.capBezierPoints && cV(e, n);
}
function Pg() {
  return typeof window < "u" && typeof document < "u";
}
function Ag(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function fc(e, t, n) {
  let i;
  return typeof e == "string" ? (i = parseInt(e, 10), e.indexOf("%") !== -1 && (i = i / 100 * t.parentNode[n])) : i = e, i;
}
const Wc = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function fV(e, t) {
  return Wc(e).getPropertyValue(t);
}
const hV = [
  "top",
  "right",
  "bottom",
  "left"
];
function Io(e, t, n) {
  const i = {};
  n = n ? "-" + n : "";
  for (let r = 0; r < 4; r++) {
    const o = hV[r];
    i[o] = parseFloat(e[t + "-" + o + n]) || 0;
  }
  return i.width = i.left + i.right, i.height = i.top + i.bottom, i;
}
const gV = (e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot);
function mV(e, t) {
  const n = e.touches, i = n && n.length ? n[0] : e, { offsetX: r, offsetY: o } = i;
  let a = !1, l, u;
  if (gV(r, o, e.target))
    l = r, u = o;
  else {
    const d = t.getBoundingClientRect();
    l = i.clientX - d.left, u = i.clientY - d.top, a = !0;
  }
  return {
    x: l,
    y: u,
    box: a
  };
}
function Co(e, t) {
  if ("native" in e)
    return e;
  const { canvas: n, currentDevicePixelRatio: i } = t, r = Wc(n), o = r.boxSizing === "border-box", a = Io(r, "padding"), l = Io(r, "border", "width"), { x: u, y: d, box: f } = mV(e, n), m = a.left + (f && l.left), h = a.top + (f && l.top);
  let { width: v, height: y } = t;
  return o && (v -= a.width + l.width, y -= a.height + l.height), {
    x: Math.round((u - m) / v * n.width / i),
    y: Math.round((d - h) / y * n.height / i)
  };
}
function vV(e, t, n) {
  let i, r;
  if (t === void 0 || n === void 0) {
    const o = e && Ag(e);
    if (!o)
      t = e.clientWidth, n = e.clientHeight;
    else {
      const a = o.getBoundingClientRect(), l = Wc(o), u = Io(l, "border", "width"), d = Io(l, "padding");
      t = a.width - d.width - u.width, n = a.height - d.height - u.height, i = fc(l.maxWidth, o, "clientWidth"), r = fc(l.maxHeight, o, "clientHeight");
    }
  }
  return {
    width: t,
    height: n,
    maxWidth: i || uc,
    maxHeight: r || uc
  };
}
const wu = (e) => Math.round(e * 10) / 10;
function pV(e, t, n, i) {
  const r = Wc(e), o = Io(r, "margin"), a = fc(r.maxWidth, e, "clientWidth") || uc, l = fc(r.maxHeight, e, "clientHeight") || uc, u = vV(e, t, n);
  let { width: d, height: f } = u;
  if (r.boxSizing === "content-box") {
    const h = Io(r, "border", "width"), v = Io(r, "padding");
    d -= v.width + h.width, f -= v.height + h.height;
  }
  return d = Math.max(0, d - o.width), f = Math.max(0, i ? d / i : f - o.height), d = wu(Math.min(d, a, u.maxWidth)), f = wu(Math.min(f, l, u.maxHeight)), d && !f && (f = wu(d / 2)), (t !== void 0 || n !== void 0) && i && u.height && f > u.height && (f = u.height, d = wu(Math.floor(f * i))), {
    width: d,
    height: f
  };
}
function Xy(e, t, n) {
  const i = t || 1, r = Math.floor(e.height * i), o = Math.floor(e.width * i);
  e.height = Math.floor(e.height), e.width = Math.floor(e.width);
  const a = e.canvas;
  return a.style && (n || !a.style.height && !a.style.width) && (a.style.height = `${e.height}px`, a.style.width = `${e.width}px`), e.currentDevicePixelRatio !== i || a.height !== r || a.width !== o ? (e.currentDevicePixelRatio = i, a.height = r, a.width = o, e.ctx.setTransform(i, 0, 0, i, 0, 0), !0) : !1;
}
const yV = function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    Pg() && (window.addEventListener("test", null, t), window.removeEventListener("test", null, t));
  } catch {
  }
  return e;
}();
function Ky(e, t) {
  const n = fV(e, t), i = n && n.match(/^(\d+)(\.\d+)?px$/);
  return i ? +i[1] : void 0;
}
function Oo(e, t, n, i) {
  return {
    x: e.x + n * (t.x - e.x),
    y: e.y + n * (t.y - e.y)
  };
}
function bV(e, t, n, i) {
  return {
    x: e.x + n * (t.x - e.x),
    y: i === "middle" ? n < 0.5 ? e.y : t.y : i === "after" ? n < 1 ? e.y : t.y : n > 0 ? t.y : e.y
  };
}
function wV(e, t, n, i) {
  const r = {
    x: e.cp2x,
    y: e.cp2y
  }, o = {
    x: t.cp1x,
    y: t.cp1y
  }, a = Oo(e, r, n), l = Oo(r, o, n), u = Oo(o, t, n), d = Oo(a, l, n), f = Oo(l, u, n);
  return Oo(d, f, n);
}
const _V = function(e, t) {
  return {
    x(n) {
      return e + e + t - n;
    },
    setWidth(n) {
      t = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, i) {
      return n - i;
    },
    leftForLtr(n, i) {
      return n - i;
    }
  };
}, xV = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
};
function ba(e, t, n) {
  return e ? _V(t, n) : xV();
}
function Lw(e, t) {
  let n, i;
  (t === "ltr" || t === "rtl") && (n = e.canvas.style, i = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", t, "important"), e.prevTextDirection = i);
}
function Bw(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function Vw(e) {
  return e === "angle" ? {
    between: js,
    compare: bB,
    normalize: Hn
  } : {
    between: To,
    compare: (t, n) => t - n,
    normalize: (t) => t
  };
}
function Zy({ start: e, end: t, count: n, loop: i, style: r }) {
  return {
    start: e % n,
    end: t % n,
    loop: i && (t - e + 1) % n === 0,
    style: r
  };
}
function kV(e, t, n) {
  const { property: i, start: r, end: o } = n, { between: a, normalize: l } = Vw(i), u = t.length;
  let { start: d, end: f, loop: m } = e, h, v;
  if (m) {
    for (d += u, f += u, h = 0, v = u; h < v && a(l(t[d % u][i]), r, o); ++h)
      d--, f--;
    d %= u, f %= u;
  }
  return f < d && (f += u), {
    start: d,
    end: f,
    loop: m,
    style: e.style
  };
}
function $w(e, t, n) {
  if (!n)
    return [
      e
    ];
  const { property: i, start: r, end: o } = n, a = t.length, { compare: l, between: u, normalize: d } = Vw(i), { start: f, end: m, loop: h, style: v } = kV(e, t, n), y = [];
  let p = !1, b = null, x, _, O;
  const D = () => u(r, O, x) && l(r, O) !== 0, F = () => l(o, x) === 0 || u(o, O, x), $ = () => p || D(), A = () => !p || F();
  for (let k = f, S = f; k <= m; ++k)
    _ = t[k % a], !_.skip && (x = d(_[i]), x !== O && (p = u(x, r, o), b === null && $() && (b = l(x, r) === 0 ? k : S), b !== null && A() && (y.push(Zy({
      start: b,
      end: k,
      loop: h,
      count: a,
      style: v
    })), b = null), S = k, O = x));
  return b !== null && y.push(Zy({
    start: b,
    end: m,
    loop: h,
    count: a,
    style: v
  })), y;
}
function Rw(e, t) {
  const n = [], i = e.segments;
  for (let r = 0; r < i.length; r++) {
    const o = $w(i[r], e.points, t);
    o.length && n.push(...o);
  }
  return n;
}
function SV(e, t, n, i) {
  let r = 0, o = t - 1;
  if (n && !i)
    for (; r < t && !e[r].skip; )
      r++;
  for (; r < t && e[r].skip; )
    r++;
  for (r %= t, n && (o += r); o > r && e[o % t].skip; )
    o--;
  return o %= t, {
    start: r,
    end: o
  };
}
function CV(e, t, n, i) {
  const r = e.length, o = [];
  let a = t, l = e[t], u;
  for (u = t + 1; u <= n; ++u) {
    const d = e[u % r];
    d.skip || d.stop ? l.skip || (i = !1, o.push({
      start: t % r,
      end: (u - 1) % r,
      loop: i
    }), t = a = d.stop ? u : null) : (a = u, l.skip && (t = u)), l = d;
  }
  return a !== null && o.push({
    start: t % r,
    end: a % r,
    loop: i
  }), o;
}
function OV(e, t) {
  const n = e.points, i = e.options.spanGaps, r = n.length;
  if (!r)
    return [];
  const o = !!e._loop, { start: a, end: l } = SV(n, r, o, i);
  if (i === !0)
    return Qy(e, [
      {
        start: a,
        end: l,
        loop: o
      }
    ], n, t);
  const u = l < a ? l + r : l, d = !!e._fullLoop && a === 0 && l === r - 1;
  return Qy(e, CV(n, a, u, d), n, t);
}
function Qy(e, t, n, i) {
  return !i || !i.setContext || !n ? t : MV(e, t, n, i);
}
function MV(e, t, n, i) {
  const r = e._chart.getContext(), o = Jy(e.options), { _datasetIndex: a, options: { spanGaps: l } } = e, u = n.length, d = [];
  let f = o, m = t[0].start, h = m;
  function v(y, p, b, x) {
    const _ = l ? -1 : 1;
    if (y !== p) {
      for (y += u; n[y % u].skip; )
        y -= _;
      for (; n[p % u].skip; )
        p += _;
      y % u !== p % u && (d.push({
        start: y % u,
        end: p % u,
        loop: b,
        style: x
      }), f = x, m = p % u);
    }
  }
  for (const y of t) {
    m = l ? m : y.start;
    let p = n[m % u], b;
    for (h = m + 1; h <= y.end; h++) {
      const x = n[h % u];
      b = Jy(i.setContext(Jr(r, {
        type: "segment",
        p0: p,
        p1: x,
        p0DataIndex: (h - 1) % u,
        p1DataIndex: h % u,
        datasetIndex: a
      }))), TV(b, f) && v(m, h - 1, y.loop, f), p = x, f = b;
    }
    m < h - 1 && v(m, h - 1, y.loop, f);
  }
  return d;
}
function Jy(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
function TV(e, t) {
  if (!t)
    return !1;
  const n = [], i = function(r, o) {
    return Sg(o) ? (n.includes(o) || n.push(o), n.indexOf(o)) : o;
  };
  return JSON.stringify(e, i) !== JSON.stringify(t, i);
}
/*!
 * Chart.js v4.4.3
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */
class PV {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, n, i, r) {
    const o = n.listeners[r], a = n.duration;
    o.forEach((l) => l({
      chart: t,
      initial: n.initial,
      numSteps: a,
      currentStep: Math.min(i - n.start, a)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = Sw.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let n = 0;
    this._charts.forEach((i, r) => {
      if (!i.running || !i.items.length)
        return;
      const o = i.items;
      let a = o.length - 1, l = !1, u;
      for (; a >= 0; --a)
        u = o[a], u._active ? (u._total > i.duration && (i.duration = u._total), u.tick(t), l = !0) : (o[a] = o[o.length - 1], o.pop());
      l && (r.draw(), this._notify(r, i, t, "progress")), o.length || (i.running = !1, this._notify(r, i, t, "complete"), i.initial = !1), n += o.length;
    }), this._lastDate = t, n === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const n = this._charts;
    let i = n.get(t);
    return i || (i = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(t, i)), i;
  }
  listen(t, n, i) {
    this._getAnims(t).listeners[n].push(i);
  }
  add(t, n) {
    !n || !n.length || this._getAnims(t).items.push(...n);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const n = this._charts.get(t);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((i, r) => Math.max(i, r._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const n = this._charts.get(t);
    return !(!n || !n.running || !n.items.length);
  }
  stop(t) {
    const n = this._charts.get(t);
    if (!n || !n.items.length)
      return;
    const i = n.items;
    let r = i.length - 1;
    for (; r >= 0; --r)
      i[r].cancel();
    n.items = [], this._notify(t, n, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var nr = /* @__PURE__ */ new PV();
const e0 = "transparent", AV = {
  boolean(e, t, n) {
    return n > 0.5 ? t : e;
  },
  color(e, t, n) {
    const i = jy(e || e0), r = i.valid && jy(t || e0);
    return r && r.valid ? r.mix(i, n).hexString() : t;
  },
  number(e, t, n) {
    return e + (t - e) * n;
  }
};
class EV {
  constructor(t, n, i, r) {
    const o = n[i];
    r = yu([
      t.to,
      r,
      o,
      t.from
    ]);
    const a = yu([
      t.from,
      o,
      r
    ]);
    this._active = !0, this._fn = t.fn || AV[t.type || typeof a], this._easing = Os[t.easing] || Os.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = n, this._prop = i, this._from = a, this._to = r, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, n, i) {
    if (this._active) {
      this._notify(!1);
      const r = this._target[this._prop], o = i - this._start, a = this._duration - o;
      this._start = i, this._duration = Math.floor(Math.max(a, t.duration)), this._total += o, this._loop = !!t.loop, this._to = yu([
        t.to,
        n,
        r,
        t.from
      ]), this._from = yu([
        t.from,
        r,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const n = t - this._start, i = this._duration, r = this._prop, o = this._from, a = this._loop, l = this._to;
    let u;
    if (this._active = o !== l && (a || n < i), !this._active) {
      this._target[r] = l, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[r] = o;
      return;
    }
    u = n / i % 2, u = a && u > 1 ? 2 - u : u, u = this._easing(Math.min(1, Math.max(0, u))), this._target[r] = this._fn(o, l, u);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((n, i) => {
      t.push({
        res: n,
        rej: i
      });
    });
  }
  _notify(t) {
    const n = t ? "res" : "rej", i = this._promises || [];
    for (let r = 0; r < i.length; r++)
      i[r][n]();
  }
}
class Fw {
  constructor(t, n) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(t) {
    if (!it(t))
      return;
    const n = Object.keys(It.animation), i = this._properties;
    Object.getOwnPropertyNames(t).forEach((r) => {
      const o = t[r];
      if (!it(o))
        return;
      const a = {};
      for (const l of n)
        a[l] = o[l];
      (Ct(o.properties) && o.properties || [
        r
      ]).forEach((l) => {
        (l === r || !i.has(l)) && i.set(l, a);
      });
    });
  }
  _animateOptions(t, n) {
    const i = n.options, r = DV(t, i);
    if (!r)
      return [];
    const o = this._createAnimations(r, i);
    return i.$shared && IV(t.options.$animations, i).then(() => {
      t.options = i;
    }, () => {
    }), o;
  }
  _createAnimations(t, n) {
    const i = this._properties, r = [], o = t.$animations || (t.$animations = {}), a = Object.keys(n), l = Date.now();
    let u;
    for (u = a.length - 1; u >= 0; --u) {
      const d = a[u];
      if (d.charAt(0) === "$")
        continue;
      if (d === "options") {
        r.push(...this._animateOptions(t, n));
        continue;
      }
      const f = n[d];
      let m = o[d];
      const h = i.get(d);
      if (m)
        if (h && m.active()) {
          m.update(h, f, l);
          continue;
        } else
          m.cancel();
      if (!h || !h.duration) {
        t[d] = f;
        continue;
      }
      o[d] = m = new EV(h, t, d, f), r.push(m);
    }
    return r;
  }
  update(t, n) {
    if (this._properties.size === 0) {
      Object.assign(t, n);
      return;
    }
    const i = this._createAnimations(t, n);
    if (i.length)
      return nr.add(this._chart, i), !0;
  }
}
function IV(e, t) {
  const n = [], i = Object.keys(t);
  for (let r = 0; r < i.length; r++) {
    const o = e[i[r]];
    o && o.active() && n.push(o.wait());
  }
  return Promise.all(n);
}
function DV(e, t) {
  if (!t)
    return;
  let n = e.options;
  if (!n) {
    e.options = t;
    return;
  }
  return n.$shared && (e.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function t0(e, t) {
  const n = e && e.options || {}, i = n.reverse, r = n.min === void 0 ? t : 0, o = n.max === void 0 ? t : 0;
  return {
    start: i ? o : r,
    end: i ? r : o
  };
}
function LV(e, t, n) {
  if (n === !1)
    return !1;
  const i = t0(e, n), r = t0(t, n);
  return {
    top: r.end,
    right: i.end,
    bottom: r.start,
    left: i.start
  };
}
function BV(e) {
  let t, n, i, r;
  return it(e) ? (t = e.top, n = e.right, i = e.bottom, r = e.left) : t = n = i = r = e, {
    top: t,
    right: n,
    bottom: i,
    left: r,
    disabled: e === !1
  };
}
function Nw(e, t) {
  const n = [], i = e._getSortedDatasetMetas(t);
  let r, o;
  for (r = 0, o = i.length; r < o; ++r)
    n.push(i[r].index);
  return n;
}
function n0(e, t, n, i = {}) {
  const r = e.keys, o = i.mode === "single";
  let a, l, u, d;
  if (t !== null) {
    for (a = 0, l = r.length; a < l; ++a) {
      if (u = +r[a], u === n) {
        if (i.all)
          continue;
        break;
      }
      d = e.values[u], Et(d) && (o || t === 0 || Ca(t) === Ca(d)) && (t += d);
    }
    return t;
  }
}
function VV(e, t) {
  const { iScale: n, vScale: i } = t, r = n.axis === "x" ? "x" : "y", o = i.axis === "x" ? "x" : "y", a = Object.keys(e), l = new Array(a.length);
  let u, d, f;
  for (u = 0, d = a.length; u < d; ++u)
    f = a[u], l[u] = {
      [r]: f,
      [o]: e[f]
    };
  return l;
}
function i0(e, t) {
  const n = e && e.options.stacked;
  return n || n === void 0 && t.stack !== void 0;
}
function $V(e, t, n) {
  return `${e.id}.${t.id}.${n.stack || n.type}`;
}
function RV(e) {
  const { min: t, max: n, minDefined: i, maxDefined: r } = e.getUserBounds();
  return {
    min: i ? t : Number.NEGATIVE_INFINITY,
    max: r ? n : Number.POSITIVE_INFINITY
  };
}
function FV(e, t, n) {
  const i = e[t] || (e[t] = {});
  return i[n] || (i[n] = {});
}
function r0(e, t, n, i) {
  for (const r of t.getMatchingVisibleMetas(i).reverse()) {
    const o = e[r.index];
    if (n && o > 0 || !n && o < 0)
      return r.index;
  }
  return null;
}
function o0(e, t) {
  const { chart: n, _cachedMeta: i } = e, r = n._stacks || (n._stacks = {}), { iScale: o, vScale: a, index: l } = i, u = o.axis, d = a.axis, f = $V(o, a, i), m = t.length;
  let h;
  for (let v = 0; v < m; ++v) {
    const y = t[v], { [u]: p, [d]: b } = y, x = y._stacks || (y._stacks = {});
    h = x[d] = FV(r, f, p), h[l] = b, h._top = r0(h, a, !0, i.type), h._bottom = r0(h, a, !1, i.type);
    const _ = h._visualValues || (h._visualValues = {});
    _[l] = b;
  }
}
function Nf(e, t) {
  const n = e.scales;
  return Object.keys(n).filter((i) => n[i].axis === t).shift();
}
function NV(e, t) {
  return Jr(e, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function WV(e, t, n) {
  return Jr(e, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: t,
    mode: "default",
    type: "data"
  });
}
function cs(e, t) {
  const n = e.controller.index, i = e.vScale && e.vScale.axis;
  if (i) {
    t = t || e._parsed;
    for (const r of t) {
      const o = r._stacks;
      if (!o || o[i] === void 0 || o[i][n] === void 0)
        return;
      delete o[i][n], o[i]._visualValues !== void 0 && o[i]._visualValues[n] !== void 0 && delete o[i]._visualValues[n];
    }
  }
}
const Wf = (e) => e === "reset" || e === "none", a0 = (e, t) => t ? e : Object.assign({}, e), zV = (e, t, n) => e && !t.hidden && t._stacked && {
  keys: Nw(n, !0),
  values: null
};
class wa {
  constructor(t, n) {
    this.chart = t, this._ctx = t.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = i0(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && cs(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, n = this._cachedMeta, i = this.getDataset(), r = (m, h, v, y) => m === "x" ? h : m === "r" ? y : v, o = n.xAxisID = et(i.xAxisID, Nf(t, "x")), a = n.yAxisID = et(i.yAxisID, Nf(t, "y")), l = n.rAxisID = et(i.rAxisID, Nf(t, "r")), u = n.indexAxis, d = n.iAxisID = r(u, o, a, l), f = n.vAxisID = r(u, a, o, l);
    n.xScale = this.getScaleForId(o), n.yScale = this.getScaleForId(a), n.rScale = this.getScaleForId(l), n.iScale = this.getScaleForId(d), n.vScale = this.getScaleForId(f);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const n = this._cachedMeta;
    return t === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && Wy(this._data, this), t._stacked && cs(t);
  }
  _dataCheck() {
    const t = this.getDataset(), n = t.data || (t.data = []), i = this._data;
    if (it(n)) {
      const r = this._cachedMeta;
      this._data = VV(n, r);
    } else if (i !== n) {
      if (i) {
        Wy(i, this);
        const r = this._cachedMeta;
        cs(r), r._parsed = [];
      }
      n && Object.isExtensible(n) && kB(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const n = this._cachedMeta, i = this.getDataset();
    let r = !1;
    this._dataCheck();
    const o = n._stacked;
    n._stacked = i0(n.vScale, n), n.stack !== i.stack && (r = !0, cs(n), n.stack = i.stack), this._resyncElements(t), (r || o !== n._stacked) && o0(this, n._parsed);
  }
  configure() {
    const t = this.chart.config, n = t.datasetScopeKeys(this._type), i = t.getOptionScopes(this.getDataset(), n, !0);
    this.options = t.createResolver(i, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, n) {
    const { _cachedMeta: i, _data: r } = this, { iScale: o, _stacked: a } = i, l = o.axis;
    let u = t === 0 && n === r.length ? !0 : i._sorted, d = t > 0 && i._parsed[t - 1], f, m, h;
    if (this._parsing === !1)
      i._parsed = r, i._sorted = !0, h = r;
    else {
      Ct(r[t]) ? h = this.parseArrayData(i, r, t, n) : it(r[t]) ? h = this.parseObjectData(i, r, t, n) : h = this.parsePrimitiveData(i, r, t, n);
      const v = () => m[l] === null || d && m[l] < d[l];
      for (f = 0; f < n; ++f)
        i._parsed[f + t] = m = h[f], u && (v() && (u = !1), d = m);
      i._sorted = u;
    }
    a && o0(this, h);
  }
  parsePrimitiveData(t, n, i, r) {
    const { iScale: o, vScale: a } = t, l = o.axis, u = a.axis, d = o.getLabels(), f = o === a, m = new Array(r);
    let h, v, y;
    for (h = 0, v = r; h < v; ++h)
      y = h + i, m[h] = {
        [l]: f || o.parse(d[y], y),
        [u]: a.parse(n[y], y)
      };
    return m;
  }
  parseArrayData(t, n, i, r) {
    const { xScale: o, yScale: a } = t, l = new Array(r);
    let u, d, f, m;
    for (u = 0, d = r; u < d; ++u)
      f = u + i, m = n[f], l[u] = {
        x: o.parse(m[0], f),
        y: a.parse(m[1], f)
      };
    return l;
  }
  parseObjectData(t, n, i, r) {
    const { xScale: o, yScale: a } = t, { xAxisKey: l = "x", yAxisKey: u = "y" } = this._parsing, d = new Array(r);
    let f, m, h, v;
    for (f = 0, m = r; f < m; ++f)
      h = f + i, v = n[h], d[f] = {
        x: o.parse(zs(v, l), h),
        y: a.parse(zs(v, u), h)
      };
    return d;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, n, i) {
    const r = this.chart, o = this._cachedMeta, a = n[t.axis], l = {
      keys: Nw(r, !0),
      values: n._stacks[t.axis]._visualValues
    };
    return n0(l, a, o.index, {
      mode: i
    });
  }
  updateRangeFromParsed(t, n, i, r) {
    const o = i[n.axis];
    let a = o === null ? NaN : o;
    const l = r && i._stacks[n.axis];
    r && l && (r.values = l, a = n0(r, o, this._cachedMeta.index)), t.min = Math.min(t.min, a), t.max = Math.max(t.max, a);
  }
  getMinMax(t, n) {
    const i = this._cachedMeta, r = i._parsed, o = i._sorted && t === i.iScale, a = r.length, l = this._getOtherScale(t), u = zV(n, i, this.chart), d = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: f, max: m } = RV(l);
    let h, v;
    function y() {
      v = r[h];
      const p = v[l.axis];
      return !Et(v[t.axis]) || f > p || m < p;
    }
    for (h = 0; h < a && !(!y() && (this.updateRangeFromParsed(d, t, v, u), o)); ++h)
      ;
    if (o) {
      for (h = a - 1; h >= 0; --h)
        if (!y()) {
          this.updateRangeFromParsed(d, t, v, u);
          break;
        }
    }
    return d;
  }
  getAllParsedValues(t) {
    const n = this._cachedMeta._parsed, i = [];
    let r, o, a;
    for (r = 0, o = n.length; r < o; ++r)
      a = n[r][t.axis], Et(a) && i.push(a);
    return i;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, i = n.iScale, r = n.vScale, o = this.getParsed(t);
    return {
      label: i ? "" + i.getLabelForValue(o[i.axis]) : "",
      value: r ? "" + r.getLabelForValue(o[r.axis]) : ""
    };
  }
  _update(t) {
    const n = this._cachedMeta;
    this.update(t || "default"), n._clip = BV(et(this.options.clip, LV(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, n = this.chart, i = this._cachedMeta, r = i.data || [], o = n.chartArea, a = [], l = this._drawStart || 0, u = this._drawCount || r.length - l, d = this.options.drawActiveElementsOnTop;
    let f;
    for (i.dataset && i.dataset.draw(t, o, l, u), f = l; f < l + u; ++f) {
      const m = r[f];
      m.hidden || (m.active && d ? a.push(m) : m.draw(t, o));
    }
    for (f = 0; f < a.length; ++f)
      a[f].draw(t, o);
  }
  getStyle(t, n) {
    const i = n ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(i) : this.resolveDataElementOptions(t || 0, i);
  }
  getContext(t, n, i) {
    const r = this.getDataset();
    let o;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const a = this._cachedMeta.data[t];
      o = a.$context || (a.$context = WV(this.getContext(), t, a)), o.parsed = this.getParsed(t), o.raw = r.data[t], o.index = o.dataIndex = t;
    } else
      o = this.$context || (this.$context = NV(this.chart.getContext(), this.index)), o.dataset = r, o.index = o.datasetIndex = this.index;
    return o.active = !!n, o.mode = i, o;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, t);
  }
  _resolveElementOptions(t, n = "default", i) {
    const r = n === "active", o = this._cachedDataOpts, a = t + "-" + n, l = o[a], u = this.enableOptionSharing && lc(i);
    if (l)
      return a0(l, u);
    const d = this.chart.config, f = d.datasetElementScopeKeys(this._type, t), m = r ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], h = d.getOptionScopes(this.getDataset(), f), v = Object.keys(It.elements[t]), y = () => this.getContext(i, r, n), p = d.resolveNamedOptions(h, v, y, m);
    return p.$shared && (p.$shared = u, o[a] = Object.freeze(a0(p, u))), p;
  }
  _resolveAnimations(t, n, i) {
    const r = this.chart, o = this._cachedDataOpts, a = `animation-${n}`, l = o[a];
    if (l)
      return l;
    let u;
    if (r.options.animation !== !1) {
      const f = this.chart.config, m = f.datasetAnimationScopeKeys(this._type, n), h = f.getOptionScopes(this.getDataset(), m);
      u = f.createResolver(h, this.getContext(t, i, n));
    }
    const d = new Fw(r, u && u.animations);
    return u && u._cacheable && (o[a] = Object.freeze(d)), d;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, n) {
    return !n || Wf(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, n) {
    const i = this.resolveDataElementOptions(t, n), r = this._sharedOptions, o = this.getSharedOptions(i), a = this.includeOptions(n, o) || o !== r;
    return this.updateSharedOptions(o, n, i), {
      sharedOptions: o,
      includeOptions: a
    };
  }
  updateElement(t, n, i, r) {
    Wf(r) ? Object.assign(t, i) : this._resolveAnimations(n, r).update(t, i);
  }
  updateSharedOptions(t, n, i) {
    t && !Wf(n) && this._resolveAnimations(void 0, n).update(t, i);
  }
  _setStyle(t, n, i, r) {
    t.active = r;
    const o = this.getStyle(n, r);
    this._resolveAnimations(n, i, r).update(t, {
      options: !r && this.getSharedOptions(o) || o
    });
  }
  removeHoverStyle(t, n, i) {
    this._setStyle(t, i, "active", !1);
  }
  setHoverStyle(t, n, i) {
    this._setStyle(t, i, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const n = this._data, i = this._cachedMeta.data;
    for (const [l, u, d] of this._syncList)
      this[l](u, d);
    this._syncList = [];
    const r = i.length, o = n.length, a = Math.min(o, r);
    a && this.parse(0, a), o > r ? this._insertElements(r, o - r, t) : o < r && this._removeElements(o, r - o);
  }
  _insertElements(t, n, i = !0) {
    const r = this._cachedMeta, o = r.data, a = t + n;
    let l;
    const u = (d) => {
      for (d.length += n, l = d.length - 1; l >= a; l--)
        d[l] = d[l - n];
    };
    for (u(o), l = t; l < a; ++l)
      o[l] = new this.dataElementType();
    this._parsing && u(r._parsed), this.parse(t, n), i && this.updateElements(o, t, n, "reset");
  }
  updateElements(t, n, i, r) {
  }
  _removeElements(t, n) {
    const i = this._cachedMeta;
    if (this._parsing) {
      const r = i._parsed.splice(t, n);
      i._stacked && cs(i, r);
    }
    i.data.splice(t, n);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [n, i, r] = t;
      this[n](i, r);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, n) {
    n && this._sync([
      "_removeElements",
      t,
      n
    ]);
    const i = arguments.length - 2;
    i && this._sync([
      "_insertElements",
      t,
      i
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
ne(wa, "defaults", {}), ne(wa, "datasetElementType", null), ne(wa, "dataElementType", null);
function HV(e, t, n) {
  let i = 1, r = 1, o = 0, a = 0;
  if (t < xt) {
    const l = e, u = l + t, d = Math.cos(l), f = Math.sin(l), m = Math.cos(u), h = Math.sin(u), v = (O, D, F) => js(O, l, u, !0) ? 1 : Math.max(D, D * n, F, F * n), y = (O, D, F) => js(O, l, u, !0) ? -1 : Math.min(D, D * n, F, F * n), p = v(0, d, m), b = v($t, f, h), x = y(Dt, d, m), _ = y(Dt + $t, f, h);
    i = (p - x) / 2, r = (b - _) / 2, o = -(p + x) / 2, a = -(b + _) / 2;
  }
  return {
    ratioX: i,
    ratioY: r,
    offsetX: o,
    offsetY: a
  };
}
class ws extends wa {
  constructor(t, n) {
    super(t, n), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, n) {
    const i = this.getDataset().data, r = this._cachedMeta;
    if (this._parsing === !1)
      r._parsed = i;
    else {
      let o = (u) => +i[u];
      if (it(i[t])) {
        const { key: u = "value" } = this._parsing;
        o = (d) => +zs(i[d], u);
      }
      let a, l;
      for (a = t, l = t + n; a < l; ++a)
        r._parsed[a] = o(a);
    }
  }
  _getRotation() {
    return $i(this.options.rotation - 90);
  }
  _getCircumference() {
    return $i(this.options.circumference);
  }
  _getRotationExtents() {
    let t = xt, n = -xt;
    for (let i = 0; i < this.chart.data.datasets.length; ++i)
      if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
        const r = this.chart.getDatasetMeta(i).controller, o = r._getRotation(), a = r._getCircumference();
        t = Math.min(t, o), n = Math.max(n, o + a);
      }
    return {
      rotation: t,
      circumference: n - t
    };
  }
  update(t) {
    const n = this.chart, { chartArea: i } = n, r = this._cachedMeta, o = r.data, a = this.getMaxBorderWidth() + this.getMaxOffset(o) + this.options.spacing, l = Math.max((Math.min(i.width, i.height) - a) / 2, 0), u = Math.min(uB(this.options.cutout, l), 1), d = this._getRingWeight(this.index), { circumference: f, rotation: m } = this._getRotationExtents(), { ratioX: h, ratioY: v, offsetX: y, offsetY: p } = HV(m, f, u), b = (i.width - a) / h, x = (i.height - a) / v, _ = Math.max(Math.min(b, x) / 2, 0), O = bw(this.options.radius, _), D = Math.max(O * u, 0), F = (O - D) / this._getVisibleDatasetWeightTotal();
    this.offsetX = y * O, this.offsetY = p * O, r.total = this.calculateTotal(), this.outerRadius = O - F * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - F * d, 0), this.updateElements(o, 0, o.length, t);
  }
  _circumference(t, n) {
    const i = this.options, r = this._cachedMeta, o = this._getCircumference();
    return n && i.animation.animateRotate || !this.chart.getDataVisibility(t) || r._parsed[t] === null || r.data[t].hidden ? 0 : this.calculateCircumference(r._parsed[t] * o / xt);
  }
  updateElements(t, n, i, r) {
    const o = r === "reset", a = this.chart, l = a.chartArea, d = a.options.animation, f = (l.left + l.right) / 2, m = (l.top + l.bottom) / 2, h = o && d.animateScale, v = h ? 0 : this.innerRadius, y = h ? 0 : this.outerRadius, { sharedOptions: p, includeOptions: b } = this._getSharedOptions(n, r);
    let x = this._getRotation(), _;
    for (_ = 0; _ < n; ++_)
      x += this._circumference(_, o);
    for (_ = n; _ < n + i; ++_) {
      const O = this._circumference(_, o), D = t[_], F = {
        x: f + this.offsetX,
        y: m + this.offsetY,
        startAngle: x,
        endAngle: x + O,
        circumference: O,
        outerRadius: y,
        innerRadius: v
      };
      b && (F.options = p || this.resolveDataElementOptions(_, D.active ? "active" : r)), x += O, this.updateElement(D, _, F, r);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, n = t.data;
    let i = 0, r;
    for (r = 0; r < n.length; r++) {
      const o = t._parsed[r];
      o !== null && !isNaN(o) && this.chart.getDataVisibility(r) && !n[r].hidden && (i += Math.abs(o));
    }
    return i;
  }
  calculateCircumference(t) {
    const n = this._cachedMeta.total;
    return n > 0 && !isNaN(t) ? xt * (Math.abs(t) / n) : 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, i = this.chart, r = i.data.labels || [], o = $c(n._parsed[t], i.options.locale);
    return {
      label: r[t] || "",
      value: o
    };
  }
  getMaxBorderWidth(t) {
    let n = 0;
    const i = this.chart;
    let r, o, a, l, u;
    if (!t) {
      for (r = 0, o = i.data.datasets.length; r < o; ++r)
        if (i.isDatasetVisible(r)) {
          a = i.getDatasetMeta(r), t = a.data, l = a.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (r = 0, o = t.length; r < o; ++r)
      u = l.resolveDataElementOptions(r), u.borderAlign !== "inner" && (n = Math.max(n, u.borderWidth || 0, u.hoverBorderWidth || 0));
    return n;
  }
  getMaxOffset(t) {
    let n = 0;
    for (let i = 0, r = t.length; i < r; ++i) {
      const o = this.resolveDataElementOptions(i);
      n = Math.max(n, o.offset || 0, o.hoverOffset || 0);
    }
    return n;
  }
  _getRingWeightOffset(t) {
    let n = 0;
    for (let i = 0; i < t; ++i)
      this.chart.isDatasetVisible(i) && (n += this._getRingWeight(i));
    return n;
  }
  _getRingWeight(t) {
    return Math.max(et(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
ne(ws, "id", "doughnut"), ne(ws, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), ne(ws, "descriptors", {
  _scriptable: (t) => t !== "spacing",
  _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
}), ne(ws, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const n = t.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: i, color: r } } = t.legend.options;
            return n.labels.map((o, a) => {
              const u = t.getDatasetMeta(0).controller.getStyle(a);
              return {
                text: o,
                fillStyle: u.backgroundColor,
                strokeStyle: u.borderColor,
                fontColor: r,
                lineWidth: u.borderWidth,
                pointStyle: i,
                hidden: !t.getDataVisibility(a),
                index: a
              };
            });
          }
          return [];
        }
      },
      onClick(t, n, i) {
        i.chart.toggleDataVisibility(n.index), i.chart.update();
      }
    }
  }
});
class Ru extends wa {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const n = this._cachedMeta, { dataset: i, data: r = [], _dataset: o } = n, a = this.chart._animationsDisabled;
    let { start: l, count: u } = MB(n, r, a);
    this._drawStart = l, this._drawCount = u, TB(n) && (l = 0, u = r.length), i._chart = this.chart, i._datasetIndex = this.index, i._decimated = !!o._decimated, i.points = r;
    const d = this.resolveDatasetElementOptions(t);
    this.options.showLine || (d.borderWidth = 0), d.segment = this.options.segment, this.updateElement(i, void 0, {
      animated: !a,
      options: d
    }, t), this.updateElements(r, l, u, t);
  }
  updateElements(t, n, i, r) {
    const o = r === "reset", { iScale: a, vScale: l, _stacked: u, _dataset: d } = this._cachedMeta, { sharedOptions: f, includeOptions: m } = this._getSharedOptions(n, r), h = a.axis, v = l.axis, { spanGaps: y, segment: p } = this.options, b = Hs(y) ? y : Number.POSITIVE_INFINITY, x = this.chart._animationsDisabled || o || r === "none", _ = n + i, O = t.length;
    let D = n > 0 && this.getParsed(n - 1);
    for (let F = 0; F < O; ++F) {
      const $ = t[F], A = x ? $ : {};
      if (F < n || F >= _) {
        A.skip = !0;
        continue;
      }
      const k = this.getParsed(F), S = _t(k[v]), M = A[h] = a.getPixelForValue(k[h], F), E = A[v] = o || S ? l.getBasePixel() : l.getPixelForValue(u ? this.applyStack(l, k, u) : k[v], F);
      A.skip = isNaN(M) || isNaN(E) || S, A.stop = F > 0 && Math.abs(k[h] - D[h]) > b, p && (A.parsed = k, A.raw = d.data[F]), m && (A.options = f || this.resolveDataElementOptions(F, $.active ? "active" : r)), x || this.updateElement($, F, A, r), D = k;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.dataset, i = n.options && n.options.borderWidth || 0, r = t.data || [];
    if (!r.length)
      return i;
    const o = r[0].size(this.resolveDataElementOptions(0)), a = r[r.length - 1].size(this.resolveDataElementOptions(r.length - 1));
    return Math.max(i, o, a) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
ne(Ru, "id", "line"), ne(Ru, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), ne(Ru, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
function ko() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class Eg {
  constructor(t) {
    ne(this, "options");
    this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(Eg.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return ko();
  }
  parse() {
    return ko();
  }
  format() {
    return ko();
  }
  add() {
    return ko();
  }
  diff() {
    return ko();
  }
  startOf() {
    return ko();
  }
  endOf() {
    return ko();
  }
}
var Ww = {
  _date: Eg
};
function jV(e, t, n, i) {
  const { controller: r, data: o, _sorted: a } = e, l = r._cachedMeta.iScale;
  if (l && t === l.axis && t !== "r" && a && o.length) {
    const u = l._reversePixels ? _B : Po;
    if (i) {
      if (r._sharedOptions) {
        const d = o[0], f = typeof d.getRange == "function" && d.getRange(t);
        if (f) {
          const m = u(o, t, n - f), h = u(o, t, n + f);
          return {
            lo: m.lo,
            hi: h.hi
          };
        }
      }
    } else
      return u(o, t, n);
  }
  return {
    lo: 0,
    hi: o.length - 1
  };
}
function cl(e, t, n, i, r) {
  const o = e.getSortedVisibleDatasetMetas(), a = n[t];
  for (let l = 0, u = o.length; l < u; ++l) {
    const { index: d, data: f } = o[l], { lo: m, hi: h } = jV(o[l], t, a, r);
    for (let v = m; v <= h; ++v) {
      const y = f[v];
      y.skip || i(y, d, v);
    }
  }
}
function YV(e) {
  const t = e.indexOf("x") !== -1, n = e.indexOf("y") !== -1;
  return function(i, r) {
    const o = t ? Math.abs(i.x - r.x) : 0, a = n ? Math.abs(i.y - r.y) : 0;
    return Math.sqrt(Math.pow(o, 2) + Math.pow(a, 2));
  };
}
function zf(e, t, n, i, r) {
  const o = [];
  return !r && !e.isPointInArea(t) || cl(e, n, t, function(l, u, d) {
    !r && !ar(l, e.chartArea, 0) || l.inRange(t.x, t.y, i) && o.push({
      element: l,
      datasetIndex: u,
      index: d
    });
  }, !0), o;
}
function UV(e, t, n, i) {
  let r = [];
  function o(a, l, u) {
    const { startAngle: d, endAngle: f } = a.getProps([
      "startAngle",
      "endAngle"
    ], i), { angle: m } = xw(a, {
      x: t.x,
      y: t.y
    });
    js(m, d, f) && r.push({
      element: a,
      datasetIndex: l,
      index: u
    });
  }
  return cl(e, n, t, o), r;
}
function qV(e, t, n, i, r, o) {
  let a = [];
  const l = YV(n);
  let u = Number.POSITIVE_INFINITY;
  function d(f, m, h) {
    const v = f.inRange(t.x, t.y, r);
    if (i && !v)
      return;
    const y = f.getCenterPoint(r);
    if (!(!!o || e.isPointInArea(y)) && !v)
      return;
    const b = l(t, y);
    b < u ? (a = [
      {
        element: f,
        datasetIndex: m,
        index: h
      }
    ], u = b) : b === u && a.push({
      element: f,
      datasetIndex: m,
      index: h
    });
  }
  return cl(e, n, t, d), a;
}
function Hf(e, t, n, i, r, o) {
  return !o && !e.isPointInArea(t) ? [] : n === "r" && !i ? UV(e, t, n, r) : qV(e, t, n, i, r, o);
}
function s0(e, t, n, i, r) {
  const o = [], a = n === "x" ? "inXRange" : "inYRange";
  let l = !1;
  return cl(e, n, t, (u, d, f) => {
    u[a](t[n], r) && (o.push({
      element: u,
      datasetIndex: d,
      index: f
    }), l = l || u.inRange(t.x, t.y, r));
  }), i && !l ? [] : o;
}
var GV = {
  evaluateInteractionItems: cl,
  modes: {
    index(e, t, n, i) {
      const r = Co(t, e), o = n.axis || "x", a = n.includeInvisible || !1, l = n.intersect ? zf(e, r, o, i, a) : Hf(e, r, o, !1, i, a), u = [];
      return l.length ? (e.getSortedVisibleDatasetMetas().forEach((d) => {
        const f = l[0].index, m = d.data[f];
        m && !m.skip && u.push({
          element: m,
          datasetIndex: d.index,
          index: f
        });
      }), u) : [];
    },
    dataset(e, t, n, i) {
      const r = Co(t, e), o = n.axis || "xy", a = n.includeInvisible || !1;
      let l = n.intersect ? zf(e, r, o, i, a) : Hf(e, r, o, !1, i, a);
      if (l.length > 0) {
        const u = l[0].datasetIndex, d = e.getDatasetMeta(u).data;
        l = [];
        for (let f = 0; f < d.length; ++f)
          l.push({
            element: d[f],
            datasetIndex: u,
            index: f
          });
      }
      return l;
    },
    point(e, t, n, i) {
      const r = Co(t, e), o = n.axis || "xy", a = n.includeInvisible || !1;
      return zf(e, r, o, i, a);
    },
    nearest(e, t, n, i) {
      const r = Co(t, e), o = n.axis || "xy", a = n.includeInvisible || !1;
      return Hf(e, r, o, n.intersect, i, a);
    },
    x(e, t, n, i) {
      const r = Co(t, e);
      return s0(e, r, "x", n.intersect, i);
    },
    y(e, t, n, i) {
      const r = Co(t, e);
      return s0(e, r, "y", n.intersect, i);
    }
  }
};
const zw = [
  "left",
  "top",
  "right",
  "bottom"
];
function ds(e, t) {
  return e.filter((n) => n.pos === t);
}
function l0(e, t) {
  return e.filter((n) => zw.indexOf(n.pos) === -1 && n.box.axis === t);
}
function fs(e, t) {
  return e.sort((n, i) => {
    const r = t ? i : n, o = t ? n : i;
    return r.weight === o.weight ? r.index - o.index : r.weight - o.weight;
  });
}
function XV(e) {
  const t = [];
  let n, i, r, o, a, l;
  for (n = 0, i = (e || []).length; n < i; ++n)
    r = e[n], { position: o, options: { stack: a, stackWeight: l = 1 } } = r, t.push({
      index: n,
      box: r,
      pos: o,
      horizontal: r.isHorizontal(),
      weight: r.weight,
      stack: a && o + a,
      stackWeight: l
    });
  return t;
}
function KV(e) {
  const t = {};
  for (const n of e) {
    const { stack: i, pos: r, stackWeight: o } = n;
    if (!i || !zw.includes(r))
      continue;
    const a = t[i] || (t[i] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    a.count++, a.weight += o;
  }
  return t;
}
function ZV(e, t) {
  const n = KV(e), { vBoxMaxWidth: i, hBoxMaxHeight: r } = t;
  let o, a, l;
  for (o = 0, a = e.length; o < a; ++o) {
    l = e[o];
    const { fullSize: u } = l.box, d = n[l.stack], f = d && l.stackWeight / d.weight;
    l.horizontal ? (l.width = f ? f * i : u && t.availableWidth, l.height = r) : (l.width = i, l.height = f ? f * r : u && t.availableHeight);
  }
  return n;
}
function QV(e) {
  const t = XV(e), n = fs(t.filter((d) => d.box.fullSize), !0), i = fs(ds(t, "left"), !0), r = fs(ds(t, "right")), o = fs(ds(t, "top"), !0), a = fs(ds(t, "bottom")), l = l0(t, "x"), u = l0(t, "y");
  return {
    fullSize: n,
    leftAndTop: i.concat(o),
    rightAndBottom: r.concat(u).concat(a).concat(l),
    chartArea: ds(t, "chartArea"),
    vertical: i.concat(r).concat(u),
    horizontal: o.concat(a).concat(l)
  };
}
function u0(e, t, n, i) {
  return Math.max(e[n], t[n]) + Math.max(e[i], t[i]);
}
function Hw(e, t) {
  e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
function JV(e, t, n, i) {
  const { pos: r, box: o } = n, a = e.maxPadding;
  if (!it(r)) {
    n.size && (e[r] -= n.size);
    const m = i[n.stack] || {
      size: 0,
      count: 1
    };
    m.size = Math.max(m.size, n.horizontal ? o.height : o.width), n.size = m.size / m.count, e[r] += n.size;
  }
  o.getPadding && Hw(a, o.getPadding());
  const l = Math.max(0, t.outerWidth - u0(a, e, "left", "right")), u = Math.max(0, t.outerHeight - u0(a, e, "top", "bottom")), d = l !== e.w, f = u !== e.h;
  return e.w = l, e.h = u, n.horizontal ? {
    same: d,
    other: f
  } : {
    same: f,
    other: d
  };
}
function e$(e) {
  const t = e.maxPadding;
  function n(i) {
    const r = Math.max(t[i] - e[i], 0);
    return e[i] += r, r;
  }
  e.y += n("top"), e.x += n("left"), n("right"), n("bottom");
}
function t$(e, t) {
  const n = t.maxPadding;
  function i(r) {
    const o = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return r.forEach((a) => {
      o[a] = Math.max(t[a], n[a]);
    }), o;
  }
  return i(e ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function _s(e, t, n, i) {
  const r = [];
  let o, a, l, u, d, f;
  for (o = 0, a = e.length, d = 0; o < a; ++o) {
    l = e[o], u = l.box, u.update(l.width || t.w, l.height || t.h, t$(l.horizontal, t));
    const { same: m, other: h } = JV(t, n, l, i);
    d |= m && r.length, f = f || h, u.fullSize || r.push(l);
  }
  return d && _s(r, t, n, i) || f;
}
function _u(e, t, n, i, r) {
  e.top = n, e.left = t, e.right = t + i, e.bottom = n + r, e.width = i, e.height = r;
}
function c0(e, t, n, i) {
  const r = n.padding;
  let { x: o, y: a } = t;
  for (const l of e) {
    const u = l.box, d = i[l.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, f = l.stackWeight / d.weight || 1;
    if (l.horizontal) {
      const m = t.w * f, h = d.size || u.height;
      lc(d.start) && (a = d.start), u.fullSize ? _u(u, r.left, a, n.outerWidth - r.right - r.left, h) : _u(u, t.left + d.placed, a, m, h), d.start = a, d.placed += m, a = u.bottom;
    } else {
      const m = t.h * f, h = d.size || u.width;
      lc(d.start) && (o = d.start), u.fullSize ? _u(u, o, r.top, h, n.outerHeight - r.bottom - r.top) : _u(u, o, t.top + d.placed, h, m), d.start = o, d.placed += m, o = u.right;
    }
  }
  t.x = o, t.y = a;
}
var Rr = {
  addBox(e, t) {
    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            t.draw(n);
          }
        }
      ];
    }, e.boxes.push(t);
  },
  removeBox(e, t) {
    const n = e.boxes ? e.boxes.indexOf(t) : -1;
    n !== -1 && e.boxes.splice(n, 1);
  },
  configure(e, t, n) {
    t.fullSize = n.fullSize, t.position = n.position, t.weight = n.weight;
  },
  update(e, t, n, i) {
    if (!e)
      return;
    const r = bn(e.options.layout.padding), o = Math.max(t - r.width, 0), a = Math.max(n - r.height, 0), l = QV(e.boxes), u = l.vertical, d = l.horizontal;
    dt(e.boxes, (p) => {
      typeof p.beforeLayout == "function" && p.beforeLayout();
    });
    const f = u.reduce((p, b) => b.box.options && b.box.options.display === !1 ? p : p + 1, 0) || 1, m = Object.freeze({
      outerWidth: t,
      outerHeight: n,
      padding: r,
      availableWidth: o,
      availableHeight: a,
      vBoxMaxWidth: o / 2 / f,
      hBoxMaxHeight: a / 2
    }), h = Object.assign({}, r);
    Hw(h, bn(i));
    const v = Object.assign({
      maxPadding: h,
      w: o,
      h: a,
      x: r.left,
      y: r.top
    }, r), y = ZV(u.concat(d), m);
    _s(l.fullSize, v, m, y), _s(u, v, m, y), _s(d, v, m, y) && _s(u, v, m, y), e$(v), c0(l.leftAndTop, v, m, y), v.x += v.w, v.y += v.h, c0(l.rightAndBottom, v, m, y), e.chartArea = {
      left: v.left,
      top: v.top,
      right: v.left + v.w,
      bottom: v.top + v.h,
      height: v.h,
      width: v.w
    }, dt(l.chartArea, (p) => {
      const b = p.box;
      Object.assign(b, e.chartArea), b.update(v.w, v.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class jw {
  acquireContext(t, n) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, n, i) {
  }
  removeEventListener(t, n, i) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, n, i, r) {
    return n = Math.max(0, n || t.width), i = i || t.height, {
      width: n,
      height: Math.max(0, r ? Math.floor(n / r) : i)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class n$ extends jw {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const Fu = "$chartjs", i$ = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, d0 = (e) => e === null || e === "";
function r$(e, t) {
  const n = e.style, i = e.getAttribute("height"), r = e.getAttribute("width");
  if (e[Fu] = {
    initial: {
      height: i,
      width: r,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", d0(r)) {
    const o = Ky(e, "width");
    o !== void 0 && (e.width = o);
  }
  if (d0(i))
    if (e.style.height === "")
      e.height = e.width / (t || 2);
    else {
      const o = Ky(e, "height");
      o !== void 0 && (e.height = o);
    }
  return e;
}
const Yw = yV ? {
  passive: !0
} : !1;
function o$(e, t, n) {
  e && e.addEventListener(t, n, Yw);
}
function a$(e, t, n) {
  e && e.canvas && e.canvas.removeEventListener(t, n, Yw);
}
function s$(e, t) {
  const n = i$[e.type] || e.type, { x: i, y: r } = Co(e, t);
  return {
    type: n,
    chart: t,
    native: e,
    x: i !== void 0 ? i : null,
    y: r !== void 0 ? r : null
  };
}
function hc(e, t) {
  for (const n of e)
    if (n === t || n.contains(t))
      return !0;
}
function l$(e, t, n) {
  const i = e.canvas, r = new MutationObserver((o) => {
    let a = !1;
    for (const l of o)
      a = a || hc(l.addedNodes, i), a = a && !hc(l.removedNodes, i);
    a && n();
  });
  return r.observe(document, {
    childList: !0,
    subtree: !0
  }), r;
}
function u$(e, t, n) {
  const i = e.canvas, r = new MutationObserver((o) => {
    let a = !1;
    for (const l of o)
      a = a || hc(l.removedNodes, i), a = a && !hc(l.addedNodes, i);
    a && n();
  });
  return r.observe(document, {
    childList: !0,
    subtree: !0
  }), r;
}
const Ys = /* @__PURE__ */ new Map();
let f0 = 0;
function Uw() {
  const e = window.devicePixelRatio;
  e !== f0 && (f0 = e, Ys.forEach((t, n) => {
    n.currentDevicePixelRatio !== e && t();
  }));
}
function c$(e, t) {
  Ys.size || window.addEventListener("resize", Uw), Ys.set(e, t);
}
function d$(e) {
  Ys.delete(e), Ys.size || window.removeEventListener("resize", Uw);
}
function f$(e, t, n) {
  const i = e.canvas, r = i && Ag(i);
  if (!r)
    return;
  const o = Cw((l, u) => {
    const d = r.clientWidth;
    n(l, u), d < r.clientWidth && n();
  }, window), a = new ResizeObserver((l) => {
    const u = l[0], d = u.contentRect.width, f = u.contentRect.height;
    d === 0 && f === 0 || o(d, f);
  });
  return a.observe(r), c$(e, o), a;
}
function jf(e, t, n) {
  n && n.disconnect(), t === "resize" && d$(e);
}
function h$(e, t, n) {
  const i = e.canvas, r = Cw((o) => {
    e.ctx !== null && n(s$(o, e));
  }, e);
  return o$(i, t, r), r;
}
class g$ extends jw {
  acquireContext(t, n) {
    const i = t && t.getContext && t.getContext("2d");
    return i && i.canvas === t ? (r$(t, n), i) : null;
  }
  releaseContext(t) {
    const n = t.canvas;
    if (!n[Fu])
      return !1;
    const i = n[Fu].initial;
    [
      "height",
      "width"
    ].forEach((o) => {
      const a = i[o];
      _t(a) ? n.removeAttribute(o) : n.setAttribute(o, a);
    });
    const r = i.style || {};
    return Object.keys(r).forEach((o) => {
      n.style[o] = r[o];
    }), n.width = n.width, delete n[Fu], !0;
  }
  addEventListener(t, n, i) {
    this.removeEventListener(t, n);
    const r = t.$proxies || (t.$proxies = {}), a = {
      attach: l$,
      detach: u$,
      resize: f$
    }[n] || h$;
    r[n] = a(t, n, i);
  }
  removeEventListener(t, n) {
    const i = t.$proxies || (t.$proxies = {}), r = i[n];
    if (!r)
      return;
    ({
      attach: jf,
      detach: jf,
      resize: jf
    }[n] || a$)(t, n, r), i[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, n, i, r) {
    return pV(t, n, i, r);
  }
  isAttached(t) {
    const n = t && Ag(t);
    return !!(n && n.isConnected);
  }
}
function m$(e) {
  return !Pg() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? n$ : g$;
}
var Lu;
let No = (Lu = class {
  constructor() {
    ne(this, "x");
    ne(this, "y");
    ne(this, "active", !1);
    ne(this, "options");
    ne(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: n, y: i } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: n,
      y: i
    };
  }
  hasValue() {
    return Hs(this.x) && Hs(this.y);
  }
  getProps(t, n) {
    const i = this.$animations;
    if (!n || !i)
      return this;
    const r = {};
    return t.forEach((o) => {
      r[o] = i[o] && i[o].active() ? i[o]._to : this[o];
    }), r;
  }
}, ne(Lu, "defaults", {}), ne(Lu, "defaultRoutes"), Lu);
function v$(e, t) {
  const n = e.options.ticks, i = p$(e), r = Math.min(n.maxTicksLimit || i, i), o = n.major.enabled ? b$(t) : [], a = o.length, l = o[0], u = o[a - 1], d = [];
  if (a > r)
    return w$(t, d, o, a / r), d;
  const f = y$(o, t, r);
  if (a > 0) {
    let m, h;
    const v = a > 1 ? Math.round((u - l) / (a - 1)) : null;
    for (xu(t, d, f, _t(v) ? 0 : l - v, l), m = 0, h = a - 1; m < h; m++)
      xu(t, d, f, o[m], o[m + 1]);
    return xu(t, d, f, u, _t(v) ? t.length : u + v), d;
  }
  return xu(t, d, f), d;
}
function p$(e) {
  const t = e.options.offset, n = e._tickSize(), i = e._length / n + (t ? 0 : 1), r = e._maxLength / n;
  return Math.floor(Math.min(i, r));
}
function y$(e, t, n) {
  const i = _$(e), r = t.length / n;
  if (!i)
    return Math.max(r, 1);
  const o = pB(i);
  for (let a = 0, l = o.length - 1; a < l; a++) {
    const u = o[a];
    if (u > r)
      return u;
  }
  return Math.max(r, 1);
}
function b$(e) {
  const t = [];
  let n, i;
  for (n = 0, i = e.length; n < i; n++)
    e[n].major && t.push(n);
  return t;
}
function w$(e, t, n, i) {
  let r = 0, o = n[0], a;
  for (i = Math.ceil(i), a = 0; a < e.length; a++)
    a === o && (t.push(e[a]), r++, o = n[r * i]);
}
function xu(e, t, n, i, r) {
  const o = et(i, 0), a = Math.min(et(r, e.length), e.length);
  let l = 0, u, d, f;
  for (n = Math.ceil(n), r && (u = r - i, n = u / Math.floor(u / n)), f = o; f < 0; )
    l++, f = Math.round(o + l * n);
  for (d = Math.max(o, 0); d < a; d++)
    d === f && (t.push(e[d]), l++, f = Math.round(o + l * n));
}
function _$(e) {
  const t = e.length;
  let n, i;
  if (t < 2)
    return !1;
  for (i = e[0], n = 1; n < t; ++n)
    if (e[n] - e[n - 1] !== i)
      return !1;
  return i;
}
const x$ = (e) => e === "left" ? "right" : e === "right" ? "left" : e, h0 = (e, t, n) => t === "top" || t === "left" ? e[t] + n : e[t] - n, g0 = (e, t) => Math.min(t || e, e);
function m0(e, t) {
  const n = [], i = e.length / t, r = e.length;
  let o = 0;
  for (; o < r; o += i)
    n.push(e[Math.floor(o)]);
  return n;
}
function k$(e, t, n) {
  const i = e.ticks.length, r = Math.min(t, i - 1), o = e._startPixel, a = e._endPixel, l = 1e-6;
  let u = e.getPixelForTick(r), d;
  if (!(n && (i === 1 ? d = Math.max(u - o, a - u) : t === 0 ? d = (e.getPixelForTick(1) - u) / 2 : d = (u - e.getPixelForTick(r - 1)) / 2, u += r < t ? d : -d, u < o - l || u > a + l)))
    return u;
}
function S$(e, t) {
  dt(e, (n) => {
    const i = n.gc, r = i.length / 2;
    let o;
    if (r > t) {
      for (o = 0; o < r; ++o)
        delete n.data[i[o]];
      i.splice(0, r);
    }
  });
}
function hs(e) {
  return e.drawTicks ? e.tickLength : 0;
}
function v0(e, t) {
  if (!e.display)
    return 0;
  const n = an(e.font, t), i = bn(e.padding);
  return (Ct(e.text) ? e.text.length : 1) * n.lineHeight + i.height;
}
function C$(e, t) {
  return Jr(e, {
    scale: t,
    type: "scale"
  });
}
function O$(e, t, n) {
  return Jr(e, {
    tick: n,
    index: t,
    type: "tick"
  });
}
function M$(e, t, n) {
  let i = Ow(e);
  return (n && t !== "right" || !n && t === "right") && (i = x$(i)), i;
}
function T$(e, t, n, i) {
  const { top: r, left: o, bottom: a, right: l, chart: u } = e, { chartArea: d, scales: f } = u;
  let m = 0, h, v, y;
  const p = a - r, b = l - o;
  if (e.isHorizontal()) {
    if (v = Wn(i, o, l), it(n)) {
      const x = Object.keys(n)[0], _ = n[x];
      y = f[x].getPixelForValue(_) + p - t;
    } else
      n === "center" ? y = (d.bottom + d.top) / 2 + p - t : y = h0(e, n, t);
    h = l - o;
  } else {
    if (it(n)) {
      const x = Object.keys(n)[0], _ = n[x];
      v = f[x].getPixelForValue(_) - b + t;
    } else
      n === "center" ? v = (d.left + d.right) / 2 - b + t : v = h0(e, n, t);
    y = Wn(i, a, r), m = n === "left" ? -$t : $t;
  }
  return {
    titleX: v,
    titleY: y,
    maxWidth: h,
    rotation: m
  };
}
class Wo extends No {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, n) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: n, _suggestedMin: i, _suggestedMax: r } = this;
    return t = zn(t, Number.POSITIVE_INFINITY), n = zn(n, Number.NEGATIVE_INFINITY), i = zn(i, Number.POSITIVE_INFINITY), r = zn(r, Number.NEGATIVE_INFINITY), {
      min: zn(t, i),
      max: zn(n, r),
      minDefined: Et(t),
      maxDefined: Et(n)
    };
  }
  getMinMax(t) {
    let { min: n, max: i, minDefined: r, maxDefined: o } = this.getUserBounds(), a;
    if (r && o)
      return {
        min: n,
        max: i
      };
    const l = this.getMatchingVisibleMetas();
    for (let u = 0, d = l.length; u < d; ++u)
      a = l[u].controller.getMinMax(this, t), r || (n = Math.min(n, a.min)), o || (i = Math.max(i, a.max));
    return n = o && n > i ? i : n, i = r && n > i ? n : i, {
      min: zn(n, zn(i, n)),
      max: zn(i, zn(n, i))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    vt(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, n, i) {
    const { beginAtZero: r, grace: o, ticks: a } = this.options, l = a.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = n, this._margins = i = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, i), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + i.left + i.right : this.height + i.top + i.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = XB(this, o, r), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const u = l < this.ticks.length;
    this._convertTicksToLabels(u ? m0(this.ticks, l) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), a.display && (a.autoSkip || a.source === "auto") && (this.ticks = v$(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), u && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, n, i;
    this.isHorizontal() ? (n = this.left, i = this.right) : (n = this.top, i = this.bottom, t = !t), this._startPixel = n, this._endPixel = i, this._reversePixels = t, this._length = i - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    vt(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    vt(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    vt(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), vt(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    vt(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const n = this.options.ticks;
    let i, r, o;
    for (i = 0, r = t.length; i < r; i++)
      o = t[i], o.label = vt(n.callback, [
        o.value,
        i,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    vt(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    vt(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, n = t.ticks, i = g0(this.ticks.length, t.ticks.maxTicksLimit), r = n.minRotation || 0, o = n.maxRotation;
    let a = r, l, u, d;
    if (!this._isVisible() || !n.display || r >= o || i <= 1 || !this.isHorizontal()) {
      this.labelRotation = r;
      return;
    }
    const f = this._getLabelSizes(), m = f.widest.width, h = f.highest.height, v = yn(this.chart.width - m, 0, this.maxWidth);
    l = t.offset ? this.maxWidth / i : v / (i - 1), m + 6 > l && (l = v / (i - (t.offset ? 0.5 : 1)), u = this.maxHeight - hs(t.grid) - n.padding - v0(t.title, this.chart.options.font), d = Math.sqrt(m * m + h * h), a = xg(Math.min(Math.asin(yn((f.highest.height + 6) / l, -1, 1)), Math.asin(yn(u / d, -1, 1)) - Math.asin(yn(h / d, -1, 1)))), a = Math.max(r, Math.min(o, a))), this.labelRotation = a;
  }
  afterCalculateLabelRotation() {
    vt(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    vt(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: i, title: r, grid: o } } = this, a = this._isVisible(), l = this.isHorizontal();
    if (a) {
      const u = v0(r, n.options.font);
      if (l ? (t.width = this.maxWidth, t.height = hs(o) + u) : (t.height = this.maxHeight, t.width = hs(o) + u), i.display && this.ticks.length) {
        const { first: d, last: f, widest: m, highest: h } = this._getLabelSizes(), v = i.padding * 2, y = $i(this.labelRotation), p = Math.cos(y), b = Math.sin(y);
        if (l) {
          const x = i.mirror ? 0 : b * m.width + p * h.height;
          t.height = Math.min(this.maxHeight, t.height + x + v);
        } else {
          const x = i.mirror ? 0 : p * m.width + b * h.height;
          t.width = Math.min(this.maxWidth, t.width + x + v);
        }
        this._calculatePadding(d, f, b, p);
      }
    }
    this._handleMargins(), l ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, n, i, r) {
    const { ticks: { align: o, padding: a }, position: l } = this.options, u = this.labelRotation !== 0, d = l !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const f = this.getPixelForTick(0) - this.left, m = this.right - this.getPixelForTick(this.ticks.length - 1);
      let h = 0, v = 0;
      u ? d ? (h = r * t.width, v = i * n.height) : (h = i * t.height, v = r * n.width) : o === "start" ? v = n.width : o === "end" ? h = t.width : o !== "inner" && (h = t.width / 2, v = n.width / 2), this.paddingLeft = Math.max((h - f + a) * this.width / (this.width - f), 0), this.paddingRight = Math.max((v - m + a) * this.width / (this.width - m), 0);
    } else {
      let f = n.height / 2, m = t.height / 2;
      o === "start" ? (f = 0, m = t.height) : o === "end" && (f = n.height, m = 0), this.paddingTop = f + a, this.paddingBottom = m + a;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    vt(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: n } = this.options;
    return n === "top" || n === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let n, i;
    for (n = 0, i = t.length; n < i; n++)
      _t(t[n].label) && (t.splice(n, 1), i--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const n = this.options.ticks.sampleSize;
      let i = this.ticks;
      n < i.length && (i = m0(i, n)), this._labelSizes = t = this._computeLabelSizes(i, i.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, n, i) {
    const { ctx: r, _longestTextCache: o } = this, a = [], l = [], u = Math.floor(n / g0(n, i));
    let d = 0, f = 0, m, h, v, y, p, b, x, _, O, D, F;
    for (m = 0; m < n; m += u) {
      if (y = t[m].label, p = this._resolveTickFontOptions(m), r.font = b = p.string, x = o[b] = o[b] || {
        data: {},
        gc: []
      }, _ = p.lineHeight, O = D = 0, !_t(y) && !Ct(y))
        O = cc(r, x.data, x.gc, O, y), D = _;
      else if (Ct(y))
        for (h = 0, v = y.length; h < v; ++h)
          F = y[h], !_t(F) && !Ct(F) && (O = cc(r, x.data, x.gc, O, F), D += _);
      a.push(O), l.push(D), d = Math.max(O, d), f = Math.max(D, f);
    }
    S$(o, n);
    const $ = a.indexOf(d), A = l.indexOf(f), k = (S) => ({
      width: a[S] || 0,
      height: l[S] || 0
    });
    return {
      first: k(0),
      last: k(n - 1),
      widest: k($),
      highest: k(A),
      widths: a,
      heights: l
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, n) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const n = this._startPixel + t * this._length;
    return wB(this._alignToPixels ? xo(this.chart, n, 0) : n);
  }
  getDecimalForPixel(t) {
    const n = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: n } = this;
    return t < 0 && n < 0 ? n : t > 0 && n > 0 ? t : 0;
  }
  getContext(t) {
    const n = this.ticks || [];
    if (t >= 0 && t < n.length) {
      const i = n[t];
      return i.$context || (i.$context = O$(this.getContext(), t, i));
    }
    return this.$context || (this.$context = C$(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, n = $i(this.labelRotation), i = Math.abs(Math.cos(n)), r = Math.abs(Math.sin(n)), o = this._getLabelSizes(), a = t.autoSkipPadding || 0, l = o ? o.widest.width + a : 0, u = o ? o.highest.height + a : 0;
    return this.isHorizontal() ? u * i > l * r ? l / i : u / r : u * r < l * i ? u / i : l / r;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const n = this.axis, i = this.chart, r = this.options, { grid: o, position: a, border: l } = r, u = o.offset, d = this.isHorizontal(), m = this.ticks.length + (u ? 1 : 0), h = hs(o), v = [], y = l.setContext(this.getContext()), p = y.display ? y.width : 0, b = p / 2, x = function(z) {
      return xo(i, z, p);
    };
    let _, O, D, F, $, A, k, S, M, E, I, L;
    if (a === "top")
      _ = x(this.bottom), A = this.bottom - h, S = _ - b, E = x(t.top) + b, L = t.bottom;
    else if (a === "bottom")
      _ = x(this.top), E = t.top, L = x(t.bottom) - b, A = _ + b, S = this.top + h;
    else if (a === "left")
      _ = x(this.right), $ = this.right - h, k = _ - b, M = x(t.left) + b, I = t.right;
    else if (a === "right")
      _ = x(this.left), M = t.left, I = x(t.right) - b, $ = _ + b, k = this.left + h;
    else if (n === "x") {
      if (a === "center")
        _ = x((t.top + t.bottom) / 2 + 0.5);
      else if (it(a)) {
        const z = Object.keys(a)[0], H = a[z];
        _ = x(this.chart.scales[z].getPixelForValue(H));
      }
      E = t.top, L = t.bottom, A = _ + b, S = A + h;
    } else if (n === "y") {
      if (a === "center")
        _ = x((t.left + t.right) / 2);
      else if (it(a)) {
        const z = Object.keys(a)[0], H = a[z];
        _ = x(this.chart.scales[z].getPixelForValue(H));
      }
      $ = _ - b, k = $ - h, M = t.left, I = t.right;
    }
    const N = et(r.ticks.maxTicksLimit, m), V = Math.max(1, Math.ceil(m / N));
    for (O = 0; O < m; O += V) {
      const z = this.getContext(O), H = o.setContext(z), W = l.setContext(z), j = H.lineWidth, U = H.color, K = W.dash || [], te = W.dashOffset, ue = H.tickWidth, de = H.tickColor, Q = H.tickBorderDash || [], J = H.tickBorderDashOffset;
      D = k$(this, O, u), D !== void 0 && (F = xo(i, D, j), d ? $ = k = M = I = F : A = S = E = L = F, v.push({
        tx1: $,
        ty1: A,
        tx2: k,
        ty2: S,
        x1: M,
        y1: E,
        x2: I,
        y2: L,
        width: j,
        color: U,
        borderDash: K,
        borderDashOffset: te,
        tickWidth: ue,
        tickColor: de,
        tickBorderDash: Q,
        tickBorderDashOffset: J
      }));
    }
    return this._ticksLength = m, this._borderValue = _, v;
  }
  _computeLabelItems(t) {
    const n = this.axis, i = this.options, { position: r, ticks: o } = i, a = this.isHorizontal(), l = this.ticks, { align: u, crossAlign: d, padding: f, mirror: m } = o, h = hs(i.grid), v = h + f, y = m ? -f : v, p = -$i(this.labelRotation), b = [];
    let x, _, O, D, F, $, A, k, S, M, E, I, L = "middle";
    if (r === "top")
      $ = this.bottom - y, A = this._getXAxisLabelAlignment();
    else if (r === "bottom")
      $ = this.top + y, A = this._getXAxisLabelAlignment();
    else if (r === "left") {
      const V = this._getYAxisLabelAlignment(h);
      A = V.textAlign, F = V.x;
    } else if (r === "right") {
      const V = this._getYAxisLabelAlignment(h);
      A = V.textAlign, F = V.x;
    } else if (n === "x") {
      if (r === "center")
        $ = (t.top + t.bottom) / 2 + v;
      else if (it(r)) {
        const V = Object.keys(r)[0], z = r[V];
        $ = this.chart.scales[V].getPixelForValue(z) + v;
      }
      A = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (r === "center")
        F = (t.left + t.right) / 2 - v;
      else if (it(r)) {
        const V = Object.keys(r)[0], z = r[V];
        F = this.chart.scales[V].getPixelForValue(z);
      }
      A = this._getYAxisLabelAlignment(h).textAlign;
    }
    n === "y" && (u === "start" ? L = "top" : u === "end" && (L = "bottom"));
    const N = this._getLabelSizes();
    for (x = 0, _ = l.length; x < _; ++x) {
      O = l[x], D = O.label;
      const V = o.setContext(this.getContext(x));
      k = this.getPixelForTick(x) + o.labelOffset, S = this._resolveTickFontOptions(x), M = S.lineHeight, E = Ct(D) ? D.length : 1;
      const z = E / 2, H = V.color, W = V.textStrokeColor, j = V.textStrokeWidth;
      let U = A;
      a ? (F = k, A === "inner" && (x === _ - 1 ? U = this.options.reverse ? "left" : "right" : x === 0 ? U = this.options.reverse ? "right" : "left" : U = "center"), r === "top" ? d === "near" || p !== 0 ? I = -E * M + M / 2 : d === "center" ? I = -N.highest.height / 2 - z * M + M : I = -N.highest.height + M / 2 : d === "near" || p !== 0 ? I = M / 2 : d === "center" ? I = N.highest.height / 2 - z * M : I = N.highest.height - E * M, m && (I *= -1), p !== 0 && !V.showLabelBackdrop && (F += M / 2 * Math.sin(p))) : ($ = k, I = (1 - E) * M / 2);
      let K;
      if (V.showLabelBackdrop) {
        const te = bn(V.backdropPadding), ue = N.heights[x], de = N.widths[x];
        let Q = I - te.top, J = 0 - te.left;
        switch (L) {
          case "middle":
            Q -= ue / 2;
            break;
          case "bottom":
            Q -= ue;
            break;
        }
        switch (A) {
          case "center":
            J -= de / 2;
            break;
          case "right":
            J -= de;
            break;
          case "inner":
            x === _ - 1 ? J -= de : x > 0 && (J -= de / 2);
            break;
        }
        K = {
          left: J,
          top: Q,
          width: de + te.width,
          height: ue + te.height,
          color: V.backdropColor
        };
      }
      b.push({
        label: D,
        font: S,
        textOffset: I,
        options: {
          rotation: p,
          color: H,
          strokeColor: W,
          strokeWidth: j,
          textAlign: U,
          textBaseline: L,
          translation: [
            F,
            $
          ],
          backdrop: K
        }
      });
    }
    return b;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: n } = this.options;
    if (-$i(this.labelRotation))
      return t === "top" ? "left" : "right";
    let r = "center";
    return n.align === "start" ? r = "left" : n.align === "end" ? r = "right" : n.align === "inner" && (r = "inner"), r;
  }
  _getYAxisLabelAlignment(t) {
    const { position: n, ticks: { crossAlign: i, mirror: r, padding: o } } = this.options, a = this._getLabelSizes(), l = t + o, u = a.widest.width;
    let d, f;
    return n === "left" ? r ? (f = this.right + o, i === "near" ? d = "left" : i === "center" ? (d = "center", f += u / 2) : (d = "right", f += u)) : (f = this.right - l, i === "near" ? d = "right" : i === "center" ? (d = "center", f -= u / 2) : (d = "left", f = this.left)) : n === "right" ? r ? (f = this.left + o, i === "near" ? d = "right" : i === "center" ? (d = "center", f -= u / 2) : (d = "left", f -= u)) : (f = this.left + l, i === "near" ? d = "left" : i === "center" ? (d = "center", f += u / 2) : (d = "right", f = this.right)) : d = "right", {
      textAlign: d,
      x: f
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: n }, left: i, top: r, width: o, height: a } = this;
    n && (t.save(), t.fillStyle = n, t.fillRect(i, r, o, a), t.restore());
  }
  getLineWidthForValue(t) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const r = this.ticks.findIndex((o) => o.value === t);
    return r >= 0 ? n.setContext(this.getContext(r)).lineWidth : 0;
  }
  drawGrid(t) {
    const n = this.options.grid, i = this.ctx, r = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let o, a;
    const l = (u, d, f) => {
      !f.width || !f.color || (i.save(), i.lineWidth = f.width, i.strokeStyle = f.color, i.setLineDash(f.borderDash || []), i.lineDashOffset = f.borderDashOffset, i.beginPath(), i.moveTo(u.x, u.y), i.lineTo(d.x, d.y), i.stroke(), i.restore());
    };
    if (n.display)
      for (o = 0, a = r.length; o < a; ++o) {
        const u = r[o];
        n.drawOnChartArea && l({
          x: u.x1,
          y: u.y1
        }, {
          x: u.x2,
          y: u.y2
        }, u), n.drawTicks && l({
          x: u.tx1,
          y: u.ty1
        }, {
          x: u.tx2,
          y: u.ty2
        }, {
          color: u.tickColor,
          width: u.tickWidth,
          borderDash: u.tickBorderDash,
          borderDashOffset: u.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: n, options: { border: i, grid: r } } = this, o = i.setContext(this.getContext()), a = i.display ? o.width : 0;
    if (!a)
      return;
    const l = r.setContext(this.getContext(0)).lineWidth, u = this._borderValue;
    let d, f, m, h;
    this.isHorizontal() ? (d = xo(t, this.left, a) - a / 2, f = xo(t, this.right, l) + l / 2, m = h = u) : (m = xo(t, this.top, a) - a / 2, h = xo(t, this.bottom, l) + l / 2, d = f = u), n.save(), n.lineWidth = o.width, n.strokeStyle = o.color, n.beginPath(), n.moveTo(d, m), n.lineTo(f, h), n.stroke(), n.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const i = this.ctx, r = this._computeLabelArea();
    r && Fc(i, r);
    const o = this.getLabelItems(t);
    for (const a of o) {
      const l = a.options, u = a.font, d = a.label, f = a.textOffset;
      Oa(i, d, 0, f, u, l);
    }
    r && Nc(i);
  }
  drawTitle() {
    const { ctx: t, options: { position: n, title: i, reverse: r } } = this;
    if (!i.display)
      return;
    const o = an(i.font), a = bn(i.padding), l = i.align;
    let u = o.lineHeight / 2;
    n === "bottom" || n === "center" || it(n) ? (u += a.bottom, Ct(i.text) && (u += o.lineHeight * (i.text.length - 1))) : u += a.top;
    const { titleX: d, titleY: f, maxWidth: m, rotation: h } = T$(this, u, n, l);
    Oa(t, i.text, 0, 0, o, {
      color: i.color,
      maxWidth: m,
      rotation: h,
      textAlign: M$(l, n, r),
      textBaseline: "middle",
      translation: [
        d,
        f
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, n = t.ticks && t.ticks.z || 0, i = et(t.grid && t.grid.z, -1), r = et(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== Wo.prototype.draw ? [
      {
        z: n,
        draw: (o) => {
          this.draw(o);
        }
      }
    ] : [
      {
        z: i,
        draw: (o) => {
          this.drawBackground(), this.drawGrid(o), this.drawTitle();
        }
      },
      {
        z: r,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (o) => {
          this.drawLabels(o);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const n = this.chart.getSortedVisibleDatasetMetas(), i = this.axis + "AxisID", r = [];
    let o, a;
    for (o = 0, a = n.length; o < a; ++o) {
      const l = n[o];
      l[i] === this.id && (!t || l.type === t) && r.push(l);
    }
    return r;
  }
  _resolveTickFontOptions(t) {
    const n = this.options.ticks.setContext(this.getContext(t));
    return an(n.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class ku {
  constructor(t, n, i) {
    this.type = t, this.scope = n, this.override = i, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const n = Object.getPrototypeOf(t);
    let i;
    E$(n) && (i = this.register(n));
    const r = this.items, o = t.id, a = this.scope + "." + o;
    if (!o)
      throw new Error("class does not have id: " + t);
    return o in r || (r[o] = t, P$(t, a, i), this.override && It.override(t.id, t.overrides)), a;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const n = this.items, i = t.id, r = this.scope;
    i in n && delete n[i], r && i in It[r] && (delete It[r][i], this.override && delete Lo[i]);
  }
}
function P$(e, t, n) {
  const i = Ws(/* @__PURE__ */ Object.create(null), [
    n ? It.get(n) : {},
    It.get(t),
    e.defaults
  ]);
  It.set(t, i), e.defaultRoutes && A$(t, e.defaultRoutes), e.descriptors && It.describe(t, e.descriptors);
}
function A$(e, t) {
  Object.keys(t).forEach((n) => {
    const i = n.split("."), r = i.pop(), o = [
      e
    ].concat(i).join("."), a = t[n].split("."), l = a.pop(), u = a.join(".");
    It.route(o, r, u, l);
  });
}
function E$(e) {
  return "id" in e && "defaults" in e;
}
class I$ {
  constructor() {
    this.controllers = new ku(wa, "datasets", !0), this.elements = new ku(No, "elements"), this.plugins = new ku(Object, "plugins"), this.scales = new ku(Wo, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, n, i) {
    [
      ...n
    ].forEach((r) => {
      const o = i || this._getRegistryForType(r);
      i || o.isForType(r) || o === this.plugins && r.id ? this._exec(t, o, r) : dt(r, (a) => {
        const l = i || this._getRegistryForType(a);
        this._exec(t, l, a);
      });
    });
  }
  _exec(t, n, i) {
    const r = _g(t);
    vt(i["before" + r], [], i), n[t](i), vt(i["after" + r], [], i);
  }
  _getRegistryForType(t) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const i = this._typedRegistries[n];
      if (i.isForType(t))
        return i;
    }
    return this.plugins;
  }
  _get(t, n, i) {
    const r = n.get(t);
    if (r === void 0)
      throw new Error('"' + t + '" is not a registered ' + i + ".");
    return r;
  }
}
var Di = /* @__PURE__ */ new I$();
class D$ {
  constructor() {
    this._init = [];
  }
  notify(t, n, i, r) {
    n === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const o = r ? this._descriptors(t).filter(r) : this._descriptors(t), a = this._notify(o, t, n, i);
    return n === "afterDestroy" && (this._notify(o, t, "stop"), this._notify(this._init, t, "uninstall")), a;
  }
  _notify(t, n, i, r) {
    r = r || {};
    for (const o of t) {
      const a = o.plugin, l = a[i], u = [
        n,
        r,
        o.options
      ];
      if (vt(l, u, a) === !1 && r.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    _t(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), n;
  }
  _createDescriptors(t, n) {
    const i = t && t.config, r = et(i.options && i.options.plugins, {}), o = L$(i);
    return r === !1 && !n ? [] : V$(t, o, r, n);
  }
  _notifyStateChanges(t) {
    const n = this._oldCache || [], i = this._cache, r = (o, a) => o.filter((l) => !a.some((u) => l.plugin.id === u.plugin.id));
    this._notify(r(n, i), t, "stop"), this._notify(r(i, n), t, "start");
  }
}
function L$(e) {
  const t = {}, n = [], i = Object.keys(Di.plugins.items);
  for (let o = 0; o < i.length; o++)
    n.push(Di.getPlugin(i[o]));
  const r = e.plugins || [];
  for (let o = 0; o < r.length; o++) {
    const a = r[o];
    n.indexOf(a) === -1 && (n.push(a), t[a.id] = !0);
  }
  return {
    plugins: n,
    localIds: t
  };
}
function B$(e, t) {
  return !t && e === !1 ? null : e === !0 ? {} : e;
}
function V$(e, { plugins: t, localIds: n }, i, r) {
  const o = [], a = e.getContext();
  for (const l of t) {
    const u = l.id, d = B$(i[u], r);
    d !== null && o.push({
      plugin: l,
      options: $$(e.config, {
        plugin: l,
        local: n[u]
      }, d, a)
    });
  }
  return o;
}
function $$(e, { plugin: t, local: n }, i, r) {
  const o = e.pluginScopeKeys(t), a = e.getOptionScopes(i, o);
  return n && t.defaults && a.push(t.defaults), e.createResolver(a, r, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function xh(e, t) {
  const n = It.datasets[e] || {};
  return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || n.indexAxis || "x";
}
function R$(e, t) {
  let n = e;
  return e === "_index_" ? n = t : e === "_value_" && (n = t === "x" ? "y" : "x"), n;
}
function F$(e, t) {
  return e === t ? "_index_" : "_value_";
}
function p0(e) {
  if (e === "x" || e === "y" || e === "r")
    return e;
}
function N$(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
function kh(e, ...t) {
  if (p0(e))
    return e;
  for (const n of t) {
    const i = n.axis || N$(n.position) || e.length > 1 && p0(e[0].toLowerCase());
    if (i)
      return i;
  }
  throw new Error(`Cannot determine type of '${e}' axis. Please provide 'axis' or 'position' option.`);
}
function y0(e, t, n) {
  if (n[t + "AxisID"] === e)
    return {
      axis: t
    };
}
function W$(e, t) {
  if (t.data && t.data.datasets) {
    const n = t.data.datasets.filter((i) => i.xAxisID === e || i.yAxisID === e);
    if (n.length)
      return y0(e, "x", n[0]) || y0(e, "y", n[0]);
  }
  return {};
}
function z$(e, t) {
  const n = Lo[e.type] || {
    scales: {}
  }, i = t.scales || {}, r = xh(e.type, t), o = /* @__PURE__ */ Object.create(null);
  return Object.keys(i).forEach((a) => {
    const l = i[a];
    if (!it(l))
      return console.error(`Invalid scale configuration for scale: ${a}`);
    if (l._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${a}`);
    const u = kh(a, l, W$(a, e), It.scales[l.type]), d = F$(u, r), f = n.scales || {};
    o[a] = Ss(/* @__PURE__ */ Object.create(null), [
      {
        axis: u
      },
      l,
      f[u],
      f[d]
    ]);
  }), e.data.datasets.forEach((a) => {
    const l = a.type || e.type, u = a.indexAxis || xh(l, t), f = (Lo[l] || {}).scales || {};
    Object.keys(f).forEach((m) => {
      const h = R$(m, u), v = a[h + "AxisID"] || h;
      o[v] = o[v] || /* @__PURE__ */ Object.create(null), Ss(o[v], [
        {
          axis: h
        },
        i[v],
        f[m]
      ]);
    });
  }), Object.keys(o).forEach((a) => {
    const l = o[a];
    Ss(l, [
      It.scales[l.type],
      It.scale
    ]);
  }), o;
}
function qw(e) {
  const t = e.options || (e.options = {});
  t.plugins = et(t.plugins, {}), t.scales = z$(e, t);
}
function Gw(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function H$(e) {
  return e = e || {}, e.data = Gw(e.data), qw(e), e;
}
const b0 = /* @__PURE__ */ new Map(), Xw = /* @__PURE__ */ new Set();
function Su(e, t) {
  let n = b0.get(e);
  return n || (n = t(), b0.set(e, n), Xw.add(n)), n;
}
const gs = (e, t, n) => {
  const i = zs(t, n);
  i !== void 0 && e.add(i);
};
class j$ {
  constructor(t) {
    this._config = H$(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = Gw(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), qw(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return Su(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, n) {
    return Su(`${t}.transition.${n}`, () => [
      [
        `datasets.${t}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, n) {
    return Su(`${t}-${n}`, () => [
      [
        `datasets.${t}.elements.${n}`,
        `datasets.${t}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const n = t.id, i = this.type;
    return Su(`${i}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, n) {
    const i = this._scopeCache;
    let r = i.get(t);
    return (!r || n) && (r = /* @__PURE__ */ new Map(), i.set(t, r)), r;
  }
  getOptionScopes(t, n, i) {
    const { options: r, type: o } = this, a = this._cachedScopes(t, i), l = a.get(n);
    if (l)
      return l;
    const u = /* @__PURE__ */ new Set();
    n.forEach((f) => {
      t && (u.add(t), f.forEach((m) => gs(u, t, m))), f.forEach((m) => gs(u, r, m)), f.forEach((m) => gs(u, Lo[o] || {}, m)), f.forEach((m) => gs(u, It, m)), f.forEach((m) => gs(u, wh, m));
    });
    const d = Array.from(u);
    return d.length === 0 && d.push(/* @__PURE__ */ Object.create(null)), Xw.has(n) && a.set(n, d), d;
  }
  chartOptionScopes() {
    const { options: t, type: n } = this;
    return [
      t,
      Lo[n] || {},
      It.datasets[n] || {},
      {
        type: n
      },
      It,
      wh
    ];
  }
  resolveNamedOptions(t, n, i, r = [
    ""
  ]) {
    const o = {
      $shared: !0
    }, { resolver: a, subPrefixes: l } = w0(this._resolverCache, t, r);
    let u = a;
    if (U$(a, n)) {
      o.$shared = !1, i = qr(i) ? i() : i;
      const d = this.createResolver(t, i, l);
      u = Ma(a, i, d);
    }
    for (const d of n)
      o[d] = u[d];
    return o;
  }
  createResolver(t, n, i = [
    ""
  ], r) {
    const { resolver: o } = w0(this._resolverCache, t, i);
    return it(n) ? Ma(o, n, void 0, r) : o;
  }
}
function w0(e, t, n) {
  let i = e.get(t);
  i || (i = /* @__PURE__ */ new Map(), e.set(t, i));
  const r = n.join();
  let o = i.get(r);
  return o || (o = {
    resolver: Og(t, n),
    subPrefixes: n.filter((l) => !l.toLowerCase().includes("hover"))
  }, i.set(r, o)), o;
}
const Y$ = (e) => it(e) && Object.getOwnPropertyNames(e).some((t) => qr(e[t]));
function U$(e, t) {
  const { isScriptable: n, isIndexable: i } = Pw(e);
  for (const r of t) {
    const o = n(r), a = i(r), l = (a || o) && e[r];
    if (o && (qr(l) || Y$(l)) || a && Ct(l))
      return !0;
  }
  return !1;
}
var q$ = "4.4.3";
const G$ = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function _0(e, t) {
  return e === "top" || e === "bottom" || G$.indexOf(e) === -1 && t === "x";
}
function x0(e, t) {
  return function(n, i) {
    return n[e] === i[e] ? n[t] - i[t] : n[e] - i[e];
  };
}
function k0(e) {
  const t = e.chart, n = t.options.animation;
  t.notifyPlugins("afterRender"), vt(n && n.onComplete, [
    e
  ], t);
}
function X$(e) {
  const t = e.chart, n = t.options.animation;
  vt(n && n.onProgress, [
    e
  ], t);
}
function Kw(e) {
  return Pg() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
const Nu = {}, S0 = (e) => {
  const t = Kw(e);
  return Object.values(Nu).filter((n) => n.canvas === t).pop();
};
function K$(e, t, n) {
  const i = Object.keys(e);
  for (const r of i) {
    const o = +r;
    if (o >= t) {
      const a = e[r];
      delete e[r], (n > 0 || o > t) && (e[o + n] = a);
    }
  }
}
function Z$(e, t, n, i) {
  return !n || e.type === "mouseout" ? null : i ? t : e;
}
function Cu(e, t, n) {
  return e.options.clip ? e[n] : t[n];
}
function Q$(e, t) {
  const { xScale: n, yScale: i } = e;
  return n && i ? {
    left: Cu(n, t, "left"),
    right: Cu(n, t, "right"),
    top: Cu(i, t, "top"),
    bottom: Cu(i, t, "bottom")
  } : t;
}
var Dr;
let Bn = (Dr = class {
  static register(...t) {
    Di.add(...t), C0();
  }
  static unregister(...t) {
    Di.remove(...t), C0();
  }
  constructor(t, n) {
    const i = this.config = new j$(n), r = Kw(t), o = S0(r);
    if (o)
      throw new Error("Canvas is already in use. Chart with ID '" + o.id + "' must be destroyed before the canvas with ID '" + o.canvas.id + "' can be reused.");
    const a = i.createResolver(i.chartOptionScopes(), this.getContext());
    this.platform = new (i.platform || m$(r))(), this.platform.updateConfig(i);
    const l = this.platform.acquireContext(r, a.aspectRatio), u = l && l.canvas, d = u && u.height, f = u && u.width;
    if (this.id = lB(), this.ctx = l, this.canvas = u, this.width = f, this.height = d, this._options = a, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new D$(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = CB((m) => this.update(m), a.resizeDelay || 0), this._dataChanges = [], Nu[this.id] = this, !l || !u) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    nr.listen(this, "complete", k0), nr.listen(this, "progress", X$), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: n }, width: i, height: r, _aspectRatio: o } = this;
    return _t(t) ? n && o ? o : r ? i / r : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return Di;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : Xy(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return Uy(this.canvas, this.ctx), this;
  }
  stop() {
    return nr.stop(this), this;
  }
  resize(t, n) {
    nr.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: n
    } : this._resize(t, n);
  }
  _resize(t, n) {
    const i = this.options, r = this.canvas, o = i.maintainAspectRatio && this.aspectRatio, a = this.platform.getMaximumSize(r, t, n, o), l = i.devicePixelRatio || this.platform.getDevicePixelRatio(), u = this.width ? "resize" : "attach";
    this.width = a.width, this.height = a.height, this._aspectRatio = this.aspectRatio, Xy(this, l, !0) && (this.notifyPlugins("resize", {
      size: a
    }), vt(i.onResize, [
      this,
      a
    ], this), this.attached && this._doResize(u) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    dt(n, (i, r) => {
      i.id = r;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, n = t.scales, i = this.scales, r = Object.keys(i).reduce((a, l) => (a[l] = !1, a), {});
    let o = [];
    n && (o = o.concat(Object.keys(n).map((a) => {
      const l = n[a], u = kh(a, l), d = u === "r", f = u === "x";
      return {
        options: l,
        dposition: d ? "chartArea" : f ? "bottom" : "left",
        dtype: d ? "radialLinear" : f ? "category" : "linear"
      };
    }))), dt(o, (a) => {
      const l = a.options, u = l.id, d = kh(u, l), f = et(l.type, a.dtype);
      (l.position === void 0 || _0(l.position, d) !== _0(a.dposition)) && (l.position = a.dposition), r[u] = !0;
      let m = null;
      if (u in i && i[u].type === f)
        m = i[u];
      else {
        const h = Di.getScale(f);
        m = new h({
          id: u,
          type: f,
          ctx: this.ctx,
          chart: this
        }), i[m.id] = m;
      }
      m.init(l, t);
    }), dt(r, (a, l) => {
      a || delete i[l];
    }), dt(i, (a) => {
      Rr.configure(this, a, a.options), Rr.addBox(this, a);
    });
  }
  _updateMetasets() {
    const t = this._metasets, n = this.data.datasets.length, i = t.length;
    if (t.sort((r, o) => r.index - o.index), i > n) {
      for (let r = n; r < i; ++r)
        this._destroyDatasetMeta(r);
      t.splice(n, i - n);
    }
    this._sortedMetasets = t.slice(0).sort(x0("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: n } } = this;
    t.length > n.length && delete this._stacks, t.forEach((i, r) => {
      n.filter((o) => o === i._dataset).length === 0 && this._destroyDatasetMeta(r);
    });
  }
  buildOrUpdateControllers() {
    const t = [], n = this.data.datasets;
    let i, r;
    for (this._removeUnreferencedMetasets(), i = 0, r = n.length; i < r; i++) {
      const o = n[i];
      let a = this.getDatasetMeta(i);
      const l = o.type || this.config.type;
      if (a.type && a.type !== l && (this._destroyDatasetMeta(i), a = this.getDatasetMeta(i)), a.type = l, a.indexAxis = o.indexAxis || xh(l, this.options), a.order = o.order || 0, a.index = i, a.label = "" + o.label, a.visible = this.isDatasetVisible(i), a.controller)
        a.controller.updateIndex(i), a.controller.linkScales();
      else {
        const u = Di.getController(l), { datasetElementType: d, dataElementType: f } = It.datasets[l];
        Object.assign(u, {
          dataElementType: Di.getElement(f),
          datasetElementType: d && Di.getElement(d)
        }), a.controller = new u(this, i), t.push(a.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    dt(this.data.datasets, (t, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const n = this.config;
    n.update();
    const i = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), r = this._animationsDisabled = !i.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const o = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let a = 0;
    for (let d = 0, f = this.data.datasets.length; d < f; d++) {
      const { controller: m } = this.getDatasetMeta(d), h = !r && o.indexOf(m) === -1;
      m.buildOrUpdateElements(h), a = Math.max(+m.getMaxOverflow(), a);
    }
    a = this._minPadding = i.layout.autoPadding ? a : 0, this._updateLayout(a), r || dt(o, (d) => {
      d.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(x0("z", "_idx"));
    const { _active: l, _lastEvent: u } = this;
    u ? this._eventHandler(u, !0) : l.length && this._updateHoverStyles(l, l, !0), this.render();
  }
  _updateScales() {
    dt(this.scales, (t) => {
      Rr.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, n = new Set(Object.keys(this._listeners)), i = new Set(t.events);
    (!$y(n, i) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, n = this._getUniformDataChanges() || [];
    for (const { method: i, start: r, count: o } of n) {
      const a = i === "_removeElements" ? -o : o;
      K$(t, r, a);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, i = (o) => new Set(t.filter((a) => a[0] === o).map((a, l) => l + "," + a.splice(1).join(","))), r = i(0);
    for (let o = 1; o < n; o++)
      if (!$y(r, i(o)))
        return;
    return Array.from(r).map((o) => o.split(",")).map((o) => ({
      method: o[1],
      start: +o[2],
      count: +o[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    Rr.update(this, this.width, this.height, t);
    const n = this.chartArea, i = n.width <= 0 || n.height <= 0;
    this._layers = [], dt(this.boxes, (r) => {
      i && r.position === "chartArea" || (r.configure && r.configure(), this._layers.push(...r._layers()));
    }, this), this._layers.forEach((r, o) => {
      r._idx = o;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, i = this.data.datasets.length; n < i; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, i = this.data.datasets.length; n < i; ++n)
        this._updateDataset(n, qr(t) ? t({
          datasetIndex: n
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, n) {
    const i = this.getDatasetMeta(t), r = {
      meta: i,
      index: t,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", r) !== !1 && (i.controller._update(n), r.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", r));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (nr.has(this) ? this.attached && !nr.running(this) && nr.start(this) : (this.draw(), k0({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: i, height: r } = this._resizeBeforeDraw;
      this._resize(i, r), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (t = 0; t < n.length && n[t].z <= 0; ++t)
      n[t].draw(this.chartArea);
    for (this._drawDatasets(); t < n.length; ++t)
      n[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const n = this._sortedMetasets, i = [];
    let r, o;
    for (r = 0, o = n.length; r < o; ++r) {
      const a = n[r];
      (!t || a.visible) && i.push(a);
    }
    return i;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let n = t.length - 1; n >= 0; --n)
      this._drawDataset(t[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const n = this.ctx, i = t._clip, r = !i.disabled, o = Q$(t, this.chartArea), a = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", a) !== !1 && (r && Fc(n, {
      left: i.left === !1 ? 0 : o.left - i.left,
      right: i.right === !1 ? this.width : o.right + i.right,
      top: i.top === !1 ? 0 : o.top - i.top,
      bottom: i.bottom === !1 ? this.height : o.bottom + i.bottom
    }), t.controller.draw(), r && Nc(n), a.cancelable = !1, this.notifyPlugins("afterDatasetDraw", a));
  }
  isPointInArea(t) {
    return ar(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, n, i, r) {
    const o = GV.modes[n];
    return typeof o == "function" ? o(this, t, i, r) : [];
  }
  getDatasetMeta(t) {
    const n = this.data.datasets[t], i = this._metasets;
    let r = i.filter((o) => o && o._dataset === n).pop();
    return r || (r = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: t,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, i.push(r)), r;
  }
  getContext() {
    return this.$context || (this.$context = Jr(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const n = this.data.datasets[t];
    if (!n)
      return !1;
    const i = this.getDatasetMeta(t);
    return typeof i.hidden == "boolean" ? !i.hidden : !n.hidden;
  }
  setDatasetVisibility(t, n) {
    const i = this.getDatasetMeta(t);
    i.hidden = !n;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, n, i) {
    const r = i ? "show" : "hide", o = this.getDatasetMeta(t), a = o.controller._resolveAnimations(void 0, r);
    lc(n) ? (o.data[n].hidden = !i, this.update()) : (this.setDatasetVisibility(t, i), a.update(o, {
      visible: i
    }), this.update((l) => l.datasetIndex === t ? r : void 0));
  }
  hide(t, n) {
    this._updateVisibility(t, n, !1);
  }
  show(t, n) {
    this._updateVisibility(t, n, !0);
  }
  _destroyDatasetMeta(t) {
    const n = this._metasets[t];
    n && n.controller && n.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, n;
    for (this.stop(), nr.remove(this), t = 0, n = this.data.datasets.length; t < n; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: n } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), Uy(t, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete Nu[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, n = this.platform, i = (o, a) => {
      n.addEventListener(this, o, a), t[o] = a;
    }, r = (o, a, l) => {
      o.offsetX = a, o.offsetY = l, this._eventHandler(o);
    };
    dt(this.options.events, (o) => i(o, r));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, n = this.platform, i = (u, d) => {
      n.addEventListener(this, u, d), t[u] = d;
    }, r = (u, d) => {
      t[u] && (n.removeEventListener(this, u, d), delete t[u]);
    }, o = (u, d) => {
      this.canvas && this.resize(u, d);
    };
    let a;
    const l = () => {
      r("attach", l), this.attached = !0, this.resize(), i("resize", o), i("detach", a);
    };
    a = () => {
      this.attached = !1, r("resize", o), this._stop(), this._resize(0, 0), i("attach", l);
    }, n.isAttached(this.canvas) ? l() : a();
  }
  unbindEvents() {
    dt(this._listeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._listeners = {}, dt(this._responsiveListeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, n, i) {
    const r = i ? "set" : "remove";
    let o, a, l, u;
    for (n === "dataset" && (o = this.getDatasetMeta(t[0].datasetIndex), o.controller["_" + r + "DatasetHoverStyle"]()), l = 0, u = t.length; l < u; ++l) {
      a = t[l];
      const d = a && this.getDatasetMeta(a.datasetIndex).controller;
      d && d[r + "HoverStyle"](a.element, a.datasetIndex, a.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const n = this._active || [], i = t.map(({ datasetIndex: o, index: a }) => {
      const l = this.getDatasetMeta(o);
      if (!l)
        throw new Error("No dataset found at index " + o);
      return {
        datasetIndex: o,
        element: l.data[a],
        index: a
      };
    });
    !ac(i, n) && (this._active = i, this._lastEvent = null, this._updateHoverStyles(i, n));
  }
  notifyPlugins(t, n, i) {
    return this._plugins.notify(this, t, n, i);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((n) => n.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, n, i) {
    const r = this.options.hover, o = (u, d) => u.filter((f) => !d.some((m) => f.datasetIndex === m.datasetIndex && f.index === m.index)), a = o(n, t), l = i ? t : o(t, n);
    a.length && this.updateHoverStyle(a, r.mode, !1), l.length && r.mode && this.updateHoverStyle(l, r.mode, !0);
  }
  _eventHandler(t, n) {
    const i = {
      event: t,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, r = (a) => (a.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", i, r) === !1)
      return;
    const o = this._handleEvent(t, n, i.inChartArea);
    return i.cancelable = !1, this.notifyPlugins("afterEvent", i, r), (o || i.changed) && this.render(), this;
  }
  _handleEvent(t, n, i) {
    const { _active: r = [], options: o } = this, a = n, l = this._getActiveElements(t, r, i, a), u = gB(t), d = Z$(t, this._lastEvent, i, u);
    i && (this._lastEvent = null, vt(o.onHover, [
      t,
      l,
      this
    ], this), u && vt(o.onClick, [
      t,
      l,
      this
    ], this));
    const f = !ac(l, r);
    return (f || n) && (this._active = l, this._updateHoverStyles(l, r, n)), this._lastEvent = d, f;
  }
  _getActiveElements(t, n, i, r) {
    if (t.type === "mouseout")
      return [];
    if (!i)
      return n;
    const o = this.options.hover;
    return this.getElementsAtEventForMode(t, o.mode, o, r);
  }
}, ne(Dr, "defaults", It), ne(Dr, "instances", Nu), ne(Dr, "overrides", Lo), ne(Dr, "registry", Di), ne(Dr, "version", q$), ne(Dr, "getChart", S0), Dr);
function C0() {
  return dt(Bn.instances, (e) => e._plugins.invalidate());
}
function J$(e, t, n) {
  const { startAngle: i, pixelMargin: r, x: o, y: a, outerRadius: l, innerRadius: u } = t;
  let d = r / l;
  e.beginPath(), e.arc(o, a, l, i - d, n + d), u > r ? (d = r / u, e.arc(o, a, u, n + d, i - d, !0)) : e.arc(o, a, r, n + $t, i - $t), e.closePath(), e.clip();
}
function eR(e) {
  return Cg(e, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function tR(e, t, n, i) {
  const r = eR(e.options.borderRadius), o = (n - t) / 2, a = Math.min(o, i * t / 2), l = (u) => {
    const d = (n - Math.min(o, u)) * i / 2;
    return yn(u, 0, Math.min(o, d));
  };
  return {
    outerStart: l(r.outerStart),
    outerEnd: l(r.outerEnd),
    innerStart: yn(r.innerStart, 0, a),
    innerEnd: yn(r.innerEnd, 0, a)
  };
}
function ha(e, t, n, i) {
  return {
    x: n + e * Math.cos(t),
    y: i + e * Math.sin(t)
  };
}
function gc(e, t, n, i, r, o) {
  const { x: a, y: l, startAngle: u, pixelMargin: d, innerRadius: f } = t, m = Math.max(t.outerRadius + i + n - d, 0), h = f > 0 ? f + i + n + d : 0;
  let v = 0;
  const y = r - u;
  if (i) {
    const V = f > 0 ? f - i : 0, z = m > 0 ? m - i : 0, H = (V + z) / 2, W = H !== 0 ? y * H / (H + i) : y;
    v = (y - W) / 2;
  }
  const p = Math.max(1e-3, y * m - n / Dt) / m, b = (y - p) / 2, x = u + b + v, _ = r - b - v, { outerStart: O, outerEnd: D, innerStart: F, innerEnd: $ } = tR(t, h, m, _ - x), A = m - O, k = m - D, S = x + O / A, M = _ - D / k, E = h + F, I = h + $, L = x + F / E, N = _ - $ / I;
  if (e.beginPath(), o) {
    const V = (S + M) / 2;
    if (e.arc(a, l, m, S, V), e.arc(a, l, m, V, M), D > 0) {
      const j = ha(k, M, a, l);
      e.arc(j.x, j.y, D, M, _ + $t);
    }
    const z = ha(I, _, a, l);
    if (e.lineTo(z.x, z.y), $ > 0) {
      const j = ha(I, N, a, l);
      e.arc(j.x, j.y, $, _ + $t, N + Math.PI);
    }
    const H = (_ - $ / h + (x + F / h)) / 2;
    if (e.arc(a, l, h, _ - $ / h, H, !0), e.arc(a, l, h, H, x + F / h, !0), F > 0) {
      const j = ha(E, L, a, l);
      e.arc(j.x, j.y, F, L + Math.PI, x - $t);
    }
    const W = ha(A, x, a, l);
    if (e.lineTo(W.x, W.y), O > 0) {
      const j = ha(A, S, a, l);
      e.arc(j.x, j.y, O, x - $t, S);
    }
  } else {
    e.moveTo(a, l);
    const V = Math.cos(S) * m + a, z = Math.sin(S) * m + l;
    e.lineTo(V, z);
    const H = Math.cos(M) * m + a, W = Math.sin(M) * m + l;
    e.lineTo(H, W);
  }
  e.closePath();
}
function nR(e, t, n, i, r) {
  const { fullCircles: o, startAngle: a, circumference: l } = t;
  let u = t.endAngle;
  if (o) {
    gc(e, t, n, i, u, r);
    for (let d = 0; d < o; ++d)
      e.fill();
    isNaN(l) || (u = a + (l % xt || xt));
  }
  return gc(e, t, n, i, u, r), e.fill(), u;
}
function iR(e, t, n, i, r) {
  const { fullCircles: o, startAngle: a, circumference: l, options: u } = t, { borderWidth: d, borderJoinStyle: f, borderDash: m, borderDashOffset: h } = u, v = u.borderAlign === "inner";
  if (!d)
    return;
  e.setLineDash(m || []), e.lineDashOffset = h, v ? (e.lineWidth = d * 2, e.lineJoin = f || "round") : (e.lineWidth = d, e.lineJoin = f || "bevel");
  let y = t.endAngle;
  if (o) {
    gc(e, t, n, i, y, r);
    for (let p = 0; p < o; ++p)
      e.stroke();
    isNaN(l) || (y = a + (l % xt || xt));
  }
  v && J$(e, t, y), o || (gc(e, t, n, i, y, r), e.stroke());
}
class xs extends No {
  constructor(n) {
    super();
    ne(this, "circumference");
    ne(this, "endAngle");
    ne(this, "fullCircles");
    ne(this, "innerRadius");
    ne(this, "outerRadius");
    ne(this, "pixelMargin");
    ne(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, n && Object.assign(this, n);
  }
  inRange(n, i, r) {
    const o = this.getProps([
      "x",
      "y"
    ], r), { angle: a, distance: l } = xw(o, {
      x: n,
      y: i
    }), { startAngle: u, endAngle: d, innerRadius: f, outerRadius: m, circumference: h } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], r), v = (this.options.spacing + this.options.borderWidth) / 2, p = et(h, d - u) >= xt || js(a, u, d), b = To(l, f + v, m + v);
    return p && b;
  }
  getCenterPoint(n) {
    const { x: i, y: r, startAngle: o, endAngle: a, innerRadius: l, outerRadius: u } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], n), { offset: d, spacing: f } = this.options, m = (o + a) / 2, h = (l + u + f + d) / 2;
    return {
      x: i + Math.cos(m) * h,
      y: r + Math.sin(m) * h
    };
  }
  tooltipPosition(n) {
    return this.getCenterPoint(n);
  }
  draw(n) {
    const { options: i, circumference: r } = this, o = (i.offset || 0) / 4, a = (i.spacing || 0) / 2, l = i.circular;
    if (this.pixelMargin = i.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = r > xt ? Math.floor(r / xt) : 0, r === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    n.save();
    const u = (this.startAngle + this.endAngle) / 2;
    n.translate(Math.cos(u) * o, Math.sin(u) * o);
    const d = 1 - Math.sin(Math.min(Dt, r || 0)), f = o * d;
    n.fillStyle = i.backgroundColor, n.strokeStyle = i.borderColor, nR(n, this, f, a, l), iR(n, this, f, a, l), n.restore();
  }
}
ne(xs, "id", "arc"), ne(xs, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), ne(xs, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), ne(xs, "descriptors", {
  _scriptable: !0,
  _indexable: (n) => n !== "borderDash"
});
function Zw(e, t, n = t) {
  e.lineCap = et(n.borderCapStyle, t.borderCapStyle), e.setLineDash(et(n.borderDash, t.borderDash)), e.lineDashOffset = et(n.borderDashOffset, t.borderDashOffset), e.lineJoin = et(n.borderJoinStyle, t.borderJoinStyle), e.lineWidth = et(n.borderWidth, t.borderWidth), e.strokeStyle = et(n.borderColor, t.borderColor);
}
function rR(e, t, n) {
  e.lineTo(n.x, n.y);
}
function oR(e) {
  return e.stepped ? FB : e.tension || e.cubicInterpolationMode === "monotone" ? NB : rR;
}
function Qw(e, t, n = {}) {
  const i = e.length, { start: r = 0, end: o = i - 1 } = n, { start: a, end: l } = t, u = Math.max(r, a), d = Math.min(o, l), f = r < a && o < a || r > l && o > l;
  return {
    count: i,
    start: u,
    loop: t.loop,
    ilen: d < u && !f ? i + d - u : d - u
  };
}
function aR(e, t, n, i) {
  const { points: r, options: o } = t, { count: a, start: l, loop: u, ilen: d } = Qw(r, n, i), f = oR(o);
  let { move: m = !0, reverse: h } = i || {}, v, y, p;
  for (v = 0; v <= d; ++v)
    y = r[(l + (h ? d - v : v)) % a], !y.skip && (m ? (e.moveTo(y.x, y.y), m = !1) : f(e, p, y, h, o.stepped), p = y);
  return u && (y = r[(l + (h ? d : 0)) % a], f(e, p, y, h, o.stepped)), !!u;
}
function sR(e, t, n, i) {
  const r = t.points, { count: o, start: a, ilen: l } = Qw(r, n, i), { move: u = !0, reverse: d } = i || {};
  let f = 0, m = 0, h, v, y, p, b, x;
  const _ = (D) => (a + (d ? l - D : D)) % o, O = () => {
    p !== b && (e.lineTo(f, b), e.lineTo(f, p), e.lineTo(f, x));
  };
  for (u && (v = r[_(0)], e.moveTo(v.x, v.y)), h = 0; h <= l; ++h) {
    if (v = r[_(h)], v.skip)
      continue;
    const D = v.x, F = v.y, $ = D | 0;
    $ === y ? (F < p ? p = F : F > b && (b = F), f = (m * f + D) / ++m) : (O(), e.lineTo(D, F), y = $, m = 0, p = b = F), x = F;
  }
  O();
}
function Sh(e) {
  const t = e.options, n = t.borderDash && t.borderDash.length;
  return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !n ? sR : aR;
}
function lR(e) {
  return e.stepped ? bV : e.tension || e.cubicInterpolationMode === "monotone" ? wV : Oo;
}
function uR(e, t, n, i) {
  let r = t._path;
  r || (r = t._path = new Path2D(), t.path(r, n, i) && r.closePath()), Zw(e, t.options), e.stroke(r);
}
function cR(e, t, n, i) {
  const { segments: r, options: o } = t, a = Sh(t);
  for (const l of r)
    Zw(e, o, l.style), e.beginPath(), a(e, t, l, {
      start: n,
      end: n + i - 1
    }) && e.closePath(), e.stroke();
}
const dR = typeof Path2D == "function";
function fR(e, t, n, i) {
  dR && !t.options.segment ? uR(e, t, n, i) : cR(e, t, n, i);
}
class Fr extends No {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, n) {
    const i = this.options;
    if ((i.tension || i.cubicInterpolationMode === "monotone") && !i.stepped && !this._pointsUpdated) {
      const r = i.spanGaps ? this._loop : this._fullLoop;
      dV(this._points, i, t, r, n), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = OV(this, this.options.segment));
  }
  first() {
    const t = this.segments, n = this.points;
    return t.length && n[t[0].start];
  }
  last() {
    const t = this.segments, n = this.points, i = t.length;
    return i && n[t[i - 1].end];
  }
  interpolate(t, n) {
    const i = this.options, r = t[n], o = this.points, a = Rw(this, {
      property: n,
      start: r,
      end: r
    });
    if (!a.length)
      return;
    const l = [], u = lR(i);
    let d, f;
    for (d = 0, f = a.length; d < f; ++d) {
      const { start: m, end: h } = a[d], v = o[m], y = o[h];
      if (v === y) {
        l.push(v);
        continue;
      }
      const p = Math.abs((r - v[n]) / (y[n] - v[n])), b = u(v, y, p, i.stepped);
      b[n] = t[n], l.push(b);
    }
    return l.length === 1 ? l[0] : l;
  }
  pathSegment(t, n, i) {
    return Sh(this)(t, this, n, i);
  }
  path(t, n, i) {
    const r = this.segments, o = Sh(this);
    let a = this._loop;
    n = n || 0, i = i || this.points.length - n;
    for (const l of r)
      a &= o(t, this, l, {
        start: n,
        end: n + i - 1
      });
    return !!a;
  }
  draw(t, n, i, r) {
    const o = this.options || {};
    (this.points || []).length && o.borderWidth && (t.save(), fR(t, this, i, r), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
ne(Fr, "id", "line"), ne(Fr, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), ne(Fr, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), ne(Fr, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash" && t !== "fill"
});
function O0(e, t, n, i) {
  const r = e.options, { [n]: o } = e.getProps([
    n
  ], i);
  return Math.abs(t - o) < r.radius + r.hitRadius;
}
class Wu extends No {
  constructor(n) {
    super();
    ne(this, "parsed");
    ne(this, "skip");
    ne(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, n && Object.assign(this, n);
  }
  inRange(n, i, r) {
    const o = this.options, { x: a, y: l } = this.getProps([
      "x",
      "y"
    ], r);
    return Math.pow(n - a, 2) + Math.pow(i - l, 2) < Math.pow(o.hitRadius + o.radius, 2);
  }
  inXRange(n, i) {
    return O0(this, n, "x", i);
  }
  inYRange(n, i) {
    return O0(this, n, "y", i);
  }
  getCenterPoint(n) {
    const { x: i, y: r } = this.getProps([
      "x",
      "y"
    ], n);
    return {
      x: i,
      y: r
    };
  }
  size(n) {
    n = n || this.options || {};
    let i = n.radius || 0;
    i = Math.max(i, i && n.hoverRadius || 0);
    const r = i && n.borderWidth || 0;
    return (i + r) * 2;
  }
  draw(n, i) {
    const r = this.options;
    this.skip || r.radius < 0.1 || !ar(this, i, this.size(r) / 2) || (n.strokeStyle = r.borderColor, n.lineWidth = r.borderWidth, n.fillStyle = r.backgroundColor, _h(n, r, this.x, this.y));
  }
  getRange() {
    const n = this.options || {};
    return n.radius + n.hitRadius;
  }
}
ne(Wu, "id", "point"), /**
* @type {any}
*/
ne(Wu, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
ne(Wu, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function hR(e, t, n) {
  const i = e.segments, r = e.points, o = t.points, a = [];
  for (const l of i) {
    let { start: u, end: d } = l;
    d = Ig(u, d, r);
    const f = Ch(n, r[u], r[d], l.loop);
    if (!t.segments) {
      a.push({
        source: l,
        target: f,
        start: r[u],
        end: r[d]
      });
      continue;
    }
    const m = Rw(t, f);
    for (const h of m) {
      const v = Ch(n, o[h.start], o[h.end], h.loop), y = $w(l, r, v);
      for (const p of y)
        a.push({
          source: p,
          target: h,
          start: {
            [n]: M0(f, v, "start", Math.max)
          },
          end: {
            [n]: M0(f, v, "end", Math.min)
          }
        });
    }
  }
  return a;
}
function Ch(e, t, n, i) {
  if (i)
    return;
  let r = t[e], o = n[e];
  return e === "angle" && (r = Hn(r), o = Hn(o)), {
    property: e,
    start: r,
    end: o
  };
}
function gR(e, t) {
  const { x: n = null, y: i = null } = e || {}, r = t.points, o = [];
  return t.segments.forEach(({ start: a, end: l }) => {
    l = Ig(a, l, r);
    const u = r[a], d = r[l];
    i !== null ? (o.push({
      x: u.x,
      y: i
    }), o.push({
      x: d.x,
      y: i
    })) : n !== null && (o.push({
      x: n,
      y: u.y
    }), o.push({
      x: n,
      y: d.y
    }));
  }), o;
}
function Ig(e, t, n) {
  for (; t > e; t--) {
    const i = n[t];
    if (!isNaN(i.x) && !isNaN(i.y))
      break;
  }
  return t;
}
function M0(e, t, n, i) {
  return e && t ? i(e[n], t[n]) : e ? e[n] : t ? t[n] : 0;
}
function Jw(e, t) {
  let n = [], i = !1;
  return Ct(e) ? (i = !0, n = e) : n = gR(e, t), n.length ? new Fr({
    points: n,
    options: {
      tension: 0
    },
    _loop: i,
    _fullLoop: i
  }) : null;
}
function T0(e) {
  return e && e.fill !== !1;
}
function mR(e, t, n) {
  let r = e[t].fill;
  const o = [
    t
  ];
  let a;
  if (!n)
    return r;
  for (; r !== !1 && o.indexOf(r) === -1; ) {
    if (!Et(r))
      return r;
    if (a = e[r], !a)
      return !1;
    if (a.visible)
      return r;
    o.push(r), r = a.fill;
  }
  return !1;
}
function vR(e, t, n) {
  const i = wR(e);
  if (it(i))
    return isNaN(i.value) ? !1 : i;
  let r = parseFloat(i);
  return Et(r) && Math.floor(r) === r ? pR(i[0], t, r, n) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(i) >= 0 && i;
}
function pR(e, t, n, i) {
  return (e === "-" || e === "+") && (n = t + n), n === t || n < 0 || n >= i ? !1 : n;
}
function yR(e, t) {
  let n = null;
  return e === "start" ? n = t.bottom : e === "end" ? n = t.top : it(e) ? n = t.getPixelForValue(e.value) : t.getBasePixel && (n = t.getBasePixel()), n;
}
function bR(e, t, n) {
  let i;
  return e === "start" ? i = n : e === "end" ? i = t.options.reverse ? t.min : t.max : it(e) ? i = e.value : i = t.getBaseValue(), i;
}
function wR(e) {
  const t = e.options, n = t.fill;
  let i = et(n && n.target, n);
  return i === void 0 && (i = !!t.backgroundColor), i === !1 || i === null ? !1 : i === !0 ? "origin" : i;
}
function _R(e) {
  const { scale: t, index: n, line: i } = e, r = [], o = i.segments, a = i.points, l = xR(t, n);
  l.push(Jw({
    x: null,
    y: t.bottom
  }, i));
  for (let u = 0; u < o.length; u++) {
    const d = o[u];
    for (let f = d.start; f <= d.end; f++)
      kR(r, a[f], l);
  }
  return new Fr({
    points: r,
    options: {}
  });
}
function xR(e, t) {
  const n = [], i = e.getMatchingVisibleMetas("line");
  for (let r = 0; r < i.length; r++) {
    const o = i[r];
    if (o.index === t)
      break;
    o.hidden || n.unshift(o.dataset);
  }
  return n;
}
function kR(e, t, n) {
  const i = [];
  for (let r = 0; r < n.length; r++) {
    const o = n[r], { first: a, last: l, point: u } = SR(o, t, "x");
    if (!(!u || a && l)) {
      if (a)
        i.unshift(u);
      else if (e.push(u), !l)
        break;
    }
  }
  e.push(...i);
}
function SR(e, t, n) {
  const i = e.interpolate(t, n);
  if (!i)
    return {};
  const r = i[n], o = e.segments, a = e.points;
  let l = !1, u = !1;
  for (let d = 0; d < o.length; d++) {
    const f = o[d], m = a[f.start][n], h = a[f.end][n];
    if (To(r, m, h)) {
      l = r === m, u = r === h;
      break;
    }
  }
  return {
    first: l,
    last: u,
    point: i
  };
}
class e_ {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, n, i) {
    const { x: r, y: o, radius: a } = this;
    return n = n || {
      start: 0,
      end: xt
    }, t.arc(r, o, a, n.end, n.start, !0), !i.bounds;
  }
  interpolate(t) {
    const { x: n, y: i, radius: r } = this, o = t.angle;
    return {
      x: n + Math.cos(o) * r,
      y: i + Math.sin(o) * r,
      angle: o
    };
  }
}
function CR(e) {
  const { chart: t, fill: n, line: i } = e;
  if (Et(n))
    return OR(t, n);
  if (n === "stack")
    return _R(e);
  if (n === "shape")
    return !0;
  const r = MR(e);
  return r instanceof e_ ? r : Jw(r, i);
}
function OR(e, t) {
  const n = e.getDatasetMeta(t);
  return n && e.isDatasetVisible(t) ? n.dataset : null;
}
function MR(e) {
  return (e.scale || {}).getPointPositionForValue ? PR(e) : TR(e);
}
function TR(e) {
  const { scale: t = {}, fill: n } = e, i = yR(n, t);
  if (Et(i)) {
    const r = t.isHorizontal();
    return {
      x: r ? i : null,
      y: r ? null : i
    };
  }
  return null;
}
function PR(e) {
  const { scale: t, fill: n } = e, i = t.options, r = t.getLabels().length, o = i.reverse ? t.max : t.min, a = bR(n, t, o), l = [];
  if (i.grid.circular) {
    const u = t.getPointPositionForValue(0, o);
    return new e_({
      x: u.x,
      y: u.y,
      radius: t.getDistanceFromCenterForValue(a)
    });
  }
  for (let u = 0; u < r; ++u)
    l.push(t.getPointPositionForValue(u, a));
  return l;
}
function Yf(e, t, n) {
  const i = CR(t), { line: r, scale: o, axis: a } = t, l = r.options, u = l.fill, d = l.backgroundColor, { above: f = d, below: m = d } = u || {};
  i && r.points.length && (Fc(e, n), AR(e, {
    line: r,
    target: i,
    above: f,
    below: m,
    area: n,
    scale: o,
    axis: a
  }), Nc(e));
}
function AR(e, t) {
  const { line: n, target: i, above: r, below: o, area: a, scale: l } = t, u = n._loop ? "angle" : t.axis;
  e.save(), u === "x" && o !== r && (P0(e, i, a.top), A0(e, {
    line: n,
    target: i,
    color: r,
    scale: l,
    property: u
  }), e.restore(), e.save(), P0(e, i, a.bottom)), A0(e, {
    line: n,
    target: i,
    color: o,
    scale: l,
    property: u
  }), e.restore();
}
function P0(e, t, n) {
  const { segments: i, points: r } = t;
  let o = !0, a = !1;
  e.beginPath();
  for (const l of i) {
    const { start: u, end: d } = l, f = r[u], m = r[Ig(u, d, r)];
    o ? (e.moveTo(f.x, f.y), o = !1) : (e.lineTo(f.x, n), e.lineTo(f.x, f.y)), a = !!t.pathSegment(e, l, {
      move: a
    }), a ? e.closePath() : e.lineTo(m.x, n);
  }
  e.lineTo(t.first().x, n), e.closePath(), e.clip();
}
function A0(e, t) {
  const { line: n, target: i, property: r, color: o, scale: a } = t, l = hR(n, i, r);
  for (const { source: u, target: d, start: f, end: m } of l) {
    const { style: { backgroundColor: h = o } = {} } = u, v = i !== !0;
    e.save(), e.fillStyle = h, ER(e, a, v && Ch(r, f, m)), e.beginPath();
    const y = !!n.pathSegment(e, u);
    let p;
    if (v) {
      y ? e.closePath() : E0(e, i, m, r);
      const b = !!i.pathSegment(e, d, {
        move: y,
        reverse: !0
      });
      p = y && b, p || E0(e, i, f, r);
    }
    e.closePath(), e.fill(p ? "evenodd" : "nonzero"), e.restore();
  }
}
function ER(e, t, n) {
  const { top: i, bottom: r } = t.chart.chartArea, { property: o, start: a, end: l } = n || {};
  o === "x" && (e.beginPath(), e.rect(a, i, l - a, r - i), e.clip());
}
function E0(e, t, n, i) {
  const r = t.interpolate(n, i);
  r && e.lineTo(r.x, r.y);
}
var IR = {
  id: "filler",
  afterDatasetsUpdate(e, t, n) {
    const i = (e.data.datasets || []).length, r = [];
    let o, a, l, u;
    for (a = 0; a < i; ++a)
      o = e.getDatasetMeta(a), l = o.dataset, u = null, l && l.options && l instanceof Fr && (u = {
        visible: e.isDatasetVisible(a),
        index: a,
        fill: vR(l, a, i),
        chart: e,
        axis: o.controller.options.indexAxis,
        scale: o.vScale,
        line: l
      }), o.$filler = u, r.push(u);
    for (a = 0; a < i; ++a)
      u = r[a], !(!u || u.fill === !1) && (u.fill = mR(r, a, n.propagate));
  },
  beforeDraw(e, t, n) {
    const i = n.drawTime === "beforeDraw", r = e.getSortedVisibleDatasetMetas(), o = e.chartArea;
    for (let a = r.length - 1; a >= 0; --a) {
      const l = r[a].$filler;
      l && (l.line.updateControlPoints(o, l.axis), i && l.fill && Yf(e.ctx, l, o));
    }
  },
  beforeDatasetsDraw(e, t, n) {
    if (n.drawTime !== "beforeDatasetsDraw")
      return;
    const i = e.getSortedVisibleDatasetMetas();
    for (let r = i.length - 1; r >= 0; --r) {
      const o = i[r].$filler;
      T0(o) && Yf(e.ctx, o, e.chartArea);
    }
  },
  beforeDatasetDraw(e, t, n) {
    const i = t.meta.$filler;
    !T0(i) || n.drawTime !== "beforeDatasetDraw" || Yf(e.ctx, i, e.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const I0 = (e, t) => {
  let { boxHeight: n = t, boxWidth: i = t } = e;
  return e.usePointStyle && (n = Math.min(n, t), i = e.pointStyleWidth || Math.min(i, t)), {
    boxWidth: i,
    boxHeight: n,
    itemHeight: Math.max(t, n)
  };
}, DR = (e, t) => e !== null && t !== null && e.datasetIndex === t.datasetIndex && e.index === t.index;
class D0 extends No {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, n, i) {
    this.maxWidth = t, this.maxHeight = n, this._margins = i, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let n = vt(t.generateLabels, [
      this.chart
    ], this) || [];
    t.filter && (n = n.filter((i) => t.filter(i, this.chart.data))), t.sort && (n = n.sort((i, r) => t.sort(i, r, this.chart.data))), this.options.reverse && n.reverse(), this.legendItems = n;
  }
  fit() {
    const { options: t, ctx: n } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const i = t.labels, r = an(i.font), o = r.size, a = this._computeTitleHeight(), { boxWidth: l, itemHeight: u } = I0(i, o);
    let d, f;
    n.font = r.string, this.isHorizontal() ? (d = this.maxWidth, f = this._fitRows(a, o, l, u) + 10) : (f = this.maxHeight, d = this._fitCols(a, r, l, u) + 10), this.width = Math.min(d, t.maxWidth || this.maxWidth), this.height = Math.min(f, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, n, i, r) {
    const { ctx: o, maxWidth: a, options: { labels: { padding: l } } } = this, u = this.legendHitBoxes = [], d = this.lineWidths = [
      0
    ], f = r + l;
    let m = t;
    o.textAlign = "left", o.textBaseline = "middle";
    let h = -1, v = -f;
    return this.legendItems.forEach((y, p) => {
      const b = i + n / 2 + o.measureText(y.text).width;
      (p === 0 || d[d.length - 1] + b + 2 * l > a) && (m += f, d[d.length - (p > 0 ? 0 : 1)] = 0, v += f, h++), u[p] = {
        left: 0,
        top: v,
        row: h,
        width: b,
        height: r
      }, d[d.length - 1] += b + l;
    }), m;
  }
  _fitCols(t, n, i, r) {
    const { ctx: o, maxHeight: a, options: { labels: { padding: l } } } = this, u = this.legendHitBoxes = [], d = this.columnSizes = [], f = a - t;
    let m = l, h = 0, v = 0, y = 0, p = 0;
    return this.legendItems.forEach((b, x) => {
      const { itemWidth: _, itemHeight: O } = LR(i, n, o, b, r);
      x > 0 && v + O + 2 * l > f && (m += h + l, d.push({
        width: h,
        height: v
      }), y += h + l, p++, h = v = 0), u[x] = {
        left: y,
        top: v,
        col: p,
        width: _,
        height: O
      }, h = Math.max(h, _), v += O + l;
    }), m += h, d.push({
      width: h,
      height: v
    }), m;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: n, options: { align: i, labels: { padding: r }, rtl: o } } = this, a = ba(o, this.left, this.width);
    if (this.isHorizontal()) {
      let l = 0, u = Wn(i, this.left + r, this.right - this.lineWidths[l]);
      for (const d of n)
        l !== d.row && (l = d.row, u = Wn(i, this.left + r, this.right - this.lineWidths[l])), d.top += this.top + t + r, d.left = a.leftForLtr(a.x(u), d.width), u += d.width + r;
    } else {
      let l = 0, u = Wn(i, this.top + t + r, this.bottom - this.columnSizes[l].height);
      for (const d of n)
        d.col !== l && (l = d.col, u = Wn(i, this.top + t + r, this.bottom - this.columnSizes[l].height)), d.top = u, d.left += this.left + r, d.left = a.leftForLtr(a.x(d.left), d.width), u += d.height + r;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      Fc(t, this), this._draw(), Nc(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: n, lineWidths: i, ctx: r } = this, { align: o, labels: a } = t, l = It.color, u = ba(t.rtl, this.left, this.width), d = an(a.font), { padding: f } = a, m = d.size, h = m / 2;
    let v;
    this.drawTitle(), r.textAlign = u.textAlign("left"), r.textBaseline = "middle", r.lineWidth = 0.5, r.font = d.string;
    const { boxWidth: y, boxHeight: p, itemHeight: b } = I0(a, m), x = function($, A, k) {
      if (isNaN(y) || y <= 0 || isNaN(p) || p < 0)
        return;
      r.save();
      const S = et(k.lineWidth, 1);
      if (r.fillStyle = et(k.fillStyle, l), r.lineCap = et(k.lineCap, "butt"), r.lineDashOffset = et(k.lineDashOffset, 0), r.lineJoin = et(k.lineJoin, "miter"), r.lineWidth = S, r.strokeStyle = et(k.strokeStyle, l), r.setLineDash(et(k.lineDash, [])), a.usePointStyle) {
        const M = {
          radius: p * Math.SQRT2 / 2,
          pointStyle: k.pointStyle,
          rotation: k.rotation,
          borderWidth: S
        }, E = u.xPlus($, y / 2), I = A + h;
        Tw(r, M, E, I, a.pointStyleWidth && y);
      } else {
        const M = A + Math.max((m - p) / 2, 0), E = u.leftForLtr($, y), I = ya(k.borderRadius);
        r.beginPath(), Object.values(I).some((L) => L !== 0) ? dc(r, {
          x: E,
          y: M,
          w: y,
          h: p,
          radius: I
        }) : r.rect(E, M, y, p), r.fill(), S !== 0 && r.stroke();
      }
      r.restore();
    }, _ = function($, A, k) {
      Oa(r, k.text, $, A + b / 2, d, {
        strikethrough: k.hidden,
        textAlign: u.textAlign(k.textAlign)
      });
    }, O = this.isHorizontal(), D = this._computeTitleHeight();
    O ? v = {
      x: Wn(o, this.left + f, this.right - i[0]),
      y: this.top + f + D,
      line: 0
    } : v = {
      x: this.left + f,
      y: Wn(o, this.top + D + f, this.bottom - n[0].height),
      line: 0
    }, Lw(this.ctx, t.textDirection);
    const F = b + f;
    this.legendItems.forEach(($, A) => {
      r.strokeStyle = $.fontColor, r.fillStyle = $.fontColor;
      const k = r.measureText($.text).width, S = u.textAlign($.textAlign || ($.textAlign = a.textAlign)), M = y + h + k;
      let E = v.x, I = v.y;
      u.setWidth(this.width), O ? A > 0 && E + M + f > this.right && (I = v.y += F, v.line++, E = v.x = Wn(o, this.left + f, this.right - i[v.line])) : A > 0 && I + F > this.bottom && (E = v.x = E + n[v.line].width + f, v.line++, I = v.y = Wn(o, this.top + D + f, this.bottom - n[v.line].height));
      const L = u.x(E);
      if (x(L, I, $), E = OB(S, E + y + h, O ? E + M : this.right, t.rtl), _(u.x(E), I, $), O)
        v.x += M + f;
      else if (typeof $.text != "string") {
        const N = d.lineHeight;
        v.y += t_($, N) + f;
      } else
        v.y += F;
    }), Bw(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, n = t.title, i = an(n.font), r = bn(n.padding);
    if (!n.display)
      return;
    const o = ba(t.rtl, this.left, this.width), a = this.ctx, l = n.position, u = i.size / 2, d = r.top + u;
    let f, m = this.left, h = this.width;
    if (this.isHorizontal())
      h = Math.max(...this.lineWidths), f = this.top + d, m = Wn(t.align, m, this.right - h);
    else {
      const y = this.columnSizes.reduce((p, b) => Math.max(p, b.height), 0);
      f = d + Wn(t.align, this.top, this.bottom - y - t.labels.padding - this._computeTitleHeight());
    }
    const v = Wn(l, m, m + h);
    a.textAlign = o.textAlign(Ow(l)), a.textBaseline = "middle", a.strokeStyle = n.color, a.fillStyle = n.color, a.font = i.string, Oa(a, n.text, v, f, i);
  }
  _computeTitleHeight() {
    const t = this.options.title, n = an(t.font), i = bn(t.padding);
    return t.display ? n.lineHeight + i.height : 0;
  }
  _getLegendItemAt(t, n) {
    let i, r, o;
    if (To(t, this.left, this.right) && To(n, this.top, this.bottom)) {
      for (o = this.legendHitBoxes, i = 0; i < o.length; ++i)
        if (r = o[i], To(t, r.left, r.left + r.width) && To(n, r.top, r.top + r.height))
          return this.legendItems[i];
    }
    return null;
  }
  handleEvent(t) {
    const n = this.options;
    if (!$R(t.type, n))
      return;
    const i = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const r = this._hoveredItem, o = DR(r, i);
      r && !o && vt(n.onLeave, [
        t,
        r,
        this
      ], this), this._hoveredItem = i, i && !o && vt(n.onHover, [
        t,
        i,
        this
      ], this);
    } else
      i && vt(n.onClick, [
        t,
        i,
        this
      ], this);
  }
}
function LR(e, t, n, i, r) {
  const o = BR(i, e, t, n), a = VR(r, i, t.lineHeight);
  return {
    itemWidth: o,
    itemHeight: a
  };
}
function BR(e, t, n, i) {
  let r = e.text;
  return r && typeof r != "string" && (r = r.reduce((o, a) => o.length > a.length ? o : a)), t + n.size / 2 + i.measureText(r).width;
}
function VR(e, t, n) {
  let i = e;
  return typeof t.text != "string" && (i = t_(t, n)), i;
}
function t_(e, t) {
  const n = e.text ? e.text.length : 0;
  return t * n;
}
function $R(e, t) {
  return !!((e === "mousemove" || e === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (e === "click" || e === "mouseup"));
}
var RR = {
  id: "legend",
  _element: D0,
  start(e, t, n) {
    const i = e.legend = new D0({
      ctx: e.ctx,
      options: n,
      chart: e
    });
    Rr.configure(e, i, n), Rr.addBox(e, i);
  },
  stop(e) {
    Rr.removeBox(e, e.legend), delete e.legend;
  },
  beforeUpdate(e, t, n) {
    const i = e.legend;
    Rr.configure(e, i, n), i.options = n;
  },
  afterUpdate(e) {
    const t = e.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(e, t) {
    t.replay || e.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(e, t, n) {
      const i = t.datasetIndex, r = n.chart;
      r.isDatasetVisible(i) ? (r.hide(i), t.hidden = !0) : (r.show(i), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (e) => e.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(e) {
        const t = e.data.datasets, { labels: { usePointStyle: n, pointStyle: i, textAlign: r, color: o, useBorderRadius: a, borderRadius: l } } = e.legend.options;
        return e._getSortedDatasetMetas().map((u) => {
          const d = u.controller.getStyle(n ? 0 : void 0), f = bn(d.borderWidth);
          return {
            text: t[u.index].label,
            fillStyle: d.backgroundColor,
            fontColor: o,
            hidden: !u.visible,
            lineCap: d.borderCapStyle,
            lineDash: d.borderDash,
            lineDashOffset: d.borderDashOffset,
            lineJoin: d.borderJoinStyle,
            lineWidth: (f.width + f.height) / 4,
            strokeStyle: d.borderColor,
            pointStyle: i || d.pointStyle,
            rotation: d.rotation,
            textAlign: r || d.textAlign,
            borderRadius: a && (l || d.borderRadius),
            datasetIndex: u.index
          };
        }, this);
      }
    },
    title: {
      color: (e) => e.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (e) => !e.startsWith("on"),
    labels: {
      _scriptable: (e) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(e)
    }
  }
};
const ks = {
  average(e) {
    if (!e.length)
      return !1;
    let t, n, i = /* @__PURE__ */ new Set(), r = 0, o = 0;
    for (t = 0, n = e.length; t < n; ++t) {
      const l = e[t].element;
      if (l && l.hasValue()) {
        const u = l.tooltipPosition();
        i.add(u.x), r += u.y, ++o;
      }
    }
    return {
      x: [
        ...i
      ].reduce((l, u) => l + u) / i.size,
      y: r / o
    };
  },
  nearest(e, t) {
    if (!e.length)
      return !1;
    let n = t.x, i = t.y, r = Number.POSITIVE_INFINITY, o, a, l;
    for (o = 0, a = e.length; o < a; ++o) {
      const u = e[o].element;
      if (u && u.hasValue()) {
        const d = u.getCenterPoint(), f = bh(t, d);
        f < r && (r = f, l = u);
      }
    }
    if (l) {
      const u = l.tooltipPosition();
      n = u.x, i = u.y;
    }
    return {
      x: n,
      y: i
    };
  }
};
function Ii(e, t) {
  return t && (Ct(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
function ir(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
function FR(e, t) {
  const { element: n, datasetIndex: i, index: r } = t, o = e.getDatasetMeta(i).controller, { label: a, value: l } = o.getLabelAndValue(r);
  return {
    chart: e,
    label: a,
    parsed: o.getParsed(r),
    raw: e.data.datasets[i].data[r],
    formattedValue: l,
    dataset: o.getDataset(),
    dataIndex: r,
    datasetIndex: i,
    element: n
  };
}
function L0(e, t) {
  const n = e.chart.ctx, { body: i, footer: r, title: o } = e, { boxWidth: a, boxHeight: l } = t, u = an(t.bodyFont), d = an(t.titleFont), f = an(t.footerFont), m = o.length, h = r.length, v = i.length, y = bn(t.padding);
  let p = y.height, b = 0, x = i.reduce((D, F) => D + F.before.length + F.lines.length + F.after.length, 0);
  if (x += e.beforeBody.length + e.afterBody.length, m && (p += m * d.lineHeight + (m - 1) * t.titleSpacing + t.titleMarginBottom), x) {
    const D = t.displayColors ? Math.max(l, u.lineHeight) : u.lineHeight;
    p += v * D + (x - v) * u.lineHeight + (x - 1) * t.bodySpacing;
  }
  h && (p += t.footerMarginTop + h * f.lineHeight + (h - 1) * t.footerSpacing);
  let _ = 0;
  const O = function(D) {
    b = Math.max(b, n.measureText(D).width + _);
  };
  return n.save(), n.font = d.string, dt(e.title, O), n.font = u.string, dt(e.beforeBody.concat(e.afterBody), O), _ = t.displayColors ? a + 2 + t.boxPadding : 0, dt(i, (D) => {
    dt(D.before, O), dt(D.lines, O), dt(D.after, O);
  }), _ = 0, n.font = f.string, dt(e.footer, O), n.restore(), b += y.width, {
    width: b,
    height: p
  };
}
function NR(e, t) {
  const { y: n, height: i } = t;
  return n < i / 2 ? "top" : n > e.height - i / 2 ? "bottom" : "center";
}
function WR(e, t, n, i) {
  const { x: r, width: o } = i, a = n.caretSize + n.caretPadding;
  if (e === "left" && r + o + a > t.width || e === "right" && r - o - a < 0)
    return !0;
}
function zR(e, t, n, i) {
  const { x: r, width: o } = n, { width: a, chartArea: { left: l, right: u } } = e;
  let d = "center";
  return i === "center" ? d = r <= (l + u) / 2 ? "left" : "right" : r <= o / 2 ? d = "left" : r >= a - o / 2 && (d = "right"), WR(d, e, t, n) && (d = "center"), d;
}
function B0(e, t, n) {
  const i = n.yAlign || t.yAlign || NR(e, n);
  return {
    xAlign: n.xAlign || t.xAlign || zR(e, t, n, i),
    yAlign: i
  };
}
function HR(e, t) {
  let { x: n, width: i } = e;
  return t === "right" ? n -= i : t === "center" && (n -= i / 2), n;
}
function jR(e, t, n) {
  let { y: i, height: r } = e;
  return t === "top" ? i += n : t === "bottom" ? i -= r + n : i -= r / 2, i;
}
function V0(e, t, n, i) {
  const { caretSize: r, caretPadding: o, cornerRadius: a } = e, { xAlign: l, yAlign: u } = n, d = r + o, { topLeft: f, topRight: m, bottomLeft: h, bottomRight: v } = ya(a);
  let y = HR(t, l);
  const p = jR(t, u, d);
  return u === "center" ? l === "left" ? y += d : l === "right" && (y -= d) : l === "left" ? y -= Math.max(f, h) + r : l === "right" && (y += Math.max(m, v) + r), {
    x: yn(y, 0, i.width - t.width),
    y: yn(p, 0, i.height - t.height)
  };
}
function Ou(e, t, n) {
  const i = bn(n.padding);
  return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - i.right : e.x + i.left;
}
function $0(e) {
  return Ii([], ir(e));
}
function YR(e, t, n) {
  return Jr(e, {
    tooltip: t,
    tooltipItems: n,
    type: "tooltip"
  });
}
function R0(e, t) {
  const n = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return n ? e.override(n) : e;
}
const n_ = {
  beforeTitle: tr,
  title(e) {
    if (e.length > 0) {
      const t = e[0], n = t.chart.data.labels, i = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (i > 0 && t.dataIndex < i)
        return n[t.dataIndex];
    }
    return "";
  },
  afterTitle: tr,
  beforeBody: tr,
  beforeLabel: tr,
  label(e) {
    if (this && this.options && this.options.mode === "dataset")
      return e.label + ": " + e.formattedValue || e.formattedValue;
    let t = e.dataset.label || "";
    t && (t += ": ");
    const n = e.formattedValue;
    return _t(n) || (t += n), t;
  },
  labelColor(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: tr,
  afterBody: tr,
  beforeFooter: tr,
  footer: tr,
  afterFooter: tr
};
function Pn(e, t, n, i) {
  const r = e[t].call(n, i);
  return typeof r > "u" ? n_[t].call(n, i) : r;
}
class Oh extends No {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const n = this.chart, i = this.options.setContext(this.getContext()), r = i.enabled && n.options.animation && i.animations, o = new Fw(this.chart, r);
    return r._cacheable && (this._cachedAnimations = Object.freeze(o)), o;
  }
  getContext() {
    return this.$context || (this.$context = YR(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, n) {
    const { callbacks: i } = n, r = Pn(i, "beforeTitle", this, t), o = Pn(i, "title", this, t), a = Pn(i, "afterTitle", this, t);
    let l = [];
    return l = Ii(l, ir(r)), l = Ii(l, ir(o)), l = Ii(l, ir(a)), l;
  }
  getBeforeBody(t, n) {
    return $0(Pn(n.callbacks, "beforeBody", this, t));
  }
  getBody(t, n) {
    const { callbacks: i } = n, r = [];
    return dt(t, (o) => {
      const a = {
        before: [],
        lines: [],
        after: []
      }, l = R0(i, o);
      Ii(a.before, ir(Pn(l, "beforeLabel", this, o))), Ii(a.lines, Pn(l, "label", this, o)), Ii(a.after, ir(Pn(l, "afterLabel", this, o))), r.push(a);
    }), r;
  }
  getAfterBody(t, n) {
    return $0(Pn(n.callbacks, "afterBody", this, t));
  }
  getFooter(t, n) {
    const { callbacks: i } = n, r = Pn(i, "beforeFooter", this, t), o = Pn(i, "footer", this, t), a = Pn(i, "afterFooter", this, t);
    let l = [];
    return l = Ii(l, ir(r)), l = Ii(l, ir(o)), l = Ii(l, ir(a)), l;
  }
  _createItems(t) {
    const n = this._active, i = this.chart.data, r = [], o = [], a = [];
    let l = [], u, d;
    for (u = 0, d = n.length; u < d; ++u)
      l.push(FR(this.chart, n[u]));
    return t.filter && (l = l.filter((f, m, h) => t.filter(f, m, h, i))), t.itemSort && (l = l.sort((f, m) => t.itemSort(f, m, i))), dt(l, (f) => {
      const m = R0(t.callbacks, f);
      r.push(Pn(m, "labelColor", this, f)), o.push(Pn(m, "labelPointStyle", this, f)), a.push(Pn(m, "labelTextColor", this, f));
    }), this.labelColors = r, this.labelPointStyles = o, this.labelTextColors = a, this.dataPoints = l, l;
  }
  update(t, n) {
    const i = this.options.setContext(this.getContext()), r = this._active;
    let o, a = [];
    if (!r.length)
      this.opacity !== 0 && (o = {
        opacity: 0
      });
    else {
      const l = ks[i.position].call(this, r, this._eventPosition);
      a = this._createItems(i), this.title = this.getTitle(a, i), this.beforeBody = this.getBeforeBody(a, i), this.body = this.getBody(a, i), this.afterBody = this.getAfterBody(a, i), this.footer = this.getFooter(a, i);
      const u = this._size = L0(this, i), d = Object.assign({}, l, u), f = B0(this.chart, i, d), m = V0(i, d, f, this.chart);
      this.xAlign = f.xAlign, this.yAlign = f.yAlign, o = {
        opacity: 1,
        x: m.x,
        y: m.y,
        width: u.width,
        height: u.height,
        caretX: l.x,
        caretY: l.y
      };
    }
    this._tooltipItems = a, this.$context = void 0, o && this._resolveAnimations().update(this, o), t && i.external && i.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(t, n, i, r) {
    const o = this.getCaretPosition(t, i, r);
    n.lineTo(o.x1, o.y1), n.lineTo(o.x2, o.y2), n.lineTo(o.x3, o.y3);
  }
  getCaretPosition(t, n, i) {
    const { xAlign: r, yAlign: o } = this, { caretSize: a, cornerRadius: l } = i, { topLeft: u, topRight: d, bottomLeft: f, bottomRight: m } = ya(l), { x: h, y: v } = t, { width: y, height: p } = n;
    let b, x, _, O, D, F;
    return o === "center" ? (D = v + p / 2, r === "left" ? (b = h, x = b - a, O = D + a, F = D - a) : (b = h + y, x = b + a, O = D - a, F = D + a), _ = b) : (r === "left" ? x = h + Math.max(u, f) + a : r === "right" ? x = h + y - Math.max(d, m) - a : x = this.caretX, o === "top" ? (O = v, D = O - a, b = x - a, _ = x + a) : (O = v + p, D = O + a, b = x + a, _ = x - a), F = O), {
      x1: b,
      x2: x,
      x3: _,
      y1: O,
      y2: D,
      y3: F
    };
  }
  drawTitle(t, n, i) {
    const r = this.title, o = r.length;
    let a, l, u;
    if (o) {
      const d = ba(i.rtl, this.x, this.width);
      for (t.x = Ou(this, i.titleAlign, i), n.textAlign = d.textAlign(i.titleAlign), n.textBaseline = "middle", a = an(i.titleFont), l = i.titleSpacing, n.fillStyle = i.titleColor, n.font = a.string, u = 0; u < o; ++u)
        n.fillText(r[u], d.x(t.x), t.y + a.lineHeight / 2), t.y += a.lineHeight + l, u + 1 === o && (t.y += i.titleMarginBottom - l);
    }
  }
  _drawColorBox(t, n, i, r, o) {
    const a = this.labelColors[i], l = this.labelPointStyles[i], { boxHeight: u, boxWidth: d } = o, f = an(o.bodyFont), m = Ou(this, "left", o), h = r.x(m), v = u < f.lineHeight ? (f.lineHeight - u) / 2 : 0, y = n.y + v;
    if (o.usePointStyle) {
      const p = {
        radius: Math.min(d, u) / 2,
        pointStyle: l.pointStyle,
        rotation: l.rotation,
        borderWidth: 1
      }, b = r.leftForLtr(h, d) + d / 2, x = y + u / 2;
      t.strokeStyle = o.multiKeyBackground, t.fillStyle = o.multiKeyBackground, _h(t, p, b, x), t.strokeStyle = a.borderColor, t.fillStyle = a.backgroundColor, _h(t, p, b, x);
    } else {
      t.lineWidth = it(a.borderWidth) ? Math.max(...Object.values(a.borderWidth)) : a.borderWidth || 1, t.strokeStyle = a.borderColor, t.setLineDash(a.borderDash || []), t.lineDashOffset = a.borderDashOffset || 0;
      const p = r.leftForLtr(h, d), b = r.leftForLtr(r.xPlus(h, 1), d - 2), x = ya(a.borderRadius);
      Object.values(x).some((_) => _ !== 0) ? (t.beginPath(), t.fillStyle = o.multiKeyBackground, dc(t, {
        x: p,
        y,
        w: d,
        h: u,
        radius: x
      }), t.fill(), t.stroke(), t.fillStyle = a.backgroundColor, t.beginPath(), dc(t, {
        x: b,
        y: y + 1,
        w: d - 2,
        h: u - 2,
        radius: x
      }), t.fill()) : (t.fillStyle = o.multiKeyBackground, t.fillRect(p, y, d, u), t.strokeRect(p, y, d, u), t.fillStyle = a.backgroundColor, t.fillRect(b, y + 1, d - 2, u - 2));
    }
    t.fillStyle = this.labelTextColors[i];
  }
  drawBody(t, n, i) {
    const { body: r } = this, { bodySpacing: o, bodyAlign: a, displayColors: l, boxHeight: u, boxWidth: d, boxPadding: f } = i, m = an(i.bodyFont);
    let h = m.lineHeight, v = 0;
    const y = ba(i.rtl, this.x, this.width), p = function(k) {
      n.fillText(k, y.x(t.x + v), t.y + h / 2), t.y += h + o;
    }, b = y.textAlign(a);
    let x, _, O, D, F, $, A;
    for (n.textAlign = a, n.textBaseline = "middle", n.font = m.string, t.x = Ou(this, b, i), n.fillStyle = i.bodyColor, dt(this.beforeBody, p), v = l && b !== "right" ? a === "center" ? d / 2 + f : d + 2 + f : 0, D = 0, $ = r.length; D < $; ++D) {
      for (x = r[D], _ = this.labelTextColors[D], n.fillStyle = _, dt(x.before, p), O = x.lines, l && O.length && (this._drawColorBox(n, t, D, y, i), h = Math.max(m.lineHeight, u)), F = 0, A = O.length; F < A; ++F)
        p(O[F]), h = m.lineHeight;
      dt(x.after, p);
    }
    v = 0, h = m.lineHeight, dt(this.afterBody, p), t.y -= o;
  }
  drawFooter(t, n, i) {
    const r = this.footer, o = r.length;
    let a, l;
    if (o) {
      const u = ba(i.rtl, this.x, this.width);
      for (t.x = Ou(this, i.footerAlign, i), t.y += i.footerMarginTop, n.textAlign = u.textAlign(i.footerAlign), n.textBaseline = "middle", a = an(i.footerFont), n.fillStyle = i.footerColor, n.font = a.string, l = 0; l < o; ++l)
        n.fillText(r[l], u.x(t.x), t.y + a.lineHeight / 2), t.y += a.lineHeight + i.footerSpacing;
    }
  }
  drawBackground(t, n, i, r) {
    const { xAlign: o, yAlign: a } = this, { x: l, y: u } = t, { width: d, height: f } = i, { topLeft: m, topRight: h, bottomLeft: v, bottomRight: y } = ya(r.cornerRadius);
    n.fillStyle = r.backgroundColor, n.strokeStyle = r.borderColor, n.lineWidth = r.borderWidth, n.beginPath(), n.moveTo(l + m, u), a === "top" && this.drawCaret(t, n, i, r), n.lineTo(l + d - h, u), n.quadraticCurveTo(l + d, u, l + d, u + h), a === "center" && o === "right" && this.drawCaret(t, n, i, r), n.lineTo(l + d, u + f - y), n.quadraticCurveTo(l + d, u + f, l + d - y, u + f), a === "bottom" && this.drawCaret(t, n, i, r), n.lineTo(l + v, u + f), n.quadraticCurveTo(l, u + f, l, u + f - v), a === "center" && o === "left" && this.drawCaret(t, n, i, r), n.lineTo(l, u + m), n.quadraticCurveTo(l, u, l + m, u), n.closePath(), n.fill(), r.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(t) {
    const n = this.chart, i = this.$animations, r = i && i.x, o = i && i.y;
    if (r || o) {
      const a = ks[t.position].call(this, this._active, this._eventPosition);
      if (!a)
        return;
      const l = this._size = L0(this, t), u = Object.assign({}, a, this._size), d = B0(n, t, u), f = V0(t, u, d, n);
      (r._to !== f.x || o._to !== f.y) && (this.xAlign = d.xAlign, this.yAlign = d.yAlign, this.width = l.width, this.height = l.height, this.caretX = a.x, this.caretY = a.y, this._resolveAnimations().update(this, f));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const n = this.options.setContext(this.getContext());
    let i = this.opacity;
    if (!i)
      return;
    this._updateAnimationTarget(n);
    const r = {
      width: this.width,
      height: this.height
    }, o = {
      x: this.x,
      y: this.y
    };
    i = Math.abs(i) < 1e-3 ? 0 : i;
    const a = bn(n.padding), l = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && l && (t.save(), t.globalAlpha = i, this.drawBackground(o, t, r, n), Lw(t, n.textDirection), o.y += a.top, this.drawTitle(o, t, n), this.drawBody(o, t, n), this.drawFooter(o, t, n), Bw(t, n.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, n) {
    const i = this._active, r = t.map(({ datasetIndex: l, index: u }) => {
      const d = this.chart.getDatasetMeta(l);
      if (!d)
        throw new Error("Cannot find a dataset at index " + l);
      return {
        datasetIndex: l,
        element: d.data[u],
        index: u
      };
    }), o = !ac(i, r), a = this._positionChanged(r, n);
    (o || a) && (this._active = r, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, n, i = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const r = this.options, o = this._active || [], a = this._getActiveElements(t, o, n, i), l = this._positionChanged(a, t), u = n || !ac(a, o) || l;
    return u && (this._active = a, (r.enabled || r.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, n))), u;
  }
  _getActiveElements(t, n, i, r) {
    const o = this.options;
    if (t.type === "mouseout")
      return [];
    if (!r)
      return n.filter((l) => this.chart.data.datasets[l.datasetIndex] && this.chart.getDatasetMeta(l.datasetIndex).controller.getParsed(l.index) !== void 0);
    const a = this.chart.getElementsAtEventForMode(t, o.mode, o, i);
    return o.reverse && a.reverse(), a;
  }
  _positionChanged(t, n) {
    const { caretX: i, caretY: r, options: o } = this, a = ks[o.position].call(this, t, n);
    return a !== !1 && (i !== a.x || r !== a.y);
  }
}
ne(Oh, "positioners", ks);
var UR = {
  id: "tooltip",
  _element: Oh,
  positioners: ks,
  afterInit(e, t, n) {
    n && (e.tooltip = new Oh({
      chart: e,
      options: n
    }));
  },
  beforeUpdate(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  reset(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  afterDraw(e) {
    const t = e.tooltip;
    if (t && t._willRender()) {
      const n = {
        tooltip: t
      };
      if (e.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(e, t) {
    if (e.tooltip) {
      const n = t.replay;
      e.tooltip.handleEvent(t.event, n, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (e, t) => t.bodyFont.size,
    boxWidth: (e, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: n_
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const qR = (e, t, n, i) => (typeof t == "string" ? (n = e.push(t) - 1, i.unshift({
  index: n,
  label: t
})) : isNaN(t) && (n = null), n);
function GR(e, t, n, i) {
  const r = e.indexOf(t);
  if (r === -1)
    return qR(e, t, n, i);
  const o = e.lastIndexOf(t);
  return r !== o ? n : r;
}
const XR = (e, t) => e === null ? null : yn(Math.round(e), 0, t);
function F0(e) {
  const t = this.getLabels();
  return e >= 0 && e < t.length ? t[e] : e;
}
class Mh extends Wo {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const n = this._addedLabels;
    if (n.length) {
      const i = this.getLabels();
      for (const { index: r, label: o } of n)
        i[r] === o && i.splice(r, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, n) {
    if (_t(t))
      return null;
    const i = this.getLabels();
    return n = isFinite(n) && i[n] === t ? n : GR(i, t, et(n, t), this._addedLabels), XR(n, i.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let { min: i, max: r } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (i = 0), n || (r = this.getLabels().length - 1)), this.min = i, this.max = r;
  }
  buildTicks() {
    const t = this.min, n = this.max, i = this.options.offset, r = [];
    let o = this.getLabels();
    o = t === 0 && n === o.length - 1 ? o : o.slice(t, n + 1), this._valueRange = Math.max(o.length - (i ? 0 : 1), 1), this._startValue = this.min - (i ? 0.5 : 0);
    for (let a = t; a <= n; a++)
      r.push({
        value: a
      });
    return r;
  }
  getLabelForValue(t) {
    return F0.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
ne(Mh, "id", "category"), ne(Mh, "defaults", {
  ticks: {
    callback: F0
  }
});
function KR(e, t) {
  const n = [], { bounds: r, step: o, min: a, max: l, precision: u, count: d, maxTicks: f, maxDigits: m, includeBounds: h } = e, v = o || 1, y = f - 1, { min: p, max: b } = t, x = !_t(a), _ = !_t(l), O = !_t(d), D = (b - p) / (m + 1);
  let F = Fy((b - p) / y / v) * v, $, A, k, S;
  if (F < 1e-14 && !x && !_)
    return [
      {
        value: p
      },
      {
        value: b
      }
    ];
  S = Math.ceil(b / F) - Math.floor(p / F), S > y && (F = Fy(S * F / y / v) * v), _t(u) || ($ = Math.pow(10, u), F = Math.ceil(F * $) / $), r === "ticks" ? (A = Math.floor(p / F) * F, k = Math.ceil(b / F) * F) : (A = p, k = b), x && _ && o && yB((l - a) / o, F / 1e3) ? (S = Math.round(Math.min((l - a) / F, f)), F = (l - a) / S, A = a, k = l) : O ? (A = x ? a : A, k = _ ? l : k, S = d - 1, F = (k - A) / S) : (S = (k - A) / F, Cs(S, Math.round(S), F / 1e3) ? S = Math.round(S) : S = Math.ceil(S));
  const M = Math.max(Ny(F), Ny(A));
  $ = Math.pow(10, _t(u) ? M : u), A = Math.round(A * $) / $, k = Math.round(k * $) / $;
  let E = 0;
  for (x && (h && A !== a ? (n.push({
    value: a
  }), A < a && E++, Cs(Math.round((A + E * F) * $) / $, a, N0(a, D, e)) && E++) : A < a && E++); E < S; ++E) {
    const I = Math.round((A + E * F) * $) / $;
    if (_ && I > l)
      break;
    n.push({
      value: I
    });
  }
  return _ && h && k !== l ? n.length && Cs(n[n.length - 1].value, l, N0(l, D, e)) ? n[n.length - 1].value = l : n.push({
    value: l
  }) : (!_ || k === l) && n.push({
    value: k
  }), n;
}
function N0(e, t, { horizontal: n, minRotation: i }) {
  const r = $i(i), o = (n ? Math.sin(r) : Math.cos(r)) || 1e-3, a = 0.75 * t * ("" + e).length;
  return Math.min(t / o, a);
}
class mc extends Wo {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    return _t(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: n, maxDefined: i } = this.getUserBounds();
    let { min: r, max: o } = this;
    const a = (u) => r = n ? r : u, l = (u) => o = i ? o : u;
    if (t) {
      const u = Ca(r), d = Ca(o);
      u < 0 && d < 0 ? l(0) : u > 0 && d > 0 && a(0);
    }
    if (r === o) {
      let u = o === 0 ? 1 : Math.abs(o * 0.05);
      l(o + u), t || a(r - u);
    }
    this.min = r, this.max = o;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: n, stepSize: i } = t, r;
    return i ? (r = Math.ceil(this.max / i) - Math.floor(this.min / i) + 1, r > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${i} would result generating up to ${r} ticks. Limiting to 1000.`), r = 1e3)) : (r = this.computeTickLimit(), n = n || 11), n && (r = Math.min(n, r)), r;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, n = t.ticks;
    let i = this.getTickLimit();
    i = Math.max(2, i);
    const r = {
      maxTicks: i,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, o = this._range || this, a = KR(r, o);
    return t.bounds === "ticks" && _w(a, this, "value"), t.reverse ? (a.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), a;
  }
  configure() {
    const t = this.ticks;
    let n = this.min, i = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const r = (i - n) / Math.max(t.length - 1, 1) / 2;
      n -= r, i += r;
    }
    this._startValue = n, this._endValue = i, this._valueRange = i - n;
  }
  getLabelForValue(t) {
    return $c(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class Th extends mc {
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = Et(t) ? t : 0, this.max = Et(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), n = t ? this.width : this.height, i = $i(this.options.ticks.minRotation), r = (t ? Math.sin(i) : Math.cos(i)) || 1e-3, o = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, o.lineHeight / r));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
ne(Th, "id", "linear"), ne(Th, "defaults", {
  ticks: {
    callback: Rc.formatters.numeric
  }
});
const Us = (e) => Math.floor($r(e)), So = (e, t) => Math.pow(10, Us(e) + t);
function W0(e) {
  return e / Math.pow(10, Us(e)) === 1;
}
function z0(e, t, n) {
  const i = Math.pow(10, n), r = Math.floor(e / i);
  return Math.ceil(t / i) - r;
}
function ZR(e, t) {
  const n = t - e;
  let i = Us(n);
  for (; z0(e, t, i) > 10; )
    i++;
  for (; z0(e, t, i) < 10; )
    i--;
  return Math.min(i, Us(e));
}
function QR(e, { min: t, max: n }) {
  t = zn(e.min, t);
  const i = [], r = Us(t);
  let o = ZR(t, n), a = o < 0 ? Math.pow(10, Math.abs(o)) : 1;
  const l = Math.pow(10, o), u = r > o ? Math.pow(10, r) : 0, d = Math.round((t - u) * a) / a, f = Math.floor((t - u) / l / 10) * l * 10;
  let m = Math.floor((d - f) / Math.pow(10, o)), h = zn(e.min, Math.round((u + f + m * Math.pow(10, o)) * a) / a);
  for (; h < n; )
    i.push({
      value: h,
      major: W0(h),
      significand: m
    }), m >= 10 ? m = m < 15 ? 15 : 20 : m++, m >= 20 && (o++, m = 2, a = o >= 0 ? 1 : a), h = Math.round((u + f + m * Math.pow(10, o)) * a) / a;
  const v = zn(e.max, h);
  return i.push({
    value: v,
    major: W0(v),
    significand: m
  }), i;
}
class H0 extends Wo {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    const i = mc.prototype.parse.apply(this, [
      t,
      n
    ]);
    if (i === 0) {
      this._zero = !0;
      return;
    }
    return Et(i) && i > 0 ? i : null;
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = Et(t) ? Math.max(0, t) : null, this.max = Et(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !Et(this._userMin) && (this.min = t === So(this.min, 0) ? So(this.min, -1) : So(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let i = this.min, r = this.max;
    const o = (l) => i = t ? i : l, a = (l) => r = n ? r : l;
    i === r && (i <= 0 ? (o(1), a(10)) : (o(So(i, -1)), a(So(r, 1)))), i <= 0 && o(So(r, -1)), r <= 0 && a(So(i, 1)), this.min = i, this.max = r;
  }
  buildTicks() {
    const t = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, i = QR(n, this);
    return t.bounds === "ticks" && _w(i, this, "value"), t.reverse ? (i.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), i;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : $c(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = $r(t), this._valueRange = $r(this.max) - $r(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : ($r(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const n = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
ne(H0, "id", "logarithmic"), ne(H0, "defaults", {
  ticks: {
    callback: Rc.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function Ph(e) {
  const t = e.ticks;
  if (t.display && e.display) {
    const n = bn(t.backdropPadding);
    return et(t.font && t.font.size, It.font.size) + n.height;
  }
  return 0;
}
function JR(e, t, n) {
  return n = Ct(n) ? n : [
    n
  ], {
    w: RB(e, t.string, n),
    h: n.length * t.lineHeight
  };
}
function j0(e, t, n, i, r) {
  return e === i || e === r ? {
    start: t - n / 2,
    end: t + n / 2
  } : e < i || e > r ? {
    start: t - n,
    end: t
  } : {
    start: t,
    end: t + n
  };
}
function eF(e) {
  const t = {
    l: e.left + e._padding.left,
    r: e.right - e._padding.right,
    t: e.top + e._padding.top,
    b: e.bottom - e._padding.bottom
  }, n = Object.assign({}, t), i = [], r = [], o = e._pointLabels.length, a = e.options.pointLabels, l = a.centerPointLabels ? Dt / o : 0;
  for (let u = 0; u < o; u++) {
    const d = a.setContext(e.getPointLabelContext(u));
    r[u] = d.padding;
    const f = e.getPointPosition(u, e.drawingArea + r[u], l), m = an(d.font), h = JR(e.ctx, m, e._pointLabels[u]);
    i[u] = h;
    const v = Hn(e.getIndexAngle(u) + l), y = Math.round(xg(v)), p = j0(y, f.x, h.w, 0, 180), b = j0(y, f.y, h.h, 90, 270);
    tF(n, t, v, p, b);
  }
  e.setCenterPoint(t.l - n.l, n.r - t.r, t.t - n.t, n.b - t.b), e._pointLabelItems = rF(e, i, r);
}
function tF(e, t, n, i, r) {
  const o = Math.abs(Math.sin(n)), a = Math.abs(Math.cos(n));
  let l = 0, u = 0;
  i.start < t.l ? (l = (t.l - i.start) / o, e.l = Math.min(e.l, t.l - l)) : i.end > t.r && (l = (i.end - t.r) / o, e.r = Math.max(e.r, t.r + l)), r.start < t.t ? (u = (t.t - r.start) / a, e.t = Math.min(e.t, t.t - u)) : r.end > t.b && (u = (r.end - t.b) / a, e.b = Math.max(e.b, t.b + u));
}
function nF(e, t, n) {
  const i = e.drawingArea, { extra: r, additionalAngle: o, padding: a, size: l } = n, u = e.getPointPosition(t, i + r + a, o), d = Math.round(xg(Hn(u.angle + $t))), f = sF(u.y, l.h, d), m = oF(d), h = aF(u.x, l.w, m);
  return {
    visible: !0,
    x: u.x,
    y: f,
    textAlign: m,
    left: h,
    top: f,
    right: h + l.w,
    bottom: f + l.h
  };
}
function iF(e, t) {
  if (!t)
    return !0;
  const { left: n, top: i, right: r, bottom: o } = e;
  return !(ar({
    x: n,
    y: i
  }, t) || ar({
    x: n,
    y: o
  }, t) || ar({
    x: r,
    y: i
  }, t) || ar({
    x: r,
    y: o
  }, t));
}
function rF(e, t, n) {
  const i = [], r = e._pointLabels.length, o = e.options, { centerPointLabels: a, display: l } = o.pointLabels, u = {
    extra: Ph(o) / 2,
    additionalAngle: a ? Dt / r : 0
  };
  let d;
  for (let f = 0; f < r; f++) {
    u.padding = n[f], u.size = t[f];
    const m = nF(e, f, u);
    i.push(m), l === "auto" && (m.visible = iF(m, d), m.visible && (d = m));
  }
  return i;
}
function oF(e) {
  return e === 0 || e === 180 ? "center" : e < 180 ? "left" : "right";
}
function aF(e, t, n) {
  return n === "right" ? e -= t : n === "center" && (e -= t / 2), e;
}
function sF(e, t, n) {
  return n === 90 || n === 270 ? e -= t / 2 : (n > 270 || n < 90) && (e -= t), e;
}
function lF(e, t, n) {
  const { left: i, top: r, right: o, bottom: a } = n, { backdropColor: l } = t;
  if (!_t(l)) {
    const u = ya(t.borderRadius), d = bn(t.backdropPadding);
    e.fillStyle = l;
    const f = i - d.left, m = r - d.top, h = o - i + d.width, v = a - r + d.height;
    Object.values(u).some((y) => y !== 0) ? (e.beginPath(), dc(e, {
      x: f,
      y: m,
      w: h,
      h: v,
      radius: u
    }), e.fill()) : e.fillRect(f, m, h, v);
  }
}
function uF(e, t) {
  const { ctx: n, options: { pointLabels: i } } = e;
  for (let r = t - 1; r >= 0; r--) {
    const o = e._pointLabelItems[r];
    if (!o.visible)
      continue;
    const a = i.setContext(e.getPointLabelContext(r));
    lF(n, a, o);
    const l = an(a.font), { x: u, y: d, textAlign: f } = o;
    Oa(n, e._pointLabels[r], u, d + l.lineHeight / 2, l, {
      color: a.color,
      textAlign: f,
      textBaseline: "middle"
    });
  }
}
function i_(e, t, n, i) {
  const { ctx: r } = e;
  if (n)
    r.arc(e.xCenter, e.yCenter, t, 0, xt);
  else {
    let o = e.getPointPosition(0, t);
    r.moveTo(o.x, o.y);
    for (let a = 1; a < i; a++)
      o = e.getPointPosition(a, t), r.lineTo(o.x, o.y);
  }
}
function cF(e, t, n, i, r) {
  const o = e.ctx, a = t.circular, { color: l, lineWidth: u } = t;
  !a && !i || !l || !u || n < 0 || (o.save(), o.strokeStyle = l, o.lineWidth = u, o.setLineDash(r.dash), o.lineDashOffset = r.dashOffset, o.beginPath(), i_(e, n, a, i), o.closePath(), o.stroke(), o.restore());
}
function dF(e, t, n) {
  return Jr(e, {
    label: n,
    index: t,
    type: "pointLabel"
  });
}
class Mu extends mc {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = bn(Ph(this.options) / 2), n = this.width = this.maxWidth - t.width, i = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + n / 2 + t.left), this.yCenter = Math.floor(this.top + i / 2 + t.top), this.drawingArea = Math.floor(Math.min(n, i) / 2);
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!1);
    this.min = Et(t) && !isNaN(t) ? t : 0, this.max = Et(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / Ph(this.options));
  }
  generateTickLabels(t) {
    mc.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((n, i) => {
      const r = vt(this.options.pointLabels.callback, [
        n,
        i
      ], this);
      return r || r === 0 ? r : "";
    }).filter((n, i) => this.chart.getDataVisibility(i));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? eF(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, n, i, r) {
    this.xCenter += Math.floor((t - n) / 2), this.yCenter += Math.floor((i - r) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, n, i, r));
  }
  getIndexAngle(t) {
    const n = xt / (this._pointLabels.length || 1), i = this.options.startAngle || 0;
    return Hn(t * n + $i(i));
  }
  getDistanceFromCenterForValue(t) {
    if (_t(t))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * n : (t - this.min) * n;
  }
  getValueForDistanceFromCenter(t) {
    if (_t(t))
      return NaN;
    const n = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(t) {
    const n = this._pointLabels || [];
    if (t >= 0 && t < n.length) {
      const i = n[t];
      return dF(this.getContext(), t, i);
    }
  }
  getPointPosition(t, n, i = 0) {
    const r = this.getIndexAngle(t) - $t + i;
    return {
      x: Math.cos(r) * n + this.xCenter,
      y: Math.sin(r) * n + this.yCenter,
      angle: r
    };
  }
  getPointPositionForValue(t, n) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: n, top: i, right: r, bottom: o } = this._pointLabelItems[t];
    return {
      left: n,
      top: i,
      right: r,
      bottom: o
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: n } } = this.options;
    if (t) {
      const i = this.ctx;
      i.save(), i.beginPath(), i_(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), i.closePath(), i.fillStyle = t, i.fill(), i.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, n = this.options, { angleLines: i, grid: r, border: o } = n, a = this._pointLabels.length;
    let l, u, d;
    if (n.pointLabels.display && uF(this, a), r.display && this.ticks.forEach((f, m) => {
      if (m !== 0 || m === 0 && this.min < 0) {
        u = this.getDistanceFromCenterForValue(f.value);
        const h = this.getContext(m), v = r.setContext(h), y = o.setContext(h);
        cF(this, v, u, a, y);
      }
    }), i.display) {
      for (t.save(), l = a - 1; l >= 0; l--) {
        const f = i.setContext(this.getPointLabelContext(l)), { color: m, lineWidth: h } = f;
        !h || !m || (t.lineWidth = h, t.strokeStyle = m, t.setLineDash(f.borderDash), t.lineDashOffset = f.borderDashOffset, u = this.getDistanceFromCenterForValue(n.ticks.reverse ? this.min : this.max), d = this.getPointPosition(l, u), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(d.x, d.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, n = this.options, i = n.ticks;
    if (!i.display)
      return;
    const r = this.getIndexAngle(0);
    let o, a;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(r), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((l, u) => {
      if (u === 0 && this.min >= 0 && !n.reverse)
        return;
      const d = i.setContext(this.getContext(u)), f = an(d.font);
      if (o = this.getDistanceFromCenterForValue(this.ticks[u].value), d.showLabelBackdrop) {
        t.font = f.string, a = t.measureText(l.label).width, t.fillStyle = d.backdropColor;
        const m = bn(d.backdropPadding);
        t.fillRect(-a / 2 - m.left, -o - f.size / 2 - m.top, a + m.width, f.size + m.height);
      }
      Oa(t, l.label, 0, -o, f, {
        color: d.color,
        strokeColor: d.textStrokeColor,
        strokeWidth: d.textStrokeWidth
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
ne(Mu, "id", "radialLinear"), ne(Mu, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: Rc.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(t) {
      return t;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), ne(Mu, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), ne(Mu, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const zc = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, En = /* @__PURE__ */ Object.keys(zc);
function Y0(e, t) {
  return e - t;
}
function U0(e, t) {
  if (_t(t))
    return null;
  const n = e._adapter, { parser: i, round: r, isoWeekday: o } = e._parseOpts;
  let a = t;
  return typeof i == "function" && (a = i(a)), Et(a) || (a = typeof i == "string" ? n.parse(a, i) : n.parse(a)), a === null ? null : (r && (a = r === "week" && (Hs(o) || o === !0) ? n.startOf(a, "isoWeek", o) : n.startOf(a, r)), +a);
}
function q0(e, t, n, i) {
  const r = En.length;
  for (let o = En.indexOf(e); o < r - 1; ++o) {
    const a = zc[En[o]], l = a.steps ? a.steps : Number.MAX_SAFE_INTEGER;
    if (a.common && Math.ceil((n - t) / (l * a.size)) <= i)
      return En[o];
  }
  return En[r - 1];
}
function fF(e, t, n, i, r) {
  for (let o = En.length - 1; o >= En.indexOf(n); o--) {
    const a = En[o];
    if (zc[a].common && e._adapter.diff(r, i, a) >= t - 1)
      return a;
  }
  return En[n ? En.indexOf(n) : 0];
}
function hF(e) {
  for (let t = En.indexOf(e) + 1, n = En.length; t < n; ++t)
    if (zc[En[t]].common)
      return En[t];
}
function G0(e, t, n) {
  if (!n)
    e[t] = !0;
  else if (n.length) {
    const { lo: i, hi: r } = kg(n, t), o = n[i] >= t ? n[i] : n[r];
    e[o] = !0;
  }
}
function gF(e, t, n, i) {
  const r = e._adapter, o = +r.startOf(t[0].value, i), a = t[t.length - 1].value;
  let l, u;
  for (l = o; l <= a; l = +r.add(l, 1, i))
    u = n[l], u >= 0 && (t[u].major = !0);
  return t;
}
function X0(e, t, n) {
  const i = [], r = {}, o = t.length;
  let a, l;
  for (a = 0; a < o; ++a)
    l = t[a], r[l] = a, i.push({
      value: l,
      major: !1
    });
  return o === 0 || !n ? i : gF(e, i, r, n);
}
class qs extends Wo {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, n = {}) {
    const i = t.time || (t.time = {}), r = this._adapter = new Ww._date(t.adapters.date);
    r.init(n), Ss(i.displayFormats, r.formats()), this._parseOpts = {
      parser: i.parser,
      round: i.round,
      isoWeekday: i.isoWeekday
    }, super.init(t), this._normalized = n.normalized;
  }
  parse(t, n) {
    return t === void 0 ? null : U0(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, n = this._adapter, i = t.time.unit || "day";
    let { min: r, max: o, minDefined: a, maxDefined: l } = this.getUserBounds();
    function u(d) {
      !a && !isNaN(d.min) && (r = Math.min(r, d.min)), !l && !isNaN(d.max) && (o = Math.max(o, d.max));
    }
    (!a || !l) && (u(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && u(this.getMinMax(!1))), r = Et(r) && !isNaN(r) ? r : +n.startOf(Date.now(), i), o = Et(o) && !isNaN(o) ? o : +n.endOf(Date.now(), i) + 1, this.min = Math.min(r, o - 1), this.max = Math.max(r + 1, o);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, i = Number.NEGATIVE_INFINITY;
    return t.length && (n = t[0], i = t[t.length - 1]), {
      min: n,
      max: i
    };
  }
  buildTicks() {
    const t = this.options, n = t.time, i = t.ticks, r = i.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && r.length && (this.min = this._userMin || r[0], this.max = this._userMax || r[r.length - 1]);
    const o = this.min, a = this.max, l = xB(r, o, a);
    return this._unit = n.unit || (i.autoSkip ? q0(n.minUnit, this.min, this.max, this._getLabelCapacity(o)) : fF(this, l.length, n.minUnit, this.min, this.max)), this._majorUnit = !i.major.enabled || this._unit === "year" ? void 0 : hF(this._unit), this.initOffsets(r), t.reverse && l.reverse(), X0(this, l, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let n = 0, i = 0, r, o;
    this.options.offset && t.length && (r = this.getDecimalForValue(t[0]), t.length === 1 ? n = 1 - r : n = (this.getDecimalForValue(t[1]) - r) / 2, o = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? i = o : i = (o - this.getDecimalForValue(t[t.length - 2])) / 2);
    const a = t.length < 3 ? 0.5 : 0.25;
    n = yn(n, 0, a), i = yn(i, 0, a), this._offsets = {
      start: n,
      end: i,
      factor: 1 / (n + 1 + i)
    };
  }
  _generate() {
    const t = this._adapter, n = this.min, i = this.max, r = this.options, o = r.time, a = o.unit || q0(o.minUnit, n, i, this._getLabelCapacity(n)), l = et(r.ticks.stepSize, 1), u = a === "week" ? o.isoWeekday : !1, d = Hs(u) || u === !0, f = {};
    let m = n, h, v;
    if (d && (m = +t.startOf(m, "isoWeek", u)), m = +t.startOf(m, d ? "day" : a), t.diff(i, n, a) > 1e5 * l)
      throw new Error(n + " and " + i + " are too far apart with stepSize of " + l + " " + a);
    const y = r.ticks.source === "data" && this.getDataTimestamps();
    for (h = m, v = 0; h < i; h = +t.add(h, l, a), v++)
      G0(f, h, y);
    return (h === i || r.bounds === "ticks" || v === 1) && G0(f, h, y), Object.keys(f).sort(Y0).map((p) => +p);
  }
  getLabelForValue(t) {
    const n = this._adapter, i = this.options.time;
    return i.tooltipFormat ? n.format(t, i.tooltipFormat) : n.format(t, i.displayFormats.datetime);
  }
  format(t, n) {
    const r = this.options.time.displayFormats, o = this._unit, a = n || r[o];
    return this._adapter.format(t, a);
  }
  _tickFormatFunction(t, n, i, r) {
    const o = this.options, a = o.ticks.callback;
    if (a)
      return vt(a, [
        t,
        n,
        i
      ], this);
    const l = o.time.displayFormats, u = this._unit, d = this._majorUnit, f = u && l[u], m = d && l[d], h = i[n], v = d && m && h && h.major;
    return this._adapter.format(t, r || (v ? m : f));
  }
  generateTickLabels(t) {
    let n, i, r;
    for (n = 0, i = t.length; n < i; ++n)
      r = t[n], r.label = this._tickFormatFunction(r.value, n, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const n = this._offsets, i = this.getDecimalForValue(t);
    return this.getPixelForDecimal((n.start + i) * n.factor);
  }
  getValueForPixel(t) {
    const n = this._offsets, i = this.getDecimalForPixel(t) / n.factor - n.end;
    return this.min + i * (this.max - this.min);
  }
  _getLabelSize(t) {
    const n = this.options.ticks, i = this.ctx.measureText(t).width, r = $i(this.isHorizontal() ? n.maxRotation : n.minRotation), o = Math.cos(r), a = Math.sin(r), l = this._resolveTickFontOptions(0).size;
    return {
      w: i * o + l * a,
      h: i * a + l * o
    };
  }
  _getLabelCapacity(t) {
    const n = this.options.time, i = n.displayFormats, r = i[n.unit] || i.millisecond, o = this._tickFormatFunction(t, 0, X0(this, [
      t
    ], this._majorUnit), r), a = this._getLabelSize(o), l = Math.floor(this.isHorizontal() ? this.width / a.w : this.height / a.h) - 1;
    return l > 0 ? l : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], n, i;
    if (t.length)
      return t;
    const r = this.getMatchingVisibleMetas();
    if (this._normalized && r.length)
      return this._cache.data = r[0].controller.getAllParsedValues(this);
    for (n = 0, i = r.length; n < i; ++n)
      t = t.concat(r[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let n, i;
    if (t.length)
      return t;
    const r = this.getLabels();
    for (n = 0, i = r.length; n < i; ++n)
      t.push(U0(this, r[n]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return SB(t.sort(Y0));
  }
}
ne(qs, "id", "time"), ne(qs, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function Tu(e, t, n) {
  let i = 0, r = e.length - 1, o, a, l, u;
  n ? (t >= e[i].pos && t <= e[r].pos && ({ lo: i, hi: r } = Po(e, "pos", t)), { pos: o, time: l } = e[i], { pos: a, time: u } = e[r]) : (t >= e[i].time && t <= e[r].time && ({ lo: i, hi: r } = Po(e, "time", t)), { time: o, pos: l } = e[i], { time: a, pos: u } = e[r]);
  const d = a - o;
  return d ? l + (u - l) * (t - o) / d : l;
}
class K0 extends qs {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(t);
    this._minPos = Tu(n, this.min), this._tableRange = Tu(n, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: n, max: i } = this, r = [], o = [];
    let a, l, u, d, f;
    for (a = 0, l = t.length; a < l; ++a)
      d = t[a], d >= n && d <= i && r.push(d);
    if (r.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: i,
          pos: 1
        }
      ];
    for (a = 0, l = r.length; a < l; ++a)
      f = r[a + 1], u = r[a - 1], d = r[a], Math.round((f + u) / 2) !== d && o.push({
        time: d,
        pos: a / (l - 1)
      });
    return o;
  }
  _generate() {
    const t = this.min, n = this.max;
    let i = super.getDataTimestamps();
    return (!i.includes(t) || !i.length) && i.splice(0, 0, t), (!i.includes(n) || i.length === 1) && i.push(n), i.sort((r, o) => r - o);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const n = this.getDataTimestamps(), i = this.getLabelTimestamps();
    return n.length && i.length ? t = this.normalize(n.concat(i)) : t = n.length ? n : i, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (Tu(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const n = this._offsets, i = this.getDecimalForPixel(t) / n.factor - n.end;
    return Tu(this._table, i * this._tableRange + this._minPos, !0);
  }
}
ne(K0, "id", "timeseries"), ne(K0, "defaults", qs.defaults);
const r_ = {
  data: {
    type: Object,
    required: !0
  },
  options: {
    type: Object,
    default: () => ({})
  },
  plugins: {
    type: Array,
    default: () => []
  },
  datasetIdKey: {
    type: String,
    default: "label"
  },
  updateMode: {
    type: String,
    default: void 0
  }
}, mF = {
  ariaLabel: {
    type: String
  },
  ariaDescribedby: {
    type: String
  }
}, vF = {
  type: {
    type: String,
    required: !0
  },
  destroyDelay: {
    type: Number,
    default: 0
    // No delay by default
  },
  ...r_,
  ...mF
}, pF = bP[0] === "2" ? (e, t) => Object.assign(e, {
  attrs: t
}) : (e, t) => Object.assign(e, t);
function ga(e) {
  return Tb(e) ? fn(e) : e;
}
function yF(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e;
  return Tb(t) ? new Proxy(e, {}) : e;
}
function bF(e, t) {
  const n = e.options;
  n && t && Object.assign(n, t);
}
function o_(e, t) {
  e.labels = t;
}
function a_(e, t, n) {
  const i = [];
  e.datasets = t.map((r) => {
    const o = e.datasets.find((a) => a[n] === r[n]);
    return !o || !r.data || i.includes(o) ? {
      ...r
    } : (i.push(o), Object.assign(o, r), o);
  });
}
function wF(e, t) {
  const n = {
    labels: [],
    datasets: []
  };
  return o_(n, e.labels), a_(n, e.datasets, t), n;
}
const _F = Ae({
  props: vF,
  setup(e, t) {
    let { expose: n, slots: i } = t;
    const r = ie(null), o = Pe(null);
    n({
      chart: o
    });
    const a = () => {
      if (!r.value)
        return;
      const { type: d, data: f, options: m, plugins: h, datasetIdKey: v } = e, y = wF(f, v), p = yF(y, f);
      o.value = new Bn(r.value, {
        type: d,
        data: p,
        options: {
          ...m
        },
        plugins: h
      });
    }, l = () => {
      const d = fn(o.value);
      d && (e.destroyDelay > 0 ? setTimeout(() => {
        d.destroy(), o.value = null;
      }, e.destroyDelay) : (d.destroy(), o.value = null));
    }, u = (d) => {
      d.update(e.updateMode);
    };
    return mn(a), wP(l), pe([
      () => e.options,
      () => e.data
    ], (d, f) => {
      let [m, h] = d, [v, y] = f;
      const p = fn(o.value);
      if (!p)
        return;
      let b = !1;
      if (m) {
        const x = ga(m), _ = ga(v);
        x && x !== _ && (bF(p, x), b = !0);
      }
      if (h) {
        const x = ga(h.labels), _ = ga(y.labels), O = ga(h.datasets), D = ga(y.datasets);
        x !== _ && (o_(p.config.data, x), b = !0), O && O !== D && (a_(p.config.data, O, e.datasetIdKey), b = !0);
      }
      b && gt(() => {
        u(p);
      });
    }, {
      deep: !0
    }), () => Un("canvas", {
      role: "img",
      ariaLabel: e.ariaLabel,
      ariaDescribedby: e.ariaDescribedby,
      ref: r
    }, [
      Un("p", {}, [
        i.default ? i.default() : ""
      ])
    ]);
  }
});
function s_(e, t) {
  return Bn.register(t), Ae({
    props: r_,
    setup(n, i) {
      let { expose: r } = i;
      const o = Pe(null), a = (l) => {
        o.value = l == null ? void 0 : l.chart;
      };
      return r({
        chart: o
      }), () => Un(_F, pF({
        ref: a
      }, {
        type: e,
        ...n
      }));
    }
  });
}
const xF = /* @__PURE__ */ s_("doughnut", ws), kF = /* @__PURE__ */ s_("line", Ru);
function Re(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function wt(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Hc(e, t) {
  const n = Re(e);
  return isNaN(t) ? wt(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function Dg(e, t) {
  const n = Re(e);
  if (isNaN(t))
    return wt(e, NaN);
  if (!t)
    return n;
  const i = n.getDate(), r = wt(e, n.getTime());
  r.setMonth(n.getMonth() + t + 1, 0);
  const o = r.getDate();
  return i >= o ? r : (n.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    i
  ), n);
}
function jc(e, t) {
  const n = +Re(e);
  return wt(e, n + t);
}
const l_ = 6048e5, SF = 864e5, dl = 6e4, fl = 36e5, CF = 1e3;
function OF(e, t) {
  return jc(e, t * fl);
}
let MF = {};
function zo() {
  return MF;
}
function Ni(e, t) {
  var l, u, d, f;
  const n = zo(), i = (t == null ? void 0 : t.weekStartsOn) ?? ((u = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) ?? n.weekStartsOn ?? ((f = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? 0, r = Re(e), o = r.getDay(), a = (o < i ? 7 : 0) + o - i;
  return r.setDate(r.getDate() - a), r.setHours(0, 0, 0, 0), r;
}
function Pa(e) {
  return Ni(e, { weekStartsOn: 1 });
}
function u_(e) {
  const t = Re(e), n = t.getFullYear(), i = wt(e, 0);
  i.setFullYear(n + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const r = Pa(i), o = wt(e, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const a = Pa(o);
  return t.getTime() >= r.getTime() ? n + 1 : t.getTime() >= a.getTime() ? n : n - 1;
}
function Ah(e) {
  const t = Re(e);
  return t.setHours(0, 0, 0, 0), t;
}
function vc(e) {
  const t = Re(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function c_(e, t) {
  const n = Ah(e), i = Ah(t), r = +n - vc(n), o = +i - vc(i);
  return Math.round((r - o) / SF);
}
function TF(e) {
  const t = u_(e), n = wt(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), Pa(n);
}
function PF(e, t) {
  return jc(e, t * dl);
}
function AF(e, t) {
  const n = t * 3;
  return Dg(e, n);
}
function EF(e, t) {
  return jc(e, t * 1e3);
}
function IF(e, t) {
  const n = t * 7;
  return Hc(e, n);
}
function DF(e, t) {
  return Dg(e, t * 12);
}
function Ts(e, t) {
  const n = Re(e), i = Re(t), r = n.getTime() - i.getTime();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function LF(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function d_(e) {
  if (!LF(e) && typeof e != "number")
    return !1;
  const t = Re(e);
  return !isNaN(Number(t));
}
function BF(e, t) {
  const n = Re(e), i = Re(t), r = n.getFullYear() - i.getFullYear(), o = n.getMonth() - i.getMonth();
  return r * 12 + o;
}
function VF(e, t) {
  const n = Re(e), i = Re(t);
  return n.getFullYear() - i.getFullYear();
}
function f_(e, t) {
  const n = Re(e), i = Re(t), r = Z0(n, i), o = Math.abs(c_(n, i));
  n.setDate(n.getDate() - r * o);
  const a = +(Z0(n, i) === -r), l = r * (o - a);
  return l === 0 ? 0 : l;
}
function Z0(e, t) {
  const n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function hl(e) {
  return (t) => {
    const i = (e ? Math[e] : Math.trunc)(t);
    return i === 0 ? 0 : i;
  };
}
function Yc(e, t) {
  return +Re(e) - +Re(t);
}
function $F(e, t, n) {
  const i = Yc(e, t) / fl;
  return hl(n == null ? void 0 : n.roundingMethod)(i);
}
function RF(e, t, n) {
  const i = Yc(e, t) / dl;
  return hl(n == null ? void 0 : n.roundingMethod)(i);
}
function h_(e) {
  const t = Re(e);
  return t.setHours(23, 59, 59, 999), t;
}
function g_(e) {
  const t = Re(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function FF(e) {
  const t = Re(e);
  return +h_(t) == +g_(t);
}
function m_(e, t) {
  const n = Re(e), i = Re(t), r = Ts(n, i), o = Math.abs(
    BF(n, i)
  );
  let a;
  if (o < 1)
    a = 0;
  else {
    n.getMonth() === 1 && n.getDate() > 27 && n.setDate(30), n.setMonth(n.getMonth() - r * o);
    let l = Ts(n, i) === -r;
    FF(Re(e)) && o === 1 && Ts(e, i) === 1 && (l = !1), a = r * (o - Number(l));
  }
  return a === 0 ? 0 : a;
}
function NF(e, t, n) {
  const i = m_(e, t) / 3;
  return hl(n == null ? void 0 : n.roundingMethod)(i);
}
function WF(e, t, n) {
  const i = Yc(e, t) / 1e3;
  return hl(n == null ? void 0 : n.roundingMethod)(i);
}
function zF(e, t, n) {
  const i = f_(e, t) / 7;
  return hl(n == null ? void 0 : n.roundingMethod)(i);
}
function HF(e, t) {
  const n = Re(e), i = Re(t), r = Ts(n, i), o = Math.abs(VF(n, i));
  n.setFullYear(1584), i.setFullYear(1584);
  const a = Ts(n, i) === -r, l = r * (o - +a);
  return l === 0 ? 0 : l;
}
function jF(e) {
  const t = Re(e);
  return t.setSeconds(0, 0), t;
}
function YF(e) {
  const t = Re(e), n = t.getMonth(), i = n - n % 3;
  return t.setMonth(i, 1), t.setHours(0, 0, 0, 0), t;
}
function UF(e) {
  const t = Re(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function qF(e) {
  const t = Re(e), n = t.getFullYear();
  return t.setFullYear(n + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function v_(e) {
  const t = Re(e), n = wt(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function GF(e) {
  const t = Re(e);
  return t.setMinutes(59, 59, 999), t;
}
function XF(e, t) {
  var l, u, d, f;
  const n = zo(), i = (t == null ? void 0 : t.weekStartsOn) ?? ((u = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) ?? n.weekStartsOn ?? ((f = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? 0, r = Re(e), o = r.getDay(), a = (o < i ? -7 : 0) + 6 - (o - i);
  return r.setDate(r.getDate() + a), r.setHours(23, 59, 59, 999), r;
}
function KF(e) {
  const t = Re(e);
  return t.setSeconds(59, 999), t;
}
function ZF(e) {
  const t = Re(e), n = t.getMonth(), i = n - n % 3 + 3;
  return t.setMonth(i, 0), t.setHours(23, 59, 59, 999), t;
}
function QF(e) {
  const t = Re(e);
  return t.setMilliseconds(999), t;
}
const JF = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, eN = (e, t, n) => {
  let i;
  const r = JF[e];
  return typeof r == "string" ? i = r : t === 1 ? i = r.one : i = r.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + i : i + " ago" : i;
};
function Uf(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const tN = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, nN = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, iN = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, rN = {
  date: Uf({
    formats: tN,
    defaultWidth: "full"
  }),
  time: Uf({
    formats: nN,
    defaultWidth: "full"
  }),
  dateTime: Uf({
    formats: iN,
    defaultWidth: "full"
  })
}, oN = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, aN = (e, t, n, i) => oN[e];
function ms(e) {
  return (t, n) => {
    const i = n != null && n.context ? String(n.context) : "standalone";
    let r;
    if (i === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, l = n != null && n.width ? String(n.width) : a;
      r = e.formattingValues[l] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, l = n != null && n.width ? String(n.width) : e.defaultWidth;
      r = e.values[l] || e.values[a];
    }
    const o = e.argumentCallback ? e.argumentCallback(t) : t;
    return r[o];
  };
}
const sN = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, lN = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, uN = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, cN = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, dN = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, fN = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, hN = (e, t) => {
  const n = Number(e), i = n % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, gN = {
  ordinalNumber: hN,
  era: ms({
    values: sN,
    defaultWidth: "wide"
  }),
  quarter: ms({
    values: lN,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ms({
    values: uN,
    defaultWidth: "wide"
  }),
  day: ms({
    values: cN,
    defaultWidth: "wide"
  }),
  dayPeriod: ms({
    values: dN,
    defaultWidth: "wide",
    formattingValues: fN,
    defaultFormattingWidth: "wide"
  })
};
function vs(e) {
  return (t, n = {}) => {
    const i = n.width, r = i && e.matchPatterns[i] || e.matchPatterns[e.defaultMatchWidth], o = t.match(r);
    if (!o)
      return null;
    const a = o[0], l = i && e.parsePatterns[i] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(l) ? vN(l, (m) => m.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      mN(l, (m) => m.test(a))
    );
    let d;
    d = e.valueCallback ? e.valueCallback(u) : u, d = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(d)
    ) : d;
    const f = t.slice(a.length);
    return { value: d, rest: f };
  };
}
function mN(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function vN(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function pN(e) {
  return (t, n = {}) => {
    const i = t.match(e.matchPattern);
    if (!i)
      return null;
    const r = i[0], o = t.match(e.parsePattern);
    if (!o)
      return null;
    let a = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const l = t.slice(r.length);
    return { value: a, rest: l };
  };
}
const yN = /^(\d+)(th|st|nd|rd)?/i, bN = /\d+/i, wN = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, _N = {
  any: [/^b/i, /^(a|c)/i]
}, xN = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, kN = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, SN = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, CN = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, ON = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, MN = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, TN = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, PN = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, AN = {
  ordinalNumber: pN({
    matchPattern: yN,
    parsePattern: bN,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: vs({
    matchPatterns: wN,
    defaultMatchWidth: "wide",
    parsePatterns: _N,
    defaultParseWidth: "any"
  }),
  quarter: vs({
    matchPatterns: xN,
    defaultMatchWidth: "wide",
    parsePatterns: kN,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: vs({
    matchPatterns: SN,
    defaultMatchWidth: "wide",
    parsePatterns: CN,
    defaultParseWidth: "any"
  }),
  day: vs({
    matchPatterns: ON,
    defaultMatchWidth: "wide",
    parsePatterns: MN,
    defaultParseWidth: "any"
  }),
  dayPeriod: vs({
    matchPatterns: TN,
    defaultMatchWidth: "any",
    parsePatterns: PN,
    defaultParseWidth: "any"
  })
}, p_ = {
  code: "en-US",
  formatDistance: eN,
  formatLong: rN,
  formatRelative: aN,
  localize: gN,
  match: AN,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function EN(e) {
  const t = Re(e);
  return c_(t, v_(t)) + 1;
}
function y_(e) {
  const t = Re(e), n = +Pa(t) - +TF(t);
  return Math.round(n / l_) + 1;
}
function Lg(e, t) {
  var f, m, h, v;
  const n = Re(e), i = n.getFullYear(), r = zo(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((m = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : m.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((v = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : v.firstWeekContainsDate) ?? 1, a = wt(e, 0);
  a.setFullYear(i + 1, 0, o), a.setHours(0, 0, 0, 0);
  const l = Ni(a, t), u = wt(e, 0);
  u.setFullYear(i, 0, o), u.setHours(0, 0, 0, 0);
  const d = Ni(u, t);
  return n.getTime() >= l.getTime() ? i + 1 : n.getTime() >= d.getTime() ? i : i - 1;
}
function IN(e, t) {
  var l, u, d, f;
  const n = zo(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((u = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : u.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((f = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, r = Lg(e, t), o = wt(e, 0);
  return o.setFullYear(r, 0, i), o.setHours(0, 0, 0, 0), Ni(o, t);
}
function b_(e, t) {
  const n = Re(e), i = +Ni(n, t) - +IN(n, t);
  return Math.round(i / l_) + 1;
}
function ct(e, t) {
  const n = e < 0 ? "-" : "", i = Math.abs(e).toString().padStart(t, "0");
  return n + i;
}
const Ir = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), i = n > 0 ? n : 1 - n;
    return ct(t === "yy" ? i % 100 : i, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : ct(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return ct(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return ct(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return ct(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return ct(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return ct(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, i = e.getMilliseconds(), r = Math.trunc(
      i * Math.pow(10, n - 3)
    );
    return ct(r, t.length);
  }
}, ma = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Q0 = {
  // Era
  G: function(e, t, n) {
    const i = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(i, { width: "abbreviated" });
      case "GGGGG":
        return n.era(i, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(i, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const i = e.getFullYear(), r = i > 0 ? i : 1 - i;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return Ir.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, i) {
    const r = Lg(e, i), o = r > 0 ? r : 1 - r;
    if (t === "YY") {
      const a = o % 100;
      return ct(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(o, { unit: "year" }) : ct(o, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = u_(e);
    return ct(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return ct(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const i = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(i);
      case "QQ":
        return ct(i, 2);
      case "Qo":
        return n.ordinalNumber(i, { unit: "quarter" });
      case "QQQ":
        return n.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const i = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(i);
      case "qq":
        return ct(i, 2);
      case "qo":
        return n.ordinalNumber(i, { unit: "quarter" });
      case "qqq":
        return n.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const i = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Ir.M(e, t);
      case "Mo":
        return n.ordinalNumber(i + 1, { unit: "month" });
      case "MMM":
        return n.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(i, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(i, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const i = e.getMonth();
    switch (t) {
      case "L":
        return String(i + 1);
      case "LL":
        return ct(i + 1, 2);
      case "Lo":
        return n.ordinalNumber(i + 1, { unit: "month" });
      case "LLL":
        return n.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(i, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(i, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, i) {
    const r = b_(e, i);
    return t === "wo" ? n.ordinalNumber(r, { unit: "week" }) : ct(r, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const i = y_(e);
    return t === "Io" ? n.ordinalNumber(i, { unit: "week" }) : ct(i, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Ir.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const i = EN(e);
    return t === "Do" ? n.ordinalNumber(i, { unit: "dayOfYear" }) : ct(i, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const i = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, i) {
    const r = e.getDay(), o = (r - i.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(o);
      case "ee":
        return ct(o, 2);
      case "eo":
        return n.ordinalNumber(o, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, i) {
    const r = e.getDay(), o = (r - i.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(o);
      case "cc":
        return ct(o, t.length);
      case "co":
        return n.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const i = e.getDay(), r = i === 0 ? 7 : i;
    switch (t) {
      case "i":
        return String(r);
      case "ii":
        return ct(r, t.length);
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      case "iii":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const i = e.getHours();
    let r;
    switch (i === 12 ? r = ma.noon : i === 0 ? r = ma.midnight : r = i / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const i = e.getHours();
    let r;
    switch (i >= 17 ? r = ma.evening : i >= 12 ? r = ma.afternoon : i >= 4 ? r = ma.morning : r = ma.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let i = e.getHours() % 12;
      return i === 0 && (i = 12), n.ordinalNumber(i, { unit: "hour" });
    }
    return Ir.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Ir.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const i = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(i, { unit: "hour" }) : ct(i, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let i = e.getHours();
    return i === 0 && (i = 24), t === "ko" ? n.ordinalNumber(i, { unit: "hour" }) : ct(i, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Ir.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Ir.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Ir.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const i = e.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (t) {
      case "X":
        return eb(i);
      case "XXXX":
      case "XX":
        return Mo(i);
      case "XXXXX":
      case "XXX":
      default:
        return Mo(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const i = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return eb(i);
      case "xxxx":
      case "xx":
        return Mo(i);
      case "xxxxx":
      case "xxx":
      default:
        return Mo(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const i = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + J0(i, ":");
      case "OOOO":
      default:
        return "GMT" + Mo(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const i = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + J0(i, ":");
      case "zzzz":
      default:
        return "GMT" + Mo(i, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const i = Math.trunc(e.getTime() / 1e3);
    return ct(i, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const i = e.getTime();
    return ct(i, t.length);
  }
};
function J0(e, t = "") {
  const n = e > 0 ? "-" : "+", i = Math.abs(e), r = Math.trunc(i / 60), o = i % 60;
  return o === 0 ? n + String(r) : n + String(r) + t + ct(o, 2);
}
function eb(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + ct(Math.abs(e) / 60, 2) : Mo(e, t);
}
function Mo(e, t = "") {
  const n = e > 0 ? "-" : "+", i = Math.abs(e), r = ct(Math.trunc(i / 60), 2), o = ct(i % 60, 2);
  return n + r + t + o;
}
const tb = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, w_ = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, DN = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], i = n[1], r = n[2];
  if (!r)
    return tb(e, t);
  let o;
  switch (i) {
    case "P":
      o = t.dateTime({ width: "short" });
      break;
    case "PP":
      o = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = t.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", tb(i, t)).replace("{{time}}", w_(r, t));
}, Eh = {
  p: w_,
  P: DN
}, LN = /^D+$/, BN = /^Y+$/, VN = ["D", "DD", "YY", "YYYY"];
function __(e) {
  return LN.test(e);
}
function x_(e) {
  return BN.test(e);
}
function Ih(e, t, n) {
  const i = $N(e, t, n);
  if (console.warn(i), VN.includes(e))
    throw new RangeError(i);
}
function $N(e, t, n) {
  const i = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${i} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const RN = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, FN = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, NN = /^'([^]*?)'?$/, WN = /''/g, zN = /[a-zA-Z]/;
function HN(e, t, n) {
  var f, m, h, v, y, p, b, x;
  const i = zo(), r = (n == null ? void 0 : n.locale) ?? i.locale ?? p_, o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((m = (f = n == null ? void 0 : n.locale) == null ? void 0 : f.options) == null ? void 0 : m.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((v = (h = i.locale) == null ? void 0 : h.options) == null ? void 0 : v.firstWeekContainsDate) ?? 1, a = (n == null ? void 0 : n.weekStartsOn) ?? ((p = (y = n == null ? void 0 : n.locale) == null ? void 0 : y.options) == null ? void 0 : p.weekStartsOn) ?? i.weekStartsOn ?? ((x = (b = i.locale) == null ? void 0 : b.options) == null ? void 0 : x.weekStartsOn) ?? 0, l = Re(e);
  if (!d_(l))
    throw new RangeError("Invalid time value");
  let u = t.match(FN).map((_) => {
    const O = _[0];
    if (O === "p" || O === "P") {
      const D = Eh[O];
      return D(_, r.formatLong);
    }
    return _;
  }).join("").match(RN).map((_) => {
    if (_ === "''")
      return { isToken: !1, value: "'" };
    const O = _[0];
    if (O === "'")
      return { isToken: !1, value: jN(_) };
    if (Q0[O])
      return { isToken: !0, value: _ };
    if (O.match(zN))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + O + "`"
      );
    return { isToken: !1, value: _ };
  });
  r.localize.preprocessor && (u = r.localize.preprocessor(l, u));
  const d = {
    firstWeekContainsDate: o,
    weekStartsOn: a,
    locale: r
  };
  return u.map((_) => {
    if (!_.isToken)
      return _.value;
    const O = _.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && x_(O) || !(n != null && n.useAdditionalDayOfYearTokens) && __(O)) && Ih(O, t, String(e));
    const D = Q0[O[0]];
    return D(l, O, r.localize, d);
  }).join("");
}
function jN(e) {
  const t = e.match(NN);
  return t ? t[1].replace(WN, "'") : e;
}
function YN() {
  return Object.assign({}, zo());
}
function UN(e) {
  let n = Re(e).getDay();
  return n === 0 && (n = 7), n;
}
function qN(e, t) {
  const n = t instanceof Date ? wt(t, 0) : new t(0);
  return n.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), n.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), n;
}
const GN = 10;
class k_ {
  constructor() {
    ne(this, "subPriority", 0);
  }
  validate(t, n) {
    return !0;
  }
}
class XN extends k_ {
  constructor(t, n, i, r, o) {
    super(), this.value = t, this.validateValue = n, this.setValue = i, this.priority = r, o && (this.subPriority = o);
  }
  validate(t, n) {
    return this.validateValue(t, this.value, n);
  }
  set(t, n, i) {
    return this.setValue(t, n, this.value, i);
  }
}
class KN extends k_ {
  constructor() {
    super(...arguments);
    ne(this, "priority", GN);
    ne(this, "subPriority", -1);
  }
  set(n, i) {
    return i.timestampIsSet ? n : wt(n, qN(n, Date));
  }
}
class st {
  run(t, n, i, r) {
    const o = this.parse(t, n, i, r);
    return o ? {
      setter: new XN(
        o.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: o.rest
    } : null;
  }
  validate(t, n, i) {
    return !0;
  }
}
class ZN extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 140);
    ne(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" }) || r.era(n, { width: "narrow" });
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(n, { width: "wide" }) || r.era(n, { width: "abbreviated" }) || r.era(n, { width: "narrow" });
    }
  }
  set(n, i, r) {
    return i.era = r, n.setFullYear(r, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
const Rt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Li = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Ft(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Ot(e, t) {
  const n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function Bi(e, t) {
  const n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const i = n[1] === "+" ? 1 : -1, r = n[2] ? parseInt(n[2], 10) : 0, o = n[3] ? parseInt(n[3], 10) : 0, a = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: i * (r * fl + o * dl + a * CF),
    rest: t.slice(n[0].length)
  };
}
function S_(e) {
  return Ot(Rt.anyDigitsSigned, e);
}
function Lt(e, t) {
  switch (e) {
    case 1:
      return Ot(Rt.singleDigit, t);
    case 2:
      return Ot(Rt.twoDigits, t);
    case 3:
      return Ot(Rt.threeDigits, t);
    case 4:
      return Ot(Rt.fourDigits, t);
    default:
      return Ot(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function pc(e, t) {
  switch (e) {
    case 1:
      return Ot(Rt.singleDigitSigned, t);
    case 2:
      return Ot(Rt.twoDigitsSigned, t);
    case 3:
      return Ot(Rt.threeDigitsSigned, t);
    case 4:
      return Ot(Rt.fourDigitsSigned, t);
    default:
      return Ot(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function Bg(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function C_(e, t) {
  const n = t > 0, i = n ? t : 1 - t;
  let r;
  if (i <= 50)
    r = e || 100;
  else {
    const o = i + 50, a = Math.trunc(o / 100) * 100, l = e >= o % 100;
    r = e + a - (l ? 100 : 0);
  }
  return n ? r : 1 - r;
}
function O_(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class QN extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 130);
    ne(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, i, r) {
    const o = (a) => ({
      year: a,
      isTwoDigitYear: i === "yy"
    });
    switch (i) {
      case "y":
        return Ft(Lt(4, n), o);
      case "yo":
        return Ft(
          r.ordinalNumber(n, {
            unit: "year"
          }),
          o
        );
      default:
        return Ft(Lt(i.length, n), o);
    }
  }
  validate(n, i) {
    return i.isTwoDigitYear || i.year > 0;
  }
  set(n, i, r) {
    const o = n.getFullYear();
    if (r.isTwoDigitYear) {
      const l = C_(
        r.year,
        o
      );
      return n.setFullYear(l, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const a = !("era" in i) || i.era === 1 ? r.year : 1 - r.year;
    return n.setFullYear(a, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class JN extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 130);
    ne(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    const o = (a) => ({
      year: a,
      isTwoDigitYear: i === "YY"
    });
    switch (i) {
      case "Y":
        return Ft(Lt(4, n), o);
      case "Yo":
        return Ft(
          r.ordinalNumber(n, {
            unit: "year"
          }),
          o
        );
      default:
        return Ft(Lt(i.length, n), o);
    }
  }
  validate(n, i) {
    return i.isTwoDigitYear || i.year > 0;
  }
  set(n, i, r, o) {
    const a = Lg(n, o);
    if (r.isTwoDigitYear) {
      const u = C_(
        r.year,
        a
      );
      return n.setFullYear(
        u,
        0,
        o.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), Ni(n, o);
    }
    const l = !("era" in i) || i.era === 1 ? r.year : 1 - r.year;
    return n.setFullYear(l, 0, o.firstWeekContainsDate), n.setHours(0, 0, 0, 0), Ni(n, o);
  }
}
class e5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 130);
    ne(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i) {
    return pc(i === "R" ? 4 : i.length, n);
  }
  set(n, i, r) {
    const o = wt(n, 0);
    return o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0), Pa(o);
  }
}
class t5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 130);
    ne(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, i) {
    return pc(i === "u" ? 4 : i.length, n);
  }
  set(n, i, r) {
    return n.setFullYear(r, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class n5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 120);
    ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    switch (i) {
      case "Q":
      case "QQ":
        return Lt(i.length, n);
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 4;
  }
  set(n, i, r) {
    return n.setMonth((r - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class i5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 120);
    ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    switch (i) {
      case "q":
      case "qq":
        return Lt(i.length, n);
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 4;
  }
  set(n, i, r) {
    return n.setMonth((r - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class r5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    ne(this, "priority", 110);
  }
  parse(n, i, r) {
    const o = (a) => a - 1;
    switch (i) {
      case "M":
        return Ft(
          Ot(Rt.month, n),
          o
        );
      case "MM":
        return Ft(Lt(2, n), o);
      case "Mo":
        return Ft(
          r.ordinalNumber(n, {
            unit: "month"
          }),
          o
        );
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(n, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" }) || r.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 11;
  }
  set(n, i, r) {
    return n.setMonth(r, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class o5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 110);
    ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    const o = (a) => a - 1;
    switch (i) {
      case "L":
        return Ft(
          Ot(Rt.month, n),
          o
        );
      case "LL":
        return Ft(Lt(2, n), o);
      case "Lo":
        return Ft(
          r.ordinalNumber(n, {
            unit: "month"
          }),
          o
        );
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(n, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" }) || r.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 11;
  }
  set(n, i, r) {
    return n.setMonth(r, 1), n.setHours(0, 0, 0, 0), n;
  }
}
function a5(e, t, n) {
  const i = Re(e), r = b_(i, n) - t;
  return i.setDate(i.getDate() - r * 7), i;
}
class s5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 100);
    ne(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    switch (i) {
      case "w":
        return Ot(Rt.week, n);
      case "wo":
        return r.ordinalNumber(n, { unit: "week" });
      default:
        return Lt(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 53;
  }
  set(n, i, r, o) {
    return Ni(a5(n, r, o), o);
  }
}
function l5(e, t) {
  const n = Re(e), i = y_(n) - t;
  return n.setDate(n.getDate() - i * 7), n;
}
class u5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 100);
    ne(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    switch (i) {
      case "I":
        return Ot(Rt.week, n);
      case "Io":
        return r.ordinalNumber(n, { unit: "week" });
      default:
        return Lt(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 53;
  }
  set(n, i, r) {
    return Pa(l5(n, r));
  }
}
const c5 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], d5 = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class f5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 90);
    ne(this, "subPriority", 1);
    ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    switch (i) {
      case "d":
        return Ot(Rt.date, n);
      case "do":
        return r.ordinalNumber(n, { unit: "date" });
      default:
        return Lt(i.length, n);
    }
  }
  validate(n, i) {
    const r = n.getFullYear(), o = O_(r), a = n.getMonth();
    return o ? i >= 1 && i <= d5[a] : i >= 1 && i <= c5[a];
  }
  set(n, i, r) {
    return n.setDate(r), n.setHours(0, 0, 0, 0), n;
  }
}
class h5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 90);
    ne(this, "subpriority", 1);
    ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    switch (i) {
      case "D":
      case "DD":
        return Ot(Rt.dayOfYear, n);
      case "Do":
        return r.ordinalNumber(n, { unit: "date" });
      default:
        return Lt(i.length, n);
    }
  }
  validate(n, i) {
    const r = n.getFullYear();
    return O_(r) ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
  }
  set(n, i, r) {
    return n.setMonth(0, r), n.setHours(0, 0, 0, 0), n;
  }
}
function Vg(e, t, n) {
  var m, h, v, y;
  const i = zo(), r = (n == null ? void 0 : n.weekStartsOn) ?? ((h = (m = n == null ? void 0 : n.locale) == null ? void 0 : m.options) == null ? void 0 : h.weekStartsOn) ?? i.weekStartsOn ?? ((y = (v = i.locale) == null ? void 0 : v.options) == null ? void 0 : y.weekStartsOn) ?? 0, o = Re(e), a = o.getDay(), u = (t % 7 + 7) % 7, d = 7 - r, f = t < 0 || t > 6 ? t - (a + d) % 7 : (u + d) % 7 - (a + d) % 7;
  return Hc(o, f);
}
class g5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 90);
    ne(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(n, { width: "short", context: "formatting" }) || r.day(n, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(n, { width: "short", context: "formatting" }) || r.day(n, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return r.day(n, { width: "wide", context: "formatting" }) || r.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(n, { width: "short", context: "formatting" }) || r.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 6;
  }
  set(n, i, r, o) {
    return n = Vg(n, r, o), n.setHours(0, 0, 0, 0), n;
  }
}
class m5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 90);
    ne(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, r, o) {
    const a = (l) => {
      const u = Math.floor((l - 1) / 7) * 7;
      return (l + o.weekStartsOn + 6) % 7 + u;
    };
    switch (i) {
      case "e":
      case "ee":
        return Ft(Lt(i.length, n), a);
      case "eo":
        return Ft(
          r.ordinalNumber(n, {
            unit: "day"
          }),
          a
        );
      case "eee":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(n, { width: "short", context: "formatting" }) || r.day(n, { width: "narrow", context: "formatting" });
      case "eeeee":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(n, { width: "short", context: "formatting" }) || r.day(n, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return r.day(n, { width: "wide", context: "formatting" }) || r.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(n, { width: "short", context: "formatting" }) || r.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 6;
  }
  set(n, i, r, o) {
    return n = Vg(n, r, o), n.setHours(0, 0, 0, 0), n;
  }
}
class v5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 90);
    ne(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(n, i, r, o) {
    const a = (l) => {
      const u = Math.floor((l - 1) / 7) * 7;
      return (l + o.weekStartsOn + 6) % 7 + u;
    };
    switch (i) {
      case "c":
      case "cc":
        return Ft(Lt(i.length, n), a);
      case "co":
        return Ft(
          r.ordinalNumber(n, {
            unit: "day"
          }),
          a
        );
      case "ccc":
        return r.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(n, { width: "short", context: "standalone" }) || r.day(n, { width: "narrow", context: "standalone" });
      case "ccccc":
        return r.day(n, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(n, { width: "short", context: "standalone" }) || r.day(n, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return r.day(n, { width: "wide", context: "standalone" }) || r.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(n, { width: "short", context: "standalone" }) || r.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 6;
  }
  set(n, i, r, o) {
    return n = Vg(n, r, o), n.setHours(0, 0, 0, 0), n;
  }
}
function p5(e, t) {
  const n = Re(e), i = UN(n), r = t - i;
  return Hc(n, r);
}
class y5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 90);
    ne(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    const o = (a) => a === 0 ? 7 : a;
    switch (i) {
      case "i":
      case "ii":
        return Lt(i.length, n);
      case "io":
        return r.ordinalNumber(n, { unit: "day" });
      case "iii":
        return Ft(
          r.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(n, {
            width: "short",
            context: "formatting"
          }) || r.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiii":
        return Ft(
          r.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiiii":
        return Ft(
          r.day(n, {
            width: "short",
            context: "formatting"
          }) || r.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiii":
      default:
        return Ft(
          r.day(n, {
            width: "wide",
            context: "formatting"
          }) || r.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(n, {
            width: "short",
            context: "formatting"
          }) || r.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 7;
  }
  set(n, i, r) {
    return n = p5(n, r), n.setHours(0, 0, 0, 0), n;
  }
}
class b5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 80);
    ne(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, i, r) {
    return n.setHours(Bg(r), 0, 0, 0), n;
  }
}
class w5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 80);
    ne(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, i, r) {
    return n.setHours(Bg(r), 0, 0, 0), n;
  }
}
class _5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 80);
    ne(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, i, r) {
    return n.setHours(Bg(r), 0, 0, 0), n;
  }
}
class x5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 70);
    ne(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "h":
        return Ot(Rt.hour12h, n);
      case "ho":
        return r.ordinalNumber(n, { unit: "hour" });
      default:
        return Lt(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 12;
  }
  set(n, i, r) {
    const o = n.getHours() >= 12;
    return o && r < 12 ? n.setHours(r + 12, 0, 0, 0) : !o && r === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(r, 0, 0, 0), n;
  }
}
class k5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 70);
    ne(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "H":
        return Ot(Rt.hour23h, n);
      case "Ho":
        return r.ordinalNumber(n, { unit: "hour" });
      default:
        return Lt(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 23;
  }
  set(n, i, r) {
    return n.setHours(r, 0, 0, 0), n;
  }
}
class S5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 70);
    ne(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "K":
        return Ot(Rt.hour11h, n);
      case "Ko":
        return r.ordinalNumber(n, { unit: "hour" });
      default:
        return Lt(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 11;
  }
  set(n, i, r) {
    return n.getHours() >= 12 && r < 12 ? n.setHours(r + 12, 0, 0, 0) : n.setHours(r, 0, 0, 0), n;
  }
}
class C5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 70);
    ne(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "k":
        return Ot(Rt.hour24h, n);
      case "ko":
        return r.ordinalNumber(n, { unit: "hour" });
      default:
        return Lt(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 24;
  }
  set(n, i, r) {
    const o = r <= 24 ? r % 24 : r;
    return n.setHours(o, 0, 0, 0), n;
  }
}
class O5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 60);
    ne(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "m":
        return Ot(Rt.minute, n);
      case "mo":
        return r.ordinalNumber(n, { unit: "minute" });
      default:
        return Lt(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 59;
  }
  set(n, i, r) {
    return n.setMinutes(r, 0, 0), n;
  }
}
class M5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 50);
    ne(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "s":
        return Ot(Rt.second, n);
      case "so":
        return r.ordinalNumber(n, { unit: "second" });
      default:
        return Lt(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 59;
  }
  set(n, i, r) {
    return n.setSeconds(r, 0), n;
  }
}
class T5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 30);
    ne(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, i) {
    const r = (o) => Math.trunc(o * Math.pow(10, -i.length + 3));
    return Ft(Lt(i.length, n), r);
  }
  set(n, i, r) {
    return n.setMilliseconds(r), n;
  }
}
class P5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 10);
    ne(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(n, i) {
    switch (i) {
      case "X":
        return Bi(
          Li.basicOptionalMinutes,
          n
        );
      case "XX":
        return Bi(Li.basic, n);
      case "XXXX":
        return Bi(
          Li.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return Bi(
          Li.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return Bi(Li.extended, n);
    }
  }
  set(n, i, r) {
    return i.timestampIsSet ? n : wt(
      n,
      n.getTime() - vc(n) - r
    );
  }
}
class A5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 10);
    ne(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(n, i) {
    switch (i) {
      case "x":
        return Bi(
          Li.basicOptionalMinutes,
          n
        );
      case "xx":
        return Bi(Li.basic, n);
      case "xxxx":
        return Bi(
          Li.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return Bi(
          Li.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return Bi(Li.extended, n);
    }
  }
  set(n, i, r) {
    return i.timestampIsSet ? n : wt(
      n,
      n.getTime() - vc(n) - r
    );
  }
}
class E5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 40);
    ne(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return S_(n);
  }
  set(n, i, r) {
    return [wt(n, r * 1e3), { timestampIsSet: !0 }];
  }
}
class I5 extends st {
  constructor() {
    super(...arguments);
    ne(this, "priority", 20);
    ne(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return S_(n);
  }
  set(n, i, r) {
    return [wt(n, r), { timestampIsSet: !0 }];
  }
}
const D5 = {
  G: new ZN(),
  y: new QN(),
  Y: new JN(),
  R: new e5(),
  u: new t5(),
  Q: new n5(),
  q: new i5(),
  M: new r5(),
  L: new o5(),
  w: new s5(),
  I: new u5(),
  d: new f5(),
  D: new h5(),
  E: new g5(),
  e: new m5(),
  c: new v5(),
  i: new y5(),
  a: new b5(),
  b: new w5(),
  B: new _5(),
  h: new x5(),
  H: new k5(),
  K: new S5(),
  k: new C5(),
  m: new O5(),
  s: new M5(),
  S: new T5(),
  X: new P5(),
  x: new A5(),
  t: new E5(),
  T: new I5()
}, L5 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, B5 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, V5 = /^'([^]*?)'?$/, $5 = /''/g, R5 = /\S/, F5 = /[a-zA-Z]/;
function N5(e, t, n, i) {
  var p, b, x, _, O, D, F, $;
  const r = YN(), o = (i == null ? void 0 : i.locale) ?? r.locale ?? p_, a = (i == null ? void 0 : i.firstWeekContainsDate) ?? ((b = (p = i == null ? void 0 : i.locale) == null ? void 0 : p.options) == null ? void 0 : b.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((_ = (x = r.locale) == null ? void 0 : x.options) == null ? void 0 : _.firstWeekContainsDate) ?? 1, l = (i == null ? void 0 : i.weekStartsOn) ?? ((D = (O = i == null ? void 0 : i.locale) == null ? void 0 : O.options) == null ? void 0 : D.weekStartsOn) ?? r.weekStartsOn ?? (($ = (F = r.locale) == null ? void 0 : F.options) == null ? void 0 : $.weekStartsOn) ?? 0;
  if (t === "")
    return e === "" ? Re(n) : wt(n, NaN);
  const u = {
    firstWeekContainsDate: a,
    weekStartsOn: l,
    locale: o
  }, d = [new KN()], f = t.match(B5).map((A) => {
    const k = A[0];
    if (k in Eh) {
      const S = Eh[k];
      return S(A, o.formatLong);
    }
    return A;
  }).join("").match(L5), m = [];
  for (let A of f) {
    !(i != null && i.useAdditionalWeekYearTokens) && x_(A) && Ih(A, t, e), !(i != null && i.useAdditionalDayOfYearTokens) && __(A) && Ih(A, t, e);
    const k = A[0], S = D5[k];
    if (S) {
      const { incompatibleTokens: M } = S;
      if (Array.isArray(M)) {
        const I = m.find(
          (L) => M.includes(L.token) || L.token === k
        );
        if (I)
          throw new RangeError(
            `The format string mustn't contain \`${I.fullToken}\` and \`${A}\` at the same time`
          );
      } else if (S.incompatibleTokens === "*" && m.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${A}\` and any other token at the same time`
        );
      m.push({ token: k, fullToken: A });
      const E = S.run(
        e,
        A,
        o.match,
        u
      );
      if (!E)
        return wt(n, NaN);
      d.push(E.setter), e = E.rest;
    } else {
      if (k.match(F5))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + k + "`"
        );
      if (A === "''" ? A = "'" : k === "'" && (A = W5(A)), e.indexOf(A) === 0)
        e = e.slice(A.length);
      else
        return wt(n, NaN);
    }
  }
  if (e.length > 0 && R5.test(e))
    return wt(n, NaN);
  const h = d.map((A) => A.priority).sort((A, k) => k - A).filter((A, k, S) => S.indexOf(A) === k).map(
    (A) => d.filter((k) => k.priority === A).sort((k, S) => S.subPriority - k.subPriority)
  ).map((A) => A[0]);
  let v = Re(n);
  if (isNaN(v.getTime()))
    return wt(n, NaN);
  const y = {};
  for (const A of h) {
    if (!A.validate(v, u))
      return wt(n, NaN);
    const k = A.set(v, y, u);
    Array.isArray(k) ? (v = k[0], Object.assign(y, k[1])) : v = k;
  }
  return wt(n, v);
}
function W5(e) {
  return e.match(V5)[1].replace($5, "'");
}
function z5(e) {
  const t = Re(e);
  return t.setMinutes(0, 0, 0), t;
}
function H5(e) {
  const t = Re(e);
  return t.setMilliseconds(0), t;
}
function j5(e, t) {
  const n = (t == null ? void 0 : t.additionalDigits) ?? 2, i = G5(e);
  let r;
  if (i.date) {
    const u = X5(i.date, n);
    r = K5(u.restDateString, u.year);
  }
  if (!r || isNaN(r.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const o = r.getTime();
  let a = 0, l;
  if (i.time && (a = Z5(i.time), isNaN(a)))
    return /* @__PURE__ */ new Date(NaN);
  if (i.timezone) {
    if (l = Q5(i.timezone), isNaN(l))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const u = new Date(o + a), d = /* @__PURE__ */ new Date(0);
    return d.setFullYear(
      u.getUTCFullYear(),
      u.getUTCMonth(),
      u.getUTCDate()
    ), d.setHours(
      u.getUTCHours(),
      u.getUTCMinutes(),
      u.getUTCSeconds(),
      u.getUTCMilliseconds()
    ), d;
  }
  return new Date(o + a + l);
}
const Pu = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Y5 = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, U5 = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, q5 = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function G5(e) {
  const t = {}, n = e.split(Pu.dateTimeDelimiter);
  let i;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? i = n[0] : (t.date = n[0], i = n[1], Pu.timeZoneDelimiter.test(t.date) && (t.date = e.split(Pu.timeZoneDelimiter)[0], i = e.substr(
    t.date.length,
    e.length
  ))), i) {
    const r = Pu.timezone.exec(i);
    r ? (t.time = i.replace(r[1], ""), t.timezone = r[1]) : t.time = i;
  }
  return t;
}
function X5(e, t) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), i = e.match(n);
  if (!i)
    return { year: NaN, restDateString: "" };
  const r = i[1] ? parseInt(i[1]) : null, o = i[2] ? parseInt(i[2]) : null;
  return {
    year: o === null ? r : o * 100,
    restDateString: e.slice((i[1] || i[2]).length)
  };
}
function K5(e, t) {
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  const n = e.match(Y5);
  if (!n)
    return /* @__PURE__ */ new Date(NaN);
  const i = !!n[4], r = ps(n[1]), o = ps(n[2]) - 1, a = ps(n[3]), l = ps(n[4]), u = ps(n[5]) - 1;
  if (i)
    return i3(t, l, u) ? J5(t, l, u) : /* @__PURE__ */ new Date(NaN);
  {
    const d = /* @__PURE__ */ new Date(0);
    return !t3(t, o, a) || !n3(t, r) ? /* @__PURE__ */ new Date(NaN) : (d.setUTCFullYear(t, o, Math.max(r, a)), d);
  }
}
function ps(e) {
  return e ? parseInt(e) : 1;
}
function Z5(e) {
  const t = e.match(U5);
  if (!t)
    return NaN;
  const n = qf(t[1]), i = qf(t[2]), r = qf(t[3]);
  return r3(n, i, r) ? n * fl + i * dl + r * 1e3 : NaN;
}
function qf(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function Q5(e) {
  if (e === "Z")
    return 0;
  const t = e.match(q5);
  if (!t)
    return 0;
  const n = t[1] === "+" ? -1 : 1, i = parseInt(t[2]), r = t[3] && parseInt(t[3]) || 0;
  return o3(i, r) ? n * (i * fl + r * dl) : NaN;
}
function J5(e, t, n) {
  const i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(e, 0, 4);
  const r = i.getUTCDay() || 7, o = (t - 1) * 7 + n + 1 - r;
  return i.setUTCDate(i.getUTCDate() + o), i;
}
const e3 = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function M_(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function t3(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (e3[t] || (M_(e) ? 29 : 28));
}
function n3(e, t) {
  return t >= 1 && t <= (M_(e) ? 366 : 365);
}
function i3(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function r3(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function o3(e, t) {
  return t >= 0 && t <= 59;
}
/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */
const a3 = {
  datetime: "MMM d, yyyy, h:mm:ss aaaa",
  millisecond: "h:mm:ss.SSS aaaa",
  second: "h:mm:ss aaaa",
  minute: "h:mm aaaa",
  hour: "ha",
  day: "MMM d",
  week: "PP",
  month: "MMM yyyy",
  quarter: "qqq - yyyy",
  year: "yyyy"
};
Ww._date.override({
  _id: "date-fns",
  // DEBUG
  formats: function() {
    return a3;
  },
  parse: function(e, t) {
    if (e === null || typeof e > "u")
      return null;
    const n = typeof e;
    return n === "number" || e instanceof Date ? e = Re(e) : n === "string" && (typeof t == "string" ? e = N5(e, t, /* @__PURE__ */ new Date(), this.options) : e = j5(e, this.options)), d_(e) ? e.getTime() : null;
  },
  format: function(e, t) {
    return HN(e, t, this.options);
  },
  add: function(e, t, n) {
    switch (n) {
      case "millisecond":
        return jc(e, t);
      case "second":
        return EF(e, t);
      case "minute":
        return PF(e, t);
      case "hour":
        return OF(e, t);
      case "day":
        return Hc(e, t);
      case "week":
        return IF(e, t);
      case "month":
        return Dg(e, t);
      case "quarter":
        return AF(e, t);
      case "year":
        return DF(e, t);
      default:
        return e;
    }
  },
  diff: function(e, t, n) {
    switch (n) {
      case "millisecond":
        return Yc(e, t);
      case "second":
        return WF(e, t);
      case "minute":
        return RF(e, t);
      case "hour":
        return $F(e, t);
      case "day":
        return f_(e, t);
      case "week":
        return zF(e, t);
      case "month":
        return m_(e, t);
      case "quarter":
        return NF(e, t);
      case "year":
        return HF(e, t);
      default:
        return 0;
    }
  },
  startOf: function(e, t, n) {
    switch (t) {
      case "second":
        return H5(e);
      case "minute":
        return jF(e);
      case "hour":
        return z5(e);
      case "day":
        return Ah(e);
      case "week":
        return Ni(e);
      case "isoWeek":
        return Ni(e, { weekStartsOn: +n });
      case "month":
        return UF(e);
      case "quarter":
        return YF(e);
      case "year":
        return v_(e);
      default:
        return e;
    }
  },
  endOf: function(e, t) {
    switch (t) {
      case "second":
        return QF(e);
      case "minute":
        return KF(e);
      case "hour":
        return GF(e);
      case "day":
        return h_(e);
      case "week":
        return XF(e);
      case "month":
        return g_(e);
      case "quarter":
        return ZF(e);
      case "year":
        return qF(e);
      default:
        return e;
    }
  }
});
Bn.register(xs, Mh, IR, RR, Th, Fr, Wu, qs, UR);
Bn.defaults.backgroundColor = "#000000";
Bn.defaults.borderColor = "#000000";
Bn.defaults.color = "#ACBBCD";
Bn.defaults.font.family = "Geist";
Bn.defaults.plugins.legend.position = "bottom";
Bn.defaults.elements.point.radius = 1;
Bn.defaults.elements.arc.borderWidth = 0;
Bn.defaults.elements.arc.circular = !0;
Bn.defaults.elements.line.borderCapStyle = "round";
Bn.defaults.elements.line.borderColor = "#342DEC";
const s3 = {
  name: "OtChartDoughnut",
  customOptions: {}
}, T_ = /* @__PURE__ */ Ae({
  ...s3,
  props: {
    data: { type: Object, required: !0 },
    options: { type: Object, default: () => ({ responsive: !0, maintainAspectRatio: !1 }) },
    loaded: { type: Boolean, required: !0 }
  },
  setup(e, { expose: t }) {
    const n = ie();
    return t({
      doughnut: n
    }), (i, r) => (ee(), Ne(Be(xF), ge({
      ref_key: "doughnut",
      ref: n,
      class: "ot-chart-doughnut",
      data: e.data,
      options: e.options
    }, i.$attrs), null, 16, ["data", "options"]));
  }
}), l3 = {
  name: "OtChartLine",
  customOptions: {}
}, P_ = /* @__PURE__ */ Ae({
  ...l3,
  props: {
    data: { type: Object, required: !0 },
    options: { type: Object, default: () => ({ responsive: !0, maintainAspectRatio: !1 }) }
  },
  setup(e, { expose: t }) {
    const n = ie();
    return t({
      line: n
    }), (i, r) => (ee(), Ne(Be(kF), ge({
      ref_key: "line",
      ref: n,
      class: "ot-chart-line",
      data: e.data,
      options: e.options
    }, i.$attrs), null, 16, ["data", "options"]));
  }
}), u3 = ["testid"], c3 = ["for"], d3 = ["id", "disabled", "value", "checked"], f3 = { key: 1 }, h3 = {
  name: "OtCheckbox",
  customOptions: {}
}, $g = /* @__PURE__ */ Ae({
  ...h3,
  props: {
    colorVariant: { type: String, default: "dark" },
    description: { type: String, required: !1 },
    disabled: { type: Boolean, default: !1 },
    iconClass: { type: String, required: !1 },
    label: { type: String, required: !1 },
    labelPosition: { type: String, default: "right" },
    labelVariant: { type: String, default: "default" },
    name: { type: String, default: () => `ot-checkbox-${crypto.randomUUID()}` },
    selected: { type: [Array, Boolean], required: !1 },
    value: { type: [String, Boolean], default: !0 },
    verticallyCentered: { type: Boolean, default: !1 }
  },
  emits: ["update:selected"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = B(() => Array.isArray(n.selected) ? n.selected.includes(n.value) : n.selected === n.value), o = B(() => n.labelPosition === "right"), a = B(() => {
      const f = "ot-checkbox__icon ot-checkbox__icon--checked", m = "ot-checkbox__icon ot-checkbox__icon--unchecked", h = "checkmark", v = {
        name: h,
        class: n.iconClass ? `${m} ${n.iconClass}` : m
      };
      return r.value && (v.name = h, v.class = n.iconClass ? `${f} ${n.iconClass}` : f), v;
    }), l = B(() => {
      const f = "ot-checkbox__layout";
      let m = f;
      return n.description ? o.value ? m = `${m} ${f}--description` : m = `${m} ${f}--description-left` : o.value || (m = `${m} ${f}--left`), m;
    }), u = () => {
      if (!Array.isArray(n.selected))
        return !r.value;
      const f = n.selected.slice(), m = n.value;
      return r.value ? f.splice(n.selected.indexOf(m), 1) : f.push(m), f;
    }, d = () => {
      i("update:selected", u());
    };
    return (f, m) => (ee(), ce("div", {
      class: we(["ot-checkbox", [`ot-checkbox--${e.colorVariant}`, { "ot-checkbox--disabled": e.disabled, "ot-checkbox--v-centered": e.verticallyCentered }]]),
      testid: e.name
    }, [
      ve("label", { for: e.name }, [
        ve("input", {
          id: e.name,
          class: "ot-checkbox__input",
          type: "checkbox",
          disabled: e.disabled,
          value: e.value,
          checked: r.value,
          onChange: d
        }, null, 40, d3),
        ve("div", {
          class: we(["ot-checkbox__label", l.value])
        }, [
          ve("div", {
            class: we([`ot-checkbox__label--${e.labelVariant}`])
          }, [
            f.$slots.label ? De(f.$slots, "label", { key: 0 }) : (ee(), ce("div", f3, Ue(e.label), 1))
          ], 2),
          T(qt, {
            class: we(a.value.class),
            name: a.value.name,
            testid: "checkbox"
          }, null, 8, ["class", "name"]),
          e.description ? (ee(), ce("div", {
            key: 0,
            class: we(["ot-checkbox__description", ["ot-checkbox__description"]])
          }, Ue(e.description), 1)) : Fe("", !0)
        ], 2)
      ], 8, c3)
    ], 10, u3));
  }
}), g3 = {
  name: "OtCheckboxPositiveUi",
  customOptions: {}
}, A_ = /* @__PURE__ */ Ae({
  ...g3,
  props: {
    label: { type: String, required: !1 },
    labelPosition: { type: String, default: "right" },
    onCheckAction: { type: Function, required: !0 },
    onCheckActionFailed: { type: Function, default: () => Promise.resolve() },
    selected: { type: Boolean, required: !1 },
    verticallyCentered: { type: Boolean, required: !1 }
  },
  emits: ["update:selected"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = ie(!!n.selected);
    pe(
      () => n.selected,
      (a) => {
        r.value = !!a;
      }
    );
    const o = B({
      get: () => !!r.value,
      set: (a) => {
        r.value = a, n.onCheckAction({ value: a }).catch(() => {
          n.onCheckActionFailed(), r.value = !!n.selected;
        }).finally(() => {
          i("update:selected", r.value);
        });
      }
    });
    return (a, l) => (ee(), Ne($g, {
      selected: o.value,
      "onUpdate:selected": l[0] || (l[0] = (u) => o.value = u),
      class: "ot-checkbox-positive-ui",
      "label-position": e.labelPosition,
      label: e.label,
      "vertically-centered": e.verticallyCentered
    }, null, 8, ["selected", "label-position", "label", "vertically-centered"]));
  }
});
/*!
  * @soerenmartius/vue3-clipboard v0.1.2
  * (c) 2021 Soeren Martius
  * @license MIT
  */
var m3 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function v3(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function p3(e, t, n) {
  return n = {
    path: t,
    exports: {},
    require: function(i, r) {
      return y3(i, r ?? n.path);
    }
  }, e(n, n.exports), n.exports;
}
function y3() {
  throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var b3 = p3(function(e, t) {
  /*!
   * clipboard.js v2.0.6
   * https://clipboardjs.com/
   * 
   * Licensed MIT © Zeno Rocha
   */
  (function(i, r) {
    e.exports = r();
  })(m3, function() {
    return (
      /******/
      function(n) {
        var i = {};
        function r(o) {
          if (i[o])
            return i[o].exports;
          var a = i[o] = {
            /******/
            i: o,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return n[o].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
        }
        return r.m = n, r.c = i, r.d = function(o, a, l) {
          r.o(o, a) || Object.defineProperty(o, a, { enumerable: !0, get: l });
        }, r.r = function(o) {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
        }, r.t = function(o, a) {
          if (a & 1 && (o = r(o)), a & 8 || a & 4 && typeof o == "object" && o && o.__esModule)
            return o;
          var l = /* @__PURE__ */ Object.create(null);
          if (r.r(l), Object.defineProperty(l, "default", { enumerable: !0, value: o }), a & 2 && typeof o != "string")
            for (var u in o)
              r.d(l, u, (function(d) {
                return o[d];
              }).bind(null, u));
          return l;
        }, r.n = function(o) {
          var a = o && o.__esModule ? (
            /******/
            function() {
              return o.default;
            }
          ) : (
            /******/
            function() {
              return o;
            }
          );
          return r.d(a, "a", a), a;
        }, r.o = function(o, a) {
          return Object.prototype.hasOwnProperty.call(o, a);
        }, r.p = "", r(r.s = 6);
      }([
        /* 0 */
        /***/
        function(n, i) {
          function r(o) {
            var a;
            if (o.nodeName === "SELECT")
              o.focus(), a = o.value;
            else if (o.nodeName === "INPUT" || o.nodeName === "TEXTAREA") {
              var l = o.hasAttribute("readonly");
              l || o.setAttribute("readonly", ""), o.select(), o.setSelectionRange(0, o.value.length), l || o.removeAttribute("readonly"), a = o.value;
            } else {
              o.hasAttribute("contenteditable") && o.focus();
              var u = window.getSelection(), d = document.createRange();
              d.selectNodeContents(o), u.removeAllRanges(), u.addRange(d), a = u.toString();
            }
            return a;
          }
          n.exports = r;
        },
        /* 1 */
        /***/
        function(n, i) {
          function r() {
          }
          r.prototype = {
            on: function(o, a, l) {
              var u = this.e || (this.e = {});
              return (u[o] || (u[o] = [])).push({
                fn: a,
                ctx: l
              }), this;
            },
            once: function(o, a, l) {
              var u = this;
              function d() {
                u.off(o, d), a.apply(l, arguments);
              }
              return d._ = a, this.on(o, d, l);
            },
            emit: function(o) {
              var a = [].slice.call(arguments, 1), l = ((this.e || (this.e = {}))[o] || []).slice(), u = 0, d = l.length;
              for (u; u < d; u++)
                l[u].fn.apply(l[u].ctx, a);
              return this;
            },
            off: function(o, a) {
              var l = this.e || (this.e = {}), u = l[o], d = [];
              if (u && a)
                for (var f = 0, m = u.length; f < m; f++)
                  u[f].fn !== a && u[f].fn._ !== a && d.push(u[f]);
              return d.length ? l[o] = d : delete l[o], this;
            }
          }, n.exports = r, n.exports.TinyEmitter = r;
        },
        /* 2 */
        /***/
        function(n, i, r) {
          var o = r(3), a = r(4);
          function l(m, h, v) {
            if (!m && !h && !v)
              throw new Error("Missing required arguments");
            if (!o.string(h))
              throw new TypeError("Second argument must be a String");
            if (!o.fn(v))
              throw new TypeError("Third argument must be a Function");
            if (o.node(m))
              return u(m, h, v);
            if (o.nodeList(m))
              return d(m, h, v);
            if (o.string(m))
              return f(m, h, v);
            throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
          }
          function u(m, h, v) {
            return m.addEventListener(h, v), {
              destroy: function() {
                m.removeEventListener(h, v);
              }
            };
          }
          function d(m, h, v) {
            return Array.prototype.forEach.call(m, function(y) {
              y.addEventListener(h, v);
            }), {
              destroy: function() {
                Array.prototype.forEach.call(m, function(y) {
                  y.removeEventListener(h, v);
                });
              }
            };
          }
          function f(m, h, v) {
            return a(document.body, m, h, v);
          }
          n.exports = l;
        },
        /* 3 */
        /***/
        function(n, i) {
          i.node = function(r) {
            return r !== void 0 && r instanceof HTMLElement && r.nodeType === 1;
          }, i.nodeList = function(r) {
            var o = Object.prototype.toString.call(r);
            return r !== void 0 && (o === "[object NodeList]" || o === "[object HTMLCollection]") && "length" in r && (r.length === 0 || i.node(r[0]));
          }, i.string = function(r) {
            return typeof r == "string" || r instanceof String;
          }, i.fn = function(r) {
            var o = Object.prototype.toString.call(r);
            return o === "[object Function]";
          };
        },
        /* 4 */
        /***/
        function(n, i, r) {
          var o = r(5);
          function a(d, f, m, h, v) {
            var y = u.apply(this, arguments);
            return d.addEventListener(m, y, v), {
              destroy: function() {
                d.removeEventListener(m, y, v);
              }
            };
          }
          function l(d, f, m, h, v) {
            return typeof d.addEventListener == "function" ? a.apply(null, arguments) : typeof m == "function" ? a.bind(null, document).apply(null, arguments) : (typeof d == "string" && (d = document.querySelectorAll(d)), Array.prototype.map.call(d, function(y) {
              return a(y, f, m, h, v);
            }));
          }
          function u(d, f, m, h) {
            return function(v) {
              v.delegateTarget = o(v.target, f), v.delegateTarget && h.call(d, v);
            };
          }
          n.exports = l;
        },
        /* 5 */
        /***/
        function(n, i) {
          var r = 9;
          if (typeof Element < "u" && !Element.prototype.matches) {
            var o = Element.prototype;
            o.matches = o.matchesSelector || o.mozMatchesSelector || o.msMatchesSelector || o.oMatchesSelector || o.webkitMatchesSelector;
          }
          function a(l, u) {
            for (; l && l.nodeType !== r; ) {
              if (typeof l.matches == "function" && l.matches(u))
                return l;
              l = l.parentNode;
            }
          }
          n.exports = a;
        },
        /* 6 */
        /***/
        function(n, i, r) {
          r.r(i);
          var o = r(0), a = /* @__PURE__ */ r.n(o), l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
            return typeof A;
          } : function(A) {
            return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
          }, u = /* @__PURE__ */ function() {
            function A(k, S) {
              for (var M = 0; M < S.length; M++) {
                var E = S[M];
                E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(k, E.key, E);
              }
            }
            return function(k, S, M) {
              return S && A(k.prototype, S), M && A(k, M), k;
            };
          }();
          function d(A, k) {
            if (!(A instanceof k))
              throw new TypeError("Cannot call a class as a function");
          }
          var f = function() {
            function A(k) {
              d(this, A), this.resolveOptions(k), this.initSelection();
            }
            return u(A, [{
              key: "resolveOptions",
              value: function() {
                var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.action = S.action, this.container = S.container, this.emitter = S.emitter, this.target = S.target, this.text = S.text, this.trigger = S.trigger, this.selectedText = "";
              }
              /**
               * Decides which selection strategy is going to be applied based
               * on the existence of `text` and `target` properties.
               */
            }, {
              key: "initSelection",
              value: function() {
                this.text ? this.selectFake() : this.target && this.selectTarget();
              }
              /**
               * Creates a fake textarea element, sets its value from `text` property,
               * and makes a selection on it.
               */
            }, {
              key: "selectFake",
              value: function() {
                var S = this, M = document.documentElement.getAttribute("dir") == "rtl";
                this.removeFake(), this.fakeHandlerCallback = function() {
                  return S.removeFake();
                }, this.fakeHandler = this.container.addEventListener("click", this.fakeHandlerCallback) || !0, this.fakeElem = document.createElement("textarea"), this.fakeElem.style.fontSize = "12pt", this.fakeElem.style.border = "0", this.fakeElem.style.padding = "0", this.fakeElem.style.margin = "0", this.fakeElem.style.position = "absolute", this.fakeElem.style[M ? "right" : "left"] = "-9999px";
                var E = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = E + "px", this.fakeElem.setAttribute("readonly", ""), this.fakeElem.value = this.text, this.container.appendChild(this.fakeElem), this.selectedText = a()(this.fakeElem), this.copyText();
              }
              /**
               * Only removes the fake element after another click event, that way
               * a user can hit `Ctrl+C` to copy because selection still exists.
               */
            }, {
              key: "removeFake",
              value: function() {
                this.fakeHandler && (this.container.removeEventListener("click", this.fakeHandlerCallback), this.fakeHandler = null, this.fakeHandlerCallback = null), this.fakeElem && (this.container.removeChild(this.fakeElem), this.fakeElem = null);
              }
              /**
               * Selects the content from element passed on `target` property.
               */
            }, {
              key: "selectTarget",
              value: function() {
                this.selectedText = a()(this.target), this.copyText();
              }
              /**
               * Executes the copy operation based on the current selection.
               */
            }, {
              key: "copyText",
              value: function() {
                var S = void 0;
                try {
                  S = document.execCommand(this.action);
                } catch {
                  S = !1;
                }
                this.handleResult(S);
              }
              /**
               * Fires an event based on the copy operation result.
               * @param {Boolean} succeeded
               */
            }, {
              key: "handleResult",
              value: function(S) {
                this.emitter.emit(S ? "success" : "error", {
                  action: this.action,
                  text: this.selectedText,
                  trigger: this.trigger,
                  clearSelection: this.clearSelection.bind(this)
                });
              }
              /**
               * Moves focus away from `target` and back to the trigger, removes current selection.
               */
            }, {
              key: "clearSelection",
              value: function() {
                this.trigger && this.trigger.focus(), document.activeElement.blur(), window.getSelection().removeAllRanges();
              }
              /**
               * Sets the `action` to be performed which can be either 'copy' or 'cut'.
               * @param {String} action
               */
            }, {
              key: "destroy",
              /**
               * Destroy lifecycle.
               */
              value: function() {
                this.removeFake();
              }
            }, {
              key: "action",
              set: function() {
                var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "copy";
                if (this._action = S, this._action !== "copy" && this._action !== "cut")
                  throw new Error('Invalid "action" value, use either "copy" or "cut"');
              },
              get: function() {
                return this._action;
              }
              /**
               * Sets the `target` property using an element
               * that will be have its content copied.
               * @param {Element} target
               */
            }, {
              key: "target",
              set: function(S) {
                if (S !== void 0)
                  if (S && (typeof S > "u" ? "undefined" : l(S)) === "object" && S.nodeType === 1) {
                    if (this.action === "copy" && S.hasAttribute("disabled"))
                      throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                    if (this.action === "cut" && (S.hasAttribute("readonly") || S.hasAttribute("disabled")))
                      throw new Error(`Invalid "target" attribute. You can't cut text from elements with "readonly" or "disabled" attributes`);
                    this._target = S;
                  } else
                    throw new Error('Invalid "target" value, use a valid Element');
              },
              get: function() {
                return this._target;
              }
            }]), A;
          }(), m = f, h = r(1), v = /* @__PURE__ */ r.n(h), y = r(2), p = /* @__PURE__ */ r.n(y), b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
            return typeof A;
          } : function(A) {
            return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
          }, x = /* @__PURE__ */ function() {
            function A(k, S) {
              for (var M = 0; M < S.length; M++) {
                var E = S[M];
                E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(k, E.key, E);
              }
            }
            return function(k, S, M) {
              return S && A(k.prototype, S), M && A(k, M), k;
            };
          }();
          function _(A, k) {
            if (!(A instanceof k))
              throw new TypeError("Cannot call a class as a function");
          }
          function O(A, k) {
            if (!A)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return k && (typeof k == "object" || typeof k == "function") ? k : A;
          }
          function D(A, k) {
            if (typeof k != "function" && k !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof k);
            A.prototype = Object.create(k && k.prototype, { constructor: { value: A, enumerable: !1, writable: !0, configurable: !0 } }), k && (Object.setPrototypeOf ? Object.setPrototypeOf(A, k) : A.__proto__ = k);
          }
          var F = function(A) {
            D(k, A);
            function k(S, M) {
              _(this, k);
              var E = O(this, (k.__proto__ || Object.getPrototypeOf(k)).call(this));
              return E.resolveOptions(M), E.listenClick(S), E;
            }
            return x(k, [{
              key: "resolveOptions",
              value: function() {
                var M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.action = typeof M.action == "function" ? M.action : this.defaultAction, this.target = typeof M.target == "function" ? M.target : this.defaultTarget, this.text = typeof M.text == "function" ? M.text : this.defaultText, this.container = b(M.container) === "object" ? M.container : document.body;
              }
              /**
               * Adds a click event listener to the passed trigger.
               * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
               */
            }, {
              key: "listenClick",
              value: function(M) {
                var E = this;
                this.listener = p()(M, "click", function(I) {
                  return E.onClick(I);
                });
              }
              /**
               * Defines a new `ClipboardAction` on each click event.
               * @param {Event} e
               */
            }, {
              key: "onClick",
              value: function(M) {
                var E = M.delegateTarget || M.currentTarget;
                this.clipboardAction && (this.clipboardAction = null), this.clipboardAction = new m({
                  action: this.action(E),
                  target: this.target(E),
                  text: this.text(E),
                  container: this.container,
                  trigger: E,
                  emitter: this
                });
              }
              /**
               * Default `action` lookup function.
               * @param {Element} trigger
               */
            }, {
              key: "defaultAction",
              value: function(M) {
                return $("action", M);
              }
              /**
               * Default `target` lookup function.
               * @param {Element} trigger
               */
            }, {
              key: "defaultTarget",
              value: function(M) {
                var E = $("target", M);
                if (E)
                  return document.querySelector(E);
              }
              /**
               * Returns the support of the given action, or all actions if no action is
               * given.
               * @param {String} [action]
               */
            }, {
              key: "defaultText",
              /**
               * Default `text` lookup function.
               * @param {Element} trigger
               */
              value: function(M) {
                return $("text", M);
              }
              /**
               * Destroy lifecycle.
               */
            }, {
              key: "destroy",
              value: function() {
                this.listener.destroy(), this.clipboardAction && (this.clipboardAction.destroy(), this.clipboardAction = null);
              }
            }], [{
              key: "isSupported",
              value: function() {
                var M = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["copy", "cut"], E = typeof M == "string" ? [M] : M, I = !!document.queryCommandSupported;
                return E.forEach(function(L) {
                  I = I && !!document.queryCommandSupported(L);
                }), I;
              }
            }]), k;
          }(v.a);
          function $(A, k) {
            var S = "data-clipboard-" + A;
            if (k.hasAttribute(S))
              return k.getAttribute(S);
          }
          i.default = F;
        }
        /******/
      ]).default
    );
  });
}), w3 = /* @__PURE__ */ v3(b3);
const E_ = (e, t = "copy") => new Promise((n, i) => {
  const r = document.createElement("button"), o = new w3(r, {
    text: () => e,
    action: () => t
  });
  o.on("success", (a) => {
    o.destroy(), n(a);
  }), o.on("error", (a) => {
    o.destroy(), i(a);
  }), document.body.appendChild(r), r.click(), document.body.removeChild(r);
}), _3 = { class: "ot-copy-textbox__label" }, x3 = {
  key: 0,
  class: "ot-copy-textbox__label--warning"
}, k3 = { class: "ot-copy-textbox__wrapper" }, S3 = { class: "ot-copy-textbox__value user-select" }, C3 = ["value"], O3 = {
  key: 0,
  class: "ot-copy-textbox__outer-right"
}, M3 = { class: "ot-copy-textbox__controls" }, T3 = {
  name: "OtCopyTextbox",
  customOptions: {}
}, I_ = /* @__PURE__ */ Ae({
  ...T3,
  props: {
    outerRight: { type: String, default: "" },
    label: { type: String, default: "" },
    labelWarning: { type: String, default: "" },
    onError: { type: Function, default: () => {
    } },
    onSuccess: { type: Function, default: () => {
    } },
    value: { type: [String, Number], default: "" },
    variant: { type: String, required: !0 }
  },
  setup(e) {
    const t = e, n = () => {
      var o;
      (o = t.onSuccess) == null || o.call(t);
    }, i = () => {
      var o;
      (o = t.onError) == null || o.call(t);
    }, r = async () => {
      try {
        await E_(t.value.toString()), n();
      } catch {
        i();
      }
    };
    return (o, a) => (ee(), ce("div", {
      class: we(["ot-copy-textbox", [`ot-copy-textbox--${e.variant}`]])
    }, [
      ve("div", _3, Ue(e.label), 1),
      e.labelWarning ? (ee(), ce("div", x3, Ue(e.labelWarning), 1)) : Fe("", !0),
      ve("div", k3, [
        ve("span", S3, Ue(e.value), 1),
        ve("input", {
          ref: "copyContentField",
          value: e.value,
          type: "hidden"
        }, null, 8, C3),
        e.outerRight ? (ee(), ce("div", O3, [
          ve("span", null, Ue(e.outerRight), 1)
        ])) : Fe("", !0),
        ve("span", M3, [
          ve("a", {
            class: "ot-copy-textbox__anchor",
            onClick: r
          }, [
            T(qt, {
              class: "ot-copy-textbox__copy-icon",
              name: "copy"
            })
          ])
        ])
      ])
    ], 2));
  }
}), P3 = {
  name: "OtDetails",
  customOptions: {}
}, Uc = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [i, r] of t)
    n[i] = r;
  return n;
}, A3 = { class: "ot-details" };
function E3(e, t, n, i, r, o) {
  return ee(), ce("div", A3, [
    De(e.$slots, "default")
  ]);
}
const D_ = /* @__PURE__ */ Uc(P3, [["render", E3]]), I3 = {
  name: "OtDetailsRow",
  customOptions: {}
}, D3 = { class: "ot-details-row" };
function L3(e, t, n, i, r, o) {
  return ee(), ce("div", D3, [
    De(e.$slots, "default")
  ]);
}
const L_ = /* @__PURE__ */ Uc(I3, [["render", L3]]), B3 = (e, t) => {
  t && (e.style.transformOrigin = t);
}, yc = (e, t, n) => {
  B3(e, n), Object.keys(t).forEach((i) => {
    const r = t[i];
    r && (e.style[i] = r);
  });
}, B_ = (e, t) => {
  t && (e.style.position = "absolute");
}, V3 = {
  name: "OtTransitionCollapse",
  customOptions: {}
}, Rg = /* @__PURE__ */ Ae({
  ...V3,
  props: {
    appear: { type: Boolean, default: !1 },
    delay: { type: [Number, Object], default: 0 },
    duration: { type: [Number, Object], default: 300 },
    group: { type: Boolean, default: !1 },
    origin: { type: String, default: "" },
    tag: { type: String, default: "div" },
    styles: {
      type: Object,
      default: () => ({
        animationFillMode: "both",
        animationTimingFunction: "ease-out"
      })
    }
  },
  emits: ["before-enter", "after-enter", "before-leave", "leave"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = (h = 300) => {
      const v = h / 1e3;
      return `${v}s height ease-in-out, ${v}s padding-top ease-in-out, ${v}s padding-bottom ease-in-out`;
    }, o = (h) => {
      let v;
      typeof n.duration == "number" ? v = n.duration : v = n.duration.enter, h.style.transition = r(v), h.dataset.oldPaddingTop = h.style.paddingTop, h.dataset.oldPaddingBottom = h.style.paddingBottom, h.style.height = "0", h.style.paddingTop = "0", h.style.paddingBottom = "0", yc(h, n.styles, n.origin), i("before-enter", h);
    }, a = (h) => {
      h.dataset.oldOverflow = h.style.overflow, h.scrollHeight !== 0 ? (h.style.height = `${h.scrollHeight}px`, h.dataset.oldPaddingTop !== void 0 && (h.style.paddingTop = h.dataset.oldPaddingTop), h.dataset.oldPaddingBottom !== void 0 && (h.style.paddingBottom = h.dataset.oldPaddingBottom)) : (h.style.height = "", h.dataset.oldPaddingTop !== void 0 && (h.style.paddingTop = h.dataset.oldPaddingTop), h.dataset.oldPaddingBottom !== void 0 && (h.style.paddingBottom = h.dataset.oldPaddingBottom)), h.style.overflow = "hidden";
    }, l = (h) => {
      h.style.transition = "", h.style.height = "", h.dataset.oldOverflow !== void 0 && (h.style.overflow = h.dataset.oldOverflow), i("after-enter", h);
    }, u = (h) => {
      h.dataset.oldPaddingTop = h.style.paddingTop, h.dataset.oldPaddingBottom = h.style.paddingBottom, h.dataset.oldOverflow = h.style.overflow, h.style.height = `${h.scrollHeight}px`, h.style.overflow = "hidden", yc(h, n.styles, n.origin);
    }, d = (h) => {
      let v;
      typeof n.duration == "number" ? v = n.duration : v = n.duration.leave, h.scrollHeight !== 0 && (h.style.transition = r(v), h.style.height = "0", h.style.paddingTop = "0", h.style.paddingBottom = "0"), B_(h, n.group), i("leave", h);
    }, f = (h) => {
      h.style.transition = "", h.style.height = "", h.dataset.oldOverflow !== void 0 && (h.style.overflow = h.dataset.oldOverflow), h.dataset.oldPaddingTop !== void 0 && (h.style.paddingTop = h.dataset.oldPaddingTop), h.dataset.oldPaddingBottom !== void 0 && (h.style.paddingBottom = h.dataset.oldPaddingBottom);
    }, m = B(() => ({
      "before-enter": o,
      "after-enter": l,
      enter: a,
      "before-leave": u,
      leave: d,
      "after-leave": f
    }));
    return (h, v) => (ee(), ce(qe, null, [
      e.group ? (ee(), Ne(Qs, ge({ key: 0 }, h.$attrs, {
        tag: e.tag,
        name: "ot-transition-collapse"
      }, xa(m.value)), {
        default: Ye(() => [
          De(h.$slots, "default")
        ]),
        _: 3
      }, 16, ["tag"])) : Fe("", !0),
      e.group ? Fe("", !0) : (ee(), Ne(hn, ge({ key: 1 }, h.$attrs, { name: "ot-transition-collapse" }, xa(m.value)), {
        default: Ye(() => [
          De(h.$slots, "default")
        ]),
        _: 3
      }, 16))
    ], 64));
  }
}), $3 = {
  name: "OtGridTableRow",
  customOptions: {}
}, V_ = /* @__PURE__ */ Ae({
  ...$3,
  props: {
    collapsed: { type: Boolean, default: !0 },
    dense: { type: Boolean, default: !1 },
    hasDot: { type: Boolean, default: !1 },
    lightBackgroundOnExpand: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    rowContentClass: { type: String, default: "" }
  },
  setup(e) {
    const t = e, n = "ot-grid-table-row", i = ie(!1), r = ie(), o = B(() => [
      n,
      {
        [`${n}--collapsed`]: t.collapsed,
        [`${n}--dense`]: t.dense,
        [`${n}--has-dot`]: t.hasDot
      }
    ]), a = B(() => [
      `${n}__content`,
      {
        light: t.lightBackgroundOnExpand && !t.collapsed,
        [t.rowContentClass]: t.rowContentClass
      }
    ]), l = (f) => {
      if (!f)
        return document.documentElement;
      let m = f.parentElement;
      for (; m; ) {
        if (window.getComputedStyle(m).getPropertyValue("overflow-y").split(" ").every((v) => v === "auto" || v === "scroll"))
          return m;
        m = m.parentElement;
      }
      return document.documentElement;
    }, u = (f, m) => Number(getComputedStyle(f).getPropertyValue(m).split("px")[0]) || 0, d = () => {
      if (!r.value)
        return;
      const f = l(r.value), m = f.getBoundingClientRect().top, h = u(r.value, "--grid-table-scroll-into-view-y-offset"), v = u(r.value, "--grid-table-header-height"), y = f.scrollTop + r.value.getBoundingClientRect().top - m - v - h;
      f.scrollTo({
        top: y,
        behavior: "smooth"
      });
    };
    return pe(
      () => t.collapsed,
      (f, m) => {
        i.value = !f && m;
      }
    ), (f, m) => (ee(), ce("div", {
      ref_key: "gridRowEl",
      ref: r,
      class: we(o.value)
    }, [
      ve("div", {
        class: we(a.value),
        testid: "table-row-content"
      }, [
        De(f.$slots, "default")
      ], 2),
      T(Rg, { onAfterEnter: d }, {
        default: Ye(() => [
          e.collapsed ? Fe("", !0) : (ee(), ce("div", {
            key: 0,
            class: we({ [`${n}__collapse-content`]: !0, light: e.lightBackgroundOnExpand }),
            onClick: m[0] || (m[0] = Wr(() => {
            }, ["stop"]))
          }, [
            De(f.$slots, "collapsed", {
              collapsedSectionClass: `${n}__collapsed-section`
            })
          ], 2))
        ]),
        _: 3
      }),
      De(f.$slots, "footer")
    ], 2));
  }
}), R3 = {
  name: "OtLoadingOverlay",
  customOptions: {}
}, Fg = /* @__PURE__ */ Ae({
  ...R3,
  props: {
    loadingNoOpacity: { type: Boolean, default: !1 },
    notRounded: { type: Boolean, default: !1 },
    onTopOfAll: { type: Boolean, default: !1 },
    variant: { type: String, default: "absolute" }
  },
  setup(e) {
    const t = e, n = "ot-loading-overlay", i = B(() => [
      [n],
      [`${n}--${t.variant}`],
      {
        [`${n}--no-opacity`]: t.loadingNoOpacity,
        [`${n}--not-rounded`]: t.notRounded,
        [`${n}--on-top-of-all`]: t.onTopOfAll
      }
    ]);
    return (r, o) => (ee(), Ne(Bc, null, {
      default: Ye(() => [
        ve("div", {
          class: we(["ot-loading-overlay", i.value]),
          testid: "loading-overlay"
        }, [
          T(Na, { variant: e.variant }, null, 8, ["variant"])
        ], 2)
      ]),
      _: 1
    }));
  }
}), F3 = {
  name: "OtScroll",
  customOptions: {}
}, Ng = /* @__PURE__ */ Ae({
  ...F3,
  props: {
    overflowVisible: { type: Boolean, default: !1 },
    scrollCallbacks: { type: Object },
    startAtMiddle: { type: Boolean, default: !1 },
    suppressScrollX: { type: Boolean, default: !1 },
    suppressScrollY: { type: Boolean, default: !1 }
  },
  setup(e, { expose: t }) {
    const n = e, i = ie(), r = (a = 0) => {
      var d;
      const l = i.value;
      if (!l)
        return;
      const u = ((d = l.getClientRects()[0]) == null ? void 0 : d.height) || 0;
      l.scrollTop = (l.scrollHeight - u) / 2 + a;
    }, o = B(() => ({
      "ot-scroll--x-suppressed": n.suppressScrollX && !n.overflowVisible,
      "ot-scroll--y-suppressed": n.suppressScrollY && !n.overflowVisible,
      "ot-scroll--overflow-visible": n.overflowVisible && !n.suppressScrollX && !n.suppressScrollY
    }));
    return mn(() => {
      var l;
      const a = i.value;
      a && (n.startAtMiddle && r(), (l = n.scrollCallbacks) != null && l.onScroll && a.addEventListener("scroll", () => {
        var u;
        return (u = n.scrollCallbacks) == null ? void 0 : u.onScroll();
      }));
    }), t({
      doScrollAtMiddle: r,
      scrollbar: i
    }), (a, l) => (ee(), ce("div", {
      ref_key: "scrollbar",
      ref: i,
      class: we(["ot-scroll", o.value])
    }, [
      De(a.$slots, "default", { doScrollAtMiddle: r })
    ], 2));
  }
}), N3 = { testid: "toolbar-title" }, W3 = {
  key: 0,
  class: "ot-module-container__actions-left"
}, z3 = {
  key: 1,
  class: "ot-module-container__actions-right"
}, H3 = { class: "fill-height ot-module-container__content" }, j3 = {
  name: "OtModuleContainer",
  customOptions: {}
}, Wg = /* @__PURE__ */ Ae({
  ...j3,
  props: {
    loading: { type: Boolean },
    loadingNoOpacity: { type: Boolean },
    scrollCallbacks: { type: Object },
    scrollSettings: { type: Object },
    title: { type: String },
    variant: { type: String, default: "default" },
    withBottomPadding: { type: Boolean, default: !1 },
    actionsClass: { type: String, default: "" },
    headerClass: { type: String, default: "" },
    scrollContainerClass: { type: String, default: "" },
    titleClass: { type: String, default: "" }
  },
  setup(e) {
    const t = e, n = zh(), i = B(() => t.title || n["header-left-actions"] || n["header-actions"]), r = B(() => {
      var u;
      return (u = t.scrollSettings) == null ? void 0 : u.startAtMiddle;
    }), o = B(() => {
      var u;
      return (u = t.scrollSettings) == null ? void 0 : u.suppressScrollX;
    }), a = B(() => {
      var u;
      return (u = t.scrollSettings) == null ? void 0 : u.suppressScrollY;
    }), l = B(() => {
      var u;
      return (u = t.scrollSettings) == null ? void 0 : u.overflowVisible;
    });
    return (u, d) => (ee(), ce("div", {
      class: we(["ot-module-container", `ot-module-container--${e.variant}`, { "ot-module-container--pb": e.withBottomPadding }])
    }, [
      u.$slots.default ? De(u.$slots, "default", zt(ge({ key: 0 }, { sectionClass: "ot-module-container__default-section" }))) : Fe("", !0),
      i.value ? (ee(), ce("div", {
        key: 1,
        class: we(["ot-module-container__header", [e.headerClass, { "ot-module-container__header--no-radius": u.$slots.default }]])
      }, [
        e.title ? (ee(), ce("div", {
          key: 0,
          class: we(["ot-module-container__header-title", [e.titleClass]])
        }, [
          ve("span", N3, Ue(e.title), 1)
        ], 2)) : Fe("", !0),
        ve("div", {
          class: we(["ot-module-container__actions", e.actionsClass])
        }, [
          u.$slots["header-left-actions"] ? (ee(), ce("div", W3, [
            De(u.$slots, "header-left-actions")
          ])) : Fe("", !0),
          u.$slots["header-actions"] ? (ee(), ce("div", z3, [
            De(u.$slots, "header-actions")
          ])) : Fe("", !0)
        ], 2)
      ], 2)) : Fe("", !0),
      ve("div", H3, [
        e.loading ? (ee(), Ne(Fg, {
          key: 0,
          "loading-no-opacity": e.loadingNoOpacity
        }, null, 8, ["loading-no-opacity"])) : Fe("", !0),
        T(Ng, {
          class: we(["fill-height ot-module-container__scroll-container", [e.scrollContainerClass]]),
          "overflow-visible": l.value,
          "scroll-callbacks": e.scrollCallbacks,
          "start-at-middle": r.value,
          "suppress-scroll-x": o.value,
          "suppress-scroll-y": a.value
        }, {
          default: Ye(({ doScrollAtMiddle: f }) => [
            De(u.$slots, "main-content", { doScrollAtMiddle: f })
          ]),
          _: 3
        }, 8, ["class", "overflow-visible", "scroll-callbacks", "start-at-middle", "suppress-scroll-x", "suppress-scroll-y"])
      ])
    ], 2));
  }
}), Y3 = {
  name: "OtHorizontalSlidePanel",
  customOptions: {}
}, U3 = /* @__PURE__ */ Ae({
  ...Y3,
  props: {
    open: { type: Boolean, default: !1 },
    width: { type: Number, default: 300 }
  },
  emits: ["update:open", "closed"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = ie(!1), o = ie(n.open), a = ie(0), l = ie(0), u = ie(0), d = ie(0), f = ie(n.width), m = 0.1 * n.width, h = 0.2, v = B({
      get: () => n.open,
      set: ($) => {
        i("update:open", $);
      }
    }), y = () => {
      o.value = !1;
    }, p = () => {
      const $ = Math.abs(a.value - l.value), A = $ / (d.value - u.value), k = a.value > l.value, S = $ > m, M = A > h;
      k && (S || M) && y();
    }, b = ($, A) => A ? $.changedTouches[0].clientX : $.clientX, x = ($, A) => {
      r.value = !0, a.value = b($, A), u.value = (/* @__PURE__ */ new Date()).getTime();
    }, _ = ($, A) => {
      r.value && (r.value = !1, l.value = b($, A), d.value = (/* @__PURE__ */ new Date()).getTime(), p());
    }, O = ($, A) => {
      r.value && requestAnimationFrame(() => {
        const k = window.innerWidth - b($, A);
        k < n.width && (f.value = k);
      });
    }, D = ($) => _($, !0), F = ($) => _($);
    return mn(() => {
      window.addEventListener("touchend", D), window.addEventListener("mouseup", F);
    }), _n(() => {
      window.removeEventListener("touchend", D), window.removeEventListener("mouseup", F);
    }), ($, A) => (ee(), Ne(As, { to: "body" }, [
      T(hn, {
        name: "ot-horizontal-slide-panel-container",
        onAfterEnter: A[4] || (A[4] = (k) => o.value = !0),
        onAfterLeave: A[5] || (A[5] = (k) => i("closed"))
      }, {
        default: Ye(() => [
          v.value ? (ee(), ce("div", {
            key: 0,
            ref: "panel",
            class: we(["ot-horizontal-slide-panel ot-horizontal-slide-panel--open", { "ot-horizontal-slide-panel--dragging": r.value }]),
            onMousemove: O,
            onTouchmove: A[2] || (A[2] = (k) => O(k, !0)),
            onMousedown: A[3] || (A[3] = Wr((k) => v.value && y(), ["self"]))
          }, [
            T(hn, {
              name: "ot-horizontal-sliding-panel",
              onAfterLeave: A[1] || (A[1] = (k) => v.value = !1)
            }, {
              default: Ye(() => [
                o.value ? (ee(), ce("div", {
                  key: 0,
                  class: "ot-horizontal-slide-panel__animation-handler",
                  style: Do({ width: `${f.value}px` })
                }, [
                  T(Wg, {
                    class: "ot-horizontal-slide-panel__container",
                    onMousedown: x,
                    onTouchstart: A[0] || (A[0] = (k) => x(k, !0))
                  }, {
                    "main-content": Ye(() => [
                      De($.$slots, "default", {}, void 0, !0)
                    ]),
                    _: 3
                  })
                ], 4)) : Fe("", !0)
              ]),
              _: 3
            })
          ], 34)) : Fe("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), $_ = /* @__PURE__ */ Uc(U3, [["__scopeId", "data-v-9bd5f6fb"]]), q3 = { class: "ot-info__message" }, G3 = {
  name: "OtInfo",
  customOptions: {}
}, R_ = /* @__PURE__ */ Ae({
  ...G3,
  props: {
    message: { type: String, required: !0 },
    isWarning: { type: Boolean, default: !1 },
    isError: { type: Boolean, default: !1 },
    variant: { type: String, default: "dark" }
  },
  setup(e) {
    return (t, n) => (ee(), ce("div", {
      class: we(["ot-info", [`ot-info--${e.variant}`, { "ot-info--warning": e.isWarning, "ot-info--error": e.isError }]])
    }, [
      T(qt, {
        class: "ot-info__icon",
        name: e.isWarning ? "danger-hollow" : "info-outlined"
      }, null, 8, ["name"]),
      ve("div", q3, Ue(e.message), 1)
    ], 2));
  }
}), X3 = { class: "ot-input-error-wrapper" }, K3 = {
  key: 0,
  class: "ot-input-error-wrapper__message",
  testid: "validation-msg"
}, Z3 = {
  name: "OtInputErrorWrapper",
  customOptions: {}
}, zg = /* @__PURE__ */ Ae({
  ...Z3,
  props: {
    error: { type: Object, default: () => {
    } },
    errorMessages: { type: Object, default: () => {
    } },
    disabled: { type: Boolean, default: !1 },
    noMessagePlaceholder: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = B(() => {
      var o;
      if (!((o = t.error) != null && o.$error))
        return [];
      const i = [];
      return Object.keys(t.error).filter((a) => !a.startsWith("$")).forEach((a) => {
        if (t.error[a].$invalid) {
          const u = t.errorMessages[a];
          u && i.push(u);
        }
      }), i;
    });
    return (i, r) => (ee(), ce("div", X3, [
      De(i.$slots, "default"),
      e.disabled ? Fe("", !0) : (ee(), ce("div", K3, Ue(n.value[0]), 1))
    ]));
  }
});
var F_ = { exports: {} };
(function(e) {
  e.exports = /******/
  function(t) {
    var n = {};
    function i(r) {
      if (n[r])
        return n[r].exports;
      var o = n[r] = {
        /******/
        i: r,
        /******/
        l: !1,
        /******/
        exports: {}
        /******/
      };
      return t[r].call(o.exports, o, o.exports, i), o.l = !0, o.exports;
    }
    return i.m = t, i.c = n, i.d = function(r, o, a) {
      i.o(r, o) || Object.defineProperty(r, o, {
        /******/
        configurable: !1,
        /******/
        enumerable: !0,
        /******/
        get: a
        /******/
      });
    }, i.n = function(r) {
      var o = r && r.__esModule ? (
        /******/
        function() {
          return r.default;
        }
      ) : (
        /******/
        function() {
          return r;
        }
      );
      return i.d(o, "a", o), o;
    }, i.o = function(r, o) {
      return Object.prototype.hasOwnProperty.call(r, o);
    }, i.p = "", i(i.s = 1);
  }([
    /* 0 */
    /***/
    function(t, n, i) {
      var r = {
        MOBILE: "mobile",
        TABLET: "tablet",
        SMART_TV: "smarttv",
        CONSOLE: "console",
        WEARABLE: "wearable",
        BROWSER: void 0
      }, o = {
        CHROME: "Chrome",
        FIREFOX: "Firefox",
        OPERA: "Opera",
        YANDEX: "Yandex",
        SAFARI: "Safari",
        INTERNET_EXPLORER: "Internet Explorer",
        EDGE: "Edge",
        CHROMIUM: "Chromium",
        IE: "IE",
        MOBILE_SAFARI: "Mobile Safari",
        EDGE_CHROMIUM: "Edge Chromium"
      }, a = {
        IOS: "iOS",
        ANDROID: "Android",
        WINDOWS_PHONE: "Windows Phone",
        WINDOWS: "Windows",
        MAC_OS: "Mac OS"
      }, l = {
        isMobile: !1,
        isTablet: !1,
        isBrowser: !1,
        isSmartTV: !1,
        isConsole: !1,
        isWearable: !1
      };
      t.exports = { BROWSER_TYPES: o, DEVICE_TYPES: r, OS_TYPES: a, defaultData: l };
    },
    /* 1 */
    /***/
    function(t, n, i) {
      var r = i(2), o = i(0), a = o.BROWSER_TYPES, l = o.OS_TYPES, u = o.DEVICE_TYPES, d = i(4), f = d.checkType, m = d.broPayload, h = d.mobilePayload, v = d.wearPayload, y = d.consolePayload, p = d.stvPayload, b = d.getNavigatorInstance, x = d.isIOS13Check, _ = new r(), O = _.getBrowser(), D = _.getDevice(), F = _.getEngine(), $ = _.getOS(), A = _.getUA(), k = a.CHROME, S = a.CHROMIUM, M = a.IE, E = a.INTERNET_EXPLORER, I = a.OPERA, L = a.FIREFOX, N = a.SAFARI, V = a.EDGE, z = a.YANDEX, H = a.MOBILE_SAFARI, W = u.MOBILE, j = u.TABLET, U = u.SMART_TV, K = u.BROWSER, te = u.WEARABLE, ue = u.CONSOLE, de = l.ANDROID, Q = l.WINDOWS_PHONE, J = l.IOS, re = l.WINDOWS, me = l.MAC_OS, xe = function() {
        return D.type === W;
      }, tt = function() {
        return D.type === j;
      }, nt = function() {
        switch (D.type) {
          case W:
          case j:
            return !0;
          default:
            return !1;
        }
      }, fe = function() {
        return $.name === l.WINDOWS && $.version === "10" ? typeof A == "string" && A.indexOf("Edg/") !== -1 : !1;
      }, be = function() {
        return D.type === U;
      }, Ee = function() {
        return D.type === K;
      }, ke = function() {
        return D.type === te;
      }, at = function() {
        return D.type === ue;
      }, xn = function() {
        return $.name === de;
      }, vi = function() {
        return $.name === re;
      }, Y = function() {
        return $.name === me;
      }, pi = function() {
        return $.name === Q;
      }, Ht = function() {
        return $.name === J;
      }, jo = function() {
        return O.name === k;
      }, nn = function() {
        return O.name === L;
      }, vr = function() {
        return O.name === S;
      }, yi = function() {
        return O.name === V;
      }, Qc = function() {
        return O.name === z;
      }, Yo = function() {
        return O.name === N || O.name === H;
      }, Mi = function() {
        return O.name === H;
      }, vl = function() {
        return O.name === I;
      }, pr = function() {
        return O.name === E || O.name === M;
      }, yr = function() {
        var Rn = b(), kr = Rn && Rn.userAgent.toLowerCase();
        return typeof kr == "string" ? /electron/.test(kr) : !1;
      }, Uo = function() {
        var Rn = b();
        return Rn && (/iPad|iPhone|iPod/.test(Rn.platform) || Rn.platform === "MacIntel" && Rn.maxTouchPoints > 1) && !window.MSStream;
      }, Xt = function() {
        return x("iPad");
      }, ji = function() {
        return x("iPhone");
      }, pl = function() {
        return x("iPod");
      }, Qn = function() {
        return O.major;
      }, br = function() {
        return O.version;
      }, Jn = function() {
        return $.version ? $.version : "none";
      }, wr = function() {
        return $.name ? $.name : "none";
      }, bi = function() {
        return O.name;
      }, to = function() {
        return D.vendor ? D.vendor : "none";
      }, Wa = function() {
        return D.model ? D.model : "none";
      }, Jc = function() {
        return F.name;
      }, ed = function() {
        return F.version;
      }, td = function() {
        return A;
      }, nd = function() {
        return D.type;
      }, yl = be(), id = at(), rd = ke(), Yi = Mi() || Xt(), Ti = vr(), od = nt() || Xt(), qo = xe(), ei = tt() || Xt(), ad = Ee(), sd = xn(), ld = pi(), _r = Ht() || Xt(), Go = jo(), ud = nn(), no = Yo(), io = vl(), cd = pr(), Xo = Jn(), Ko = wr(), bl = Qn(), Vn = br(), ro = bi(), dd = to(), wi = Wa(), wl = Jc(), fd = ed(), oo = td(), $n = yi() || fe(), ao = Qc(), Zo = nd(), hd = Uo(), so = Xt(), gd = ji(), lo = pl(), xr = yr(), za = fe(), Ha = yi(), ja = vi(), Ya = Y(), ti = f(D.type);
      function Ua() {
        var We = ti.isBrowser, Rn = ti.isMobile, kr = ti.isTablet, _l = ti.isSmartTV, xl = ti.isConsole, kl = ti.isWearable;
        if (We)
          return m(We, O, F, $, A);
        if (_l)
          return p(_l, F, $, A);
        if (xl)
          return y(xl, F, $, A);
        if (Rn || kr)
          return h(ti, D, $, A);
        if (kl)
          return v(kl, F, $, A);
      }
      t.exports = {
        deviceDetect: Ua,
        isSmartTV: yl,
        isConsole: id,
        isWearable: rd,
        isMobileSafari: Yi,
        isChromium: Ti,
        isMobile: od,
        isMobileOnly: qo,
        isTablet: ei,
        isBrowser: ad,
        isAndroid: sd,
        isWinPhone: ld,
        isIOS: _r,
        isChrome: Go,
        isFirefox: ud,
        isSafari: no,
        isOpera: io,
        isIE: cd,
        osVersion: Xo,
        osName: Ko,
        fullBrowserVersion: bl,
        browserVersion: Vn,
        browserName: ro,
        mobileVendor: dd,
        mobileModel: wi,
        engineName: wl,
        engineVersion: fd,
        getUA: oo,
        isEdge: $n,
        isYandex: ao,
        deviceType: Zo,
        isIOS13: hd,
        isIPad13: so,
        isIPhone13: gd,
        isIPod13: lo,
        isElectron: xr,
        isEdgeChromium: za,
        isLegacyEdge: Ha,
        isWindows: ja,
        isMacOs: Ya
      };
    },
    /* 2 */
    /***/
    function(t, n, i) {
      var r;
      /*!
      * UAParser.js v0.7.18
      * Lightweight JavaScript-based User-Agent string parser
      * https://github.com/faisalman/ua-parser-js
      *
      * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
      * Dual licensed under GPLv2 or MIT
      */
      (function(o, a) {
        var l = "0.7.18", u = "", d = "?", f = "function", m = "undefined", h = "object", v = "string", y = "major", p = "model", b = "name", x = "type", _ = "vendor", O = "version", D = "architecture", F = "console", $ = "mobile", A = "tablet", k = "smarttv", S = "wearable", M = "embedded", E = { extend: function(W, j) {
          var U = {};
          for (var K in W)
            j[K] && j[K].length % 2 === 0 ? U[K] = j[K].concat(W[K]) : U[K] = W[K];
          return U;
        }, has: function(W, j) {
          return typeof W == "string" ? j.toLowerCase().indexOf(W.toLowerCase()) !== -1 : !1;
        }, lowerize: function(W) {
          return W.toLowerCase();
        }, major: function(W) {
          return typeof W === v ? W.replace(/[^\d\.]/g, "").split(".")[0] : a;
        }, trim: function(W) {
          return W.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
        } }, I = { rgx: function(W, j) {
          for (var U = 0, K, te, ue, de, Q, J; U < j.length && !Q; ) {
            var re = j[U], me = j[U + 1];
            for (K = te = 0; K < re.length && !Q; )
              if (Q = re[K++].exec(W), Q)
                for (ue = 0; ue < me.length; ue++)
                  J = Q[++te], de = me[ue], typeof de === h && de.length > 0 ? de.length == 2 ? typeof de[1] == f ? this[de[0]] = de[1].call(this, J) : this[de[0]] = de[1] : de.length == 3 ? typeof de[1] === f && !(de[1].exec && de[1].test) ? this[de[0]] = J ? de[1].call(this, J, de[2]) : a : this[de[0]] = J ? J.replace(de[1], de[2]) : a : de.length == 4 && (this[de[0]] = J ? de[3].call(this, J.replace(de[1], de[2])) : a) : this[de] = J || a;
            U += 2;
          }
        }, str: function(W, j) {
          for (var U in j)
            if (typeof j[U] === h && j[U].length > 0) {
              for (var K = 0; K < j[U].length; K++)
                if (E.has(j[U][K], W))
                  return U === d ? a : U;
            } else if (E.has(j[U], W))
              return U === d ? a : U;
          return W;
        } }, L = { browser: { oldsafari: { version: { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" } } }, device: { amazon: { model: { "Fire Phone": ["SD", "KF"] } }, sprint: { model: { "Evo Shift 4G": "7373KT" }, vendor: { HTC: "APA", Sprint: "Sprint" } } }, os: { windows: { version: { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" } } } }, N = { browser: [[/(opera\smini)\/([\w\.-]+)/i, /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i, /(opera).+version\/([\w\.]+)/i, /(opera)[\/\s]+([\w\.]+)/i], [b, O], [/(opios)[\/\s]+([\w\.]+)/i], [[b, "Opera Mini"], O], [/\s(opr)\/([\w\.]+)/i], [[b, "Opera"], O], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i, /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i, /(?:ms|\()(ie)\s([\w\.]+)/i, /(rekonq)\/([\w\.]*)/i, /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i], [b, O], [/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i], [[b, "IE"], O], [/(edge|edgios|edgea)\/((\d+)?[\w\.]+)/i], [[b, "Edge"], O], [/(yabrowser)\/([\w\.]+)/i], [[b, "Yandex"], O], [/(puffin)\/([\w\.]+)/i], [[b, "Puffin"], O], [/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i], [[b, "UCBrowser"], O], [/(comodo_dragon)\/([\w\.]+)/i], [[b, /_/g, " "], O], [/(micromessenger)\/([\w\.]+)/i], [[b, "WeChat"], O], [/(qqbrowserlite)\/([\w\.]+)/i], [b, O], [/(QQ)\/([\d\.]+)/i], [b, O], [/m?(qqbrowser)[\/\s]?([\w\.]+)/i], [b, O], [/(BIDUBrowser)[\/\s]?([\w\.]+)/i], [b, O], [/(2345Explorer)[\/\s]?([\w\.]+)/i], [b, O], [/(MetaSr)[\/\s]?([\w\.]+)/i], [b], [/(LBBROWSER)/i], [b], [/xiaomi\/miuibrowser\/([\w\.]+)/i], [O, [b, "MIUI Browser"]], [/;fbav\/([\w\.]+);/i], [O, [b, "Facebook"]], [/headlesschrome(?:\/([\w\.]+)|\s)/i], [O, [b, "Chrome Headless"]], [/\swv\).+(chrome)\/([\w\.]+)/i], [[b, /(.+)/, "$1 WebView"], O], [/((?:oculus|samsung)browser)\/([\w\.]+)/i], [[b, /(.+(?:g|us))(.+)/, "$1 $2"], O], [/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i], [O, [b, "Android Browser"]], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i], [b, O], [/(dolfin)\/([\w\.]+)/i], [[b, "Dolphin"], O], [/((?:android.+)crmo|crios)\/([\w\.]+)/i], [[b, "Chrome"], O], [/(coast)\/([\w\.]+)/i], [[b, "Opera Coast"], O], [/fxios\/([\w\.-]+)/i], [O, [b, "Firefox"]], [/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i], [O, [b, "Mobile Safari"]], [/version\/([\w\.]+).+?(mobile\s?safari|safari)/i], [O, b], [/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i], [[b, "GSA"], O], [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i], [b, [O, I.str, L.browser.oldsafari.version]], [/(konqueror)\/([\w\.]+)/i, /(webkit|khtml)\/([\w\.]+)/i], [b, O], [/(navigator|netscape)\/([\w\.-]+)/i], [[b, "Netscape"], O], [/(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i, /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, /(links)\s\(([\w\.]+)/i, /(gobrowser)\/?([\w\.]*)/i, /(ice\s?browser)\/v?([\w\._]+)/i, /(mosaic)[\/\s]([\w\.]+)/i], [b, O]], cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i], [[D, "amd64"]], [/(ia32(?=;))/i], [[D, E.lowerize]], [/((?:i[346]|x)86)[;\)]/i], [[D, "ia32"]], [/windows\s(ce|mobile);\sppc;/i], [[D, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i], [[D, /ower/, "", E.lowerize]], [/(sun4\w)[;\)]/i], [[D, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i], [[D, E.lowerize]]], device: [[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i], [p, _, [x, A]], [/applecoremedia\/[\w\.]+ \((ipad)/], [p, [_, "Apple"], [x, A]], [/(apple\s{0,1}tv)/i], [[p, "Apple TV"], [_, "Apple"]], [/(archos)\s(gamepad2?)/i, /(hp).+(touchpad)/i, /(hp).+(tablet)/i, /(kindle)\/([\w\.]+)/i, /\s(nook)[\w\s]+build\/(\w+)/i, /(dell)\s(strea[kpr\s\d]*[\dko])/i], [_, p, [x, A]], [/(kf[A-z]+)\sbuild\/.+silk\//i], [p, [_, "Amazon"], [x, A]], [/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i], [[p, I.str, L.device.amazon.model], [_, "Amazon"], [x, $]], [/\((ip[honed|\s\w*]+);.+(apple)/i], [p, _, [x, $]], [/\((ip[honed|\s\w*]+);/i], [p, [_, "Apple"], [x, $]], [/(blackberry)[\s-]?(\w+)/i, /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i, /(hp)\s([\w\s]+\w)/i, /(asus)-?(\w+)/i], [_, p, [x, $]], [/\(bb10;\s(\w+)/i], [p, [_, "BlackBerry"], [x, $]], [/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i], [p, [_, "Asus"], [x, A]], [/(sony)\s(tablet\s[ps])\sbuild\//i, /(sony)?(?:sgp.+)\sbuild\//i], [[_, "Sony"], [p, "Xperia Tablet"], [x, A]], [/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i], [p, [_, "Sony"], [x, $]], [/\s(ouya)\s/i, /(nintendo)\s([wids3u]+)/i], [_, p, [x, F]], [/android.+;\s(shield)\sbuild/i], [p, [_, "Nvidia"], [x, F]], [/(playstation\s[34portablevi]+)/i], [p, [_, "Sony"], [x, F]], [/(sprint\s(\w+))/i], [[_, I.str, L.device.sprint.vendor], [p, I.str, L.device.sprint.model], [x, $]], [/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i], [_, p, [x, A]], [/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i, /(zte)-(\w*)/i, /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i], [_, [p, /_/g, " "], [x, $]], [/(nexus\s9)/i], [p, [_, "HTC"], [x, A]], [/d\/huawei([\w\s-]+)[;\)]/i, /(nexus\s6p)/i], [p, [_, "Huawei"], [x, $]], [/(microsoft);\s(lumia[\s\w]+)/i], [_, p, [x, $]], [/[\s\(;](xbox(?:\sone)?)[\s\);]/i], [p, [_, "Microsoft"], [x, F]], [/(kin\.[onetw]{3})/i], [[p, /\./g, " "], [_, "Microsoft"], [x, $]], [/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i, /mot[\s-]?(\w*)/i, /(XT\d{3,4}) build\//i, /(nexus\s6)/i], [p, [_, "Motorola"], [x, $]], [/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i], [p, [_, "Motorola"], [x, A]], [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i], [[_, E.trim], [p, E.trim], [x, k]], [/hbbtv.+maple;(\d+)/i], [[p, /^/, "SmartTV"], [_, "Samsung"], [x, k]], [/\(dtv[\);].+(aquos)/i], [p, [_, "Sharp"], [x, k]], [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i], [[_, "Samsung"], p, [x, A]], [/smart-tv.+(samsung)/i], [_, [x, k], p], [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i, /sec-((sgh\w+))/i], [[_, "Samsung"], p, [x, $]], [/sie-(\w*)/i], [p, [_, "Siemens"], [x, $]], [/(maemo|nokia).*(n900|lumia\s\d+)/i, /(nokia)[\s_-]?([\w-]*)/i], [[_, "Nokia"], p, [x, $]], [/android\s3\.[\s\w;-]{10}(a\d{3})/i], [p, [_, "Acer"], [x, A]], [/android.+([vl]k\-?\d{3})\s+build/i], [p, [_, "LG"], [x, A]], [/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i], [[_, "LG"], p, [x, A]], [/(lg) netcast\.tv/i], [_, p, [x, k]], [/(nexus\s[45])/i, /lg[e;\s\/-]+(\w*)/i, /android.+lg(\-?[\d\w]+)\s+build/i], [p, [_, "LG"], [x, $]], [/android.+(ideatab[a-z0-9\-\s]+)/i], [p, [_, "Lenovo"], [x, A]], [/linux;.+((jolla));/i], [_, p, [x, $]], [/((pebble))app\/[\d\.]+\s/i], [_, p, [x, S]], [/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i], [_, p, [x, $]], [/crkey/i], [[p, "Chromecast"], [_, "Google"]], [/android.+;\s(glass)\s\d/i], [p, [_, "Google"], [x, S]], [/android.+;\s(pixel c)\s/i], [p, [_, "Google"], [x, A]], [/android.+;\s(pixel xl|pixel)\s/i], [p, [_, "Google"], [x, $]], [/android.+;\s(\w+)\s+build\/hm\1/i, /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i, /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i, /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i], [[p, /_/g, " "], [_, "Xiaomi"], [x, $]], [/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i], [[p, /_/g, " "], [_, "Xiaomi"], [x, A]], [/android.+;\s(m[1-5]\snote)\sbuild/i], [p, [_, "Meizu"], [x, A]], [/android.+a000(1)\s+build/i, /android.+oneplus\s(a\d{4})\s+build/i], [p, [_, "OnePlus"], [x, $]], [/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i], [p, [_, "RCA"], [x, A]], [/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i], [p, [_, "Dell"], [x, A]], [/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i], [p, [_, "Verizon"], [x, A]], [/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i], [[_, "Barnes & Noble"], p, [x, A]], [/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i], [p, [_, "NuVision"], [x, A]], [/android.+;\s(k88)\sbuild/i], [p, [_, "ZTE"], [x, A]], [/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i], [p, [_, "Swiss"], [x, $]], [/android.+[;\/]\s*(zur\d{3})\s+build/i], [p, [_, "Swiss"], [x, A]], [/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i], [p, [_, "Zeki"], [x, A]], [/(android).+[;\/]\s+([YR]\d{2})\s+build/i, /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i], [[_, "Dragon Touch"], p, [x, A]], [/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i], [p, [_, "Insignia"], [x, A]], [/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i], [p, [_, "NextBook"], [x, A]], [/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i], [[_, "Voice"], p, [x, $]], [/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i], [[_, "LvTel"], p, [x, $]], [/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i], [p, [_, "Envizen"], [x, A]], [/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i], [_, p, [x, A]], [/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i], [p, [_, "MachSpeed"], [x, A]], [/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i], [_, p, [x, A]], [/android.+[;\/]\s*TU_(1491)\s+build/i], [p, [_, "Rotor"], [x, A]], [/android.+(KS(.+))\s+build/i], [p, [_, "Amazon"], [x, A]], [/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i], [_, p, [x, A]], [/\s(tablet|tab)[;\/]/i, /\s(mobile)(?:[;\/]|\ssafari)/i], [[x, E.lowerize], _, p], [/(android[\w\.\s\-]{0,9});.+build/i], [p, [_, "Generic"]]], engine: [[/windows.+\sedge\/([\w\.]+)/i], [O, [b, "EdgeHTML"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i, /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, /(icab)[\/\s]([23]\.[\d\.]+)/i], [b, O], [/rv\:([\w\.]{1,9}).+(gecko)/i], [O, b]], os: [[/microsoft\s(windows)\s(vista|xp)/i], [b, O], [/(windows)\snt\s6\.2;\s(arm)/i, /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i, /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i], [b, [O, I.str, L.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[b, "Windows"], [O, I.str, L.os.windows.version]], [/\((bb)(10);/i], [[b, "BlackBerry"], O], [/(blackberry)\w*\/?([\w\.]*)/i, /(tizen)[\/\s]([\w\.]+)/i, /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i, /linux;.+(sailfish);/i], [b, O], [/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i], [[b, "Symbian"], O], [/\((series40);/i], [b], [/mozilla.+\(mobile;.+gecko.+firefox/i], [[b, "Firefox OS"], O], [/(nintendo|playstation)\s([wids34portablevu]+)/i, /(mint)[\/\s\(]?(\w*)/i, /(mageia|vectorlinux)[;\s]/i, /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i, /(hurd|linux)\s?([\w\.]*)/i, /(gnu)\s?([\w\.]*)/i], [b, O], [/(cros)\s[\w]+\s([\w\.]+\w)/i], [[b, "Chromium OS"], O], [/(sunos)\s?([\w\.\d]*)/i], [[b, "Solaris"], O], [/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i], [b, O], [/(haiku)\s(\w+)/i], [b, O], [/cfnetwork\/.+darwin/i, /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i], [[O, /_/g, "."], [b, "iOS"]], [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)/i], [[b, "Mac OS"], [O, /_/g, "."]], [/((?:open)?solaris)[\/\s-]?([\w\.]*)/i, /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i, /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i, /(unix)\s?([\w\.]*)/i], [b, O]] }, V = function(W, j) {
          if (typeof W == "object" && (j = W, W = a), !(this instanceof V))
            return new V(W, j).getResult();
          var U = W || (o && o.navigator && o.navigator.userAgent ? o.navigator.userAgent : u), K = j ? E.extend(N, j) : N;
          return this.getBrowser = function() {
            var te = { name: a, version: a };
            return I.rgx.call(te, U, K.browser), te.major = E.major(te.version), te;
          }, this.getCPU = function() {
            var te = { architecture: a };
            return I.rgx.call(te, U, K.cpu), te;
          }, this.getDevice = function() {
            var te = { vendor: a, model: a, type: a };
            return I.rgx.call(te, U, K.device), te;
          }, this.getEngine = function() {
            var te = { name: a, version: a };
            return I.rgx.call(te, U, K.engine), te;
          }, this.getOS = function() {
            var te = { name: a, version: a };
            return I.rgx.call(te, U, K.os), te;
          }, this.getResult = function() {
            return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
          }, this.getUA = function() {
            return U;
          }, this.setUA = function(te) {
            return U = te, this;
          }, this;
        };
        V.VERSION = l, V.BROWSER = { NAME: b, MAJOR: y, VERSION: O }, V.CPU = { ARCHITECTURE: D }, V.DEVICE = { MODEL: p, VENDOR: _, TYPE: x, CONSOLE: F, MOBILE: $, SMARTTV: k, TABLET: A, WEARABLE: S, EMBEDDED: M }, V.ENGINE = { NAME: b, VERSION: O }, V.OS = { NAME: b, VERSION: O }, typeof n !== m ? (typeof t !== m && t.exports && (n = t.exports = V), n.UAParser = V) : i(3) ? (r = (function() {
          return V;
        }).call(n, i, n, t), r !== a && (t.exports = r)) : o && (o.UAParser = V);
        var z = o && (o.jQuery || o.Zepto);
        if (typeof z !== m) {
          var H = new V();
          z.ua = H.getResult(), z.ua.get = function() {
            return H.getUA();
          }, z.ua.set = function(W) {
            H.setUA(W);
            var j = H.getResult();
            for (var U in j)
              z.ua[U] = j[U];
          };
        }
      })(typeof window == "object" ? window : this);
    },
    /* 3 */
    /***/
    function(t, n) {
      (function(i) {
        t.exports = i;
      }).call(n, {});
    },
    /* 4 */
    /***/
    function(t, n, i) {
      Object.defineProperty(n, "__esModule", {
        value: !0
      });
      var r = Object.assign || function(b) {
        for (var x = 1; x < arguments.length; x++) {
          var _ = arguments[x];
          for (var O in _)
            Object.prototype.hasOwnProperty.call(_, O) && (b[O] = _[O]);
        }
        return b;
      }, o = i(0), a = o.DEVICE_TYPES, l = o.defaultData, u = function(x) {
        switch (x) {
          case a.MOBILE:
            return { isMobile: !0 };
          case a.TABLET:
            return { isTablet: !0 };
          case a.SMART_TV:
            return { isSmartTV: !0 };
          case a.CONSOLE:
            return { isConsole: !0 };
          case a.WEARABLE:
            return { isWearable: !0 };
          case a.BROWSER:
            return { isBrowser: !0 };
          default:
            return l;
        }
      }, d = function(x, _, O, D, F) {
        return {
          isBrowser: x,
          browserMajorVersion: _.major,
          browserFullVersion: _.version,
          browserName: _.name,
          engineName: O.name || !1,
          engineVersion: O.version,
          osName: D.name,
          osVersion: D.version,
          userAgent: F
        };
      }, f = function(x, _, O, D) {
        return r({}, x, {
          vendor: _.vendor,
          model: _.model,
          os: O.name,
          osVersion: O.version,
          ua: D
        });
      }, m = function(x, _, O, D) {
        return {
          isSmartTV: x,
          engineName: _.name,
          engineVersion: _.version,
          osName: O.name,
          osVersion: O.version,
          userAgent: D
        };
      }, h = function(x, _, O, D) {
        return {
          isConsole: x,
          engineName: _.name,
          engineVersion: _.version,
          osName: O.name,
          osVersion: O.version,
          userAgent: D
        };
      }, v = function(x, _, O, D) {
        return {
          isWearable: x,
          engineName: _.name,
          engineVersion: _.version,
          osName: O.name,
          osVersion: O.version,
          userAgent: D
        };
      }, y = n.getNavigatorInstance = function() {
        return typeof window < "u" && (window.navigator || navigator) ? window.navigator || navigator : !1;
      }, p = n.isIOS13Check = function(x) {
        var _ = y();
        return _ && _.platform && (_.platform.indexOf(x) !== -1 || _.platform === "MacIntel" && _.maxTouchPoints > 1 && !window.MSStream);
      };
      t.exports = {
        checkType: u,
        broPayload: d,
        mobilePayload: f,
        stvPayload: m,
        consolePayload: h,
        wearPayload: v,
        getNavigatorInstance: y,
        isIOS13Check: p
      };
    }
    /******/
  ]);
})(F_);
var N_ = F_.exports;
const kc = class kc extends CustomEvent {
  constructor(t) {
    super(kc.type, { detail: t });
  }
};
ne(kc, "type", "input-focus-toggle");
let bc = kc;
const Q3 = { class: "ot-input-number__field" }, J3 = { class: "ot-input-number__input" }, e4 = ["value", "name", "placeholder", "data-lpignore", "disabled"], t4 = {
  key: 0,
  class: "ot-input-number__subvalue"
}, n4 = {
  key: 0,
  class: "ot-input-number__outer ot-input-number__outer--currency"
}, i4 = {
  key: 1,
  class: "ot-input-number__outer ot-input-number__outer--right"
}, r4 = { class: "ot-input-number__outline" }, o4 = /* @__PURE__ */ ve("div", { class: "ot-input-number__outline-start" }, null, -1), a4 = { class: "ot-input-number__outline-notch" }, s4 = { class: "ot-input-number__label" }, l4 = /* @__PURE__ */ ve("div", { class: "ot-input-number__outline-end" }, null, -1), u4 = {
  name: "OtInputNumber",
  customOptions: {}
}, m7 = {
  light: "light",
  dark: "dark"
}, v7 = {
  default: "default",
  warning: "warning",
  error: "error"
}, W_ = /* @__PURE__ */ Ae({
  ...u4,
  props: {
    autofocus: { type: Boolean, default: !1 },
    compact: { type: Boolean, default: !0 },
    currency: { type: String, required: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { type: String, required: !0 },
    lpignore: { type: Boolean, default: !1 },
    name: { type: String, required: !0 },
    noRightPadding: { type: Boolean, default: !1 },
    precision: { type: Number, default: 0 },
    state: { type: String, default: "default" },
    subvalue: { type: String, required: !1 },
    value: { type: [String, null], required: !0 },
    variant: { type: String, default: "light" }
  },
  emits: ["blur", "focus", "inner-right-click", "toggle-input-state", "update:value"],
  setup(e, { emit: t }) {
    const n = e, i = t, { current: r } = tn(), o = zh(), a = ie();
    let l;
    const u = [
      8,
      // backspace
      9,
      // tab
      13,
      // enter
      17,
      // ctrl
      37,
      // left arrow
      38,
      // up arrow
      39,
      // right arrow
      40,
      // down arrow
      46,
      // delete
      48,
      // 0
      49,
      // 1
      50,
      // 2
      51,
      // 3
      52,
      // 4
      53,
      // 5
      54,
      // 6
      55,
      // 7
      56,
      // 8
      57,
      // 9
      65,
      // a
      67,
      // c
      82,
      // r
      86,
      // v
      88,
      // x
      91,
      // left window (on Mac: left command)
      96,
      // numpad 0
      97,
      // numpad 1
      98,
      // numpad 2
      99,
      // numpad 3
      100,
      // numpad 4
      101,
      // numpad 5
      102,
      // numpad 6
      103,
      // numpad 7
      104,
      // numpad 8
      105,
      // numpad 9
      116
      // F5
    ], d = [
      110,
      // numpad decimal point
      188,
      // ,
      190
      // .
    ], f = "ot-input-number", m = B(() => [
      f,
      `${f}--${n.variant}`,
      `${f}--${n.state}`,
      { [`${f}--compact`]: n.compact },
      { [`${f}--disabled`]: n.disabled }
    ]), h = B(() => n.precision <= 0 ? "0" : `0.${"0".repeat(n.precision)}`), v = (O, D) => O === "" || O == null || Number.isNaN(Number(O)) ? "" : dw({ v: O, precision: D, locale: r.value }), y = (O) => O ? u.indexOf(O.keyCode) !== -1 || d.indexOf(O.keyCode) !== -1 && O.target.value.indexOf(".") === -1 && n.precision > 0 ? !0 : (O.preventDefault(), !1) : !1, p = (O) => {
      const F = EL(n.precision)(O.target.value), $ = O.target.selectionStart;
      i("update:value", F), O.target.value = F, gt(() => {
        O.target.setSelectionRange($, $);
      });
    }, b = (O) => {
      var F;
      i("toggle-input-state", O);
      const D = new bc({
        focused: O
      });
      (F = a.value) == null || F.dispatchEvent(D);
    }, x = (O) => {
      b(!0), i("focus", O);
    }, _ = (O) => {
      b(!1);
      const D = v(n.value, n.precision);
      D !== n.value && i("update:value", D), i("blur", O);
    };
    return mn(() => {
      var D;
      n.autofocus && (N_.isIOS ? (D = a.value) == null || D.focus() : l = setTimeout(() => {
        var F;
        (F = a.value) == null || F.focus();
      }, 350));
    }), _n(() => {
      clearTimeout(l);
    }), (O, D) => (ee(), ce("div", {
      class: we(["ot-input-number", m.value])
    }, [
      ve("div", {
        class: we(["ot-input-number__wrapper", { "ot-input-number__wrapper--no-right-padding": e.noRightPadding }])
      }, [
        ve("div", Q3, [
          ve("div", J3, [
            ve("input", {
              ref_key: "inputRef",
              ref: a,
              testid: "number-input",
              autocomplete: "off",
              type: "text",
              inputmode: "decimal",
              value: e.value,
              name: e.name,
              placeholder: h.value,
              "data-lpignore": e.lpignore,
              disabled: e.disabled,
              onInput: D[0] || (D[0] = (F) => p(F)),
              onKeydown: D[1] || (D[1] = (F) => y(F)),
              onChange: D[2] || (D[2] = (F) => p(F)),
              onFocus: D[3] || (D[3] = (F) => x(F)),
              onBlur: D[4] || (D[4] = (F) => _(F))
            }, null, 40, e4),
            e.subvalue ? (ee(), ce("div", t4, [
              ve("span", null, Ue(e.subvalue), 1)
            ])) : Fe("", !0)
          ]),
          Be(o).right ? (ee(), ce("div", {
            key: 0,
            class: "ot-input-number__inner--right",
            testid: "number-input-right",
            onClick: D[5] || (D[5] = (F) => O.$emit("inner-right-click", F))
          }, [
            De(O.$slots, "right")
          ])) : Fe("", !0)
        ]),
        e.currency ? (ee(), ce("div", n4, [
          ve("span", null, Ue(e.currency), 1)
        ])) : Be(o).right ? (ee(), ce("div", i4, [
          De(O.$slots, "outer-right")
        ])) : Fe("", !0)
      ], 2),
      ve("div", r4, [
        o4,
        ve("div", a4, [
          ve("label", s4, Ue(e.label), 1)
        ]),
        l4
      ])
    ], 2));
  }
}), c4 = { class: "ot-input-text__field" }, d4 = ["tabindex", "value", "disabled"], f4 = { class: "ot-input-text__outer" }, h4 = { class: "ot-input-text__outline" }, g4 = /* @__PURE__ */ ve("div", { class: "ot-input-text__outline-start" }, null, -1), m4 = { class: "ot-input-text__outline-notch" }, v4 = { class: "ot-input-text__label" }, p4 = /* @__PURE__ */ ve("div", { class: "ot-input-text__outline-end" }, null, -1), y4 = {
  name: "OtInputText",
  customOptions: {}
}, p7 = {
  light: "light",
  dark: "dark"
}, y7 = {
  default: "default",
  warning: "warning",
  error: "error"
}, z_ = /* @__PURE__ */ Ae({
  ...y4,
  props: {
    autofocus: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: { type: String, required: !0 },
    short: { type: Boolean, default: !1 },
    state: { type: String, default: "default" },
    value: { type: String, default: "" },
    variant: { type: String, default: "dark" }
  },
  emits: ["blur", "focus", "toggle-input-state", "update:value"],
  setup(e, { expose: t, emit: n }) {
    const i = e, r = n;
    let o;
    const a = ie(), l = ie(null), u = B(() => ["ot-input-text", `ot-input-text--${i.variant}`, `ot-input-text--${i.state}`, { "ot-input-text--disabled": i.disabled }]), d = (v) => {
      if (!v.target || !("value" in v.target))
        return;
      const y = v.target.value;
      r("update:value", y);
    }, f = (v) => {
      var p;
      r("toggle-input-state", v);
      const y = new bc({
        focused: v
      });
      (p = a.value) == null || p.dispatchEvent(y);
    }, m = (v) => {
      f(!1), r("blur", v);
    }, h = (v) => {
      f(!0), r("focus", v);
    };
    return mn(() => {
      var y;
      i.autofocus && (N_.isIOS ? (y = a.value) == null || y.focus() : o = setTimeout(() => {
        var p;
        (p = a.value) == null || p.focus();
      }, 350));
    }), _n(() => {
      clearTimeout(o);
    }), t({
      inputTextRef: l
    }), (v, y) => (ee(), ce("div", {
      class: we(["ot-input-text", u.value])
    }, [
      ve("div", {
        ref_key: "inputTextRef",
        ref: l,
        class: "ot-input-text__wrapper"
      }, [
        ve("div", c4, [
          ve("input", ge({
            ref_key: "inputRef",
            ref: a,
            testid: "input",
            class: "truncate-text ot-input-text__input",
            type: "text",
            tabindex: v.$attrs.disabled ? -1 : 0,
            value: e.value,
            disabled: e.disabled
          }, v.$attrs, {
            onBlur: m,
            onFocus: h,
            onInput: d
          }), null, 16, d4)
        ]),
        ve("div", f4, [
          De(v.$slots, "right")
        ])
      ], 512),
      ve("div", h4, [
        g4,
        ve("div", m4, [
          ve("label", v4, Ue(e.label), 1)
        ]),
        p4
      ])
    ], 2));
  }
}), b4 = async () => {
  const { default: e } = await import("./blank-BpKuVu52.js"), t = await fetch(e).then((i) => i.text()).catch(() => {
  });
  return t ? `data:image/svg+xml;base64,${btoa(t)}` : void 0;
}, nb = (e, t, n) => `${e}/img/${t}/${n}.svg`, w4 = ["src"], _4 = {
  name: "OtLogo",
  customOptions: {}
}, Hg = /* @__PURE__ */ Ae({
  ..._4,
  props: {
    cdn: { type: String, default: "https://assets.onetrading.com" },
    name: { type: String, required: !0 },
    type: { type: String, required: !0 }
  },
  emits: ["clicked"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = ie(nb(n.cdn, n.type, n.name)), o = () => i("clicked"), a = (l, u) => {
      const d = new Image();
      d.src = l, d.complete ? u(!0) : (d.onload = () => {
        u(!0);
      }, d.onerror = () => {
        u(!1);
      });
    };
    return pe(
      () => n,
      () => {
        r.value = nb(n.cdn, n.type, n.name), a(r.value, async (l) => {
          if (!l) {
            const u = await b4();
            u && (r.value = u);
          }
        });
      },
      { immediate: !0 }
    ), (l, u) => (ee(), ce("div", {
      class: we(["ot-logo", `logo-${e.name}`])
    }, [
      ve("img", {
        src: r.value,
        onClick: o
      }, null, 8, w4)
    ], 2));
  }
}), x4 = { class: "ot-label__content" }, k4 = { class: "ot-label__title" }, S4 = {
  key: 0,
  class: "ot-label__subtitle"
}, C4 = {
  key: 1,
  class: "ot-label__subtitle"
}, O4 = {
  name: "OtLabel",
  customOptions: {}
}, jg = /* @__PURE__ */ Ae({
  ...O4,
  props: {
    cdn: { type: String, required: !1 },
    highlighted: { type: Boolean, default: !1 },
    leftIconInfo: { type: Boolean, required: !1 },
    leftIconInheritFill: { type: Boolean, default: !1 },
    leftIconInheritStroke: { type: Boolean, default: !1 },
    leftIconName: { type: String, required: !1 },
    leftIconVariant: { type: String, default: "default" },
    leftIconWarning: { type: Boolean, required: !1 },
    rightIconName: { type: String, required: !1 },
    subtitle: { type: String, required: !1 },
    title: { type: String, required: !1 },
    variant: { type: String, default: "default" }
  },
  setup(e) {
    return (t, n) => (ee(), ce("div", {
      class: we(["ot-label", `ot-label--${e.variant}`, { "ot-label--highlighted": e.highlighted }])
    }, [
      e.leftIconName && e.leftIconVariant !== "logo" ? (ee(), Ne(qt, {
        key: 0,
        class: we(["ot-label__icon ot-label__icon--left", `ot-label__icon--${e.leftIconVariant}`]),
        flag: e.leftIconVariant === "flag",
        "inherit-fill": e.leftIconInheritFill,
        "inherit-stroke": e.leftIconInheritStroke,
        name: e.leftIconName,
        "with-info": e.leftIconInfo,
        "with-warning": e.leftIconWarning
      }, null, 8, ["class", "flag", "inherit-fill", "inherit-stroke", "name", "with-info", "with-warning"])) : e.leftIconName ? (ee(), Ne(Hg, {
        key: 1,
        class: we(["ot-label__icon ot-label__icon--left", `ot-label__icon--${e.leftIconVariant}`]),
        cdn: e.cdn,
        name: e.leftIconName,
        type: "crypto"
      }, null, 8, ["class", "cdn", "name"])) : Fe("", !0),
      ve("div", x4, [
        ve("span", k4, Ue(e.title), 1),
        e.subtitle ? (ee(), ce("span", S4, Ue(e.subtitle), 1)) : t.$slots.subtitle ? (ee(), ce("span", C4, [
          De(t.$slots, "subtitle")
        ])) : Fe("", !0)
      ]),
      e.rightIconName ? (ee(), Ne(qt, {
        key: 2,
        class: "ot-label__icon ot-label__icon--right",
        name: e.rightIconName,
        "inherit-stroke": !0
      }, null, 8, ["name"])) : Fe("", !0),
      De(t.$slots, "additional-content")
    ], 2));
  }
}), M4 = { class: "ot-link-external__content" }, T4 = {
  name: "OtLinkExternal",
  customOptions: {}
}, H_ = /* @__PURE__ */ Ae({
  ...T4,
  props: {
    href: { type: String, required: !0 },
    isNative: { type: Boolean, default: !1 },
    noLinkIcon: { type: Boolean, default: !1 },
    noWrap: { type: Boolean, default: !1 },
    noUnderline: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, i = t, { href: r } = Bo(n), o = B(() => mg(n.isNative, r.value)), a = (l) => {
      i("click", l);
    };
    return (l, u) => (ee(), Ne(sr(o.value.el), ge(o.value.attrs, {
      class: ["ot-link-external", { "ot-link-external--no-icon": e.noLinkIcon, "ot-link-external--nowrap": e.noWrap, "ot-link-external--no-underline": e.noUnderline }],
      onClick: a
    }), {
      default: Ye(() => [
        ve("span", M4, [
          De(l.$slots, "default")
        ]),
        e.noLinkIcon ? Fe("", !0) : (ee(), Ne(qt, {
          key: 0,
          class: "ot-link-external__icon",
          name: "export",
          "inherit-stroke": !0
        }))
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), P4 = {
  key: 0,
  class: "ot-link-internal__title"
}, A4 = {
  name: "OtLinkInternal",
  customOptions: {}
}, j_ = /* @__PURE__ */ Ae({
  ...A4,
  props: {
    disabled: { type: Boolean, default: !1 },
    title: { type: String, required: !1 },
    variant: { type: String, default: "dark" }
  },
  setup(e) {
    return (t, n) => {
      const i = Hh("router-link");
      return ee(), Ne(i, ge({ class: "ot-link-internal" }, t.$attrs, {
        class: [`ot-link-internal--${e.variant}`, { "ot-link-internal--disabled": e.disabled }]
      }), {
        default: Ye(() => [
          e.title ? (ee(), ce("span", P4, Ue(e.title), 1)) : De(t.$slots, "default", { key: 1 })
        ]),
        _: 3
      }, 16, ["class"]);
    };
  }
}), E4 = {
  name: "OtListItem",
  customOptions: {}
}, b7 = {
  default: "default",
  light: "light"
}, qc = /* @__PURE__ */ Ae({
  ...E4,
  props: {
    active: { type: Boolean, default: !1 },
    emitId: { type: String, required: !1 },
    cdn: { type: String, required: !1 },
    href: { type: String, required: !1 },
    isNative: { type: Boolean, default: !1 },
    leftIconInfo: { type: Boolean, required: !1 },
    leftIconInheritFill: { type: Boolean, default: !1 },
    leftIconInheritStroke: { type: Boolean, default: !1 },
    leftIconName: { type: String, required: !1 },
    leftIconVariant: { type: String, default: "default" },
    leftIconWarning: { type: Boolean, default: !1 },
    routerLink: { type: [String, Object], required: !1 },
    subtitle: { type: String, required: !1 },
    title: { type: String, required: !1 },
    useSystemBrowser: { type: Boolean, default: !1 },
    variant: { type: String, default: "default" }
  },
  emits: ["click", "native-open-link"],
  setup(e, { emit: t }) {
    const n = e, i = t, { href: r } = Bo(n), o = ie(!1), a = B(() => n.active || o.value), l = B(() => n.routerLink ? {
      el: "router-link",
      attrs: {
        to: n.routerLink
      }
    } : (r == null ? void 0 : r.value) !== void 0 && typeof r.value == "string" ? mg(n.isNative, r.value) : {
      el: "span"
    }), u = (h) => {
      o.value = h;
    }, d = () => u(!0), f = () => u(!1), m = (h) => {
      n.href && n.isNative && i("native-open-link"), i("click", n.emitId || h);
    };
    return (h, v) => (ee(), Ne(sr(l.value.el), ge({ class: "ot-list-item" }, l.value.attrs, {
      class: [`ot-list-item--${e.variant}`, { "ot-list-item--active": e.active }],
      onClick: m,
      onMouseenter: d,
      onMouseleave: f
    }), {
      default: Ye(() => [
        T(jg, {
          class: "ot-list-item__label",
          title: e.title,
          subtitle: e.subtitle,
          variant: e.variant,
          highlighted: a.value,
          "left-icon-name": e.leftIconName,
          "left-icon-warning": e.leftIconWarning,
          "left-icon-info": e.leftIconInfo,
          "left-icon-variant": e.leftIconVariant,
          "left-icon-inherit-stroke": e.leftIconInheritStroke,
          "left-icon-inherit-fill": e.leftIconInheritFill,
          cdn: e.cdn,
          "right-icon-name": e.href ? "export" : void 0
        }, {
          subtitle: Ye(() => [
            De(h.$slots, "subtitle")
          ]),
          "additional-content": Ye(() => [
            De(h.$slots, "label-additional-content")
          ]),
          _: 3
        }, 8, ["title", "subtitle", "variant", "highlighted", "left-icon-name", "left-icon-warning", "left-icon-info", "left-icon-variant", "left-icon-inherit-stroke", "left-icon-inherit-fill", "cdn", "right-icon-name"])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), I4 = {
  name: "OtList",
  customOptions: {}
}, Y_ = /* @__PURE__ */ Ae({
  ...I4,
  setup(e) {
    const t = zh(), n = (r) => Un("div", { class: "ot-list" }, r), i = B(() => {
      const r = [];
      return t.default && t.default().forEach((o) => {
        if (o.type !== qc)
          return;
        const l = ["ot-list__item-container"];
        r.push(Un("div", { class: l }, [o]));
      }), n(r);
    });
    return (r, o) => (ee(), Ne(sr(i.value)));
  }
}), D4 = {
  name: "OtLozenge",
  customOptions: {}
}, U_ = /* @__PURE__ */ Ae({
  ...D4,
  props: {
    filled: { type: Boolean, default: !0 },
    solid: { type: Boolean, default: !1 },
    text: { type: String, required: !0 },
    uppercase: { type: Boolean, default: !1 },
    grayscale: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (ee(), ce("div", {
      class: we(["ot-lozenge", {
        "ot-lozenge--uppercase": e.uppercase,
        "ot-lozenge--grayscale": e.grayscale,
        "ot-lozenge--no-fill": !e.filled,
        "ot-lozenge--full-fill": e.solid
      }])
    }, Ue(e.text), 3));
  }
}), L4 = (e, t = "_") => {
  const [n, i] = e.split(t);
  return {
    base: n,
    quote: i
  };
}, B4 = { class: "ot-market-id__separator" }, V4 = {
  name: "OtMarketId",
  customOptions: {}
}, q_ = /* @__PURE__ */ Ae({
  ...V4,
  props: {
    isLink: { type: Boolean, default: !1 },
    underemphasizeSymbol: { type: String },
    marketId: { type: String, required: !0 },
    separator: { type: String, default: "/" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = B(() => L4(n.marketId, n.separator)), o = (d) => n.underemphasizeSymbol === d.toLocaleLowerCase(), a = B(() => o(r.value.base)), l = B(() => o(r.value.quote)), u = (d) => {
      n.isLink && (d.stopPropagation(), i("click"));
    };
    return (d, f) => (ee(), ce("div", {
      class: we(["ot-market-id", { "ot-market-id--link": e.isLink }]),
      onClick: u
    }, [
      ve("span", {
        class: we(["ot-market-id__symbol", { "ot-market-id__symbol--underemphasized": a.value }])
      }, Ue(r.value.base), 3),
      ve("span", B4, Ue(e.separator), 1),
      ve("span", {
        class: we(["ot-market-id__symbol", { "ot-market-id__symbol--underemphasized": l.value }])
      }, Ue(r.value.quote), 3)
    ], 2));
  }
}), $4 = {
  key: 0,
  class: "ot-number-display__prefix"
}, R4 = {
  class: "ot-number-display__value",
  testid: "number-display-value"
}, F4 = {
  name: "OtNumberDisplay",
  customOptions: {}
}, G_ = /* @__PURE__ */ Ae({
  ...F4,
  props: {
    addLowerSign: { type: Boolean, default: !1 },
    addPlusSign: { type: Boolean, default: !1 },
    coloredPercentage: { type: Boolean, default: !1 },
    currencyDisplay: { type: String, default: "code" },
    displayStyle: { type: String, default: "decimal" },
    grouping: { type: Boolean, default: !1 },
    leftAligned: { type: Boolean, default: !1 },
    number: { type: [Number, String, Object], required: !1 },
    percentage: { type: Boolean },
    precision: { type: Number, default: 0 },
    prefix: { type: String },
    smallerSuffix: { type: Boolean, default: !1 },
    suffix: { type: String },
    suffixClass: { type: String }
  },
  setup(e) {
    const t = e, { t: n, current: i } = tn(), r = B(() => t.number !== void 0 ? new zr(t.number) : void 0), o = B(() => {
      const d = [
        {
          "ot-number-display--left-aligned": t.leftAligned,
          "ot-number-display--smaller-suffix": t.smallerSuffix
        }
      ];
      if (t.coloredPercentage) {
        const f = () => {
          const m = r.value;
          return m ? m.gt(0) ? "positive" : m.lt(0) ? "negative" : "" : "";
        };
        d.push(f());
      }
      return d;
    }), a = B(() => t.prefix ?? ""), l = B(() => {
      const d = r.value && !r.value.isNaN();
      return t.percentage ? t.suffix ? `% ${t.suffix}` : d ? "%" : "" : t.suffix && d ? t.suffix : "";
    }), u = B(() => {
      const d = r.value;
      if (!d || d.isNaN())
        return n("$vuetify.fundamentals.emptyValues.default");
      let f = cw({
        number: d.toNumber(),
        precision: t.precision,
        grouping: t.grouping,
        style: t.displayStyle,
        currencyDisplay: t.currencyDisplay,
        locale: i.value
      });
      if (t.addLowerSign) {
        const m = new zr(10).pow(-t.precision);
        m.gt(new zr(f)) && !d.eq(0) && (f = `< ${m}`);
      }
      return t.addPlusSign && d.gt(0) && (f = `+${f}`), f;
    });
    return (d, f) => (ee(), ce("span", {
      class: we(["ot-number-display", o.value])
    }, [
      a.value ? (ee(), ce("span", $4, Ue(a.value), 1)) : Fe("", !0),
      ve("span", R4, Ue(u.value), 1),
      l.value ? (ee(), ce("span", {
        key: 1,
        class: we(["ot-number-display__suffix", e.suffixClass, { percentage: e.percentage }])
      }, Ue(l.value), 3)) : Fe("", !0)
    ], 2));
  }
}), N4 = {
  name: "OtPaginationControls",
  customOptions: {}
}, X_ = /* @__PURE__ */ Ae({
  ...N4,
  props: {
    cursors: { type: Object, required: !0 }
  },
  emits: ["page-changed", "update:cursors"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = ie(), o = B(() => [
      {
        icon: "previous",
        disabled: !n.cursors.hasPrev,
        action: l
      },
      {
        icon: "next",
        disabled: !n.cursors.hasNext,
        action: u
      }
    ]), a = () => {
      var f;
      const d = new CustomEvent("pagination-control:page-changed");
      (f = r.value) == null || f.dispatchEvent(d), i("update:cursors", n.cursors), i("page-changed", n.cursors.current);
    }, l = Fs.debounce(200, () => {
      n.cursors.goBack(), a();
    }), u = Fs.debounce(200, () => {
      n.cursors.goForward(), a();
    });
    return (d, f) => (ee(), ce("div", {
      ref_key: "paginationContainerElement",
      ref: r,
      class: "ot-pagination-controls"
    }, [
      e.cursors.hasPrev || e.cursors.hasNext ? (ee(!0), ce(qe, { key: 0 }, Dn(o.value, (m) => (ee(), ce("div", {
        key: m.icon,
        class: "ot-pagination-controls__control"
      }, [
        m.disabled ? Fe("", !0) : (ee(), Ne(Ur, {
          key: 0,
          size: "sm",
          variant: "dark-outline",
          class: we({ "ot-pagination-controls__control--disabled": m.disabled }),
          onClick: m.action
        }, {
          default: Ye(() => [
            T(qt, {
              class: "ot-pagination-controls__control-icon",
              name: m.icon,
              "inherit-stroke": !0
            }, null, 8, ["name"])
          ]),
          _: 2
        }, 1032, ["class", "onClick"]))
      ]))), 128)) : Fe("", !0)
    ], 512));
  }
});
class w7 {
  constructor() {
    ne(this, "list", [null]);
    // the cursor of the first page is null therefore we init an array with a null
    ne(this, "current", 1);
  }
  add(t) {
    this.list.indexOf(t) === -1 && this.list.push(t);
  }
  get cursor() {
    return this.list[this.current - 1];
  }
  goForward() {
    if (this.hasNext) {
      this.current += 1;
      return;
    }
    throw new Error("there is no next page!");
  }
  goBack() {
    if (this.hasPrev) {
      this.current -= 1;
      return;
    }
    throw new Error("there is no previous page!");
  }
  get hasNext() {
    return !!this.list[this.current];
  }
  get hasPrev() {
    return this.current !== 1;
  }
}
const W4 = { class: "ot-panel__content-holder" }, z4 = { class: "ot-panel__content" }, H4 = {
  key: 0,
  class: "ot-panel__footer"
}, j4 = {
  name: "OtPanel",
  customOptions: {}
}, K_ = /* @__PURE__ */ Ae({
  ...j4,
  props: {
    canClose: { type: Boolean, default: !1 },
    defaultHeight: { type: Number, default: 300 },
    expanding: { type: Boolean, default: !0 },
    open: { type: Boolean, default: !1 },
    openExpended: { type: Boolean, default: !1 }
  },
  emits: ["update:open", "close"],
  setup(e, { emit: t }) {
    const n = e, i = t, { t: r } = tn(), o = 35, a = ie(!1), l = ie(!1), u = ie(0), d = ie(0), f = ie(0), m = ie(0), h = window.innerHeight * 0.01, v = 90 * h, y = () => n.openExpended ? v : n.defaultHeight, p = ie(y()), b = ie(p.value), x = 15 * h, _ = 0.2, O = ie(!1), D = () => {
      O.value = !1;
    }, F = B(() => r("$vuetify.fundamentals.close")), $ = B({
      get: () => n.open,
      set: (N) => {
        i("update:open", N);
      }
    }), A = () => {
      let N = b.value;
      const V = Math.abs(u.value - d.value), z = V / (m.value - f.value), H = u.value > d.value, W = V > x, j = z > _;
      W || j ? H && n.expanding ? (N = v, a.value = !0) : a.value || H && !n.expanding ? (N = n.defaultHeight, a.value = !1) : j && D() : N = b.value, requestAnimationFrame(() => {
        p.value = N;
      });
    }, k = (N, V) => {
      l.value = !0, V ? u.value = N.changedTouches[0].clientY : u.value = N.clientY, f.value = (/* @__PURE__ */ new Date()).getTime(), b.value = p.value;
    }, S = (N, V) => {
      l.value && (l.value = !1, V ? d.value = N.changedTouches[0].clientY : d.value = N.clientY, m.value = (/* @__PURE__ */ new Date()).getTime(), A());
    }, M = (N, V) => {
      l.value && requestAnimationFrame(() => {
        V && "changedTouches" in N ? p.value = window.innerHeight - N.changedTouches[0].clientY + o / 2 : "clientY" in N && (p.value = window.innerHeight - N.clientY + o / 2);
      });
    }, E = () => {
      i("close"), $.value = !1, O.value = !1, p.value = y(), a.value = !1;
    }, I = (N) => S(N, !0), L = (N) => S(N);
    return mn(() => {
      window.addEventListener("touchend", I), window.addEventListener("mouseup", L);
    }), _n(() => {
      window.removeEventListener("touchend", I), window.removeEventListener("mouseup", L);
    }), (N, V) => (ee(), Ne(As, { to: "body" }, [
      T(hn, {
        name: "panel-container",
        onAfterEnter: V[3] || (V[3] = (z) => O.value = !0)
      }, {
        default: Ye(() => [
          $.value ? (ee(), ce("div", {
            key: 0,
            ref: "panel",
            class: we(["ot-panel ot-panel--open", { "ot-panel--dragging": l.value, "ot-panel--expanded": a.value }]),
            onMousemove: M,
            onTouchmove: V[1] || (V[1] = (z) => M(z, !0)),
            onMousedown: V[2] || (V[2] = Wr((z) => $.value && D(), ["self"]))
          }, [
            T(hn, {
              name: "sliding-panel",
              onAfterLeave: E
            }, {
              default: Ye(() => [
                O.value ? (ee(), ce("div", {
                  key: 0,
                  class: "ot-panel__animation-handler",
                  style: Do({ height: p.value + "px" })
                }, [
                  ve("div", W4, [
                    ve("div", {
                      ref: "panel-grab-handle",
                      class: "ot-panel__grab-handle",
                      style: Do({ height: o + "px" }),
                      onMousedown: k,
                      onTouchstart: V[0] || (V[0] = (z) => k(z, !0))
                    }, null, 36),
                    ve("div", z4, [
                      De(N.$slots, "default")
                    ]),
                    e.canClose ? (ee(), ce("div", H4, [
                      T(Ur, {
                        text: F.value,
                        onClick: D
                      }, null, 8, ["text"])
                    ])) : Fe("", !0)
                  ])
                ], 4)) : Fe("", !0)
              ]),
              _: 3
            })
          ], 34)) : Fe("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), Y4 = { class: "ot-pid__text" }, U4 = {
  name: "OtPid",
  customOptions: {}
}, Z_ = /* @__PURE__ */ Ae({
  ...U4,
  props: {
    text: { type: [String, Number], required: !0 },
    onError: { type: Function, default: () => {
    } },
    onSuccess: { type: Function, default: () => {
    } }
  },
  setup(e) {
    const t = e, n = () => {
      var o;
      (o = t.onSuccess) == null || o.call(t);
    }, i = () => {
      var o;
      (o = t.onError) == null || o.call(t);
    }, r = async () => {
      try {
        await E_(String(t.text)), n();
      } catch {
        i();
      }
    };
    return (o, a) => {
      const l = Hh("ot-icon");
      return ee(), ce("div", {
        class: "ot-pid",
        onClick: r
      }, [
        ve("span", Y4, Ue(e.text), 1),
        T(l, {
          class: "ot-pid__icon",
          name: "copy"
        })
      ]);
    };
  }
}), q4 = {
  name: "OtProgressBar",
  customOptions: {}
}, Q_ = /* @__PURE__ */ Ae({
  ...q4,
  props: {
    size: { type: String, default: "md" },
    value: { type: [String, Number], default: "0" }
  },
  setup(e) {
    const t = e, n = B(() => Math.min(Math.round(+t.value), 100)), i = B(() => [`ot-progress--${t.size}`]);
    return (r, o) => (ee(), ce("div", {
      class: we(["ot-progress", i.value])
    }, [
      n.value > 0 ? (ee(), ce("div", {
        key: 0,
        class: "ot-progress__bar",
        style: Do({ width: `${n.value}%` })
      }, null, 4)) : Fe("", !0)
    ], 2));
  }
});
var gl = {}, G4 = function() {
  return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
}, J_ = {}, Zn = {};
let Yg;
const X4 = [
  0,
  // Not used
  26,
  44,
  70,
  100,
  134,
  172,
  196,
  242,
  292,
  346,
  404,
  466,
  532,
  581,
  655,
  733,
  815,
  901,
  991,
  1085,
  1156,
  1258,
  1364,
  1474,
  1588,
  1706,
  1828,
  1921,
  2051,
  2185,
  2323,
  2465,
  2611,
  2761,
  2876,
  3034,
  3196,
  3362,
  3532,
  3706
];
Zn.getSymbolSize = function(t) {
  if (!t)
    throw new Error('"version" cannot be null or undefined');
  if (t < 1 || t > 40)
    throw new Error('"version" should be in range from 1 to 40');
  return t * 4 + 17;
};
Zn.getSymbolTotalCodewords = function(t) {
  return X4[t];
};
Zn.getBCHDigit = function(e) {
  let t = 0;
  for (; e !== 0; )
    t++, e >>>= 1;
  return t;
};
Zn.setToSJISFunction = function(t) {
  if (typeof t != "function")
    throw new Error('"toSJISFunc" is not a valid function.');
  Yg = t;
};
Zn.isKanjiModeEnabled = function() {
  return typeof Yg < "u";
};
Zn.toSJIS = function(t) {
  return Yg(t);
};
var Gc = {};
(function(e) {
  e.L = { bit: 1 }, e.M = { bit: 0 }, e.Q = { bit: 3 }, e.H = { bit: 2 };
  function t(n) {
    if (typeof n != "string")
      throw new Error("Param is not a string");
    switch (n.toLowerCase()) {
      case "l":
      case "low":
        return e.L;
      case "m":
      case "medium":
        return e.M;
      case "q":
      case "quartile":
        return e.Q;
      case "h":
      case "high":
        return e.H;
      default:
        throw new Error("Unknown EC Level: " + n);
    }
  }
  e.isValid = function(i) {
    return i && typeof i.bit < "u" && i.bit >= 0 && i.bit < 4;
  }, e.from = function(i, r) {
    if (e.isValid(i))
      return i;
    try {
      return t(i);
    } catch {
      return r;
    }
  };
})(Gc);
function ex() {
  this.buffer = [], this.length = 0;
}
ex.prototype = {
  get: function(e) {
    const t = Math.floor(e / 8);
    return (this.buffer[t] >>> 7 - e % 8 & 1) === 1;
  },
  put: function(e, t) {
    for (let n = 0; n < t; n++)
      this.putBit((e >>> t - n - 1 & 1) === 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(e) {
    const t = Math.floor(this.length / 8);
    this.buffer.length <= t && this.buffer.push(0), e && (this.buffer[t] |= 128 >>> this.length % 8), this.length++;
  }
};
var K4 = ex;
function ml(e) {
  if (!e || e < 1)
    throw new Error("BitMatrix size must be defined and greater than 0");
  this.size = e, this.data = new Uint8Array(e * e), this.reservedBit = new Uint8Array(e * e);
}
ml.prototype.set = function(e, t, n, i) {
  const r = e * this.size + t;
  this.data[r] = n, i && (this.reservedBit[r] = !0);
};
ml.prototype.get = function(e, t) {
  return this.data[e * this.size + t];
};
ml.prototype.xor = function(e, t, n) {
  this.data[e * this.size + t] ^= n;
};
ml.prototype.isReserved = function(e, t) {
  return this.reservedBit[e * this.size + t];
};
var Z4 = ml, tx = {};
(function(e) {
  const t = Zn.getSymbolSize;
  e.getRowColCoords = function(i) {
    if (i === 1)
      return [];
    const r = Math.floor(i / 7) + 2, o = t(i), a = o === 145 ? 26 : Math.ceil((o - 13) / (2 * r - 2)) * 2, l = [o - 7];
    for (let u = 1; u < r - 1; u++)
      l[u] = l[u - 1] - a;
    return l.push(6), l.reverse();
  }, e.getPositions = function(i) {
    const r = [], o = e.getRowColCoords(i), a = o.length;
    for (let l = 0; l < a; l++)
      for (let u = 0; u < a; u++)
        l === 0 && u === 0 || // top-left
        l === 0 && u === a - 1 || // bottom-left
        l === a - 1 && u === 0 || r.push([o[l], o[u]]);
    return r;
  };
})(tx);
var nx = {};
const Q4 = Zn.getSymbolSize, ib = 7;
nx.getPositions = function(t) {
  const n = Q4(t);
  return [
    // top-left
    [0, 0],
    // top-right
    [n - ib, 0],
    // bottom-left
    [0, n - ib]
  ];
};
var ix = {};
(function(e) {
  e.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
  };
  const t = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
  };
  e.isValid = function(r) {
    return r != null && r !== "" && !isNaN(r) && r >= 0 && r <= 7;
  }, e.from = function(r) {
    return e.isValid(r) ? parseInt(r, 10) : void 0;
  }, e.getPenaltyN1 = function(r) {
    const o = r.size;
    let a = 0, l = 0, u = 0, d = null, f = null;
    for (let m = 0; m < o; m++) {
      l = u = 0, d = f = null;
      for (let h = 0; h < o; h++) {
        let v = r.get(m, h);
        v === d ? l++ : (l >= 5 && (a += t.N1 + (l - 5)), d = v, l = 1), v = r.get(h, m), v === f ? u++ : (u >= 5 && (a += t.N1 + (u - 5)), f = v, u = 1);
      }
      l >= 5 && (a += t.N1 + (l - 5)), u >= 5 && (a += t.N1 + (u - 5));
    }
    return a;
  }, e.getPenaltyN2 = function(r) {
    const o = r.size;
    let a = 0;
    for (let l = 0; l < o - 1; l++)
      for (let u = 0; u < o - 1; u++) {
        const d = r.get(l, u) + r.get(l, u + 1) + r.get(l + 1, u) + r.get(l + 1, u + 1);
        (d === 4 || d === 0) && a++;
      }
    return a * t.N2;
  }, e.getPenaltyN3 = function(r) {
    const o = r.size;
    let a = 0, l = 0, u = 0;
    for (let d = 0; d < o; d++) {
      l = u = 0;
      for (let f = 0; f < o; f++)
        l = l << 1 & 2047 | r.get(d, f), f >= 10 && (l === 1488 || l === 93) && a++, u = u << 1 & 2047 | r.get(f, d), f >= 10 && (u === 1488 || u === 93) && a++;
    }
    return a * t.N3;
  }, e.getPenaltyN4 = function(r) {
    let o = 0;
    const a = r.data.length;
    for (let u = 0; u < a; u++)
      o += r.data[u];
    return Math.abs(Math.ceil(o * 100 / a / 5) - 10) * t.N4;
  };
  function n(i, r, o) {
    switch (i) {
      case e.Patterns.PATTERN000:
        return (r + o) % 2 === 0;
      case e.Patterns.PATTERN001:
        return r % 2 === 0;
      case e.Patterns.PATTERN010:
        return o % 3 === 0;
      case e.Patterns.PATTERN011:
        return (r + o) % 3 === 0;
      case e.Patterns.PATTERN100:
        return (Math.floor(r / 2) + Math.floor(o / 3)) % 2 === 0;
      case e.Patterns.PATTERN101:
        return r * o % 2 + r * o % 3 === 0;
      case e.Patterns.PATTERN110:
        return (r * o % 2 + r * o % 3) % 2 === 0;
      case e.Patterns.PATTERN111:
        return (r * o % 3 + (r + o) % 2) % 2 === 0;
      default:
        throw new Error("bad maskPattern:" + i);
    }
  }
  e.applyMask = function(r, o) {
    const a = o.size;
    for (let l = 0; l < a; l++)
      for (let u = 0; u < a; u++)
        o.isReserved(u, l) || o.xor(u, l, n(r, u, l));
  }, e.getBestMask = function(r, o) {
    const a = Object.keys(e.Patterns).length;
    let l = 0, u = 1 / 0;
    for (let d = 0; d < a; d++) {
      o(d), e.applyMask(d, r);
      const f = e.getPenaltyN1(r) + e.getPenaltyN2(r) + e.getPenaltyN3(r) + e.getPenaltyN4(r);
      e.applyMask(d, r), f < u && (u = f, l = d);
    }
    return l;
  };
})(ix);
var Xc = {};
const Nr = Gc, Au = [
  // L  M  Q  H
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  1,
  2,
  2,
  4,
  1,
  2,
  4,
  4,
  2,
  4,
  4,
  4,
  2,
  4,
  6,
  5,
  2,
  4,
  6,
  6,
  2,
  5,
  8,
  8,
  4,
  5,
  8,
  8,
  4,
  5,
  8,
  11,
  4,
  8,
  10,
  11,
  4,
  9,
  12,
  16,
  4,
  9,
  16,
  16,
  6,
  10,
  12,
  18,
  6,
  10,
  17,
  16,
  6,
  11,
  16,
  19,
  6,
  13,
  18,
  21,
  7,
  14,
  21,
  25,
  8,
  16,
  20,
  25,
  8,
  17,
  23,
  25,
  9,
  17,
  23,
  34,
  9,
  18,
  25,
  30,
  10,
  20,
  27,
  32,
  12,
  21,
  29,
  35,
  12,
  23,
  34,
  37,
  12,
  25,
  34,
  40,
  13,
  26,
  35,
  42,
  14,
  28,
  38,
  45,
  15,
  29,
  40,
  48,
  16,
  31,
  43,
  51,
  17,
  33,
  45,
  54,
  18,
  35,
  48,
  57,
  19,
  37,
  51,
  60,
  19,
  38,
  53,
  63,
  20,
  40,
  56,
  66,
  21,
  43,
  59,
  70,
  22,
  45,
  62,
  74,
  24,
  47,
  65,
  77,
  25,
  49,
  68,
  81
], Eu = [
  // L  M  Q  H
  7,
  10,
  13,
  17,
  10,
  16,
  22,
  28,
  15,
  26,
  36,
  44,
  20,
  36,
  52,
  64,
  26,
  48,
  72,
  88,
  36,
  64,
  96,
  112,
  40,
  72,
  108,
  130,
  48,
  88,
  132,
  156,
  60,
  110,
  160,
  192,
  72,
  130,
  192,
  224,
  80,
  150,
  224,
  264,
  96,
  176,
  260,
  308,
  104,
  198,
  288,
  352,
  120,
  216,
  320,
  384,
  132,
  240,
  360,
  432,
  144,
  280,
  408,
  480,
  168,
  308,
  448,
  532,
  180,
  338,
  504,
  588,
  196,
  364,
  546,
  650,
  224,
  416,
  600,
  700,
  224,
  442,
  644,
  750,
  252,
  476,
  690,
  816,
  270,
  504,
  750,
  900,
  300,
  560,
  810,
  960,
  312,
  588,
  870,
  1050,
  336,
  644,
  952,
  1110,
  360,
  700,
  1020,
  1200,
  390,
  728,
  1050,
  1260,
  420,
  784,
  1140,
  1350,
  450,
  812,
  1200,
  1440,
  480,
  868,
  1290,
  1530,
  510,
  924,
  1350,
  1620,
  540,
  980,
  1440,
  1710,
  570,
  1036,
  1530,
  1800,
  570,
  1064,
  1590,
  1890,
  600,
  1120,
  1680,
  1980,
  630,
  1204,
  1770,
  2100,
  660,
  1260,
  1860,
  2220,
  720,
  1316,
  1950,
  2310,
  750,
  1372,
  2040,
  2430
];
Xc.getBlocksCount = function(t, n) {
  switch (n) {
    case Nr.L:
      return Au[(t - 1) * 4 + 0];
    case Nr.M:
      return Au[(t - 1) * 4 + 1];
    case Nr.Q:
      return Au[(t - 1) * 4 + 2];
    case Nr.H:
      return Au[(t - 1) * 4 + 3];
    default:
      return;
  }
};
Xc.getTotalCodewordsCount = function(t, n) {
  switch (n) {
    case Nr.L:
      return Eu[(t - 1) * 4 + 0];
    case Nr.M:
      return Eu[(t - 1) * 4 + 1];
    case Nr.Q:
      return Eu[(t - 1) * 4 + 2];
    case Nr.H:
      return Eu[(t - 1) * 4 + 3];
    default:
      return;
  }
};
var rx = {}, Kc = {};
const Ps = new Uint8Array(512), wc = new Uint8Array(256);
(function() {
  let t = 1;
  for (let n = 0; n < 255; n++)
    Ps[n] = t, wc[t] = n, t <<= 1, t & 256 && (t ^= 285);
  for (let n = 255; n < 512; n++)
    Ps[n] = Ps[n - 255];
})();
Kc.log = function(t) {
  if (t < 1)
    throw new Error("log(" + t + ")");
  return wc[t];
};
Kc.exp = function(t) {
  return Ps[t];
};
Kc.mul = function(t, n) {
  return t === 0 || n === 0 ? 0 : Ps[wc[t] + wc[n]];
};
(function(e) {
  const t = Kc;
  e.mul = function(i, r) {
    const o = new Uint8Array(i.length + r.length - 1);
    for (let a = 0; a < i.length; a++)
      for (let l = 0; l < r.length; l++)
        o[a + l] ^= t.mul(i[a], r[l]);
    return o;
  }, e.mod = function(i, r) {
    let o = new Uint8Array(i);
    for (; o.length - r.length >= 0; ) {
      const a = o[0];
      for (let u = 0; u < r.length; u++)
        o[u] ^= t.mul(r[u], a);
      let l = 0;
      for (; l < o.length && o[l] === 0; )
        l++;
      o = o.slice(l);
    }
    return o;
  }, e.generateECPolynomial = function(i) {
    let r = new Uint8Array([1]);
    for (let o = 0; o < i; o++)
      r = e.mul(r, new Uint8Array([1, t.exp(o)]));
    return r;
  };
})(rx);
const ox = rx;
function Ug(e) {
  this.genPoly = void 0, this.degree = e, this.degree && this.initialize(this.degree);
}
Ug.prototype.initialize = function(t) {
  this.degree = t, this.genPoly = ox.generateECPolynomial(this.degree);
};
Ug.prototype.encode = function(t) {
  if (!this.genPoly)
    throw new Error("Encoder not initialized");
  const n = new Uint8Array(t.length + this.degree);
  n.set(t);
  const i = ox.mod(n, this.genPoly), r = this.degree - i.length;
  if (r > 0) {
    const o = new Uint8Array(this.degree);
    return o.set(i, r), o;
  }
  return i;
};
var J4 = Ug, ax = {}, eo = {}, qg = {};
qg.isValid = function(t) {
  return !isNaN(t) && t >= 1 && t <= 40;
};
var Hi = {};
const sx = "[0-9]+", e6 = "[A-Z $%*+\\-./:]+";
let Gs = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
Gs = Gs.replace(/u/g, "\\u");
const t6 = "(?:(?![A-Z0-9 $%*+\\-./:]|" + Gs + `)(?:.|[\r
]))+`;
Hi.KANJI = new RegExp(Gs, "g");
Hi.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
Hi.BYTE = new RegExp(t6, "g");
Hi.NUMERIC = new RegExp(sx, "g");
Hi.ALPHANUMERIC = new RegExp(e6, "g");
const n6 = new RegExp("^" + Gs + "$"), i6 = new RegExp("^" + sx + "$"), r6 = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
Hi.testKanji = function(t) {
  return n6.test(t);
};
Hi.testNumeric = function(t) {
  return i6.test(t);
};
Hi.testAlphanumeric = function(t) {
  return r6.test(t);
};
(function(e) {
  const t = qg, n = Hi;
  e.NUMERIC = {
    id: "Numeric",
    bit: 1,
    ccBits: [10, 12, 14]
  }, e.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [9, 11, 13]
  }, e.BYTE = {
    id: "Byte",
    bit: 4,
    ccBits: [8, 16, 16]
  }, e.KANJI = {
    id: "Kanji",
    bit: 8,
    ccBits: [8, 10, 12]
  }, e.MIXED = {
    bit: -1
  }, e.getCharCountIndicator = function(o, a) {
    if (!o.ccBits)
      throw new Error("Invalid mode: " + o);
    if (!t.isValid(a))
      throw new Error("Invalid version: " + a);
    return a >= 1 && a < 10 ? o.ccBits[0] : a < 27 ? o.ccBits[1] : o.ccBits[2];
  }, e.getBestModeForData = function(o) {
    return n.testNumeric(o) ? e.NUMERIC : n.testAlphanumeric(o) ? e.ALPHANUMERIC : n.testKanji(o) ? e.KANJI : e.BYTE;
  }, e.toString = function(o) {
    if (o && o.id)
      return o.id;
    throw new Error("Invalid mode");
  }, e.isValid = function(o) {
    return o && o.bit && o.ccBits;
  };
  function i(r) {
    if (typeof r != "string")
      throw new Error("Param is not a string");
    switch (r.toLowerCase()) {
      case "numeric":
        return e.NUMERIC;
      case "alphanumeric":
        return e.ALPHANUMERIC;
      case "kanji":
        return e.KANJI;
      case "byte":
        return e.BYTE;
      default:
        throw new Error("Unknown mode: " + r);
    }
  }
  e.from = function(o, a) {
    if (e.isValid(o))
      return o;
    try {
      return i(o);
    } catch {
      return a;
    }
  };
})(eo);
(function(e) {
  const t = Zn, n = Xc, i = Gc, r = eo, o = qg, a = 7973, l = t.getBCHDigit(a);
  function u(h, v, y) {
    for (let p = 1; p <= 40; p++)
      if (v <= e.getCapacity(p, y, h))
        return p;
  }
  function d(h, v) {
    return r.getCharCountIndicator(h, v) + 4;
  }
  function f(h, v) {
    let y = 0;
    return h.forEach(function(p) {
      const b = d(p.mode, v);
      y += b + p.getBitsLength();
    }), y;
  }
  function m(h, v) {
    for (let y = 1; y <= 40; y++)
      if (f(h, y) <= e.getCapacity(y, v, r.MIXED))
        return y;
  }
  e.from = function(v, y) {
    return o.isValid(v) ? parseInt(v, 10) : y;
  }, e.getCapacity = function(v, y, p) {
    if (!o.isValid(v))
      throw new Error("Invalid QR Code version");
    typeof p > "u" && (p = r.BYTE);
    const b = t.getSymbolTotalCodewords(v), x = n.getTotalCodewordsCount(v, y), _ = (b - x) * 8;
    if (p === r.MIXED)
      return _;
    const O = _ - d(p, v);
    switch (p) {
      case r.NUMERIC:
        return Math.floor(O / 10 * 3);
      case r.ALPHANUMERIC:
        return Math.floor(O / 11 * 2);
      case r.KANJI:
        return Math.floor(O / 13);
      case r.BYTE:
      default:
        return Math.floor(O / 8);
    }
  }, e.getBestVersionForData = function(v, y) {
    let p;
    const b = i.from(y, i.M);
    if (Array.isArray(v)) {
      if (v.length > 1)
        return m(v, b);
      if (v.length === 0)
        return 1;
      p = v[0];
    } else
      p = v;
    return u(p.mode, p.getLength(), b);
  }, e.getEncodedBits = function(v) {
    if (!o.isValid(v) || v < 7)
      throw new Error("Invalid QR Code version");
    let y = v << 12;
    for (; t.getBCHDigit(y) - l >= 0; )
      y ^= a << t.getBCHDigit(y) - l;
    return v << 12 | y;
  };
})(ax);
var lx = {};
const Dh = Zn, ux = 1335, o6 = 21522, rb = Dh.getBCHDigit(ux);
lx.getEncodedBits = function(t, n) {
  const i = t.bit << 3 | n;
  let r = i << 10;
  for (; Dh.getBCHDigit(r) - rb >= 0; )
    r ^= ux << Dh.getBCHDigit(r) - rb;
  return (i << 10 | r) ^ o6;
};
var cx = {};
const a6 = eo;
function Aa(e) {
  this.mode = a6.NUMERIC, this.data = e.toString();
}
Aa.getBitsLength = function(t) {
  return 10 * Math.floor(t / 3) + (t % 3 ? t % 3 * 3 + 1 : 0);
};
Aa.prototype.getLength = function() {
  return this.data.length;
};
Aa.prototype.getBitsLength = function() {
  return Aa.getBitsLength(this.data.length);
};
Aa.prototype.write = function(t) {
  let n, i, r;
  for (n = 0; n + 3 <= this.data.length; n += 3)
    i = this.data.substr(n, 3), r = parseInt(i, 10), t.put(r, 10);
  const o = this.data.length - n;
  o > 0 && (i = this.data.substr(n), r = parseInt(i, 10), t.put(r, o * 3 + 1));
};
var s6 = Aa;
const l6 = eo, Gf = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  " ",
  "$",
  "%",
  "*",
  "+",
  "-",
  ".",
  "/",
  ":"
];
function Ea(e) {
  this.mode = l6.ALPHANUMERIC, this.data = e;
}
Ea.getBitsLength = function(t) {
  return 11 * Math.floor(t / 2) + 6 * (t % 2);
};
Ea.prototype.getLength = function() {
  return this.data.length;
};
Ea.prototype.getBitsLength = function() {
  return Ea.getBitsLength(this.data.length);
};
Ea.prototype.write = function(t) {
  let n;
  for (n = 0; n + 2 <= this.data.length; n += 2) {
    let i = Gf.indexOf(this.data[n]) * 45;
    i += Gf.indexOf(this.data[n + 1]), t.put(i, 11);
  }
  this.data.length % 2 && t.put(Gf.indexOf(this.data[n]), 6);
};
var u6 = Ea, c6 = function(t) {
  for (var n = [], i = t.length, r = 0; r < i; r++) {
    var o = t.charCodeAt(r);
    if (o >= 55296 && o <= 56319 && i > r + 1) {
      var a = t.charCodeAt(r + 1);
      a >= 56320 && a <= 57343 && (o = (o - 55296) * 1024 + a - 56320 + 65536, r += 1);
    }
    if (o < 128) {
      n.push(o);
      continue;
    }
    if (o < 2048) {
      n.push(o >> 6 | 192), n.push(o & 63 | 128);
      continue;
    }
    if (o < 55296 || o >= 57344 && o < 65536) {
      n.push(o >> 12 | 224), n.push(o >> 6 & 63 | 128), n.push(o & 63 | 128);
      continue;
    }
    if (o >= 65536 && o <= 1114111) {
      n.push(o >> 18 | 240), n.push(o >> 12 & 63 | 128), n.push(o >> 6 & 63 | 128), n.push(o & 63 | 128);
      continue;
    }
    n.push(239, 191, 189);
  }
  return new Uint8Array(n).buffer;
};
const d6 = c6, f6 = eo;
function Ia(e) {
  this.mode = f6.BYTE, typeof e == "string" && (e = d6(e)), this.data = new Uint8Array(e);
}
Ia.getBitsLength = function(t) {
  return t * 8;
};
Ia.prototype.getLength = function() {
  return this.data.length;
};
Ia.prototype.getBitsLength = function() {
  return Ia.getBitsLength(this.data.length);
};
Ia.prototype.write = function(e) {
  for (let t = 0, n = this.data.length; t < n; t++)
    e.put(this.data[t], 8);
};
var h6 = Ia;
const g6 = eo, m6 = Zn;
function Da(e) {
  this.mode = g6.KANJI, this.data = e;
}
Da.getBitsLength = function(t) {
  return t * 13;
};
Da.prototype.getLength = function() {
  return this.data.length;
};
Da.prototype.getBitsLength = function() {
  return Da.getBitsLength(this.data.length);
};
Da.prototype.write = function(e) {
  let t;
  for (t = 0; t < this.data.length; t++) {
    let n = m6.toSJIS(this.data[t]);
    if (n >= 33088 && n <= 40956)
      n -= 33088;
    else if (n >= 57408 && n <= 60351)
      n -= 49472;
    else
      throw new Error(
        "Invalid SJIS character: " + this.data[t] + `
Make sure your charset is UTF-8`
      );
    n = (n >>> 8 & 255) * 192 + (n & 255), e.put(n, 13);
  }
};
var v6 = Da, dx = { exports: {} };
(function(e) {
  var t = {
    single_source_shortest_paths: function(n, i, r) {
      var o = {}, a = {};
      a[i] = 0;
      var l = t.PriorityQueue.make();
      l.push(i, 0);
      for (var u, d, f, m, h, v, y, p, b; !l.empty(); ) {
        u = l.pop(), d = u.value, m = u.cost, h = n[d] || {};
        for (f in h)
          h.hasOwnProperty(f) && (v = h[f], y = m + v, p = a[f], b = typeof a[f] > "u", (b || p > y) && (a[f] = y, l.push(f, y), o[f] = d));
      }
      if (typeof r < "u" && typeof a[r] > "u") {
        var x = ["Could not find a path from ", i, " to ", r, "."].join("");
        throw new Error(x);
      }
      return o;
    },
    extract_shortest_path_from_predecessor_list: function(n, i) {
      for (var r = [], o = i; o; )
        r.push(o), n[o], o = n[o];
      return r.reverse(), r;
    },
    find_path: function(n, i, r) {
      var o = t.single_source_shortest_paths(n, i, r);
      return t.extract_shortest_path_from_predecessor_list(
        o,
        r
      );
    },
    /**
     * A very naive priority queue implementation.
     */
    PriorityQueue: {
      make: function(n) {
        var i = t.PriorityQueue, r = {}, o;
        n = n || {};
        for (o in i)
          i.hasOwnProperty(o) && (r[o] = i[o]);
        return r.queue = [], r.sorter = n.sorter || i.default_sorter, r;
      },
      default_sorter: function(n, i) {
        return n.cost - i.cost;
      },
      /**
       * Add a new item to the queue and ensure the highest priority element
       * is at the front of the queue.
       */
      push: function(n, i) {
        var r = { value: n, cost: i };
        this.queue.push(r), this.queue.sort(this.sorter);
      },
      /**
       * Return the highest priority element in the queue.
       */
      pop: function() {
        return this.queue.shift();
      },
      empty: function() {
        return this.queue.length === 0;
      }
    }
  };
  e.exports = t;
})(dx);
var p6 = dx.exports;
(function(e) {
  const t = eo, n = s6, i = u6, r = h6, o = v6, a = Hi, l = Zn, u = p6;
  function d(x) {
    return unescape(encodeURIComponent(x)).length;
  }
  function f(x, _, O) {
    const D = [];
    let F;
    for (; (F = x.exec(O)) !== null; )
      D.push({
        data: F[0],
        index: F.index,
        mode: _,
        length: F[0].length
      });
    return D;
  }
  function m(x) {
    const _ = f(a.NUMERIC, t.NUMERIC, x), O = f(a.ALPHANUMERIC, t.ALPHANUMERIC, x);
    let D, F;
    return l.isKanjiModeEnabled() ? (D = f(a.BYTE, t.BYTE, x), F = f(a.KANJI, t.KANJI, x)) : (D = f(a.BYTE_KANJI, t.BYTE, x), F = []), _.concat(O, D, F).sort(function(A, k) {
      return A.index - k.index;
    }).map(function(A) {
      return {
        data: A.data,
        mode: A.mode,
        length: A.length
      };
    });
  }
  function h(x, _) {
    switch (_) {
      case t.NUMERIC:
        return n.getBitsLength(x);
      case t.ALPHANUMERIC:
        return i.getBitsLength(x);
      case t.KANJI:
        return o.getBitsLength(x);
      case t.BYTE:
        return r.getBitsLength(x);
    }
  }
  function v(x) {
    return x.reduce(function(_, O) {
      const D = _.length - 1 >= 0 ? _[_.length - 1] : null;
      return D && D.mode === O.mode ? (_[_.length - 1].data += O.data, _) : (_.push(O), _);
    }, []);
  }
  function y(x) {
    const _ = [];
    for (let O = 0; O < x.length; O++) {
      const D = x[O];
      switch (D.mode) {
        case t.NUMERIC:
          _.push([
            D,
            { data: D.data, mode: t.ALPHANUMERIC, length: D.length },
            { data: D.data, mode: t.BYTE, length: D.length }
          ]);
          break;
        case t.ALPHANUMERIC:
          _.push([
            D,
            { data: D.data, mode: t.BYTE, length: D.length }
          ]);
          break;
        case t.KANJI:
          _.push([
            D,
            { data: D.data, mode: t.BYTE, length: d(D.data) }
          ]);
          break;
        case t.BYTE:
          _.push([
            { data: D.data, mode: t.BYTE, length: d(D.data) }
          ]);
      }
    }
    return _;
  }
  function p(x, _) {
    const O = {}, D = { start: {} };
    let F = ["start"];
    for (let $ = 0; $ < x.length; $++) {
      const A = x[$], k = [];
      for (let S = 0; S < A.length; S++) {
        const M = A[S], E = "" + $ + S;
        k.push(E), O[E] = { node: M, lastCount: 0 }, D[E] = {};
        for (let I = 0; I < F.length; I++) {
          const L = F[I];
          O[L] && O[L].node.mode === M.mode ? (D[L][E] = h(O[L].lastCount + M.length, M.mode) - h(O[L].lastCount, M.mode), O[L].lastCount += M.length) : (O[L] && (O[L].lastCount = M.length), D[L][E] = h(M.length, M.mode) + 4 + t.getCharCountIndicator(M.mode, _));
        }
      }
      F = k;
    }
    for (let $ = 0; $ < F.length; $++)
      D[F[$]].end = 0;
    return { map: D, table: O };
  }
  function b(x, _) {
    let O;
    const D = t.getBestModeForData(x);
    if (O = t.from(_, D), O !== t.BYTE && O.bit < D.bit)
      throw new Error('"' + x + '" cannot be encoded with mode ' + t.toString(O) + `.
 Suggested mode is: ` + t.toString(D));
    switch (O === t.KANJI && !l.isKanjiModeEnabled() && (O = t.BYTE), O) {
      case t.NUMERIC:
        return new n(x);
      case t.ALPHANUMERIC:
        return new i(x);
      case t.KANJI:
        return new o(x);
      case t.BYTE:
        return new r(x);
    }
  }
  e.fromArray = function(_) {
    return _.reduce(function(O, D) {
      return typeof D == "string" ? O.push(b(D, null)) : D.data && O.push(b(D.data, D.mode)), O;
    }, []);
  }, e.fromString = function(_, O) {
    const D = m(_, l.isKanjiModeEnabled()), F = y(D), $ = p(F, O), A = u.find_path($.map, "start", "end"), k = [];
    for (let S = 1; S < A.length - 1; S++)
      k.push($.table[A[S]].node);
    return e.fromArray(v(k));
  }, e.rawSplit = function(_) {
    return e.fromArray(
      m(_, l.isKanjiModeEnabled())
    );
  };
})(cx);
const Zc = Zn, Xf = Gc, y6 = K4, b6 = Z4, w6 = tx, _6 = nx, Lh = ix, Bh = Xc, x6 = J4, _c = ax, k6 = lx, S6 = eo, Kf = cx;
function C6(e, t) {
  const n = e.size, i = _6.getPositions(t);
  for (let r = 0; r < i.length; r++) {
    const o = i[r][0], a = i[r][1];
    for (let l = -1; l <= 7; l++)
      if (!(o + l <= -1 || n <= o + l))
        for (let u = -1; u <= 7; u++)
          a + u <= -1 || n <= a + u || (l >= 0 && l <= 6 && (u === 0 || u === 6) || u >= 0 && u <= 6 && (l === 0 || l === 6) || l >= 2 && l <= 4 && u >= 2 && u <= 4 ? e.set(o + l, a + u, !0, !0) : e.set(o + l, a + u, !1, !0));
  }
}
function O6(e) {
  const t = e.size;
  for (let n = 8; n < t - 8; n++) {
    const i = n % 2 === 0;
    e.set(n, 6, i, !0), e.set(6, n, i, !0);
  }
}
function M6(e, t) {
  const n = w6.getPositions(t);
  for (let i = 0; i < n.length; i++) {
    const r = n[i][0], o = n[i][1];
    for (let a = -2; a <= 2; a++)
      for (let l = -2; l <= 2; l++)
        a === -2 || a === 2 || l === -2 || l === 2 || a === 0 && l === 0 ? e.set(r + a, o + l, !0, !0) : e.set(r + a, o + l, !1, !0);
  }
}
function T6(e, t) {
  const n = e.size, i = _c.getEncodedBits(t);
  let r, o, a;
  for (let l = 0; l < 18; l++)
    r = Math.floor(l / 3), o = l % 3 + n - 8 - 3, a = (i >> l & 1) === 1, e.set(r, o, a, !0), e.set(o, r, a, !0);
}
function Zf(e, t, n) {
  const i = e.size, r = k6.getEncodedBits(t, n);
  let o, a;
  for (o = 0; o < 15; o++)
    a = (r >> o & 1) === 1, o < 6 ? e.set(o, 8, a, !0) : o < 8 ? e.set(o + 1, 8, a, !0) : e.set(i - 15 + o, 8, a, !0), o < 8 ? e.set(8, i - o - 1, a, !0) : o < 9 ? e.set(8, 15 - o - 1 + 1, a, !0) : e.set(8, 15 - o - 1, a, !0);
  e.set(i - 8, 8, 1, !0);
}
function P6(e, t) {
  const n = e.size;
  let i = -1, r = n - 1, o = 7, a = 0;
  for (let l = n - 1; l > 0; l -= 2)
    for (l === 6 && l--; ; ) {
      for (let u = 0; u < 2; u++)
        if (!e.isReserved(r, l - u)) {
          let d = !1;
          a < t.length && (d = (t[a] >>> o & 1) === 1), e.set(r, l - u, d), o--, o === -1 && (a++, o = 7);
        }
      if (r += i, r < 0 || n <= r) {
        r -= i, i = -i;
        break;
      }
    }
}
function A6(e, t, n) {
  const i = new y6();
  n.forEach(function(u) {
    i.put(u.mode.bit, 4), i.put(u.getLength(), S6.getCharCountIndicator(u.mode, e)), u.write(i);
  });
  const r = Zc.getSymbolTotalCodewords(e), o = Bh.getTotalCodewordsCount(e, t), a = (r - o) * 8;
  for (i.getLengthInBits() + 4 <= a && i.put(0, 4); i.getLengthInBits() % 8 !== 0; )
    i.putBit(0);
  const l = (a - i.getLengthInBits()) / 8;
  for (let u = 0; u < l; u++)
    i.put(u % 2 ? 17 : 236, 8);
  return E6(i, e, t);
}
function E6(e, t, n) {
  const i = Zc.getSymbolTotalCodewords(t), r = Bh.getTotalCodewordsCount(t, n), o = i - r, a = Bh.getBlocksCount(t, n), l = i % a, u = a - l, d = Math.floor(i / a), f = Math.floor(o / a), m = f + 1, h = d - f, v = new x6(h);
  let y = 0;
  const p = new Array(a), b = new Array(a);
  let x = 0;
  const _ = new Uint8Array(e.buffer);
  for (let A = 0; A < a; A++) {
    const k = A < u ? f : m;
    p[A] = _.slice(y, y + k), b[A] = v.encode(p[A]), y += k, x = Math.max(x, k);
  }
  const O = new Uint8Array(i);
  let D = 0, F, $;
  for (F = 0; F < x; F++)
    for ($ = 0; $ < a; $++)
      F < p[$].length && (O[D++] = p[$][F]);
  for (F = 0; F < h; F++)
    for ($ = 0; $ < a; $++)
      O[D++] = b[$][F];
  return O;
}
function I6(e, t, n, i) {
  let r;
  if (Array.isArray(e))
    r = Kf.fromArray(e);
  else if (typeof e == "string") {
    let d = t;
    if (!d) {
      const f = Kf.rawSplit(e);
      d = _c.getBestVersionForData(f, n);
    }
    r = Kf.fromString(e, d || 40);
  } else
    throw new Error("Invalid data");
  const o = _c.getBestVersionForData(r, n);
  if (!o)
    throw new Error("The amount of data is too big to be stored in a QR Code");
  if (!t)
    t = o;
  else if (t < o)
    throw new Error(
      `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + o + `.
`
    );
  const a = A6(t, n, r), l = Zc.getSymbolSize(t), u = new b6(l);
  return C6(u, t), O6(u), M6(u, t), Zf(u, n, 0), t >= 7 && T6(u, t), P6(u, a), isNaN(i) && (i = Lh.getBestMask(
    u,
    Zf.bind(null, u, n)
  )), Lh.applyMask(i, u), Zf(u, n, i), {
    modules: u,
    version: t,
    errorCorrectionLevel: n,
    maskPattern: i,
    segments: r
  };
}
J_.create = function(t, n) {
  if (typeof t > "u" || t === "")
    throw new Error("No input text");
  let i = Xf.M, r, o;
  return typeof n < "u" && (i = Xf.from(n.errorCorrectionLevel, Xf.M), r = _c.from(n.version), o = Lh.from(n.maskPattern), n.toSJISFunc && Zc.setToSJISFunction(n.toSJISFunc)), I6(t, r, i, o);
};
var fx = {}, Gg = {};
(function(e) {
  function t(n) {
    if (typeof n == "number" && (n = n.toString()), typeof n != "string")
      throw new Error("Color should be defined as hex string");
    let i = n.slice().replace("#", "").split("");
    if (i.length < 3 || i.length === 5 || i.length > 8)
      throw new Error("Invalid hex color: " + n);
    (i.length === 3 || i.length === 4) && (i = Array.prototype.concat.apply([], i.map(function(o) {
      return [o, o];
    }))), i.length === 6 && i.push("F", "F");
    const r = parseInt(i.join(""), 16);
    return {
      r: r >> 24 & 255,
      g: r >> 16 & 255,
      b: r >> 8 & 255,
      a: r & 255,
      hex: "#" + i.slice(0, 6).join("")
    };
  }
  e.getOptions = function(i) {
    i || (i = {}), i.color || (i.color = {});
    const r = typeof i.margin > "u" || i.margin === null || i.margin < 0 ? 4 : i.margin, o = i.width && i.width >= 21 ? i.width : void 0, a = i.scale || 4;
    return {
      width: o,
      scale: o ? 4 : a,
      margin: r,
      color: {
        dark: t(i.color.dark || "#000000ff"),
        light: t(i.color.light || "#ffffffff")
      },
      type: i.type,
      rendererOpts: i.rendererOpts || {}
    };
  }, e.getScale = function(i, r) {
    return r.width && r.width >= i + r.margin * 2 ? r.width / (i + r.margin * 2) : r.scale;
  }, e.getImageWidth = function(i, r) {
    const o = e.getScale(i, r);
    return Math.floor((i + r.margin * 2) * o);
  }, e.qrToImageData = function(i, r, o) {
    const a = r.modules.size, l = r.modules.data, u = e.getScale(a, o), d = Math.floor((a + o.margin * 2) * u), f = o.margin * u, m = [o.color.light, o.color.dark];
    for (let h = 0; h < d; h++)
      for (let v = 0; v < d; v++) {
        let y = (h * d + v) * 4, p = o.color.light;
        if (h >= f && v >= f && h < d - f && v < d - f) {
          const b = Math.floor((h - f) / u), x = Math.floor((v - f) / u);
          p = m[l[b * a + x] ? 1 : 0];
        }
        i[y++] = p.r, i[y++] = p.g, i[y++] = p.b, i[y] = p.a;
      }
  };
})(Gg);
(function(e) {
  const t = Gg;
  function n(r, o, a) {
    r.clearRect(0, 0, o.width, o.height), o.style || (o.style = {}), o.height = a, o.width = a, o.style.height = a + "px", o.style.width = a + "px";
  }
  function i() {
    try {
      return document.createElement("canvas");
    } catch {
      throw new Error("You need to specify a canvas element");
    }
  }
  e.render = function(o, a, l) {
    let u = l, d = a;
    typeof u > "u" && (!a || !a.getContext) && (u = a, a = void 0), a || (d = i()), u = t.getOptions(u);
    const f = t.getImageWidth(o.modules.size, u), m = d.getContext("2d"), h = m.createImageData(f, f);
    return t.qrToImageData(h.data, o, u), n(m, d, f), m.putImageData(h, 0, 0), d;
  }, e.renderToDataURL = function(o, a, l) {
    let u = l;
    typeof u > "u" && (!a || !a.getContext) && (u = a, a = void 0), u || (u = {});
    const d = e.render(o, a, u), f = u.type || "image/png", m = u.rendererOpts || {};
    return d.toDataURL(f, m.quality);
  };
})(fx);
var hx = {};
const D6 = Gg;
function ob(e, t) {
  const n = e.a / 255, i = t + '="' + e.hex + '"';
  return n < 1 ? i + " " + t + '-opacity="' + n.toFixed(2).slice(1) + '"' : i;
}
function Qf(e, t, n) {
  let i = e + t;
  return typeof n < "u" && (i += " " + n), i;
}
function L6(e, t, n) {
  let i = "", r = 0, o = !1, a = 0;
  for (let l = 0; l < e.length; l++) {
    const u = Math.floor(l % t), d = Math.floor(l / t);
    !u && !o && (o = !0), e[l] ? (a++, l > 0 && u > 0 && e[l - 1] || (i += o ? Qf("M", u + n, 0.5 + d + n) : Qf("m", r, 0), r = 0, o = !1), u + 1 < t && e[l + 1] || (i += Qf("h", a), a = 0)) : r++;
  }
  return i;
}
hx.render = function(t, n, i) {
  const r = D6.getOptions(n), o = t.modules.size, a = t.modules.data, l = o + r.margin * 2, u = r.color.light.a ? "<path " + ob(r.color.light, "fill") + ' d="M0 0h' + l + "v" + l + 'H0z"/>' : "", d = "<path " + ob(r.color.dark, "stroke") + ' d="' + L6(a, o, r.margin) + '"/>', f = 'viewBox="0 0 ' + l + " " + l + '"', h = '<svg xmlns="http://www.w3.org/2000/svg" ' + (r.width ? 'width="' + r.width + '" height="' + r.width + '" ' : "") + f + ' shape-rendering="crispEdges">' + u + d + `</svg>
`;
  return typeof i == "function" && i(null, h), h;
};
const B6 = G4, Vh = J_, gx = fx, V6 = hx;
function Xg(e, t, n, i, r) {
  const o = [].slice.call(arguments, 1), a = o.length, l = typeof o[a - 1] == "function";
  if (!l && !B6())
    throw new Error("Callback required as last argument");
  if (l) {
    if (a < 2)
      throw new Error("Too few arguments provided");
    a === 2 ? (r = n, n = t, t = i = void 0) : a === 3 && (t.getContext && typeof r > "u" ? (r = i, i = void 0) : (r = i, i = n, n = t, t = void 0));
  } else {
    if (a < 1)
      throw new Error("Too few arguments provided");
    return a === 1 ? (n = t, t = i = void 0) : a === 2 && !t.getContext && (i = n, n = t, t = void 0), new Promise(function(u, d) {
      try {
        const f = Vh.create(n, i);
        u(e(f, t, i));
      } catch (f) {
        d(f);
      }
    });
  }
  try {
    const u = Vh.create(n, i);
    r(null, e(u, t, i));
  } catch (u) {
    r(u);
  }
}
gl.create = Vh.create;
gl.toCanvas = Xg.bind(null, gx.render);
gl.toDataURL = Xg.bind(null, gx.renderToDataURL);
gl.toString = Xg.bind(null, function(e, t, n) {
  return V6.render(e, n);
});
const $6 = ["innerHTML"], R6 = ["src"], F6 = {
  name: "OtQrCode",
  customOptions: {}
}, mx = /* @__PURE__ */ Ae({
  ...F6,
  props: {
    text: { type: String, required: !0 },
    options: { type: Object, default: () => {
    } },
    size: { type: Number, default: 0 },
    styles: { type: Object, default: () => {
    } }
  },
  setup(e) {
    const t = e, n = ie(), i = ie(), r = B(
      () => Fs.isEmpty(t.options) ? {
        margin: 0,
        color: {
          dark: "#fff",
          light: "#172833"
        }
      } : t.options
    ), o = B(() => t.size ? {
      width: `${t.size}px`,
      height: `${t.size}px`
    } : t.styles ? t.styles : {}), a = async () => {
      try {
        n.value = await gl.toDataURL(t.text, r.value);
      } catch {
        console.error(`Failed to generate QR code for ${t.text}`);
      }
    }, l = async () => {
      const { default: u } = await import("./qr-code-wrapper-Sdelt0b4.js");
      i.value = await fetch(u).then((d) => d.text()).catch(() => {
      });
    };
    return a(), l(), (u, d) => (ee(), ce("div", {
      class: "ot-qr-code",
      style: Do(o.value)
    }, [
      ve("div", {
        class: "ot-qr-code__wrapper",
        innerHTML: i.value
      }, null, 8, $6),
      ve("img", {
        class: "ot-qr-code__image",
        src: n.value
      }, null, 8, R6)
    ], 4));
  }
}), N6 = ["placeholder"], W6 = ["value", "autofocus", "disabled", "placeholder"], z6 = {
  name: "OtSearch",
  customOptions: {}
}, Kg = /* @__PURE__ */ Ae({
  ...z6,
  props: {
    autofocus: { type: Boolean, default: !1 },
    customPlaceholder: { type: String, default: "" },
    debounceWait: { type: Number, default: 500 },
    disabled: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    inputAttributes: { type: Object, required: !1 },
    inputEvents: { type: Object, required: !1 },
    narrow: { type: Boolean, default: !1 },
    onSearchCb: { type: Function, required: !0 },
    value: { type: String, default: "" },
    variant: { type: String, default: "dark" },
    withPlaceholder: { type: Boolean, default: !0 }
  },
  emits: ["input-click", "update:value", "scroll-top", "search-toggled"],
  setup(e, { emit: t }) {
    const n = e, i = t, { t: r } = tn(), o = ie(n.autofocus), a = ie(), l = ie(), u = ie(n.value);
    pe(
      () => n.value,
      (_) => {
        u.value = _, n.onSearchCb(_);
      },
      { immediate: !0 }
    );
    const d = B(() => n.withPlaceholder ? n.customPlaceholder || r("$vuetify.fundamentals.search") : ""), f = Fs.debounce(n.debounceWait, (_) => {
      n.onSearchCb(_), i("update:value", _);
    });
    pe(u, f);
    const m = () => {
      gt(() => {
        var _;
        return (_ = a.value) == null ? void 0 : _.focus();
      });
    }, h = () => {
      o.value = !0;
    }, v = () => {
      o.value = !1;
    }, y = (_) => {
      _.stopPropagation();
    }, p = () => {
      u.value = "", i("update:value", "");
    }, b = () => {
      i("input-click"), i("scroll-top", l.value);
    }, x = (_) => {
      if (!_.target || !("value" in _.target))
        return;
      const O = _.target.value;
      i("update:value", O), n.onSearchCb(O);
    };
    return mn(() => {
      if (!a.value)
        return;
      const { top: _ } = a.value.getBoundingClientRect();
      l.value = _;
    }), (_, O) => (ee(), ce("div", {
      class: we(["ot-search", [`ot-search--${e.variant}`, { "ot-search--in-focus": o.value, "ot-search--disabled": e.disabled }]]),
      onClick: b
    }, [
      T(Ur, {
        class: "ot-search__button ot-search__button--search",
        size: "text-like",
        variant: "clear",
        onClick: m
      }, {
        default: Ye(() => [
          T(qt, {
            class: "ot-search__icon-search",
            name: "search-normal",
            "inherit-stroke": !0
          })
        ]),
        _: 1
      }),
      e.inputAttributes || e.inputEvents ? (ee(), ce("input", ge({
        key: 0,
        class: "ot-search__input"
      }, e.inputAttributes, {
        "disable-scroll-on-focus-ios": !0,
        placeholder: d.value
      }, xa(e.inputEvents, !0)), null, 16, N6)) : (ee(), ce("input", {
        key: 1,
        ref_key: "inputRef",
        ref: a,
        value: u.value,
        testid: "search-input",
        class: "ot-search__input",
        type: "text",
        autocomplete: "off",
        autofocus: e.autofocus,
        disabled: e.disabled,
        placeholder: d.value,
        "disable-scroll-on-focus-ios": !0,
        onInput: x,
        onBlur: v,
        onFocus: h,
        onKeydown: _P(v, ["esc"]),
        onFocusin: y,
        onFocusout: y
      }, null, 40, W6)),
      T(hn, { name: "fade" }, {
        default: Ye(() => {
          var D;
          return [
            ((D = e.inputAttributes) != null && D.value || u.value) && !e.disabled ? (ee(), Ne(Ur, {
              key: 0,
              testid: "cancel-search",
              class: "ot-search__button ot-search__button--cancel",
              variant: "clear",
              size: "text-like",
              onClick: p
            }, {
              default: Ye(() => [
                T(qt, {
                  class: "ot-search__icon-cancel",
                  name: "cancel"
                })
              ]),
              _: 1
            })) : Fe("", !0)
          ];
        }),
        _: 1
      }),
      _.$slots.action ? De(_.$slots, "action", { key: 2 }) : Fe("", !0)
    ], 2));
  }
});
var H6 = Object.defineProperty, j6 = Object.defineProperties, Y6 = Object.getOwnPropertyDescriptors, ab = Object.getOwnPropertySymbols, U6 = Object.prototype.hasOwnProperty, q6 = Object.prototype.propertyIsEnumerable, sb = (e, t, n) => t in e ? H6(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, va = (e, t) => {
  for (var n in t || (t = {}))
    U6.call(t, n) && sb(e, n, t[n]);
  if (ab)
    for (var n of ab(t))
      q6.call(t, n) && sb(e, n, t[n]);
  return e;
}, lb = (e, t) => j6(e, Y6(t));
const G6 = {
  props: {
    autoscroll: {
      type: Boolean,
      default: !0
    }
  },
  watch: {
    typeAheadPointer() {
      this.autoscroll && this.maybeAdjustScroll();
    },
    open(e) {
      this.autoscroll && e && this.$nextTick(() => this.maybeAdjustScroll());
    }
  },
  methods: {
    maybeAdjustScroll() {
      var e;
      const t = ((e = this.$refs.dropdownMenu) == null ? void 0 : e.children[this.typeAheadPointer]) || !1;
      if (t) {
        const n = this.getDropdownViewport(), { top: i, bottom: r, height: o } = t.getBoundingClientRect();
        if (i < n.top)
          return this.$refs.dropdownMenu.scrollTop = t.offsetTop;
        if (r > n.bottom)
          return this.$refs.dropdownMenu.scrollTop = t.offsetTop - (n.height - o);
      }
    },
    getDropdownViewport() {
      return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : {
        height: 0,
        top: 0,
        bottom: 0
      };
    }
  }
}, X6 = {
  data() {
    return {
      typeAheadPointer: -1
    };
  },
  watch: {
    filteredOptions() {
      for (let e = 0; e < this.filteredOptions.length; e++)
        if (this.selectable(this.filteredOptions[e])) {
          this.typeAheadPointer = e;
          break;
        }
    },
    open(e) {
      e && this.typeAheadToLastSelected();
    },
    selectedValue() {
      this.open && this.typeAheadToLastSelected();
    }
  },
  methods: {
    typeAheadUp() {
      for (let e = this.typeAheadPointer - 1; e >= 0; e--)
        if (this.selectable(this.filteredOptions[e])) {
          this.typeAheadPointer = e;
          break;
        }
    },
    typeAheadDown() {
      for (let e = this.typeAheadPointer + 1; e < this.filteredOptions.length; e++)
        if (this.selectable(this.filteredOptions[e])) {
          this.typeAheadPointer = e;
          break;
        }
    },
    typeAheadSelect() {
      const e = this.filteredOptions[this.typeAheadPointer];
      e && this.selectable(e) && this.select(e);
    },
    typeAheadToLastSelected() {
      this.typeAheadPointer = this.selectedValue.length !== 0 ? this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length - 1]) : -1;
    }
  }
}, K6 = {
  props: {
    loading: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      mutableLoading: !1
    };
  },
  watch: {
    search() {
      this.$emit("search", this.search, this.toggleLoading);
    },
    loading(e) {
      this.mutableLoading = e;
    }
  },
  methods: {
    toggleLoading(e = null) {
      return e == null ? this.mutableLoading = !this.mutableLoading : this.mutableLoading = e;
    }
  }
}, Zg = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [i, r] of t)
    n[i] = r;
  return n;
}, Z6 = {}, Q6 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10"
}, J6 = /* @__PURE__ */ ve("path", { d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z" }, null, -1), e8 = [
  J6
];
function t8(e, t) {
  return ee(), ce("svg", Q6, e8);
}
const n8 = /* @__PURE__ */ Zg(Z6, [["render", t8]]), i8 = {}, r8 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10"
}, o8 = /* @__PURE__ */ ve("path", { d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z" }, null, -1), a8 = [
  o8
];
function s8(e, t) {
  return ee(), ce("svg", r8, a8);
}
const l8 = /* @__PURE__ */ Zg(i8, [["render", s8]]), ub = {
  Deselect: n8,
  OpenIndicator: l8
}, u8 = {
  mounted(e, { instance: t }) {
    if (t.appendToBody) {
      const {
        height: n,
        top: i,
        left: r,
        width: o
      } = t.$refs.toggle.getBoundingClientRect();
      let a = window.scrollX || window.pageXOffset, l = window.scrollY || window.pageYOffset;
      e.unbindPosition = t.calculatePosition(e, t, {
        width: o + "px",
        left: a + r + "px",
        top: l + i + n + "px"
      }), document.body.appendChild(e);
    }
  },
  unmounted(e, { instance: t }) {
    t.appendToBody && (e.unbindPosition && typeof e.unbindPosition == "function" && e.unbindPosition(), e.parentNode && e.parentNode.removeChild(e));
  }
};
function c8(e) {
  const t = {};
  return Object.keys(e).sort().forEach((n) => {
    t[n] = e[n];
  }), JSON.stringify(t);
}
let d8 = 0;
function f8() {
  return ++d8;
}
const h8 = {
  components: va({}, ub),
  directives: { appendToBody: u8 },
  mixins: [G6, X6, K6],
  compatConfig: {
    MODE: 3
  },
  emits: [
    "open",
    "close",
    "update:modelValue",
    "search",
    "search:compositionstart",
    "search:compositionend",
    "search:keydown",
    "search:blur",
    "search:focus",
    "search:input",
    "option:created",
    "option:selecting",
    "option:selected",
    "option:deselecting",
    "option:deselected"
  ],
  props: {
    modelValue: {},
    components: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    clearable: {
      type: Boolean,
      default: !0
    },
    deselectFromDropdown: {
      type: Boolean,
      default: !1
    },
    searchable: {
      type: Boolean,
      default: !0
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    transition: {
      type: String,
      default: "vs__fade"
    },
    clearSearchOnSelect: {
      type: Boolean,
      default: !0
    },
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    label: {
      type: String,
      default: "label"
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    reduce: {
      type: Function,
      default: (e) => e
    },
    selectable: {
      type: Function,
      default: (e) => !0
    },
    getOptionLabel: {
      type: Function,
      default(e) {
        return typeof e == "object" ? e.hasOwnProperty(this.label) ? e[this.label] : console.warn(`[vue-select warn]: Label key "option.${this.label}" does not exist in options object ${JSON.stringify(e)}.
https://vue-select.org/api/props.html#getoptionlabel`) : e;
      }
    },
    getOptionKey: {
      type: Function,
      default(e) {
        if (typeof e != "object")
          return e;
        try {
          return e.hasOwnProperty("id") ? e.id : c8(e);
        } catch (t) {
          return console.warn(`[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.
https://vue-select.org/api/props.html#getoptionkey`, e, t);
        }
      }
    },
    onTab: {
      type: Function,
      default: function() {
        this.selectOnTab && !this.isComposing && this.typeAheadSelect();
      }
    },
    taggable: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: null
    },
    pushTags: {
      type: Boolean,
      default: !1
    },
    filterable: {
      type: Boolean,
      default: !0
    },
    filterBy: {
      type: Function,
      default(e, t, n) {
        return (t || "").toLocaleLowerCase().indexOf(n.toLocaleLowerCase()) > -1;
      }
    },
    filter: {
      type: Function,
      default(e, t) {
        return e.filter((n) => {
          let i = this.getOptionLabel(n);
          return typeof i == "number" && (i = i.toString()), this.filterBy(n, i, t);
        });
      }
    },
    createOption: {
      type: Function,
      default(e) {
        return typeof this.optionList[0] == "object" ? { [this.label]: e } : e;
      }
    },
    resetOnOptionsChange: {
      default: !1,
      validator: (e) => ["function", "boolean"].includes(typeof e)
    },
    clearSearchOnBlur: {
      type: Function,
      default: function({ clearSearchOnSelect: e, multiple: t }) {
        return e && !t;
      }
    },
    noDrop: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String
    },
    dir: {
      type: String,
      default: "auto"
    },
    selectOnTab: {
      type: Boolean,
      default: !1
    },
    selectOnKeyCodes: {
      type: Array,
      default: () => [13]
    },
    searchInputQuerySelector: {
      type: String,
      default: "[type=search]"
    },
    mapKeydown: {
      type: Function,
      default: (e, t) => e
    },
    appendToBody: {
      type: Boolean,
      default: !1
    },
    calculatePosition: {
      type: Function,
      default(e, t, { width: n, top: i, left: r }) {
        e.style.top = i, e.style.left = r, e.style.width = n;
      }
    },
    dropdownShouldOpen: {
      type: Function,
      default({ noDrop: e, open: t, mutableLoading: n }) {
        return e ? !1 : t && !n;
      }
    },
    uid: {
      type: [String, Number],
      default: () => f8()
    }
  },
  data() {
    return {
      search: "",
      open: !1,
      isComposing: !1,
      pushedTags: [],
      _value: [],
      deselectButtons: []
    };
  },
  computed: {
    isReducingValues() {
      return this.$props.reduce !== this.$options.props.reduce.default;
    },
    isTrackingValues() {
      return typeof this.modelValue > "u" || this.isReducingValues;
    },
    selectedValue() {
      let e = this.modelValue;
      return this.isTrackingValues && (e = this.$data._value), e != null && e !== "" ? [].concat(e) : [];
    },
    optionList() {
      return this.options.concat(this.pushTags ? this.pushedTags : []);
    },
    searchEl() {
      return this.$slots.search ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
    },
    scope() {
      const e = {
        search: this.search,
        loading: this.loading,
        searching: this.searching,
        filteredOptions: this.filteredOptions
      };
      return {
        search: {
          attributes: va({
            disabled: this.disabled,
            placeholder: this.searchPlaceholder,
            tabindex: this.tabindex,
            readonly: !this.searchable,
            id: this.inputId,
            "aria-autocomplete": "list",
            "aria-labelledby": `vs${this.uid}__combobox`,
            "aria-controls": `vs${this.uid}__listbox`,
            ref: "search",
            type: "search",
            autocomplete: this.autocomplete,
            value: this.search
          }, this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? {
            "aria-activedescendant": `vs${this.uid}__option-${this.typeAheadPointer}`
          } : {}),
          events: {
            compositionstart: () => this.isComposing = !0,
            compositionend: () => this.isComposing = !1,
            keydown: this.onSearchKeyDown,
            blur: this.onSearchBlur,
            focus: this.onSearchFocus,
            input: (t) => this.search = t.target.value
          }
        },
        spinner: {
          loading: this.mutableLoading
        },
        noOptions: {
          search: this.search,
          loading: this.mutableLoading,
          searching: this.searching
        },
        openIndicator: {
          attributes: {
            ref: "openIndicator",
            role: "presentation",
            class: "vs__open-indicator"
          }
        },
        listHeader: e,
        listFooter: e,
        header: lb(va({}, e), { deselect: this.deselect }),
        footer: lb(va({}, e), { deselect: this.deselect })
      };
    },
    childComponents() {
      return va(va({}, ub), this.components);
    },
    stateClasses() {
      return {
        "vs--open": this.dropdownOpen,
        "vs--single": !this.multiple,
        "vs--multiple": this.multiple,
        "vs--searching": this.searching && !this.noDrop,
        "vs--searchable": this.searchable && !this.noDrop,
        "vs--unsearchable": !this.searchable,
        "vs--loading": this.mutableLoading,
        "vs--disabled": this.disabled
      };
    },
    searching() {
      return !!this.search;
    },
    dropdownOpen() {
      return this.dropdownShouldOpen(this);
    },
    searchPlaceholder() {
      return this.isValueEmpty && this.placeholder ? this.placeholder : void 0;
    },
    filteredOptions() {
      const e = [].concat(this.optionList);
      if (!this.filterable && !this.taggable)
        return e;
      const t = this.search.length ? this.filter(e, this.search, this) : e;
      if (this.taggable && this.search.length) {
        const n = this.createOption(this.search);
        this.optionExists(n) || t.unshift(n);
      }
      return t;
    },
    isValueEmpty() {
      return this.selectedValue.length === 0;
    },
    showClearButton() {
      return !this.multiple && this.clearable && !this.open && !this.isValueEmpty;
    }
  },
  watch: {
    options(e, t) {
      const n = () => typeof this.resetOnOptionsChange == "function" ? this.resetOnOptionsChange(e, t, this.selectedValue) : this.resetOnOptionsChange;
      !this.taggable && n() && this.clearSelection(), this.modelValue && this.isTrackingValues && this.setInternalValueFromOptions(this.modelValue);
    },
    modelValue: {
      immediate: !0,
      handler(e) {
        this.isTrackingValues && this.setInternalValueFromOptions(e);
      }
    },
    multiple() {
      this.clearSelection();
    },
    open(e) {
      this.$emit(e ? "open" : "close");
    }
  },
  created() {
    this.mutableLoading = this.loading;
  },
  methods: {
    setInternalValueFromOptions(e) {
      Array.isArray(e) ? this.$data._value = e.map((t) => this.findOptionFromReducedValue(t)) : this.$data._value = this.findOptionFromReducedValue(e);
    },
    select(e) {
      this.$emit("option:selecting", e), this.isOptionSelected(e) ? this.deselectFromDropdown && (this.clearable || this.multiple && this.selectedValue.length > 1) && this.deselect(e) : (this.taggable && !this.optionExists(e) && (this.$emit("option:created", e), this.pushTag(e)), this.multiple && (e = this.selectedValue.concat(e)), this.updateValue(e), this.$emit("option:selected", e)), this.onAfterSelect(e);
    },
    deselect(e) {
      this.$emit("option:deselecting", e), this.updateValue(this.selectedValue.filter((t) => !this.optionComparator(t, e))), this.$emit("option:deselected", e);
    },
    clearSelection() {
      this.updateValue(this.multiple ? [] : null);
    },
    onAfterSelect(e) {
      this.closeOnSelect && (this.open = !this.open, this.searchEl.blur()), this.clearSearchOnSelect && (this.search = "");
    },
    updateValue(e) {
      typeof this.modelValue > "u" && (this.$data._value = e), e !== null && (Array.isArray(e) ? e = e.map((t) => this.reduce(t)) : e = this.reduce(e)), this.$emit("update:modelValue", e);
    },
    toggleDropdown(e) {
      const t = e.target !== this.searchEl;
      t && e.preventDefault();
      const n = [
        ...this.deselectButtons || [],
        this.$refs.clearButton
      ];
      if (this.searchEl === void 0 || n.filter(Boolean).some((i) => i.contains(e.target) || i === e.target)) {
        e.preventDefault();
        return;
      }
      this.open && t ? this.searchEl.blur() : this.disabled || (this.open = !0, this.searchEl.focus());
    },
    isOptionSelected(e) {
      return this.selectedValue.some((t) => this.optionComparator(t, e));
    },
    isOptionDeselectable(e) {
      return this.isOptionSelected(e) && this.deselectFromDropdown;
    },
    optionComparator(e, t) {
      return this.getOptionKey(e) === this.getOptionKey(t);
    },
    findOptionFromReducedValue(e) {
      const t = (i) => JSON.stringify(this.reduce(i)) === JSON.stringify(e), n = [...this.options, ...this.pushedTags].filter(t);
      return n.length === 1 ? n[0] : n.find((i) => this.optionComparator(i, this.$data._value)) || e;
    },
    closeSearchOptions() {
      this.open = !1, this.$emit("search:blur");
    },
    maybeDeleteValue() {
      if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
        let e = null;
        this.multiple && (e = [
          ...this.selectedValue.slice(0, this.selectedValue.length - 1)
        ]), this.updateValue(e);
      }
    },
    optionExists(e) {
      return this.optionList.some((t) => this.optionComparator(t, e));
    },
    normalizeOptionForSlot(e) {
      return typeof e == "object" ? e : { [this.label]: e };
    },
    pushTag(e) {
      this.pushedTags.push(e);
    },
    onEscape() {
      this.search.length ? this.search = "" : this.searchEl.blur();
    },
    onSearchBlur() {
      if (this.mousedown && !this.searching)
        this.mousedown = !1;
      else {
        const { clearSearchOnSelect: e, multiple: t } = this;
        this.clearSearchOnBlur({ clearSearchOnSelect: e, multiple: t }) && (this.search = ""), this.closeSearchOptions();
        return;
      }
      if (this.search.length === 0 && this.options.length === 0) {
        this.closeSearchOptions();
        return;
      }
    },
    onSearchFocus() {
      this.open = !0, this.$emit("search:focus");
    },
    onMousedown() {
      this.mousedown = !0;
    },
    onMouseUp() {
      this.mousedown = !1;
    },
    onSearchKeyDown(e) {
      const t = (r) => (r.preventDefault(), !this.isComposing && this.typeAheadSelect()), n = {
        8: (r) => this.maybeDeleteValue(),
        9: (r) => this.onTab(),
        27: (r) => this.onEscape(),
        38: (r) => (r.preventDefault(), this.typeAheadUp()),
        40: (r) => (r.preventDefault(), this.typeAheadDown())
      };
      this.selectOnKeyCodes.forEach((r) => n[r] = t);
      const i = this.mapKeydown(n, this);
      if (typeof i[e.keyCode] == "function")
        return i[e.keyCode](e);
    }
  }
}, g8 = ["dir"], m8 = ["id", "aria-expanded", "aria-owns"], v8 = {
  ref: "selectedOptions",
  class: "vs__selected-options"
}, p8 = ["disabled", "title", "aria-label", "onClick"], y8 = {
  ref: "actions",
  class: "vs__actions"
}, b8 = ["disabled"], w8 = { class: "vs__spinner" }, _8 = ["id"], x8 = ["id", "aria-selected", "onMouseover", "onClick"], k8 = {
  key: 0,
  class: "vs__no-options"
}, S8 = /* @__PURE__ */ dr(" Sorry, no matching options. "), C8 = ["id"];
function O8(e, t, n, i, r, o) {
  const a = Ci("append-to-body");
  return ee(), ce("div", {
    dir: n.dir,
    class: we(["v-select", o.stateClasses])
  }, [
    De(e.$slots, "header", zt(Qt(o.scope.header))),
    ve("div", {
      id: `vs${n.uid}__combobox`,
      ref: "toggle",
      class: "vs__dropdown-toggle",
      role: "combobox",
      "aria-expanded": o.dropdownOpen.toString(),
      "aria-owns": `vs${n.uid}__listbox`,
      "aria-label": "Search for option",
      onMousedown: t[1] || (t[1] = (l) => o.toggleDropdown(l))
    }, [
      ve("div", v8, [
        (ee(!0), ce(qe, null, Dn(o.selectedValue, (l, u) => De(e.$slots, "selected-option-container", {
          option: o.normalizeOptionForSlot(l),
          deselect: o.deselect,
          multiple: n.multiple,
          disabled: n.disabled
        }, () => [
          (ee(), ce("span", {
            key: n.getOptionKey(l),
            class: "vs__selected"
          }, [
            De(e.$slots, "selected-option", zt(Qt(o.normalizeOptionForSlot(l))), () => [
              dr(Ue(n.getOptionLabel(l)), 1)
            ]),
            n.multiple ? (ee(), ce("button", {
              key: 0,
              ref_for: !0,
              ref: (d) => r.deselectButtons[u] = d,
              disabled: n.disabled,
              type: "button",
              class: "vs__deselect",
              title: `Deselect ${n.getOptionLabel(l)}`,
              "aria-label": `Deselect ${n.getOptionLabel(l)}`,
              onClick: (d) => o.deselect(l)
            }, [
              (ee(), Ne(sr(o.childComponents.Deselect)))
            ], 8, p8)) : Fe("", !0)
          ]))
        ])), 256)),
        De(e.$slots, "search", zt(Qt(o.scope.search)), () => [
          ve("input", ge({ class: "vs__search" }, o.scope.search.attributes, xa(o.scope.search.events)), null, 16)
        ])
      ], 512),
      ve("div", y8, [
        Nt(ve("button", {
          ref: "clearButton",
          disabled: n.disabled,
          type: "button",
          class: "vs__clear",
          title: "Clear Selected",
          "aria-label": "Clear Selected",
          onClick: t[0] || (t[0] = (...l) => o.clearSelection && o.clearSelection(...l))
        }, [
          (ee(), Ne(sr(o.childComponents.Deselect)))
        ], 8, b8), [
          [Ri, o.showClearButton]
        ]),
        De(e.$slots, "open-indicator", zt(Qt(o.scope.openIndicator)), () => [
          n.noDrop ? Fe("", !0) : (ee(), Ne(sr(o.childComponents.OpenIndicator), zt(ge({ key: 0 }, o.scope.openIndicator.attributes)), null, 16))
        ]),
        De(e.$slots, "spinner", zt(Qt(o.scope.spinner)), () => [
          Nt(ve("div", w8, "Loading...", 512), [
            [Ri, e.mutableLoading]
          ])
        ])
      ], 512)
    ], 40, m8),
    T(hn, { name: n.transition }, {
      default: Ye(() => [
        o.dropdownOpen ? Nt((ee(), ce("ul", {
          id: `vs${n.uid}__listbox`,
          ref: "dropdownMenu",
          key: `vs${n.uid}__listbox`,
          class: "vs__dropdown-menu",
          role: "listbox",
          tabindex: "-1",
          onMousedown: t[2] || (t[2] = Wr((...l) => o.onMousedown && o.onMousedown(...l), ["prevent"])),
          onMouseup: t[3] || (t[3] = (...l) => o.onMouseUp && o.onMouseUp(...l))
        }, [
          De(e.$slots, "list-header", zt(Qt(o.scope.listHeader))),
          (ee(!0), ce(qe, null, Dn(o.filteredOptions, (l, u) => (ee(), ce("li", {
            id: `vs${n.uid}__option-${u}`,
            key: n.getOptionKey(l),
            role: "option",
            class: we(["vs__dropdown-option", {
              "vs__dropdown-option--deselect": o.isOptionDeselectable(l) && u === e.typeAheadPointer,
              "vs__dropdown-option--selected": o.isOptionSelected(l),
              "vs__dropdown-option--highlight": u === e.typeAheadPointer,
              "vs__dropdown-option--disabled": !n.selectable(l)
            }]),
            "aria-selected": u === e.typeAheadPointer ? !0 : null,
            onMouseover: (d) => n.selectable(l) ? e.typeAheadPointer = u : null,
            onClick: Wr((d) => n.selectable(l) ? o.select(l) : null, ["prevent", "stop"])
          }, [
            De(e.$slots, "option", zt(Qt(o.normalizeOptionForSlot(l))), () => [
              dr(Ue(n.getOptionLabel(l)), 1)
            ])
          ], 42, x8))), 128)),
          o.filteredOptions.length === 0 ? (ee(), ce("li", k8, [
            De(e.$slots, "no-options", zt(Qt(o.scope.noOptions)), () => [
              S8
            ])
          ])) : Fe("", !0),
          De(e.$slots, "list-footer", zt(Qt(o.scope.listFooter)))
        ], 40, _8)), [
          [a]
        ]) : (ee(), ce("ul", {
          key: 1,
          id: `vs${n.uid}__listbox`,
          role: "listbox",
          style: { display: "none", visibility: "hidden" }
        }, null, 8, C8))
      ]),
      _: 3
    }, 8, ["name"]),
    De(e.$slots, "footer", zt(Qt(o.scope.footer)))
  ], 10, g8);
}
const M8 = /* @__PURE__ */ Zg(h8, [["render", O8]]), T8 = { class: "vs__search-container" }, P8 = {
  name: "OtSelect",
  customOptions: {}
}, A8 = {
  darkBorderless: "dark-borderless",
  darkOutlined: "dark-outlined",
  lightOutlined: "light-outlined"
}, Qg = /* @__PURE__ */ Ae({
  ...P8,
  props: {
    alignDropdownRight: { type: Boolean, default: !1 },
    dropdownMaxHeight: { type: String, default: "350px" },
    enableSorting: { type: Boolean, default: !1 },
    filter: { type: Function, required: !1 },
    hideActions: { type: Boolean, default: !1 },
    inputId: { type: String, default: `ot-select-input-${crypto.randomUUID()}` },
    label: { type: String, required: !0 },
    menuTopSpace: { type: Boolean, default: !0 },
    multiple: { type: Boolean, default: !1 },
    name: { type: String, default: () => `ot-select-${crypto.randomUUID()}` },
    narrow: { type: Boolean, default: !1 },
    onSearchCb: { type: Function, required: !1 },
    openIndicatorIconName: { type: String, default: "arrow-down" },
    options: { type: Array, required: !0 },
    searchable: { type: Boolean, default: !1 },
    short: { type: Boolean, default: !1 },
    // eslint-disable-next-line max-len
    sortingCb: {
      type: Function,
      default: (e, t, n) => {
        var i;
        return ((i = e[n]) == null ? void 0 : i.localeCompare(t[n] || "")) ?? 0;
      }
    },
    value: { type: [Object, Array], required: !1 },
    variant: { type: String, default: "dark-outlined" }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const i = e, r = n, { t: o } = tn(), a = xP(), l = ie(), u = () => Un("span", ""), d = (L = "arrow-down") => () => Un(qt, {
      name: L,
      inheritStroke: !0,
      style: {
        width: "16px"
      }
    }), f = B(() => d(i.openIndicatorIconName)), m = B(() => i.variant === A8.lightOutlined ? "light" : "dark"), h = (L) => {
      const N = typeof L[i.label] == "string" ? L[i.label] : L[i.label].value;
      return {
        ...L,
        [i.label]: N
      };
    }, v = () => i.value ? Array.isArray(i.value) ? i.value.map(h) : h(i.value) : i.value, y = mi({ selected: v() });
    pe(
      () => i.value,
      () => {
        y.selected = v();
      }
    );
    const p = () => {
      const L = i.options.map(h);
      return i.enableSorting && L.sort((N, V) => i.sortingCb(N, V, i.label)), L;
    }, b = ie(p());
    pe(
      () => i.options,
      () => {
        b.value = p();
      },
      { deep: !0 }
    );
    const x = B(() => o("$vuetify.fundamentals.noMatchingOptions")), _ = B(() => ({ [i.label]: o("$vuetify.fundamentals.multiSelect.all") })), O = B(() => {
      var L;
      return ((L = y.selected) == null ? void 0 : L.length) === b.value.length;
    }), D = B(() => {
      var L;
      return O.value ? o("$vuetify.fundamentals.multiSelect.all") : o("$vuetify.fundamentals.multiSelect.selectedNumber", (L = y.selected) == null ? void 0 : L.length);
    }), F = B(() => [_.value, ...b.value]), $ = (L) => y.selected ? Array.isArray(y.selected) ? y.selected.some((N) => N[i.label] === L) : y.selected[i.label] === L : !1, A = (L) => {
      i.multiple && Array.isArray(L) && L.some((N) => N[i.label] === _.value[i.label]) ? y.selected = O.value ? [] : [...b.value] : y.selected = L, r("update:value", y.selected);
    }, k = B(() => a ? JSON.stringify({
      qaId: i.inputId,
      value: a.value,
      options: a.options
    }) : null), S = (L, N) => ({
      ...L,
      8: (V) => {
        N.search.length === 0 && V.preventDefault();
      }
    }), M = "ot-select", E = B(() => [
      M,
      `${M}--${i.variant}`,
      `${M}--search-theme-${m.value}`,
      { [`${M}--searchable`]: i.searchable },
      { [`${M}--menu-top-space`]: i.menuTopSpace },
      { [`${M}--align-dropdown-right`]: i.alignDropdownRight },
      { [`${M}--hide-actions`]: i.hideActions },
      { [`${M}--narrow`]: i.narrow },
      { [`${M}--short`]: i.short }
    ]), I = (L) => {
      i.onSearchCb && i.onSearchCb(L);
    };
    return t({
      otSelect: l
    }), (L, N) => (ee(), Ne(Be(M8), ge({
      ref_key: "otSelect",
      ref: l
    }, L.$attrs, {
      class: E.value,
      "close-on-select": !e.multiple,
      components: { Deselect: u, OpenIndicator: f.value },
      "deselect-from-dropdown": e.multiple,
      filter: e.filter,
      "input-id": e.inputId,
      label: e.label,
      "map-keydown": S,
      "model-value": y.selected,
      multiple: e.multiple,
      options: e.multiple ? F.value : b.value,
      "qa-help": k.value,
      searchable: e.searchable,
      style: { "--vs-dropdown-max-height": e.dropdownMaxHeight },
      testid: e.name,
      "onUpdate:modelValue": A
    }), Cc({
      "no-options": Ye(() => [
        ve("span", null, Ue(x.value), 1)
      ]),
      option: Ye((V) => [
        T(qc, {
          title: V[e.label],
          variant: e.variant === "light-outlined" ? "light" : "default",
          active: $(V[e.label])
        }, null, 8, ["title", "variant", "active"])
      ]),
      _: 2
    }, [
      e.multiple ? {
        name: "selected-option-container",
        fn: Ye(() => [
          ve("div", {
            class: we(`${M}__multiple-result`)
          }, Ue(D.value), 3)
        ]),
        key: "0"
      } : void 0,
      e.searchable ? {
        name: "search",
        fn: Ye(({ attributes: V, events: z }) => [
          ve("div", T8, [
            T(Kg, {
              class: "vs__search",
              "input-attributes": V,
              "input-events": z,
              variant: m.value,
              "on-search-cb": I
            }, null, 8, ["input-attributes", "input-events", "variant"])
          ])
        ]),
        key: "1"
      } : void 0,
      Dn(L.$slots, (V, z) => ({
        name: z,
        fn: Ye((H) => [
          De(L.$slots, z, zt(Qt(H)))
        ])
      }))
    ]), 1040, ["class", "close-on-select", "components", "deselect-from-dropdown", "filter", "input-id", "label", "model-value", "multiple", "options", "qa-help", "searchable", "style", "testid"]));
  }
});
function E8(e) {
  let {
    selectedElement: t,
    containerElement: n,
    isRtl: i,
    isHorizontal: r
  } = e;
  const o = Xs(r, n), a = vx(r, i, n), l = Xs(r, t), u = px(r, t), d = l * 0.4;
  return a > u ? u - d : a + o < u + l ? u - o + l + d : a;
}
function I8(e) {
  let {
    selectedElement: t,
    containerElement: n,
    isHorizontal: i
  } = e;
  const r = Xs(i, n), o = px(i, t), a = Xs(i, t);
  return o - r / 2 + a / 2;
}
function cb(e, t) {
  const n = e ? "scrollWidth" : "scrollHeight";
  return (t == null ? void 0 : t[n]) || 0;
}
function D8(e, t) {
  const n = e ? "clientWidth" : "clientHeight";
  return (t == null ? void 0 : t[n]) || 0;
}
function vx(e, t, n) {
  if (!n)
    return 0;
  const {
    scrollLeft: i,
    offsetWidth: r,
    scrollWidth: o
  } = n;
  return e ? t ? o - r + i : i : n.scrollTop;
}
function Xs(e, t) {
  const n = e ? "offsetWidth" : "offsetHeight";
  return (t == null ? void 0 : t[n]) || 0;
}
function px(e, t) {
  const n = e ? "offsetLeft" : "offsetTop";
  return (t == null ? void 0 : t[n]) || 0;
}
const L8 = Symbol.for("vuetify:v-slide-group"), yx = le({
  centerActive: Boolean,
  direction: {
    type: String,
    default: "horizontal"
  },
  symbol: {
    type: null,
    default: L8
  },
  nextIcon: {
    type: ot,
    default: "$next"
  },
  prevIcon: {
    type: ot,
    default: "$prev"
  },
  showArrows: {
    type: [Boolean, String],
    validator: (e) => typeof e == "boolean" || ["always", "desktop", "mobile"].includes(e)
  },
  ...Xe(),
  ...lE({
    mobile: null
  }),
  ...Bt(),
  ...rl({
    selectedClass: "v-slide-group-item--active"
  })
}, "VSlideGroup"), db = ye()({
  name: "VSlideGroup",
  props: yx(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      isRtl: i
    } = Xr(), {
      displayClasses: r,
      mobile: o
    } = Jh(e), a = Fa(e, e.symbol), l = Pe(!1), u = Pe(0), d = Pe(0), f = Pe(0), m = B(() => e.direction === "horizontal"), {
      resizeRef: h,
      contentRect: v
    } = Bs(), {
      resizeRef: y,
      contentRect: p
    } = Bs(), b = dE(), x = B(() => ({
      container: h.el,
      duration: 200,
      easing: "easeOutQuart"
    })), _ = B(() => a.selected.value.length ? a.items.value.findIndex((U) => U.id === a.selected.value[0]) : -1), O = B(() => a.selected.value.length ? a.items.value.findIndex((U) => U.id === a.selected.value[a.selected.value.length - 1]) : -1);
    if (ft) {
      let U = -1;
      pe(() => [a.selected.value, v.value, p.value, m.value], () => {
        cancelAnimationFrame(U), U = requestAnimationFrame(() => {
          if (v.value && p.value) {
            const K = m.value ? "width" : "height";
            d.value = v.value[K], f.value = p.value[K], l.value = d.value + 1 < f.value;
          }
          if (_.value >= 0 && y.el) {
            const K = y.el.children[O.value];
            F(K, e.centerActive);
          }
        });
      });
    }
    const D = Pe(!1);
    function F(U, K) {
      let te = 0;
      K ? te = I8({
        containerElement: h.el,
        isHorizontal: m.value,
        selectedElement: U
      }) : te = E8({
        containerElement: h.el,
        isHorizontal: m.value,
        isRtl: i.value,
        selectedElement: U
      }), $(te);
    }
    function $(U) {
      if (!ft || !h.el)
        return;
      const K = Xs(m.value, h.el), te = vx(m.value, i.value, h.el);
      if (!(cb(m.value, h.el) <= K || // Prevent scrolling by only a couple of pixels, which doesn't look smooth
      Math.abs(U - te) < 16)) {
        if (m.value && i.value && h.el) {
          const {
            scrollWidth: de,
            offsetWidth: Q
          } = h.el;
          U = de - Q - U;
        }
        m.value ? b.horizontal(U, x.value) : b(U, x.value);
      }
    }
    function A(U) {
      const {
        scrollTop: K,
        scrollLeft: te
      } = U.target;
      u.value = m.value ? te : K;
    }
    function k(U) {
      if (D.value = !0, !(!l.value || !y.el)) {
        for (const K of U.composedPath())
          for (const te of y.el.children)
            if (te === K) {
              F(te);
              return;
            }
      }
    }
    function S(U) {
      D.value = !1;
    }
    let M = !1;
    function E(U) {
      var K;
      !M && !D.value && !(U.relatedTarget && ((K = y.el) != null && K.contains(U.relatedTarget))) && N(), M = !1;
    }
    function I() {
      M = !0;
    }
    function L(U) {
      if (!y.el)
        return;
      function K(te) {
        U.preventDefault(), N(te);
      }
      m.value ? U.key === "ArrowRight" ? K(i.value ? "prev" : "next") : U.key === "ArrowLeft" && K(i.value ? "next" : "prev") : U.key === "ArrowDown" ? K("next") : U.key === "ArrowUp" && K("prev"), U.key === "Home" ? K("first") : U.key === "End" && K("last");
    }
    function N(U) {
      var te, ue;
      if (!y.el)
        return;
      let K;
      if (!U)
        K = Es(y.el)[0];
      else if (U === "next") {
        if (K = (te = y.el.querySelector(":focus")) == null ? void 0 : te.nextElementSibling, !K)
          return N("first");
      } else if (U === "prev") {
        if (K = (ue = y.el.querySelector(":focus")) == null ? void 0 : ue.previousElementSibling, !K)
          return N("last");
      } else
        U === "first" ? K = y.el.firstElementChild : U === "last" && (K = y.el.lastElementChild);
      K && K.focus({
        preventScroll: !0
      });
    }
    function V(U) {
      const K = m.value && i.value ? -1 : 1, te = (U === "prev" ? -K : K) * d.value;
      let ue = u.value + te;
      if (m.value && i.value && h.el) {
        const {
          scrollWidth: de,
          offsetWidth: Q
        } = h.el;
        ue += de - Q;
      }
      $(ue);
    }
    const z = B(() => ({
      next: a.next,
      prev: a.prev,
      select: a.select,
      isSelected: a.isSelected
    })), H = B(() => {
      switch (e.showArrows) {
        case "always":
          return !0;
        case "desktop":
          return !o.value;
        case !0:
          return l.value || Math.abs(u.value) > 0;
        case "mobile":
          return o.value || l.value || Math.abs(u.value) > 0;
        default:
          return !o.value && (l.value || Math.abs(u.value) > 0);
      }
    }), W = B(() => Math.abs(u.value) > 1), j = B(() => {
      if (!h.value)
        return !1;
      const U = cb(m.value, h.el), K = D8(m.value, h.el);
      return U - K - Math.abs(u.value) > 1;
    });
    return Oe(() => T(e.tag, {
      class: ["v-slide-group", {
        "v-slide-group--vertical": !m.value,
        "v-slide-group--has-affixes": H.value,
        "v-slide-group--is-overflowing": l.value
      }, r.value, e.class],
      style: e.style,
      tabindex: D.value || a.selected.value.length ? -1 : 0,
      onFocus: E
    }, {
      default: () => {
        var U, K, te;
        return [H.value && T("div", {
          key: "prev",
          class: ["v-slide-group__prev", {
            "v-slide-group__prev--disabled": !W.value
          }],
          onMousedown: I,
          onClick: () => W.value && V("prev")
        }, [((U = n.prev) == null ? void 0 : U.call(n, z.value)) ?? T(hh, null, {
          default: () => [T(At, {
            icon: i.value ? e.nextIcon : e.prevIcon
          }, null)]
        })]), T("div", {
          key: "container",
          ref: h,
          class: "v-slide-group__container",
          onScroll: A
        }, [T("div", {
          ref: y,
          class: "v-slide-group__content",
          onFocusin: k,
          onFocusout: S,
          onKeydown: L
        }, [(K = n.default) == null ? void 0 : K.call(n, z.value)])]), H.value && T("div", {
          key: "next",
          class: ["v-slide-group__next", {
            "v-slide-group__next--disabled": !j.value
          }],
          onMousedown: I,
          onClick: () => j.value && V("next")
        }, [((te = n.next) == null ? void 0 : te.call(n, z.value)) ?? T(hh, null, {
          default: () => [T(At, {
            icon: i.value ? e.prevIcon : e.nextIcon
          }, null)]
        })])];
      }
    })), {
      selected: a.selected,
      scrollTo: V,
      scrollOffset: u,
      focus: N
    };
  }
}), bx = Symbol.for("vuetify:v-chip-group"), B8 = le({
  column: Boolean,
  filter: Boolean,
  valueComparator: {
    type: Function,
    default: Ba
  },
  ...yx(),
  ...Xe(),
  ...rl({
    selectedClass: "v-chip--selected"
  }),
  ...Bt(),
  ...Mt(),
  ...mr({
    variant: "tonal"
  })
}, "VChipGroup");
ye()({
  name: "VChipGroup",
  props: B8(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: i
    } = Wt(e), {
      isSelected: r,
      select: o,
      next: a,
      prev: l,
      selected: u
    } = Fa(e, bx);
    return Gr({
      VChip: {
        color: Me(e, "color"),
        disabled: Me(e, "disabled"),
        filter: Me(e, "filter"),
        variant: Me(e, "variant")
      }
    }), Oe(() => {
      const d = db.filterProps(e);
      return T(db, ge(d, {
        class: ["v-chip-group", {
          "v-chip-group--column": e.column
        }, i.value, e.class],
        style: e.style
      }), {
        default: () => {
          var f;
          return [(f = n.default) == null ? void 0 : f.call(n, {
            isSelected: r,
            select: o,
            next: a,
            prev: l,
            selected: u.value
          })];
        }
      });
    }), {};
  }
});
const V8 = le({
  activeClass: String,
  appendAvatar: String,
  appendIcon: ot,
  closable: Boolean,
  closeIcon: {
    type: ot,
    default: "$delete"
  },
  closeLabel: {
    type: String,
    default: "$vuetify.close"
  },
  draggable: Boolean,
  filter: Boolean,
  filterIcon: {
    type: String,
    default: "$complete"
  },
  label: Boolean,
  link: {
    type: Boolean,
    default: void 0
  },
  pill: Boolean,
  prependAvatar: String,
  prependIcon: ot,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  text: String,
  modelValue: {
    type: Boolean,
    default: !0
  },
  onClick: gi(),
  onClickOnce: gi(),
  ...$o(),
  ...Xe(),
  ...Oi(),
  ...Kr(),
  ...ol(),
  ...Gn(),
  ...Dc(),
  ...tl(),
  ...Bt({
    tag: "span"
  }),
  ...Mt(),
  ...mr({
    variant: "tonal"
  })
}, "VChip"), wx = ye()({
  name: "VChip",
  directives: {
    Ripple: Fo
  },
  props: V8(),
  emits: {
    "click:close": (e) => !0,
    "update:modelValue": (e) => !0,
    "group:selected": (e) => !0,
    click: (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: i,
      slots: r
    } = t;
    const {
      t: o
    } = tn(), {
      borderClasses: a
    } = Ro(e), {
      colorClasses: l,
      colorStyles: u,
      variantClasses: d
    } = Ra(e), {
      densityClasses: f
    } = zi(e), {
      elevationClasses: m
    } = Zr(e), {
      roundedClasses: h
    } = Xn(e), {
      sizeClasses: v
    } = nl(e), {
      themeClasses: y
    } = Wt(e), p = rt(e, "modelValue"), b = al(e, bx, !1), x = Ic(e, n), _ = B(() => e.link !== !1 && x.isLink.value), O = B(() => !e.disabled && e.link !== !1 && (!!b || e.link || x.isClickable.value)), D = B(() => ({
      "aria-label": o(e.closeLabel),
      onClick(A) {
        A.preventDefault(), A.stopPropagation(), p.value = !1, i("click:close", A);
      }
    }));
    function F(A) {
      var k;
      i("click", A), O.value && ((k = x.navigate) == null || k.call(x, A), b == null || b.toggle());
    }
    function $(A) {
      (A.key === "Enter" || A.key === " ") && (A.preventDefault(), F(A));
    }
    return () => {
      const A = x.isLink.value ? "a" : e.tag, k = !!(e.appendIcon || e.appendAvatar), S = !!(k || r.append), M = !!(r.close || e.closable), E = !!(r.filter || e.filter) && b, I = !!(e.prependIcon || e.prependAvatar), L = !!(I || r.prepend), N = !b || b.isSelected.value;
      return p.value && Nt(T(A, {
        class: ["v-chip", {
          "v-chip--disabled": e.disabled,
          "v-chip--label": e.label,
          "v-chip--link": O.value,
          "v-chip--filter": E,
          "v-chip--pill": e.pill
        }, y.value, a.value, N ? l.value : void 0, f.value, m.value, h.value, v.value, d.value, b == null ? void 0 : b.selectedClass.value, e.class],
        style: [N ? u.value : void 0, e.style],
        disabled: e.disabled || void 0,
        draggable: e.draggable,
        href: x.href.value,
        tabindex: O.value ? 0 : void 0,
        onClick: F,
        onKeydown: O.value && !_.value && $
      }, {
        default: () => {
          var V;
          return [Vo(O.value, "v-chip"), E && T(A1, {
            key: "filter"
          }, {
            default: () => [Nt(T("div", {
              class: "v-chip__filter"
            }, [r.filter ? T(pt, {
              key: "filter-defaults",
              disabled: !e.filterIcon,
              defaults: {
                VIcon: {
                  icon: e.filterIcon
                }
              }
            }, r.filter) : T(At, {
              key: "filter-icon",
              icon: e.filterIcon
            }, null)]), [[Ri, b.isSelected.value]])]
          }), L && T("div", {
            key: "prepend",
            class: "v-chip__prepend"
          }, [r.prepend ? T(pt, {
            key: "prepend-defaults",
            disabled: !I,
            defaults: {
              VAvatar: {
                image: e.prependAvatar,
                start: !0
              },
              VIcon: {
                icon: e.prependIcon,
                start: !0
              }
            }
          }, r.prepend) : T(qe, null, [e.prependIcon && T(At, {
            key: "prepend-icon",
            icon: e.prependIcon,
            start: !0
          }, null), e.prependAvatar && T(fr, {
            key: "prepend-avatar",
            image: e.prependAvatar,
            start: !0
          }, null)])]), T("div", {
            class: "v-chip__content",
            "data-no-activator": ""
          }, [((V = r.default) == null ? void 0 : V.call(r, {
            isSelected: b == null ? void 0 : b.isSelected.value,
            selectedClass: b == null ? void 0 : b.selectedClass.value,
            select: b == null ? void 0 : b.select,
            toggle: b == null ? void 0 : b.toggle,
            value: b == null ? void 0 : b.value.value,
            disabled: e.disabled
          })) ?? e.text]), S && T("div", {
            key: "append",
            class: "v-chip__append"
          }, [r.append ? T(pt, {
            key: "append-defaults",
            disabled: !k,
            defaults: {
              VAvatar: {
                end: !0,
                image: e.appendAvatar
              },
              VIcon: {
                end: !0,
                icon: e.appendIcon
              }
            }
          }, r.append) : T(qe, null, [e.appendIcon && T(At, {
            key: "append-icon",
            end: !0,
            icon: e.appendIcon
          }, null), e.appendAvatar && T(fr, {
            key: "append-avatar",
            end: !0,
            image: e.appendAvatar
          }, null)])]), M && T("button", ge({
            key: "close",
            class: "v-chip__close",
            type: "button"
          }, D.value), [r.close ? T(pt, {
            key: "close-defaults",
            defaults: {
              VIcon: {
                icon: e.closeIcon,
                size: "x-small"
              }
            }
          }, r.close) : T(At, {
            key: "close-icon",
            icon: e.closeIcon,
            size: "x-small"
          }, null)])];
        }
      }), [[Ci("ripple"), O.value && e.ripple, null]]);
    };
  }
}), $h = Symbol.for("vuetify:list");
function _x() {
  const e = ht($h, {
    hasPrepend: Pe(!1),
    updateHasPrepend: () => null
  }), t = {
    hasPrepend: Pe(!1),
    updateHasPrepend: (n) => {
      n && (t.hasPrepend.value = n);
    }
  };
  return sn($h, t), e;
}
function xx() {
  return ht($h, null);
}
const Jg = (e) => {
  const t = {
    activate: (n) => {
      let {
        id: i,
        value: r,
        activated: o
      } = n;
      return i = fn(i), e && !r && o.size === 1 && o.has(i) || (r ? o.add(i) : o.delete(i)), o;
    },
    in: (n, i, r) => {
      let o = /* @__PURE__ */ new Set();
      if (n != null)
        for (const a of en(n))
          o = t.activate({
            id: a,
            value: !0,
            activated: new Set(o),
            children: i,
            parents: r
          });
      return o;
    },
    out: (n) => Array.from(n)
  };
  return t;
}, kx = (e) => {
  const t = Jg(e);
  return {
    activate: (i) => {
      let {
        activated: r,
        id: o,
        ...a
      } = i;
      o = fn(o);
      const l = r.has(o) ? /* @__PURE__ */ new Set([o]) : /* @__PURE__ */ new Set();
      return t.activate({
        ...a,
        id: o,
        activated: l
      });
    },
    in: (i, r, o) => {
      let a = /* @__PURE__ */ new Set();
      if (i != null) {
        const l = en(i);
        l.length && (a = t.in(l.slice(0, 1), r, o));
      }
      return a;
    },
    out: (i, r, o) => t.out(i, r, o)
  };
}, $8 = (e) => {
  const t = Jg(e);
  return {
    activate: (i) => {
      let {
        id: r,
        activated: o,
        children: a,
        ...l
      } = i;
      return r = fn(r), a.has(r) ? o : t.activate({
        id: r,
        activated: o,
        children: a,
        ...l
      });
    },
    in: t.in,
    out: t.out
  };
}, R8 = (e) => {
  const t = kx(e);
  return {
    activate: (i) => {
      let {
        id: r,
        activated: o,
        children: a,
        ...l
      } = i;
      return r = fn(r), a.has(r) ? o : t.activate({
        id: r,
        activated: o,
        children: a,
        ...l
      });
    },
    in: t.in,
    out: t.out
  };
}, F8 = {
  open: (e) => {
    let {
      id: t,
      value: n,
      opened: i,
      parents: r
    } = e;
    if (n) {
      const o = /* @__PURE__ */ new Set();
      o.add(t);
      let a = r.get(t);
      for (; a != null; )
        o.add(a), a = r.get(a);
      return o;
    } else
      return i.delete(t), i;
  },
  select: () => null
}, Sx = {
  open: (e) => {
    let {
      id: t,
      value: n,
      opened: i,
      parents: r
    } = e;
    if (n) {
      let o = r.get(t);
      for (i.add(t); o != null && o !== t; )
        i.add(o), o = r.get(o);
      return i;
    } else
      i.delete(t);
    return i;
  },
  select: () => null
}, N8 = {
  open: Sx.open,
  select: (e) => {
    let {
      id: t,
      value: n,
      opened: i,
      parents: r
    } = e;
    if (!n)
      return i;
    const o = [];
    let a = r.get(t);
    for (; a != null; )
      o.push(a), a = r.get(a);
    return new Set(o);
  }
}, em = (e) => {
  const t = {
    select: (n) => {
      let {
        id: i,
        value: r,
        selected: o
      } = n;
      if (i = fn(i), e && !r) {
        const a = Array.from(o.entries()).reduce((l, u) => {
          let [d, f] = u;
          return f === "on" && l.push(d), l;
        }, []);
        if (a.length === 1 && a[0] === i)
          return o;
      }
      return o.set(i, r ? "on" : "off"), o;
    },
    in: (n, i, r) => {
      let o = /* @__PURE__ */ new Map();
      for (const a of n || [])
        o = t.select({
          id: a,
          value: !0,
          selected: new Map(o),
          children: i,
          parents: r
        });
      return o;
    },
    out: (n) => {
      const i = [];
      for (const [r, o] of n.entries())
        o === "on" && i.push(r);
      return i;
    }
  };
  return t;
}, Cx = (e) => {
  const t = em(e);
  return {
    select: (i) => {
      let {
        selected: r,
        id: o,
        ...a
      } = i;
      o = fn(o);
      const l = r.has(o) ? /* @__PURE__ */ new Map([[o, r.get(o)]]) : /* @__PURE__ */ new Map();
      return t.select({
        ...a,
        id: o,
        selected: l
      });
    },
    in: (i, r, o) => {
      let a = /* @__PURE__ */ new Map();
      return i != null && i.length && (a = t.in(i.slice(0, 1), r, o)), a;
    },
    out: (i, r, o) => t.out(i, r, o)
  };
}, W8 = (e) => {
  const t = em(e);
  return {
    select: (i) => {
      let {
        id: r,
        selected: o,
        children: a,
        ...l
      } = i;
      return r = fn(r), a.has(r) ? o : t.select({
        id: r,
        selected: o,
        children: a,
        ...l
      });
    },
    in: t.in,
    out: t.out
  };
}, z8 = (e) => {
  const t = Cx(e);
  return {
    select: (i) => {
      let {
        id: r,
        selected: o,
        children: a,
        ...l
      } = i;
      return r = fn(r), a.has(r) ? o : t.select({
        id: r,
        selected: o,
        children: a,
        ...l
      });
    },
    in: t.in,
    out: t.out
  };
}, H8 = (e) => {
  const t = {
    select: (n) => {
      let {
        id: i,
        value: r,
        selected: o,
        children: a,
        parents: l
      } = n;
      i = fn(i);
      const u = new Map(o), d = [i];
      for (; d.length; ) {
        const m = d.shift();
        o.set(m, r ? "on" : "off"), a.has(m) && d.push(...a.get(m));
      }
      let f = l.get(i);
      for (; f; ) {
        const m = a.get(f), h = m.every((y) => o.get(y) === "on"), v = m.every((y) => !o.has(y) || o.get(y) === "off");
        o.set(f, h ? "on" : v ? "off" : "indeterminate"), f = l.get(f);
      }
      return e && !r && Array.from(o.entries()).reduce((h, v) => {
        let [y, p] = v;
        return p === "on" && h.push(y), h;
      }, []).length === 0 ? u : o;
    },
    in: (n, i, r) => {
      let o = /* @__PURE__ */ new Map();
      for (const a of n || [])
        o = t.select({
          id: a,
          value: !0,
          selected: new Map(o),
          children: i,
          parents: r
        });
      return o;
    },
    out: (n, i) => {
      const r = [];
      for (const [o, a] of n.entries())
        a === "on" && !i.has(o) && r.push(o);
      return r;
    }
  };
  return t;
}, Ks = Symbol.for("vuetify:nested"), Ox = {
  id: Pe(),
  root: {
    register: () => null,
    unregister: () => null,
    parents: ie(/* @__PURE__ */ new Map()),
    children: ie(/* @__PURE__ */ new Map()),
    open: () => null,
    openOnSelect: () => null,
    activate: () => null,
    select: () => null,
    activatable: ie(!1),
    selectable: ie(!1),
    opened: ie(/* @__PURE__ */ new Set()),
    activated: ie(/* @__PURE__ */ new Set()),
    selected: ie(/* @__PURE__ */ new Map()),
    selectedValues: ie([])
  }
}, j8 = le({
  activatable: Boolean,
  selectable: Boolean,
  activeStrategy: [String, Function, Object],
  selectStrategy: [String, Function, Object],
  openStrategy: [String, Object],
  opened: null,
  activated: null,
  selected: null,
  mandatory: Boolean
}, "nested"), Y8 = (e) => {
  let t = !1;
  const n = ie(/* @__PURE__ */ new Map()), i = ie(/* @__PURE__ */ new Map()), r = rt(e, "opened", e.opened, (v) => new Set(v), (v) => [...v.values()]), o = B(() => {
    if (typeof e.activeStrategy == "object")
      return e.activeStrategy;
    if (typeof e.activeStrategy == "function")
      return e.activeStrategy(e.mandatory);
    switch (e.activeStrategy) {
      case "leaf":
        return $8(e.mandatory);
      case "single-leaf":
        return R8(e.mandatory);
      case "independent":
        return Jg(e.mandatory);
      case "single-independent":
      default:
        return kx(e.mandatory);
    }
  }), a = B(() => {
    if (typeof e.selectStrategy == "object")
      return e.selectStrategy;
    if (typeof e.selectStrategy == "function")
      return e.selectStrategy(e.mandatory);
    switch (e.selectStrategy) {
      case "single-leaf":
        return z8(e.mandatory);
      case "leaf":
        return W8(e.mandatory);
      case "independent":
        return em(e.mandatory);
      case "single-independent":
        return Cx(e.mandatory);
      case "classic":
      default:
        return H8(e.mandatory);
    }
  }), l = B(() => {
    if (typeof e.openStrategy == "object")
      return e.openStrategy;
    switch (e.openStrategy) {
      case "list":
        return N8;
      case "single":
        return F8;
      case "multiple":
      default:
        return Sx;
    }
  }), u = rt(e, "activated", e.activated, (v) => o.value.in(v, n.value, i.value), (v) => o.value.out(v, n.value, i.value)), d = rt(e, "selected", e.selected, (v) => a.value.in(v, n.value, i.value), (v) => a.value.out(v, n.value, i.value));
  _n(() => {
    t = !0;
  });
  function f(v) {
    const y = [];
    let p = v;
    for (; p != null; )
      y.unshift(p), p = i.value.get(p);
    return y;
  }
  const m = Gt("nested"), h = {
    id: Pe(),
    root: {
      opened: r,
      activatable: Me(e, "activatable"),
      selectable: Me(e, "selectable"),
      activated: u,
      selected: d,
      selectedValues: B(() => {
        const v = [];
        for (const [y, p] of d.value.entries())
          p === "on" && v.push(y);
        return v;
      }),
      register: (v, y, p) => {
        y && v !== y && i.value.set(v, y), p && n.value.set(v, []), y != null && n.value.set(y, [...n.value.get(y) || [], v]);
      },
      unregister: (v) => {
        if (t)
          return;
        n.value.delete(v);
        const y = i.value.get(v);
        if (y) {
          const p = n.value.get(y) ?? [];
          n.value.set(y, p.filter((b) => b !== v));
        }
        i.value.delete(v), r.value.delete(v);
      },
      open: (v, y, p) => {
        m.emit("click:open", {
          id: v,
          value: y,
          path: f(v),
          event: p
        });
        const b = l.value.open({
          id: v,
          value: y,
          opened: new Set(r.value),
          children: n.value,
          parents: i.value,
          event: p
        });
        b && (r.value = b);
      },
      openOnSelect: (v, y, p) => {
        const b = l.value.select({
          id: v,
          value: y,
          selected: new Map(d.value),
          opened: new Set(r.value),
          children: n.value,
          parents: i.value,
          event: p
        });
        b && (r.value = b);
      },
      select: (v, y, p) => {
        m.emit("click:select", {
          id: v,
          value: y,
          path: f(v),
          event: p
        });
        const b = a.value.select({
          id: v,
          value: y,
          selected: new Map(d.value),
          children: n.value,
          parents: i.value,
          event: p
        });
        b && (d.value = b), h.root.openOnSelect(v, y, p);
      },
      activate: (v, y, p) => {
        if (!e.activatable)
          return h.root.select(v, !0, p);
        m.emit("click:activate", {
          id: v,
          value: y,
          path: f(v),
          event: p
        });
        const b = o.value.activate({
          id: v,
          value: y,
          activated: new Set(u.value),
          children: n.value,
          parents: i.value,
          event: p
        });
        b && (u.value = b);
      },
      children: n,
      parents: i
    }
  };
  return sn(Ks, h), h.root;
}, Mx = (e, t) => {
  const n = ht(Ks, Ox), i = Symbol(qn()), r = B(() => e.value !== void 0 ? e.value : i), o = {
    ...n,
    id: r,
    open: (a, l) => n.root.open(r.value, a, l),
    openOnSelect: (a, l) => n.root.openOnSelect(r.value, a, l),
    isOpen: B(() => n.root.opened.value.has(r.value)),
    parent: B(() => n.root.parents.value.get(r.value)),
    activate: (a, l) => n.root.activate(r.value, a, l),
    isActivated: B(() => n.root.activated.value.has(fn(r.value))),
    select: (a, l) => n.root.select(r.value, a, l),
    isSelected: B(() => n.root.selected.value.get(fn(r.value)) === "on"),
    isIndeterminate: B(() => n.root.selected.value.get(r.value) === "indeterminate"),
    isLeaf: B(() => !n.root.children.value.get(r.value)),
    isGroupActivator: n.isGroupActivator
  };
  return !n.isGroupActivator && n.root.register(r.value, n.id.value, t), _n(() => {
    !n.isGroupActivator && n.root.unregister(r.value);
  }), t && sn(Ks, o), o;
}, U8 = () => {
  const e = ht(Ks, Ox);
  sn(Ks, {
    ...e,
    isGroupActivator: !0
  });
}, q8 = Va({
  name: "VListGroupActivator",
  setup(e, t) {
    let {
      slots: n
    } = t;
    return U8(), () => {
      var i;
      return (i = n.default) == null ? void 0 : i.call(n);
    };
  }
}), G8 = le({
  /* @deprecated */
  activeColor: String,
  baseColor: String,
  color: String,
  collapseIcon: {
    type: ot,
    default: "$collapse"
  },
  expandIcon: {
    type: ot,
    default: "$expand"
  },
  prependIcon: ot,
  appendIcon: ot,
  fluid: Boolean,
  subgroup: Boolean,
  title: String,
  value: null,
  ...Xe(),
  ...Bt()
}, "VListGroup"), fb = ye()({
  name: "VListGroup",
  props: G8(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      isOpen: i,
      open: r,
      id: o
    } = Mx(Me(e, "value"), !0), a = B(() => `v-list-group--id-${String(o.value)}`), l = xx(), {
      isBooted: u
    } = nw();
    function d(v) {
      r(!i.value, v);
    }
    const f = B(() => ({
      onClick: d,
      class: "v-list-group__header",
      id: a.value
    })), m = B(() => i.value ? e.collapseIcon : e.expandIcon), h = B(() => ({
      VListItem: {
        active: i.value,
        activeColor: e.activeColor,
        baseColor: e.baseColor,
        color: e.color,
        prependIcon: e.prependIcon || e.subgroup && m.value,
        appendIcon: e.appendIcon || !e.subgroup && m.value,
        title: e.title,
        value: e.value
      }
    }));
    return Oe(() => T(e.tag, {
      class: ["v-list-group", {
        "v-list-group--prepend": l == null ? void 0 : l.hasPrepend.value,
        "v-list-group--fluid": e.fluid,
        "v-list-group--subgroup": e.subgroup,
        "v-list-group--open": i.value
      }, e.class],
      style: e.style
    }, {
      default: () => [n.activator && T(pt, {
        defaults: h.value
      }, {
        default: () => [T(q8, null, {
          default: () => [n.activator({
            props: f.value,
            isOpen: i.value
          })]
        })]
      }), T(Si, {
        transition: {
          component: P1
        },
        disabled: !u.value
      }, {
        default: () => {
          var v;
          return [Nt(T("div", {
            class: "v-list-group__items",
            role: "group",
            "aria-labelledby": a.value
          }, [(v = n.default) == null ? void 0 : v.call(n)]), [[Ri, i.value]])];
        }
      })]
    })), {
      isOpen: i
    };
  }
}), X8 = le({
  opacity: [Number, String],
  ...Xe(),
  ...Bt()
}, "VListItemSubtitle"), K8 = ye()({
  name: "VListItemSubtitle",
  props: X8(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return Oe(() => T(e.tag, {
      class: ["v-list-item-subtitle", e.class],
      style: [{
        "--v-list-item-subtitle-opacity": e.opacity
      }, e.style]
    }, n)), {};
  }
}), Z8 = Js("v-list-item-title"), Q8 = le({
  active: {
    type: Boolean,
    default: void 0
  },
  activeClass: String,
  /* @deprecated */
  activeColor: String,
  appendAvatar: String,
  appendIcon: ot,
  baseColor: String,
  disabled: Boolean,
  lines: [Boolean, String],
  link: {
    type: Boolean,
    default: void 0
  },
  nav: Boolean,
  prependAvatar: String,
  prependIcon: ot,
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  slim: Boolean,
  subtitle: [String, Number],
  title: [String, Number],
  value: null,
  onClick: gi(),
  onClickOnce: gi(),
  ...$o(),
  ...Xe(),
  ...Oi(),
  ...hr(),
  ...Kr(),
  ...Gn(),
  ...Dc(),
  ...Bt(),
  ...Mt(),
  ...mr({
    variant: "text"
  })
}, "VListItem"), La = ye()({
  name: "VListItem",
  directives: {
    Ripple: Fo
  },
  props: Q8(),
  emits: {
    click: (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: i,
      emit: r
    } = t;
    const o = Ic(e, n), a = B(() => e.value === void 0 ? o.href.value : e.value), {
      activate: l,
      isActivated: u,
      select: d,
      isSelected: f,
      isIndeterminate: m,
      isGroupActivator: h,
      root: v,
      parent: y,
      openOnSelect: p
    } = Mx(a, !1), b = xx(), x = B(() => {
      var U;
      return e.active !== !1 && (e.active || ((U = o.isActive) == null ? void 0 : U.value) || (v.activatable.value ? u.value : f.value));
    }), _ = B(() => e.link !== !1 && o.isLink.value), O = B(() => !e.disabled && e.link !== !1 && (e.link || o.isClickable.value || !!b && (v.selectable.value || v.activatable.value || e.value != null))), D = B(() => e.rounded || e.nav), F = B(() => e.color ?? e.activeColor), $ = B(() => ({
      color: x.value ? F.value ?? e.baseColor : e.baseColor,
      variant: e.variant
    }));
    pe(() => {
      var U;
      return (U = o.isActive) == null ? void 0 : U.value;
    }, (U) => {
      U && y.value != null && v.open(y.value, !0), U && p(U);
    }, {
      immediate: !0
    });
    const {
      themeClasses: A
    } = Wt(e), {
      borderClasses: k
    } = Ro(e), {
      colorClasses: S,
      colorStyles: M,
      variantClasses: E
    } = Ra($), {
      densityClasses: I
    } = zi(e), {
      dimensionStyles: L
    } = gr(e), {
      elevationClasses: N
    } = Zr(e), {
      roundedClasses: V
    } = Xn(D), z = B(() => e.lines ? `v-list-item--${e.lines}-line` : void 0), H = B(() => ({
      isActive: x.value,
      select: d,
      isSelected: f.value,
      isIndeterminate: m.value
    }));
    function W(U) {
      var K;
      r("click", U), O.value && ((K = o.navigate) == null || K.call(o, U), !h && (v.activatable.value ? l(!u.value, U) : (v.selectable.value || e.value != null) && d(!f.value, U)));
    }
    function j(U) {
      (U.key === "Enter" || U.key === " ") && (U.preventDefault(), W(U));
    }
    return Oe(() => {
      const U = _.value ? "a" : e.tag, K = i.title || e.title != null, te = i.subtitle || e.subtitle != null, ue = !!(e.appendAvatar || e.appendIcon), de = !!(ue || i.append), Q = !!(e.prependAvatar || e.prependIcon), J = !!(Q || i.prepend);
      return b == null || b.updateHasPrepend(J), e.activeColor && UP("active-color", ["color", "base-color"]), Nt(T(U, {
        class: ["v-list-item", {
          "v-list-item--active": x.value,
          "v-list-item--disabled": e.disabled,
          "v-list-item--link": O.value,
          "v-list-item--nav": e.nav,
          "v-list-item--prepend": !J && (b == null ? void 0 : b.hasPrepend.value),
          "v-list-item--slim": e.slim,
          [`${e.activeClass}`]: e.activeClass && x.value
        }, A.value, k.value, S.value, I.value, N.value, z.value, V.value, E.value, e.class],
        style: [M.value, L.value, e.style],
        href: o.href.value,
        tabindex: O.value ? b ? -2 : 0 : void 0,
        onClick: W,
        onKeydown: O.value && !_.value && j
      }, {
        default: () => {
          var re;
          return [Vo(O.value || x.value, "v-list-item"), J && T("div", {
            key: "prepend",
            class: "v-list-item__prepend"
          }, [i.prepend ? T(pt, {
            key: "prepend-defaults",
            disabled: !Q,
            defaults: {
              VAvatar: {
                density: e.density,
                image: e.prependAvatar
              },
              VIcon: {
                density: e.density,
                icon: e.prependIcon
              },
              VListItemAction: {
                start: !0
              }
            }
          }, {
            default: () => {
              var me;
              return [(me = i.prepend) == null ? void 0 : me.call(i, H.value)];
            }
          }) : T(qe, null, [e.prependAvatar && T(fr, {
            key: "prepend-avatar",
            density: e.density,
            image: e.prependAvatar
          }, null), e.prependIcon && T(At, {
            key: "prepend-icon",
            density: e.density,
            icon: e.prependIcon
          }, null)]), T("div", {
            class: "v-list-item__spacer"
          }, null)]), T("div", {
            class: "v-list-item__content",
            "data-no-activator": ""
          }, [K && T(Z8, {
            key: "title"
          }, {
            default: () => {
              var me;
              return [((me = i.title) == null ? void 0 : me.call(i, {
                title: e.title
              })) ?? e.title];
            }
          }), te && T(K8, {
            key: "subtitle"
          }, {
            default: () => {
              var me;
              return [((me = i.subtitle) == null ? void 0 : me.call(i, {
                subtitle: e.subtitle
              })) ?? e.subtitle];
            }
          }), (re = i.default) == null ? void 0 : re.call(i, H.value)]), de && T("div", {
            key: "append",
            class: "v-list-item__append"
          }, [i.append ? T(pt, {
            key: "append-defaults",
            disabled: !ue,
            defaults: {
              VAvatar: {
                density: e.density,
                image: e.appendAvatar
              },
              VIcon: {
                density: e.density,
                icon: e.appendIcon
              },
              VListItemAction: {
                end: !0
              }
            }
          }, {
            default: () => {
              var me;
              return [(me = i.append) == null ? void 0 : me.call(i, H.value)];
            }
          }) : T(qe, null, [e.appendIcon && T(At, {
            key: "append-icon",
            density: e.density,
            icon: e.appendIcon
          }, null), e.appendAvatar && T(fr, {
            key: "append-avatar",
            density: e.density,
            image: e.appendAvatar
          }, null)]), T("div", {
            class: "v-list-item__spacer"
          }, null)])];
        }
      }), [[Ci("ripple"), O.value && e.ripple]]);
    }), {
      isGroupActivator: h,
      isSelected: f,
      list: b,
      select: d
    };
  }
}), J8 = le({
  color: String,
  inset: Boolean,
  sticky: Boolean,
  title: String,
  ...Xe(),
  ...Bt()
}, "VListSubheader"), eW = ye()({
  name: "VListSubheader",
  props: J8(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      textColorClasses: i,
      textColorStyles: r
    } = Fi(Me(e, "color"));
    return Oe(() => {
      const o = !!(n.default || e.title);
      return T(e.tag, {
        class: ["v-list-subheader", {
          "v-list-subheader--inset": e.inset,
          "v-list-subheader--sticky": e.sticky
        }, i.value, e.class],
        style: [{
          textColorStyles: r
        }, e.style]
      }, {
        default: () => {
          var a;
          return [o && T("div", {
            class: "v-list-subheader__text"
          }, [((a = n.default) == null ? void 0 : a.call(n)) ?? e.title])];
        }
      });
    }), {};
  }
}), tW = le({
  items: Array,
  returnObject: Boolean
}, "VListChildren"), Tx = ye()({
  name: "VListChildren",
  props: tW(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return _x(), () => {
      var i, r;
      return ((i = n.default) == null ? void 0 : i.call(n)) ?? ((r = e.items) == null ? void 0 : r.map((o) => {
        var h, v;
        let {
          children: a,
          props: l,
          type: u,
          raw: d
        } = o;
        if (u === "divider")
          return ((h = n.divider) == null ? void 0 : h.call(n, {
            props: l
          })) ?? T(U1, l, null);
        if (u === "subheader")
          return ((v = n.subheader) == null ? void 0 : v.call(n, {
            props: l
          })) ?? T(eW, l, null);
        const f = {
          subtitle: n.subtitle ? (y) => {
            var p;
            return (p = n.subtitle) == null ? void 0 : p.call(n, {
              ...y,
              item: d
            });
          } : void 0,
          prepend: n.prepend ? (y) => {
            var p;
            return (p = n.prepend) == null ? void 0 : p.call(n, {
              ...y,
              item: d
            });
          } : void 0,
          append: n.append ? (y) => {
            var p;
            return (p = n.append) == null ? void 0 : p.call(n, {
              ...y,
              item: d
            });
          } : void 0,
          title: n.title ? (y) => {
            var p;
            return (p = n.title) == null ? void 0 : p.call(n, {
              ...y,
              item: d
            });
          } : void 0
        }, m = fb.filterProps(l);
        return a ? T(fb, ge({
          value: l == null ? void 0 : l.value
        }, m), {
          activator: (y) => {
            let {
              props: p
            } = y;
            const b = {
              ...l,
              ...p,
              value: e.returnObject ? d : l.value
            };
            return n.header ? n.header({
              props: b
            }) : T(La, b, f);
          },
          default: () => T(Tx, {
            items: a,
            returnObject: e.returnObject
          }, n)
        }) : n.item ? n.item({
          props: l
        }) : T(La, ge(l, {
          value: e.returnObject ? d : l.value
        }), f);
      }));
    };
  }
}), Px = le({
  items: {
    type: Array,
    default: () => []
  },
  itemTitle: {
    type: [String, Array, Function],
    default: "title"
  },
  itemValue: {
    type: [String, Array, Function],
    default: "value"
  },
  itemChildren: {
    type: [Boolean, String, Array, Function],
    default: "children"
  },
  itemProps: {
    type: [Boolean, String, Array, Function],
    default: "props"
  },
  returnObject: Boolean,
  valueComparator: {
    type: Function,
    default: Ba
  }
}, "list-items");
function Br(e, t) {
  const n = hi(t, e.itemTitle, t), i = hi(t, e.itemValue, n), r = hi(t, e.itemChildren), o = e.itemProps === !0 ? typeof t == "object" && t != null && !Array.isArray(t) ? "children" in t ? gn(t, ["children"]) : t : void 0 : hi(t, e.itemProps), a = {
    title: n,
    value: i,
    ...o
  };
  return {
    title: String(a.title ?? ""),
    value: a.value,
    props: a,
    children: Array.isArray(r) ? Ax(e, r) : void 0,
    raw: t
  };
}
function Ax(e, t) {
  const n = [];
  for (const i of t)
    n.push(Br(e, i));
  return n;
}
function Ex(e) {
  const t = B(() => Ax(e, e.items)), n = B(() => t.value.some((o) => o.value === null));
  function i(o) {
    return n.value || (o = o.filter((a) => a !== null)), o.map((a) => e.returnObject && typeof a == "string" ? Br(e, a) : t.value.find((l) => e.valueComparator(a, l.value)) || Br(e, a));
  }
  function r(o) {
    return e.returnObject ? o.map((a) => {
      let {
        raw: l
      } = a;
      return l;
    }) : o.map((a) => {
      let {
        value: l
      } = a;
      return l;
    });
  }
  return {
    items: t,
    transformIn: i,
    transformOut: r
  };
}
function nW(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean";
}
function iW(e, t) {
  const n = hi(t, e.itemType, "item"), i = nW(t) ? t : hi(t, e.itemTitle), r = hi(t, e.itemValue, void 0), o = hi(t, e.itemChildren), a = e.itemProps === !0 ? gn(t, ["children"]) : hi(t, e.itemProps), l = {
    title: i,
    value: r,
    ...a
  };
  return {
    type: n,
    title: l.title,
    value: l.value,
    props: l,
    children: n === "item" && o ? Ix(e, o) : void 0,
    raw: t
  };
}
function Ix(e, t) {
  const n = [];
  for (const i of t)
    n.push(iW(e, i));
  return n;
}
function rW(e) {
  return {
    items: B(() => Ix(e, e.items))
  };
}
const oW = le({
  baseColor: String,
  /* @deprecated */
  activeColor: String,
  activeClass: String,
  bgColor: String,
  disabled: Boolean,
  expandIcon: String,
  collapseIcon: String,
  lines: {
    type: [Boolean, String],
    default: "one"
  },
  slim: Boolean,
  nav: Boolean,
  ...j8({
    selectStrategy: "single-leaf",
    openStrategy: "list"
  }),
  ...$o(),
  ...Xe(),
  ...Oi(),
  ...hr(),
  ...Kr(),
  itemType: {
    type: String,
    default: "type"
  },
  ...Px(),
  ...Gn(),
  ...Bt(),
  ...Mt(),
  ...mr({
    variant: "text"
  })
}, "VList"), Dx = ye()({
  name: "VList",
  props: oW(),
  emits: {
    "update:selected": (e) => !0,
    "update:activated": (e) => !0,
    "update:opened": (e) => !0,
    "click:open": (e) => !0,
    "click:activate": (e) => !0,
    "click:select": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      items: i
    } = rW(e), {
      themeClasses: r
    } = Wt(e), {
      backgroundColorClasses: o,
      backgroundColorStyles: a
    } = Yn(Me(e, "bgColor")), {
      borderClasses: l
    } = Ro(e), {
      densityClasses: u
    } = zi(e), {
      dimensionStyles: d
    } = gr(e), {
      elevationClasses: f
    } = Zr(e), {
      roundedClasses: m
    } = Xn(e), {
      children: h,
      open: v,
      parents: y,
      select: p
    } = Y8(e), b = B(() => e.lines ? `v-list--${e.lines}-line` : void 0), x = Me(e, "activeColor"), _ = Me(e, "baseColor"), O = Me(e, "color");
    _x(), Gr({
      VListGroup: {
        activeColor: x,
        baseColor: _,
        color: O,
        expandIcon: Me(e, "expandIcon"),
        collapseIcon: Me(e, "collapseIcon")
      },
      VListItem: {
        activeClass: Me(e, "activeClass"),
        activeColor: x,
        baseColor: _,
        color: O,
        density: Me(e, "density"),
        disabled: Me(e, "disabled"),
        lines: Me(e, "lines"),
        nav: Me(e, "nav"),
        slim: Me(e, "slim"),
        variant: Me(e, "variant")
      }
    });
    const D = Pe(!1), F = ie();
    function $(I) {
      D.value = !0;
    }
    function A(I) {
      D.value = !1;
    }
    function k(I) {
      var L;
      !D.value && !(I.relatedTarget && ((L = F.value) != null && L.contains(I.relatedTarget))) && E();
    }
    function S(I) {
      const L = I.target;
      if (!(!F.value || ["INPUT", "TEXTAREA"].includes(L.tagName))) {
        if (I.key === "ArrowDown")
          E("next");
        else if (I.key === "ArrowUp")
          E("prev");
        else if (I.key === "Home")
          E("first");
        else if (I.key === "End")
          E("last");
        else
          return;
        I.preventDefault();
      }
    }
    function M(I) {
      D.value = !0;
    }
    function E(I) {
      if (F.value)
        return Uu(F.value, I);
    }
    return Oe(() => T(e.tag, {
      ref: F,
      class: ["v-list", {
        "v-list--disabled": e.disabled,
        "v-list--nav": e.nav,
        "v-list--slim": e.slim
      }, r.value, o.value, l.value, u.value, f.value, b.value, m.value, e.class],
      style: [a.value, d.value, e.style],
      tabindex: e.disabled || D.value ? -1 : 0,
      role: "listbox",
      "aria-activedescendant": void 0,
      onFocusin: $,
      onFocusout: A,
      onFocus: k,
      onKeydown: S,
      onMousedown: M
    }, {
      default: () => [T(Tx, {
        items: i.value,
        returnObject: e.returnObject
      }, n)]
    })), {
      open: v,
      select: p,
      focus: E,
      children: h,
      parents: y
    };
  }
}), aW = le({
  active: Boolean,
  disabled: Boolean,
  max: [Number, String],
  value: {
    type: [Number, String],
    default: 0
  },
  ...Xe(),
  ...$a({
    transition: {
      component: T1
    }
  })
}, "VCounter"), sW = ye()({
  name: "VCounter",
  functional: !0,
  props: aW(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = B(() => e.max ? `${e.value} / ${e.max}` : String(e.value));
    return Oe(() => T(Si, {
      transition: e.transition
    }, {
      default: () => [Nt(T("div", {
        class: ["v-counter", {
          "text-error": e.max && !e.disabled && parseFloat(e.value) > parseFloat(e.max)
        }, e.class],
        style: e.style
      }, [n.default ? n.default({
        counter: i.value,
        max: e.max,
        value: e.value
      }) : i.value]), [[Ri, e.active]])]
    })), {};
  }
}), lW = le({
  floating: Boolean,
  ...Xe()
}, "VFieldLabel"), Iu = ye()({
  name: "VFieldLabel",
  props: lW(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    return Oe(() => T(og, {
      class: ["v-field-label", {
        "v-field-label--floating": e.floating
      }, e.class],
      style: e.style,
      "aria-hidden": e.floating || void 0
    }, n)), {};
  }
}), uW = ["underlined", "outlined", "filled", "solo", "solo-inverted", "solo-filled", "plain"], Lx = le({
  appendInnerIcon: ot,
  bgColor: String,
  clearable: Boolean,
  clearIcon: {
    type: ot,
    default: "$clear"
  },
  active: Boolean,
  centerAffix: {
    type: Boolean,
    default: void 0
  },
  color: String,
  baseColor: String,
  dirty: Boolean,
  disabled: {
    type: Boolean,
    default: null
  },
  error: Boolean,
  flat: Boolean,
  label: String,
  persistentClear: Boolean,
  prependInnerIcon: ot,
  reverse: Boolean,
  singleLine: Boolean,
  variant: {
    type: String,
    default: "filled",
    validator: (e) => uW.includes(e)
  },
  "onClick:clear": gi(),
  "onClick:appendInner": gi(),
  "onClick:prependInner": gi(),
  ...Xe(),
  ...ig(),
  ...Gn(),
  ...Mt()
}, "VField"), Bx = ye()({
  name: "VField",
  inheritAttrs: !1,
  props: {
    id: String,
    ...E1(),
    ...Lx()
  },
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: i,
      slots: r
    } = t;
    const {
      themeClasses: o
    } = Wt(e), {
      loaderClasses: a
    } = rg(e), {
      focusClasses: l,
      isFocused: u,
      focus: d,
      blur: f
    } = ug(e), {
      InputIcon: m
    } = C1(e), {
      roundedClasses: h
    } = Xn(e), {
      rtlClasses: v
    } = Xr(), y = B(() => e.dirty || e.active), p = B(() => !e.singleLine && !!(e.label || r.label)), b = qn(), x = B(() => e.id || `input-${b}`), _ = B(() => `${x.value}-messages`), O = ie(), D = ie(), F = ie(), $ = B(() => ["plain", "underlined"].includes(e.variant)), {
      backgroundColorClasses: A,
      backgroundColorStyles: k
    } = Yn(Me(e, "bgColor")), {
      textColorClasses: S,
      textColorStyles: M
    } = Fi(B(() => e.error || e.disabled ? void 0 : y.value && u.value ? e.color : e.baseColor));
    pe(y, (N) => {
      if (p.value) {
        const V = O.value.$el, z = D.value.$el;
        requestAnimationFrame(() => {
          const H = Xh(V), W = z.getBoundingClientRect(), j = W.x - H.x, U = W.y - H.y - (H.height / 2 - W.height / 2), K = W.width / 0.75, te = Math.abs(K - H.width) > 1 ? {
            maxWidth: ze(K)
          } : void 0, ue = getComputedStyle(V), de = getComputedStyle(z), Q = parseFloat(ue.transitionDuration) * 1e3 || 150, J = parseFloat(de.getPropertyValue("--v-field-label-scale")), re = de.getPropertyValue("color");
          V.style.visibility = "visible", z.style.visibility = "hidden", pa(V, {
            transform: `translate(${j}px, ${U}px) scale(${J})`,
            color: re,
            ...te
          }, {
            duration: Q,
            easing: Ku,
            direction: N ? "normal" : "reverse"
          }).finished.then(() => {
            V.style.removeProperty("visibility"), z.style.removeProperty("visibility");
          });
        });
      }
    }, {
      flush: "post"
    });
    const E = B(() => ({
      isActive: y,
      isFocused: u,
      controlRef: F,
      blur: f,
      focus: d
    }));
    function I(N) {
      N.target !== document.activeElement && N.preventDefault();
    }
    function L(N) {
      var V;
      N.key !== "Enter" && N.key !== " " || (N.preventDefault(), N.stopPropagation(), (V = e["onClick:clear"]) == null || V.call(e, new MouseEvent("click")));
    }
    return Oe(() => {
      var j, U, K;
      const N = e.variant === "outlined", V = !!(r["prepend-inner"] || e.prependInnerIcon), z = !!(e.clearable || r.clear), H = !!(r["append-inner"] || e.appendInnerIcon || z), W = () => r.label ? r.label({
        ...E.value,
        label: e.label,
        props: {
          for: x.value
        }
      }) : e.label;
      return T("div", ge({
        class: ["v-field", {
          "v-field--active": y.value,
          "v-field--appended": H,
          "v-field--center-affix": e.centerAffix ?? !$.value,
          "v-field--disabled": e.disabled,
          "v-field--dirty": e.dirty,
          "v-field--error": e.error,
          "v-field--flat": e.flat,
          "v-field--has-background": !!e.bgColor,
          "v-field--persistent-clear": e.persistentClear,
          "v-field--prepended": V,
          "v-field--reverse": e.reverse,
          "v-field--single-line": e.singleLine,
          "v-field--no-label": !W(),
          [`v-field--variant-${e.variant}`]: !0
        }, o.value, A.value, l.value, a.value, h.value, v.value, e.class],
        style: [k.value, e.style],
        onClick: I
      }, n), [T("div", {
        class: "v-field__overlay"
      }, null), T(g1, {
        name: "v-field",
        active: !!e.loading,
        color: e.error ? "error" : typeof e.loading == "string" ? e.loading : e.color
      }, {
        default: r.loader
      }), V && T("div", {
        key: "prepend",
        class: "v-field__prepend-inner"
      }, [e.prependInnerIcon && T(m, {
        key: "prepend-icon",
        name: "prependInner"
      }, null), (j = r["prepend-inner"]) == null ? void 0 : j.call(r, E.value)]), T("div", {
        class: "v-field__field",
        "data-no-activator": ""
      }, [["filled", "solo", "solo-inverted", "solo-filled"].includes(e.variant) && p.value && T(Iu, {
        key: "floating-label",
        ref: D,
        class: [S.value],
        floating: !0,
        for: x.value,
        style: M.value
      }, {
        default: () => [W()]
      }), T(Iu, {
        ref: O,
        for: x.value
      }, {
        default: () => [W()]
      }), (U = r.default) == null ? void 0 : U.call(r, {
        ...E.value,
        props: {
          id: x.value,
          class: "v-field__input",
          "aria-describedby": _.value
        },
        focus: d,
        blur: f
      })]), z && T(A1, {
        key: "clear"
      }, {
        default: () => [Nt(T("div", {
          class: "v-field__clearable",
          onMousedown: (te) => {
            te.preventDefault(), te.stopPropagation();
          }
        }, [T(pt, {
          defaults: {
            VIcon: {
              icon: e.clearIcon
            }
          }
        }, {
          default: () => [r.clear ? r.clear({
            ...E.value,
            props: {
              onKeydown: L,
              onFocus: d,
              onBlur: f,
              onClick: e["onClick:clear"]
            }
          }) : T(m, {
            name: "clear",
            onKeydown: L,
            onFocus: d,
            onBlur: f
          }, null)]
        })]), [[Ri, e.dirty]])]
      }), H && T("div", {
        key: "append",
        class: "v-field__append-inner"
      }, [(K = r["append-inner"]) == null ? void 0 : K.call(r, E.value), e.appendInnerIcon && T(m, {
        key: "append-icon",
        name: "appendInner"
      }, null)]), T("div", {
        class: ["v-field__outline", S.value],
        style: M.value
      }, [N && T(qe, null, [T("div", {
        class: "v-field__outline__start"
      }, null), p.value && T("div", {
        class: "v-field__outline__notch"
      }, [T(Iu, {
        ref: D,
        floating: !0,
        for: x.value
      }, {
        default: () => [W()]
      })]), T("div", {
        class: "v-field__outline__end"
      }, null)]), $.value && p.value && T(Iu, {
        ref: D,
        floating: !0,
        for: x.value
      }, {
        default: () => [W()]
      })])]);
    }), {
      controlRef: F
    };
  }
});
function cW(e) {
  const t = Object.keys(Bx.props).filter((n) => !Uh(n) && n !== "class" && n !== "style");
  return Eb(e, t);
}
const dW = ["color", "file", "time", "date", "datetime-local", "week", "month"], tm = le({
  autofocus: Boolean,
  counter: [Boolean, Number, String],
  counterValue: [Number, Function],
  prefix: String,
  placeholder: String,
  persistentPlaceholder: Boolean,
  persistentCounter: Boolean,
  suffix: String,
  role: String,
  type: {
    type: String,
    default: "text"
  },
  modelModifiers: Object,
  ...Lc(),
  ...Lx()
}, "VTextField"), Zs = ye()({
  name: "VTextField",
  directives: {
    Intersect: c1
  },
  inheritAttrs: !1,
  props: tm(),
  emits: {
    "click:control": (e) => !0,
    "mousedown:control": (e) => !0,
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: i,
      slots: r
    } = t;
    const o = rt(e, "modelValue"), {
      isFocused: a,
      focus: l,
      blur: u
    } = ug(e), d = B(() => typeof e.counterValue == "function" ? e.counterValue(o.value) : typeof e.counterValue == "number" ? e.counterValue : (o.value ?? "").toString().length), f = B(() => {
      if (n.maxlength)
        return n.maxlength;
      if (!(!e.counter || typeof e.counter != "number" && typeof e.counter != "string"))
        return e.counter;
    }), m = B(() => ["plain", "underlined"].includes(e.variant));
    function h($, A) {
      var k, S;
      !e.autofocus || !$ || (S = (k = A[0].target) == null ? void 0 : k.focus) == null || S.call(k);
    }
    const v = ie(), y = ie(), p = ie(), b = B(() => dW.includes(e.type) || e.persistentPlaceholder || a.value || e.active);
    function x() {
      var $;
      p.value !== document.activeElement && (($ = p.value) == null || $.focus()), a.value || l();
    }
    function _($) {
      i("mousedown:control", $), $.target !== p.value && (x(), $.preventDefault());
    }
    function O($) {
      x(), i("click:control", $);
    }
    function D($) {
      $.stopPropagation(), x(), gt(() => {
        o.value = null, IP(e["onClick:clear"], $);
      });
    }
    function F($) {
      var k;
      const A = $.target;
      if (o.value = A.value, (k = e.modelModifiers) != null && k.trim && ["text", "search", "password", "tel", "url"].includes(e.type)) {
        const S = [A.selectionStart, A.selectionEnd];
        gt(() => {
          A.selectionStart = S[0], A.selectionEnd = S[1];
        });
      }
    }
    return Oe(() => {
      const $ = !!(r.counter || e.counter !== !1 && e.counter != null), A = !!($ || r.details), [k, S] = Mc(n), {
        modelValue: M,
        ...E
      } = Sa.filterProps(e), I = cW(e);
      return T(Sa, ge({
        ref: v,
        modelValue: o.value,
        "onUpdate:modelValue": (L) => o.value = L,
        class: ["v-text-field", {
          "v-text-field--prefixed": e.prefix,
          "v-text-field--suffixed": e.suffix,
          "v-input--plain-underlined": m.value
        }, e.class],
        style: e.style
      }, k, E, {
        centerAffix: !m.value,
        focused: a.value
      }), {
        ...r,
        default: (L) => {
          let {
            id: N,
            isDisabled: V,
            isDirty: z,
            isReadonly: H,
            isValid: W
          } = L;
          return T(Bx, ge({
            ref: y,
            onMousedown: _,
            onClick: O,
            "onClick:clear": D,
            "onClick:prependInner": e["onClick:prependInner"],
            "onClick:appendInner": e["onClick:appendInner"],
            role: e.role
          }, I, {
            id: N.value,
            active: b.value || z.value,
            dirty: z.value || e.dirty,
            disabled: V.value,
            focused: a.value,
            error: W.value === !1
          }), {
            ...r,
            default: (j) => {
              let {
                props: {
                  class: U,
                  ...K
                }
              } = j;
              const te = Nt(T("input", ge({
                ref: p,
                value: o.value,
                onInput: F,
                autofocus: e.autofocus,
                readonly: H.value,
                disabled: V.value,
                name: e.name,
                placeholder: e.placeholder,
                size: 1,
                type: e.type,
                onFocus: x,
                onBlur: u
              }, K, S), null), [[Ci("intersect"), {
                handler: h
              }, null, {
                once: !0
              }]]);
              return T(qe, null, [e.prefix && T("span", {
                class: "v-text-field__prefix"
              }, [T("span", {
                class: "v-text-field__prefix__text"
              }, [e.prefix])]), r.default ? T("div", {
                class: U,
                "data-no-activator": ""
              }, [r.default(), te]) : kP(te, {
                class: U
              }), e.suffix && T("span", {
                class: "v-text-field__suffix"
              }, [T("span", {
                class: "v-text-field__suffix__text"
              }, [e.suffix])])]);
            }
          });
        },
        details: A ? (L) => {
          var N;
          return T(qe, null, [(N = r.details) == null ? void 0 : N.call(r, L), $ && T(qe, null, [T("span", null, null), T(sW, {
            active: e.persistentCounter || a.value,
            value: d.value,
            max: f.value,
            disabled: e.disabled
          }, r.counter)])]);
        } : void 0
      });
    }), Qr({}, v, y, p);
  }
}), fW = le({
  renderless: Boolean,
  ...Xe()
}, "VVirtualScrollItem"), hW = ye()({
  name: "VVirtualScrollItem",
  inheritAttrs: !1,
  props: fW(),
  emits: {
    "update:height": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: i,
      slots: r
    } = t;
    const {
      resizeRef: o,
      contentRect: a
    } = Bs(void 0, "border");
    pe(() => {
      var l;
      return (l = a.value) == null ? void 0 : l.height;
    }, (l) => {
      l != null && i("update:height", l);
    }), Oe(() => {
      var l, u;
      return e.renderless ? T(qe, null, [(l = r.default) == null ? void 0 : l.call(r, {
        itemRef: o
      })]) : T("div", ge({
        ref: o,
        class: ["v-virtual-scroll__item", e.class],
        style: e.style
      }, n), [(u = r.default) == null ? void 0 : u.call(r)]);
    });
  }
}), gW = -1, mW = 1, Jf = 100, vW = le({
  itemHeight: {
    type: [Number, String],
    default: null
  },
  height: [Number, String]
}, "virtual");
function pW(e, t) {
  const n = Jh(), i = Pe(0);
  Ln(() => {
    i.value = parseFloat(e.itemHeight || 0);
  });
  const r = Pe(0), o = Pe(Math.ceil(
    // Assume 16px items filling the entire screen height if
    // not provided. This is probably incorrect but it minimises
    // the chance of ending up with empty space at the bottom.
    // The default value is set here to avoid poisoning getSize()
    (parseInt(e.height) || n.height.value) / (i.value || 16)
  ) || 1), a = Pe(0), l = Pe(0), u = ie(), d = ie();
  let f = 0;
  const {
    resizeRef: m,
    contentRect: h
  } = Bs();
  Ln(() => {
    m.value = u.value;
  });
  const v = B(() => {
    var j;
    return u.value === document.documentElement ? n.height.value : ((j = h.value) == null ? void 0 : j.height) || parseInt(e.height) || 0;
  }), y = B(() => !!(u.value && d.value && v.value && i.value));
  let p = Array.from({
    length: t.value.length
  }), b = Array.from({
    length: t.value.length
  });
  const x = Pe(0);
  let _ = -1;
  function O(j) {
    return p[j] || i.value;
  }
  const D = AP(() => {
    const j = performance.now();
    b[0] = 0;
    const U = t.value.length;
    for (let K = 1; K <= U - 1; K++)
      b[K] = (b[K - 1] || 0) + O(K - 1);
    x.value = Math.max(x.value, performance.now() - j);
  }, x), F = pe(y, (j) => {
    j && (F(), f = d.value.offsetTop, D.immediate(), V(), ~_ && gt(() => {
      ft && window.requestAnimationFrame(() => {
        H(_), _ = -1;
      });
    }));
  });
  wn(() => {
    D.clear();
  });
  function $(j, U) {
    const K = p[j], te = i.value;
    i.value = te ? Math.min(i.value, U) : U, (K !== U || te !== i.value) && (p[j] = U, D());
  }
  function A(j) {
    return j = lr(j, 0, t.value.length - 1), b[j] || 0;
  }
  function k(j) {
    return yW(b, j);
  }
  let S = 0, M = 0, E = 0;
  pe(v, (j, U) => {
    U && (V(), j < U && requestAnimationFrame(() => {
      M = 0, V();
    }));
  });
  function I() {
    if (!u.value || !d.value)
      return;
    const j = u.value.scrollTop, U = performance.now();
    U - E > 500 ? (M = Math.sign(j - S), f = d.value.offsetTop) : M = j - S, S = j, E = U, V();
  }
  function L() {
    !u.value || !d.value || (M = 0, E = 0, V());
  }
  let N = -1;
  function V() {
    cancelAnimationFrame(N), N = requestAnimationFrame(z);
  }
  function z() {
    if (!u.value || !v.value)
      return;
    const j = S - f, U = Math.sign(M), K = Math.max(0, j - Jf), te = lr(k(K), 0, t.value.length), ue = j + v.value + Jf, de = lr(k(ue) + 1, te + 1, t.value.length);
    if (
      // Only update the side we're scrolling towards,
      // the other side will be updated incidentally
      (U !== gW || te < r.value) && (U !== mW || de > o.value)
    ) {
      const Q = A(r.value) - A(te), J = A(de) - A(o.value);
      Math.max(Q, J) > Jf ? (r.value = te, o.value = de) : (te <= 0 && (r.value = te), de >= t.value.length && (o.value = de));
    }
    a.value = A(r.value), l.value = A(t.value.length) - A(o.value);
  }
  function H(j) {
    const U = A(j);
    !u.value || j && !U ? _ = j : u.value.scrollTop = U;
  }
  const W = B(() => t.value.slice(r.value, o.value).map((j, U) => ({
    raw: j,
    index: U + r.value
  })));
  return pe(t, () => {
    p = Array.from({
      length: t.value.length
    }), b = Array.from({
      length: t.value.length
    }), D.immediate(), V();
  }, {
    deep: !0
  }), {
    containerRef: u,
    markerRef: d,
    computedItems: W,
    paddingTop: a,
    paddingBottom: l,
    scrollToIndex: H,
    handleScroll: I,
    handleScrollend: L,
    handleItemResize: $
  };
}
function yW(e, t) {
  let n = e.length - 1, i = 0, r = 0, o = null, a = -1;
  if (e[n] < t)
    return n;
  for (; i <= n; )
    if (r = i + n >> 1, o = e[r], o > t)
      n = r - 1;
    else if (o < t)
      a = r, i = r + 1;
    else
      return o === t ? r : i;
  return a;
}
const bW = le({
  items: {
    type: Array,
    default: () => []
  },
  renderless: Boolean,
  ...vW(),
  ...Xe(),
  ...hr()
}, "VVirtualScroll"), Vx = ye()({
  name: "VVirtualScroll",
  props: bW(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const i = Gt("VVirtualScroll"), {
      dimensionStyles: r
    } = gr(e), {
      containerRef: o,
      markerRef: a,
      handleScroll: l,
      handleScrollend: u,
      handleItemResize: d,
      scrollToIndex: f,
      paddingTop: m,
      paddingBottom: h,
      computedItems: v
    } = pW(e, Me(e, "items"));
    return jr(() => e.renderless, () => {
      function y() {
        var x, _;
        const b = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1) ? "addEventListener" : "removeEventListener";
        o.value === document.documentElement ? (document[b]("scroll", l, {
          passive: !0
        }), document[b]("scrollend", u)) : ((x = o.value) == null || x[b]("scroll", l, {
          passive: !0
        }), (_ = o.value) == null || _[b]("scrollend", u));
      }
      mn(() => {
        o.value = Ub(i.vnode.el, !0), y(!0);
      }), wn(y);
    }), Oe(() => {
      const y = v.value.map((p) => T(hW, {
        key: p.index,
        renderless: e.renderless,
        "onUpdate:height": (b) => d(p.index, b)
      }, {
        default: (b) => {
          var x;
          return (x = n.default) == null ? void 0 : x.call(n, {
            item: p.raw,
            index: p.index,
            ...b
          });
        }
      }));
      return e.renderless ? T(qe, null, [T("div", {
        ref: a,
        class: "v-virtual-scroll__spacer",
        style: {
          paddingTop: ze(m.value)
        }
      }, null), y, T("div", {
        class: "v-virtual-scroll__spacer",
        style: {
          paddingBottom: ze(h.value)
        }
      }, null)]) : T("div", {
        ref: o,
        class: ["v-virtual-scroll", e.class],
        onScrollPassive: l,
        onScrollend: u,
        style: [r.value, e.style]
      }, [T("div", {
        ref: a,
        class: "v-virtual-scroll__container",
        style: {
          paddingTop: ze(m.value),
          paddingBottom: ze(h.value)
        }
      }, [y])]);
    }), {
      scrollToIndex: f
    };
  }
});
function $x(e, t) {
  const n = Pe(!1);
  let i;
  function r(l) {
    cancelAnimationFrame(i), n.value = !0, i = requestAnimationFrame(() => {
      i = requestAnimationFrame(() => {
        n.value = !1;
      });
    });
  }
  async function o() {
    await new Promise((l) => requestAnimationFrame(l)), await new Promise((l) => requestAnimationFrame(l)), await new Promise((l) => requestAnimationFrame(l)), await new Promise((l) => {
      if (n.value) {
        const u = pe(n, () => {
          u(), l();
        });
      } else
        l();
    });
  }
  async function a(l) {
    var f, m;
    if (l.key === "Tab" && ((f = t.value) == null || f.focus()), !["PageDown", "PageUp", "Home", "End"].includes(l.key))
      return;
    const u = (m = e.value) == null ? void 0 : m.$el;
    if (!u)
      return;
    (l.key === "Home" || l.key === "End") && u.scrollTo({
      top: l.key === "Home" ? 0 : u.scrollHeight,
      behavior: "smooth"
    }), await o();
    const d = u.querySelectorAll(":scope > :not(.v-virtual-scroll__spacer)");
    if (l.key === "PageDown" || l.key === "Home") {
      const h = u.getBoundingClientRect().top;
      for (const v of d)
        if (v.getBoundingClientRect().top >= h) {
          v.focus();
          break;
        }
    } else {
      const h = u.getBoundingClientRect().bottom;
      for (const v of [...d].reverse())
        if (v.getBoundingClientRect().bottom <= h) {
          v.focus();
          break;
        }
    }
  }
  return {
    onListScroll: r,
    onListKeydown: a
  };
}
const Rx = le({
  chips: Boolean,
  closableChips: Boolean,
  closeText: {
    type: String,
    default: "$vuetify.close"
  },
  openText: {
    type: String,
    default: "$vuetify.open"
  },
  eager: Boolean,
  hideNoData: Boolean,
  hideSelected: Boolean,
  listProps: {
    type: Object
  },
  menu: Boolean,
  menuIcon: {
    type: ot,
    default: "$dropdown"
  },
  menuProps: {
    type: Object
  },
  multiple: Boolean,
  noDataText: {
    type: String,
    default: "$vuetify.noDataText"
  },
  openOnClear: Boolean,
  itemColor: String,
  ...Px({
    itemChildren: !1
  })
}, "Select"), wW = le({
  ...Rx(),
  ...gn(tm({
    modelValue: null,
    role: "combobox"
  }), ["validationValue", "dirty", "appendInnerIcon"]),
  ...$a({
    transition: {
      component: lg
    }
  })
}, "VSelect");
ye()({
  name: "VSelect",
  props: wW(),
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    "update:menu": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      t: i
    } = tn(), r = ie(), o = ie(), a = ie(), l = rt(e, "menu"), u = B({
      get: () => l.value,
      set: (W) => {
        var j;
        l.value && !W && ((j = o.value) != null && j.ΨopenChildren) || (l.value = W);
      }
    }), {
      items: d,
      transformIn: f,
      transformOut: m
    } = Ex(e), h = rt(e, "modelValue", [], (W) => f(W === null ? [null] : en(W)), (W) => {
      const j = m(W);
      return e.multiple ? j : j[0] ?? null;
    }), v = B(() => typeof e.counterValue == "function" ? e.counterValue(h.value) : typeof e.counterValue == "number" ? e.counterValue : h.value.length), y = cg(), p = B(() => h.value.map((W) => W.value)), b = Pe(!1), x = B(() => u.value ? e.closeText : e.openText);
    let _ = "", O;
    const D = B(() => e.hideSelected ? d.value.filter((W) => !h.value.some((j) => e.valueComparator(j, W))) : d.value), F = B(() => e.hideNoData && !D.value.length || e.readonly || (y == null ? void 0 : y.isReadonly.value)), $ = B(() => {
      var W;
      return {
        ...e.menuProps,
        activatorProps: {
          ...((W = e.menuProps) == null ? void 0 : W.activatorProps) || {},
          "aria-haspopup": "listbox"
          // Set aria-haspopup to 'listbox'
        }
      };
    }), A = ie(), {
      onListScroll: k,
      onListKeydown: S
    } = $x(A, r);
    function M(W) {
      e.openOnClear && (u.value = !0);
    }
    function E() {
      F.value || (u.value = !u.value);
    }
    function I(W) {
      var ue, de;
      if (!W.key || e.readonly || y != null && y.isReadonly.value)
        return;
      ["Enter", " ", "ArrowDown", "ArrowUp", "Home", "End"].includes(W.key) && W.preventDefault(), ["Enter", "ArrowDown", " "].includes(W.key) && (u.value = !0), ["Escape", "Tab"].includes(W.key) && (u.value = !1), W.key === "Home" ? (ue = A.value) == null || ue.focus("first") : W.key === "End" && ((de = A.value) == null || de.focus("last"));
      const j = 1e3;
      function U(Q) {
        const J = Q.key.length === 1, re = !Q.ctrlKey && !Q.metaKey && !Q.altKey;
        return J && re;
      }
      if (e.multiple || !U(W))
        return;
      const K = performance.now();
      K - O > j && (_ = ""), _ += W.key.toLowerCase(), O = K;
      const te = d.value.find((Q) => Q.title.toLowerCase().startsWith(_));
      if (te !== void 0) {
        h.value = [te];
        const Q = D.value.indexOf(te);
        ft && window.requestAnimationFrame(() => {
          var J;
          Q >= 0 && ((J = a.value) == null || J.scrollToIndex(Q));
        });
      }
    }
    function L(W) {
      let j = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (!W.props.disabled)
        if (e.multiple) {
          const U = h.value.findIndex((te) => e.valueComparator(te.value, W.value)), K = j ?? !~U;
          if (~U) {
            const te = K ? [...h.value, W] : [...h.value];
            te.splice(U, 1), h.value = te;
          } else
            K && (h.value = [...h.value, W]);
        } else {
          const U = j !== !1;
          h.value = U ? [W] : [], gt(() => {
            u.value = !1;
          });
        }
    }
    function N(W) {
      var j;
      (j = A.value) != null && j.$el.contains(W.relatedTarget) || (u.value = !1);
    }
    function V() {
      var W;
      b.value && ((W = r.value) == null || W.focus());
    }
    function z(W) {
      b.value = !0;
    }
    function H(W) {
      if (W == null)
        h.value = [];
      else if (qu(r.value, ":autofill") || qu(r.value, ":-webkit-autofill")) {
        const j = d.value.find((U) => U.title === W);
        j && L(j);
      } else
        r.value && (r.value.value = "");
    }
    return pe(u, () => {
      if (!e.hideSelected && u.value && h.value.length) {
        const W = D.value.findIndex((j) => h.value.some((U) => e.valueComparator(U.value, j.value)));
        ft && window.requestAnimationFrame(() => {
          var j;
          W >= 0 && ((j = a.value) == null || j.scrollToIndex(W));
        });
      }
    }), pe(() => e.items, (W, j) => {
      u.value || b.value && !j.length && W.length && (u.value = !0);
    }), Oe(() => {
      const W = !!(e.chips || n.chip), j = !!(!e.hideNoData || D.value.length || n["prepend-item"] || n["append-item"] || n["no-data"]), U = h.value.length > 0, K = Zs.filterProps(e), te = U || !b.value && e.label && !e.persistentPlaceholder ? void 0 : e.placeholder;
      return T(Zs, ge({
        ref: r
      }, K, {
        modelValue: h.value.map((ue) => ue.props.value).join(", "),
        "onUpdate:modelValue": H,
        focused: b.value,
        "onUpdate:focused": (ue) => b.value = ue,
        validationValue: h.externalValue,
        counterValue: v.value,
        dirty: U,
        class: ["v-select", {
          "v-select--active-menu": u.value,
          "v-select--chips": !!e.chips,
          [`v-select--${e.multiple ? "multiple" : "single"}`]: !0,
          "v-select--selected": h.value.length,
          "v-select--selection-slot": !!n.selection
        }, e.class],
        style: e.style,
        inputmode: "none",
        placeholder: te,
        "onClick:clear": M,
        "onMousedown:control": E,
        onBlur: N,
        onKeydown: I,
        "aria-label": i(x.value),
        title: i(x.value)
      }), {
        ...n,
        default: () => T(qe, null, [T(K1, ge({
          ref: o,
          modelValue: u.value,
          "onUpdate:modelValue": (ue) => u.value = ue,
          activator: "parent",
          contentClass: "v-select__content",
          disabled: F.value,
          eager: e.eager,
          maxHeight: 310,
          openOnClick: !1,
          closeOnContentClick: !1,
          transition: e.transition,
          onAfterLeave: V
        }, $.value), {
          default: () => [j && T(Dx, ge({
            ref: A,
            selected: p.value,
            selectStrategy: e.multiple ? "independent" : "single-independent",
            onMousedown: (ue) => ue.preventDefault(),
            onKeydown: S,
            onFocusin: z,
            onScrollPassive: k,
            tabindex: "-1",
            "aria-live": "polite",
            color: e.itemColor ?? e.color
          }, e.listProps), {
            default: () => {
              var ue, de, Q;
              return [(ue = n["prepend-item"]) == null ? void 0 : ue.call(n), !D.value.length && !e.hideNoData && (((de = n["no-data"]) == null ? void 0 : de.call(n)) ?? T(La, {
                title: i(e.noDataText)
              }, null)), T(Vx, {
                ref: a,
                renderless: !0,
                items: D.value
              }, {
                default: (J) => {
                  var nt;
                  let {
                    item: re,
                    index: me,
                    itemRef: xe
                  } = J;
                  const tt = ge(re.props, {
                    ref: xe,
                    key: me,
                    onClick: () => L(re, null)
                  });
                  return ((nt = n.item) == null ? void 0 : nt.call(n, {
                    item: re,
                    index: me,
                    props: tt
                  })) ?? T(La, ge(tt, {
                    role: "option"
                  }), {
                    prepend: (fe) => {
                      let {
                        isSelected: be
                      } = fe;
                      return T(qe, null, [e.multiple && !e.hideSelected ? T(nc, {
                        key: re.value,
                        modelValue: be,
                        ripple: !1,
                        tabindex: "-1"
                      }, null) : void 0, re.props.prependAvatar && T(fr, {
                        image: re.props.prependAvatar
                      }, null), re.props.prependIcon && T(At, {
                        icon: re.props.prependIcon
                      }, null)]);
                    }
                  });
                }
              }), (Q = n["append-item"]) == null ? void 0 : Q.call(n)];
            }
          })]
        }), h.value.map((ue, de) => {
          function Q(xe) {
            xe.stopPropagation(), xe.preventDefault(), L(ue, !1);
          }
          const J = {
            "onClick:close": Q,
            onKeydown(xe) {
              xe.key !== "Enter" && xe.key !== " " || (xe.preventDefault(), xe.stopPropagation(), Q(xe));
            },
            onMousedown(xe) {
              xe.preventDefault(), xe.stopPropagation();
            },
            modelValue: !0,
            "onUpdate:modelValue": void 0
          }, re = W ? !!n.chip : !!n.selection, me = re ? Gh(W ? n.chip({
            item: ue,
            index: de,
            props: J
          }) : n.selection({
            item: ue,
            index: de
          })) : void 0;
          if (!(re && !me))
            return T("div", {
              key: ue.value,
              class: "v-select__selection"
            }, [W ? n.chip ? T(pt, {
              key: "chip-defaults",
              defaults: {
                VChip: {
                  closable: e.closableChips,
                  size: "small",
                  text: ue.title
                }
              }
            }, {
              default: () => [me]
            }) : T(wx, ge({
              key: "chip",
              closable: e.closableChips,
              size: "small",
              text: ue.title,
              disabled: ue.props.disabled
            }, J), null) : me ?? T("span", {
              class: "v-select__selection-text"
            }, [ue.title, e.multiple && de < h.value.length - 1 && T("span", {
              class: "v-select__selection-comma"
            }, [dr(",")])])]);
        })]),
        "append-inner": function() {
          var J;
          for (var ue = arguments.length, de = new Array(ue), Q = 0; Q < ue; Q++)
            de[Q] = arguments[Q];
          return T(qe, null, [(J = n["append-inner"]) == null ? void 0 : J.call(n, ...de), e.menuIcon ? T(At, {
            class: "v-select__menu-icon",
            icon: e.menuIcon
          }, null) : void 0]);
        }
      });
    }), Qr({
      isFocused: b,
      menu: u,
      select: L
    }, r);
  }
});
const _W = (e, t, n) => e == null || t == null ? -1 : e.toString().toLocaleLowerCase().indexOf(t.toString().toLocaleLowerCase()), xW = le({
  customFilter: Function,
  customKeyFilter: Object,
  filterKeys: [Array, String],
  filterMode: {
    type: String,
    default: "intersection"
  },
  noFilter: Boolean
}, "filter");
function kW(e, t, n) {
  var l;
  const i = [], r = (n == null ? void 0 : n.default) ?? _W, o = n != null && n.filterKeys ? en(n.filterKeys) : !1, a = Object.keys((n == null ? void 0 : n.customKeyFilter) ?? {}).length;
  if (!(e != null && e.length))
    return i;
  e:
    for (let u = 0; u < e.length; u++) {
      const [d, f = d] = en(e[u]), m = {}, h = {};
      let v = -1;
      if (t && !(n != null && n.noFilter)) {
        if (typeof d == "object") {
          const b = o || Object.keys(f);
          for (const x of b) {
            const _ = hi(f, x), O = (l = n == null ? void 0 : n.customKeyFilter) == null ? void 0 : l[x];
            if (v = O ? O(_, t, d) : r(_, t, d), v !== -1 && v !== !1)
              O ? m[x] = v : h[x] = v;
            else if ((n == null ? void 0 : n.filterMode) === "every")
              continue e;
          }
        } else
          v = r(d, t, d), v !== -1 && v !== !1 && (h.title = v);
        const y = Object.keys(h).length, p = Object.keys(m).length;
        if (!y && !p || (n == null ? void 0 : n.filterMode) === "union" && p !== a && !y || (n == null ? void 0 : n.filterMode) === "intersection" && (p !== a || !y))
          continue;
      }
      i.push({
        index: u,
        matches: {
          ...h,
          ...m
        }
      });
    }
  return i;
}
function SW(e, t, n, i) {
  const r = ie([]), o = ie(/* @__PURE__ */ new Map()), a = B(() => i != null && i.transform ? Be(t).map((u) => [u, i.transform(u)]) : Be(t));
  Ln(() => {
    const u = typeof n == "function" ? n() : Be(n), d = typeof u != "string" && typeof u != "number" ? "" : String(u), f = kW(a.value, d, {
      customKeyFilter: {
        ...e.customKeyFilter,
        ...Be(i == null ? void 0 : i.customKeyFilter)
      },
      default: e.customFilter,
      filterKeys: e.filterKeys,
      filterMode: e.filterMode,
      noFilter: e.noFilter
    }), m = Be(t), h = [], v = /* @__PURE__ */ new Map();
    f.forEach((y) => {
      let {
        index: p,
        matches: b
      } = y;
      const x = m[p];
      h.push(x), v.set(x.value, b);
    }), r.value = h, o.value = v;
  });
  function l(u) {
    return o.value.get(u.value);
  }
  return {
    filteredItems: r,
    filteredMatches: o,
    getMatches: l
  };
}
function CW(e, t, n) {
  if (t == null)
    return e;
  if (Array.isArray(t))
    throw new Error("Multiple matches is not implemented");
  return typeof t == "number" && ~t ? T(qe, null, [T("span", {
    class: "v-combobox__unmask"
  }, [e.substr(0, t)]), T("span", {
    class: "v-combobox__mask"
  }, [e.substr(t, n)]), T("span", {
    class: "v-combobox__unmask"
  }, [e.substr(t + n)])]) : e;
}
const OW = le({
  autoSelectFirst: {
    type: [Boolean, String]
  },
  clearOnSelect: {
    type: Boolean,
    default: !0
  },
  delimiters: Array,
  ...xW({
    filterKeys: ["title"]
  }),
  ...Rx({
    hideNoData: !0,
    returnObject: !0
  }),
  ...gn(tm({
    modelValue: null,
    role: "combobox"
  }), ["validationValue", "dirty", "appendInnerIcon"]),
  ...$a({
    transition: !1
  })
}, "VCombobox"), MW = ye()({
  name: "VCombobox",
  props: OW(),
  emits: {
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0,
    "update:search": (e) => !0,
    "update:menu": (e) => !0
  },
  setup(e, t) {
    var nt;
    let {
      emit: n,
      slots: i
    } = t;
    const {
      t: r
    } = tn(), o = ie(), a = Pe(!1), l = Pe(!0), u = Pe(!1), d = ie(), f = ie(), m = rt(e, "menu"), h = B({
      get: () => m.value,
      set: (fe) => {
        var be;
        m.value && !fe && ((be = d.value) != null && be.ΨopenChildren) || (m.value = fe);
      }
    }), v = Pe(-1);
    let y = !1;
    const p = B(() => {
      var fe;
      return (fe = o.value) == null ? void 0 : fe.color;
    }), b = B(() => h.value ? e.closeText : e.openText), {
      items: x,
      transformIn: _,
      transformOut: O
    } = Ex(e), {
      textColorClasses: D,
      textColorStyles: F
    } = Fi(p), $ = rt(e, "modelValue", [], (fe) => _(en(fe)), (fe) => {
      const be = O(fe);
      return e.multiple ? be : be[0] ?? null;
    }), A = cg(), k = B(() => !!(e.chips || i.chip)), S = B(() => k.value || !!i.selection), M = Pe(!e.multiple && !S.value ? ((nt = $.value[0]) == null ? void 0 : nt.title) ?? "" : ""), E = B({
      get: () => M.value,
      set: (fe) => {
        var be;
        if (M.value = fe ?? "", !e.multiple && !S.value && ($.value = [Br(e, fe)]), fe && e.multiple && ((be = e.delimiters) != null && be.length)) {
          const Ee = fe.split(new RegExp(`(?:${e.delimiters.join("|")})+`));
          Ee.length > 1 && (Ee.forEach((ke) => {
            ke = ke.trim(), ke && re(Br(e, ke));
          }), M.value = "");
        }
        fe || (v.value = -1), l.value = !fe;
      }
    }), I = B(() => typeof e.counterValue == "function" ? e.counterValue($.value) : typeof e.counterValue == "number" ? e.counterValue : e.multiple ? $.value.length : E.value.length);
    pe(M, (fe) => {
      y ? gt(() => y = !1) : a.value && !h.value && (h.value = !0), n("update:search", fe);
    }), pe($, (fe) => {
      var be;
      !e.multiple && !S.value && (M.value = ((be = fe[0]) == null ? void 0 : be.title) ?? "");
    });
    const {
      filteredItems: L,
      getMatches: N
    } = SW(e, x, () => l.value ? "" : E.value), V = B(() => e.hideSelected ? L.value.filter((fe) => !$.value.some((be) => be.value === fe.value)) : L.value), z = B(() => $.value.map((fe) => fe.value)), H = B(() => {
      var be;
      return (e.autoSelectFirst === !0 || e.autoSelectFirst === "exact" && E.value === ((be = V.value[0]) == null ? void 0 : be.title)) && V.value.length > 0 && !l.value && !u.value;
    }), W = B(() => e.hideNoData && !V.value.length || e.readonly || (A == null ? void 0 : A.isReadonly.value)), j = ie(), {
      onListScroll: U,
      onListKeydown: K
    } = $x(j, o);
    function te(fe) {
      y = !0, e.openOnClear && (h.value = !0);
    }
    function ue() {
      W.value || (h.value = !0);
    }
    function de(fe) {
      W.value || (a.value && (fe.preventDefault(), fe.stopPropagation()), h.value = !h.value);
    }
    function Q(fe) {
      var ke;
      if (PP(fe) || e.readonly || A != null && A.isReadonly.value)
        return;
      const be = o.value.selectionStart, Ee = $.value.length;
      if ((v.value > -1 || ["Enter", "ArrowDown", "ArrowUp"].includes(fe.key)) && fe.preventDefault(), ["Enter", "ArrowDown"].includes(fe.key) && (h.value = !0), ["Escape"].includes(fe.key) && (h.value = !1), ["Enter", "Escape"].includes(fe.key) && (H.value && fe.key === "Enter" && re(L.value[0]), l.value = !0), fe.key === "ArrowDown" && H.value && ((ke = j.value) == null || ke.focus("next")), fe.key === "Enter" && E.value && (re(Br(e, E.value)), S.value && (M.value = "")), ["Backspace", "Delete"].includes(fe.key)) {
        if (!e.multiple && S.value && $.value.length > 0 && !E.value)
          return re($.value[0], !1);
        if (~v.value) {
          const at = v.value;
          re($.value[v.value], !1), v.value = at >= Ee - 1 ? Ee - 2 : at;
        } else
          fe.key === "Backspace" && !E.value && (v.value = Ee - 1);
      }
      if (e.multiple) {
        if (fe.key === "ArrowLeft") {
          if (v.value < 0 && be > 0)
            return;
          const at = v.value > -1 ? v.value - 1 : Ee - 1;
          $.value[at] ? v.value = at : (v.value = -1, o.value.setSelectionRange(E.value.length, E.value.length));
        }
        if (fe.key === "ArrowRight") {
          if (v.value < 0)
            return;
          const at = v.value + 1;
          $.value[at] ? v.value = at : (v.value = -1, o.value.setSelectionRange(0, 0));
        }
      }
    }
    function J() {
      var fe;
      a.value && (l.value = !0, (fe = o.value) == null || fe.focus());
    }
    function re(fe) {
      let be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      if (!(!fe || fe.props.disabled))
        if (e.multiple) {
          const Ee = $.value.findIndex((at) => e.valueComparator(at.value, fe.value)), ke = be ?? !~Ee;
          if (~Ee) {
            const at = ke ? [...$.value, fe] : [...$.value];
            at.splice(Ee, 1), $.value = at;
          } else
            ke && ($.value = [...$.value, fe]);
          e.clearOnSelect && (E.value = "");
        } else {
          const Ee = be !== !1;
          $.value = Ee ? [fe] : [], M.value = Ee && !S.value ? fe.title : "", gt(() => {
            h.value = !1, l.value = !0;
          });
        }
    }
    function me(fe) {
      a.value = !0, setTimeout(() => {
        u.value = !0;
      });
    }
    function xe(fe) {
      u.value = !1;
    }
    function tt(fe) {
      (fe == null || fe === "" && !e.multiple && !S.value) && ($.value = []);
    }
    return pe(a, (fe, be) => {
      if (!(fe || fe === be)) {
        if (v.value = -1, h.value = !1, H.value && !u.value && !$.value.some((Ee) => {
          let {
            value: ke
          } = Ee;
          return ke === V.value[0].value;
        })) {
          re(V.value[0]);
          return;
        }
        if (E.value) {
          if (e.multiple) {
            re(Br(e, E.value));
            return;
          }
          if (!S.value)
            return;
          $.value.some((Ee) => {
            let {
              title: ke
            } = Ee;
            return ke === E.value;
          }) ? M.value = "" : re(Br(e, E.value));
        }
      }
    }), pe(h, () => {
      if (!e.hideSelected && h.value && $.value.length) {
        const fe = V.value.findIndex((be) => $.value.some((Ee) => e.valueComparator(Ee.value, be.value)));
        ft && window.requestAnimationFrame(() => {
          var be;
          fe >= 0 && ((be = f.value) == null || be.scrollToIndex(fe));
        });
      }
    }), pe(() => e.items, (fe, be) => {
      h.value || a.value && !be.length && fe.length && (h.value = !0);
    }), Oe(() => {
      const fe = !!(!e.hideNoData || V.value.length || i["prepend-item"] || i["append-item"] || i["no-data"]), be = $.value.length > 0, Ee = Zs.filterProps(e);
      return T(Zs, ge({
        ref: o
      }, Ee, {
        modelValue: E.value,
        "onUpdate:modelValue": [(ke) => E.value = ke, tt],
        focused: a.value,
        "onUpdate:focused": (ke) => a.value = ke,
        validationValue: $.externalValue,
        counterValue: I.value,
        dirty: be,
        class: ["v-combobox", {
          "v-combobox--active-menu": h.value,
          "v-combobox--chips": !!e.chips,
          "v-combobox--selection-slot": !!S.value,
          "v-combobox--selecting-index": v.value > -1,
          [`v-combobox--${e.multiple ? "multiple" : "single"}`]: !0
        }, e.class],
        style: e.style,
        readonly: e.readonly,
        placeholder: be ? void 0 : e.placeholder,
        "onClick:clear": te,
        "onMousedown:control": ue,
        onKeydown: Q
      }), {
        ...i,
        default: () => T(qe, null, [T(K1, ge({
          ref: d,
          modelValue: h.value,
          "onUpdate:modelValue": (ke) => h.value = ke,
          activator: "parent",
          contentClass: "v-combobox__content",
          disabled: W.value,
          eager: e.eager,
          maxHeight: 310,
          openOnClick: !1,
          closeOnContentClick: !1,
          transition: e.transition,
          onAfterLeave: J
        }, e.menuProps), {
          default: () => [fe && T(Dx, ge({
            ref: j,
            selected: z.value,
            selectStrategy: e.multiple ? "independent" : "single-independent",
            onMousedown: (ke) => ke.preventDefault(),
            onKeydown: K,
            onFocusin: me,
            onFocusout: xe,
            onScrollPassive: U,
            tabindex: "-1",
            "aria-live": "polite",
            color: e.itemColor ?? e.color
          }, e.listProps), {
            default: () => {
              var ke, at, xn;
              return [(ke = i["prepend-item"]) == null ? void 0 : ke.call(i), !V.value.length && !e.hideNoData && (((at = i["no-data"]) == null ? void 0 : at.call(i)) ?? T(La, {
                title: r(e.noDataText)
              }, null)), T(Vx, {
                ref: f,
                renderless: !0,
                items: V.value
              }, {
                default: (vi) => {
                  var nn;
                  let {
                    item: Y,
                    index: pi,
                    itemRef: Ht
                  } = vi;
                  const jo = ge(Y.props, {
                    ref: Ht,
                    key: pi,
                    active: H.value && pi === 0 ? !0 : void 0,
                    onClick: () => re(Y, null)
                  });
                  return ((nn = i.item) == null ? void 0 : nn.call(i, {
                    item: Y,
                    index: pi,
                    props: jo
                  })) ?? T(La, ge(jo, {
                    role: "option"
                  }), {
                    prepend: (vr) => {
                      let {
                        isSelected: yi
                      } = vr;
                      return T(qe, null, [e.multiple && !e.hideSelected ? T(nc, {
                        key: Y.value,
                        modelValue: yi,
                        ripple: !1,
                        tabindex: "-1"
                      }, null) : void 0, Y.props.prependAvatar && T(fr, {
                        image: Y.props.prependAvatar
                      }, null), Y.props.prependIcon && T(At, {
                        icon: Y.props.prependIcon
                      }, null)]);
                    },
                    title: () => {
                      var vr, yi;
                      return l.value ? Y.title : CW(Y.title, (vr = N(Y)) == null ? void 0 : vr.title, ((yi = E.value) == null ? void 0 : yi.length) ?? 0);
                    }
                  });
                }
              }), (xn = i["append-item"]) == null ? void 0 : xn.call(i)];
            }
          })]
        }), $.value.map((ke, at) => {
          function xn(Ht) {
            Ht.stopPropagation(), Ht.preventDefault(), re(ke, !1);
          }
          const vi = {
            "onClick:close": xn,
            onKeydown(Ht) {
              Ht.key !== "Enter" && Ht.key !== " " || (Ht.preventDefault(), Ht.stopPropagation(), xn(Ht));
            },
            onMousedown(Ht) {
              Ht.preventDefault(), Ht.stopPropagation();
            },
            modelValue: !0,
            "onUpdate:modelValue": void 0
          }, Y = k.value ? !!i.chip : !!i.selection, pi = Y ? Gh(k.value ? i.chip({
            item: ke,
            index: at,
            props: vi
          }) : i.selection({
            item: ke,
            index: at
          })) : void 0;
          if (!(Y && !pi))
            return T("div", {
              key: ke.value,
              class: ["v-combobox__selection", at === v.value && ["v-combobox__selection--selected", D.value]],
              style: at === v.value ? F.value : {}
            }, [k.value ? i.chip ? T(pt, {
              key: "chip-defaults",
              defaults: {
                VChip: {
                  closable: e.closableChips,
                  size: "small",
                  text: ke.title
                }
              }
            }, {
              default: () => [pi]
            }) : T(wx, ge({
              key: "chip",
              closable: e.closableChips,
              size: "small",
              text: ke.title,
              disabled: ke.props.disabled
            }, vi), null) : pi ?? T("span", {
              class: "v-combobox__selection-text"
            }, [ke.title, e.multiple && at < $.value.length - 1 && T("span", {
              class: "v-combobox__selection-comma"
            }, [dr(",")])])]);
        })]),
        "append-inner": function() {
          var vi;
          for (var ke = arguments.length, at = new Array(ke), xn = 0; xn < ke; xn++)
            at[xn] = arguments[xn];
          return T(qe, null, [(vi = i["append-inner"]) == null ? void 0 : vi.call(i, ...at), (!e.hideNoData || e.items.length) && e.menuIcon ? T(At, {
            class: "v-combobox__menu-icon",
            icon: e.menuIcon,
            onMousedown: de,
            onClick: DP,
            "aria-label": r(b.value),
            title: r(b.value),
            tabindex: "-1"
          }, null) : void 0]);
        }
      });
    }), Qr({
      isFocused: a,
      isPristine: l,
      menu: h,
      search: E,
      selectionIndex: v,
      filteredItems: L,
      select: re
    }, o);
  }
}), TW = {
  name: "OtSelectV",
  customOptions: {}
}, _7 = /* @__PURE__ */ Ae({
  ...TW,
  props: {
    label: { type: String, required: !0 },
    warning: { type: Boolean, default: !1 },
    state: {
      type: String,
      default: "default"
    }
  },
  setup(e) {
    const t = e, n = B(() => ["warning", "error"].includes(t.state));
    return (i, r) => (ee(), Ne(MW, ge({
      variant: "outlined",
      class: ["ot-select-v", { "ot-select-v--warning": e.state === "warning" }]
    }, i.$attrs, {
      label: e.label,
      color: "primary",
      "base-color": "text-tertiary",
      error: n.value
    }), Cc({ _: 2 }, [
      Dn(i.$slots, (o, a) => ({
        name: a,
        fn: Ye((l) => [
          De(i.$slots, a, zt(Qt(l)))
        ])
      }))
    ]), 1040, ["class", "label", "error"]));
  }
});
function hb(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Lr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hb(Object(n), !0).forEach(function(i) {
      PW(e, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : hb(Object(n)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return e;
}
function PW(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function gb(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return Object.keys(e).reduce((n, i) => (t.includes(i) || (n[i] = Be(e[i])), n), {});
}
function xc(e) {
  return typeof e == "function";
}
function AW(e) {
  return SP(e) || CP(e);
}
function Fx(e, t, n) {
  let i = e;
  const r = t.split(".");
  for (let o = 0; o < r.length; o++) {
    if (!i[r[o]])
      return n;
    i = i[r[o]];
  }
  return i;
}
function eh(e, t, n) {
  return B(() => e.some((i) => Fx(t, i, {
    [n]: !1
  })[n]));
}
function mb(e, t, n) {
  return B(() => e.reduce((i, r) => {
    const o = Fx(t, r, {
      [n]: !1
    })[n] || [];
    return i.concat(o);
  }, []));
}
function Nx(e, t, n, i) {
  return e.call(i, Be(t), Be(n), i);
}
function Wx(e) {
  return e.$valid !== void 0 ? !e.$valid : !e;
}
function EW(e, t, n, i, r, o, a) {
  let {
    $lazy: l,
    $rewardEarly: u
  } = r, d = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : [], f = arguments.length > 8 ? arguments[8] : void 0, m = arguments.length > 9 ? arguments[9] : void 0, h = arguments.length > 10 ? arguments[10] : void 0;
  const v = ie(!!i.value), y = ie(0);
  n.value = !1;
  const p = pe([t, i].concat(d, h), () => {
    if (l && !i.value || u && !m.value && !n.value)
      return;
    let b;
    try {
      b = Nx(e, t, f, a);
    } catch (x) {
      b = Promise.reject(x);
    }
    y.value++, n.value = !!y.value, v.value = !1, Promise.resolve(b).then((x) => {
      y.value--, n.value = !!y.value, o.value = x, v.value = Wx(x);
    }).catch((x) => {
      y.value--, n.value = !!y.value, o.value = x, v.value = !0;
    });
  }, {
    immediate: !0,
    deep: typeof t == "object"
  });
  return {
    $invalid: v,
    $unwatch: p
  };
}
function IW(e, t, n, i, r, o, a, l) {
  let {
    $lazy: u,
    $rewardEarly: d
  } = i;
  const f = () => ({}), m = B(() => {
    if (u && !n.value || d && !l.value)
      return !1;
    let h = !0;
    try {
      const v = Nx(e, t, a, o);
      r.value = v, h = Wx(v);
    } catch (v) {
      r.value = v;
    }
    return h;
  });
  return {
    $unwatch: f,
    $invalid: m
  };
}
function DW(e, t, n, i, r, o, a, l, u, d, f) {
  const m = ie(!1), h = e.$params || {}, v = ie(null);
  let y, p;
  e.$async ? {
    $invalid: y,
    $unwatch: p
  } = EW(e.$validator, t, m, n, i, v, r, e.$watchTargets, u, d, f) : {
    $invalid: y,
    $unwatch: p
  } = IW(e.$validator, t, n, i, v, r, u, d);
  const b = e.$message;
  return {
    $message: xc(b) ? B(() => b(gb({
      $pending: m,
      $invalid: y,
      $params: gb(h),
      $model: t,
      $response: v,
      $validator: o,
      $propertyPath: l,
      $property: a
    }))) : b || "",
    $params: h,
    $pending: m,
    $invalid: y,
    $response: v,
    $unwatch: p
  };
}
function LW() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const t = Be(e), n = Object.keys(t), i = {}, r = {}, o = {};
  let a = null;
  return n.forEach((l) => {
    const u = t[l];
    switch (!0) {
      case xc(u.$validator):
        i[l] = u;
        break;
      case xc(u):
        i[l] = {
          $validator: u
        };
        break;
      case l === "$validationGroups":
        a = u;
        break;
      case l.startsWith("$"):
        o[l] = u;
        break;
      default:
        r[l] = u;
    }
  }), {
    rules: i,
    nestedValidators: r,
    config: o,
    validationGroups: a
  };
}
const BW = "__root";
function VW(e, t, n, i, r, o, a, l, u) {
  const d = Object.keys(e), f = i.get(r, e), m = ie(!1), h = ie(!1), v = ie(0);
  if (f) {
    if (!f.$partial)
      return f;
    f.$unwatch(), m.value = f.$dirty.value;
  }
  const y = {
    $dirty: m,
    $path: r,
    $touch: () => {
      m.value || (m.value = !0);
    },
    $reset: () => {
      m.value && (m.value = !1);
    },
    $commit: () => {
    }
  };
  return d.length ? (d.forEach((p) => {
    y[p] = DW(e[p], t, y.$dirty, o, a, p, n, r, u, h, v);
  }), y.$externalResults = B(() => l.value ? [].concat(l.value).map((p, b) => ({
    $propertyPath: r,
    $property: n,
    $validator: "$externalResults",
    $uid: `${r}-externalResult-${b}`,
    $message: p,
    $params: {},
    $response: null,
    $pending: !1
  })) : []), y.$invalid = B(() => {
    const p = d.some((b) => Be(y[b].$invalid));
    return h.value = p, !!y.$externalResults.value.length || p;
  }), y.$pending = B(() => d.some((p) => Be(y[p].$pending))), y.$error = B(() => y.$dirty.value ? y.$pending.value || y.$invalid.value : !1), y.$silentErrors = B(() => d.filter((p) => Be(y[p].$invalid)).map((p) => {
    const b = y[p];
    return mi({
      $propertyPath: r,
      $property: n,
      $validator: p,
      $uid: `${r}-${p}`,
      $message: b.$message,
      $params: b.$params,
      $response: b.$response,
      $pending: b.$pending
    });
  }).concat(y.$externalResults.value)), y.$errors = B(() => y.$dirty.value ? y.$silentErrors.value : []), y.$unwatch = () => d.forEach((p) => {
    y[p].$unwatch();
  }), y.$commit = () => {
    h.value = !0, v.value = Date.now();
  }, i.set(r, e, y), y) : (f && i.set(r, e, y), y);
}
function $W(e, t, n, i, r, o, a) {
  const l = Object.keys(e);
  return l.length ? l.reduce((u, d) => (u[d] = Rh({
    validations: e[d],
    state: t,
    key: d,
    parentKey: n,
    resultsCache: i,
    globalConfig: r,
    instance: o,
    externalResults: a
  }), u), {}) : {};
}
function RW(e, t, n) {
  const i = B(() => [t, n].filter((y) => y).reduce((y, p) => y.concat(Object.values(Be(p))), [])), r = B({
    get() {
      return e.$dirty.value || (i.value.length ? i.value.every((y) => y.$dirty) : !1);
    },
    set(y) {
      e.$dirty.value = y;
    }
  }), o = B(() => {
    const y = Be(e.$silentErrors) || [], p = i.value.filter((b) => (Be(b).$silentErrors || []).length).reduce((b, x) => b.concat(...x.$silentErrors), []);
    return y.concat(p);
  }), a = B(() => {
    const y = Be(e.$errors) || [], p = i.value.filter((b) => (Be(b).$errors || []).length).reduce((b, x) => b.concat(...x.$errors), []);
    return y.concat(p);
  }), l = B(() => i.value.some((y) => y.$invalid) || Be(e.$invalid) || !1), u = B(() => i.value.some((y) => Be(y.$pending)) || Be(e.$pending) || !1), d = B(() => i.value.some((y) => y.$dirty) || i.value.some((y) => y.$anyDirty) || r.value), f = B(() => r.value ? u.value || l.value : !1), m = () => {
    e.$touch(), i.value.forEach((y) => {
      y.$touch();
    });
  }, h = () => {
    e.$commit(), i.value.forEach((y) => {
      y.$commit();
    });
  }, v = () => {
    e.$reset(), i.value.forEach((y) => {
      y.$reset();
    });
  };
  return i.value.length && i.value.every((y) => y.$dirty) && m(), {
    $dirty: r,
    $errors: a,
    $invalid: l,
    $anyDirty: d,
    $error: f,
    $pending: u,
    $touch: m,
    $reset: v,
    $silentErrors: o,
    $commit: h
  };
}
function Rh(e) {
  let {
    validations: t,
    state: n,
    key: i,
    parentKey: r,
    childResults: o,
    resultsCache: a,
    globalConfig: l = {},
    instance: u,
    externalResults: d
  } = e;
  const f = r ? `${r}.${i}` : i, {
    rules: m,
    nestedValidators: h,
    config: v,
    validationGroups: y
  } = LW(t), p = Lr(Lr({}, l), v), b = i ? B(() => {
    const U = Be(n);
    return U ? Be(U[i]) : void 0;
  }) : n, x = Lr({}, Be(d) || {}), _ = B(() => {
    const U = Be(d);
    return i ? U ? Be(U[i]) : void 0 : U;
  }), O = VW(m, b, i, a, f, p, u, _, n), D = $W(h, b, f, a, p, u, _), F = {};
  y && Object.entries(y).forEach((U) => {
    let [K, te] = U;
    F[K] = {
      $invalid: eh(te, D, "$invalid"),
      $error: eh(te, D, "$error"),
      $pending: eh(te, D, "$pending"),
      $errors: mb(te, D, "$errors"),
      $silentErrors: mb(te, D, "$silentErrors")
    };
  });
  const {
    $dirty: $,
    $errors: A,
    $invalid: k,
    $anyDirty: S,
    $error: M,
    $pending: E,
    $touch: I,
    $reset: L,
    $silentErrors: N,
    $commit: V
  } = RW(O, D, o), z = i ? B({
    get: () => Be(b),
    set: (U) => {
      $.value = !0;
      const K = Be(n), te = Be(d);
      te && (te[i] = x[i]), cr(K[i]) ? K[i].value = U : K[i] = U;
    }
  }) : null;
  i && p.$autoDirty && pe(b, () => {
    $.value || I();
    const U = Be(d);
    U && (U[i] = x[i]);
  }, {
    flush: "sync"
  });
  async function H() {
    return I(), p.$rewardEarly && (V(), await gt()), await gt(), new Promise((U) => {
      if (!E.value)
        return U(!k.value);
      const K = pe(E, () => {
        U(!k.value), K();
      });
    });
  }
  function W(U) {
    return (o.value || {})[U];
  }
  function j() {
    cr(d) ? d.value = x : Object.keys(x).length === 0 ? Object.keys(d).forEach((U) => {
      delete d[U];
    }) : Object.assign(d, x);
  }
  return mi(Lr(Lr(Lr({}, O), {}, {
    $model: z,
    $dirty: $,
    $error: M,
    $errors: A,
    $invalid: k,
    $anyDirty: S,
    $pending: E,
    $touch: I,
    $reset: L,
    $path: f || BW,
    $silentErrors: N,
    $validate: H,
    $commit: V
  }, o && {
    $getResultsForChild: W,
    $clearExternalResults: j,
    $validationGroups: F
  }), D));
}
class FW {
  constructor() {
    this.storage = /* @__PURE__ */ new Map();
  }
  set(t, n, i) {
    this.storage.set(t, {
      rules: n,
      result: i
    });
  }
  checkRulesValidity(t, n, i) {
    const r = Object.keys(i), o = Object.keys(n);
    return o.length !== r.length || !o.every((l) => r.includes(l)) ? !1 : o.every((l) => n[l].$params ? Object.keys(n[l].$params).every((u) => Be(i[l].$params[u]) === Be(n[l].$params[u])) : !0);
  }
  get(t, n) {
    const i = this.storage.get(t);
    if (!i)
      return;
    const {
      rules: r,
      result: o
    } = i, a = this.checkRulesValidity(t, n, r), l = o.$unwatch ? o.$unwatch : () => ({});
    return a ? o : {
      $dirty: o.$dirty,
      $partial: !0,
      $unwatch: l
    };
  }
}
const zu = {
  COLLECT_ALL: !0,
  COLLECT_NONE: !1
}, vb = Symbol("vuelidate#injectChildResults"), pb = Symbol("vuelidate#removeChildResults");
function NW(e) {
  let {
    $scope: t,
    instance: n
  } = e;
  const i = {}, r = ie([]), o = B(() => r.value.reduce((f, m) => (f[m] = Be(i[m]), f), {}));
  function a(f, m) {
    let {
      $registerAs: h,
      $scope: v,
      $stopPropagation: y
    } = m;
    y || t === zu.COLLECT_NONE || v === zu.COLLECT_NONE || t !== zu.COLLECT_ALL && t !== v || (i[h] = f, r.value.push(h));
  }
  n.__vuelidateInjectInstances = [].concat(n.__vuelidateInjectInstances || [], a);
  function l(f) {
    r.value = r.value.filter((m) => m !== f), delete i[f];
  }
  n.__vuelidateRemoveInstances = [].concat(n.__vuelidateRemoveInstances || [], l);
  const u = ht(vb, []);
  sn(vb, n.__vuelidateInjectInstances);
  const d = ht(pb, []);
  return sn(pb, n.__vuelidateRemoveInstances), {
    childResults: o,
    sendValidationResultsToParent: u,
    removeValidationResultsFromParent: d
  };
}
function zx(e) {
  return new Proxy(e, {
    get(t, n) {
      return typeof t[n] == "object" ? zx(t[n]) : B(() => t[n]);
    }
  });
}
let yb = 0;
function WW(e, t) {
  var n;
  let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  arguments.length === 1 && (i = e, e = void 0, t = void 0);
  let {
    $registerAs: r,
    $scope: o = zu.COLLECT_ALL,
    $stopPropagation: a,
    $externalResults: l,
    currentVueInstance: u
  } = i;
  const d = u || ((n = Mb()) === null || n === void 0 ? void 0 : n.proxy), f = d ? d.$options : {};
  r || (yb += 1, r = `_vuelidate_${yb}`);
  const m = ie({}), h = new FW(), {
    childResults: v,
    sendValidationResultsToParent: y,
    removeValidationResultsFromParent: p
  } = d ? NW({
    $scope: o,
    instance: d
  }) : {
    childResults: ie({})
  };
  if (!e && f.validations) {
    const b = f.validations;
    t = ie({}), Wh(() => {
      t.value = d, pe(() => xc(b) ? b.call(t.value, new zx(t.value)) : b, (x) => {
        m.value = Rh({
          validations: x,
          state: t,
          childResults: v,
          resultsCache: h,
          globalConfig: i,
          instance: d,
          externalResults: l || d.vuelidateExternalResults
        });
      }, {
        immediate: !0
      });
    }), i = f.validationsConfig || i;
  } else {
    const b = cr(e) || AW(e) ? e : mi(e || {});
    pe(b, (x) => {
      m.value = Rh({
        validations: x,
        state: t,
        childResults: v,
        resultsCache: h,
        globalConfig: i,
        instance: d ?? {},
        externalResults: l
      });
    }, {
      immediate: !0
    });
  }
  return d && (y.forEach((b) => b(m, {
    $registerAs: r,
    $scope: o,
    $stopPropagation: a
  })), _n(() => p.forEach((b) => b(r)))), B(() => Lr(Lr({}, Be(m.value)), v.value));
}
const Hx = (e) => {
  if (e = Be(e), Array.isArray(e))
    return !!e.length;
  if (e == null)
    return !1;
  if (e === !1)
    return !0;
  if (e instanceof Date)
    return !isNaN(e.getTime());
  if (typeof e == "object") {
    for (let t in e)
      return !0;
    return !1;
  }
  return !!String(e).length;
};
function Ho() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return (i) => (i = Be(i), !Hx(i) || t.every((r) => (r.lastIndex = 0, r.test(i))));
}
Ho(/^[a-zA-Z]*$/);
Ho(/^[a-zA-Z0-9]*$/);
Ho(/^\d*(\.\d+)?$/);
const zW = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
Ho(zW);
function HW(e) {
  return typeof e == "string" && (e = e.trim()), Hx(e);
}
var jW = {
  $validator: HW,
  $message: "Value is required",
  $params: {
    type: "required"
  }
};
const YW = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
Ho(YW);
Ho(/(^[0-9]*$)|(^-[0-9]+$)/);
Ho(/^[-]?\d*(\.\d+)?$/);
const UW = {
  name: "OtSelectMulti",
  customOptions: {}
}, jx = /* @__PURE__ */ Ae({
  ...UW,
  props: {
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !0 },
    value: { type: Array, required: !0 }
  },
  setup(e) {
    const t = e, { t: n } = tn(), i = WW(
      {
        internalVModel: {
          required: t.required ? jW : () => !0
        }
      },
      mi({
        internalVModel: t.value
      })
    ), r = B(() => ({
      internalVModel: {
        required: n("$vuetify.fundamentals.multiSelect.required")
      }
    }));
    return (o, a) => (ee(), Ne(zg, {
      error: Be(i).internalVModel,
      "error-messages": r.value.internalVModel,
      disabled: e.disabled
    }, {
      default: Ye(() => [
        T(Qg, ge(o.$attrs, {
          value: Be(i).internalVModel.$model,
          "onUpdate:value": a[0] || (a[0] = (l) => Be(i).internalVModel.$model = l),
          disabled: e.disabled,
          multiple: !0
        }), null, 16, ["value", "disabled"])
      ]),
      _: 1
    }, 8, ["error", "error-messages", "disabled"]));
  }
}), qW = {
  name: "OtTab",
  customOptions: {}
}, nm = /* @__PURE__ */ Ae({
  ...qW,
  props: {
    /** Defines a method that scrolls element's ancestor containers such that the element on which method is called is visible to the user */
    scrollElementIntoView: { type: Function, default: () => {
    } },
    tab: { type: Object, required: !0 }
  },
  emits: ["click"],
  setup(e, { expose: t, emit: n }) {
    const i = e, r = n, o = ie(), a = B(() => {
      const m = i.tab.getTitle();
      return typeof m == "string" ? m : m.value;
    }), l = "ot-tab", u = B(() => [
      l,
      `${l}--${i.tab.variant ?? "default"}`,
      { [`${l}--active`]: i.tab.active },
      { [`${l}--capitalize`]: i.tab.capitalize },
      { [`${l}--icon-only`]: !!i.tab.icon && !a.value }
    ]), d = B(() => i.tab.icon), f = () => {
      i.scrollElementIntoView(o.value), r("click", i.tab);
    };
    return t({
      tabElement: o
    }), (m, h) => (ee(), ce("button", {
      ref_key: "tabElement",
      ref: o,
      class: we(u.value),
      onClick: f
    }, [
      d.value ? (ee(), Ne(qt, {
        key: 0,
        class: "ot-tab__icon",
        name: d.value,
        "inherit-stroke": !0
      }, null, 8, ["name"])) : Fe("", !0),
      ve("span", {
        class: we(`${l}__label`)
      }, Ue(a.value), 3)
    ], 2));
  }
});
function bb(e) {
  const t = (n) => Number.isNaN(n) ? -1 : n;
  return e instanceof zr ? t(e.toNumber()) : typeof e == "string" ? e : t(e);
}
function GW(e) {
  if (typeof e == "string")
    return (t, n) => {
      const i = bb(t[e]), r = bb(n[e]);
      return i > r ? 1 : i < r ? -1 : 0;
    };
  if (typeof e == "function")
    return e;
}
function x7(e) {
  return {
    class: "",
    internalId: e.id ?? crypto.randomUUID(),
    reversed: !1,
    sortable: !1,
    sorted: !1,
    toggleable: !1,
    ...e,
    sortFunction: GW(e.sortFunction)
  };
}
const _a = {
  asc: "asc",
  desc: "desc"
};
class XW {
  constructor({
    colspan: t,
    columnClass: n,
    sortDirection: i,
    sorted: r,
    sortFunction: o,
    title: a,
    titleClass: l
  }) {
    ne(this, "sortDirection");
    ne(this, "sorted");
    ne(this, "colspan");
    ne(this, "title");
    ne(this, "titleClass");
    ne(this, "columnClass");
    ne(this, "sortFunction");
    this.colspan = t, this.columnClass = n ?? "", this.sortDirection = i ?? _a.asc, this.sorted = r ?? !1, this.sortFunction = o, this.title = a, this.titleClass = l ?? "";
  }
}
const k7 = ({
  title: e,
  columnClass: t = "",
  titleClass: n = "",
  sortFunction: i,
  sorted: r = !1,
  sortDirection: o = _a.asc,
  colspan: a
}) => new XW({
  colspan: a,
  columnClass: t,
  sortDirection: o,
  sorted: r,
  sortFunction: i,
  title: e,
  titleClass: n
}), KW = ["colspan", "onClick"], ZW = {
  name: "OtTableHeader",
  customOptions: {}
}, im = /* @__PURE__ */ Ae({
  ...ZW,
  props: {
    value: { type: Array, required: !0 },
    stickyHeader: { type: Boolean, required: !0 }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = ie(n.value), o = (l) => [
      "ot-table-header__cell",
      l.columnClass,
      {
        "ot-table-header__cell--empty": !l.title.trim().length,
        "ot-table-header__cell--sortable": l.sortFunction
      }
    ];
    pe(
      () => n.value,
      () => {
        r.value = n.value;
      }
    );
    const a = (l) => {
      !l.sortFunction || !r.value || i(
        "update:value",
        r.value.reduce((u, d) => {
          const f = d;
          return f !== l ? f.sorted = !1 : f.sorted === !0 ? f.sortDirection = f.sortDirection === _a.asc ? _a.desc : _a.asc : f.sorted = !0, u.push(f), u;
        }, [])
      );
    };
    return (l, u) => {
      const d = Hh("ot-icon");
      return ee(), ce("thead", {
        class: we(["ot-table-header", { "ot-table-header--sticky-header": e.stickyHeader }])
      }, [
        ve("tr", null, [
          (ee(!0), ce(qe, null, Dn(r.value, (f, m) => (ee(), ce("th", {
            key: m,
            colspan: f.colspan,
            class: we(o(f)),
            onClick: (h) => a(f)
          }, [
            f.title ? (ee(), ce("div", {
              key: 0,
              class: we(["ot-table-header__cell-title", [{ sorted: f.sorted, [f.titleClass]: f.titleClass }]])
            }, Ue(f.title), 3)) : Fe("", !0),
            f.sortFunction ? (ee(), Ne(d, {
              key: 1,
              class: we(["ot-table-header__sort-icon", f.sortDirection, { sorted: f.sorted }]),
              "inherit-stroke": !0,
              name: f.sorted ? "full-arrow-up" : "arrow-3"
            }, null, 8, ["class", "name"])) : Fe("", !0)
          ], 10, KW))), 128))
        ])
      ], 2);
    };
  }
}), QW = ["cellspacing"], JW = { class: "ot-table__content" }, ez = {
  name: "OtTable",
  customOptions: {}
}, Yx = /* @__PURE__ */ Ae({
  ...ez,
  props: {
    hasBorders: { type: Boolean, default: !1 },
    header: { type: Array, required: !0 },
    headerClass: { type: String, default: "" },
    rows: { type: Array, default: () => [] },
    stickyHeader: { type: Boolean, default: !0 }
  },
  emits: ["header-changed"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = ie(n.header);
    pe(
      () => n.header,
      () => {
        r.value = n.header;
      }
    );
    const o = B(() => {
      if (r.value)
        return r.value.some((l) => l.sorted) ? r.value.find((l) => l.sorted) : void 0;
    }), a = B(() => {
      var u;
      if (o.value === void 0)
        return n.rows;
      const l = n.rows.map((d) => d).sort((d, f) => {
        var m, h;
        return ((h = (m = o.value) == null ? void 0 : m.sortFunction) == null ? void 0 : h.call(m, d, f)) || -1;
      });
      return ((u = o.value) == null ? void 0 : u.sortDirection) === _a.asc ? l : l.reverse();
    });
    return (l, u) => (ee(), ce("table", {
      class: "ot-table",
      cellspacing: e.hasBorders ? void 0 : "0"
    }, [
      T(im, {
        value: r.value,
        "onUpdate:value": [
          u[0] || (u[0] = (d) => r.value = d),
          u[1] || (u[1] = (d) => i("header-changed", d))
        ],
        class: we(["ot-table__header", e.headerClass ? e.headerClass : ""]),
        "sticky-header": e.stickyHeader
      }, null, 8, ["value", "sticky-header", "class"]),
      ve("tbody", JW, [
        De(l.$slots, "default", {
          rows: a.value,
          rowClass: "ot-table__row"
        })
      ])
    ], 8, QW));
  }
}), tz = le({
  fixedHeader: Boolean,
  fixedFooter: Boolean,
  height: [Number, String],
  hover: Boolean,
  ...Xe(),
  ...Oi(),
  ...Bt(),
  ...Mt()
}, "VTable"), nz = ye()({
  name: "VTable",
  props: tz(),
  setup(e, t) {
    let {
      slots: n,
      emit: i
    } = t;
    const {
      themeClasses: r
    } = Wt(e), {
      densityClasses: o
    } = zi(e);
    return Oe(() => T(e.tag, {
      class: ["v-table", {
        "v-table--fixed-height": !!e.height,
        "v-table--fixed-header": e.fixedHeader,
        "v-table--fixed-footer": e.fixedFooter,
        "v-table--has-top": !!n.top,
        "v-table--has-bottom": !!n.bottom,
        "v-table--hover": e.hover
      }, r.value, o.value, e.class],
      style: e.style
    }, {
      default: () => {
        var a, l, u;
        return [(a = n.top) == null ? void 0 : a.call(n), n.default ? T("div", {
          class: "v-table__wrapper",
          style: {
            height: ze(e.height)
          }
        }, [T("table", null, [n.default()])]) : (l = n.wrapper) == null ? void 0 : l.call(n), (u = n.bottom) == null ? void 0 : u.call(n)];
      }
    })), {};
  }
}), iz = {
  name: "OtTableV",
  customOptions: {}
}, rz = /* @__PURE__ */ Ae({
  ...iz,
  props: {
    headers: { type: Array, required: !0 },
    headerClass: { type: String, default: "" },
    rows: { type: Array, default: () => [] },
    smallerXPaddings: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (t, n) => (ee(), Ne(nz, ge({
      class: ["ot-table-v", { "ot-table-v--smaller-px": e.smallerXPaddings }]
    }, t.$attrs, { "fixed-header": !0 }), {
      default: Ye(() => [
        ve("thead", null, [
          ve("tr", null, [
            (ee(!0), ce(qe, null, Dn(e.headers, (i, r) => (ee(), ce("th", {
              key: i.name,
              class: we(i.class)
            }, [
              De(t.$slots, `header-${i.name}`, ge({ ref_for: !0 }, { ...i, headerIdx: r }), void 0, !0)
            ], 2))), 128))
          ])
        ]),
        ve("tbody", null, [
          (ee(!0), ce(qe, null, Dn(e.rows, (i, r) => (ee(), ce("tr", {
            key: i.name,
            class: we(i.class)
          }, [
            (ee(!0), ce(qe, null, Dn(e.headers, (o) => (ee(), ce("td", {
              key: o.name
            }, [
              De(t.$slots, `cell-${o.name}`, ge({ ref_for: !0 }, { ...i, rowIdx: r }), void 0, !0)
            ]))), 128))
          ], 2))), 128))
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), S7 = /* @__PURE__ */ Uc(rz, [["__scopeId", "data-v-b6106b8a"]]), wb = (e) => typeof e == "object" && e != null && e.nodeType === 1, _b = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", th = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const n = getComputedStyle(e, null);
    return _b(n.overflowY, t) || _b(n.overflowX, t) || ((i) => {
      const r = ((o) => {
        if (!o.ownerDocument || !o.ownerDocument.defaultView)
          return null;
        try {
          return o.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(i);
      return !!r && (r.clientHeight < i.scrollHeight || r.clientWidth < i.scrollWidth);
    })(e);
  }
  return !1;
}, Du = (e, t, n, i, r, o, a, l) => o < e && a > t || o > e && a < t ? 0 : o <= e && l <= n || a >= t && l >= n ? o - e - i : a > t && l < n || o < e && l > n ? a - t + r : 0, oz = (e) => {
  const t = e.parentElement;
  return t ?? (e.getRootNode().host || null);
}, xb = (e, t) => {
  var n, i, r, o;
  if (typeof document > "u")
    return [];
  const { scrollMode: a, block: l, inline: u, boundary: d, skipOverflowHiddenElements: f } = t, m = typeof d == "function" ? d : (z) => z !== d;
  if (!wb(e))
    throw new TypeError("Invalid target");
  const h = document.scrollingElement || document.documentElement, v = [];
  let y = e;
  for (; wb(y) && m(y); ) {
    if (y = oz(y), y === h) {
      v.push(y);
      break;
    }
    y != null && y === document.body && th(y) && !th(document.documentElement) || y != null && th(y, f) && v.push(y);
  }
  const p = (i = (n = window.visualViewport) == null ? void 0 : n.width) != null ? i : innerWidth, b = (o = (r = window.visualViewport) == null ? void 0 : r.height) != null ? o : innerHeight, { scrollX: x, scrollY: _ } = window, { height: O, width: D, top: F, right: $, bottom: A, left: k } = e.getBoundingClientRect(), { top: S, right: M, bottom: E, left: I } = ((z) => {
    const H = window.getComputedStyle(z);
    return { top: parseFloat(H.scrollMarginTop) || 0, right: parseFloat(H.scrollMarginRight) || 0, bottom: parseFloat(H.scrollMarginBottom) || 0, left: parseFloat(H.scrollMarginLeft) || 0 };
  })(e);
  let L = l === "start" || l === "nearest" ? F - S : l === "end" ? A + E : F + O / 2 - S + E, N = u === "center" ? k + D / 2 - I + M : u === "end" ? $ + M : k - I;
  const V = [];
  for (let z = 0; z < v.length; z++) {
    const H = v[z], { height: W, width: j, top: U, right: K, bottom: te, left: ue } = H.getBoundingClientRect();
    if (a === "if-needed" && F >= 0 && k >= 0 && A <= b && $ <= p && F >= U && A <= te && k >= ue && $ <= K)
      return V;
    const de = getComputedStyle(H), Q = parseInt(de.borderLeftWidth, 10), J = parseInt(de.borderTopWidth, 10), re = parseInt(de.borderRightWidth, 10), me = parseInt(de.borderBottomWidth, 10);
    let xe = 0, tt = 0;
    const nt = "offsetWidth" in H ? H.offsetWidth - H.clientWidth - Q - re : 0, fe = "offsetHeight" in H ? H.offsetHeight - H.clientHeight - J - me : 0, be = "offsetWidth" in H ? H.offsetWidth === 0 ? 0 : j / H.offsetWidth : 0, Ee = "offsetHeight" in H ? H.offsetHeight === 0 ? 0 : W / H.offsetHeight : 0;
    if (h === H)
      xe = l === "start" ? L : l === "end" ? L - b : l === "nearest" ? Du(_, _ + b, b, J, me, _ + L, _ + L + O, O) : L - b / 2, tt = u === "start" ? N : u === "center" ? N - p / 2 : u === "end" ? N - p : Du(x, x + p, p, Q, re, x + N, x + N + D, D), xe = Math.max(0, xe + _), tt = Math.max(0, tt + x);
    else {
      xe = l === "start" ? L - U - J : l === "end" ? L - te + me + fe : l === "nearest" ? Du(U, te, W, J, me + fe, L, L + O, O) : L - (U + W / 2) + fe / 2, tt = u === "start" ? N - ue - Q : u === "center" ? N - (ue + j / 2) + nt / 2 : u === "end" ? N - K + re + nt : Du(ue, K, j, Q, re + nt, N, N + D, D);
      const { scrollLeft: ke, scrollTop: at } = H;
      xe = Ee === 0 ? 0 : Math.max(0, Math.min(at + xe / Ee, H.scrollHeight - W / Ee + fe)), tt = be === 0 ? 0 : Math.max(0, Math.min(ke + tt / be, H.scrollWidth - j / be + nt)), L += at - xe, N += ke - tt;
    }
    V.push({ el: H, top: xe, left: tt });
  }
  return V;
}, az = (e) => e === !1 ? { block: "end", inline: "nearest" } : ((t) => t === Object(t) && Object.keys(t).length !== 0)(e) ? e : { block: "start", inline: "nearest" };
function sz(e, t) {
  if (!e.isConnected || !((r) => {
    let o = r;
    for (; o && o.parentNode; ) {
      if (o.parentNode === document)
        return !0;
      o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
    }
    return !1;
  })(e))
    return;
  const n = ((r) => {
    const o = window.getComputedStyle(r);
    return { top: parseFloat(o.scrollMarginTop) || 0, right: parseFloat(o.scrollMarginRight) || 0, bottom: parseFloat(o.scrollMarginBottom) || 0, left: parseFloat(o.scrollMarginLeft) || 0 };
  })(e);
  if (((r) => typeof r == "object" && typeof r.behavior == "function")(t))
    return t.behavior(xb(e, t));
  const i = typeof t == "boolean" || t == null ? void 0 : t.behavior;
  for (const { el: r, top: o, left: a } of xb(e, az(t))) {
    const l = o - n.top + n.bottom, u = a - n.left + n.right;
    r.scroll({ top: l, left: u, behavior: i });
  }
}
const kb = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getObjFromJSON(e, t, n) {
    const i = localStorage.getItem(e);
    if (i !== null && i !== "undefined") {
      const r = JSON.parse(i);
      if (!n || Object.values(n).includes(r))
        return r;
    }
    return t;
  },
  localstorageSet(e, t) {
    return localStorage.setItem(e, JSON.stringify(t));
  },
  localStorageDelete(e) {
    localStorage.removeItem(e);
  }
}, lz = {
  name: "OtTabs",
  customOptions: {}
}, Ux = /* @__PURE__ */ Ae({
  ...lz,
  props: {
    dense: { type: Boolean, default: !0 },
    loading: { type: Boolean, default: !1 },
    mobile: { type: Boolean, default: !1 },
    persistance: { type: Object, default: void 0 },
    scrollable: { type: Boolean, default: !1 },
    scrollableInline: { type: String, default: "nearest" },
    tabs: { type: Array, required: !0 }
  },
  emits: ["update:tabs", "tab-selected"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = "route-transition", o = B({
      get: () => n.tabs,
      set: (x) => {
        i("update:tabs", x);
      }
    }), a = ie(), l = ie(), u = ie({
      mounted: !1,
      shouldScroll: !1
    }), d = "ot-tabs", f = B(() => [
      d,
      { [`${d}--sparse`]: !n.dense },
      { [`${d}--scrollable`]: n.scrollable },
      { [`${d}--loading`]: n.loading },
      { [`${d}--mobile`]: n.mobile }
    ]), m = (x) => o.value.map((_) => {
      const O = { ..._ };
      return O.active = _.id === x, O;
    }), h = (x) => {
      o.value = m(x.id), i("tab-selected", x), n.persistance && kb.localstorageSet(n.persistance.localstorageKey, x.id);
    }, v = () => {
      if (n.persistance) {
        const x = kb.getObjFromJSON(n.persistance.localstorageKey, n.persistance.defaultValue);
        o.value = m(x);
      }
    }, y = (x) => {
      !n.scrollable || !x || !a.value || sz(x, {
        behavior: "smooth",
        scrollMode: "always",
        boundary: a.value,
        inline: n.scrollableInline
      });
    }, p = () => {
      const x = o.value.findIndex((_) => _.active);
      if (x !== -1 && l.value) {
        const _ = l.value[x];
        y(_ == null ? void 0 : _.tabElement);
      }
    }, b = {
      onRunningTransition: (x) => {
        if (!n.scrollable || x.detail.doing) {
          u.value.shouldScroll = !1;
          return;
        }
        if (u.value.mounted === !1) {
          u.value.shouldScroll = !0;
          return;
        }
        u.value.shouldScroll = !1, p();
      },
      startListen: () => window.addEventListener(r, b.onRunningTransition, !0),
      stopListen: () => window.removeEventListener(r, b.onRunningTransition, !0)
    };
    return mn(() => {
      u.value.mounted = !0, b.startListen();
    }), _n(() => {
      b.stopListen();
    }), pe(u, () => {
      u.value.mounted && u.value.shouldScroll && p();
    }), v(), (x, _) => (ee(), ce("div", {
      ref_key: "tabsContainerElement",
      ref: a,
      class: we(f.value)
    }, [
      (ee(!0), ce(qe, null, Dn(o.value, (O) => (ee(), Ne(nm, {
        key: O.id,
        ref_for: !0,
        ref_key: "tabElements",
        ref: l,
        tab: O,
        "scroll-element-into-view": y,
        class: we([`${d}__tab`]),
        testid: `tab-${O.id.toLowerCase()}`,
        onClick: (D) => h(O)
      }, null, 8, ["tab", "class", "testid", "onClick"]))), 128))
    ], 2));
  }
}), uz = {
  name: "OtTextFieldV",
  customOptions: {}
}, C7 = /* @__PURE__ */ Ae({
  ...uz,
  props: {
    label: { type: String, required: !0 },
    warning: { type: Boolean, default: !1 },
    state: { type: String, default: "default" }
  },
  setup(e) {
    const t = e, n = B(() => ["warning", "error"].includes(t.state));
    return (i, r) => (ee(), Ne(Zs, ge({
      variant: "outlined",
      class: ["ot-text-field-v", { "ot-text-field-v--warning": e.state === "warning" }]
    }, i.$attrs, {
      label: e.label,
      color: "primary",
      "base-color": "text-tertiary",
      error: n.value
    }), Cc({ _: 2 }, [
      Dn(i.$slots, (o, a) => ({
        name: a,
        fn: Ye((l) => [
          De(i.$slots, a, zt(Qt(l)))
        ])
      }))
    ]), 1040, ["class", "label", "error"]));
  }
}), cz = { class: "ot-toggle" }, dz = ["checked", "disabled"], fz = /* @__PURE__ */ ve("div", { class: "ot-toggle__rail" }, [
  /* @__PURE__ */ ve("div", { class: "ot-toggle__knob" })
], -1), hz = {
  name: "OtToggle",
  customOptions: {}
}, rm = /* @__PURE__ */ Ae({
  ...hz,
  props: {
    disabled: { type: Boolean, default: !1 },
    value: { type: Boolean, default: !1 }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const i = e, r = n, o = "ot-toggle", a = (l) => {
      l.target && "checked" in l.target && r("update:value", l.target.checked);
    };
    return t({
      prefix: o,
      props: i,
      onValueChange: a
    }), (l, u) => (ee(), ce("label", cz, [
      ve("input", {
        class: "ot-toggle__checkbox",
        type: "checkbox",
        checked: e.value,
        disabled: e.disabled,
        onChange: a
      }, null, 40, dz),
      fz
    ]));
  }
}), gz = {
  name: "OtTogglePositiveUi",
  customOptions: {}
}, qx = /* @__PURE__ */ Ae({
  ...gz,
  props: {
    disabled: { type: Boolean, default: !1 },
    value: { type: Boolean, default: !1 },
    onToggleAction: { type: Function, default: () => Promise.resolve() },
    onToggleActionFailed: { type: Function, default: () => Promise.resolve() }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = ie(!!n.value);
    pe(
      () => n.value,
      (a) => {
        r.value = !!a;
      }
    );
    const o = B({
      get: () => !!r.value,
      set: (a) => {
        var l;
        r.value = a, (l = n.onToggleAction) == null || l.call(n, { value: a }).catch(() => {
          var u;
          (u = n.onToggleActionFailed) == null || u.call(n), r.value = !!n.value;
        }).finally(() => {
          i("update:value", r.value);
        });
      }
    });
    return (a, l) => (ee(), Ne(rm, {
      value: o.value,
      "onUpdate:value": l[0] || (l[0] = (u) => o.value = u),
      class: "ot-toggle-positive-ui",
      disabled: e.disabled
    }, null, 8, ["value", "disabled"]));
  }
}), mz = {
  name: "OtTransitionZoomY",
  customOptions: {}
}, Gx = /* @__PURE__ */ Ae({
  ...mz,
  props: {
    appear: { type: Boolean, default: !1 },
    delay: { type: [Number, Object], default: 0 },
    duration: { type: [Number, Object], default: 300 },
    group: { type: Boolean, default: !1 },
    origin: { type: String, default: "" },
    tag: { type: String, default: "div" },
    styles: {
      type: Object,
      default: () => ({
        animationFillMode: "both",
        animationTimingFunction: "cubic-bezier(.55,0,.1,1)"
      })
    }
  },
  emits: ["before-enter", "after-enter", "before-leave", "leave", "after-leave"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = (m) => {
      let h, v;
      typeof n.duration == "number" ? h = n.duration : h = n.duration.enter, typeof n.delay == "number" ? v = n.delay : v = n.delay.enter, m.style.animationDuration = `${h}ms`, m.style.animationDelay = `${v}ms`, yc(m, n.styles, n.origin), i("before-enter", m);
    }, o = (m) => {
      a(m), i("after-enter", m);
    }, a = (m) => {
      Object.keys(n.styles).forEach((h) => {
        n.styles[h] && (m.style[h] = "");
      }), m.style.animationDuration = "", m.style.animationDelay = "";
    }, l = (m) => {
      let h, v;
      typeof n.duration == "number" ? h = n.duration : h = n.duration.leave, typeof n.delay == "number" ? v = n.delay : v = n.delay.leave, m.style.animationDuration = `${h}ms`, m.style.animationDelay = `${v}ms`, yc(m, n.styles, n.origin), i("before-leave", m);
    }, u = (m) => {
      B_(m, n.group), i("leave", m);
    }, d = (m) => {
      a(m), i("after-leave", m);
    }, f = B(() => ({
      "before-enter": r,
      "after-enter": o,
      "before-leave": l,
      leave: u,
      "after-leave": d
    }));
    return (m, h) => (ee(), ce(qe, null, [
      e.group ? (ee(), Ne(Qs, ge({ key: 0 }, m.$attrs, {
        tag: e.tag,
        name: "ot-transition-zoom-y"
      }, xa(f.value)), {
        default: Ye(() => [
          De(m.$slots, "default")
        ]),
        _: 3
      }, 16, ["tag"])) : Fe("", !0),
      e.group ? Fe("", !0) : (ee(), Ne(hn, ge({ key: 1 }, m.$attrs, { name: "ot-transition-zoom-y" }, xa(f.value)), {
        default: Ye(() => [
          De(m.$slots, "default")
        ]),
        _: 3
      }, 16))
    ], 64));
  }
});
var vz = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var i = 0; i < n.length; i++) {
      var r = n[i];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  return function(t, n, i) {
    return n && e(t.prototype, n), i && e(t, i), t;
  };
}();
function pz(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var yz = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    pz(this, e), this.start = t.start, this.end = t.end, this.decimal = t.decimal;
  }
  return vz(e, [{
    key: "getIntermediateValue",
    value: function(n) {
      return this.decimal ? n : Math.round(n);
    }
  }, {
    key: "getFinalValue",
    value: function() {
      return this.end;
    }
  }]), e;
}(), bz = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var i = 0; i < n.length; i++) {
      var r = n[i];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }
  return function(t, n, i) {
    return n && e(t.prototype, n), i && e(t, i), t;
  };
}();
function wz(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var _z = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    wz(this, e), this.duration = t.duration || 1e3, this.ease = t.easing || this._defaultEase, this.tweener = t.tweener || new yz(t), this.start = this.tweener.start, this.end = this.tweener.end, this.frame = null, this.next = null, this.isRunning = !1, this.events = {}, this.direction = this.start < this.end ? "up" : "down";
  }
  return bz(e, [{
    key: "begin",
    value: function() {
      return !this.isRunning && this.next !== this.end && (this.frame = window.requestAnimationFrame(this._tick.bind(this))), this;
    }
  }, {
    key: "stop",
    value: function() {
      return window.cancelAnimationFrame(this.frame), this.isRunning = !1, this.frame = null, this.timeStart = null, this.next = null, this;
    }
  }, {
    key: "on",
    value: function(n, i) {
      return this.events[n] = this.events[n] || [], this.events[n].push(i), this;
    }
  }, {
    key: "_emit",
    value: function(n, i) {
      var r = this, o = this.events[n];
      o && o.forEach(function(a) {
        return a.call(r, i);
      });
    }
  }, {
    key: "_tick",
    value: function(n) {
      this.isRunning = !0;
      var i = this.next || this.start;
      this.timeStart || (this.timeStart = n), this.timeElapsed = n - this.timeStart, this.next = this.ease(this.timeElapsed, this.start, this.end - this.start, this.duration), this._shouldTick(i) ? (this._emit("tick", this.tweener.getIntermediateValue(this.next)), this.frame = window.requestAnimationFrame(this._tick.bind(this))) : (this._emit("tick", this.tweener.getFinalValue()), this._emit("done", null));
    }
  }, {
    key: "_shouldTick",
    value: function(n) {
      return {
        up: this.next < this.end && n <= this.next,
        down: this.next > this.end && n >= this.next
      }[this.direction];
    }
  }, {
    key: "_defaultEase",
    value: function(n, i, r, o) {
      return (n /= o / 2) < 1 ? r / 2 * n * n + i : -r / 2 * (--n * (n - 2) - 1) + i;
    }
  }]), e;
}();
const xz = { class: "ot-tweezer" }, kz = {
  name: "OtTweezer",
  customOptions: {}
}, Xx = /* @__PURE__ */ Ae({
  ...kz,
  props: {
    to: { type: Number, required: !0 },
    duration: { type: Number, default: 500 },
    getShownValue: { type: Function, required: !0 }
  },
  emits: ["start", "end"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = ie(n.to), o = ie(n.to), a = (f, m, h) => {
      let v;
      return new _z({
        start: f,
        end: m,
        ...h
      }).on("tick", (y) => {
        v || (v = !0, i("start")), h.setValue(y), o.value = y;
      }).on("done", () => i("end")).begin();
    }, l = (f) => a(r.value, f, {
      setValue: (m) => {
        r.value = m;
      },
      duration: n.duration
    });
    let u = l(n.to);
    return pe(() => n.to, (f) => {
      u.stop(), u = l(f);
    }), (f, m) => (ee(), ce("div", xz, [
      De(f.$slots, "default", zt(Qt({ tweezedValue: e.getShownValue(o.value) })))
    ]));
  }
}), Sz = {
  name: "OtvButton",
  customOptions: {}
}, Sb = {
  primary: "primary",
  secondary: "secondary"
}, nh = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary"
}, Kx = /* @__PURE__ */ Ae({
  ...Sz,
  props: {
    colorVariant: { type: String, default: "primary" },
    disabled: { type: Boolean, default: !1 },
    label: { type: String, required: !1 },
    loading: { type: Boolean, default: !1 },
    size: { type: String, default: "default" },
    variant: { type: String, default: "primary" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, i = t, r = B(() => {
      switch (n.colorVariant) {
        case Sb.primary:
          return "primary";
        case Sb.secondary:
          return "elevation-2";
        default:
          return "elevation-2";
      }
    }), o = B(() => {
      switch (n.variant) {
        case nh.primary:
          return "flat";
        case nh.secondary:
          return "outlined";
        case nh.tertiary:
          return "text";
        default:
          return "flat";
      }
    });
    return (a, l) => (ee(), Ne(In, ge({
      class: `otv-button otv-button--color-${e.colorVariant} otv-button--variant-${e.variant} otv-button--size-${e.size}`
    }, a.$attrs, {
      rounded: "null",
      color: r.value,
      size: e.size,
      variant: o.value,
      disabled: e.disabled,
      loading: e.loading,
      onClick: l[0] || (l[0] = (u) => i("click"))
    }), Cc({ _: 2 }, [
      e.label ? {
        name: "default",
        fn: Ye(() => [
          dr(Ue(e.label), 1)
        ]),
        key: "0"
      } : void 0,
      e.loading ? {
        name: "loader",
        fn: Ye(() => [
          T(Na)
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["class", "color", "size", "variant", "disabled", "loading"]));
  }
}), Cz = {
  name: "OtVolumeDisplay",
  customOptions: {}
}, Zx = /* @__PURE__ */ Ae({
  ...Cz,
  props: {
    number: { type: [Number, String, Object] },
    align: { type: String, default: "right" }
  },
  setup(e) {
    const t = e, { t: n } = tn(), i = new Intl.NumberFormat("en", { notation: "compact" }), r = B(() => {
      let o = t.number;
      return o === void 0 || (typeof o == "string" && (o = Number(o)), typeof o == "number" && (o = new zr(o)), !o || o.isNaN()) ? n("$vuetify.fundamentals.emptyValues.default") : i.format(o.toNumber());
    });
    return (o, a) => (ee(), ce("span", {
      class: we(["ot-volume-display", `ot-volume-display--${t.align}`]),
      testid: "volume-display-value"
    }, Ue(r.value), 3));
  }
}), Oz = {
  defaults: {
    VAppBar: {
      flat: !0
    },
    VAutocomplete: {
      variant: "filled"
    },
    VBanner: {
      color: "primary"
    },
    VBottomSheet: {
      contentClass: "rounded-t-xl overflow-hidden"
    },
    VBtn: {
      color: "primary",
      rounded: "xl"
    },
    VBtnGroup: {
      rounded: "xl",
      VBtn: {
        rounded: null
      }
    },
    VCard: {
      rounded: "lg"
    },
    VCheckbox: {
      color: "secondary",
      inset: !0
    },
    VChip: {
      rounded: "sm"
    },
    VCombobox: {
      variant: "filled"
    },
    VNavigationDrawer: {
      // VList: {
      //   nav: true,
      //   VListItem: {
      //     rounded: 'xl',
      //   },
      // },
    },
    VSelect: {
      variant: "filled"
    },
    VSlider: {
      color: "primary"
    },
    VTabs: {
      color: "primary"
    },
    VTextarea: {
      variant: "filled"
    },
    VTextField: {
      variant: "filled"
    },
    VToolbar: {
      VBtn: {
        color: null
      }
    }
  },
  icons: {
    defaultSet: "mdi",
    sets: {
      mdi: r1
    }
  },
  theme: {
    themes: {
      light: {
        colors: {
          primary: "#6750a4",
          secondary: "#b4b0bb",
          tertiary: "#7d5260",
          error: "#b3261e",
          surface: "#fffbfe"
        }
      }
    }
  }
}, Mz = {
  collapse: "svg:M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z",
  complete: "svg:M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z",
  cancel: "svg:M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
  close: "svg:M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  delete: "svg:M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
  // delete (e.g. v-chip close)
  clear: "svg:M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
  success: "svg:M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z",
  info: "svg:M13,9H11V7H13M13,17H11V11H13M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  warning: "svg:M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z",
  error: "svg:M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z",
  prev: "svg:M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z",
  next: "svg:M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z",
  checkboxOn: "svg:M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  checkboxOff: "svg:M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z",
  checkboxIndeterminate: "svg:M17,13H7V11H17M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z",
  delimiter: "svg:M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  // for carousel
  sortAsc: "svg:M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z",
  sortDesc: "svg:M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z",
  expand: "svg:M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z",
  menu: "svg:M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z",
  subgroup: "svg:M7,10L12,15L17,10H7Z",
  dropdown: "svg:M7,10L12,15L17,10H7Z",
  radioOn: "svg:M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7Z",
  radioOff: "svg:M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z",
  edit: "svg:M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z",
  ratingEmpty: "svg:M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z",
  ratingFull: "svg:M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z",
  ratingHalf: "svg:M12,15.4V6.1L13.71,10.13L18.09,10.5L14.77,13.39L15.76,17.67M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z",
  loading: "svg:M19,8L15,12H18C18,15.31 15.31,18 12,18C11,18 10.03,17.75 9.2,17.3L7.74,18.76C8.97,19.54 10.43,20 12,20C16.42,20 20,16.42 20,12H23M6,12C6,8.69 8.69,6 12,6C13,6 13.97,6.25 14.8,6.7L16.26,5.24C15.03,4.46 13.57,4 12,4C7.58,4 4,7.58 4,12H1L5,16L9,12",
  first: "svg:M18.41,16.59L13.82,12L18.41,7.41L17,6L11,12L17,18L18.41,16.59M6,6H8V18H6V6Z",
  last: "svg:M5.59,7.41L10.18,12L5.59,16.59L7,18L13,12L7,6L5.59,7.41M16,6H18V18H16V6Z",
  unfold: "svg:M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z",
  file: "svg:M16.5,6V17.5C16.5,19.71 14.71,21.5 12.5,21.5C10.29,21.5 8.5,19.71 8.5,17.5V5C8.5,3.62 9.62,2.5 11,2.5C12.38,2.5 13.5,3.62 13.5,5V15.5C13.5,16.05 13.05,16.5 12.5,16.5C11.95,16.5 11.5,16.05 11.5,15.5V6H10V15.5C10,16.88 11.12,18 12.5,18C13.88,18 15,16.88 15,15.5V5C15,2.79 13.21,1 11,1C8.79,1 7,2.79 7,5V17.5C7,20.54 9.46,23 12.5,23C15.54,23 18,20.54 18,17.5V6H16.5Z",
  plus: "svg:M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  minus: "svg:M19,13H5V11H19V13Z",
  calendar: "svg:M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z",
  treeviewCollapse: "svg:M7,10L12,15L17,10H7Z",
  treeviewExpand: "svg:M10,17L15,12L10,7V17Z",
  eyeDropper: "svg:M19.35,11.72L17.22,13.85L15.81,12.43L8.1,20.14L3.5,22L2,20.5L3.86,15.9L11.57,8.19L10.15,6.78L12.28,4.65L19.35,11.72M16.76,3C17.93,1.83 19.83,1.83 21,3C22.17,4.17 22.17,6.07 21,7.24L19.08,9.16L14.84,4.92L16.76,3M5.56,17.03L4.5,19.5L6.97,18.44L14.4,11L13,9.6L5.56,17.03Z"
}, Tz = {
  component: tg
}, Pz = {
  badge: "Abzeichen",
  open: "Öffnen",
  close: "Schließen",
  dismiss: "Verwerfen",
  confirmEdit: {
    ok: "OK",
    cancel: "Abbrechen"
  },
  dataIterator: {
    noResultsText: "Keine Elemente gefunden",
    loadingText: "Lade Elemente..."
  },
  dataTable: {
    itemsPerPageText: "Zeilen pro Seite:",
    ariaLabel: {
      sortDescending: "Absteigend sortiert.",
      sortAscending: "Aufsteigend sortiert.",
      sortNone: "Nicht sortiert.",
      activateNone: "Aktivieren um Sortierung zu entfernen.",
      activateDescending: "Aktivieren um absteigend zu sortieren.",
      activateAscending: "Aktivieren um aufsteigend zu sortieren."
    },
    sortBy: "Sortiere nach"
  },
  dataFooter: {
    itemsPerPageText: "Elemente pro Seite:",
    itemsPerPageAll: "Alle",
    nextPage: "Nächste Seite",
    prevPage: "Vorherige Seite",
    firstPage: "Erste Seite",
    lastPage: "Letzte Seite",
    pageText: "{0}-{1} von {2}"
  },
  dateRangeInput: {
    divider: "bis"
  },
  datePicker: {
    itemsSelected: "{0} ausgewählt",
    range: {
      title: "Daten auswählen",
      header: "Daten eingeben"
    },
    title: "Datum auswählen",
    header: "Datum eingeben",
    input: {
      placeholder: "Datum eingeben"
    }
  },
  noDataText: "Keine Daten vorhanden",
  carousel: {
    prev: "Vorheriges Bild",
    next: "Nächstes Bild",
    ariaLabel: {
      delimiter: "Element {0} von {1}"
    }
  },
  calendar: {
    moreEvents: "{0} mehr",
    today: "Heute"
  },
  input: {
    clear: "{0} leeren",
    prependAction: "{0} vorangestellte Aktion",
    appendAction: "{0} angehängte Aktion",
    otp: "Bitte OTP-Zeichen {0} eingeben"
  },
  fileInput: {
    counter: "{0} Dateien",
    counterSize: "{0} Dateien ({1} gesamt)"
  },
  timePicker: {
    am: "AM",
    pm: "PM",
    title: "Uhrzeit auswählen"
  },
  pagination: {
    ariaLabel: {
      root: "Seitennavigation",
      next: "Nächste Seite",
      previous: "Vorherige Seite",
      page: "Gehe zu Seite {0}",
      currentPage: "Aktuelle Seite, Seite {0}",
      first: "Erste Seite",
      last: "Letzte Seite"
    }
  },
  stepper: {
    next: "Weiter",
    prev: "Zurück"
  },
  rating: {
    ariaLabel: {
      item: "Bewertung {0} von {1}"
    }
  },
  loading: "Laden...",
  infiniteScroll: {
    loadMore: "Mehr laden",
    empty: "Nichts weiteres"
  }
}, Az = {
  component: (e) => Un(qt, {
    class: [e.icon],
    tag: e.tag,
    name: e.icon
  })
}, Jt = {
  // Primary Shades
  "brand-50": "#ffffff",
  // on-primary
  "brand-100": "#b5c9fb",
  "brand-200": "#90aefa",
  "brand-300": "#6b93f8",
  "brand-400": "#4678f6",
  // primary
  "brand-500": "#3f6cdd",
  "brand-600": "#3860c5",
  "brand-700": "#2a4894",
  "brand-800": "#1c3062",
  "brand-900": "#0e1831",
  "brand-950": "#070c19",
  // Secondary Shades
  "brand-2-50": "#ffffff",
  "brand-2-100": "#efd1fa",
  "brand-2-200": "#ce74ef",
  "brand-2-300": "#be46ea",
  "brand-2-400": "#B62BE9",
  "brand-2-500": "#9d16ce",
  "brand-2-600": "#7a11a0",
  "brand-2-700": "#570c73",
  "brand-2-800": "#340745",
  "brand-2-900": "#110217",
  "cly-50": "#F0F1F3",
  "cly-100": "#E3E6ED",
  "cly-200": "#B9BDC7",
  "cly-300": "#989FAD",
  "cly-400": "#858D9D",
  "cly-500": "#667085",
  "cly-600": "#5D6679",
  "cly-700": "#48505E",
  "cly-800": "#383E49",
  "cly-900": "#2B2F38",
  "skyscrap-50": "#EEFAFD",
  "skyscrap-100": "#CAF0FA",
  "skyscrap-200": "#B1E8F8",
  "skyscrap-300": "#8DDEF4",
  "skyscrap-400": "#77D7F2",
  "skyscrap-500": "#55CDEF",
  "skyscrap-600": "#4DBBD9",
  "skyscrap-700": "#3C92AA",
  "skyscrap-800": "#2F7183",
  "skyscrap-900": "#245664",
  "midnight-50": "#ECEEF8",
  "midnight-100": "#C5CAE9",
  "midnight-200": "#A7AFDD",
  "midnight-300": "#7E8ACD",
  "midnight-400": "#6574C4",
  "midnight-500": "#3F51B5",
  "midnight-600": "#394AA5",
  "midnight-700": "#2D3A81",
  "midnight-800": "#232D64",
  "midnight-900": "#1A224C"
}, Ez = {
  primary: Jt["brand-400"],
  // done
  "on-primary": Jt["brand-50"],
  // done
  "primary-hover": Jt["brand-600"],
  // done
  "primary-disabled": Jt["brand-200"]
  // done
}, Iz = {
  primary: Jt["brand-600"],
  // done
  "on-primary": Jt["brand-950"],
  // done
  "primary-hover": Jt["brand-700"],
  // done
  "primary-disabled": Jt["brand-800"]
  // done
}, Dz = {
  secondary: Jt["brand-2-400"],
  "on-secondary": Jt["brand-2-50"],
  "secondary-hover": Jt["brand-2-600"],
  "secondary-disabled": Jt["brand-2-200"]
}, Lz = {
  secondary: Jt["brand-2-600"],
  "on-secondary": Jt["brand-2-900"],
  "secondary-hover": Jt["brand-2-500"],
  "secondary-disabled": Jt["brand-2-400"]
}, Qx = {
  "text-primary": "#F6F7F9",
  "text-secondary": "#ACBBCD",
  "text-tertiary": "#5F7998",
  "text-disabled": "#ACBBCD",
  "text-button": Jt["brand-950"]
}, Jx = {
  "text-primary": "#0F1217",
  "text-secondary": "#3D4F67",
  "text-tertiary": "#5F7998",
  "text-disabled": "#4B627E",
  "text-button": Jt["brand-950"]
  // was text-0 #232930
}, ek = {
  error: "#F33D61",
  "error-hover": "#aa2b44",
  success: "#2FB977",
  "success-hover": "#218253",
  warning: "#F99B16",
  "warning-hover": "#c27a00"
}, Hu = {
  "elevation-3": "#4B5A78",
  "elevation-2": "#354357",
  "elevation-1": "#12121F",
  "elevation-01": "#1e1d23",
  "elevation-0": "#000000",
  "elevation-00": "#000000",
  "on-elevation-2": Qx["text-secondary"]
}, ju = {
  "elevation-3": "#ACBBCD",
  "elevation-2": "#D3DAE4",
  "elevation-1": "#EBEEF3",
  "elevation-01": "#F6F7F9",
  "elevation-0": "#F6F7F9",
  "on-elevation-2": Jx["text-secondary"]
}, Bz = {
  "overlay-0": "#1a1d22",
  "overlay-2": "#12121F",
  "overlay-3": "#ffffff"
}, Vz = {
  "overlay-0": "#191e27",
  "overlay-2": "#090a0d",
  "overlay-3": "#ffffff"
}, $z = {
  background: Hu["elevation-00"],
  surface: Hu["elevation-0"],
  "surface-variant": Hu["elevation-1"],
  "on-surface-variant": "#ACBBCD"
}, Rz = {
  background: ju["elevation-0"],
  surface: ju["elevation-1"],
  "surface-variant": ju["elevation-2"],
  "on-surface-variant": "#4B627E"
}, tk = {
  "hover-opacity": 0.12,
  "focus-opacity": 0.22,
  "overlay-0": 0.95,
  "overlay-2": 0.6,
  "overlay-3": 0.1
}, Fz = {
  dark: !0,
  colors: {
    ...$z,
    ...Ez,
    ...Dz,
    ...Qx,
    ...ek,
    ...Hu,
    ...Bz
  },
  variables: tk
}, Nz = {
  dark: !1,
  colors: {
    ...Rz,
    ...Iz,
    ...Lz,
    ...Jx,
    ...ek,
    ...ju,
    ...Vz
  },
  variables: tk
}, Wz = {
  close: "Schließen",
  emptyValues: {
    default: "–"
  },
  multiSelect: {
    all: "Alle",
    required: "Nichts ausgewählt",
    selectedNumber: "Ausgewählt: {0}"
  },
  noMatchingOptions: "Keine passende Option",
  search: "Suchen"
}, zz = {
  error: {
    titile: "Hoppla, etwas ist schiefgelaufen!"
  },
  noRecords: "Es gibt noch keine anzuzeigenden Datensätze",
  retryButton: "Erneut versuchen"
}, Hz = {
  fundamentals: Wz,
  table: zz
}, jz = {
  close: "Close",
  emptyValues: {
    default: "–"
  },
  multiSelect: {
    all: "All",
    required: "Nothing selected",
    selectedNumber: "Selected: {0}"
  },
  noMatchingOptions: "No matching options",
  search: "Search"
}, Yz = {
  error: {
    titile: "Whoops, something went wrong!"
  },
  noRecords: "There are no records to display yet",
  retryButton: "Try again"
}, Uz = {
  fundamentals: jz,
  table: Yz
}, nk = s1({
  blueprint: Oz,
  defaults: {
    global: {
      ripple: !1
    }
  },
  display: {
    mobileBreakpoint: "sm",
    thresholds: {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920,
      xl: 2560
    }
  },
  icons: {
    defaultSet: "custom",
    aliases: {
      ...Mz
    },
    sets: {
      custom: Az,
      mdi: Tz
    }
  },
  locale: {
    /** https://vuetifyjs.com/en/features/internationalization/#internationalization-i18n */
    locale: "en",
    fallback: "en",
    messages: {
      en: {
        ...qb,
        ...Uz
      },
      de: {
        ...Pz,
        ...Hz
      }
    }
  },
  theme: {
    /** https://vuetifyjs.com/en/features/theme */
    defaultTheme: "dark",
    cspNonce: "dQw4w9WgXcQ",
    themes: {
      dark: Fz,
      light: Nz
    }
  }
}), qz = (e) => {
  nk.locale.current.value = e;
}, Gz = sw.name, Xz = fw.name, Kz = pg.name, Zz = hw.name, Qz = gw.name, Jz = mw.name, eH = Ur.name, tH = T_.name, nH = P_.name, iH = $g.name, rH = A_.name, oH = I_.name, aH = D_.name, sH = L_.name, lH = gg.name, uH = V_.name, cH = $_.name, dH = qt.name, fH = R_.name, hH = zg.name, gH = W_.name, mH = z_.name, vH = jg.name, pH = H_.name, yH = j_.name, bH = qc.name, wH = Y_.name, _H = Vc.name, xH = Fg.name, kH = Hg.name, SH = U_.name, CH = q_.name, OH = Wg.name, MH = G_.name, TH = X_.name, PH = K_.name, AH = Z_.name, EH = Q_.name, IH = mx.name, DH = Ng.name, LH = Kg.name, BH = jx.name, VH = Qg.name, $H = Na.name, RH = vg.name, FH = im.name, NH = Yx.name, WH = nm.name, zH = Ux.name, HH = rm.name, jH = qx.name, YH = Rg.name, UH = Bc.name, qH = Gx.name, GH = Xx.name, XH = Kx.name, KH = Zx.name, O7 = {
  // LegacyComponents = components that have been moved from the "Main" project (Exchange UI), they do not use Vuetify
  install: (e, t = { autoRegLegacyComponents: !1 }) => (e.use(nk), t.autoRegLegacyComponents && (e.component(Gz, sw), e.component(Xz, fw), e.component(Kz, pg), e.component(Zz, hw), e.component(Qz, gw), e.component(Jz, mw), e.component(eH, Ur), e.component(tH, T_), e.component(nH, P_), e.component(iH, $g), e.component(rH, A_), e.component(oH, I_), e.component(aH, D_), e.component(sH, L_), e.component(lH, gg), e.component(uH, V_), e.component(cH, $_), e.component(dH, qt), e.component(fH, R_), e.component(hH, zg), e.component(gH, W_), e.component(mH, z_), e.component(vH, jg), e.component(pH, H_), e.component(yH, j_), e.component(bH, qc), e.component(wH, Y_), e.component(_H, Vc), e.component(xH, Fg), e.component(kH, Hg), e.component(SH, U_), e.component(CH, q_), e.component(OH, Wg), e.component(MH, G_), e.component(TH, X_), e.component(PH, K_), e.component(AH, Z_), e.component(EH, Q_), e.component(IH, mx), e.component(DH, Ng), e.component(LH, Kg), e.component(BH, jx), e.component(VH, Qg), e.component($H, Na), e.component(RH, vg), e.component(FH, im), e.component(NH, Yx), e.component(WH, nm), e.component(zH, Ux), e.component(HH, rm), e.component(jH, qx), e.component(YH, Rg), e.component(UH, Bc), e.component(qH, Gx), e.component(GH, Xx), e.component(XH, Kx), e.component(KH, Zx)), e),
  changeLocale: qz
};
export {
  O7 as ComponentLibrary,
  sw as OtAsyncGridTable,
  pg as OtBalance,
  fw as OtBalanceLoading,
  hw as OtBanner,
  Ur as OtButton,
  gw as OtButtonDropdown,
  mw as OtButtonToggle,
  T_ as OtChartDoughnut,
  P_ as OtChartLine,
  $g as OtCheckbox,
  A_ as OtCheckboxPositiveUi,
  I_ as OtCopyTextbox,
  D_ as OtDetails,
  L_ as OtDetailsRow,
  gg as OtGridTable,
  V_ as OtGridTableRow,
  $_ as OtHorizontalSlidePanel,
  qt as OtIcon,
  R_ as OtInfo,
  zg as OtInputErrorWrapper,
  W_ as OtInputNumber,
  z_ as OtInputText,
  jg as OtLabel,
  H_ as OtLinkExternal,
  j_ as OtLinkInternal,
  Y_ as OtList,
  qc as OtListItem,
  Vc as OtLoadingIndicator,
  Fg as OtLoadingOverlay,
  Hg as OtLogo,
  U_ as OtLozenge,
  q_ as OtMarketId,
  Wg as OtModuleContainer,
  G_ as OtNumberDisplay,
  X_ as OtPaginationControls,
  w7 as OtPaginationControlsCursors,
  K_ as OtPanel,
  Z_ as OtPid,
  Q_ as OtProgressBar,
  mx as OtQrCode,
  Ng as OtScroll,
  Kg as OtSearch,
  Qg as OtSelect,
  jx as OtSelectMulti,
  _7 as OtSelectV,
  Na as OtSpinner,
  nm as OtTab,
  Yx as OtTable,
  XW as OtTableColumn,
  vg as OtTableError,
  im as OtTableHeader,
  S7 as OtTableV,
  Ux as OtTabs,
  C7 as OtTextFieldV,
  rm as OtToggle,
  qx as OtTogglePositiveUi,
  Rg as OtTransitionCollapse,
  Bc as OtTransitionFade,
  Gx as OtTransitionZoomY,
  Xx as OtTweezer,
  Zx as OtVolumeDisplay,
  Kx as OtvButton,
  bc as ToggleInputCustomEvent,
  e7 as VCard,
  t7 as VCheckbox,
  n7 as VDatePicker,
  i7 as VDialog,
  U1 as VDivider,
  r7 as VExpansionPanel,
  o7 as VForm,
  K1 as VMenu,
  a7 as VRadio,
  s7 as VRadioGroup,
  QE as VSelectionControlGroup,
  l7 as VSnackbar,
  u7 as VStepper,
  rD as VStepperHeader,
  sD as VStepperItem,
  c7 as VThemeProvider,
  d7 as VTooltip,
  qz as changeLocale,
  x7 as createFlexTableColumn,
  k7 as createOtTableColumnInstance,
  f7 as otButtonRounded,
  hL as otButtonSizes,
  Ef as otButtonVariants,
  v7 as otInputNumberStates,
  m7 as otInputNumberVariants,
  y7 as otInputTextStates,
  p7 as otInputTextVariants,
  b7 as otListItemVariant,
  A8 as otSelectVariants,
  _a as otTableSortDirections,
  JH as useTheme,
  nk as vuetify
};
//# sourceMappingURL=one-trading-design-system.es.js.map
